
<template>
    
    <div class = "maindiv">
        
        <div>
            <audio ref="goal_sound_on" src="../assets/goal_sound.mp3" preload="auto"></audio>
            <audio ref="event_sound_on" src="../assets/new_alert.mp3" preload="auto"></audio>
            <audio ref="event_sound_off" src="../assets/expire_alert.mp3" preload="auto"></audio>
        </div>
        <b-modal id="modal-1"  hide-footer hide-header centered no-close-on-backdrop>
            <b-progress value="100" max="100" animated variant="secondary"></b-progress>
        </b-modal>
        <!-- <div v-if="!isload_" style="height: 10px;">
            <b-progress :value="current_counter" :max="counter" animated></b-progress>
        </div> -->
        <CCard>
            <CCardBody>
                <CRow>
                    <CCol lg="12">
                        <label style="font-weight: 600;" class="header_label">{{ $t('Match') }}</label>
                        <div class="match-container">
                            <CRow>
                                <CCol sm="9" lg="4" md="4" col="9">
                                    <label style="color: red; font-weight: 600;" class="font_size">{{ $t('Select Match')}}({{this.eventLists3.length - 1}})</label>
                                    <CSelect
                                            :value.sync = "key1"
                                            :options="eventLists3"
                                            @update:value="select_match"
                                            style="font-size:10px !important; background-color: floralwhite !important"
                                    >
                                    </CSelect>
                                    <p style="text-align: center; margin-bottom: 8px;"><strong style="color: blue">{{this.competitionName}}</strong></p>
                                </CCol>
                                <CCol sm="3" lg="1" md="1" col="3">
                                    <label style="color: red; font-weight: 600; width: 100%; text-align: left; margin-left: -15px;">{{ $t('Open') }}:</label>
                                    <CRow>
                                        <CCol col="6" style = "padding : 0px">
                                            <div style="width: 30px; margin: auto; float: left;" class = "open-image">
                                                <a :href="oddUrl" target="_blank">
                                                    <img src="/img/bf.com_icon.png" width="25px;" height="25px;"/>
                                                </a>
                                            </div>
                                        </CCol>
                                        <CCol col="6" style = "padding : 0px">
                                            <div style="width: 30px; margin: auto; float: left;" class = "open-image">
                                                <a :href="oddUrl1" target="_blank">
                                                    <img src="/img/bf.it_icon_new.png" width="25px;" height="25px;"/>
                                                </a>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm="12" lg="4" md="4" col="12">
                                    <div>
                                        <label style="color: red; font-weight: 600;">
                                            {{ $t('General Filters') }}:
                                        </label>
                                        <div style="display: flex; margin-bottom: 12px; min-height: 87px;" class="input_checkbox_div">
                                            <div style="width: 20%; flex: 1; text-align: left">
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter1"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        1
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter2"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        x
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter3"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        2
                                                    </template>
                                                </CInputCheckbox>
                                            </div>
                                            <div style="width: 20%; flex: 1; text-align: left">
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter4"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        O 0.5
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter5"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        O 1.5
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter6"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        O 2.5
                                                    </template>
                                                </CInputCheckbox>
                                            </div>
                                            <div style="width: 20%; flex: 1; text-align: left">
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter7"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        U 2.5
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter8"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        U 3.5
                                                    </template>
                                                </CInputCheckbox>
                                            </div>
                                            <div style="width: 25%; flex: 1; ">
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter9"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        {{ $t('Back') }}
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter10"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        {{ $t('Lay') }}
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter11"
                                                >
                                                    <template #label>
                                                        {{ $t('Double Tips') }}
                                                    </template>
                                                </CInputCheckbox>
                                            </div>
                                            <div style="width: 15%; flex: 1;">
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter12"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        {{ $t('Cup') }}
                                                    </template>
                                                </CInputCheckbox>
                                                <CInputCheckbox class="check-box"
                                                                @update:checked="select_filter13"
                                                                :checked = "true"
                                                >
                                                    <template #label>
                                                        {{ $t('Week') }}
                                                    </template>
                                                </CInputCheckbox>
                                            </div>
                                        </div>
                                    </div>
                                </CCol>
                                <CCol sm="12" lg="3" md="3" col="12">
                                    <CRow style="display: flex;">
                                        <CCol sm="7" lg="12" col="7" md="12" style="flex: 1;">
                                            <label style="color: red; font-weight: 600;">{{ $t('Odd Filters') }}:</label>
                                            <div style="margin-bottom: 15px;">
                                                <div >
                                                    <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Min') }}:</label>
                                                    <CInput type="number" min="0" max="90000000" :value="this.oddMin" @update:value="odd_min" class="odd-filter-inputbox odd-cont" style = "background: floralwhite !important"></CInput>
                                                </div>
                                                <div >
                                                    <label style="float: left; margin-top: 6px; margin-right: 5px;">Max:</label>
                                                    <CInput type="number" min="0" max="100000" :value="this.oddMax" @update:value="odd_max" class="odd-filter-inputbox odd-cont" style = "background: floralwhite !important"></CInput>
                                                </div>
                                            </div>
                                        </CCol>
                                        
                                        <CCol sm="5" lg="12" col="5" md="12" style="flex: 1;">
                                            <label style="color: red; font-weight: 600;">{{ $t('Matched Filters') }}:</label>
                                            <div style="display: flex;">
                                                <div style="flex: 2;">
                                                    <label style="float: left; margin-top: 6px; margin-right: 5px;">{{ $t('Min') }}:</label>
                                                    <CInput type="number" min="0" max="90000000" :value="this.matchedMin" @update:value="matched_min" class="odd-filter-inputbox" style = "background: floralwhite !important"></CInput>
                                                </div>
                                            </div>
                                        </CCol>
                                    </CRow>
                                </CCol>
                            </CRow>
                        </div>
                    </CCol>
                    <CCol lg="12">
                        <label style="font-weight: 600; margin-top: 20px;" class="header_label">Live</label>
                        <div class="match-container">
                            <CRow>
                                <CCol sm="6" lg="2" md="6" col="6">
                                    <label style="color: red; font-weight: 600;">{{ $t('Score') }}:</label>
                                    <div class="score">
                                        <div v-if="(typeof timeRecord === 'string' && timeRecord.includes('undefined') === false) || typeof timeRecord === 'number'" style="background: #20a052;
                                            text-align: center;
                                            font-weight: 600;
                                            color: #fff;
                                            height: 30px;
                                            padding-top: 2px;
                                            border: 1px solid white;
                                            " class="height60 p_font_576">
                                            <label style="" class="p_font_576">{{$t(this.status)}}</label> {{this.timeRecord}}
                                        </div>
                                        <div v-else style="background: #20a052;
                                            text-align: center;
                                            font-weight: 600;
                                            color: #fff;
                                            height: 30px;
                                            padding-top: 2px;
                                            border: 1px solid white;
                                            " class="height60 p_font_576">
                                            <label style="" class = "p_font_576">Live </label>
                                        </div>
                                        <div v-if="this.marketStatus == 'SUSPENDED' || this.marketStatus ==  'CLOSED' " style="width: 130px;
                                                height: 30px;
                                                background: rgba(255,255,255,0.8);
                                                margin: auto;
                                                margin-top:-30px;
                                                border-radius: 3px;
                                                border: 1px solid red;
                                                color: red;
                                                padding-top: 3px;
                                                text-align: center;
                                                font-weight: 600;
                                                position: relative;" class="height60">
                                            {{$t(this.marketStatus)}}
                                        </div>
                                        <div :key="goal_key + '00'" :id="goal_key + '00'" style="background: #4db375;
                                                    font-size: 25px !important;
                                                    text-align: center;
                                                    font-weight: 600;
                                                    margin-bottom: 10px;
                                                    padding: 5px;
                                                    color: white;
                                                    height: 50px;
                                                    border: 1px solid white;
                                                    border-top: none;
                                                    " class = "height120">
                                            <p v-if="this.scoreOne" style="font-weight: 600;" class="p_font_score">
                                                {{this.scoreOne}}  {{this.scoreTwo}}
                                            </p>
                                        </div>
                                        <b-tooltip :key="goal_key + '001'" :target="goal_key + '00'" v-if="goal_tooltip != null" triggers="hover">
                                            {{goal_tooltip}}
                                        </b-tooltip>
                                    </div>
                                </CCol>
                                <CCol sm="6" lg="2" md="6" col="6" class="odd-cont1">
                                    <CRow style = "margin:0px;">
                                        <CCol sm="6" class="odd-cont" col="6">
                                            <label style="color: red; font-weight: 600;">{{ $t('Odds') }}:</label>
                                            <div style="width: 100%;
                                                        display: flex;
                                                        background: #6cd7fd;
                                                        text-align: center;
                                                        height: 30px;
                                                        border: 1px solid white;
                                                " class = "height60">
                                                <p style="margin-bottom: 0; text-align: center; width: 100%; font-weight: 600; padding-top: 2px;" class="p_font_576">{{ $t('Back') }}</p>
                                            </div>
                                            <div style="display: flex;
                                                        width: 100%;
                                                        background: #b7eafc;
                                                        text-align: center;
                                                        height: 25px;
                                                        border: 1px solid white;
                                                        border-top: none;
                                                " class = "height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="this.back" style="margin-bottom: 0; text-align: center; width: 100%; height: 23px; font-weight: 600;" class="height60 p_font_576">
                                                        {{this.back}}
                                                    </p>
                                                </transition>

                                            </div>
                                           
                                            <div style="display: flex;
                                                        width: 100%;
                                                        background: #b5e8fa;
                                                        text-align: center;
                                                        height: 25px;
                                                        border: 1px solid white;
                                                        border-top: none;
                                                " class = "height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="this.back_matched" v-if="this.back_matched != 0" style="padding-top: 2px; margin-bottom: 0; text-align: center; width: 100%; height: 23px;" class="height60">
                                                        {{this.currency_list[this.mycurrency].currencySymbol}}{{(this.back_matched  * this.currency_data[this.mycurrency]).toFixed(2)}}
                                                    </p>
                                                </transition>
                                            </div>
                                            <p style="text-align: center; width: 100%; font-weight: 600;">{{ $t('Total Matched') }}</p>
                                        </CCol>
                                        <CCol sm="6" class="odd-cont" col="6">
                                            <label style="color: #fff">{{ $t('Odds') }}:</label>
                                            <div style="width: 100%;
                                                        display: flex;
                                                        background: #fac9d1;
                                                        text-align: center;
                                                        height: 30px;
                                                        border: 1px solid white;
                                                        padding: 2px;" class = "height60">
                                                <p style="margin-bottom: 0; text-align: center; width: 100%; font-weight: 600;" class="p_font_576">{{ $t('Lay') }}</p>
                                            </div>
                                            <div style="display: flex;
                                                        width: 100%;
                                                        background: #fdecef;
                                                        text-align: center;
                                                        height: 25px;
                                                        border: 1px solid white;
                                                        border-top: none;
                                                         " class = "height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="this.lay" style="margin-bottom: 0; text-align: center; width: 100%; height: 23px; font-weight: 600;" class="height60 p_font_576">
                                                        {{this.lay}}
                                                    </p>
                                                </transition>
                                            </div>
                                            <div style="display: flex;
                                                        width: 100%;
                                                        background: #fdecef;
                                                        text-align: center;
                                                        height: 25px;
                                                        border: 1px solid white;
                                                        border-top: none;
                                                        " class = "height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="this.lay_matched" v-if="this.lay_matched != 0" style="padding-top: 2px; margin-bottom: 0; text-align: center; width: 100%; height: 23px;" class="height60">
                                                        {{this.currency_list[this.mycurrency].currencySymbol}}{{(this.lay_matched * this.currency_data[this.mycurrency]).toFixed(2)}}
                                                    </p>
                                                </transition>
                                            </div>
                                            <p style="text-align: center; width: 90%; font-weight: 600;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(this.total_matched * this.currency_data[this.mycurrency]).toFixed(2)}}</p>
                                        </CCol>
                                    </CRow>
                                </CCol>
                                <CCol sm="12" col="12" lg="8" md="12" class="stats_table_modify">
                                    <div >
                                        <CRow>
                                            <CCol sm="12" md="12" lg="6" col="12" class = "stats_table_modify1">
                                                <div class="header-content detail_total height60" style="width: 100%; float: left; height: 27px; color: red; font-weight: bold;">{{ $t('Total Live Stats') }}</div>
                                                <div class="header-content detail_total height60" style="padding-top: 6px; background: lightblue; width: 100%; height: 30px; float: left; border-left: 1px solid whitesmoke; font-size: 13px!important; font-weight: bold;">
                                                    <div style="width: 100%">
                                                        <div class="detail">
                                                            On
                                                        </div>
                                                        <div class="detail">
                                                            Off
                                                        </div>
                                                        <div class="detail">
                                                            Blk
                                                        </div>
                                                        <div class="detail">
                                                            In
                                                        </div>
                                                        <div class="detail">
                                                            Out
                                                        </div>
                                                        <div class="detail">
                                                            Cnr
                                                        </div>
                                                        <div class="detail">
                                                            DA
                                                        </div>
                                                        <div class="detail">
                                                            Poss
                                                        </div>
                                                        <div class="detail">
                                                            Red
                                                        </div>
                                                        <div class="detail">
                                                            Yel
                                                        </div>
                                                        <div class="detail">
                                                            Sbst
                                                        </div>
                                                        <div class="detail" style="min-width: 27px;">
                                                            Ini
                                                        </div>
                                                        <div class="detail">
                                                            PFM
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="detail_total height60" style="width: 100%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                                    <div style="width: 100%; padding: 3px 4px; color: #212529;">
                                                        <div v-if="item1.homeT.on == 0" class="detail" style="color: #212529;">
                                                            0
                                                        </div>
                                                        <div :key="item1.home_tooltip.onKey" :id="item1.home_tooltip.onKey"  v-if="item1.homeT.on > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.on}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.on != ''" :key="item1.home_tooltip.onKey + '1'" :target="item1.home_tooltip.onKey" triggers="hover">
                                                            {{item1.home_tooltip.on}}
                                                        </b-tooltip>

                                                        <div v-if="item1.homeT.off == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.off}}
                                                        </div>
                                                        <div :key="item1.home_tooltip.offKey" :id="item1.home_tooltip.offKey"  v-if="item1.homeT.off > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.off}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.off != ''" :key="item1.home_tooltip.offKey + '1'" :target="item1.home_tooltip.offKey" triggers="hover">
                                                            {{item1.home_tooltip.off}}
                                                        </b-tooltip>
                                                        <div :key="item1.home_tooltip.blkKey" :id="item1.home_tooltip.blkKey"  v-if="item1.homeT.blk > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.blk}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.blk != ''" :key="item1.home_tooltip.blkKey + '1'" :target="item1.home_tooltip.blkKey" triggers="hover">
                                                            {{item1.home_tooltip.blk}}
                                                        </b-tooltip>

                                                        <div v-if="item1.homeT.blk == 0 && item1.awayT.blk != 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.blk}}
                                                        </div>
                                                        <div v-if="item1.homeT.blk == null || (item1.homeT.blk == 0 && item1.awayT.blk == 0)" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.in == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.in}}
                                                        </div>
                                                        <div :key="item1.home_tooltip.inKey" :id="item1.home_tooltip.inKey"  v-if="item1.homeT.in > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.in}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.in != ''" :key="item1.home_tooltip.inKey + '1'" :target="item1.home_tooltip.inKey" triggers="hover">
                                                            {{item1.home_tooltip.in}}
                                                        </b-tooltip>
                                                        <div v-if="item1.homeT.in == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.out == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.out}}
                                                        </div>
                                                        <div :key="item1.home_tooltip.outKey" :id="item1.home_tooltip.outKey"  v-if="item1.homeT.out > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.out}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.out != ''" :key="item1.home_tooltip.outKey + '1'" :target="item1.home_tooltip.outKey" triggers="hover">
                                                            {{item1.home_tooltip.out}}
                                                        </b-tooltip>
                                                        <div v-if="item1.homeT.out == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.cnr == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.cnr}}
                                                        </div>
                                                        <div :key="item1.home_tooltip.cnrKey" :id="item1.home_tooltip.cnrKey"  v-if="item1.homeT.cnr > 0" class="detail" style="color: #212529;">
                                                            {{item1.homeT.cnr}}
                                                        </div>
                                                        <b-tooltip v-if="item1.home_tooltip.cnr != ''" :key="item1.home_tooltip.cnrKey + '1'" :target="item1.home_tooltip.cnrKey" triggers="hover">
                                                            {{item1.home_tooltip.cnr}}
                                                        </b-tooltip>

                                                        <div v-if="item1.homeT.cnr == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.da == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.da}}
                                                        </div>
                                                        <div v-if="item1.homeT.da > 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.da}}
                                                        </div>
                                                        <div v-if="item1.homeT.poss == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.poss == 0" class="detail" style="color: #212529">
                                                            {{item1.homeT.poss}}
                                                        </div>
                                                        <div v-if="item1.homeT.poss != 0 && item1.homeT.poss != null" class="detail" style="color: #212529">
                                                            {{item1.homeT.poss}}
                                                        </div>
                                                        <div v-if="item1.homeT.red == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.red == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>
                                                        <div v-if="item1.homeT.red != 0 && item1.homeT.red != null" class="detail" :id="item1.home_tooltip.redKey" :key="item1.home_tooltip.redKey" style="color: #212529; background-color: red;">
                                                            {{item1.homeT.red}}
                                                        </div>

                                                        <b-tooltip v-if="item1.home_tooltip.red != ''" :target="item1.home_tooltip.redKey" :key="item1.home_tooltip.redKey + '1'" triggers="hover">
                                                            {{item1.home_tooltip.red}}
                                                        </b-tooltip>
                                                        <div v-if="item1.homeT.yel == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.yel == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>
                                                        <div v-if="item1.homeT.yel != 0 && item1.homeT.yel != null" class="detail" :id="item1.home_tooltip.yelKey" :key="item1.home_tooltip.yelKey"  style="color: #212529">
                                                            {{item1.homeT.yel}}
                                                        </div>

                                                        <b-tooltip v-if="item1.home_tooltip.yel != ''" :target="item1.home_tooltip.yelKey" :key="item1.home_tooltip.yelKey + '1'" triggers="hover">
                                                            {{item1.home_tooltip.yel}}
                                                        </b-tooltip>
                                                        <div v-if="item1.homeT.sbst == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>
                                                        <div v-if="item1.homeT.sbst == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>
                                                        <div v-if="item1.homeT.sbst != 0 && item1.homeT.sbst != null" class="detail"  :id="item1.home_tooltip.sbstKey" :key="item1.home_tooltip.sbstKey"  style="color: #212529">
                                                            {{item1.homeT.sbst}}
                                                        </div>

                                                         <b-tooltip v-if="item1.home_tooltip.sbst != ''" :target="item1.home_tooltip.sbstKey" :key="item1.home_tooltip.sbstKey + '1'" triggers="hover">
                                                            {{item1.home_tooltip.sbst}}
                                                        </b-tooltip>
                                                        <div class="detail" style="color: #212529; min-width: 27px; font-weight: bold">
                                                            {{item1.homeT.nxt}}
                                                        </div>
                                                        <div class="detail" style="color: #212529; font-weight: bold">
                                                            {{item1.homeT.rtg}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="detail_total height60" style="width: 100%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                                    <div style="width: 100%; padding: 3px 4px; color: black;">
                                                        <div v-if="item1.awayT.on == 0"  class="detail" style="color: #212529;">
                                                            {{item1.awayT.on}}
                                                        </div>
                                                        <div :key="item1.away_tooltip.onKey" :id="item1.away_tooltip.onKey"  v-if="item1.awayT.on > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.on}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.on != ''" :key="item1.away_tooltip.onKey + '1'" :target="item1.away_tooltip.onKey" triggers="hover">
                                                            {{item1.away_tooltip.on}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.off == 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.off}}
                                                        </div>
                                                        <div :key="item1.away_tooltip.offKey" :id="item1.away_tooltip.offKey"  v-if="item1.awayT.off > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.off}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.off != ''" :key="item1.away_tooltip.offKey + '1'" :target="item1.away_tooltip.offKey" triggers="hover">
                                                            {{item1.away_tooltip.off}}
                                                        </b-tooltip>

                                                        <div :key="item1.away_tooltip.blkKey" :id="item1.away_tooltip.blkKey"  v-if="item1.awayT.blk > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.blk}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.blk != ''" :key="item1.away_tooltip.blkKey + '1'" :target="item1.away_tooltip.blkKey" triggers="hover">
                                                            {{item1.away_tooltip.blk}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.blk == 0 && item1.homeT.blk != 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.blk}}
                                                        </div>

                                                        <div v-if="item1.awayT.blk == null || (item1.awayT.blk == 0 && item1.homeT.blk == 0)" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.in == 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.in}}
                                                        </div>
                                                        <div :key="item1.away_tooltip.inKey" :id="item1.away_tooltip.inKey"  v-if="item1.awayT.in > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.in}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.in != ''" :key="item1.away_tooltip.inKey + '1'" :target="item1.away_tooltip.inKey" triggers="hover">
                                                            {{item1.away_tooltip.in}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.in == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.out == 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.out}}
                                                        </div>
                                                        <div :key="item1.away_tooltip.outKey" :id="item1.away_tooltip.outKey"  v-if="item1.awayT.out > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.out}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.out != ''" :key="item1.away_tooltip.outKey + '1'" :target="item1.away_tooltip.outKey" triggers="hover">
                                                            {{item1.away_tooltip.out}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.out == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.cnr == 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.cnr}}
                                                        </div>
                                                        <div :key="item1.away_tooltip.cnrKey" :id="item1.away_tooltip.cnrKey"  v-if="item1.awayT.cnr > 0" class="detail" style="color: #212529;">
                                                            {{item1.awayT.cnr}}
                                                        </div>
                                                        <b-tooltip v-if="item1.away_tooltip.cnr != ''" :key="item1.away_tooltip.cnrKey + '1'" :target="item1.away_tooltip.cnrKey" triggers="hover">
                                                            {{item1.away_tooltip.cnr}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.cnr == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.da == 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.da}}
                                                        </div>

                                                        <div v-if="item1.awayT.da > 0" class="detail" style="color: #212529">
                                                            {{item1.awayT.da}}
                                                        </div>

                                                        <div v-if="item1.awayT.poss == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.poss == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>

                                                        <div v-if="item1.awayT.poss != 0 && item1.awayT.poss != null" class="detail" style="color: #212529">
                                                            {{item1.awayT.poss}}
                                                        </div>

                                                        <div v-if="item1.awayT.red == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.red == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>

                                                        <div v-if="item1.awayT.red > 0" class="detail" :id="item1.away_tooltip.redKey" :key="item1.away_tooltip.redKey" style="color: #212529; background-color: red;">
                                                            {{item1.awayT.red}}
                                                        </div>

                                                        <b-tooltip v-if="item1.away_tooltip.red != ''" :key="item1.away_tooltip.redKey + '1'" :target="item1.away_tooltip.redKey" triggers="hover">
                                                            {{item1.away_tooltip.red}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.yel == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.yel == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>

                                                        <div v-if="item1.awayT.yel > 0" class="detail" :key="item1.away_tooltip.yelKey"  :id="item1.away_tooltip.yelKey"  style="color: #212529">
                                                            {{item1.awayT.yel}}
                                                        </div>

                                                        <b-tooltip v-if="item1.away_tooltip.yel != ''" :key="item1.away_tooltip.yelKey + '1'" :target="item1.away_tooltip.yelKey" triggers="hover">
                                                            {{item1.away_tooltip.yel}}
                                                        </b-tooltip>

                                                        <div v-if="item1.awayT.sbst == null" class="detail" style="color: #212529">
                                                            -
                                                        </div>

                                                        <div v-if="item1.awayT.sbst == 0" class="detail" style="color: #212529">
                                                            0
                                                        </div>

                                                        <div v-if="item1.awayT.sbst > 0" class="detail" :key="item1.away_tooltip.sbstKey"  :id="item1.away_tooltip.sbstKey"  style="color: #212529">
                                                            {{item1.awayT.sbst}}
                                                        </div>

                                                        <b-tooltip v-if="item1.away_tooltip.sbst != ''" :key="item1.away_tooltip.sbstKey + '1'"  :target="item1.away_tooltip.sbstKey" triggers="hover">
                                                            {{item1.away_tooltip.sbst}}
                                                        </b-tooltip>

                                                        
                                                        <div class="detail" style="color: #212529; min-width: 27px; font-weight: bold">
                                                            {{item1.awayT.nxt}}
                                                        </div>
                                                        <div class="detail" style="color: #212529; font-weight: bold">
                                                            {{item1.awayT.rtg}}
                                                        </div>
                                                    </div>
                                                </div>
                                            </CCol>
                                            <CCol sm="12" md="12" lg="6" col="12" class="stats_table_modify1">
                                                <div class="header-content detail_total" style="width: 80%; float: left; color: red; font-weight: bold;">{{ $t('Last 10 minutes Live Stats') }}</div>
                                                <div style="width: 20%; height: 27px; float: left; color: #fffff0" class = "height60">.</div>
                                                <div class="header-content detail_total height60" style="padding-top: 6px; background: lightblue; width: 80%; height: 30px; float: left; border-left: 1px solid whitesmoke; font-size: 13px!important; font-weight: bold;">
                                                    <div style="width: 100%">
                                                        <div class="detail1">
                                                            On
                                                        </div>
                                                        <div class="detail1">
                                                            Off
                                                        </div>
                                                        <div class="detail1">
                                                            Blk
                                                        </div>
                                                        <div class="detail1">
                                                            In
                                                        </div>
                                                        <div class="detail1">
                                                            Out
                                                        </div>
                                                        <div class="detail1">
                                                            Cnr
                                                        </div>
                                                        <div class="detail1">
                                                            DA
                                                        </div>
                                                        <div class="detail1">
                                                            Poss
                                                        </div>
                                                        <div class="detail1">
                                                            Sbst
                                                        </div>
                                                        <div class="detail1" style="min-width: 24px;">
                                                            Goal
                                                        </div>
                                                        <div class="detail1">
                                                            Rtg
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width: 20%; height: 32px; float: left; color: red; font-weight: normal; position: relative; top: 5px; left: 10px; font-weight: bold;" class = "height60">atk chart</div>
                                                <div class="detail_total" style="width: 80%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                                    <div style="width: 100%; color: black;">
                                                        <div v-if="item1.home.on >= 0" class="detail1" :style="{'color': item1.home1.on}">
                                                            {{item1.home.on}}
                                                        </div>
                                                        <div v-if="item1.home.on == null" class="detail1" :style="{'color': item1.home1.on}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.home.off >= 0" class="detail1" :style="{'color': item1.home1.off}">
                                                            {{item1.home.off}}
                                                        </div>
                                                        <div v-if="item1.home.off == null" class="detail1" :style="{'color': item1.home1.off}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.home.blk > 0" class="detail1" :style="{'color': item1.home1.blk}">
                                                            {{item1.home.blk}}
                                                        </div>
                                                        <div v-if="(item1.home.blk == 0 && item1.away.blk != 0)" class="detail1" :style="{'color': item1.home1.blk}">
                                                            {{item1.home.blk}}
                                                        </div>
                                                        <div v-if="item1.home.blk == null || (item1.home.blk == 0 && item1.away.blk == 0)" class="detail1" :style="{'color': item1.home1.blk}">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.in > 0" class="detail1" :style="{'color': item1.home1.in}">
                                                            {{item1.home.in}}
                                                        </div>
                                                        <div v-if="item1.home.in == 0" class="detail1" :style="{'color': item1.home1.in}">
                                                            {{item1.home.in}}
                                                        </div>
                                                        <div v-if="item1.home.in == null" class="detail1" :style="{'color': item1.home1.in}">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.out > 0" class="detail1" :style="{'color': item1.home1.out}">
                                                            {{item1.home.out}}
                                                        </div>
                                                        <div v-if="item1.home.out == 0" class="detail1" :style="{'color': item1.home1.out}">
                                                            {{item1.home.out}}
                                                        </div>
                                                        <div v-if="item1.home.out == null" class="detail1" :style="{'color': item1.home1.out}">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.cnr == 0" class="detail1" :style="{'color': item1.home1.cnr}">
                                                            {{item1.home.cnr}}
                                                        </div>
                                                        <div v-if="item1.home.cnr > 0" class="detail1" :style="{'color': item1.home1.cnr}">
                                                            {{item1.home.cnr}}
                                                        </div>
                                                        <div v-if="item1.home.cnr == null" class="detail1" :style="{'color': item1.home1.cnr}">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.da == 0" class="detail1" :style="{'color': item1.home1.da}">
                                                            {{item1.home.da}}
                                                        </div>
                                                        <div v-if="item1.home.da > 0" class="detail1" :style="{'color': item1.home1.da}">
                                                            {{item1.home.da}}
                                                        </div>
                                                        <div v-if="item1.home.da == null" class="detail1" :style="{'color': item1.home1.da}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.home.poss == null" class="detail1" :style="{'color': item1.home1.poss}">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.poss == 0" class="detail1" :style="{'color': item1.home1.poss}">
                                                            0
                                                        </div>
                                                        <div v-if="item1.home.poss != null && item1.home.poss != 0" class="detail1" :style="{'color': item1.home1.poss}">
                                                            {{item1.home.poss}}
                                                        </div>
                                                        <div v-if="item1.home.sbst == null" class="detail1" style="color: black">
                                                            -
                                                        </div>

                                                        <div v-if="item1.home.sbst == 0" class="detail1" style="color: black">
                                                            0
                                                        </div>
                                                        <div v-if="item1.home.sbst != null && item1.home.sbst != 0" class="detail1" style="color: black">
                                                            {{item1.home.sbst}}
                                                        </div>

                                                        <div v-if="item1.home.goal == null" class="detail1" style="color: black; min-width: 24px;">
                                                            -
                                                        </div>
                                                        <div v-if="item1.home.goal != null" class="detail1" style="color: black;  min-width: 24px;">
                                                            {{item1.home.goal}}
                                                        </div>
                                                        <div v-if="item1.home.rtg > item1.home.a_rtg" class="detail1" style="color: #263043; font-weight: bold; background: #d4edda; height: 31px;">
                                                            {{item1.home.rtg}}
                                                        </div>
                                                        <div v-else class="detail1" style="color: #263043; font-weight: bold; height: 31px;">
                                                            {{item1.home.rtg}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width: 20%; height: 32px; float: left;" class = "height60">
                                                    <div
                                                            duration="100"
                                                            style="height: 0px; position: relative; left: 21px; float: left; z-index: 1000;" class="atk_chart_image"
                                                    >
                                                        <img v-if="item1.fixtureId !== undefined " v-b-modal.modal-center src="/img/info_icon.png" @click="callHistoricalData(item1.home.id, item1.away.id, item1.season_id, item1.home.name + ' v ' + item1.away.name, item1.home.rtg, item1.home.a_rtg, item1.away.rtg, item1.away.a_rtg, item1.fixtureId)" width="13px;" style="width: 20px; cursor: pointer; outline: none;"/>
                                                        <!--                                <img v-if="isPlus(item1.index0)" @click="callHistoricalData(item1.home.id, item1.away.id, item1.season_id)" src="/img/ico-plus.png" width="13px;" style="width: 16px; cursor: pointer;"/>-->
                                                        <!--                                <img v-if="isMinus(item1.index0)"  src="/img/ico-minus.png" width="13px;" style="width: 16px; cursor: pointer;"/>-->
                                                    </div>
                                                </div>
                                                <div class="detail_total height60" style="width: 80%; height: 30px; float: left; border-left: 1px solid #e2e2e2;">
                                                    <div style="width: 100%; color: black;">
                                                        <div v-if="item1.away.on == null" class="detail1" :style="{'color': item1.away1.on}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.on != null" class="detail1" :style="{'color': item1.away1.on}">
                                                            {{item1.away.on}}
                                                        </div>

                                                        <div v-if="item1.away.off == null" class="detail1" :style="{'color': item1.away1.off}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.off != null" class="detail1" :style="{'color': item1.away1.off}">
                                                            {{item1.away.off}}
                                                        </div>

                                                        <div v-if="item1.away.blk > 0" class="detail1" :style="{'color': item1.away1.blk}">
                                                            {{item1.away.blk}}
                                                        </div>

                                                        <div v-if="item1.away.blk == 0 && item1.home.blk != 0" class="detail1" :style="{'color': item1.away1.blk}">
                                                            {{item1.away.blk}}
                                                        </div>

                                                        <div v-if="item1.away.blk == null || (item1.away.blk == 0 && item1.home.blk == 0)" class="detail1" :style="{'color': item1.away1.blk}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.in == 0" class="detail1" :style="{'color': item1.away1.in}">
                                                            {{item1.away.in}}
                                                        </div>

                                                        <div v-if="item1.away.in > 0" class="detail1" :style="{'color': item1.away1.in}">
                                                            {{item1.away.in}}
                                                        </div>

                                                        <div v-if="item1.away.in == null" class="detail1" :style="{'color': item1.away1.in}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.out == 0" class="detail1" :style="{'color': item1.away1.out}">
                                                            {{item1.away.out}}
                                                        </div>

                                                        <div v-if="item1.away.out > 0" class="detail1" :style="{'color': item1.away1.out}">
                                                            {{item1.away.out}}
                                                        </div>

                                                        <div v-if="item1.away.out == null" class="detail1" :style="{'color': item1.away1.out}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.cnr == 0" class="detail1" :style="{'color': item1.away1.cnr}">
                                                            {{item1.away.cnr}}
                                                        </div>

                                                        <div v-if="item1.away.cnr > 0" class="detail1" :style="{'color': item1.away1.cnr}">
                                                            {{item1.away.cnr}}
                                                        </div>

                                                        <div v-if="item1.away.cnr == null" class="detail1" :style="{'color': item1.away1.cnr}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.da == 0" class="detail1" :style="{'color': item1.away1.da}">
                                                            {{item1.away.da}}
                                                        </div>

                                                        <div v-if="item1.away.da > 0" class="detail1" :style="{'color': item1.away1.da}">
                                                            {{item1.away.da}}
                                                        </div>

                                                        <div v-if="item1.away.da == null" class="detail1" :style="{'color': item1.away1.da}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.poss == null" class="detail1" :style="{'color': item1.away1.poss}">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.poss == 0" class="detail1" :style="{'color': item1.away1.poss}">
                                                            0
                                                        </div>

                                                        <div v-if="item1.away.poss != null && item1.away.poss != 0" class="detail1" :style="{'color': item1.away1.poss}">
                                                            {{item1.away.poss}}
                                                        </div>

                                                        <div v-if="item1.away.sbst == null" class="detail1" style="color: black">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.sbst == 0" class="detail1" style="color: black">
                                                            0
                                                        </div>

                                                        <div v-if="item1.away.sbst != null && item1.away.sbst != 0" class="detail1" style="color: black">
                                                            {{item1.away.sbst}}
                                                        </div>

                                                        <div v-if="item1.away.goal == null" class="detail1" style="color: black; min-width: 24px;">
                                                            -
                                                        </div>

                                                        <div v-if="item1.away.goal != null" class="detail1" style="color: black; min-width: 24px;">
                                                            {{item1.away.goal}}
                                                        </div>
                                                        <div v-if="item1.away.rtg > item1.away.a_rtg" class="detail1" style="color: #263043; font-weight: bold; background: #d4edda; height: 31px;">
                                                            {{item1.away.rtg}}
                                                        </div>
                                                        <div v-else class="detail1" style="color: #263043; height: 31px; font-weight: bold">
                                                            {{item1.away.rtg}}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div style="width: 20%; height: 50px; float: left;" class = "height120">
                                                    <div style="width: 8%; height: 50px; float: left;">.</div>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
                    </CCol>
                    <CCol lg="12" style="height: 20px;"></CCol>
                    <CCol lg="6" style="margin-bottom: 20px; height: fit-content;">
                        <div class="select-container" style="padding-bottom: 20px;">
                            <label  style="font-weight: 600;" class="header_label">{{ $t('Messages') }}</label>
                            <div class="select-container2">
                                <CRow>
                                    
                                    <!-- <CCol sm="7">
                                        <label style="color: red; font-weight: 600;">{{ $t('Cash out bar') }}:</label>
                                        <div style="">
                                            <div v-if="percent_text1 == ''" class="percent1" :style="{'background': percentBackgroundColor, 'color': percentTextColor1, 'text-align': 'center', 'width': '100%', 'padding': '2px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text1}}
                                            </div>
                                            <div v-else class="percent1" :style="{'background': percentBackgroundColor, 'color': percentTextColor1, 'text-align': 'center', 'width': '100%', 'padding': '2px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                  {{this.percent_text1_}}
                                            </div>
                                            <div v-if="percent_text1 != ''" class="percent2" :style="{'background': percentBackgroundColor1, 'color': percentTextColor, 'text-align': 'center', 'width': '100%', 'padding': '2px','padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic', 'height': '62px'}">
                                                {{this.percent_text2}}
                                            </div>
                                            <div v-if="percent_text1 != ''" class="percent2 message_size" :style="{'background': percentBackgroundColor1, 'color': percentTextColor, 'text-align': 'center', 'width': '100%', 'height': '62px', 'padding': '2px','padding-top': '14px', 'padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text2}}
                                            </div>
                                            <div v-if="percent_text1 == ''" class="percent2 message_size" :style="{'background': percentBackgroundColor1, 'color': percentTextColor, 'text-align': 'center', 'width': '100%', 'height': '62px', 'padding': '2px','padding-top': '14px', 'padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text2}}
                                            </div>
                                        </div>
                                        <div>
                                            <div style="width: 50%; float: left; text-align: left; padding-left: 10px;">
                                                {{ $t('Max profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{guad_max}}
                                            </div>
                                            <div style="width: 50%; text-align: right; float: right; padding-right: 10px;">
                                                {{ $t('Current Profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{guad_att}}
                                            </div>
                                        </div>
                                    </CCol> -->
                                    <CCol sm="7">
                                        <label style="color: red; font-weight: 600;">{{ $t('Cash out bar') }}:</label>
                                        <div style="">
                                            <div class="percent1" :style="{'background': percentBackgroundColor, 'color': percentTextColor1, 'text-align': 'center', 'width': '100%', 'padding': '2px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text1}}
                                            </div>
                                            <div v-if="percent_text1 != ''" class="percent2" :style="{'background': percentBackgroundColor1, 'color': percentTextColor, 'text-align': 'center', 'width': '100%', 'padding': '2px','padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text2}}
                                            </div>
                                            <div v-if="percent_text1 == ''" class="percent2 message_size" :style="{'background': percentBackgroundColor1, 'color': percentTextColor, 'text-align': 'center', 'width': '100%', 'height': '62px', 'padding': '2px','padding-top': '14px', 'padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.percent_text2}}
                                            </div>
                                        </div>
                                        <div>
                                            <div style="width: 50%; float: left; text-align: left; padding-left: 10px;">
                                                {{ $t('Max profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{guad_max}}
                                            </div>
                                            <div style="width: 50%; text-align: right; float: right; padding-right: 10px;">
                                                {{ $t('Current Profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{guad_att}}
                                            </div>
                                        </div>
                                    </CCol>
                                    <CCol sm="5">
                                        <label style="color: red; font-weight: 600;">{{ $t('Correct Score bar') }}:</label>
                                        <div style="">
                                            <div class="percent1" :style="{'background': cs_percentBackgroundColor, 'color': cs_percentTextColor1, 'text-align': 'center', 'width': '100%', 'padding': '2px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.cs_percent_text1}}
                                            </div>
                                            <div v-if="cs_percent_text1 != ''" class="percent2" :style="{'background': cs_percentBackgroundColor1, 'color': cs_percentTextColor, 'text-align': 'center', 'width': '100%', 'padding': '2px','padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.cs_percent_text2}}
                                            </div>
                                            <div v-if="cs_percent_text1 == ''" class="percent2 message_size" :style="{'background': cs_percentBackgroundColor1, 'color': cs_percentTextColor, 'text-align': 'center', 'width': '100%', 'height': '62px', 'padding': '2px','padding-top': '14px', 'padding-bottom': '5px', 'font-size': '18px!important', 'font-weight': '700', 'font-style': 'italic'}">
                                                {{this.cs_percent_text2}}
                                            </div>
                                        </div>
                                        <div>
                                            <div style="width: 45%; float: left; text-align: left; padding-left: 10px;">
                                                {{ $t('Max profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{cs_guad_max}}
                                            </div>
                                            <div style="width: 55%; text-align: right; float: right; padding-right: 10px;">
                                                {{ $t('Current Profit') }}:   {{this.currency_list[this.mycurrency].currencySymbol}} {{cs_guad_att}}
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                            </div>
                        </div>
                        <div class="select-container">
                            <label style="font-weight: 600;" class="header_label">{{ $t('Select') }}</label>
                            <div class="select-container1">
                                <CRow>
                                    <CCol sm="12" lg="12" col="12">
                                        <!-- First Line: Inputs and Select Risk Trading, Top Aligned -->
                                        <div style="display: flex; align-items: flex-start; gap: 10px;">
                                            <!-- Enter the Odd with label below -->
                                            <div style="flex: 0.5;">
                                                <label style="color: red; font-weight: 600;">{{ $t('Enter the Odd') }}</label>
                                                <CInput
                                                    type="number"
                                                    :value="calc_odd"
                                                    @update:value="odd_calc"
                                                    style="background: floralwhite; width: 100%;"
                                                ></CInput>
                                                <label style="font-weight: 600;">pre-match Odd: {{ this.prematchOdd }}</label>
                                            </div>

                                            <!-- Enter the Stake -->
                                            <div style="flex: 0.5;">
                                                <label style="color: red; font-weight: 600;">{{ $t('Enter the Stake') }}</label>
                                                <CInput
                                                    type="number"
                                                    :value="calc_stake"
                                                    @update:value="stake_calc"
                                                    style="background: floralwhite; width: 100%;"
                                                ></CInput>
                                                <label v-if="selectedArray[6] == 1" style="font-weight: 600;">
                                                    {{ $t('Responsibility') }}: <span style="color: blue;">{{ this.currency_list[this.mycurrency].currencySymbol }}{{ max_lose }}</span>
                                                </label>
                                            </div>

                                            <!-- Bookmaker -->
                                            <div style="flex: 0.5;">
                                                <label style="color: red; font-weight: 600;">{{ $t('Bookmaker') }}(%)</label>
                                                <CInput
                                                    type="number"
                                                    :value="bookmarkerFee"
                                                    @update:value="bookmaker_fee"
                                                    style="background: floralwhite; width: 100%;"
                                                ></CInput>
                                            </div>

                                            <!-- Select Risk Trading -->
                                            <div style="flex: 1;">
                                                <label style="color: red; font-weight: 600;">{{ $t('Select Risk Trading') }}</label>
                                                <CSelect
                                                    :value.sync="risk_key"
                                                    :options="[
                                                        { value: '3', label: 'Auto' },
                                                        { value: '0', label: this.$t('Easy') },                                                       
                                                        { value: '1', label: this.$t('Medium') },                                                        
                                                        { value: '2', label: this.$t('Risky') }
                                                    ]"
                                                    @update:value="riskMode"
                                                    style="background: floralwhite; width: 100%;"
                                                ></CSelect>
                                            </div>
                                        </div>

                                        <!-- Second Line: Center-aligned Elements and Buttons with Reduced Line Spacing -->
                                        <div style="display: flex; align-items: center; gap: 10px; margin-top: 0.1rem;">
                                            <!-- S/L Checkbox with Label on Top, Reduced Width, and Closer Spacing -->
                                            <div style="flex: 0.25; display: flex; flex-direction: column; align-items: center; margin-right: -5px;">
                                                <label style="color: red; font-weight: 600;">S/L:</label>
                                                <CInputCheckbox
                                                    class="check-box0"
                                                    @update:checked="stopLossfunction"
                                                    :checked="checked_stoploss"
                                                ></CInputCheckbox>
                                            </div>

                                            <!-- Trading Checkbox with Label on Top, Reduced Width, and Closer Spacing -->
                                            <div style="flex: 0.25; display: flex; flex-direction: column; align-items: center; margin-left: -15px;">
                                                <label style="color: red; font-weight: 600;">Trading:</label>
                                                <CInputCheckbox
                                                    class="check-box0 trading-mode"
                                                    @update:checked="tradingModefunction"
                                                    :checked.sync="checked_trading"
                                                ></CInputCheckbox>
                                            </div>

                                            <!-- Select Strategy Field with Extended Width and Extra Space for Label -->
                                            <div style="flex: 1;">
                                                <label style="color: red; font-weight: 600; margin-bottom: 16px;">{{ $t('Select Strategy') }}</label>
                                                <div v-if="!tradingMode">
                                                    <CSelect class="alert-name-list" :options="alertNameList1" style="background: floralwhite; width: 100%;"></CSelect>
                                                </div>
                                                <div v-else>
                                                    <CSelect
                                                        class="alert-name-list"
                                                        :value.sync="alert_key"
                                                        :options="currentAlertList"
                                                        @update:value="update_alert_name"
                                                        style="background: floralwhite; width: 100%;"
                                                    ></CSelect>
                                                </div>
                                            </div>

                                            <!-- Save and Delete Buttons with Equal Width and Hover Effect -->
                                            <div style="flex: 1; display: flex; gap: 5px;">
                                                <CButton color="info" style="width: 100%; transition: 0.3s;" @click="save_calc">
                                                    {{ $t('Save Data') }}
                                                </CButton>
                                                <CButton color="danger" style="width: 100%; transition: 0.3s;" @click="delete_calc">
                                                    {{ $t('Delete Data') }}
                                                </CButton>
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                            </div>

                            <label style="font-weight: 600;" class="header_label">{{ $t('Select CS') }}</label>
                            <div class="select-container1">
                                <CRow>
                                    <!-- First Column: Correct Score, CS Odd, and CS Stake Inputs in a Single Row -->
                                    <CCol sm="12" lg="8" md="8" col="12">
                                        <CRow>
                                            <CCol col="4">
                                                <label style="color: red; font-weight: 600;">{{ $t('Correct Score') }}:</label>
                                                <CSelect
                                                    :value.sync="key2"
                                                    :options="correctScoreList"
                                                    @update:value="correct_score_update"
                                                    style="background: floralwhite !important; width: 100%;"
                                                ></CSelect>
                                            </CCol>
                                            <CCol col="4">
                                                <label style="color: red; font-weight: 600;">{{ $t('Enter CS Odd') }}:</label>
                                                <CInput
                                                    type="number"
                                                    :value="cs_odd"
                                                    @update:value="cs_calc"
                                                    style="background: floralwhite !important; width: 100%;"
                                                ></CInput>
                                            </CCol>
                                            <CCol col="4">
                                                <label style="color: red; font-weight: 600;">{{ $t('Enter CS Stake') }}:</label>
                                                <CInput
                                                    type="number"
                                                    :value="cs_stake"
                                                    @update:value="cs_stake_calc"
                                                    style="background: floralwhite !important; width: 100%;"
                                                ></CInput>
                                            </CCol>
                                        </CRow>
                                        <label style="font-weight: 600;">{{ $t('Stake to cover') }}: {{ this.currency_list[this.mycurrency].currencySymbol }}{{ stakeToCover }}</label>
                                    </CCol>

                                    <!-- Back and Lay Sections in a Single Line with 1px Spacing -->
                                    <CCol sm="12" lg="4" md="4" col="12" style="display: flex;">
                                        <!-- Back Section -->
                                        <div style="flex: 1; margin-right: 1px;">
                                            <label style="color: red; font-weight: 600;">{{ $t('CS Odds') }}:</label>
                                            <div style="display: flex; background: #6cd7fd; text-align: center; height: 30px; border: 1px solid white;" class="height60">
                                                <p style="width: 100%; font-weight: 600;" class="p_font_576">{{ $t('Back') }}</p>
                                            </div>
                                            <div style="display: flex; background: #b7eafc; text-align: center; height: 25px; border: 1px solid white; border-top: none;" class="height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="CS_Odd_back_price" style="width: 100%; font-weight: 600; text-align: center;" class="p_font_576">{{ CS_Odd_back_price }}</p>
                                                </transition>
                                            </div>
                                            <div style="display: flex; background: #b5e8fa; text-align: center; height: 25px; border: 1px solid white; border-top: none;" class="height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="CS_Odd_back_stack" v-if="CS_Odd_back_stack != null" style="width: 100%; text-align: center;">
                                                        {{ this.currency_list[this.mycurrency].currencySymbol }}{{ CS_Odd_back_stack }}
                                                    </p>
                                                </transition>
                                            </div>
                                            <p style="text-align: center; font-weight: 600;" class="height60">{{ $t('Total Matched') }}</p>
                                        </div>

                                        <!-- Lay Section -->
                                        <div style="flex: 1;">
                                            <label style="color: #F5F5F5; font-weight: 600;"> .</label>
                                            <div style="display: flex; background: #fac9d1; height: 30px; border: 1px solid white;" class="height60">
                                                <p style="width: 100%; font-weight: 600; text-align: center;" class="p_font_576">{{ $t('Lay') }}</p>
                                            </div>
                                            <div style="display: flex; background: #fdecef; height: 25px; border: 1px solid white;" class="height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="CS_Odd_lay_price" style="width: 100%; font-weight: 600; text-align: center;" class="p_font_576">{{ CS_Odd_lay_price }}</p>
                                                </transition>
                                            </div>
                                            <div style="display: flex; background: #fdecef; height: 25px; border: 1px solid white;" class="height60">
                                                <transition name="slide-fade" mode="out-in">
                                                    <p :key="CS_Odd_lay_stack" v-if="CS_Odd_lay_stack != null" style="width: 100%; text-align: center;">
                                                        {{ this.currency_list[this.mycurrency].currencySymbol }}{{ CS_Odd_lay_stack }}
                                                    </p>
                                                </transition>
                                            </div>
                                            <p v-if="CS_total_matched != null" style="text-align: center; font-weight: 600;">{{ this.currency_list[this.mycurrency].currencySymbol }}{{ CS_total_matched }}</p>
                                        </div>
                                    </CCol>
                                </CRow>
                            </div>
                        </div>
                    </CCol>
                    
                    <CCol lg="6" style = "margin-top: 20px; margin-bottom: 20px;">
                        <CTabs variant="tabs" :active-tab="1">
                            <CTab title="Betfair Classic">
                                <div class="betfair-classic-container1">
                                    <CRow style="margin: 0;">
                                        <CCol v-if="selectedArray[6] == 0 || !selectedArray[6]" sm="12" style="padding: 0px;">
                                            <div class="back-header height60" style="height: 25px; background: #6dd9ff; padding: 2px 10px; font-weight: 600; color: black;">
                                                <div style="width: 35%; float: left">
                                                    {{ $t('Back') }}
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    {{ $t('Odd') }}
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Stake
                                                </div>
                                                <div style="width: 25%; float: left">
                                                    Profit
                                                </div>
                                            </div>
                                            <div class="back-content" style="height: 70px; background: #b9edff; padding: 5px;">
                                                <div style="width: 35%; float: left; color: #b5e8fa">
                                                    .
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            class="inputOdd"
                                                            :value="calc_odd"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            class="inputOdd"
                                                            :value="calc_stake"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 25%; float: left; height: 30px; padding-top: 12px;" class="height60">
                                                    {{this.currency_list[this.mycurrency].currencySymbol}}{{max_profit}}
                                                </div>
                                                <div style="font-style: italic; font-weight: 600; margin-top: 40px;">You're betting in favour of: {{classic_match}}</div>
                                            </div>
                                        </CCol>
                                        <CCol v-if="selectedArray[6] == 1 " sm="12" style="padding: 0px;">
                                            <div class="back-header" style="height: 25px; background: #ebedef; padding: 2px 10px; font-weight: 600;">
                                                <div style="width: 35%; float: left">
                                                    Back
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Odd
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Stake
                                                </div>
                                                <div style="width: 25%; float: left">
                                                    Profit
                                                </div>
                                            </div>
                                            <div class="back-content" style="height: 70px; background: #ebedef; padding: 5px;">
                                                <div style="width: 35%; float: left; color: #b5e8fa">
                                                    .
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            class="inputOdd1"
                                                            :value="back"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            class="inputOdd1"
                                                            :value="((calc_odd*calc_stake)/(back)).toFixed(2)"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 35%; float: left; height: 30px; padding-top: 12px;" class="height60">
                                                    {{this.currency_list[this.mycurrency].currencySymbol}}{{((calc_odd*calc_stake)/(back)*(back - 1)).toFixed(2)}}
                                                </div>
                                                <div style="font-style: italic; font-weight: 600; margin-top: 40px;">You're betting in favour of: {{classic_match}}</div>
                                            </div>
                                        </CCol>
                                        <CCol sm="12" style="height: 5px;">
                                        </CCol>
                                        <CCol  v-if="selectedArray[6] == 1 || !selectedArray[6]" sm="12" style="padding: 0px; margin-bottom: 5px;">
                                            <div class="lay-header" style="height: 25px; background: #fac9d1; color:black; padding: 2px 10px; font-weight: 600;">
                                                <div style="width: 35%; float: left">
                                                    Lay
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Odd
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Profit
                                                </div>
                                                <div style="width: 25%; float: left; ">
                                                    Responsibility
                                                </div>
                                            </div>
                                            <div class="lay-content" style="height: 70px;background: #fdecef; padding: 5px;">
                                                <div style="width: 35%; float: left; color: #b5e8fa">
                                                    .
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            :value="calc_odd"
                                                            class="inputOdd"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            class="inputOdd"
                                                            :value="calc_stake"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 25%; float: left; height: 30px; padding-top: 12px;" class="height60">
                                                    {{this.currency_list[this.mycurrency].currencySymbol}}{{(calc_odd*calc_stake - calc_stake).toFixed(2)}}
                                                </div>
                                                <div style="font-style: italic; font-weight: 600; margin-top:40px;">You're betting against of: {{classic_match}}</div>
                                            </div>

                                        </CCol>
                                        <CCol  v-if="selectedArray[6] == 0" sm="12" style="padding: 0px; margin-bottom: 5px;">
                                            <div class="lay-header" style="height: 25px; background: #ebedef; padding: 2px 10px; font-weight: 600;">
                                                <div style="width: 35%; float: left">
                                                    Lay
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Odd
                                                </div>
                                                <div style="width: 20%; float: left">
                                                    Profit
                                                </div>
                                                <div style="width: 25%; float: left; ">
                                                    Responsibility
                                                </div>
                                            </div>
                                            <div class="lay-content" style="height: 70px;background: #ebedef; padding: 5px;">
                                                <div style="width: 35%; float: left; color: #ebedef">
                                                    .
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            :value="lay"
                                                            class="inputOdd1"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 20%; float: left;">
                                                    <CInput
                                                            :value="(back*calc_stake/lay).toFixed(2)"
                                                            class="inputOdd1"
                                                            readonly
                                                    ></CInput>
                                                </div>
                                                <div style="width: 25%; float: left; height: 30px; padding-top: 12px;" class="height60">
                                                    {{this.currency_list[this.mycurrency].currencySymbol}}{{(lay*(back*calc_stake/lay) - (back*calc_stake/lay)).toFixed(2)}}
                                                </div>
                                                <div style="font-style: italic; font-weight: 600; margin-top: 40px;">You're betting against of: {{classic_match}}</div>
                                            </div>

                                        </CCol>
                                        <CCol sm="12" style="height: 17px; text-align: right; font-weight: bold; font-size: 11px!important;">
                                            Net Profits
                                        </CCol>

                                        <CCol sm="9" col="9" style="text-align: left; height: 22px;">
                                            <p style="margin: 0;">In case of <strong>{{classic_match}}</strong> wins you'll earn:</p>
                                        </CCol>
                                        <CCol sm="3" col="3" style="text-align: right; height: 22px;">
                                            <label v-if="cash_out == true" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{guad_att}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 1 && (calc_stake - ((calc_odd*calc_stake - calc_stake)/(back - 1))) < 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{((calc_stake - ((calc_odd*calc_stake - calc_stake)/(back - 1)))).toFixed(2)}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 1 && (calc_stake - ((calc_odd*calc_stake - calc_stake)/(back - 1))) > 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{((calc_stake - ((calc_odd*calc_stake - calc_stake)/(back - 1)))*(100 - bookmarkerFee)/100).toFixed(2)}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 0 && ((calc_stake*calc_odd - calc_stake) - (lay - 1)* calc_stake) > 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((calc_stake*calc_odd - calc_stake) - (lay - 1)* calc_stake)*(100 - bookmarkerFee)/100).toFixed(2)}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 0 && ((calc_stake*calc_odd - calc_stake) - (lay - 1)* calc_stake) < 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((calc_stake*calc_odd - calc_stake) - (lay - 1)* calc_stake)).toFixed(2)}}</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 1" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}0.00</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((calc_stake*calc_odd - calc_stake) - (lay - 1)*max_profit*(lay/(lay - 1) - 1))*(100 - bookmarkerFee)/100).toFixed(2)}}</label>
                                        </CCol>
                                        <CCol sm="9" col="9" style="text-align: left; height: 22px;">
                                            <p style="margin: 0;">In case of <strong>{{classic_match}}</strong> does NOT win you'll earn:</p>
                                        </CCol>
                                        <CCol sm="3" col="3" style="text-align: right; height: 22px;">
                                            <label v-if="cash_out == true" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{guad_att}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 1" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((calc_odd*calc_stake - calc_stake)/(back - 1))*(back - 1) - calc_stake*(calc_odd - 1)).toFixed(2)}}</label>
                                            <label v-if="low_cash == true && selectedArray[6] == 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}0.00</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 1 && ((calc_stake*back - calc_stake) - (calc_stake*calc_odd - calc_stake)) > 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((calc_stake*back - calc_stake) - (calc_stake*calc_odd - calc_stake))*(100 - bookmarkerFee)/100).toFixed(2)}}</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 1 && ((calc_stake*back - calc_stake) - (calc_stake*calc_odd - calc_stake)) < 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{((calc_stake*back - calc_stake) - (calc_stake*calc_odd - calc_stake)).toFixed(2)}}</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 0 && ((max_profit*(lay/(lay - 1) - 1)) - calc_stake) > 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(((max_profit*(lay/(lay - 1) - 1)) - calc_stake)*(100 - bookmarkerFee)/100).toFixed(2)}}</label>
                                            <label v-if="high_cash == true && selectedArray[6] == 0 && ((max_profit*(lay/(lay - 1) - 1)) - calc_stake) < 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{((max_profit*(lay/(lay - 1) - 1)) - calc_stake).toFixed(2)}}</label>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CTab>
                            <CTab :title="this.$t('Alerts')">
                                <div style="height: 340px; border: 1px solid lightgrey; overflow-y: scroll;">
                                    <div style="border-bottom: 1px solid lightgrey; display: flex; height: 30px;text-align: center; font-weight: bold!important; background: lightblue;" class="height60">
                                        <div style="flex: 7; padding-top: 5px;" class="font-size9">
                                            {{ $t('Events') }}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Odd') }}
                                        </div>
                                        <div style="flex: 1; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Min') }}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Score') }}
                                        </div>
                                        <div style="flex: 3; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Strategy') }}
                                        </div>
                                        <div style="flex: 1; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('C') }}
                                        </div>
                                    </div>
                                    <div v-for="(item00, index) in alertArray" :key="index" style="border-bottom: 1px solid lightgrey; display: flex; height: 30px;text-align: center; font-weight: bold!important; background: whitesmoke;" class="height60">
                                        <div style="flex: 7; padding-top: 5px;"  class="font-size9">
                                            {{item00.name.split(">>")[1]}}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid lightgrey; padding-top: 5px;"  class="font-size9">
                                            {{item00.oddLive}}
                                        </div>
                                        <div style="flex: 1; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            {{item00.time}}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            {{item00.scoreHome}}-{{item00.scoreAway}}
                                        </div>
                                        <div style="flex: 3; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            {{item00.alertName}}
                                        </div>
                                        <div :style="{'flex': 1, 'border-left': '1px solid lightgrey', 'padding-top': '5px', 'background': item00.c_color, 'color': item00.c_color}"  class="font-size9">
                                            {{ $t('C') }}
                                        </div>
                                    </div>
                                </div>
                            </CTab>
                            <!-- New Tab for Alerts stats -->
                            <CTab :title="this.$t('Alert Stats FT')">
                                <div style="height: 340px; border: 1px solid lightgrey; overflow-y: scroll;">
                                    <div style="border-bottom: 1px solid lightgrey; display: flex; height: 30px;text-align: center; font-weight: bold!important; background: lightblue;" class="height60">
                                        <div style="flex: 4; padding-top: 5px;" class="font-size9">
                                            {{ $t('Strategy Name') }}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Stats') }}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Details') }}
                                        </div>
                                        <div style="flex: 2; border-left: 1px solid white; padding-top: 5px;" class="font-size9">
                                            {{ $t('Financial') }}
                                        </div>
                                    </div>
                                    <div v-for="(strategy, index) in strategiesList" :key="index" style="border-bottom: 1px solid lightgrey; display: flex; height: 30px; text-align: center; background: whitesmoke;" class="height60">
                                        <div style="flex: 4; padding-top: 5px;" class="font-size9">
                                            {{ $t(strategy.name) }}
                                        </div>

                                        <div style="flex: 2; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            <a
                                                :href="`${baseURL}/user-strategy-stats/${strategy.id}/0`"
                                                target="_blank"
                                                class="link-style"
                                            >
                                            {{ $t('Open') }}
                                            </a>
                                        </div>

                                        <div style="flex: 2; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            <a
                                                :href="`${baseURL}/user-strategy-stat/${strategy.id}/0`"
                                                target="_blank"
                                                class="link-style"
                                            >
                                            {{ $t('Open') }}
                                            </a>
                                        </div>

                                        <div style="flex: 2; border-left: 1px solid lightgrey; padding-top: 5px;" class="font-size9">
                                            <a
                                                :href="`${baseURL}/user-strategy-financial/${strategy.id}/0`"
                                                target="_blank"
                                                class="link-style"
                                            >
                                            {{ $t('Open') }}
                                            </a>
                                        </div>
                                    </div>


                                </div>
                            </CTab>
                        </CTabs>
                   <!--  </CCol> -->
                    
                    
                    <!-- <CCol lg="6"> -->
                        <label style="font-weight: 600; padding-top: 20px;" class="header_label">{{ $t('Equalization Bar') }} </label>
                        <div class="betfair-classic-container height220">
                            <CRow style="margin-bottom: 10px;">
                                <CCol sm="8" style="text-align: left; margin-top: 12px; margin-bottom: 32px;">
                                    <p style="margin: 0; float: left; margin-right: 10px;">Stake CASH OUT:</p>
                                    <label v-if="cash_out == true && selectedArray[6] == 0 && lay != 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(calc_stake*calc_odd/lay).toFixed(2)}}</label>
                                    <label v-if="cash_out == true && selectedArray[6] == 1 && back != 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(calc_stake*calc_odd/back).toFixed(2)}}</label>
                                    <label v-if="low_cash == true && selectedArray[6] == 1" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{((calc_odd*calc_stake - calc_stake)/(back - 1)).toFixed(2)}}</label>
                                    <label v-if="low_cash == true && selectedArray[6] == 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{calc_stake}}</label>
                                    <label v-if="high_cash == true && selectedArray[6] == 1" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{calc_stake}}</label>
                                    <label v-if="high_cash == true && selectedArray[6] == 0" style="font-weight: bold;">{{this.currency_list[this.mycurrency].currencySymbol}}{{(max_profit*(lay/(lay - 1) - 1)).toFixed(2)}}</label>
                                </CCol>
                                <CCol sm="4" style="text-align: right; margin-bottom: 0px;">
                                </CCol>
                                <div style="width: 33%; float: left; text-align: center;">
                                    <CInputRadio
                                            @update:checked="cashOut1"
                                            :checked = "false"
                                            name="cashout"
                                            class="form-check1"
                                            style = "margin-top: -15px;"
                                    >
                                    </CInputRadio>
                                    <div style="margin-top: 17px; text-align: center;font-weight: 600; margin-top: 26px;">
                                        {{classic_match}} W
                                    </div>
                                    <div style="border-bottom: 2px solid #8e8e8e; width: 50%; float: right; margin-top: -35px;" class="stake_line">
                                    </div>
                                </div>
                                <div style="width: 33%; float: left; text-align: center;">
                                    <CInputRadio
                                            @update:checked="cashOut2"
                                            :checked = "true"
                                            name="cashout"
                                            class="form-check1"
                                            style = "margin-top: -15px;"
                                    >
                                    </CInputRadio>
                                    <div style="margin-top: 17px; text-align: center;font-weight: 600; margin-top: 26px;">
                                        CASH OUT
                                    </div>
                                    <div style="border-bottom: 2px solid #8e8e8e; width: 100%; margin-top: -35px;" class="stake_line">
                                    </div>
                                </div>
                                <div style="width: 33%; float: left;  text-align: center;">
                                    <CInputRadio
                                            @update:checked="cashOut3"
                                            :checked = "false"
                                            name="cashout"
                                            class="form-check1"
                                            style = "margin-top: -15px;"
                                    >
                                    </CInputRadio>
                                    <div style="margin-top: 17px; text-align: center;font-weight: 600; margin-top: 26px;">
                                        {{classic_match}} L
                                    </div>
                                    <div style="border-bottom: 2px solid #8e8e8e; width: 50%; float: left; margin-top: -35px;" class="stake_line">
                                    </div>
                                </div>
                            </CRow>
                        </div>
                    </CCol>
                    <CCol lg="12" class="cold-stats-team-analysis" style="margin-top: 40px; min-height: 150px;">
                        <CTabs variant="tabs" :active-tab="0" class="graph_group">
                            <CTab @click.native="switch_tab()" :title="this.$t('cold stats')">
                                <div v-if="!isload1" style="height: 10px; margin-bottom: 15px;">
                                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                                </div>
                                <div
                                        v-if="item3.away.name != ''"
                                        class="event-graph overflow_x"
                                >
                                    <div class="event-graph-header">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 30px;">

                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%;">
                                            Team
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            P
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            0 - 0
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            Ov. 1.5
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            Ov. 2.5
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            Ov. 3.5
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            Scored
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            Conc.
                                        </div>
                                        <div style="min-width: 80px; float: left; width: 8%; text-align: center;">
                                            Average
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            BTS
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            1 + 1st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            2 + 1st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            1 + 2st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            2 + 2st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 14%; text-align: center;">
                                            Filters
                                        </div>
                                    </div>
                                    <div class="graph1">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 50px; text-align: center; padding-top: 15px;">
                                            H
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 50px; padding-top: 15px;">
                                            {{item3.home.name}}
                                            <img  v-b-modal.modal-center1 @click="current_modal_title = item1.home.name, replace_modal_data(item1.home_id, item1.away_id)" src="/img/info_icon.png" width="13px;" style="width: 20px; cursor: pointer; outline: none; position: relative; top: 40px; left: 12px"/>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 50px; padding-top: 15px;">
                                            {{item3.home.p}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.z_z <= 10" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.z_z+'%'}"></div>
                                                <div v-if="item3.home.z_z >= 20" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.z_z+'%'}"></div>
                                                <div v-if="item3.home.z_z > 10 && item3.home.z_z < 20" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.z_z+'%'}"></div>
                                                <label class="graph-label">{{item3.home.z_z}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.over15 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.over15 +'%'}"></div>
                                                <div v-if="item3.home.over15 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.over15 +'%'}"></div>
                                                <div v-if="item3.home.over15 < 80 && item3.home.over15 >= 60" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.over15+'%'}"></div>
                                                <label class="graph-label">{{item3.home.over15}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.over25 >= 65" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.over25+'%'}"></div>
                                                <div v-if="item3.home.over25 < 50" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.over25 +'%'}"></div>
                                                <div v-if="item3.home.over25 >= 50 && item3.home.over25 < 65" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.over25+'%'}"></div>
                                                <label class="graph-label">{{item3.home.over25}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.over35 >= 40" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.over35+'%'}"></div>
                                                <div v-if="item3.home.over35 < 25" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.over35+'%'}"></div>
                                                <div v-if="item3.home.over35 >= 25 && item3.home.over35 < 40" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.over35 +'%'}"></div>
                                                <label class="graph-label">{{item3.home.over35}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.scored >= 70" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.scored +'%'}"></div>
                                                <div v-if="item3.home.scored < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.scored +'%'}"></div>
                                                <div v-if="item3.home.scored >= 60 && item3.home.scored < 70" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.scored +'%'}"></div>
                                                <label class="graph-label">{{item3.home.scored}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.conc >= 70" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.conc +'%'}"></div>
                                                <div v-if="item3.home.conc < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.conc +'%'}"></div>
                                                <div v-if="item3.home.conc >= 60 && item3.home.conc <70" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.conc +'%'}"></div>
                                                <label class="graph-label">{{item3.home.conc}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 80px; float: left; width: 8%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :style="{'position': 'absolute', 'left': '0','width':'100%', 'width': (item3.home.average1/(parseFloat(item3.home.average1) + parseFloat(item3.home.average2))*100).toFixed(2)+'%'}"></div>
                                                <div class="graph-inner" :style="{'position': 'absolute', 'right': '-1px','width':'0%','width': (item3.home.average2/(parseFloat(item3.home.average1) + parseFloat(item3.home.average2))*100).toFixed(2)+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{item3.home.average1}}</label>
                                                <label class="graph-label1">{{item3.home.average2}}</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.bts >= 65" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.bts+'%'}"></div>
                                                <div v-if="item3.home.bts < 45" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.bts+'%'}"></div>
                                                <div v-if="item3.home.bts >= 45 && item3.home.bts < 65" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.bts +'%'}"></div>
                                                <label class="graph-label">{{item3.home.bts}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.first1 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.first1+'%'}"></div>
                                                <div v-if="item3.home.first1 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.first1+'%'}"></div>
                                                <div v-if="item3.home.first1 >= 60 && item3.home.first1 < 80" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.first1+'%'}"></div>
                                                <label class="graph-label">{{item3.home.first1}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.first2 >= 50" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.first2+'%'}"></div>
                                                <div v-if="item3.home.first2 < 40" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.first2+'%'}"></div>
                                                <div v-if="item3.home.first2 >= 40 && item3.home.first2 <50" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.first2+'%'}"></div>
                                                <label class="graph-label">{{item3.home.first2}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.second1 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.second1+'%'}"></div>
                                                <div v-if="item3.home.second1 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.second1+'%'}"></div>
                                                <div v-if="item3.home.second1 >= 60 && item3.home.second1 < 80" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.second1+'%'}"></div>
                                                <label class="graph-label">{{item3.home.second1}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.home.second2 >= 50" class="graph-inner" :style="{'background':'#00CC00','height': item3.home.second2+'%'}"></div>
                                                <div v-if="item3.home.second2 < 40" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.home.second2+'%'}"></div>
                                                <div v-if="item3.home.second2 >= 40 && item3.home.second2 < 50" class="graph-inner" :style="{'background':'#CDCF46','height': item3.home.second2+'%'}"></div>
                                                <label class="graph-label">{{item3.home.second2}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 150px; float: left; width: 17%;">
                                            <div style="width: 100%; height: 30px;">
                                                <label style="float: left; margin-left: 10px; ">Red Card</label>

                                                <div style="width: 25%; float: right;">
                                                    <CInputCheckbox class="check-box"
                                                                    :checked="false"
                                                                    @update:checked="SH_red"
                                                                    @click="item_X = item3, home_date_list = item3.homeDateList, away_date_list = item3.awayDateList, basic_data = item3.b_data"
                                                    >
                                                        <template #label>
                                                            SH
                                                        </template>
                                                    </CInputCheckbox>
                                                </div>

                                                <div style="width: 25%; float: right;">
                                                    <CInputCheckbox class="check-box"
                                                                    :checked="false"
                                                                    @update:checked="FH_red"
                                                                    @click="item_X = item3, home_date_list = item3.homeDateList, away_date_list = item3.awayDateList, basic_data = item3.b_data"
                                                    >
                                                        <template #label>
                                                            FH
                                                        </template>
                                                    </CInputCheckbox>
                                                </div>
                                            </div>
                                            <div>
                                                <label style="float: left; margin-left: 10px; margin-top: 0px;">Show last</label>
                                                <CSelect
                                                        v-if="item3.homeDateList.length <= item3.awayDateList.length"
                                                        class="eventdays date-range"
                                                        :options="item3.homeDateList"
                                                        @click="item_X = item3, home_date_list = item3.homeDateList, away_date_list = item3.awayDateList, basic_data = item3.b_data"
                                                        @update:value="refreshCalc"
                                                >
                                                </CSelect>

                                                <CSelect
                                                        v-if="item3.homeDateList.length > item3.awayDateList.length"
                                                        class="eventdays date-range"
                                                        @click="item_X = item3"
                                                        :options="item3.awayDateList"
                                                        @update:value="refreshCalc"
                                                >
                                                </CSelect>
                                                <label style="margin-top: 0px;">days</label>
                                            </div>
                                            <div v-if="item3.homeLineupList.length > 1" style="height: 25px; margin-top: 3px; margin-bottom: 5px;">
                                                <label style="float: left; margin-left: 10px;">Home Lineup:</label>
                                                <CSelect
                                                        class="eventdays date-range lineup"
                                                        :options="item3.homeLineupList"
                                                        @click="item_X = item3, lineup_home_id = item3.home_id, away_team = item3.away, lineup_away_id = item3.away_id"
                                                        @update:value="home_lineup_refresh"
                                                >
                                                </CSelect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="graph1" style="padding-top: 0;">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 50px; text-align: center; padding-top: 15px;">
                                            A
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 50px; padding-top: 15px;">
                                            {{item3.away.name}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 50px; padding-top: 15px;">
                                            {{item3.away.p}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.z_z <= 10" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.z_z+'%'}"></div>
                                                <div v-if="item3.away.z_z >= 20" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.z_z+'%'}"></div>
                                                <div v-if="item3.away.z_z < 20 && item3.away.z_z > 10" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.z_z+'%'}"></div>
                                                <label class="graph-label">{{item3.away.z_z}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.over15 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.over15+'%'}"></div>
                                                <div v-if="item3.away.over15 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.over15+'%'}"></div>
                                                <div v-if="item3.away.over15 < 80 && item3.away.over15 >= 60" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.over15+'%'}"></div>
                                                <label class="graph-label">{{item3.away.over15}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.over25 >= 65" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.over25+'%'}"></div>
                                                <div v-if="item3.away.over25 < 50" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.over25+'%'}"></div>
                                                <div v-if="item3.away.over25 >= 50 && item3.away.over25 < 65" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.over25+'%'}"></div>
                                                <label class="graph-label">{{item3.away.over25}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.over35 >= 40" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.over35+'%'}"></div>
                                                <div v-if="item3.away.over35 < 25" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.over35+'%'}"></div>
                                                <div v-if="item3.away.over35 >= 25 && item3.away.over35 < 40" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.over35+'%'}"></div>
                                                <label class="graph-label">{{item3.away.over35}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.scored >= 70" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.scored+'%'}"></div>
                                                <div v-if="item3.away.scored < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.scored+'%'}"></div>
                                                <div v-if="item3.away.scored >= 60 && item3.away.scored < 70" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.scored+'%'}"></div>
                                                <label class="graph-label">{{item3.away.scored}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.conc >= 70" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.conc+'%'}"></div>
                                                <div v-if="item3.away.conc < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.conc+'%'}"></div>
                                                <div v-if="item3.away.conc >= 60 && item3.away.conc < 70" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.conc+'%'}"></div>
                                                <label class="graph-label">{{item3.away.conc}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 80px; float: left; width: 8%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :style="{'position': 'absolute', 'left': '0','width':'100%','width': (item3.away.average1/(parseFloat(item3.away.average1) + parseFloat(item3.away.average2))*100).toFixed(2)+'%', 'background': '#00cc00'}"></div>
                                                <div class="graph-inner" :style="{'position': 'absolute', 'right': '-1px','width':'0%','width': (item3.away.average2/(parseFloat(item3.away.average1) + parseFloat(item3.away.average2))*100).toFixed(2)+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{item3.away.average1}}</label>
                                                <label class="graph-label1">{{item3.away.average2}}</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.bts >= 65" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.bts+'%'}"></div>
                                                <div v-if="item3.away.bts < 45" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.bts+'%'}"></div>
                                                <div v-if="item3.away.bts >= 45 && item3.away.bts < 65" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.bts+'%'}"></div>
                                                <label class="graph-label">{{item3.away.bts}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.first1 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.first1+'%'}"></div>
                                                <div v-if="item3.away.first1 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.first1+'%'}"></div>
                                                <div v-if="item3.away.first1 >= 60 && item3.away.first1 < 80" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.first1+'%'}"></div>
                                                <label class="graph-label">{{item3.away.first1}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.first2 >= 50" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.first2+'%'}"></div>
                                                <div v-if="item3.away.first2 < 40" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.first2+'%'}"></div>
                                                <div v-if="item3.away.first2 >= 40 && item3.away.first2 < 50" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.first2+'%'}"></div>
                                                <label class="graph-label">{{item3.away.first2}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.second1 >= 80" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.second1+'%'}"></div>
                                                <div v-if="item3.away.second1 < 60" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.second1+'%'}"></div>
                                                <div v-if="item3.away.second1 >= 60 && item3.away.second1 < 80" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.second1+'%'}"></div>
                                                <label class="graph-label">{{item3.away.second1}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            <div class="graph-detail">
                                                <div v-if="item3.away.second2 >= 50" class="graph-inner" :style="{'background':'#00CC00','height': item3.away.second2+'%'}"></div>
                                                <div v-if="item3.away.second2 < 40" class="graph-inner" :style="{'background':'#FE9F9F','height': item3.away.second2+'%'}"></div>
                                                <div v-if="item3.away.second2 >= 40 && item3.away.second2 < 50" class="graph-inner" :style="{'background':'#CDCF46','height': item3.away.second2+'%'}"></div>
                                                <label class="graph-label">{{item3.away.second2}}%</label>
                                            </div>
                                        </div>

                                        <div style="min-width: 150px; float: left; width: 17%; margin-top: -5px;">
                                            <div v-if="item3.awayLineupList.length > 1" style="height: 25px; margin-top: 3px;">
                                                <label style="float: left; margin-left: 15px; margin-bottom: 0;">Away Lineup:</label>
                                                <CSelect
                                                        class="eventdays date-range lineup"
                                                        :options="item3.awayLineupList"
                                                        @click="item_X = item3, lineup_home_id = item3.home_id, home_team = item3.home, lineup_away_id = item3.away_id"
                                                        @update:value="away_lineup_refresh"
                                                >
                                                </CSelect>
                                            </div>
                                            <div v-if="item3.rankFilter === true" style="width: 100%; height: 30px; margin-top: 5px;">
                                                <label style="float: left; margin-left: 10px; ">HomeTeam:</label>
                                                <div style="width: 50%; float: right;">
                                                    <CSelect
                                                            class="rank_filter"
                                                            :options="item3.rank_option"
                                                            @click = "rank_filter = item3.rank_set, item_X = item3, away_team = item3.away, home_team = item3.home"
                                                            @update:value="home_rank_filter"
                                                    >
                                                    </CSelect>
                                                </div>
                                            </div>
                                            <div v-if="item3.rankFilter === true" style="width: 100%; height: 30px; margin-top: -2px;">
                                                <label style="float: left; margin-left: 10px; ">AwayTeam:</label>
                                                <div style="width: 50%; float: right;">
                                                    <CSelect
                                                            class="rank_filter"
                                                            :options="item3.rank_option"
                                                            @click = "rank_filter = item3.rank_set, item_X = item3, away_team = item3.away, home_team = item3.home"
                                                            @update:value="away_rank_filter"
                                                    >
                                                    </CSelect>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="clear: left;">
                                        <div style="width: 175px; float: left;"><label style="font-weight: 600; margin-right: 10px;">FH goals Scored:</label> home: {{item3.home.fh_percentage}}%</div>
                                        <div style="width: 70px; float: left;">away: {{item3.away.fh_percentage}}%</div>
                                        <div style="width: 100px; float: left;">probability: {{item3.home.fh_probability}}%</div>
                                        <div style="width: 175px; float: left;"><label style="font-weight: 600; margin-right: 10px;">SH goals Scored:</label> home: {{item3.home.sh_percentage}}%</div>
                                        <div style="width: 70px; float: left;">away: {{item3.away.sh_percentage}}%</div>
                                        <div style="width: 100px; float: left;">probability: {{item3.home.sh_probability}}%</div>
                                    </div>


                                    <div class="event-graph-header" style="clear: left;">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 30px;">

                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%;">
                                            Team
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            P
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 7%; text-align: center; padding: 0px 10px;">
                                            <span style="float: left;">G+</span><span style="float: right;">G-</span>
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            0 - 15
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            16 - 30
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            31 - 45
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 7%; text-align: center;">
                                            46 - 60
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 7%; text-align: center;">
                                            61 - 75
                                        </div>
                                        <div title="sdfsdfsdf" style="min-width: 60px; float: left; width: 7%; text-align: center;">
                                            76 - 90
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 9%; text-align: center; padding: 0px 10px;">
                                            <span style="float: left;">GS1</span><span style="float: right;">GS2</span>
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 9%; text-align: center; padding: 0px 10px;">
                                            <span style="float: left;">GC1</span><span style="float: right;">GC2</span>
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%; text-align: center;">
                                            40+
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%; text-align: center;">
                                            85+
                                        </div>
                                    </div>
                                    <div class="graph1">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 50px; text-align: center; padding-top: 15px;">
                                            H
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 50px; padding-top: 15px;">
                                            {{item3.home.name}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 50px; padding-top: 15px;">
                                            {{item3.home.p}}
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 7%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :style="{'position': 'absolute', 'left': '0','width': (item3.home.average1/(parseFloat(item3.home.average1) + parseFloat(item3.home.average2))*100).toFixed(2)+'%', 'background': '#00cc00'}"></div>
                                                <div class="graph-inner" :style="{'position': 'absolute', 'right': '-1px','width': (item3.home.average2/(parseFloat(item3.home.average1) + parseFloat(item3.home.average2))*100).toFixed(2)+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{(parseFloat(item3.home.average1)*parseFloat(item3.home.p)).toFixed(0)}}</label>
                                                <label class="graph-label1">{{(parseFloat(item3.home.average2)*parseFloat(item3.home.p)).toFixed(0)}}</label>
                                            </div>
                                        </div>
                                        <!--                                    <div style="min-width:450px ;width: 42%;">-->
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time15_S" :style="{'height': item3.home.time15_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time15_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time15_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label" style="left: 0;">{{item3.home.time15_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time15_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time30_S" :style="{'height': item3.home.time30_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time30_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time30_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.home.time30_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time30_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time45_S" :style="{'height': item3.home.time45_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time45_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time45_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.home.time45_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time45_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time60_S" :style="{'height': item3.home.time60_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time60_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time60_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.home.time60_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time60_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time75_S" :style="{'height': item3.home.time75_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time75_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time75_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.home.time75_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time75_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.home.time90_S" :style="{'height': item3.home.time90_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.home.time90_C" :style="{'position': 'absolute', 'right': '5px','height': item3.home.time90_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.home.time90_S}}%</label>
                                                <label class="graph-label1">{{item3.home.time90_C}}%</label>
                                            </div>
                                        </div>
                                        <!--                                    </div>-->


                                        <div style="min-width: 90px; float: left; width: 9%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :title="item3.home.gs1" :style="{'position': 'absolute', 'left': '0','width': item3.home.gs1+'%', 'background': '#00cc00'}"></div>
                                                <div class="graph-inner" :title="item3.home.gs2" :style="{'position': 'absolute', 'right': '-1px','width': (100 - parseInt(item3.home.gs1))+'%', 'background': '#00c900'}"></div>
                                                <label class="graph-label">{{item3.home.gs1}}%</label>
                                                <label class="graph-label1">{{100 - parseInt(item3.home.gs1)}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 9%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :title="item3.home.gc1" :style="{'position': 'absolute', 'left': '0','width': item3.home.gc1+'%', 'background': '#fe9f9f'}"></div>
                                                <div class="graph-inner" :title="item3.home.gc2" :style="{'position': 'absolute', 'right': '-1px','width': 100 - parseInt(item3.home.gc1)+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{item3.home.gc1}}%</label>
                                                <label class="graph-label1">{{100 - parseInt(item3.home.gc1)}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%;">
                                            <div class="graph-detail">
                                                <div class="graph-inner" :title="item3.home.over40" :style="{'height': item3.home.over40+'%', 'background': '#655'}"></div>
                                                <label class="graph-label">{{item3.home.over40}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%;">
                                            <div class="graph-detail">
                                                <div class="graph-inner" :title="item3.home.over85" :style="{'height': item3.home.over85+'%', 'background': '#655'}"></div>
                                                <label class="graph-label">{{item3.home.over85}}%</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="graph1">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 50px; text-align: center; padding-top: 15px;">
                                            A
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 50px; padding-top: 15px;">
                                            {{item3.away.name}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 50px; padding-top: 15px;">
                                            {{item3.away.p}}
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 7%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :style="{'position': 'absolute', 'left': '0','width': item3.away.average1/(parseFloat(item3.away.average1) + parseFloat(item3.away.average2))*100+'%', 'background': '#00cc00'}"></div>
                                                <div class="graph-inner" :style="{'position': 'absolute', 'right': '-1px','width': item3.away.average2/(parseFloat(item3.away.average1) + parseFloat(item3.away.average2))*100+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{(parseFloat(item3.away.average1)*item3.away.p).toFixed(0)}}</label>
                                                <label class="graph-label1">{{(parseFloat(item3.away.average2)*item3.away.p).toFixed(0)}}</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time15_S" :style="{'height': item3.away.time15_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time15_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time15_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label" style="left: 0;">{{item3.away.time15_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time15_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time30_S" :style="{'height': item3.away.time30_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time30_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time30_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.away.time30_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time30_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time45_S" :style="{'height': item3.away.time45_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time45_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time45_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.away.time45_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time45_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time60_S" :style="{'height': item3.away.time60_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time60_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time60_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.away.time60_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time60_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time75_S" :style="{'height': item3.away.time75_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time75_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time75_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.away.time75_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time75_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 75px; float: left; width: 7%;">
                                            <div class="graph-detail1" style="width: 75px; border: 1px solid lightgrey;">
                                                <div class="graph-inner" :title="item3.away.time90_S" :style="{'height': item3.away.time90_S+'%', 'background': '#00cc00','width': '25px'}"></div>
                                                <div class="graph-inner" :title="item3.away.time90_C" :style="{'position': 'absolute', 'right': '5px','height': item3.away.time90_C+'%', 'background': '#fe9f9f','width': '25px'}"></div>
                                                <label class="graph-label">{{item3.away.time90_S}}%</label>
                                                <label class="graph-label1">{{item3.away.time90_C}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 9%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :title="item3.away.gs1" :style="{'position': 'absolute', 'left': '0','width': item3.away.gs1+'%', 'background': '#00cc00'}"></div>
                                                <div class="graph-inner" :title="item3.away.gs2" :style="{'position': 'absolute', 'right': '-1px','width': item3.away.gs2+'%', 'background': '#00cc00'}"></div>
                                                <label class="graph-label">{{item3.away.gs1}}%</label>
                                                <label class="graph-label1">{{item3.away.gs2}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 90px; float: left; width: 9%;">
                                            <div class="graph-detail1">
                                                <div class="graph-inner" :title="item3.away.gc1" :style="{'position': 'absolute', 'left': '0','width': item3.away.gc1+'%', 'background': '#fe9f9f'}"></div>
                                                <div class="graph-inner" :title="item3.away.gc2" :style="{'position': 'absolute', 'right': '-1px','width': item3.away.gc2+'%', 'background': '#fe9f9f'}"></div>
                                                <label class="graph-label">{{item3.away.gc1}}%</label>
                                                <label class="graph-label1">{{item3.away.gc2}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%;">
                                            <div class="graph-detail">
                                                <div class="graph-inner" :title="item3.away.over40" :style="{'height': item3.away.over40+'%', 'background': '#655'}"></div>
                                                <label class="graph-label">{{item3.away.over40}}%</label>
                                            </div>
                                        </div>
                                        <div style="min-width: 60px; float: left; width: 6%;">
                                            <div class="graph-detail">
                                                <div class="graph-inner" :title="item3.away.over85" :style="{'height': item3.away.over85+'%', 'background': '#655'}"></div>
                                                <label class="graph-label">{{item3.away.over85}}%</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="event-graph-header">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 30px;">

                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%;">
                                            Team
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%;">
                                            P
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center; position: relative; border-left: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            H
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            D
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            A
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            1-0
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            1-1
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            2-0
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            0-1
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            1-1
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            0-2
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            First
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            Last
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center;">
                                            2+
                                        </div>
                                        <div style="min-width: 40px; float: left; width: 4%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            2-
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            H 1st
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            D 1st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            A 1st
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 4.5%; text-align: center;">
                                            H 2nd
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            D 2nd
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            A 2nd
                                        </div>

                                    </div>
                                    <div class="graph1 graph-percent">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 31px; text-align: center;">
                                            H
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 31px;">
                                            {{item3.home.name}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 31px;">
                                            {{item3.home.p}}
                                        </div>
                                        <div class="graph-detail00" style="border-left: 1px solid lightgray;">
                                            {{item3.home.C_H}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.C_D}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.home.C_A}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.first10}}
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.first11}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.home.first20}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.second01}}
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.second11}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.home.second02}}%
                                        </div>
                                        <div v-if="item3.home.p != 0" class="graph-detail00">
                                            {{(item3.home.first10/item3.home.p*100).toFixed(0)}}%
                                        </div>
                                        <div v-if="item3.home.p == 0" class="graph-detail00">
                                            0%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.lastGoal}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.home.secondplus}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.home.secondminus}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            {{item3.home.homefirst}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.home.drawfirst}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            {{item3.home.awayfirst}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.home.homesecond}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.home.drawsecond}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.home.awaysecond}}%
                                        </div>
                                    </div>
                                    <div class="graph1 graph-percent" style="margin-top: -10px;">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 31px; text-align: center;">
                                            A
                                        </div>
                                        <div style="min-width: 100px; float: left; width: 10%; height: 31px;">
                                            {{item3.away.name}}
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; height: 31px;">
                                            {{item3.away.p}}
                                        </div>
                                        <div class="graph-detail00" style="border-left: 1px solid lightgray;">
                                            {{item3.away.C_H}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.C_D}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.away.C_A}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.first10}}
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.first11}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.away.first20}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.second01}}
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.second11}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.away.second02}}%
                                        </div>
                                        <div v-if="item3.away.p != 0" class="graph-detail00">
                                            {{(item3.away.second01/item3.away.p*100).toFixed(0)}}%
                                        </div>
                                        <div v-if="item3.away.p == 0" class="graph-detail00">
                                            0%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.lastGoal}}%
                                        </div>
                                        <div class="graph-detail00">
                                            {{item3.away.secondplus}}%
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;">
                                            {{item3.away.secondminus}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center;">
                                            {{item3.away.homefirst}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.away.drawfirst}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 5%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            {{item3.away.awayfirst}}%
                                        </div>
                                        <div style="min-width: 50px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.away.homesecond}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.away.drawsecond}}%
                                        </div>
                                        <div style="min-width: 45px; float: left; width: 4.5%; text-align: center;">
                                            {{item3.away.awaysecond}}%
                                        </div>
                                    </div>
                                    <div class="graph1 graph-percent0" style="margin-top: -10px;">
                                        <div style="min-width: 190px; float: left; width: 20%; height: 70px; text-align: right; padding-right: 45px;">
                                            Total
                                        </div>
                                        <div v-if="(item3.away.p + item3.home.p) == 0" class="graph-detail00" style="border-left: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b', 'height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="border-left: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b', 'height': ((item3.away.C_H*item3.away.p + item3.home.C_H*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.C_H*item3.away.p + item3.home.C_H*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.away.p + item3.home.p) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.C_D*item3.away.p + item3.home.C_D*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.C_D*item3.away.p + item3.home.C_D*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.away.p + item3.home.p) == 0" class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.C_A*item3.away.p + item3.home.C_A*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.C_A*item3.away.p + item3.home.C_A*item3.home.p)/(item3.away.p + item3.home.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.away.p + item3.home.p) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.first10/item3.away.p + item3.home.first10/item3.home.p)*50).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.first10*100 + item3.home.first10*100)/(item3.away.p + item3.home.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.first10 + item3.away.first10) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height':'0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.first11*item3.away.first10 + item3.home.first11*item3.home.first10)/(item3.home.first10 + item3.away.first10)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.first11*item3.away.first10 + item3.home.first11*item3.home.first10)/(item3.home.first10 + item3.away.first10)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.first10 + item3.away.first10) == 0" class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.first20*item3.away.first10 + item3.home.first20*item3.home.first10)/(item3.home.first10 + item3.away.first10)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.first20*item3.away.first10 + item3.home.first20*item3.home.first10)/(item3.home.first10 + item3.away.first10)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.away.p + item3.home.p) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.second01*100 + item3.home.second01*100)/(item3.away.p + item3.home.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.second01*100 + item3.home.second01*100)/(item3.away.p + item3.home.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.second01 + item3.away.second01) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.second11*item3.away.second01 + item3.home.second11*item3.home.second01)/(item3.home.second01 + item3.away.second01)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.second11*item3.away.second01 + item3.home.second11*item3.home.second01)/(item3.home.second01 + item3.away.second01)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.second01 + item3.away.second01) == 0" class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.second02*item3.away.second01 + item3.home.second02*item3.home.second01)/(item3.home.second01 + item3.away.second01)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.second02*item3.away.second01 + item3.home.second02*item3.home.second01)/(item3.home.second01 + item3.away.second01)).toFixed(0)}}%</label>
                                        </div>

                                        <div class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px; border: none;">

                                            </div>
                                            <label class="graph-label" style="left: 13px"></label>
                                        </div>
                                        <div class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px; border: none;">

                                            </div>
                                            <label class="graph-label" style="left: 13px"></label>
                                        </div>
                                        <div v-if="(item3.home.p + item3.away.p) == 0" class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.secondplus*item3.away.p + item3.home.secondplus*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.secondplus*item3.away.p + item3.home.secondplus*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">0%</label>
                                        </div>
                                        <div v-else class="graph-detail00" style="border-right: 1px solid lightgray; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.secondminus*item3.away.p + item3.home.secondminus*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 13px">{{((item3.away.secondminus*item3.away.p + item3.home.secondminus*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="min-width: 50px; float: left; width: 5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px; position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="min-width: 50px; float: left; width: 5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.homefirst*item3.away.p + item3.home.homefirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px; position: relative; top: -10px;">{{((item3.away.homefirst*item3.away.p + item3.home.homefirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.drawfirst*item3.away.p + item3.home.drawfirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">{{((item3.away.drawfirst*item3.away.p + item3.home.drawfirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="height: 70px; min-width: 50px; float: left; width: 5%; text-align: center; position: relative; border-right: 1px solid lightgray; top: -9px; padding-top: 9px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="height: 70px; min-width: 50px; float: left; width: 5%; text-align: center; position: relative; border-right: 1px solid lightgray; top: -9px; padding-top: 9px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.awayfirst*item3.away.p + item3.home.awayfirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">{{((item3.away.awayfirst*item3.away.p + item3.home.awayfirst*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="min-width: 50px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="min-width: 50px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.homesecond*item3.away.p + item3.home.homesecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">{{((item3.away.homesecond*item3.away.p + item3.home.homesecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.drawsecond*item3.away.p + item3.home.drawsecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">{{((item3.away.drawsecond*item3.away.p + item3.home.drawsecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>

                                        <div v-if="(item3.home.p + item3.away.p) == 0" style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': '0%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">0%</label>
                                        </div>
                                        <div v-else style="min-width: 45px; float: left; width: 4.5%; text-align: center; height: 70px;">
                                            <div class="graph-detail" style="top: -10px;">
                                                <div class="graph-inner" :style="{'background':'#01235b','height': ((item3.away.awaysecond*item3.away.p + item3.home.awaysecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(2)+'%'}"></div>
                                            </div>
                                            <label class="graph-label" style="left: 0px;  position: relative; top: -10px;">{{((item3.away.awaysecond*item3.away.p + item3.home.awaysecond*item3.home.p)/(item3.home.p + item3.away.p)).toFixed(0)}}%</label>
                                        </div>
                                    </div>
                                    <div class="event-graph-header">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 30px;">

                                        </div>
                                        <div style="min-width: 150px; float: left; width: 15%;">
                                            Team
                                        </div>

                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center; position: relative; border-left: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            Pos
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            H/A
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            Swing
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            FH
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            Swing
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            SH
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            Swing
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center;">
                                            Attack
                                        </div>
                                        <div style="min-width: 70px; float: left; width: 7%; text-align: center; position: relative; border-right: 1px solid lightgray; height: 40px; top: -9px; padding-top: 9px;">
                                            Defense
                                        </div>
                                        <div style="min-width: 80px; float: left; width: 8%; text-align: center;">
                                            Form
                                        </div>
                                        <div style="min-width: 80px; float: left; width: 8%; text-align: center; position: relative; height: 40px; top: -9px; padding-top: 9px;">
                                            H/A Form
                                        </div>
                                    </div>
                                    <div class="graph1 graph-percent">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 31px; text-align: center;">
                                            H
                                        </div>
                                        <div style="min-width: 150px; float: left; width: 15%; height: 31px;">
                                            {{item3.home.name}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; border-left: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.home.pos}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; min-width: 70px; width: 7%;">
                                            {{item3.home.h_a}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.home.swing1}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; min-width: 70px; width: 7%;">
                                            {{item3.home.FH}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; border-right: 1px solid lightgray;min-width: 70px; width: 7%;">
                                            {{item3.home.swing2}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; min-width: 70px; width: 7%;">
                                            {{item3.home.SH}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.home.swing3}}
                                        </div>
                                        <div class="height: 50px; graph-detail00" style="min-width: 70px; width: 7%;">
                                            {{item3.home.attack}}
                                        </div>
                                        <div class="graph-detail00" style="height: 50px; border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.home.defense}}
                                        </div>
                                        <div style="height: 50px; min-width: 80px; float: left; text-align: center; width: 8%;">
                                            {{item3.home.form}}
                                        </div>
                                        <div style="height: 50px; min-width: 80px; float: left; text-align: center; width: 8%;">
                                            {{item3.home.form_H_A}}
                                        </div>
                                    </div>
                                    <div class="graph1 graph-percent">
                                        <div style="min-width: 40px; float: left; width: 5%; height: 31px; text-align: center;">
                                            A
                                        </div>
                                        <div style="min-width: 150px; float: left; width: 15%; height: 31px;">
                                            {{item3.away.name}}
                                        </div>
                                        <div class="graph-detail00" style="border-left: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.away.pos}}
                                        </div>
                                        <div class="graph-detail00" style="min-width: 70px; width: 7%;">
                                            {{item3.away.h_a}}
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.away.swing1}}
                                        </div>
                                        <div class="graph-detail00" style="min-width: 70px; width: 7%;">
                                            {{item3.away.FH}}
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray;min-width: 70px; width: 7%;">
                                            {{item3.away.swing2}}
                                        </div>
                                        <div class="graph-detail00" style="min-width: 70px; width: 7%;">
                                            {{item3.away.SH}}
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.away.swing3}}
                                        </div>
                                        <div class="graph-detail00" style="min-width: 70px; width: 7%;">
                                            {{item3.away.attack}}
                                        </div>
                                        <div class="graph-detail00" style="border-right: 1px solid lightgray; min-width: 70px; width: 7%;">
                                            {{item3.away.defense}}
                                        </div>
                                        <div style="min-width: 80px; float: left; text-align: center; width: 8%;">
                                            {{item3.away.form}}
                                        </div>
                                        <div style="min-width: 80px; float: left; text-align: center; width: 8%;">
                                            {{item3.away.form_H_A}}
                                        </div>
                                    </div>
                                </div>
                                <div v-else style="color: red; text-align: center; font-weight: 600; width: 50%; float: left; margin-top: 20px;">
                                    {{ $t('CLICK HERE TO LOAD COLD STATS') }}
                                </div>
                            </CTab>
                            <CTab  @click.native="switch_tab()" :title="this.$t('team analysis')">
                                <div v-if="!isload1" style="height: 10px; margin-bottom: 15px;">
                                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                                </div>
                                <div v-if="item1.homeTeam" style="display: flex; height: 800px;">
                                    <div style="flex: 1; padding: 5px; padding-bottom: 0">
                                        <div style="display: flex; height: 50px; padding-top: 14px;">
                                            <div style="flex: 5; padding-left: 20px;"><label style="color: red; margin-right: 5px;">Home Team: </label>{{item1.homeTeamName}}</div>
                                            <div v-if="item1.homeTeamFormation != null" style="flex: 3; text-align: center">
                                                <label v-if="item1.home_fmt_ans">Used: {{(item1.home_fmt_ans.used/item1.home_fmt_ans.counts*100).toFixed(2)}}%</label>
                                                <label v-else>Used: #</label>
                                            </div>
                                            <div v-else style="flex: 3; text-align: center; color: white;">
                                                .
                                            </div>

                                            <div v-if="item1.homeTeamFormation != null" style="flex: 4">
                                                <label style = "margin-right: 10px;">LineUp: {{item1.homeTeamFormation}}</label>
                                            </div>
                                            <div v-else style="flex: 4">
                                                <label style = "margin-right: 10px; color: white;">.</label>
                                            </div>

                                            <div v-if="item1.homeTeamFormation != null" style="flex: 4">
                                                <label style="margin-left: 3%; float: left;">Manual: </label>
                                                <CSelect
                                                        @click = "selected_team = item1.homeTeamName, selected_direction = 'home'"
                                                        class="lineup-selector"
                                                        :options="lineup_list"
                                                        @update:value="select_lineup1"
                                                >
                                                </CSelect>
                                            </div>
                                            <div v-else style="flex: 4">
                                                <label style="margin-left: 3%; float: left;">.</label>
                                            </div>
                                        </div>
                                        <div v-if="item1.homeTeamFormation != null" style="clear: left;  display: flex; text-align: center; background: #d8e4bc; border-bottom: 1px solid white; height: 20px; color: black;">
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                S.Role
                                            </div>
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                M.R
                                            </div>
                                            <div style="width: 18%; float: left; border-right: 1px solid white;">
                                                Line Up Home
                                            </div>
                                            <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                Sub
                                            </div>
                                            <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                Market Value
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                P.M.Role
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Primary_Role
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Alt.Role1
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Alt.Role2
                                            </div>
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                Rate
                                            </div>
                                            <div style="width: 13%;">
                                                Titularity %
                                            </div>
                                        </div>
                                        <div v-else style="clear: left;">LineUp info is not available yet.</div>
                                        <div v-if="item1.homeTeamFormation != null" v-for="(item2, index2) in item1.homeTeam" :key="item2.index">
                                            <div v-if="index2 % 2 == 0" style="display: flex; text-align: center; background: #bcdebc">
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.sRole}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.mR}}
                                                </div>
                                                <div v-if="item2.sub_order_color == 'rgb(216, 228, 188)'" :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': '#bcdebc'}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div v-else :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': item2.sub_order_color}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                    {{item2.sub_minute}}
                                                </div>
                                                <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                    {{item2.marketValue}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.p_m_Role}}
                                                </div>
                                                <div :style="{'width': '10%', 'float': 'left', 'border-right': '1px solid white', 'background': item2.rule_color}">
                                                    {{item2.primaryRole}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole1}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole2}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.rating}}
                                                </div>
                                                <div style="width: 13%;">
                                                    {{item2.Tit}}
                                                </div>
                                            </div>
                                            <div v-if="index2 % 2 == 1" style="display: flex; text-align: center; background: #d8e4bc">
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.sRole}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.mR}}
                                                </div>
                                                <div :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': item2.sub_order_color}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                    {{item2.sub_minute}}
                                                </div>
                                                <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                    {{item2.marketValue}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.p_m_Role}}
                                                </div>
                                                <div :style="{'width': '10%', 'float': 'left', 'border-right': '1px solid white', 'background': item2.rule_color}">
                                                    {{item2.primaryRole}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole1}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole2}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.rating}}
                                                </div>
                                                <div style="width: 13%;">
                                                    {{item2.Tit}}
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item1.homeTeamFormation != null" style="width: 100%; min-height: 100px;border: 1px solid lightgray;padding: 10px; margin-top: 10px;">
                                            <div style="width: 15%; float: left; height: 62px; text-align: right;">
                                                Subst.legend:
                                            </div>
                                            <div v-if="item1.home_legend" style="width: 25%; float: left; text-align: center; margin-bottom: 10px;">
                                                <div v-for="item4  in item1.home_legend" :key="item4.index" style="display: flex; width: 80%; margin: auto;">
                                                    <div :style="{'flex': '1', 'height': '20px', 'background': item4.color}">{{item4.label}}</div>
                                                </div>
                                            </div>
                                            <div style="width: 17%; float: left; height: 62px; padding-left: 20px;">
                                                Role legend:
                                            </div>
                                            <div v-if="item1.home_rule_set" style="width: 43%; float: left; height: 62px;">
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: #92d050; text-align: center;">{{item1.home_rule_set.green_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player in Role</div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: whitesmoke; text-align: center;">{{item1.home_rule_set.yellow_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player in alternative Role</div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: #ff0000; text-align: center;">{{item1.home_rule_set.red_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player out of role</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="display: flex; margin-top: 10px; padding: 10px; border: 1px solid lightgray; margin-bottom: 10px;" class="anaylysis_div">
                                            <div v-if="item1.home_fmt_ans" class="lineup-ans" style="flex:1 ;text-align: center; border-right: 1px solid lightgray">
                                                <label style="font-weight: 600; color: blue;">System of play used in home team:</label>
                                                <div v-for="(item0, index0) in item1.home_fmt_ans.ans" :key="index0 + 100">
                                                    <div style="display: flex; display: flex; text-align: center;">
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.label}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.count}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{(item0.count/(item1.home_fmt_ans.counts + 0.00001)*100).toFixed(2)}}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item1.home_b_fmt_ans" class="lineup-ans" style="flex: 1; text-align: center;">
                                                <label style="font-weight: 600; color: blue;">System of play used in the season:</label>
                                                <div v-for="(item0, index0) in item1.home_b_fmt_ans.ans" :key="index0 + 100">
                                                    <div style="display: flex; display: flex; text-align: center;">
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.label}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.count}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{(item0.count/(item1.home_b_fmt_ans.counts + 0.00001)*100).toFixed(2)}}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="flex: 1; padding: 5px; padding-bottom: 0">
                                        <div style="display: flex; height: 50px; padding-top: 14px;">
                                            <div style="flex: 5; padding-left: 20px;"><label style="color: red; margin-right: 5px;">Away Team: </label>{{item1.awayTeamName}}</div>
                                            <div v-if="item1.awayTeamFormation != null" style="flex: 3; text-align: center">
                                                <label v-if="item1.away_fmt_ans">Used: {{(item1.away_fmt_ans.used/item1.away_fmt_ans.counts*100).toFixed(2)}}%</label>
                                                <label v-else>Used: #</label>
                                            </div>
                                            <div v-else style="flex: 3; text-align: center; color: white;">
                                                .
                                            </div>
                                            <div v-if="item1.awayTeamFormation != null" style="flex: 4">
                                                <label style = "float: left; margin-right: 10px;">LineUp:</label>
                                                <label style="float: right; margin-right: 50px;">{{item1.awayTeamFormation}}</label>
                                            </div>
                                            <div v-else style="flex: 4; color: white;">
                                                .
                                            </div>
                                            <div v-if="item1.awayTeamFormation != null" style="flex: 4">
                                                <label style="margin-left: 3%; float: left;">Manual: </label>
                                                <CSelect
                                                        @click = "selected_team = item1.awayTeamName, selected_direction = 'away'"
                                                        class="lineup-selector"
                                                        :options="lineup_list"
                                                        @update:value="select_lineup1"
                                                >
                                                </CSelect>
                                            </div>
                                            <div v-else style="flex: 4; color: white;">
                                                .
                                            </div>
                                        </div>
                                        <div v-if="item1.awayTeamFormation != null" style="clear: left;  display: flex; text-align: center; background: #e6b8b7; border-bottom: 1px solid white; height: 20px; color: black;">
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                S.Role
                                            </div>
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                M.R
                                            </div>
                                            <div style="width: 18%; float: left; border-right: 1px solid white;">
                                                Line Up Home
                                            </div>
                                            <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                Sub
                                            </div>
                                            <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                Market Value
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                P.M.Role
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Primary_Role
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Alt.Role1
                                            </div>
                                            <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                Alt.Role2
                                            </div>
                                            <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                Rate
                                            </div>
                                            <div style="width: 13%;">
                                                Titularity %
                                            </div>
                                        </div>
                                        <div v-else style="clear: left;">Lineup info is not available yet.</div>
                                        <div v-if="item1.awayTeamFormation != null" v-for="(item2, index3) in item1.awayTeam" :key="item2.fixtureId" >
                                            <div v-if="index3 % 2 == 0" style="display: flex; text-align: center; background: #ff9999">
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.sRole}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.mR}}
                                                </div>
                                                <div v-if="item2.sub_order_color == 'rgb(230, 184, 183)'" :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': '#ff9999'}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div v-else :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': item2.sub_order_color}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                    {{item2.sub_minute}}
                                                </div>
                                                <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                    {{item2.marketValue}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.p_m_Role}}
                                                </div>
                                                <div :style="{'width': '10%', 'float': 'left', 'border-right': '1px solid white', 'background': item2.rule_color}">
                                                    {{item2.primaryRole}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole1}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole2}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.rating}}
                                                </div>
                                                <div style="width: 13%;">
                                                    {{item2.Tit}}
                                                </div>
                                            </div>
                                            <div v-else style="display: flex; text-align: center; background: #e6b8b7">
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.sRole}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.mR}}
                                                </div>
                                                <div :style="{'height': '18px','overflow': 'hidden', 'width': '18%', 'float': 'left', 'border-right': '1px solid white', 'text-align': 'left', 'padding-left': '5px', 'background': item2.sub_order_color}">
                                                    {{item2.Pname}}
                                                </div>
                                                <div style="width: 5%; float: left; border-right: 1px solid white;">
                                                    {{item2.sub_minute}}
                                                </div>
                                                <div style="width: 15%; float: left; border-right: 1px solid white;">
                                                    {{item2.marketValue}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.p_m_Role}}
                                                </div>
                                                <div :style="{'width': '10%', 'float': 'left', 'border-right': '1px solid white', 'background': item2.rule_color}">
                                                    {{item2.primaryRole}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole1}}
                                                </div>
                                                <div style="width: 10%; float: left; border-right: 1px solid white;">
                                                    {{item2.altRole2}}
                                                </div>
                                                <div style="width: 7%; float: left; border-right: 1px solid white;">
                                                    {{item2.rating}}
                                                </div>
                                                <div style="width: 13%;">
                                                    {{item2.Tit}}
                                                </div>
                                            </div>
                                         </div>
                                        <div v-if="item1.awayTeamFormation != null" style="width: 100%; min-height: 100px;border: 1px solid lightgray;padding: 10px; margin-top: 10px;">
                                            <div style="width: 15%; float: left; height: 62px; text-align: right;">
                                                Subst.legend:
                                            </div>
                                            <div v-if="item1.away_legend" style="width: 25%; float: left; text-align: center; margin-bottom: 10px;">
                                                <div v-for="item4  in item1.away_legend" :key="item4.index" style="display: flex; width: 80%; margin: auto;">
                                                    <div :style="{'flex': '1', 'height': '20px', 'background': item4.color}">{{item4.label}}</div>
                                                </div>
                                            </div>
                                            <div style="width: 17%; float: left; height: 62px; padding-left: 20px;">
                                                Role legend:
                                            </div>
                                            <div v-if="item1.away_rule_set" style="width: 43%; float: left; height: 62px;">
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: #92d050; text-align: center;">{{item1.away_rule_set.green_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player in Role</div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: whitesmoke; text-align: center;">{{item1.away_rule_set.yellow_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player in alternative Role</div>
                                                </div>
                                                <div style="display: flex;">
                                                    <div style="flex: 2; height: 20px; background: #ff0000; text-align: center;">{{item1.away_rule_set.red_color}}</div>
                                                    <div style="flex: 5; padding-left: 5px;">Player out of role</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div style="display: flex; margin-top: 10px; padding: 10px; border: 1px solid lightgray; margin-bottom: 10px;" class="anaylysis_div">
                                            <div v-if="item1.away_fmt_ans" class="lineup-ans" style="flex:1 ;text-align: center;">
                                                <label style="font-weight: 600; color: blue;">System of play used in away team:</label>
                                                <div v-for="(item0, index0) in item1.away_fmt_ans.ans" :key="index0 + 100">
                                                    <div style="display: flex; display: flex; text-align: center;">
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.label}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.count}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{(item0.count/(item1.away_fmt_ans.counts + 0.00001)*100).toFixed(2)}}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="item1.away_b_fmt_ans" class="lineup-ans" style="flex: 1; text-align: center;">
                                                <label style="font-weight: 600; color: blue;">System of play used in the season:</label>
                                                <div v-for="(item0, index0) in item1.away_b_fmt_ans.ans" :key="index0 + 100">
                                                    <div style="display: flex; display: flex; text-align: center;">
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.label}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{item0.count}}
                                                        </div>
                                                        <div style="flex: 1; font-weight: 600">
                                                            {{(item0.count/(item1.away_b_fmt_ans.counts + 0.00001)*100).toFixed(2)}}%
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else style="color: red; text-align: center; font-weight: 600; width: 50%; float: right; margin-top: 20px;">{{ $t('CLICK HERE TO LOAD TEAM ANALYSIS DATA.') }}</div>
                            </CTab>
                        </CTabs>
                    </CCol>
                </CRow>
            </CCardBody>
        </CCard>
        <b-modal id="modal-center" class="live-stats-modal" centered :title="historicModalData.eventName">
                <div v-if="!isload" style="height: 10px;">
                    <b-progress :value="current_counter" :max="counter" animated></b-progress>
                </div>
                <div v-else>
                    <CTabs variant="tabs" :active-tab="0">
                        <CTab :title="$t('Historical Stats')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content" style="text-align: center; padding-top: 20px; width: 5%; height: 50px; float: left; background: #8db4e2; border-left: 1px solid #ffffff;"  v-b-tooltip.hover :title = "$t(' P-Number ')">
                                        <span v-b-tooltip.hover :title = "$t(' P-Number ')">P</span>
                                    </div>
                                    <div class="header-content detail_total" style="width: 95%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        <span v-b-tooltip.hover :title = "$t(' Avg Stats Per Game ')">{{ $t('Avg Stats Per Game') }}</span>
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 30px!important; width: 6.5%!important" v-b-tooltip.hover :title = "$t(' Goals ')">
                                                {{ $t('Goals') }}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 4.5%!important" v-b-tooltip.hover :title = "$t(' On ')">
                                                On
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;" v-b-tooltip.hover :title = "$t(' Off ')">
                                                Off
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Blk ')">
                                                Blk
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 5%!important" v-b-tooltip.hover :title = "$t(' In ')">
                                                In
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Out ')">
                                                Out
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Cnr ')">
                                                Cnr
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' DA ')">
                                                DA
                                            </div>
                                            <div class="detail season-detail" style="min-width: 30px;" v-b-tooltip.hover :title = "$t(' Pos ')">
                                                Pos
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Pas ')">
                                                Pas
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Acc ')">
                                                Acc
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Atk ')">
                                                Atk
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Ofs ')">
                                                Ofs
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Sav ')">
                                                Sav
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Sbst ')">
                                                Sbst
                                            </div>
                                            <div class="detail season-detail" v-b-tooltip.hover :title = "$t(' Fou ')">
                                                Fou
                                            </div>
                                            <div  class="detail season-detail" style="min-width: 30px!important; width: 6%!important" v-b-tooltip.hover :title = "$t(' G_att ')">
                                                G_att
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Safe ')">
                                                Safe
                                            </div>
                                            <div  class="detail season-detail" v-b-tooltip.hover :title = "$t(' Rtg ')">
                                                Rtg
                                            </div>
                                        </div>
                                        <b-tooltip target="Modal-P" triggers="hover">
                                            <span>{{ $t(' P-Number ') }}</span>
                                        </b-tooltip>
                                         <b-tooltip target="Modal-avg" triggers="hover">
                                            <span>{{ $t(' Avg Stats Per Game ') }}</span>
                                        </b-tooltip>
                                        <b-tooltip target="Modal-Goals" triggers="hover">
                                            <span>{{ $t(' Goals ') }}</span>
                                        </b-tooltip>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.home_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.home_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.goals != 0 && historicModalData.home_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.home_season.goals/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.on != null && historicModalData.home_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.on/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.off != 0 && historicModalData.home_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.off/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.blk != 0 && historicModalData.home_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.blk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.in != 0 && historicModalData.home_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.in/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.out != 0 && historicModalData.home_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.out/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.cnr != 0 && historicModalData.home_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.cnr/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.da != 0 && historicModalData.home_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.da/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pos != 0 && historicModalData.home_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pos/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.pas != 0 && historicModalData.home_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.pas/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.acc != 0 && historicModalData.home_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.acc/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.atk != 0 && historicModalData.home_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.atk/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.ofs != 0 && historicModalData.home_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.ofs/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sav != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sav/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.sbst != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.sbst/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.fou != 0 && historicModalData.home_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.fou/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.g_att != 0 && historicModalData.home_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.g_att/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.home_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.home_season.safe != 0 && historicModalData.home_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.home_season.safe/historicModalData.home_p).toFixed(1)}}
                                            </div>

                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.home_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width: 5%; height: 30px; float: left; border-left: 1px solid #e2e2e2; border-bottom: 1px solid #e2e2e2;">
                                        <div style="text-align: center;">{{historicModalData.away_p}}</div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 95%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div v-if="historicModalData.away_season.goals == 0" class="detail season-detail"  style="color: red; min-width: 45px!important;">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.goals == null" class="detail season-detail" style="min-width: 45px!important;">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.goals != 0 && historicModalData.away_season.goals != null" class="detail season-detail" style="color: green; min-width: 45px!important;">
                                                {{(historicModalData.away_season.goals/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.on == 0" class="detail season-detail" style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.on == null" class="detail season-detail" style="color: red">
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.on != null && historicModalData.away_season.on != 0" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.on/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.off == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.off == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.off != 0 && historicModalData.away_season.off != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.off/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.blk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.blk != 0 && historicModalData.away_season.blk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.blk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.in == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.in == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.in != 0 && historicModalData.away_season.in != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.in/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.out == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.out == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.out != 0 && historicModalData.away_season.out != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.out/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.cnr != 0 && historicModalData.away_season.cnr != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.cnr/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.da == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.da == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.da != 0 && historicModalData.away_season.da != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.da/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pos == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pos != 0 && historicModalData.away_season.pos != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pos/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.pas == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.pas != 0 && historicModalData.away_season.pas != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.pas/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.acc == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.acc != 0 && historicModalData.away_season.acc != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.acc/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.atk == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.atk != 0 && historicModalData.away_season.atk != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.atk/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.ofs != 0 && historicModalData.away_season.ofs != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.ofs/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sav == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sav != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sav/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.sbst != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.sbst/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.fou == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.fou != 0 && historicModalData.away_season.sav != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.fou/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att == null" class="detail season-detail" >
                                                -
                                            </div>

                                            <div v-if="historicModalData.away_season.g_att != 0 && historicModalData.away_season.g_att != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.g_att/historicModalData.away_p).toFixed(1)}}
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == 0" class="detail season-detail"  style="color: red">
                                                0
                                            </div>

                                            <div v-if="historicModalData.away_season.safe == null" class="detail season-detail" >
                                                -
                                            </div>
                                            <div  v-if="historicModalData.away_season.safe != 0 && historicModalData.away_season.safe != null" class="detail season-detail" style="color: green">
                                                {{(historicModalData.away_season.safe/historicModalData.away_p).toFixed(1)}}
                                            </div>
                                            <div class="detail season-detail" style="color: #263043; font-weight: bold;">
                                                {{(historicModalData.away_a_rtg).toFixed(0)}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </CTab>
                        <CTab :title="$t('Chart')">
                            <div class="modal-tab-content" style="height: auto">
                                <div style="min-width: 714px;">
                                    <Plotly :data="data" :layout="layout" :display-mode-bar="true"></Plotly>
                                </div>
                            </div>
                        </CTab>
                        <CTab :title="$t('Odds')">
                            <div class="header modal-tab-content">
                                <div style="min-width: 714px;">
                                    <div class="header-content detail_total" style="width: 100%; height: 50px; float: left; border-left: 1px solid #ffffff; background: #8db4e2; font-weight: bold; font-size: 13px!important;">
                                        Odds
                                        <div class="season-part" style="width: 100%">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                H
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                D
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                A
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-0.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-1.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-2.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                O-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                U-3.5
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                O-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                U-0.5(ht)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(yes)
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                BTS(no)
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                                {{this.flatodds.h_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.d_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important;">
                                            {{this.flatodds.a_win}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                            {{this.flatodds.u_05}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_15}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_25}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.o_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                {{this.flatodds.u_35}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                            {{this.flatodds.o_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                {{this.flatodds.u_05_ht}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_yes}}
                                            </div>
                                            <div class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                {{this.flatodds.bts_no}}
                                            </div>
                                            
                                        </div>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none;">
                                        <div style="width: 100%; padding: 3px 7px; color: black;">
                                            <div  v-if="flatodds.prob_home != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_home" :class="{'green-label' : flatodds.prob_home_tt2 > 10 }">{{flatodds.prob_home + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_draw != '-'" class="detail season-detail" style="min-width: 20px!important;">
                                                <span id="prob_draw" :class="{'green-label' : flatodds.prob_draw_tt2 > 10 }">{{this.flatodds.prob_draw + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_away != '-'" class="detail season-detail" style="min-width: 20px!important;" >
                                                <span id="prob_away" :class="{'green-label' : flatodds.prob_away_tt2 > 10 }">{{this.flatodds.prob_away + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important;">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over05" :class="{'green-label' : flatodds.prob_over05_tt2 > 10 }">{{this.flatodds.prob_over05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under05"  :class="{'green-label' : flatodds.prob_under05_tt2 > 10 }">{{this.flatodds.prob_under05 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over15" :class="{'green-label' : flatodds.prob_over15_tt2 > 10 }">{{this.flatodds.prob_over15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under15 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under15" :class="{'green-label' : flatodds.prob_under15_tt2 > 10 }">{{this.flatodds.prob_under15 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over25" :class="{'green-label' : flatodds.prob_over25_tt2 > 10 }">{{this.flatodds.prob_over25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under25 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under25" :class="{'green-label' : flatodds.prob_under25_tt2 > 10 }">{{this.flatodds.prob_under25 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_over35" :class="{'green-label' : flatodds.prob_over35_tt2 > 10 }">{{this.flatodds.prob_over35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under35 != '-'" class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                <span id="prob_under35" :class="{'green-label' : flatodds.prob_under35_tt2 > 10 }">{{this.flatodds.prob_under35 + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 6.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_over05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_over05_ht" :class="{'green-label' : flatodds.prob_over05_ht_tt2 > 10 }">{{this.flatodds.prob_over05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_under05_ht != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                <span id="prob_under05_ht" :class="{'green-label' : flatodds.prob_under05_ht_tt2 > 10 }">{{this.flatodds.prob_under05_ht + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts" :class="{'green-label' : flatodds.prob_bts_tt2 > 10 }">{{this.flatodds.prob_bts + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            <div  v-if="flatodds.prob_bts_no != '-'" class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                <span id="prob_bts_no" :class="{'green-label' : flatodds.prob_bts_no_tt2 > 10 }">{{this.flatodds.prob_bts_no + "%"}}</span>
                                            </div>
                                            <div v-else class="detail season-detail" style="min-width: 20px!important; width: 8.5%!important">
                                                -
                                            </div>
                                            
                                        </div>
                                        
                                        <b-tooltip v-if="flatodds.prob_home_tt2" target="prob_home" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_home_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_home_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_away_tt2" target="prob_away" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_away_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_away_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_draw_tt2" target="prob_draw" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_draw_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_draw_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_tt2" target="prob_over05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over15_tt2" target="prob_over15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over25_tt2" target="prob_over25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over35_tt2" target="prob_over35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_tt2" target="prob_under05" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under15_tt2" target="prob_under15" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under15_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under15_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under25_tt2" target="prob_under25" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under25_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under25_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under35_tt2" target="prob_under35" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under35_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under35_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_over05_ht_tt2" target="prob_over05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_over05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_over05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_under05_ht_tt2" target="prob_under05_ht" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_under05_ht_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_under05_ht_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_tt2" target="prob_bts" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_tt2}}%</span>
                                        </b-tooltip>
                                        <b-tooltip v-if="flatodds.prob_bts_no_tt2" target="prob_bts_no" triggers="hover">
                                            <span>True Odds: {{flatodds.prob_bts_no_tt1}}</span><br>
                                            <span>Value: {{flatodds.prob_bts_no_tt2}}%</span>
                                        </b-tooltip>
                                    </div>
                                    <div class="detail_total season-stats-part" style="width: 100%; height: 30px; float: left; border: 1px solid #e2e2e2; border-top: none; padding-left: 15px;">
                                        {{matches_sample}} matches sample
                                    </div>
                                </div>
                                
                            </div>
                        </CTab>
                    </CTabs>
                </div>
            </b-modal>
        <b-modal id="modal-center1" centered :title="''">
            <CTabs variant="tabs" :active-tab="0">
                <CTab title="details1">
                    <div v-if="current_modal_data">
                        <div style="display: flex; ">
                            <div style="flex: 1;">
                                <div style="width: 90%;">
                                    <div style="text-align: center; background: #d6d8d9; font-size: 16px!important; font-size: 12px!important;">{{current_modal_data.current_home_name}}</div>
                                    <div style="text-align: center; background: #d6d8d9; font-size: 16px!important; font-weight: 600;">Home</div>
                                    <div style="width: 50%; background: #d6d8d9; float: left; font-size: 14px!important; text-align: center; font-weight: 600;">
                                        HT
                                    </div>
                                    <div style="width: 50%; background: #d6d8d9; float: left;  font-size: 14px!important; text-align: center; font-weight: 600;">
                                        FT
                                    </div>
                                </div>
                                <div v-for="item in current_modal_data.home_team_scores">
                                    <div :id = "item.key + '1'" :style="{'width': '42.5%', 'float': 'left', 'text-align': 'center', 'background': item.ht_color, 'margin-bottom': '5px'}">{{item.ht_score}}</div>
                                    <b-tooltip :target="item.key + '1'" v-if="item.goal_tlp != ''" triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">
                                            {{item.date}}
                                        </div>
                                    </b-tooltip>
                                    <div :id = "item.key" :style="{'width': '42.5%', 'float': 'left', 'text-align': 'center', 'background': item.ft_color, 'margin-bottom': '5px', 'margin-left': '5%'}">{{item.ft_score}}</div>
                                    <b-tooltip :target="item.key" v-if="item.goal_tlp != ''" triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">
                                            {{item.date}}
                                        </div>
                                    </b-tooltip>
                                </div>
                            </div>
                            <div style="flex: 1">
                                <div style="width: 90%;">
                                    <div style="text-align: center; background: #d6d8d9; font-size: 16px!important; font-size: 12px!important;">{{current_modal_data.current_away_name}}</div>
                                    <div style="text-align: center; background: #d6d8d9; font-size: 16px!important; font-weight: 600;">Away</div>
                                    <div style="width: 50%; background: #d6d8d9; float: left; font-size: 14px!important; text-align: center; font-weight: 600;">
                                        HT
                                    </div>
                                    <div style="width: 50%; background: #d6d8d9; float: left;  font-size: 14px!important; text-align: center; font-weight: 600;">
                                        FT
                                    </div>
                                </div>
                                <div v-for="item in current_modal_data.away_team_scores">
                                    <div :id="item.key + '1'" :style="{'width': '42.5%', 'float': 'left', 'text-align': 'center', 'background': item.ht_color, 'margin-bottom': '5px'}">{{item.ht_score}}</div>
                                    <b-tooltip :target="item.key + '1'" v-if="item.goal_tlp != ''"  triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">{{item.date}}</div>
                                    </b-tooltip>
                                    <div :id="item.key" :style="{'width': '42.5%', 'float': 'left', 'text-align': 'center', 'background': item.ft_color, 'margin-bottom': '5px', 'margin-left': '5%'}">{{item.ft_score}}</div>
                                    <b-tooltip :target="item.key" v-if="item.goal_tlp != ''"  triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">{{item.date}}</div>
                                    </b-tooltip>
                                </div>
                            </div>
                            <div style="flex: 2">
                                <div style="text-align: center; background: whitesmoke; font-size: 16px!important; font-weight: 600; color: white;">Full Score Table</div>
                                <div style="text-align: center; background: #d6d8d9; font-size: 16px!important; font-weight: 600;">Full Score Table</div>
                                <div v-for="item in current_modal_data.full_time_score_array">
                                    <div :style="{'text-align': 'left', 'margin-bottom': '5px', 'color': item.color}">{{item.rank}}. {{item.teamName}}</div>
                                </div>
                            </div>
                            <div style="flex: 1">
                                <div style="text-align: center; width:80%; height: 25px; background: #d6d8d9; font-size: 16px!important; font-size: 12px!important;">{{current_modal_data.current_home_name}}</div>
                                <div style="text-align: center; width:80%; background: #d6d8d9; font-size: 16px!important; font-weight: 600;">Home</div>
                                <div v-for="item in current_modal_data.home_full_scores">
                                    <div :id="item.key" v-if="item != null" :style="{'width': '80%', 'background': item.ft_color, 'text-align': 'center', 'margin-bottom': '5px'}">{{item.ft_score}}</div>
                                    <div v-else style="width: 80%; background: #cccccc; margin-bottom: 5px; color: #cccccc;"> ...</div>
                                    <b-tooltip v-if="item != null && item.goal_tlp != ''" :target="item.key" triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">{{item.date}}</div>
                                    </b-tooltip>
                                </div>
                            </div>
                            <div style="flex: 1">
                                <div :style="{'text-align': 'center', 'width': '80%', 'height': '25px', 'background': '#d6d8d9', 'font-size': '12px!important'}">{{current_modal_data.current_away_name}}</div>
                                <div style="text-align: center; width:80%; background: #d6d8d9; font-size: 16px!important; font-weight: 600;">Away</div>
                                <div v-for="item in current_modal_data.away_full_scores">
                                    <div :id="item.key" v-if="item != null" :style="{'width': '80%', 'background': item.ft_color, 'text-align': 'center', 'margin-bottom': '5px'}">{{item.ft_score}}</div>
                                    <div v-else style="width: 80%; background: #c7c7c7; margin-bottom: 5px; color: #cccccc;">...</div>
                                    <b-tooltip v-if="item != null && item.goal_tlp != ''" :target="item.key" triggers="hover">
                                        <div>{{item.local_name}} V {{item.visitor_name}}</div>
                                        <div>{{item.goal_tlp}}</div>
                                        <div style="font-size: 12px!important;">{{item.date}}</div>
                                    </b-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </CTab>
                <CTab title="details2">
                    <div v-if="current_modal_data">
                        <div style="display: flex;">
                            <div style="flex: 1;background: lightblue; text-align: center;">#</div>
                            <div style="flex: 4;background: lightblue;">Regular Season</div>
                            <div style="flex: 1; border-left: 1px solid lightgray;background: lightblue; text-align: center">P</div>
                            <div style="flex: 1;background: lightblue; text-align: center">W</div>
                            <div style="flex: 1;background: lightblue;text-align: center">D</div>
                            <div style="flex: 1;background: lightblue;text-align: center">L</div>
                            <div style="flex: 1;background: lightblue;text-align: center">F</div>
                            <div style="flex: 1; border-right: 1px solid lightgray;background: lightblue;text-align: center">A</div>
                            <div style="flex: 1;background: lightblue;text-align: center">GD</div>
                            <div style="flex: 1;background: lightblue;text-align: center">P</div>
                        </div>
                        <div v-for="(item, index) in current_modal_data.position_details">
                            <div v-if="index % 2 == 1"  style="display: flex; background: lightgrey; border: 1px solid white">
                                <div :id="item.key" :style="{'flex': '1', 'text-align': 'center', 'background': item.color, 'color': item.border, 'font-weight': '600'}">{{item.position}}</div>
                                <b-tooltip v-if="item.tooltip != null" :target="item.key" triggers="hover">
                                    {{item.tooltip}}
                                </b-tooltip>
                                <div style="flex: 4">{{item.name}}</div>
                                <div style="flex: 1; border-left: 1px solid white; text-align: center">{{item.p}}</div>
                                <div style="flex: 1; text-align: center">{{item.w}}</div>
                                <div style="flex: 1; text-align: center">{{item.d}}</div>
                                <div style="flex: 1; text-align: center">{{item.l}}</div>
                                <div style="flex: 1; text-align: center">{{item.f}}</div>
                                <div style="flex: 1; border-right: 1px solid lightgray; text-align: center">{{item.a}}</div>
                                <div style="flex: 1; text-align: center">{{item.gf}}</div>
                                <div style="flex: 1; text-align: center">{{item.points}}</div>
                            </div>
                            <div v-else style="display: flex; border: 1px solid white">
                                <div :id="item.key" :style="{'flex': '1', 'text-align': 'center', 'background': item.color, 'color': item.border, 'font-weight': '600'}">{{item.position}}</div>
                                <b-tooltip v-if="item.tooltip != null" :target="item.key" triggers="hover">
                                    {{item.tooltip}}
                                </b-tooltip>
                                <div style="flex: 4">{{item.name}}</div>
                                <div style="flex: 1; border-left: 1px solid lightgray; text-align: center">{{item.p}}</div>
                                <div style="flex: 1; text-align: center">{{item.w}}</div>
                                <div style="flex: 1; text-align: center">{{item.d}}</div>
                                <div style="flex: 1; text-align: center">{{item.l}}</div>
                                <div style="flex: 1; text-align: center">{{item.f}}</div>
                                <div style="flex: 1; border-right: 1px solid lightgray; text-align: center">{{item.a}}</div>
                                <div style="flex: 1; text-align: center">{{item.gf}}</div>
                                <div style="flex: 1; text-align: center">{{item.points}}</div>
                            </div>
                        </div>
                    </div>
                </CTab>
            </CTabs>
        </b-modal>
    </div>

</template>

<script>
    import { Plotly } from 'vue-plotly'
    import CountryFlag from 'vue-country-flag'
    import swal from "sweetalert2";
    const io = require("socket.io-client")
    require('howler');
    export default {
        name: 'MainView',
        components: {
            Plotly, CountryFlag
        },
        data(){
            return{
                baseURL: window.location.origin + '/#',  // dynamically fetches base URL
                strategiesList: [
                    {
                        name: 'Lay X',
                        id: '628e43436e15a3eb3666bb7e',
                    },
                    {
                        name: 'Back X',
                        id: '628e435c6e15a3eb3666bbb5',
                    },
                    {
                        name: 'Lay 1',
                        id: '628e438f6e15a3eb3666bc29',
                    },
                    {
                        name: 'Lay 2',
                        id: '628e439e6e15a3eb3666bc4d',
                    },
                    {
                        name: 'Back Over 0.5',
                        id: '628e43c06e15a3eb3666bc8c',
                    },
                    {
                        name: 'Back Over 1.5',
                        id: '628e43cc6e15a3eb3666bca8',
                    },
                    {
                        name: 'Back Over 2.5',
                        id: '628e43d76e15a3eb3666bcc2',
                    },
                    {
                        name: 'Back Under 2.5',
                        id: '628e43e76e15a3eb3666bce1',
                    },
                    {
                        name: 'Back Under 3.5',
                        id: '628e43f06e15a3eb3666bcf2',
                    },

                    // Add more strategies as needed
                ],
                // Separate visibility flags and timers for each modal
                isModalVisible: false,
                isModal2Visible: false,
                maxDurationTimer: null,
                frequentModalTimer: null, // Timer for the frequent modal

                sockets_server1: undefined,
                flatodds: {
                    "h_win": "-",
                    "a_win": "-",
                    "d_win": "-",
                    "o_05": "-",
                    "o_15": "-",
                    "o_25": "-",
                    "o_35": "-",
                    "u_05": "-",
                    "u_15": "-",
                    "u_25": "-",
                    "u_35": "-",
                    "o_05_ht": "-",
                    "u_05_ht": "-",
                    "bts_yes": "-",
                    "bts_no": "-",
                    prob_home: "-",
                    prob_draw: "-",
                    prob_away : "-",
                    prob_over05: "-",
                    prob_over15: "-",
                    prob_over25 : "-",
                    prob_over35 : "-",
                    prob_bts: "-",
                    prob_over05_ht: "-",

                    prob_under05: "-",
                    prob_under15: "-",
                    prob_under25 : "-",
                    prob_under35: "-",

                    prob_bts_no: "-",
                    prob_under05_ht: "-",

                    prob_home_tt1: null,
                    prob_home_tt2: null,
                    prob_away_tt1: null,
                    prob_away_tt2: null,
                    prob_draw_tt1: null,
                    prob_draw_tt2: null,
                    prob_over05_tt1: null,
                    prob_over05_tt2: null,
                    prob_over15_tt1: null,
                    prob_over15_tt2: null,
                    prob_over25_tt1: null,
                    prob_over25_tt2: null,
                    prob_over35_tt1: null,
                    prob_over35_tt2: null,
                    prob_under05_tt1: null,
                    prob_under05_tt2: null,
                    prob_under15_tt1: null,
                    prob_under15_tt2: null,
                    prob_under25_tt1: null,
                    prob_under25_tt2: null,
                    prob_under35_tt1: null,
                    prob_under35_tt2: null,
                    prob_over05_ht_tt1: null,
                    prob_over05_ht_tt2: null,
                    prob_under05_ht_tt1: null,
                    prob_under05_ht_tt2: null,
                    prob_bts_tt1: null,
                    prob_bts_tt2: null,
                    prob_bts_no_tt1: null,
                    prob_bts_no_tt2: null,

                },
                matches_sample: 0,
                goal_sound: false,
                alert_sound: false,
                checked_stoploss: true,
                checked_trading: false,
                risk_key: '1',
                alert_key: 'OFF',
                mycurrency: 'EUR',
                currency_data: {},

                current_modal_data: null,
                goal_key: null,
                goal_tooltip: null,
                alertNameList1:[{"value": "OFF", "label": "OFF"}],
                alertNameList: [],
                isload: false,
                isload_: false,
                isload1: true,
                counter: 50,
                current_counter: 0,
                historicModalData:{
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 1,
                    "away_p": 1,
                    "home_rtg": 0,
                    "home_a_rtg": 0,
                    "away_rtg": 0,
                    "away_a_rtg": 0
                },
                data:[
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [10,15,13,17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        showarrow: false,
                        marker: {
                            color: 'rgba(244,66,66, 1)',
                            line: {
                                color: 'rgb(244,66,66)',
                                width: 1
                            }
                        }
                    },
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [-10,-15,-13,-17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        yaxis: 'y2',
                        showarrow: false,
                        marker: {
                            color: 'rgba(65,149,244,1)',
                            line: {
                                color: 'rgb(65,149,244)',
                                width: 1
                            }
                        }
                    },
                ],
                layout:{
                    title: "",
                    xaxis:{
                        "title": {
                            "text": 'Time',
                            "font": {
                                "size": 18,
                                "color": '#263043',
                                "weight": "bold"
                            }
                        },
                    },
                    yaxis: {
                        'showgrid': false,
                        'zeroline': false,
                        'visible': false
                    },
                    yaxis2: {
                        "title": {
                            "text": 'RTG',
                            "font": {
                                "size": 18,
                                "color": '#263043',
                                "weight": "bold"
                            }
                        },
                        "overlaying": 'y',
                        "matches": 'y',
                        "tickfont" : {
                            "color" : 'white'
                        },
                        // 'showgrid': true,
                        // 'zeroline': false,
                        // 'visible': false
                        // "autorange": 'reversed',
                    },
                    showlegend: true,
                    barmode: 'relative',
                    showarrow: false
                },
                lineup_home_id:0,
                lineup_away_id:0,
                coldstats_show: false,
                home_id : 0,
                away_id: 0,
                show_collapse: false,
                item1: {
                    'fixtureId': null,
                    'main_data': null,
                    'homeRank': null,
                    'awayRank': null,
                    'chart': {
                        'time': [],
                        'homeRTG': [],
                        'awayRTG': []
                    },
                    'home_p': 1,
                    'goal_tooltip': '',
                    'goalKey': null,
                    'away_p': 1,
                    'home': {
                        'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr':0,
                        'time': '',
                        'score': 0,
                        'flash': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                    },
                    'away': {
                        'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr': 0,
                        'time': 0,
                        'score': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                    },
                    'homeT': {
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'flash': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0,
                        'match_odd_1': '',
                        'match_odd_2': '',
                        'match_odd_3': '',
                        'over_25_odd': '',
                        'under_25_odd': '',
                    },
                    'awayT': {
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0
                    },
                    'home1' : {
                        'on': 'red',
                        'off': 'red',
                        'blk': 'red',
                        'in': 'red',
                        'out': 'red',
                        'cnr': 'red',
                        'da': 'red',
                        'poss': 'red',
                    },
                    'away1' : {
                        'on': 'red',
                        'off': 'red',
                        'blk': 'red',
                        'in': 'red',
                        'out': 'red',
                        'cnr': 'red',
                        'da': 'red',
                        'poss': 'red',
                    },
                    'com_url': '',
                    'it_url': '',
                    'home_season' : {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    'away_season' : {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    'home_tooltip':{
                        'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                    },
                    'away_tooltip':{
                        'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                    },
                    'season_id': null,
                    'league': '-',
                    'homeTeam': [],
                    'awayTeam': []
                },
                bet_data:{
                    src: 'betfair.com',
                    date:'today'
                },
                select_odd_from : [
                    { value: 'betfair.com', label: 'Betfair.com' },
                    { value: 'betfair.it', label: 'Betfair.it' }
                ],
                data_load_date:[
                    { value: 'today', label: 'Today' },
                    { value: 'tomorrow', label: 'Tomorrow' },
                    { value: '2_days', label: 'In two days' },
                    { value: '3_days', label: 'In three days' }
                ],
                gameList:[
                    { value: '0', label: 'Select Prediction' },
                    { value: '1', label: '- X - Back' },
                    { value: '2', label: '- X - Lay' },
                    { value: '3', label: '- 1 - Lay' },
                    { value: '4', label: '- 2 - Lay' },
                    { value: '5', label: '- Over 0.5 Back' },
                    { value: '6', label: '- Over 1.5 Back' },
                    { value: '7', label: '- Under 2.5 Back' },
                    { value: '8', label: '- Over 2.5 Back' },
                    { value: '9', label: '- Under 3.5 Back' },

                ],
                gameList1:[],
                gameList2:[],
                mainList: [],
                mainList1: [],
                eventLists: [],
                eventLists1: [],
                eventLists2: [],
                eventLists3: [],
                marketId: '',
                selectionId: 0,
                lay:'' ,
                back: '',
                total_matched: 0,
                back_matched: 0,
                lay_matched: 0,
                scoreOne: '',
                scoreTwo: '',
                status: '',
                timeRecord:'' ,
                eventId: 0,
                eventScore: 0,
                openDate: '',
                selectedArray: [],
                marketStatus: '',
                key:'',
                key1:'',
                key2: '',
                predictionList:[],
                teamgroups1:[],
                teamgroups2:[],
                competitionList:[],
                competitionList1:[],
                competitionName: this.$t('Competition ') +  ' >> N/D',
                matchWidth: '50%',
                predictionWidth: 'block',
                filterQuery:['- 1 -','- X -','- 2 -','- Over 0.5','- Over 1.5','- Over 2.5','- Under 2.5','- Under 3.5'],
                cupList:['Cup','Copa','UEFA','Europa League','Champions League','Cupen','Coppa'],
                predictionList1:[],
                filterSection:['Back','Lay','Cup','Week'],
                cupFilter:true,
                weekFilter:true,
                backFilter:true,
                layFilter:true,
                doubleTips:false,
                oddMin:0,
                oddMax:100000,
                matchedMin:0,
                matchedMax:90000000,
                predictionStatus:true,
                oddUrl:"",
                oddUrl1:"",
                eventName:"",
                selectedValue:"",
                selectedLabel: "",
                prematchOddList:[],
                prematchOdd:0,
                calc_odd:0,
                calc_stake:0,
                cs_odd:0,
                cs_stake: 0,
                max_profit:0,
                max_lose:0,
                percent_text1:'',
                percent_text1_:'',
                percent_text2: this.$t('Insert Odd and Stake'),
                guad_max:0,
                guad_att:0,
                percentTextColor:'#20a052',
                percentTextColor1:'#20a052',
                percentBackgroundColor:'#d8e4bc',
                percentBackgroundColor1:'#d8e4bc',
                currentPercent:0,
                adminTable: {},
                adminTable1: [],
                total_adminTable: [],
                stopLoss:false,
                tradingMode:false,
                riskTrading:'medium',
                bookmarkerFee:0,
                classic_match:'',
                low_cash: false,
                cash_out: true,
                high_cash: false,
                net_profit1: 0,
                net_profit2: 0,
                stakeCashout:0,
                coldstatsdata:[],

                eventList:[],
                collapsed:[],
                collapsed1:[],
                historicArray:[],
                historicResult:[],
                coldMap:[],
                item_X: {},
                leagueIndex: 0,
                eventIndex: 0,
                standingList:[],
                mainData:[],
                home_date_list:[],
                away_date_list:[],
                basic_data:[],
                red_FH_check: false,
                red_SH_check: false,
                rankList:[
                    {"value": 1, "label": "vs All"},
                    {"value": 2, "label": "vs High rank"},
                    {"value": 3, "label": "vs middle-high rank"},
                    {"value": 4, "label": "vs middle-low rank"},
                    {"value": 5, "label": "vs low rank"},
                ],
                rank_filter:{},
                home_team:{},
                away_team:{},
                item3:{
                    home : {
                        p:0,
                        name:'',
                        rank: '',
                        z_z: 0,
                        over15: 0,
                        over25:0,
                        over35:0,
                        scored:0,
                        conc:0,
                        average1:0,
                        average2:0,
                        bts:0,
                        first1:0,
                        first2:0,
                        second1:0,
                        second2:0,
                        time15_S:0,
                        time30_S:0,
                        time45_S:0,
                        time60_S:0,
                        time75_S:0,
                        time90_S:0,
                        time15_C:0,
                        time30_C:0,
                        time45_C:0,
                        time60_C:0,
                        time75_C:0,
                        time90_C:0,
                        gs1:0,
                        gs2:0,
                        gc1:0,
                        gc2:0,
                        over40:0,
                        over85:0,
                        C_H:0,
                        C_D:0,
                        C_A:0,
                        first10:0,
                        first11:0,
                        first20:0,
                        second01:0,
                        second11:0,
                        second02:0,
                        firstGoal:0,
                        lastGoal:0,
                        secondplus:0,
                        secondminus:0,
                        homefirst:0,
                        drawfirst:0,
                        awayfirst:0,
                        homesecond:0,
                        drawsecond:0,
                        awaysecond:0,
                        eventdays:['All'],
                        pos:0,
                        h_a:0,
                        swing1:'',
                        FH:0,
                        swing2:'',
                        SH:0,
                        swing3:'',
                        attack:0,
                        defense:0,
                        form:0,
                        form_H_A:0

                    },
                    away : {
                        p:0,
                        name:'',
                        rank:'' ,
                        z_z: 0,
                        over15: 0,
                        over25:0,
                        over35:0,
                        scored:0,
                        conc:0,
                        average1:0,
                        average2:0,
                        bts:0,
                        first1:0,
                        first2:0,
                        second1:0,
                        second2:0,
                        time15_S:0,
                        time30_S:0,
                        time45_S:0,
                        time60_S:0,
                        time75_S:0,
                        time90_S:0,
                        time15_C:0,
                        time30_C:0,
                        time45_C:0,
                        time60_C:0,
                        time75_C:0,
                        time90_C:0,
                        gs1:0,
                        gs2:0,
                        gc1:0,
                        gc2:0,
                        over40:0,
                        over85:0,
                        C_H:0,
                        C_D:0,
                        C_A:0,
                        first10:0,
                        first11:0,
                        first20:0,
                        second01:0,
                        second11:0,
                        second02:0,
                        firstGoal:0,
                        lastGoal:0,
                        secondPlus:0,
                        secondMinus:0,
                        homefirst:0,
                        drawfirst:0,
                        awayfirst:0,
                        homesecond:0,
                        drawsecond:0,
                        awaysecond:0,
                        eventdays:['All'],
                        pos:0,
                        h_a:0,
                        swing1: '',
                        FH:0,
                        swing2: '',
                        SH:0,
                        swing3: '',
                        attack:0,
                        defense:0,
                        form:0,
                        form_H_A:0
                    },
                    homeDateList: [],
                    awayDateList : [],
                    home_id: 0,
                    away_id: 0,
                    openDate: '',
                    eventName: '',
                    rank_option: [],
                    rank_set: {},
                    rankFilter : false,
                    b_data : [],
                    homeLineupList: [],
                    awayLineupList: [],
                },
                current_sort_field: "",
                current_sort_data: [],
                current_sort_teamId: 0,
                current_sort_direction: true,
                current_sort_team: "home",
                current_sort_group: "DEF",
                collapse: false,
                countryCodeList:[
                    {'ccode' : 'AF', 'cname' : 'Afghanistan'},
                    {'ccode' : 'AX', 'cname' : 'Aland Islands'},
                    {'ccode' : 'AL', 'cname' : 'Albania'},
                    {'ccode' : 'DZ', 'cname' : 'Algeria'},
                    {'ccode' : 'AS', 'cname' : 'American Samoa'},
                    {'ccode' : 'AD', 'cname' : 'Andorra'},
                    {'ccode' : 'AO', 'cname' : 'Angola'},
                    {'ccode' : 'AI', 'cname' : 'Anguilla'},
                    {'ccode' : 'AQ', 'cname' : 'Antarctica'},
                    {'ccode' : 'AG', 'cname' : 'Antigua And Barbuda'},
                    {'ccode' : 'AR', 'cname' : 'Argentina'},
                    {'ccode' : 'AM', 'cname' : 'Armenia'},
                    {'ccode' : 'AW', 'cname' : 'Aruba'},
                    {'ccode' : 'AU', 'cname' : 'Australia'},
                    {'ccode' : 'AT', 'cname' : 'Austria'},
                    {'ccode' : 'AZ', 'cname' : 'Azerbaijan'},
                    {'ccode' : 'BS', 'cname' : 'Bahamas'},
                    {'ccode' : 'BH', 'cname' : 'Bahrain'},
                    {'ccode' : 'BD', 'cname' : 'Bangladesh'},
                    {'ccode' : 'BB', 'cname' : 'Barbados'},
                    {'ccode' : 'BY', 'cname' : 'Belarus'},
                    {'ccode' : 'BE', 'cname' : 'Belgium'},
                    {'ccode' : 'BZ', 'cname' : 'Belize'},
                    {'ccode' : 'BJ', 'cname' : 'Benin'},
                    {'ccode' : 'BM', 'cname' : 'Bermuda'},
                    {'ccode' : 'BT', 'cname' : 'Bhutan'},
                    {'ccode' : 'BO', 'cname' : 'Bolivia'},
                    {'ccode' : 'BA', 'cname' : 'Bosnia And Herzegovina'},
                    {'ccode' : 'BW', 'cname' : 'Botswana'},
                    {'ccode' : 'BV', 'cname' : 'Bouvet Island'},
                    {'ccode' : 'BR', 'cname' : 'Brazil'},
                    {'ccode' : 'IO', 'cname' : 'British Indian Ocean Territory'},
                    {'ccode' : 'BN', 'cname' : 'Brunei Darussalam'},
                    {'ccode' : 'BG', 'cname' : 'Bulgaria'},
                    {'ccode' : 'BF', 'cname' : 'Burkina Faso'},
                    {'ccode' : 'BI', 'cname' : 'Burundi'},
                    {'ccode' : 'KH', 'cname' : 'Cambodia'},
                    {'ccode' : 'CM', 'cname' : 'Cameroon'},
                    {'ccode' : 'CA', 'cname' : 'Canada'},
                    {'ccode' : 'CV', 'cname' : 'Cape Verde'},
                    {'ccode' : 'KY', 'cname' : 'Cayman Islands'},
                    {'ccode' : 'CF', 'cname' : 'Central African Republic'},
                    {'ccode' : 'TD', 'cname' : 'Chad'},
                    {'ccode' : 'CL', 'cname' : 'Chile'},
                    {'ccode' : 'CN', 'cname' : 'China'},
                    {'ccode' : 'CX', 'cname' : 'Christmas Island'},
                    {'ccode' : 'CC', 'cname' : 'Cocos (Keeling) Islands'},
                    {'ccode' : 'CO', 'cname' : 'Colombia'},
                    {'ccode' : 'KM', 'cname' : 'Comoros'},
                    {'ccode' : 'CG', 'cname' : 'Congo'},
                    {'ccode' : 'CD', 'cname' : 'Congo, Democratic Republic'},
                    {'ccode' : 'CK', 'cname' : 'Cook Islands'},
                    {'ccode' : 'CR', 'cname' : 'Costa Rica'},
                    {'ccode' : 'CI', 'cname' : 'Cote D\'Ivoire'},
                    {'ccode' : 'HR', 'cname' : 'Croatia'},
                    {'ccode' : 'CU', 'cname' : 'Cuba'},
                    {'ccode' : 'CY', 'cname' : 'Cyprus'},
                    {'ccode' : 'CZ', 'cname' : 'Czech Republic'},
                    {'ccode' : 'DK', 'cname' : 'Denmark'},
                    {'ccode' : 'DJ', 'cname' : 'Djibouti'},
                    {'ccode' : 'DM', 'cname' : 'Dominica'},
                    {'ccode' : 'DO', 'cname' : 'Dominican Republic'},
                    {'ccode' : 'EC', 'cname' : 'Ecuador'},
                    {'ccode' : 'EG', 'cname' : 'Egypt'},
                    {'ccode' : 'SV', 'cname' : 'El Salvador'},
                    {'ccode' : 'GQ', 'cname' : 'Equatorial Guinea'},
                    {'ccode' : 'ER', 'cname' : 'Eritrea'},
                    {'ccode' : 'EE', 'cname' : 'Estonia'},
                    {'ccode' : 'ET', 'cname' : 'Ethiopia'},
                    {'ccode' : 'FK', 'cname' : 'Falkland Islands (Malvinas)'},
                    {'ccode' : 'FO', 'cname' : 'Faroe Islands'},
                    {'ccode' : 'FJ', 'cname' : 'Fiji'},
                    {'ccode' : 'FI', 'cname' : 'Finland'},
                    {'ccode' : 'FR', 'cname' : 'France'},
                    {'ccode' : 'GF', 'cname' : 'French Guiana'},
                    {'ccode' : 'PF', 'cname' : 'French Polynesia'},
                    {'ccode' : 'TF', 'cname' : 'French Southern Territories'},
                    {'ccode' : 'GA', 'cname' : 'Gabon'},
                    {'ccode' : 'GM', 'cname' : 'Gambia'},
                    {'ccode' : 'GE', 'cname' : 'Georgia'},
                    {'ccode' : 'DE', 'cname' : 'Germany'},
                    {'ccode' : 'GH', 'cname' : 'Ghana'},
                    {'ccode' : 'GI', 'cname' : 'Gibraltar'},
                    {'ccode' : 'GR', 'cname' : 'Greece'},
                    {'ccode' : 'GL', 'cname' : 'Greenland'},
                    {'ccode' : 'GD', 'cname' : 'Grenada'},
                    {'ccode' : 'GP', 'cname' : 'Guadeloupe'},
                    {'ccode' : 'GU', 'cname' : 'Guam'},
                    {'ccode' : 'GT', 'cname' : 'Guatemala'},
                    {'ccode' : 'GG', 'cname' : 'Guernsey'},
                    {'ccode' : 'GN', 'cname' : 'Guinea'},
                    {'ccode' : 'GW', 'cname' : 'Guinea-Bissau'},
                    {'ccode' : 'GY', 'cname' : 'Guyana'},
                    {'ccode' : 'HT', 'cname' : 'Haiti'},
                    {'ccode' : 'HM', 'cname' : 'Heard Island & Mcdonald Islands'},
                    {'ccode' : 'VA', 'cname' : 'Holy See (Vatican City State)'},
                    {'ccode' : 'HN', 'cname' : 'Honduras'},
                    {'ccode' : 'HK', 'cname' : 'Hong Kong'},
                    {'ccode' : 'HU', 'cname' : 'Hungary'},
                    {'ccode' : 'IS', 'cname' : 'Iceland'},
                    {'ccode' : 'IN', 'cname' : 'India'},
                    {'ccode' : 'ID', 'cname' : 'Indonesia'},
                    {'ccode' : 'IR', 'cname' : 'Iran, Islamic Republic Of'},
                    {'ccode' : 'IQ', 'cname' : 'Iraq'},
                    {'ccode' : 'IE', 'cname' : 'Ireland'},
                    {'ccode' : 'IM', 'cname' : 'Isle Of Man'},
                    {'ccode' : 'IL', 'cname' : 'Israel'},
                    {'ccode' : 'IT', 'cname' : 'Italy'},
                    {'ccode' : 'JM', 'cname' : 'Jamaica'},
                    {'ccode' : 'JP', 'cname' : 'Japan'},
                    {'ccode' : 'JE', 'cname' : 'Jersey'},
                    {'ccode' : 'JO', 'cname' : 'Jordan'},
                    {'ccode' : 'KZ', 'cname' : 'Kazakhstan'},
                    {'ccode' : 'KE', 'cname' : 'Kenya'},
                    {'ccode' : 'KI', 'cname' : 'Kiribati'},
                    {'ccode' : 'KR', 'cname' : 'Korea'},
                    {'ccode' : 'KW', 'cname' : 'Kuwait'},
                    {'ccode' : 'KG', 'cname' : 'Kyrgyzstan'},
                    {'ccode' : 'LA', 'cname' : 'Lao People\'s Democratic Republic'},
                    {'ccode' : 'LV', 'cname' : 'Latvia'},
                    {'ccode' : 'LB', 'cname' : 'Lebanon'},
                    {'ccode' : 'LS', 'cname' : 'Lesotho'},
                    {'ccode' : 'LR', 'cname' : 'Liberia'},
                    {'ccode' : 'LY', 'cname' : 'Libyan Arab Jamahiriya'},
                    {'ccode' : 'LI', 'cname' : 'Liechtenstein'},
                    {'ccode' : 'LT', 'cname' : 'Lithuania'},
                    {'ccode' : 'LU', 'cname' : 'Luxembourg'},
                    {'ccode' : 'MO', 'cname' : 'Macao'},
                    {'ccode' : 'MK', 'cname' : 'Macedonia'},
                    {'ccode' : 'MG', 'cname' : 'Madagascar'},
                    {'ccode' : 'MW', 'cname' : 'Malawi'},
                    {'ccode' : 'MY', 'cname' : 'Malaysia'},
                    {'ccode' : 'MV', 'cname' : 'Maldives'},
                    {'ccode' : 'ML', 'cname' : 'Mali'},
                    {'ccode' : 'MT', 'cname' : 'Malta'},
                    {'ccode' : 'MH', 'cname' : 'Marshall Islands'},
                    {'ccode' : 'MQ', 'cname' : 'Martinique'},
                    {'ccode' : 'MR', 'cname' : 'Mauritania'},
                    {'ccode' : 'MU', 'cname' : 'Mauritius'},
                    {'ccode' : 'YT', 'cname' : 'Mayotte'},
                    {'ccode' : 'MX', 'cname' : 'Mexico'},
                    {'ccode' : 'FM', 'cname' : 'Micronesia, Federated States Of'},
                    {'ccode' : 'MD', 'cname' : 'Moldova'},
                    {'ccode' : 'MC', 'cname' : 'Monaco'},
                    {'ccode' : 'MN', 'cname' : 'Mongolia'},
                    {'ccode' : 'ME', 'cname' : 'Montenegro'},
                    {'ccode' : 'MS', 'cname' : 'Montserrat'},
                    {'ccode' : 'MA', 'cname' : 'Morocco'},
                    {'ccode' : 'MZ', 'cname' : 'Mozambique'},
                    {'ccode' : 'MM', 'cname' : 'Myanmar'},
                    {'ccode' : 'NA', 'cname' : 'Namibia'},
                    {'ccode' : 'NR', 'cname' : 'Nauru'},
                    {'ccode' : 'NP', 'cname' : 'Nepal'},
                    {'ccode' : 'NL', 'cname' : 'Netherlands'},
                    {'ccode' : 'AN', 'cname' : 'Netherlands Antilles'},
                    {'ccode' : 'NC', 'cname' : 'New Caledonia'},
                    {'ccode' : 'NZ', 'cname' : 'New Zealand'},
                    {'ccode' : 'NI', 'cname' : 'Nicaragua'},
                    {'ccode' : 'NE', 'cname' : 'Niger'},
                    {'ccode' : 'NG', 'cname' : 'Nigeria'},
                    {'ccode' : 'NU', 'cname' : 'Niue'},
                    {'ccode' : 'NF', 'cname' : 'Norfolk Island'},
                    {'ccode' : 'MP', 'cname' : 'Northern Mariana Islands'},
                    {'ccode' : 'NO', 'cname' : 'Norway'},
                    {'ccode' : 'OM', 'cname' : 'Oman'},
                    {'ccode' : 'PK', 'cname' : 'Pakistan'},
                    {'ccode' : 'PW', 'cname' : 'Palau'},
                    {'ccode' : 'PS', 'cname' : 'Palestinian Territory, Occupied'},
                    {'ccode' : 'PA', 'cname' : 'Panama'},
                    {'ccode' : 'PG', 'cname' : 'Papua New Guinea'},
                    {'ccode' : 'PY', 'cname' : 'Paraguay'},
                    {'ccode' : 'PE', 'cname' : 'Peru'},
                    {'ccode' : 'PH', 'cname' : 'Philippines'},
                    {'ccode' : 'PN', 'cname' : 'Pitcairn'},
                    {'ccode' : 'PL', 'cname' : 'Poland'},
                    {'ccode' : 'PT', 'cname' : 'Portugal'},
                    {'ccode' : 'PR', 'cname' : 'Puerto Rico'},
                    {'ccode' : 'QA', 'cname' : 'Qatar'},
                    {'ccode' : 'RE', 'cname' : 'Reunion'},
                    {'ccode' : 'RO', 'cname' : 'Romania'},
                    {'ccode' : 'RU', 'cname' : 'Russian Federation'},
                    {'ccode' : 'RW', 'cname' : 'Rwanda'},
                    {'ccode' : 'BL', 'cname' : 'Saint Barthelemy'},
                    {'ccode' : 'SH', 'cname' : 'Saint Helena'},
                    {'ccode' : 'KN', 'cname' : 'Saint Kitts And Nevis'},
                    {'ccode' : 'LC', 'cname' : 'Saint Lucia'},
                    {'ccode' : 'MF', 'cname' : 'Saint Martin'},
                    {'ccode' : 'PM', 'cname' : 'Saint Pierre And Miquelon'},
                    {'ccode' : 'VC', 'cname' : 'Saint Vincent And Grenadines'},
                    {'ccode' : 'WS', 'cname' : 'Samoa'},
                    {'ccode' : 'SM', 'cname' : 'San Marino'},
                    {'ccode' : 'ST', 'cname' : 'Sao Tome And Principe'},
                    {'ccode' : 'SA', 'cname' : 'Saudi Arabia'},
                    {'ccode' : 'SN', 'cname' : 'Senegal'},
                    {'ccode' : 'CS', 'cname' : 'Serbia'},
                    {'ccode' : 'SC', 'cname' : 'Seychelles'},
                    {'ccode' : 'SL', 'cname' : 'Sierra Leone'},
                    {'ccode' : 'SG', 'cname' : 'Singapore'},
                    {'ccode' : 'SK', 'cname' : 'Slovakia'},
                    {'ccode' : 'SI', 'cname' : 'Slovenia'},
                    {'ccode' : 'SB', 'cname' : 'Solomon Islands'},
                    {'ccode' : 'SO', 'cname' : 'Somalia'},
                    {'ccode' : 'ZA', 'cname' : 'South Africa'},
                    {'ccode' : 'GS', 'cname' : 'South Georgia And Sandwich Isl.'},
                    {'ccode' : 'ES', 'cname' : 'Spain'},
                    {'ccode' : 'LK', 'cname' : 'Sri Lanka'},
                    {'ccode' : 'SD', 'cname' : 'Sudan'},
                    {'ccode' : 'SR', 'cname' : 'Suriname'},
                    {'ccode' : 'SJ', 'cname' : 'Svalbard And Jan Mayen'},
                    {'ccode' : 'SZ', 'cname' : 'Swaziland'},
                    {'ccode' : 'SE', 'cname' : 'Sweden'},
                    {'ccode' : 'CH', 'cname' : 'Switzerland'},
                    {'ccode' : 'SY', 'cname' : 'Syrian Arab Republic'},
                    {'ccode' : 'TW', 'cname' : 'Taiwan'},
                    {'ccode' : 'TJ', 'cname' : 'Tajikistan'},
                    {'ccode' : 'TZ', 'cname' : 'Tanzania'},
                    {'ccode' : 'TH', 'cname' : 'Thailand'},
                    {'ccode' : 'TL', 'cname' : 'Timor-Leste'},
                    {'ccode' : 'TG', 'cname' : 'Togo'},
                    {'ccode' : 'TK', 'cname' : 'Tokelau'},
                    {'ccode' : 'TO', 'cname' : 'Tonga'},
                    {'ccode' : 'TT', 'cname' : 'Trinidad And Tobago'},
                    {'ccode' : 'TN', 'cname' : 'Tunisia'},
                    {'ccode' : 'TR', 'cname' : 'Turkey'},
                    {'ccode' : 'TM', 'cname' : 'Turkmenistan'},
                    {'ccode' : 'TC', 'cname' : 'Turks And Caicos Islands'},
                    {'ccode' : 'TV', 'cname' : 'Tuvalu'},
                    {'ccode' : 'UG', 'cname' : 'Uganda'},
                    {'ccode' : 'UA', 'cname' : 'Ukraine'},
                    {'ccode' : 'AE', 'cname' : 'United Arab Emirates'},
                    {'ccode' : 'GB', 'cname' : 'England'},
                    {'ccode' : 'US', 'cname' : 'United States'},
                    {'ccode' : 'UM', 'cname' : 'United States Outlying Islands'},
                    {'ccode' : 'UY', 'cname' : 'Uruguay'},
                    {'ccode' : 'UZ', 'cname' : 'Uzbekistan'},
                    {'ccode' : 'VU', 'cname' : 'Vanuatu'},
                    {'ccode' : 'VE', 'cname' : 'Venezuela'},
                    {'ccode' : 'VN', 'cname' : 'Viet Nam'},
                    {'ccode' : 'VG', 'cname' : 'Virgin Islands, British'},
                    {'ccode' : 'VI', 'cname' : 'Virgin Islands, U.S.'},
                    {'ccode' : 'WF', 'cname' : 'Wallis And Futuna'},
                    {'ccode' : 'EH', 'cname' : 'Western Sahara'},
                    {'ccode' : 'YE', 'cname' : 'Yemen'},
                    {'ccode' : 'ZM', 'cname' : 'Zambia'},
                    {'ccode' : 'ZW', 'cname' : 'Zimbabwe'}
                ],
                sub_color_set:[
                    {'color': '#c6d9ec', 'label': '1st Substitution'},
                    {'color': '#9fbedf', 'label': '2nd Substitution'},
                    {'color': '#79a6d2', 'label': '3rd Substitution'},
                    {'color': '#6699cc', 'label': '4th Substitution'},
                    {'color': '#538cc6', 'label': '5th Substitution'},
                    {'color': '#4080be', 'label': '6th Substitution'},
                    {'color': '#4080be', 'label': '7th Substitution'},
                    {'color': '#4080be', 'label': '8th Substitution'},
                    {'color': '#4080be', 'label': '9th Substitution'},
                    {'color': '#4080be', 'label': '10th Substitution'},
                    {'color': '#4080be', 'label': '8th Substitution'},
                    {'color': '#4080be', 'label': '9th Substitution'},
                    {'color': '#4080be', 'label': '10th Substitution'},
                ],
                s_role_set:[
                    {
                        "name": "4-3-1-2",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "CM", "CM", "CM", "AM", "CF", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "RM", "DM", "LM", "", "SS", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "4-3-3",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "CM", "CM", "CM", "RW", "CF", "LW"],
                        "alt_s_role":["", "RM", "", "", "LM", "RM", "DM", "LM", "", "", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "FWD", "FWD", "FWD"]
                    },
                    {
                        "name": "4-3-2-1",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "CM", "CM", "CM", "AM", "AM", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "RM", "DM", "LM", "", "SS", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "4-4-2",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "RM", "CM", "CM", "LM", "CF", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "RW", "DM", "DM", "LW", "SS", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "4-2-3-1",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "DM", "DM", "RM", "AM", "LM", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "CM", "CM", "RW", "", "LW", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "4-4-1-1",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "RM", "CM", "CM", "LM", "SS", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "RW", "DM", "DM", "LW", "AM", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "5-4-1",
                        "s_role":["GK", "RB", "CB", "CB", "CB", "LB", "RM", "CM", "CM", "LM", "CF"],
                        "alt_s_role":["", "RM", "", "", "", "LM", "RW", "DM", "DM", "LW", ""],
                        "alt_s_role1":["", "RW", "", "", "", "LW", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "3-4-1-2",
                        "s_role":["GK", "CB", "CB", "CB", "RM", "CM", "CM", "LM", "AM", "CF", "CF"],
                        "alt_s_role":["", "RB", "", "LB", "", "DM", "DM", "", "", "SS", ""],
                        "alt_s_role1":["", "", "", "", "", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "3-5-2",
                        "s_role":["GK", "CB", "CB", "CB", "RM", "CM", "CM", "CM", "LM", "CF", "CF"],
                        "alt_s_role":["", "RB", "", "LB", "RB", "DM", "DM", "DM", "LB", "SS", ""],
                        "alt_s_role1":["", "", "", "", "RW", "", "", "", "LW", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "3-5-1-1",
                        "s_role":["GK", "CB", "CB", "CB", "RM", "CM", "CM", "CM", "LM", "AM", "CF"],
                        "alt_s_role":["", "RB", "", "LB", "RB", "DM", "DM", "DM", "LB", "", ""],
                        "alt_s_role1":["", "", "", "", "RW", "", "", "", "LW", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "3-4-2-1",
                        "s_role":["GK", "CB", "CB", "CB", "RM", "CM", "CM", "LM", "AM", "AM", "CF"],
                        "alt_s_role":["", "RB", "", "LB", "", "DM", "DM", "", "", "SS", ""],
                        "alt_s_role1":["", "", "", "", "", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "5-3-2",
                        "s_role":["GK", "RB", "CB", "CB", "CB", "LB", "CM", "CM", "CM", "CF", "CF"],
                        "alt_s_role":["", "RM", "", "", "", "LM", "RM", "DM", "LM", "SS", ""],
                        "alt_s_role1":["", "RW", "", "", "", "LW", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "5-3-1-1",
                        "s_role":["GK", "RB", "CB", "CB", "CB", "LB", "CM", "CM", "CM", "AM", "CF"],
                        "alt_s_role":["", "RM", "", "", "", "LM", "RM", "DM", "LM", "", ""],
                        "alt_s_role1":["", "RW", "", "", "", "LW", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "4-5-1",
                        "s_role":["GK", "RB", "CB", "CB", "LB", "RM", "CM", "CM", "CM", "LM", "CF"],
                        "alt_s_role":["", "RM", "", "", "LM", "RW", "DM", "DM", "DM", "LW", ""],
                        "alt_s_role1":["", "RW", "", "", "LW", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "4-1-4-1",
                        "s_role":["GK", "CB", "CB", "CB", "CB", "DM", "RM", "CM", "CM", "LM", "CF"],
                        "alt_s_role":["", "RB", "", "", "LB", "CM", "AM", "AM", "AM", "AM", ""],
                        "alt_s_role1":["", "", "", "", "", "", "RW", "DM", "DM", "LW", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD"]
                    },
                    {
                        "name": "4-1-3-2",
                        "s_role":["GK", "CB", "CB", "CB", "CB", "DM", "AM", "AM", "AM", "CF", "CF"],
                        "alt_s_role":["", "RB", "", "", "LB", "CM", "RM", "", "LM", "SS", ""],
                        "alt_s_role1":["", "", "", "", "", "", "RW", "", "LW", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                    {
                        "name": "3-4-3",
                        "s_role":["GK", "CB", "CB", "CB", "RM", "CM", "CM", "LM", "RW", "CF", "LW"],
                        "alt_s_role":["", "RB", "", "LB", "CM", "DM", "DM", "CM", "", "", ""],
                        "alt_s_role1":["", "", "", "", "", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "FWD", "FWD", "FWD"]
                    },
                    {
                        "name": "3-1-4-2",
                        "s_role":["GK", "CB", "CB", "CB", "DM", "RM", "CM", "CM", "LM", "CF", "CF"],
                        "alt_s_role":["", "RB", "", "LB", "CM", "RW", "", "", "LW", "SS", ""],
                        "alt_s_role1":["", "", "", "", "", "", "", "", "", "", ""],
                        "mean_role":["GK", "DEF", "DEF", "DEF", "MID", "MID", "MID", "MID", "MID", "FWD", "FWD"]
                    },
                ],
                lineup_list:[
                    { value: '0', label: 'Auto'},
                    { value: '4-3-1-2', label: '4-3-1-2'},
                    { value: '4-3-3', label: '4-3-3'},
                    { value: '4-3-2-1', label: '4-3-2-1'},
                    { value: '4-4-2', label: '4-4-2'},
                    { value: '4-2-3-1', label: '4-2-3-1'},
                    { value: '4-4-1-1', label: '4-4-1-1'},
                    { value: '5-4-1', label: '5-4-1'},
                    { value: '3-4-1-2', label: '3-4-1-2'},
                    { value: '3-5-2', label: '3-5-2'},
                    { value: '3-5-1-1', label: '3-5-1-1'},
                    { value: '3-4-2-1', label: '3-4-2-1'},
                    { value: '5-3-2', label: '5-3-2'},
                    { value: '5-3-1-1', label: '5-3-1-1'},
                    { value: '4-5-1', label: '4-5-1'},
                    { value: '4-1-4-1', label: '4-1-4-1'},
                    { value: '4-1-3-2', label: '4-1-3-2'},
                    { value: '3-4-3', label: '3-4-3'},
                    { value: '3-1-4-2', label: '3-1-4-2'}
                ],
                selected_team: '',
                selected_direction: '',
                triger:{
                    "maxOddPre": null,
                    "minOddPre": null,
                    "maxOddLive": null,
                    "scoreHome": null,
                    "scoreAway": null,
                    "minTime": null,
                    "maxTime": null,
                    "matchStatus": null,
                    "alertName": null,
                    "onHome": null,
                    "offHome": null,
                    "onAway": null,
                    "offAway": null
                },
                pred_type_list:[
                    {"value": 10, "label": "- 1 - Lay"},
                    {"value": 1, "label": "- X - Lay"},
                    {"value": 2, "label": "- 2 - Lay"},
                    {"value": 3, "label": "- X - Back"},
                    {"value": 4, "label": "- O 0.5 - Back"},
                    {"value": 5, "label": "- O 1.5 - Back"},
                    {"value": 6, "label": "- O 2.5 - Back"},
                    {"value": 7, "label": "- U 2.5 - Back"},
                    {"value": 8, "label": "- U 3.5 - Back"}
                ],
                statusList:[
                    {"value": 0, "label": "All status"},
                    {"value": 1, "label": "Live"},
                    {"value": 2, "label": "Pre match"}
                ],
                alertArray: [],
                alertidArray: [],
                baseData: [],
                correctScoreList: [
                    {"value": 100, "label": "Select One"}
                ],
                currentCSR: [],
                CS_Odd_back_price: null,
                CS_Odd_back_stack: null,
                CS_Odd_lay_price: null,
                CS_Odd_lay_stack: null,
                CS_total_matched: null,
                currentCS_marketId: null,
                currentCS_selectionId: null,
                stakeToCover: null,
                cashoutTable: [],
                cashoutAlertName: "OFF",
                second_eventId: 0,
                cs_max_profit : 0,
                cs_max_lose : 0,
                cs_guad_max : 0,
                cs_percent_text1 : '',
                cs_percent_text2 : this.$t('Insert CS Odd and Stake'),
                cs_guad_att : 0,
                cs_percentTextColor : '#20a052',
                cs_percentTextColor1 : '#20a052',
                cs_percentBackgroundColor : '#d8e4bc',
                cs_percentBackgroundColor1 : '#d8e4bc',
                fixtureId: 0,
                //{{this.currency_list[this.mycurrency].currencySymbol}}
                currency_list: {
                    "ALL": {
                        "currencyName": "Albanian Lek",
                        "currencySymbol": "Lek",
                        "id": "ALL"
                    },
                    "XCD": {
                        "currencyName": "East Caribbean Dollar",
                        "currencySymbol": "$",
                        "id": "XCD"
                    },
                    "EUR": {
                        "currencyName": "Euro",
                        "currencySymbol": "€",
                        "id": "EUR"
                    },
                    "BBD": {
                        "currencyName": "Barbadian Dollar",
                        "currencySymbol": "$",
                        "id": "BBD"
                    },
                    "BTN": {
                        "currencyName": "Bhutanese Ngultrum",
                        "id": "BTN"
                    },
                    "BND": {
                        "currencyName": "Brunei Dollar",
                        "currencySymbol": "$",
                        "id": "BND"
                    },
                    
                    "CUP": {
                        "currencyName": "Cuban Peso",
                        "currencySymbol": "$",
                        "id": "CUP"
                    },
                    "USD": {
                        "currencyName": "United States Dollar",
                        "currencySymbol": "$",
                        "id": "USD"
                    },
                    "FKP": {
                        "currencyName": "Falkland Islands Pound",
                        "currencySymbol": "£",
                        "id": "FKP"
                    },
                    "GIP": {
                        "currencyName": "Gibraltar Pound",
                        "currencySymbol": "£",
                        "id": "GIP"
                    },
                    "HUF": {
                        "currencyName": "Hungarian Forint",
                        "currencySymbol": "Ft",
                        "id": "HUF"
                    },                    
                    "JMD": {
                        "currencyName": "Jamaican Dollar",
                        "currencySymbol": "J$",
                        "id": "JMD"
                    },
                    "AUD": {
                        "currencyName": "Australian Dollar",
                        "currencySymbol": "$",
                        "id": "AUD"
                    },
                    "LAK": {
                        "currencyName": "Lao Kip",
                        "currencySymbol": "₭",
                        "id": "LAK"
                    },
                    
                    "MKD": {
                        "currencyName": "Macedonian Denar",
                        "currencySymbol": "ден",
                        "id": "MKD"
                    },                    
                    "NZD": {
                        "currencyName": "New Zealand Dollar",
                        "currencySymbol": "$",
                        "id": "NZD"
                    },
                    "OMR": {
                        "currencyName": "Omani Rial",
                        "currencySymbol": "﷼",
                        "id": "OMR"
                    },
                    "PGK": {
                        "currencyName": "Papua New Guinean Kina",
                        "id": "PGK"
                    },
                    "RWF": {
                        "currencyName": "Rwandan Franc",
                        "id": "RWF"
                    },
                    "WST": {
                        "currencyName": "Samoan Tala",
                        "id": "WST"
                    },
                    "RSD": {
                        "currencyName": "Serbian Dinar",
                        "currencySymbol": "Дин.",
                        "id": "RSD"
                    },
                    "SEK": {
                        "currencyName": "Swedish Krona",
                        "currencySymbol": "kr",
                        "id": "SEK"
                    },
                    "TZS": {
                        "currencyName": "Tanzanian Shilling",
                        "currencySymbol": "TSh",
                        "id": "TZS"
                    },
                    "AMD": {
                        "currencyName": "Armenian Dram",
                        "id": "AMD"
                    },
                    "BSD": {
                        "currencyName": "Bahamian Dollar",
                        "currencySymbol": "$",
                        "id": "BSD"
                    },
                    "BAM": {
                        "currencyName": "Bosnia And Herzegovina Konvertibilna Marka",
                        "currencySymbol": "KM",
                        "id": "BAM"
                    },
                    "CVE": {
                        "currencyName": "Cape Verdean Escudo",
                        "id": "CVE"
                    },
                    "CNY": {
                        "currencyName": "Chinese Yuan",
                        "currencySymbol": "¥",
                        "id": "CNY"
                    },
                    "CRC": {
                        "currencyName": "Costa Rican Colon",
                        "currencySymbol": "₡",
                        "id": "CRC"
                    },
                    "CZK": {
                        "currencyName": "Czech Koruna",
                        "currencySymbol": "Kč",
                        "id": "CZK"
                    },
                    "ERN": {
                        "currencyName": "Eritrean Nakfa",
                        "id": "ERN"
                    },
                    "GEL": {
                        "currencyName": "Georgian Lari",
                        "id": "GEL"
                    },
                    "HTG": {
                        "currencyName": "Haitian Gourde",
                        "id": "HTG"
                    },
                    "INR": {
                        "currencyName": "Indian Rupee",
                        "currencySymbol": "₹",
                        "id": "INR"
                    },
                    "JOD": {
                        "currencyName": "Jordanian Dinar",
                        "id": "JOD"
                    },
                    "KRW": {
                        "currencyName": "South Korean Won",
                        "currencySymbol": "₩",
                        "id": "KRW"
                    },
                    "LBP": {
                        "currencyName": "Lebanese Lira",
                        "currencySymbol": "£",
                        "id": "LBP"
                    },
                    "MWK": {
                        "currencyName": "Malawian Kwacha",
                        "id": "MWK"
                    },
                    "MRO": {
                        "currencyName": "Mauritanian Ouguiya",
                        "id": "MRO"
                    },
                    "MZN": {
                        "currencyName": "Mozambican Metical",
                        "id": "MZN"
                    },
                    "ANG": {
                        "currencyName": "Netherlands Antillean Gulden",
                        "currencySymbol": "ƒ",
                        "id": "ANG"
                    },
                    "PEN": {
                        "currencyName": "Peruvian Nuevo Sol",
                        "currencySymbol": "S/.",
                        "id": "PEN"
                    },
                    "QAR": {
                        "currencyName": "Qatari Riyal",
                        "currencySymbol": "﷼",
                        "id": "QAR"
                    },
                    "STD": {
                        "currencyName": "Sao Tome And Principe Dobra",
                        "id": "STD"
                    },
                    "SLL": {
                        "currencyName": "Sierra Leonean Leone",
                        "id": "SLL"
                    },
                    "SOS": {
                        "currencyName": "Somali Shilling",
                        "currencySymbol": "S",
                        "id": "SOS"
                    },
                    "SDG": {
                        "currencyName": "Sudanese Pound",
                        "id": "SDG"
                    },
                    "SYP": {
                        "currencyName": "Syrian Pound",
                        "currencySymbol": "£",
                        "id": "SYP"
                    },
                    "AOA": {
                        "currencyName": "Angolan Kwanza",
                        "id": "AOA"
                    },
                    "AWG": {
                        "currencyName": "Aruban Florin",
                        "currencySymbol": "ƒ",
                        "id": "AWG"
                    },
                    "BHD": {
                        "currencyName": "Bahraini Dinar",
                        "id": "BHD"
                    },
                    "BZD": {
                        "currencyName": "Belize Dollar",
                        "currencySymbol": "BZ$",
                        "id": "BZD"
                    },
                    "BWP": {
                        "currencyName": "Botswana Pula",
                        "currencySymbol": "P",
                        "id": "BWP"
                    },
                    "BIF": {
                        "currencyName": "Burundi Franc",
                        "id": "BIF"
                    },
                    "KYD": {
                        "currencyName": "Cayman Islands Dollar",
                        "currencySymbol": "$",
                        "id": "KYD"
                    },
                    "COP": {
                        "currencyName": "Colombian Peso",
                        "currencySymbol": "$",
                        "id": "COP"
                    },
                    "DKK": {
                        "currencyName": "Danish Krone",
                        "currencySymbol": "kr",
                        "id": "DKK"
                    },
                    "GTQ": {
                        "currencyName": "Guatemalan Quetzal",
                        "currencySymbol": "Q",
                        "id": "GTQ"
                    },
                    "HNL": {
                        "currencyName": "Honduran Lempira",
                        "currencySymbol": "L",
                        "id": "HNL"
                    },
                    "IDR": {
                        "currencyName": "Indonesian Rupiah",
                        "currencySymbol": "Rp",
                        "id": "IDR"
                    },
                    "ILS": {
                        "currencyName": "Israeli New Sheqel",
                        "currencySymbol": "₪",
                        "id": "ILS"
                    },
                    "KZT": {
                        "currencyName": "Kazakhstani Tenge",
                        "currencySymbol": "лв",
                        "id": "KZT"
                    },
                    "KWD": {
                        "currencyName": "Kuwaiti Dinar",
                        "id": "KWD"
                    },
                    "LSL": {
                        "currencyName": "Lesotho Loti",
                        "id": "LSL"
                    },
                    "MYR": {
                        "currencyName": "Malaysian Ringgit",
                        "currencySymbol": "RM",
                        "id": "MYR"
                    },
                    "MUR": {
                        "currencyName": "Mauritian Rupee",
                        "currencySymbol": "₨",
                        "id": "MUR"
                    },
                    "MNT": {
                        "currencyName": "Mongolian Tugrik",
                        "currencySymbol": "₮",
                        "id": "MNT"
                    },
                    "MMK": {
                        "currencyName": "Myanma Kyat",
                        "id": "MMK"
                    },
                    "NGN": {
                        "currencyName": "Nigerian Naira",
                        "currencySymbol": "₦",
                        "id": "NGN"
                    },
                    "PAB": {
                        "currencyName": "Panamanian Balboa",
                        "currencySymbol": "B/.",
                        "id": "PAB"
                    },
                    "PHP": {
                        "currencyName": "Philippine Peso",
                        "currencySymbol": "₱",
                        "id": "PHP"
                    },
                    "RON": {
                        "currencyName": "Romanian Leu",
                        "currencySymbol": "lei",
                        "id": "RON"
                    },
                    "SAR": {
                        "currencyName": "Saudi Riyal",
                        "currencySymbol": "﷼",
                        "id": "SAR"
                    },
                    "SGD": {
                        "currencyName": "Singapore Dollar",
                        "currencySymbol": "$",
                        "id": "SGD"
                    },
                    "ZAR": {
                        "currencyName": "South African Rand",
                        "currencySymbol": "R",
                        "id": "ZAR"
                    },
                    "SRD": {
                        "currencyName": "Surinamese Dollar",
                        "currencySymbol": "$",
                        "id": "SRD"
                    },
                    "TWD": {
                        "currencyName": "New Taiwan Dollar",
                        "currencySymbol": "NT$",
                        "id": "TWD"
                    },
                    "TOP": {
                        "currencyName": "Paanga",
                        "id": "TOP"
                    },
                    "VEF": {
                        "currencyName": "Venezuelan Bolivar",
                        "id": "VEF"
                    },
                    "DZD": {
                        "currencyName": "Algerian Dinar",
                        "id": "DZD"
                    },
                    "ARS": {
                        "currencyName": "Argentine Peso",
                        "currencySymbol": "$",
                        "id": "ARS"
                    },
                    "AZN": {
                        "currencyName": "Azerbaijani Manat",
                        "currencySymbol": "ман",
                        "id": "AZN"
                    },
                    "BYR": {
                        "currencyName": "Belarusian Ruble",
                        "currencySymbol": "p.",
                        "id": "BYR"
                    },
                    "BOB": {
                        "currencyName": "Bolivian Boliviano",
                        "currencySymbol": "$b",
                        "id": "BOB"
                    },
                    "BGN": {
                        "currencyName": "Bulgarian Lev",
                        "currencySymbol": "лв",
                        "id": "BGN"
                    },
                    "CAD": {
                        "currencyName": "Canadian Dollar",
                        "currencySymbol": "$",
                        "id": "CAD"
                    },
                    "CLP": {
                        "currencyName": "Chilean Peso",
                        "currencySymbol": "$",
                        "id": "CLP"
                    },
                    "CDF": {
                        "currencyName": "Congolese Franc",
                        "id": "CDF"
                    },
                    "DOP": {
                        "currencyName": "Dominican Peso",
                        "currencySymbol": "RD$",
                        "id": "DOP"
                    },
                    "FJD": {
                        "currencyName": "Fijian Dollar",
                        "currencySymbol": "$",
                        "id": "FJD"
                    },
                    "GMD": {
                        "currencyName": "Gambian Dalasi",
                        "id": "GMD"
                    },
                    "GYD": {
                        "currencyName": "Guyanese Dollar",
                        "currencySymbol": "$",
                        "id": "GYD"
                    },
                    "ISK": {
                        "currencyName": "Icelandic Króna",
                        "currencySymbol": "kr",
                        "id": "ISK"
                    },
                    "IQD": {
                        "currencyName": "Iraqi Dinar",
                        "id": "IQD"
                    },
                    "JPY": {
                        "currencyName": "Japanese Yen",
                        "currencySymbol": "¥",
                        "id": "JPY"
                    },
                    "KPW": {
                        "currencyName": "North Korean Won",
                        "currencySymbol": "₩",
                        "id": "KPW"
                    },
                    "LVL": {
                        "currencyName": "Latvian Lats",
                        "currencySymbol": "Ls",
                        "id": "LVL"
                    },
                    "CHF": {
                        "currencyName": "Swiss Franc",
                        "currencySymbol": "Fr.",
                        "id": "CHF"
                    },
                    "MGA": {
                        "currencyName": "Malagasy Ariary",
                        "id": "MGA"
                    },
                    "MDL": {
                        "currencyName": "Moldovan Leu",
                        "id": "MDL"
                    },
                    "MAD": {
                        "currencyName": "Moroccan Dirham",
                        "id": "MAD"
                    },
                    "NPR": {
                        "currencyName": "Nepalese Rupee",
                        "currencySymbol": "₨",
                        "id": "NPR"
                    },
                    "NIO": {
                        "currencyName": "Nicaraguan Cordoba",
                        "currencySymbol": "C$",
                        "id": "NIO"
                    },
                    "PKR": {
                        "currencyName": "Pakistani Rupee",
                        "currencySymbol": "₨",
                        "id": "PKR"
                    },
                    "PYG": {
                        "currencyName": "Paraguayan Guarani",
                        "currencySymbol": "Gs",
                        "id": "PYG"
                    },
                    "SHP": {
                        "currencyName": "Saint Helena Pound",
                        "currencySymbol": "£",
                        "id": "SHP"
                    },
                    "SCR": {
                        "currencyName": "Seychellois Rupee",
                        "currencySymbol": "₨",
                        "id": "SCR"
                    },
                    "SBD": {
                        "currencyName": "Solomon Islands Dollar",
                        "currencySymbol": "$",
                        "id": "SBD"
                    },
                    "LKR": {
                        "currencyName": "Sri Lankan Rupee",
                        "currencySymbol": "₨",
                        "id": "LKR"
                    },
                    "THB": {
                        "currencyName": "Thai Baht",
                        "currencySymbol": "฿",
                        "id": "THB"
                    },
                    "TRY": {
                        "currencyName": "Turkish New Lira",
                        "id": "TRY"
                    },
                    "AED": {
                        "currencyName": "UAE Dirham",
                        "id": "AED"
                    },
                    "VUV": {
                        "currencyName": "Vanuatu Vatu",
                        "id": "VUV"
                    },
                    "YER": {
                        "currencyName": "Yemeni Rial",
                        "currencySymbol": "﷼",
                        "id": "YER"
                    },
                    "AFN": {
                        "currencyName": "Afghan Afghani",
                        "currencySymbol": "؋",
                        "id": "AFN"
                    },
                    "BDT": {
                        "currencyName": "Bangladeshi Taka",
                        "id": "BDT"
                    },
                    "BRL": {
                        "currencyName": "Brazilian Real",
                        "currencySymbol": "R$",
                        "id": "BRL"
                    },
                    "KHR": {
                        "currencyName": "Cambodian Riel",
                        "currencySymbol": "៛",
                        "id": "KHR"
                    },
                    "KMF": {
                        "currencyName": "Comorian Franc",
                        "id": "KMF"
                    },
                    "HRK": {
                        "currencyName": "Croatian Kuna",
                        "currencySymbol": "kn",
                        "id": "HRK"
                    },
                    "DJF": {
                        "currencyName": "Djiboutian Franc",
                        "id": "DJF"
                    },
                    "EGP": {
                        "currencyName": "Egyptian Pound",
                        "currencySymbol": "£",
                        "id": "EGP"
                    },
                    "ETB": {
                        "currencyName": "Ethiopian Birr",
                        "id": "ETB"
                    },
                    "XPF": {
                        "currencyName": "CFP Franc",
                        "id": "XPF"
                    },
                    "GHS": {
                        "currencyName": "Ghanaian Cedi",
                        "id": "GHS"
                    },
                    "GNF": {
                        "currencyName": "Guinean Franc",
                        "id": "GNF"
                    },
                    "HKD": {
                        "currencyName": "Hong Kong Dollar",
                        "currencySymbol": "$",
                        "id": "HKD"
                    },
                    "XDR": {
                        "currencyName": "Special Drawing Rights",
                        "id": "XDR"
                    },
                    "KES": {
                        "currencyName": "Kenyan Shilling",
                        "currencySymbol": "KSh",
                        "id": "KES"
                    },
                    "KGS": {
                        "currencyName": "Kyrgyzstani Som",
                        "currencySymbol": "лв",
                        "id": "KGS"
                    },
                    "LRD": {
                        "currencyName": "Liberian Dollar",
                        "currencySymbol": "$",
                        "id": "LRD"
                    },
                    "MOP": {
                        "currencyName": "Macanese Pataca",
                        "id": "MOP"
                    },
                    "MVR": {
                        "currencyName": "Maldivian Rufiyaa",
                        "id": "MVR"
                    },
                    "MXN": {
                        "currencyName": "Mexican Peso",
                        "currencySymbol": "$",
                        "id": "MXN"
                    },
                    "NAD": {
                        "currencyName": "Namibian Dollar",
                        "currencySymbol": "$",
                        "id": "NAD"
                    },
                    "NOK": {
                        "currencyName": "Norwegian Krone",
                        "currencySymbol": "kr",
                        "id": "NOK"
                    },
                    "PLN": {
                        "currencyName": "Polish Zloty",
                        "currencySymbol": "zł",
                        "id": "PLN"
                    },
                    "RUB": {
                        "currencyName": "Russian Ruble",
                        "currencySymbol": "руб",
                        "id": "RUB"
                    },
                    "SZL": {
                        "currencyName": "Swazi Lilangeni",
                        "id": "SZL"
                    },
                    "TJS": {
                        "currencyName": "Tajikistani Somoni",
                        "id": "TJS"
                    },
                    "TTD": {
                        "currencyName": "Trinidad and Tobago Dollar",
                        "currencySymbol": "TT$",
                        "id": "TTD"
                    },
                    "UGX": {
                        "currencyName": "Ugandan Shilling",
                        "currencySymbol": "USh",
                        "id": "UGX"
                    },
                    "UYU": {
                        "currencyName": "Uruguayan Peso",
                        "currencySymbol": "$U",
                        "id": "UYU"
                    },
                    "VND": {
                        "currencyName": "Vietnamese Dong",
                        "currencySymbol": "₫",
                        "id": "VND"
                    },
                    "TND": {
                        "currencyName": "Tunisian Dinar",
                        "id": "TND"
                    },
                    "UAH": {
                        "currencyName": "Ukrainian Hryvnia",
                        "currencySymbol": "₴",
                        "id": "UAH"
                    },
                    "UZS": {
                        "currencyName": "Uzbekistani Som",
                        "currencySymbol": "лв",
                        "id": "UZS"
                    },
                    "TMT": {
                        "currencyName": "Turkmenistan Manat",
                        "id": "TMT"
                    },
                    "GBP": {
                        "currencyName": "British Pound",
                        "currencySymbol": "£",
                        "id": "GBP"
                    },
                    "ZMW": {
                        "currencyName": "Zambian Kwacha",
                        "id": "ZMW"
                    },
                    "BTC": {
                        "currencyName": "Bitcoin",
                        "currencySymbol": "BTC",
                        "id": "BTC"
                    },
                    "BYN": {
                        "currencyName": "New Belarusian Ruble",
                        "currencySymbol": "p.",
                        "id": "BYN"
                    },
                    "BMD": {
                        "currencyName": "Bermudan Dollar",
                        "id": "BMD"
                    },
                    "GGP": {
                        "currencyName": "Guernsey Pound",
                        "id": "GGP"
                    },
                    "CLF": {
                        "currencyName": "Chilean Unit Of Account",
                        "id": "CLF"
                    },
                    "CUC": {
                        "currencyName": "Cuban Convertible Peso",
                        "id": "CUC"
                    },
                    "IMP": {
                        "currencyName": "Manx pound",
                        "id": "IMP"
                    },
                    "JEP": {
                        "currencyName": "Jersey Pound",
                        "id": "JEP"
                    },
                    "SVC": {
                        "currencyName": "Salvadoran Colón",
                        "id": "SVC"
                    },
                    "ZMK": {
                        "currencyName": "Old Zambian Kwacha",
                        "id": "ZMK"
                    },
                    "XAG": {
                        "currencyName": "Silver (troy ounce)",
                        "id": "XAG"
                    },
                    "ZWL": {
                        "currencyName": "Zimbabwean Dollar",
                        "id": "ZWL"
                    }   
                }
            }
        },
        methods:{
            get_trueodds_value(odds, stat) {
                var true_odd = 100 / stat;
                var value = ( (odds - 1) * 100 / (true_odd - 1) ) - 100
                return [true_odd, value]
            },
            // Methods for the Opening Modal (showModal_ and hideModal_)
            showModal_() {
                this.isModalVisible = true;
                this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow');
            },

            hideModal_() {
                if (!this.isModalVisible) {
                    console.warn('Opening modal is already hidden');
                    return;
                }

                const timeoutDuration = 20000;
                const timeoutId = setTimeout(() => {
                    this.isModalVisible = false;
                    console.log('Opening modal hidden due to timeout');
                }, timeoutDuration);

                this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow');

                this.$root.$on('bv::hidden::modal', () => {
                    clearTimeout(timeoutId);
                    this.isModalVisible = false;
                    console.log('Opening modal hidden successfully');
                });
            },

            showModal_2() {
                // Clear any existing event listeners and timers to prevent duplication
                this.$root.$off('bv::hidden::modal');
                clearTimeout(this.frequentModalTimer);

                this.isModal2Visible = true;
                this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow'); // Show modal

                // Start a timer to auto-hide the modal after max duration
                const maxDuration = 3000;
                this.frequentModalTimer = setTimeout(() => {
                    if (this.isModal2Visible) {
                        this.isModal2Visible = false;
                        this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow'); // Hide modal
                        console.log('Frequent modal automatically hidden after max duration');
                    }
                }, maxDuration);
            },

            hideModal_2() {
                if (!this.isModal2Visible) {
                    console.warn('Frequent modal is already hidden');
                    return;
                }

                // Clear any existing event listeners and timers to avoid stacking
                this.$root.$off('bv::hidden::modal');
                clearTimeout(this.frequentModalTimer);

                // Emit the hide event and set listener for successful hiding
                this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow');

                // Listen for when the modal is successfully hidden and reset visibility
                this.$root.$on('bv::hidden::modal', () => {
                    this.isModal2Visible = false;
                    clearTimeout(this.frequentModalTimer); // Clear timer just in case
                    console.log('Frequent modal hidden successfully');
                });
            },
        
            start_socket() {
                this.gameList1 = this.gameList
                let self = this
                this.sockets.subscribe('UpdateOdds', (data) => {
                    for(let i = 0 ; i < self.mainList.length; i++){
                        let marketsNode = self.mainList[i].markets
                        for(let j = 0; j < marketsNode.length; j++){
                            for(let k = 0; k < data.length; k++){
                                if(marketsNode[j].marketId == data[k].marketId){
                                    self.mainList[i].markets[j].inplay = data[k].inplay
                                    self.mainList[i].markets[j].runners = data[k].runners
                                    self.mainList[i].markets[j].state = data[k].state
                                }
                                if(self.marketId == data[k].marketId){
                                    self.odd_calc(this.calc_odd)
                                    let selections = data[k].runners.filter(function(runner) {
                                        return runner.selectionId == self.selectionId;
                                    });
                                    if(data[k].state.status == 'SUSPENDED'){
                                        this.marketStatus = 'SUSPENDED'
                                    }
                                    else if(data[k].state.status == "CLOSED"){
                                        this.marketStatus = 'CLOSED'
                                    }
                                    else if(data[k].state.status == "OPEN"){
                                        this.marketStatus =''
                                    }
                                    if(selections[0].exchange.availableToBack){
                                        self.back = selections[0].exchange.availableToBack[0].price ||''
                                        self.back_matched = selections[0].exchange.availableToBack[0].size || 0
                                    }
                                    else{
                                        self.back =''
                                        self.back_matched = 0
                                    }

                                    if(selections[0].exchange.availableToLay){
                                        self.lay = selections[0].exchange.availableToLay[0].price ||''
                                        self.lay_matched = selections[0].exchange.availableToLay[0].size || 0
                                    }
                                    else{
                                        self.lay =''
                                        self.lay_matched = 0
                                    }
                                    self.total_matched = (data[k].state.totalMatched).toFixed(1)
                                    if(data[k].inplay == false){
                                        let runnerNo = parseInt(this.selectedArray[6])
                                        if(runnerNo == 0){
                                            self.prematchOdd = self.back
                                        }
                                        else{
                                            self.prematchOdd = self.lay
                                        }
                                    }
                                }
                                if(self.currentCS_marketId == data[k].marketId){
                                    this.CS_total_matched = (data[k].state.totalMatched).toFixed(2)
                                    let currentRunner = data[k].runners.filter(function(item) {
                                        return item.selectionId == self.currentCS_selectionId
                                    });
                                    if(currentRunner.length > 0){
                                        if(currentRunner[0].exchange.availableToBack){
                                            if(currentRunner[0].exchange.availableToBack.length > 0){
                                                this.CS_Odd_back_price = currentRunner[0].exchange.availableToBack[0].price
                                                this.CS_Odd_back_stack = currentRunner[0].exchange.availableToBack[0].size
                                            }
                                        }
                                        if(currentRunner[0].exchange.availableToLay){
                                            if(currentRunner[0].exchange.availableToLay.length > 0){
                                                this.CS_Odd_lay_price = currentRunner[0].exchange.availableToLay[0].price
                                                this.CS_Odd_lay_stack = currentRunner[0].exchange.availableToLay[0].size
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    //------------------alert update part---------------------
                    //console.log('eventarrays before load',this.alertArray.length,  this.alertArray)
                    
                    //console.log('--------------------------------------')
                    var alertidArray = []
                    for (var i = 0; i < this.alertArray.length; i++) {
                        alertidArray.push(this.alertArray[i].name + this.alertArray[i].alertName)
                    }
                    //console.log('alertidArray',this.alertidArray)
                    self.alertArray = []
                    //console.log('eventarrays after load',this.alertArray.length, this.alertArray)
                    //console.log("alert part by Odd==>")
                    if(this.calc_odd != 0 && this.calc_stake != 0 && this.eventId != 0){
                        if(this.riskTrading == 'auto'){
                            //console.log("===>auto Trading Check==>", val1)
                            let val1 = this.selectedValue
                            let eventId = parseInt(val1.split(',')[1])
                            let marketType = val1.split(',')[2]
                            let team = val1.split(',')[3]
                            let runnerNo = val1.split(',')[6]
                            let pred = ""
                            let self = this
                            if(marketType == 'MATCH_ODDS'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- 1 - Back'
                                    }
                                    else{
                                        pred = '- 1 - Lay'
                                    }
                                }
                                else if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- 2 - Back'
                                    }
                                    else{
                                        pred = '- 2 - Lay'
                                    }
                                }
                                else if(team == '2'){
                                    if(runnerNo == '0'){
                                        pred = '- X - Back'
                                    }
                                    else{
                                        pred = '- X - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_05'){
                                if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- O 0.5 - Back'
                                    }
                                    else{
                                        pred = '- O 0.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_15'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 1.5 - Back'
                                    }
                                    else{
                                        pred = '- U 1.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 1.5 - Back'
                                    }
                                    else{
                                        pred = '- O 1.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_25'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 2.5 - Back'
                                    }
                                    else{
                                        pred = '- U 2.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 2.5 - Back'
                                    }
                                    else{
                                        pred = '- O 2.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_35'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 3.5 - Back'
                                    }
                                    else{
                                        pred = '- U 3.5 - Lay'
                                    }
                                }
                            }
                            let predT = self.pred_type_list.filter(function(item) {
                                return item.label == pred
                            })
                            //console.log('predT====>', predT, pred, self.cashoutTable)
                            if(predT.length > 0){
                                for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                    if(predT[0].value == self.cashoutTable[k].PredType.value){
                                        let triger = {
                                            "maxOddPre": 1000000,
                                            "minOddPre": 0,
                                            "maxOddLive": 1000000,
                                            "minOddLive": 0,
                                            "minscoreHome": 0,
                                            "maxscoreHome": 100,
                                            "minscoreAway": 0,
                                            "maxscoreAway": 100,
                                            "min_total_goal": 0,
                                            "max_total_goal": 100,
                                            "minTime": 0,
                                            "maxTime": 150,
                                            "matchStatus": 0,
                                            "alertName": null,
                                            "minonHome": 0,
                                            "maxonHome": 100,
                                            "minoffHome": 0,
                                            "maxoffHome": 100,
                                            "minonAway": 0,
                                            "maxonAway": 100,
                                            "minoffAway": 0,
                                            "maxoffAway": 100,
                                            "min_profit": -1000,
                                            "max_profit": 1000000000,
                                            "stop_loss": false,
                                            "tradingMode": false
                                        }
                                        if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                            triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                            triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                            triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                        }
                                        if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                            triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                        }
                                        if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                            triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                        }
                                        if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                            triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                        }
                                        if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                            triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                        }
                                        if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                            triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                        }
                                        if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                            triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                            triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                            triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                        }
                                        if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                            triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                        }
                                        if(self.cashoutTable[k].MatchStatus.value != null){
                                            triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                        }
                                        if(self.cashoutTable[k].Alert_Name.value != null){
                                            triger.alertName = self.cashoutTable[k].Alert_Name.value
                                        }
                                        if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                            triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                        }
                                        if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                            triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                        }
                                        if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                            triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                        }
                                        if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                            triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                        }
                                        if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                            triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                        }
                                        if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                            triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                        }
                                        if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                            triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                        }
                                        if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                            triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                        }
                                        if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                            triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                        }
                                        if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                            triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                        }
                                        if(self.cashoutTable[k].stop_loss.value != false){
                                            triger.stop_loss = true
                                        }
                                        if(self.cashoutTable[k].tradingMode.value != false){
                                            triger.tradingMode = true
                                        }
                                        for(let j = 0; j < self.mainList.length; j++){
                                            if(eventId == self.mainList[j].eventId){
                                                if (self.mainList[j].DailyApiEvents1.length == 0)
                                                    continue
                                                let eventTriger = {
                                                    "name": self.selectedLabel,
                                                    "oddPre": null,
                                                    "oddLive": null,
                                                    "scoreHome": 0,
                                                    "scoreAway": 0,
                                                    "total_goal": 0,
                                                    "min_total_goal": 0,
                                                    "max_total_goal": 0,
                                                    "time": 0,
                                                    "matchStatus": null,
                                                    "alertName": self.cashoutAlertName,
                                                    "onHome": 0,
                                                    "offHome": 0,
                                                    "onAway": 0,
                                                    "offAway": 0,
                                                    "c_color": "green",
                                                    "profit": parseFloat(this.currentPercent),
                                                    "stop_loss": self.stopLoss,
                                                    "tradingMode": self.tradingMode
                                                }
                                                let eventNode = self.mainList[j]
                                                if(eventNode.score){
                                                    let scoreDetail = eventNode.score
                                                    eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                    eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                    eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                }
                                                if(eventNode.status){
                                                    eventTriger.matchStatus = 1
                                                    eventTriger.time = eventNode.timeElapsed
                                                }
                                                else if(!eventNode.status){
                                                    eventTriger.matchStatus = 0
                                                }
                                                for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                    let marketNode = self.mainList[j].markets[c]
                                                    let check = 0
                                                    if(marketNode.marketType == marketType){
                                                        if(marketNode.state){
                                                            if(marketNode.state.status == "CLOSED"){
                                                                eventTriger.matchStatus = 0
                                                                check = 1
                                                            }
                                                        }
                                                        if(check === 0){
                                                            let runnerNode = marketNode.runners[team]
                                                            let prematchMarket = null
                                                            if(self.mainList[j].markets[c].prematchMarket){
                                                                prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                            }
                                                            if(eventNode.status && prematchMarket != null){
                                                                let runnerlists = prematchMarket.runners[team]
                                                                if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                }
                                                                if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToBack){
                                                                    if(runnerNo == 0){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                if(runnerNode.exchange.availableToLay){
                                                                    if(runnerNo == 1){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                            if(runnerNo == 0){
                                                                if(runnerNode.exchange.availableToBack){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToLay){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                let liveStatsNode = self.mainList[j].livestatus
                                                let liveNode = liveStatsNode.stats
                                                if(liveStatsNode.stats){
                                                    if(liveStatsNode.stats.length > 1){
                                                        if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                            if(liveStatsNode.stats[0].shots != null){
                                                                eventTriger.onHome = liveNode[0].shots.ongoal
                                                                eventTriger.offHome = liveNode[0].shots.offgoal
                                                                eventTriger.onAway = liveNode[1].shots.ongoal
                                                                eventTriger.offAway = liveNode[1].shots.offgoal
                                                            }
                                                        }
                                                        else{
                                                            if(liveStatsNode.stats[1].shots != null){
                                                                eventTriger.onHome = liveNode[1].shots.ongoal
                                                                eventTriger.offHome = liveNode[1].shots.offgoal
                                                                eventTriger.onAway = liveNode[0].shots.ongoal
                                                                eventTriger.offAway = liveNode[0].shots.offgoal
                                                            }
                                                        }
                                                    }
                                                }
                                                //console.log('****************************cash out message check cond= >', triger)
                                                //console.log('****************************cash out message check value= >', eventTriger)
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                            if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                if(triger.alertName == eventTriger.alertName){
                                                                                                    this.percentTextColor1 = '#000'
                                                                                                    this.percentBackgroundColor = '#ffc000'
                                                                                                    this.percent_text1 = 'Cash Out Now! '
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    for(let i = 1 ; i < self.eventLists3.length ; i++){
                        // //console.log('self.prediction list console=>', self.eventLists3[i].label)
                        let val1 = self.eventLists3[i].value
                        let eventId = parseInt(val1.split(',')[1])
                        let marketType = val1.split(',')[2]
                        let team = val1.split(',')[3]
                        let runnerNo = val1.split(',')[6]
                        let pred = ""

                        if(marketType == 'MATCH_ODDS'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- 1 - Back'
                                }
                                else{
                                    pred = '- 1 - Lay'
                                }
                            }
                            else if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- 2 - Back'
                                }
                                else{
                                    pred = '- 2 - Lay'
                                }
                            }
                            else if(team == '2'){
                                if(runnerNo == '0'){
                                    pred = '- X - Back'
                                }
                                else{
                                    pred = '- X - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_05'){
                            if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- O 0.5 - Back'
                                }
                                else{
                                    pred = '- O 0.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_15'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 1.5 - Back'
                                }
                                else{
                                    pred = '- U 1.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 1.5 - Back'
                                }
                                else{
                                    pred = '- O 1.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_25'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 2.5 - Back'
                                }
                                else{
                                    pred = '- U 2.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 2.5 - Back'
                                }
                                else{
                                    pred = '- O 2.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_35'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 3.5 - Back'
                                }
                                else{
                                    pred = '- U 3.5 - Lay'
                                }
                            }
                        }
                        let predT = self.pred_type_list.filter(function(item) {
                            return item.label == pred
                        })
                        if(predT.length > 0){
                            for(let k = 0 ; k < self.adminTable1.length ; k++){
                                if(predT[0].value == self.adminTable1[k].PredType.value){
                                    let triger = {
                                        "maxOddPre": 1000000,
                                        "minOddPre": 0,
                                        "maxOddLive": 1000000,
                                        "minOddLive": 0,
                                        "minscoreHome": 0,
                                        "maxscoreHome": 100,
                                        "minscoreAway": 0,
                                        "maxscoreAway": 100,
                                        "min_total_goal": 0,
                                        "max_total_goal": 100,
                                        "minTime": 0,
                                        "maxTime": 150,
                                        "matchStatus": 0,
                                        "alertName": null,
                                        "minonHome": 0,
                                        "maxonHome": 100,
                                        "minoffHome": 0,
                                        "maxoffHome": 100,
                                        "minonAway": 0,
                                        "maxonAway": 100,
                                        "minoffAway": 0,
                                        "maxoffAway": 100,
                                        "switch_f": 100,
                                        "hold_on": 100
                                    }
                                    if(self.adminTable1[k].maxOddpre.value != null && self.adminTable1[k].maxOddpre.value != ""){
                                        triger.maxOddPre = parseFloat(self.adminTable1[k].maxOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddpre.value != null && self.adminTable1[k].minOddpre.value != ""){
                                        triger.minOddPre = parseFloat(self.adminTable1[k].minOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddlive.value != null && self.adminTable1[k].minOddlive.value != ""){
                                        triger.minOddLive = parseFloat(self.adminTable1[k].minOddlive.value)
                                    }
                                    if(self.adminTable1[k].maxoddlive.value != null && self.adminTable1[k].maxoddlive.value != ""){
                                        triger.maxOddLive = parseFloat(self.adminTable1[k].maxoddlive.value)
                                    }
                                    if(self.adminTable1[k].min_score_home.value != null && self.adminTable1[k].min_score_home.value != ""){
                                        triger.minscoreHome = parseFloat(self.adminTable1[k].min_score_home.value)
                                    }
                                    if(self.adminTable1[k].max_score_home.value != null && self.adminTable1[k].max_score_home.value != ""){
                                        triger.maxscoreHome = parseFloat(self.adminTable1[k].max_score_home.value)
                                    }
                                    if(self.adminTable1[k].min_score_away.value != null && self.adminTable1[k].min_score_away.value != ""){
                                        triger.minscoreAway = parseFloat(self.adminTable1[k].min_score_away.value)
                                    }
                                    if(self.adminTable1[k].max_score_away.value != null && self.adminTable1[k].max_score_away.value != ""){
                                        triger.maxscoreAway = parseFloat(self.adminTable1[k].max_score_away.value)
                                    }
                                    if(self.adminTable1[k].min_total_goal.value != null && self.adminTable1[k].min_total_goal.value != ""){
                                        triger.min_total_goal = parseFloat(self.adminTable1[k].min_total_goal.value)
                                    }
                                    if(self.adminTable1[k].max_total_goal.value != null && self.adminTable1[k].max_total_goal.value != ""){
                                        triger.max_total_goal = parseFloat(self.adminTable1[k].max_total_goal.value)
                                    }
                                    if(self.adminTable1[k].min_time.value != null && self.adminTable1[k].min_time.value != ""){
                                        triger.minTime = parseInt(self.adminTable1[k].min_time.value)
                                    }
                                    if(self.adminTable1[k].max_time.value != null && self.adminTable1[k].max_time.value != ""){
                                        triger.maxTime = parseInt(self.adminTable1[k].max_time.value)
                                    }
                                    if(self.adminTable1[k].MatchStatus.value != null){
                                        triger.matchStatus = self.adminTable1[k].MatchStatus.value
                                    }
                                    if(self.adminTable1[k].Alert_Name.value != null){
                                        triger.alertName = self.adminTable1[k].Alert_Name.value
                                    }
                                    if(self.adminTable1[k].min_on_home.value != null && self.adminTable1[k].min_on_home.value != ""){
                                        triger.minonHome = parseInt(self.adminTable1[k].min_on_home.value)
                                    }
                                    if(self.adminTable1[k].max_on_home.value != null && self.adminTable1[k].max_on_home.value != ""){
                                        triger.maxonHome = parseInt(self.adminTable1[k].max_on_home.value)
                                    }
                                    if(self.adminTable1[k].min_off_home.value != null && self.adminTable1[k].min_off_home.value != ""){
                                        triger.minoffHome = parseInt(self.adminTable1[k].min_off_home.value)
                                    }
                                    if(self.adminTable1[k].max_off_home.value != null && self.adminTable1[k].max_off_home.value != ""){
                                        triger.maxoffHome = parseInt(self.adminTable1[k].max_off_home.value)
                                    }
                                    if(self.adminTable1[k].min_on_away.value != null && self.adminTable1[k].min_on_away.value != ""){
                                        triger.minonAway = parseInt(self.adminTable1[k].min_on_away.value)
                                    }
                                    if(self.adminTable1[k].max_on_away.value != null && self.adminTable1[k].max_on_away.value != ""){
                                        triger.maxonAway = parseInt(self.adminTable1[k].max_on_away.value)
                                    }
                                    if(self.adminTable1[k].min_off_away.value != null && self.adminTable1[k].min_off_away.value != ""){
                                        triger.minoffAway = parseInt(self.adminTable1[k].min_off_away.value)
                                    }
                                    if(self.adminTable1[k].max_off_away.value != null && self.adminTable1[k].max_off_away.value != ""){
                                        triger.maxoffAway = parseInt(self.adminTable1[k].max_off_away.value)
                                    }
                                    if(self.adminTable1[k].switch_btn.value != null && self.adminTable1[k].switch_btn.value != ""){
                                        triger.switch_f = parseInt(self.adminTable1[k].switch_btn.value)
                                    }
                                    if(self.adminTable1[k].hold_on.value != null && self.adminTable1[k].hold_on.value != ""){
                                        triger.hold_on = parseInt(self.adminTable1[k].hold_on.value)
                                    }
                                    for(let j = 0; j < self.mainList.length; j++){
                                        if(eventId == self.mainList[j].eventId){
                                            if (self.mainList[j].DailyApiEvents1.length == 0)
                                                continue
                                            let eventTriger = {
                                                "name": self.eventLists3[i].label,
                                                "oddPre": null,
                                                "oddLive": null,
                                                "scoreHome": 0,
                                                "scoreAway": 0,
                                                "total_goal": 0,
                                                "min_total_goal": 0,
                                                "max_total_goal": 0,
                                                "time": 0,
                                                "matchStatus": null,
                                                "alertName": null,
                                                "onHome": 0,
                                                "offHome": 0,
                                                "onAway": 0,
                                                "offAway": 0,
                                                "c_color": "green"
                                            }
                                            // let eventTriger = {
                                            //     "name": self.eventLists3[i].label,
                                            //     "oddPre": null,
                                            //     "oddLive": null,
                                            //     "scoreHome": 100000,
                                            //     "scoreAway": 100000,
                                            //     "total_goal": 100000,
                                            //     "min_total_goal": 100000,
                                            //     "max_total_goal": 100000,
                                            //     "time": 100000,
                                            //     "matchStatus": null,
                                            //     "alertName": null,
                                            //     "onHome": 100000,
                                            //     "offHome": 100000,
                                            //     "onAway": 100000,
                                            //     "offAway": 100000,
                                            //     "c_color": "green"
                                            // }
                                            let eventNode = self.mainList[j]
                                            if(eventNode.score){
                                                let scoreDetail = eventNode.score
                                                eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                            }
                                            if(eventNode.status){
                                                eventTriger.matchStatus = 1
                                                eventTriger.time = eventNode.timeElapsed
                                            }
                                            else if(!eventNode.status){
                                                eventTriger.matchStatus = 0
                                            }
                                            for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                let marketNode = self.mainList[j].markets[c]
                                                let check = 0
                                                if(marketNode.marketType == marketType){
                                                    if(marketNode.state){
                                                        if(marketNode.state.status == "CLOSED"){
                                                            eventTriger.matchStatus = 0
                                                            check = 1
                                                        }
                                                    }
                                                    if(check === 0){
                                                        let runnerNode = marketNode.runners[team]
                                                        let prematchMarket = null
                                                        if(self.mainList[j].markets[c].prematchMarket){
                                                            prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                        }
                                                        if(eventNode.status && prematchMarket != null){
                                                            let runnerlists = prematchMarket.runners[team]
                                                            if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                            }
                                                            if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNo == 0){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            if(runnerNode.exchange.availableToLay){
                                                                if(runnerNo == 1){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                        if(runnerNo == 0){
                                                            if(runnerNode.exchange.availableToBack){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToLay){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            let liveStatsNode = self.mainList[j].livestatus
                                            let liveNode = liveStatsNode.stats
                                            if(liveStatsNode.stats){
                                                if(liveStatsNode.stats.length > 1){
                                                    if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                        if(liveStatsNode.stats[0].shots != null){
                                                            eventTriger.onHome = liveNode[0].shots.ongoal
                                                            eventTriger.offHome = liveNode[0].shots.offgoal
                                                            eventTriger.onAway = liveNode[1].shots.ongoal
                                                            eventTriger.offAway = liveNode[1].shots.offgoal
                                                        }
                                                    }
                                                    else{
                                                        if(liveStatsNode.stats[1].shots != null){
                                                            eventTriger.onHome = liveNode[1].shots.ongoal
                                                            eventTriger.offHome = liveNode[1].shots.offgoal
                                                            eventTriger.onAway = liveNode[0].shots.ongoal
                                                            eventTriger.offAway = liveNode[0].shots.offgoal
                                                        }
                                                    }
                                                }
                                            }
                                            // //console.log("=======================Condition=========================>", triger)
                                            // //console.log("==========================data===========================>", eventTriger, liveStatsNode)

                                            if(triger.switch_f == 100){

                                                if(eventTriger.offAway >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        eventTriger.alertName = triger.alertName
                                                                                        self.alertArray.push(eventTriger)
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 1){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre <= triger.maxOddPre) {
                                                                                        if (eventTriger.oddPre > triger.minOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)

                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 2){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre >= triger.minOddPre) {
                                                                                        if (eventTriger.oddPre < triger.maxOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 3){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive <= triger.maxOddLive) {
                                                                                        if (eventTriger.oddLive > triger.minOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 4){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive >= triger.minOddLive) {
                                                                                        if (eventTriger.oddLive < triger.maxOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 5){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                                        if (eventTriger.scoreHome > triger.minscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 6){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                                        if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 20){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                                        if (eventTriger.scoreAway > triger.minscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 21){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                                        if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 8){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.max_total_goal) {
                                                                                        if (eventTriger.total_goal > triger.min_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 9){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.min_total_goal) {
                                                                                        if (eventTriger.total_goal < triger.max_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 10){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time <= triger.maxTime) {
                                                                                        if (eventTriger.time > triger.minTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //

                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 11){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time >= triger.minTime) {
                                                                                        if (eventTriger.time < triger.maxTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 12){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome <= triger.maxonHome) {
                                                                                        if (eventTriger.onHome > triger.minonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 13){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 14){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onAway <= triger.maxonAway) {
                                                                                        if (eventTriger.onAway > triger.minonAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 15){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 16){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome <= triger.maxoffHome) {
                                                                                        if (eventTriger.offHome > triger.minoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 17){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome >= triger.minoffHome) {
                                                                                        if (eventTriger.offHome < triger.maxoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 18){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway <= triger.maxoffAway) {
                                                                                        if (eventTriger.offAway > triger.minoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 19){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway >= triger.minoffAway) {
                                                                                        if (eventTriger.offAway < triger.maxoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if(triger.hold_on == 1){
                                                if (eventTriger.oddPre < triger.minOddPre) {
                                                    if(eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 2){
                                                if (eventTriger.oddPre < triger.maxOddPre) {
                                                    if(eventTriger.oddPre >= triger.minOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 3){
                                                if (eventTriger.oddLive < triger.minOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 4){
                                                if (eventTriger.oddLive < triger.maxOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 5){
                                                if (eventTriger.scoreHome < triger.minscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 6){
                                                if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 20){
                                                if (eventTriger.scoreAway < triger.minscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 21){
                                                if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 8){
                                                if (eventTriger.total_goal < triger.min_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 9){
                                                if (eventTriger.total_goal < triger.max_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 10){
                                                if (eventTriger.time < triger.minTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 11){
                                                if (eventTriger.time < triger.maxTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 12){
                                                if (eventTriger.onHome < triger.minonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 13){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 14){
                                                if (eventTriger.onAway < triger.minonAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 15){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 16){
                                                if (eventTriger.offHome < triger.minoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 17){
                                                if (eventTriger.offHome < triger.maxoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 18){
                                                if (eventTriger.offAway < triger.minoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 19){
                                                if (eventTriger.offAway < triger.maxoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        let deleteItem = self.alertArray.filter(function(item) {
                            return item.alertName == self.alertArray[i].alertName && item.name == self.alertArray[i].name;
                        });
                        if(deleteItem.length > 1){
                            let index = self.alertArray.indexOf(self.alertArray[i])
                            if (index > -1) {
                                self.alertArray.splice(index, 1)
                                i = i - 1
                                
                            }
                        }
                    }

                    //please search

                    var new_alertidArray = []
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        var alertid = self.alertArray[i].name + self.alertArray[i].alertName
                        if(!alertidArray.includes(alertid)){
                            //console.log('--- alert added  ---')
                            //this.playeventaddSound()
                            this.playeventaddSound()
                        }
                        new_alertidArray.push(alertid);
                    }

                    for(let i = 0 ; i < alertidArray.length ; i++){
                        
                        if(!new_alertidArray.includes(alertidArray[i])){
                            //console.log('--- alert removed  ---')
                            this.playEventdeleteSound()
                        }
                        
                    }
                    //--------------------------------------------------------
                });

                this.sockets.subscribe('UpdateScore', (data) => {
                    for(let i = 0 ; i < self.mainList.length ; i++){
                        if(self.mainList[i].eventId == data.eventId){
                            self.mainList[i].inPlayMatchStatus = data.inPlayMatchStatus
                            self.mainList[i].score = data.score
                            self.mainList[i].timeElapsed = data.timeElapsed
                            self.mainList[i].status = data.status
                            self.mainList[i].updateDetails = data.updateDetails
                            if(data.status == 'IN_PLAY'){
                                for(let j = 0; j < this.eventLists.length; j++){
                                    let value = this.eventLists[j].value
                                    let liveArray = value.split(',')
                                    if(data.eventId == liveArray[0]){
                                        let str = this.eventLists[j].label
                                        if(str.includes(' - Live') == false){
                                            this.eventLists[j].label = this.eventLists[j].label + ' - Live'
                                        }
                                    }
                                    if(data.eventId == liveArray[1]){
                                        let str = this.eventLists[j].label
                                        if(str.includes(' - Live') == false){
                                            this.eventLists[j].label = this.eventLists[j].label + ' - Live'
                                        }
                                    }
                                }
                            }
                            else{
                                for(let j = 0; j < this.eventLists.length; j++){
                                    let value = this.eventLists[j].value
                                    let liveArray = value.split(',')
                                    if(data.eventId == liveArray[0]){
                                        let str = this.eventLists[j].label
                                        if(str.includes(' - Live') == true){
                                            this.eventLists[j].label.replace(' - Live', )
                                        }
                                    }
                                }
                                for(let j = 0; j < this.eventLists.length; j++){
                                    let value = this.eventLists[j].value
                                    let liveArray = value.split(',')
                                    if(data.eventId == liveArray[1]){
                                        let str = this.eventLists[j].label
                                        if(str.includes(' - Live') == true){
                                            this.eventLists[j].label.replace(' - Live', )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(self.eventId ==  data.eventId){
                        var orig_timeRecord = this.timeRecord
                        orig_timeRecord = orig_timeRecord.toString().replace("'", "")

                        if (orig_timeRecord == '' || orig_timeRecord == "HT")
                            self.timeRecord = data.timeElapsed+ "'"
                        else if (data.timeElapsed > parseInt(orig_timeRecord))
                            self.timeRecord = data.timeElapsed+ "'"

                        //self.timeRecord = data.timeElapsed
                        self.status = data.status
                        if(data.status == 'IN_PLAY'){
                            self.status = 'Live - '
                            this.scoreOne = data.score.home.score + " -"
                            this.scoreTwo = data.score.away.score

                            
                            if (orig_timeRecord == '' || orig_timeRecord == "HT")
                                this.timeRecord = data.timeElapsed+ "'"
                            else if (data.timeElapsed > parseInt(orig_timeRecord))
                                this.timeRecord = data.timeElapsed+ "'"

                            var total_score = parseInt(data.score.home.score) + parseInt(data.score.away.score);
                            //console.log('----home.score', parseInt(data.score.home.score))
                            //console.log('----away.score', parseInt(data.score.away.score))
                            //console.log('----total_score', total_score)
                            //console.log('----this.eventScore', this.eventScore)
                            if (total_score > this.eventScore) {
                                this.playScoresound();
                                this.eventScore = total_score;
                            }

                        }
                        else if(!data.status){
                            self.status = this.$t('coming_up_main')
                            this.scoreOne =''
                            this.scoreTwo =''
                            this.timeRecord =''
                        }
                        if(data.inPlayMatchStatus == 'FirstHalfEnd'){
                            this.timeRecord = "HT"
                        }
                    }
                    var alertidArray = []
                    for (var i = 0; i < this.alertArray.length; i++) {
                        alertidArray.push(this.alertArray[i].name + this.alertArray[i].alertName)
                    }

                    self.alertArray = []
                    //console.log("alert part by score===>")
                    for(let i = 1 ; i < self.eventLists3.length ; i++){
                        // //console.log('self.prediction list console=>', self.eventLists3[i].label)
                        let val1 = self.eventLists3[i].value
                        let eventId = parseInt(val1.split(',')[1])
                        let marketType = val1.split(',')[2]
                        let team = val1.split(',')[3]
                        let runnerNo = val1.split(',')[6]
                        let pred = ""

                        if(marketType == 'MATCH_ODDS'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- 1 - Back'
                                }
                                else{
                                    pred = '- 1 - Lay'
                                }
                            }
                            else if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- 2 - Back'
                                }
                                else{
                                    pred = '- 2 - Lay'
                                }
                            }
                            else if(team == '2'){
                                if(runnerNo == '0'){
                                    pred = '- X - Back'
                                }
                                else{
                                    pred = '- X - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_05'){
                            if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- O 0.5 - Back'
                                }
                                else{
                                    pred = '- O 0.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_15'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 1.5 - Back'
                                }
                                else{
                                    pred = '- U 1.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 1.5 - Back'
                                }
                                else{
                                    pred = '- O 1.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_25'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 2.5 - Back'
                                }
                                else{
                                    pred = '- U 2.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 2.5 - Back'
                                }
                                else{
                                    pred = '- O 2.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_35'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 3.5 - Back'
                                }
                                else{
                                    pred = '- U 3.5 - Lay'
                                }
                            }
                        }
                        let predT = self.pred_type_list.filter(function(item) {
                            return item.label == pred
                        })
                        if(predT.length > 0){
                            for(let k = 0 ; k < self.adminTable1.length ; k++){
                                if(predT[0].value == self.adminTable1[k].PredType.value){
                                    let triger = {
                                        "maxOddPre": 1000000,
                                        "minOddPre": 0,
                                        "maxOddLive": 1000000,
                                        "minOddLive": 0,
                                        "minscoreHome": 0,
                                        "maxscoreHome": 100,
                                        "minscoreAway": 0,
                                        "maxscoreAway": 100,
                                        "min_total_goal": 0,
                                        "max_total_goal": 100,
                                        "minTime": 0,
                                        "maxTime": 150,
                                        "matchStatus": 0,
                                        "alertName": null,
                                        "minonHome": 0,
                                        "maxonHome": 100,
                                        "minoffHome": 0,
                                        "maxoffHome": 100,
                                        "minonAway": 0,
                                        "maxonAway": 100,
                                        "minoffAway": 0,
                                        "maxoffAway": 100,
                                        "switch_f": 100,
                                        "hold_on": 100
                                    }
                                    if(self.adminTable1[k].maxOddpre.value != null && self.adminTable1[k].maxOddpre.value != ""){
                                        triger.maxOddPre = parseFloat(self.adminTable1[k].maxOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddpre.value != null && self.adminTable1[k].minOddpre.value != ""){
                                        triger.minOddPre = parseFloat(self.adminTable1[k].minOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddlive.value != null && self.adminTable1[k].minOddlive.value != ""){
                                        triger.minOddLive = parseFloat(self.adminTable1[k].minOddlive.value)
                                    }
                                    if(self.adminTable1[k].maxoddlive.value != null && self.adminTable1[k].maxoddlive.value != ""){
                                        triger.maxOddLive = parseFloat(self.adminTable1[k].maxoddlive.value)
                                    }
                                    if(self.adminTable1[k].min_score_home.value != null && self.adminTable1[k].min_score_home.value != ""){
                                        triger.minscoreHome = parseFloat(self.adminTable1[k].min_score_home.value)
                                    }
                                    if(self.adminTable1[k].max_score_home.value != null && self.adminTable1[k].max_score_home.value != ""){
                                        triger.maxscoreHome = parseFloat(self.adminTable1[k].max_score_home.value)
                                    }
                                    if(self.adminTable1[k].min_score_away.value != null && self.adminTable1[k].min_score_away.value != ""){
                                        triger.minscoreAway = parseFloat(self.adminTable1[k].min_score_away.value)
                                    }
                                    if(self.adminTable1[k].max_score_away.value != null && self.adminTable1[k].max_score_away.value != ""){
                                        triger.maxscoreAway = parseFloat(self.adminTable1[k].max_score_away.value)
                                    }
                                    if(self.adminTable1[k].min_total_goal.value != null && self.adminTable1[k].min_total_goal.value != ""){
                                        triger.min_total_goal = parseFloat(self.adminTable1[k].min_total_goal.value)
                                    }
                                    if(self.adminTable1[k].max_total_goal.value != null && self.adminTable1[k].max_total_goal.value != ""){
                                        triger.max_total_goal = parseFloat(self.adminTable1[k].max_total_goal.value)
                                    }
                                    if(self.adminTable1[k].min_time.value != null && self.adminTable1[k].min_time.value != ""){
                                        triger.minTime = parseInt(self.adminTable1[k].min_time.value)
                                    }
                                    if(self.adminTable1[k].max_time.value != null && self.adminTable1[k].max_time.value != ""){
                                        triger.maxTime = parseInt(self.adminTable1[k].max_time.value)
                                    }
                                    if(self.adminTable1[k].MatchStatus.value != null){
                                        triger.matchStatus = self.adminTable1[k].MatchStatus.value
                                    }
                                    if(self.adminTable1[k].Alert_Name.value != null){
                                        triger.alertName = self.adminTable1[k].Alert_Name.value
                                    }
                                    if(self.adminTable1[k].min_on_home.value != null && self.adminTable1[k].min_on_home.value != ""){
                                        triger.minonHome = parseInt(self.adminTable1[k].min_on_home.value)
                                    }
                                    if(self.adminTable1[k].max_on_home.value != null && self.adminTable1[k].max_on_home.value != ""){
                                        triger.maxonHome = parseInt(self.adminTable1[k].max_on_home.value)
                                    }
                                    if(self.adminTable1[k].min_off_home.value != null && self.adminTable1[k].min_off_home.value != ""){
                                        triger.minoffHome = parseInt(self.adminTable1[k].min_off_home.value)
                                    }
                                    if(self.adminTable1[k].max_off_home.value != null && self.adminTable1[k].max_off_home.value != ""){
                                        triger.maxoffHome = parseInt(self.adminTable1[k].max_off_home.value)
                                    }
                                    if(self.adminTable1[k].min_on_away.value != null && self.adminTable1[k].min_on_away.value != ""){
                                        triger.minonAway = parseInt(self.adminTable1[k].min_on_away.value)
                                    }
                                    if(self.adminTable1[k].max_on_away.value != null && self.adminTable1[k].max_on_away.value != ""){
                                        triger.maxonAway = parseInt(self.adminTable1[k].max_on_away.value)
                                    }
                                    if(self.adminTable1[k].min_off_away.value != null && self.adminTable1[k].min_off_away.value != ""){
                                        triger.minoffAway = parseInt(self.adminTable1[k].min_off_away.value)
                                    }
                                    if(self.adminTable1[k].max_off_away.value != null && self.adminTable1[k].max_off_away.value != ""){
                                        triger.maxoffAway = parseInt(self.adminTable1[k].max_off_away.value)
                                    }
                                    if(self.adminTable1[k].switch_btn.value != null && self.adminTable1[k].switch_btn.value != ""){
                                        triger.switch_f = parseInt(self.adminTable1[k].switch_btn.value)
                                    }
                                    if(self.adminTable1[k].hold_on.value != null && self.adminTable1[k].hold_on.value != ""){
                                        triger.hold_on = parseInt(self.adminTable1[k].hold_on.value)
                                    }
                                    for(let j = 0; j < self.mainList.length; j++){
                                        if(eventId == self.mainList[j].eventId){
                                            if (self.mainList[j].DailyApiEvents1.length == 0)
                                                    continue
                                            let eventTriger = {
                                                "name": self.eventLists3[i].label,
                                                "oddPre": null,
                                                "oddLive": null,
                                                "scoreHome": 0,
                                                "scoreAway": 0,
                                                "total_goal": 0,
                                                "min_total_goal": 0,
                                                "max_total_goal": 0,
                                                "time": 0,
                                                "matchStatus": null,
                                                "alertName": null,
                                                "onHome": 0,
                                                "offHome": 0,
                                                "onAway": 0,
                                                "offAway": 0,
                                                "c_color": "green"
                                            }
                                            // let eventTriger = {
                                            //     "name": self.eventLists3[i].label,
                                            //     "oddPre": null,
                                            //     "oddLive": null,
                                            //     "scoreHome": 100000,
                                            //     "scoreAway": 100000,
                                            //     "total_goal": 100000,
                                            //     "min_total_goal": 100000,
                                            //     "max_total_goal": 100000,
                                            //     "time": 100000,
                                            //     "matchStatus": null,
                                            //     "alertName": null,
                                            //     "onHome": 100000,
                                            //     "offHome": 100000,
                                            //     "onAway": 100000,
                                            //     "offAway": 100000,
                                            //     "c_color": "green"
                                            // }
                                            let eventNode = self.mainList[j]
                                            if(eventNode.score){
                                                let scoreDetail = eventNode.score
                                                eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                            }
                                            if(eventNode.status){
                                                eventTriger.matchStatus = 1
                                                eventTriger.time = eventNode.timeElapsed
                                            }
                                            else if(!eventNode.status){
                                                eventTriger.matchStatus = 0
                                            }
                                            for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                let marketNode = self.mainList[j].markets[c]
                                                let check = 0
                                                if(marketNode.marketType == marketType){
                                                    if(marketNode.state){
                                                        if(marketNode.state.status == "CLOSED"){
                                                            eventTriger.matchStatus = 0
                                                            check = 1
                                                        }
                                                    }
                                                    if(check === 0){
                                                        let runnerNode = marketNode.runners[team]
                                                        let prematchMarket = null
                                                        if(self.mainList[j].markets[c].prematchMarket){
                                                            prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                        }
                                                        if(eventNode.status && prematchMarket != null){
                                                            let runnerlists = prematchMarket.runners[team]
                                                            if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                            }
                                                            if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNo == 0){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            if(runnerNode.exchange.availableToLay){
                                                                if(runnerNo == 1){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                        if(runnerNo == 0){
                                                            if(runnerNode.exchange.availableToBack){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToLay){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            let liveStatsNode = self.mainList[j].livestatus
                                            let liveNode = liveStatsNode.stats
                                            if(liveStatsNode.stats){
                                                if(liveStatsNode.stats.length > 1){
                                                    if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                        if(liveStatsNode.stats[0].shots != null){
                                                            eventTriger.onHome = liveNode[0].shots.ongoal
                                                            eventTriger.offHome = liveNode[0].shots.offgoal
                                                            eventTriger.onAway = liveNode[1].shots.ongoal
                                                            eventTriger.offAway = liveNode[1].shots.offgoal
                                                        }
                                                    }
                                                    else{
                                                        if(liveStatsNode.stats[1].shots != null){
                                                            eventTriger.onHome = liveNode[1].shots.ongoal
                                                            eventTriger.offHome = liveNode[1].shots.offgoal
                                                            eventTriger.onAway = liveNode[0].shots.ongoal
                                                            eventTriger.offAway = liveNode[0].shots.offgoal
                                                        }
                                                    }
                                                }
                                            }
                                            // //console.log("=======================Condition=========================>", triger)
                                            // //console.log("==========================data===========================>", eventTriger, liveStatsNode)
                                            if(triger.switch_f == 100){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        eventTriger.alertName = triger.alertName
                                                                                        self.alertArray.push(eventTriger)
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 1){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre <= triger.maxOddPre) {
                                                                                        if (eventTriger.oddPre > triger.minOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 2){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre >= triger.minOddPre) {
                                                                                        if (eventTriger.oddPre < triger.maxOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 3){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive <= triger.maxOddLive) {
                                                                                        if (eventTriger.oddLive > triger.minOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 4){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive >= triger.minOddLive) {
                                                                                        if (eventTriger.oddLive < triger.maxOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 5){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                                        if (eventTriger.scoreHome > triger.minscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 6){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                                        if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 20){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                                        if (eventTriger.scoreAway > triger.minscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 21){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                                        if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 8){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.max_total_goal) {
                                                                                        if (eventTriger.total_goal > triger.min_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 9){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.min_total_goal) {
                                                                                        if (eventTriger.total_goal < triger.max_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 10){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time <= triger.maxTime) {
                                                                                        if (eventTriger.time > triger.minTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 11){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time >= triger.minTime) {
                                                                                        if (eventTriger.time < triger.maxTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 12){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome <= triger.maxonHome) {
                                                                                        if (eventTriger.onHome > triger.minonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 13){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 14){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onAway <= triger.maxonAway) {
                                                                                        if (eventTriger.onAway > triger.minonAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 15){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 16){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome <= triger.maxoffHome) {
                                                                                        if (eventTriger.offHome > triger.minoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 17){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome >= triger.minoffHome) {
                                                                                        if (eventTriger.offHome < triger.maxoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 18){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway <= triger.maxoffAway) {
                                                                                        if (eventTriger.offAway > triger.minoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 19){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway >= triger.minoffAway) {
                                                                                        if (eventTriger.offAway < triger.maxoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        //
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if(triger.hold_on == 1){
                                                if (eventTriger.oddPre < triger.minOddPre) {
                                                    if(eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 2){
                                                if (eventTriger.oddPre < triger.maxOddPre) {
                                                    if(eventTriger.oddPre >= triger.minOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 3){
                                                if (eventTriger.oddLive < triger.minOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 4){
                                                if (eventTriger.oddLive < triger.maxOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 5){
                                                if (eventTriger.scoreHome < triger.minscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 6){
                                                if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 20){
                                                if (eventTriger.scoreAway < triger.minscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 21){
                                                if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 8){
                                                if (eventTriger.total_goal < triger.min_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 9){
                                                if (eventTriger.total_goal < triger.max_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 10){
                                                if (eventTriger.time < triger.minTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 11){
                                                if (eventTriger.time < triger.maxTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 12){
                                                if (eventTriger.onHome < triger.minonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 13){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 14){
                                                if (eventTriger.onAway < triger.minonAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 15){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 16){
                                                if (eventTriger.offHome < triger.minoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 17){
                                                if (eventTriger.offHome < triger.maxoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 18){
                                                if (eventTriger.offAway < triger.minoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 19){
                                                if (eventTriger.offAway < triger.maxoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    if(this.calc_odd != 0 && this.calc_stake != 0 && this.eventId != 0){
                        if(this.riskTrading == 'auto'){
                            //console.log("===>auto Trading Check==>", val1)
                            let val1 = this.selectedValue
                            let eventId = parseInt(val1.split(',')[1])
                            let marketType = val1.split(',')[2]
                            let team = val1.split(',')[3]
                            let runnerNo = val1.split(',')[6]
                            let pred = ""
                            let self = this
                            if(marketType == 'MATCH_ODDS'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- 1 - Back'
                                    }
                                    else{
                                        pred = '- 1 - Lay'
                                    }
                                }
                                else if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- 2 - Back'
                                    }
                                    else{
                                        pred = '- 2 - Lay'
                                    }
                                }
                                else if(team == '2'){
                                    if(runnerNo == '0'){
                                        pred = '- X - Back'
                                    }
                                    else{
                                        pred = '- X - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_05'){
                                if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- O 0.5 - Back'
                                    }
                                    else{
                                        pred = '- O 0.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_15'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 1.5 - Back'
                                    }
                                    else{
                                        pred = '- U 1.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 1.5 - Back'
                                    }
                                    else{
                                        pred = '- O 1.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_25'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 2.5 - Back'
                                    }
                                    else{
                                        pred = '- U 2.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 2.5 - Back'
                                    }
                                    else{
                                        pred = '- O 2.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_35'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 3.5 - Back'
                                    }
                                    else{
                                        pred = '- U 3.5 - Lay'
                                    }
                                }
                            }
                            let predT = self.pred_type_list.filter(function(item) {
                                return item.label == pred
                            })
                            //console.log('predT====>', predT, pred, self.cashoutTable)
                            if(predT.length > 0){
                                for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                    if(predT[0].value == self.cashoutTable[k].PredType.value){
                                        let triger = {
                                            "maxOddPre": 1000000,
                                            "minOddPre": 0,
                                            "maxOddLive": 1000000,
                                            "minOddLive": 0,
                                            "minscoreHome": 0,
                                            "maxscoreHome": 100,
                                            "minscoreAway": 0,
                                            "maxscoreAway": 100,
                                            "min_total_goal": 0,
                                            "max_total_goal": 100,
                                            "minTime": 0,
                                            "maxTime": 150,
                                            "matchStatus": 0,
                                            "alertName": null,
                                            "minonHome": 0,
                                            "maxonHome": 100,
                                            "minoffHome": 0,
                                            "maxoffHome": 100,
                                            "minonAway": 0,
                                            "maxonAway": 100,
                                            "minoffAway": 0,
                                            "maxoffAway": 100,
                                            "min_profit": -1000,
                                            "max_profit": 1000000000,
                                            "stop_loss": false,
                                            "tradingMode": false
                                        }
                                        if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                            triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                            triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                            triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                        }
                                        if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                            triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                        }
                                        if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                            triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                        }
                                        if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                            triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                        }
                                        if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                            triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                        }
                                        if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                            triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                        }
                                        if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                            triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                            triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                            triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                        }
                                        if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                            triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                        }
                                        if(self.cashoutTable[k].MatchStatus.value != null){
                                            triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                        }
                                        if(self.cashoutTable[k].Alert_Name.value != null){
                                            triger.alertName = self.cashoutTable[k].Alert_Name.value
                                        }
                                        if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                            triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                        }
                                        if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                            triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                        }
                                        if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                            triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                        }
                                        if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                            triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                        }
                                        if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                            triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                        }
                                        if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                            triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                        }
                                        if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                            triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                        }
                                        if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                            triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                        }
                                        if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                            triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                        }
                                        if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                            triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                        }
                                        if(self.cashoutTable[k].stop_loss.value != false){
                                            triger.stop_loss = true
                                        }
                                        if(self.cashoutTable[k].tradingMode.value != false){
                                            triger.tradingMode = true
                                        }
                                        for(let j = 0; j < self.mainList.length; j++){
                                            if(eventId == self.mainList[j].eventId){
                                                if (self.mainList[j].DailyApiEvents1.length == 0)
                                                    continue
                                                let eventTriger = {
                                                    "name": self.selectedLabel,
                                                    "oddPre": null,
                                                    "oddLive": null,
                                                    "scoreHome": 0,
                                                    "scoreAway": 0,
                                                    "total_goal": 0,
                                                    "min_total_goal": 0,
                                                    "max_total_goal": 0,
                                                    "time": 0,
                                                    "matchStatus": null,
                                                    "alertName": self.cashoutAlertName,
                                                    "onHome": 0,
                                                    "offHome": 0,
                                                    "onAway": 0,
                                                    "offAway": 0,
                                                    "c_color": "green",
                                                    "profit": parseFloat(this.currentPercent),
                                                    "stop_loss": self.stopLoss,
                                                    "tradingMode": self.tradingMode
                                                }
                                               
                                                let eventNode = self.mainList[j]
                                                if(eventNode.score){
                                                    let scoreDetail = eventNode.score
                                                    eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                    eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                    eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                }
                                                if(eventNode.status){
                                                    eventTriger.matchStatus = 1
                                                    eventTriger.time = eventNode.timeElapsed
                                                }
                                                else if(!eventNode.status){
                                                    eventTriger.matchStatus = 0
                                                }
                                                for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                    let marketNode = self.mainList[j].markets[c]
                                                    let check = 0
                                                    if(marketNode.marketType == marketType){
                                                        if(marketNode.state){
                                                            if(marketNode.state.status == "CLOSED"){
                                                                eventTriger.matchStatus = 0
                                                                check = 1
                                                            }
                                                        }
                                                        if(check === 0){
                                                            let runnerNode = marketNode.runners[team]
                                                            let prematchMarket = null
                                                            if(self.mainList[j].markets[c].prematchMarket){
                                                                prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                            }
                                                            if(eventNode.status && prematchMarket != null){
                                                                let runnerlists = prematchMarket.runners[team]
                                                                if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                }
                                                                if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToBack){
                                                                    if(runnerNo == 0){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                if(runnerNode.exchange.availableToLay){
                                                                    if(runnerNo == 1){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                            if(runnerNo == 0){
                                                                if(runnerNode.exchange.availableToBack){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToLay){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                let liveStatsNode = self.mainList[j].livestatus
                                                let liveNode = liveStatsNode.stats
                                                if(liveStatsNode.stats){
                                                    if(liveStatsNode.stats.length > 1){
                                                        if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                            if(liveStatsNode.stats[0].shots != null){
                                                                eventTriger.onHome = liveNode[0].shots.ongoal
                                                                eventTriger.offHome = liveNode[0].shots.offgoal
                                                                eventTriger.onAway = liveNode[1].shots.ongoal
                                                                eventTriger.offAway = liveNode[1].shots.offgoal
                                                            }
                                                        }
                                                        else{
                                                            if(liveStatsNode.stats[1].shots != null){
                                                                eventTriger.onHome = liveNode[1].shots.ongoal
                                                                eventTriger.offHome = liveNode[1].shots.offgoal
                                                                eventTriger.onAway = liveNode[0].shots.ongoal
                                                                eventTriger.offAway = liveNode[0].shots.offgoal
                                                            }
                                                        }
                                                    }
                                                }
                                                //console.log('****************************cash out message check cond= >', triger)
                                                //console.log('****************************cash out message check value= >', eventTriger)
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                            if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                if(triger.alertName == eventTriger.alertName){
                                                                                                    this.percentTextColor1 = '#000'
                                                                                                    this.percentBackgroundColor = '#ffc000'
                                                                                                    this.percent_text1 = 'Cash Out Now! '
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        let deleteItem = self.alertArray.filter(function(item) {
                            return item.alertName == self.alertArray[i].alertName && item.name == self.alertArray[i].name;
                        });
                        if(deleteItem.length > 1){
                            let index = self.alertArray.indexOf(self.alertArray[i])
                            if (index > -1) {
                                self.alertArray.splice(index, 1)
                                i = i - 1                            
                            }
                        }
                    }

                    //please search

                    var new_alertidArray = []
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        var alertid = self.alertArray[i].name + self.alertArray[i].alertName
                        if(!alertidArray.includes(alertid)){
                            //console.log('--- alert added  ---')
                            //this.playeventaddSound()
                            this.playeventaddSound()
                        }
                        new_alertidArray.push(alertid);
                    }

                    for(let i = 0 ; i < alertidArray.length ; i++){
                        
                        if(!new_alertidArray.includes(alertidArray[i])){
                            //console.log('--- alert removed  ---')
                            this.playEventdeleteSound()
                        }
                        
                    }
                });
                this.sockets_server1.on('UpdateStats', data1 => {
                    //console.log('listener data=>', data1)
                    for(let i = 0 ; i < data1.length ; i++){
                        if(data1[i].updateArray){
                            let stats = data1[i].updateArray.stats
                            let stats_ten = data1[i].updateArray.stats_ten
                            let goal_tooltip = data1[i].updateArray.goal_tooltip
                            // let home_tooltip = data1[i].updateArray.home_tooltip
                            // let away_tooltip = data1[i].updateArray.away_tooltip
                            let home_tooltip2 = data1[i].updateArray.home_tooltip2
                            let away_tooltip2 = data1[i].updateArray.away_tooltip2


                            
                            let current_main_data = {
                                "home_tip_shots": data1[i].updateArray.home_tip_shots,
                                "home_tip_cnr": data1[i].updateArray.home_tip_cnr,
                                "away_tip_shots": data1[i].updateArray.away_tip_shots,
                                "away_tip_cnr": data1[i].updateArray.away_tip_cnr,
                                "home_tooltip2": data1[i].updateArray.home_tooltip2,
                                "away_tooltip2": data1[i].updateArray.away_tooltip2,
                            }
                            
                            if(this.fixtureId == data1[i].updateArray._id && data1[i].currentData.stats[0]){
                                console.log('data1[i].updateArray', data1[i].updateArray)
                                let current_event = this.item1
                                //console.log('current_event +++++++++', current_event)
                                current_event.home.time = data1[i].currentData.time.minute
                                let tot_time = data1[i].currentData.time.minute
                                if(data1[i].currentData.time.injury_time != null){
                                    current_event.home.time = data1[i].currentData.time.minute + '+' + data1[i].currentData.time.injury_time
                                    tot_time = data1[i].currentData.time.minute + data1[i].currentData.time.injury_time
                                }
                                if(data1[i].currentData.time.status == 'HT'){
                                    current_event.home.time = 'HT'
                                    tot_time = 45
                                }
                                if(data1[i].currentData.time.extra_minute > 0){
                                    current_event.home.time = data1[i].currentData.time.minute + data1[i].currentData.time.extra_minute + "'"
                                }
                                current_event.goal_tooltip = data1[i].updateArray.goal_tooltip
                                let home_goal = data1[i].updateArray.scores.localteam_score
                                let away_goal = data1[i].updateArray.scores.visitorteam_score
                                //---------------------------------Last 10 Min--------------------------------------
                                current_event.home.score = data1[i].updateArray.scores.localteam_score
                                current_event.away.score = data1[i].updateArray.scores.visitorteam_score
                                this.scoreOne = data1[i].updateArray.scores.localteam_score + ' - '
                                this.scoreTwo = data1[i].updateArray.scores.visitorteam_score

                                // if (this.timeRecord != 'HT' && this.timeRecord != '') {
                                //     this.timeRecord = data1[i].updateArray.time.minute + "'"
                                // }

                                var orig_timeRecord = self.timeRecord
                                orig_timeRecord = orig_timeRecord.toString().replace("'", "")
                                if (orig_timeRecord != '' && orig_timeRecord != "HT" && data1[i].updateArray.time.minute > parseInt(orig_timeRecord))
                                    this.timeRecord = data1[i].updateArray.time.minute+ "'"
                                
                                
                                if(current_event.home.id === stats[0].team_id){
                                    if(stats[0].shots && stats_ten.length > 0){
                                        if(stats[0].shots.ongoal != null){
                                            current_event.home.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                            current_event.away.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                        }
                                        if(stats[0].shots.offgoal != null){
                                            current_event.home.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                            current_event.away.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                        }
                                        if(stats[0].shots.blocked != null){
                                            current_event.home.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                            current_event.away.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                        }
                                        if(stats[0].shots.insidebox != null){
                                            current_event.home.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                            current_event.away.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                        }
                                        if(stats[0].shots.outsidebox != null){
                                            current_event.home.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                            current_event.away.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                        }
                                    }
                                    if(stats[0].corners != null){
                                        current_event.home.cnr = stats[0].corners - stats_ten[0][0].corners
                                        current_event.away.cnr = stats[1].corners - stats_ten[0][1].corners
                                    }

                                    if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                        if(stats[0].attacks.dangerous_attacks != null){
                                            current_event.home.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                            current_event.away.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                        }
                                    }
                                    if(stats_ten[0][0].possessiontime != null){
                                        current_event.home.poss = stats_ten[0][0].possessiontime
                                        current_event.away.poss = stats_ten[0][1].possessiontime
                                    }

                                    if(stats[0].substitutions != null){
                                        current_event.home.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                        current_event.away.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                    }

                                    if(stats[0].goals > current_event.home.goal){
                                        current_event.home.flash = 1
                                    }
                                    else{
                                        current_event.home.flash = 0
                                    }

                                    if(stats[1].goals > current_event.away.goal){
                                        current_event.away.flash = 1
                                    }
                                    else{
                                        current_event.away.flash = 0
                                    }

                                    current_event.home.goal = stats[0].goals - stats_ten[0][0].goals
                                    current_event.away.goal = stats[1].goals - stats_ten[0][1].goals
                                }
                                else{
                                    current_event.home.score = data1[i].updateArray.scores.localteam_score
                                    current_event.away.score = data1[i].updateArray.scores.visitorteam_score
                                    if(stats[0].shots && stats_ten[0][0].shots){
                                        if(stats[0].shots.ongoal != null){
                                            current_event.home.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                            current_event.away.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                        }
                                        if(stats[0].shots.offgoal != null){
                                            current_event.home.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                            current_event.away.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                        }
                                        if(stats[0].shots.blocked != null){
                                            current_event.home.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                            current_event.away.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                        }
                                        if(stats[0].shots.insidebox != null){
                                            current_event.home.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                            current_event.away.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                        }
                                        if(stats[0].shots.outsidebox != null){
                                            current_event.home.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                            current_event.away.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                        }
                                    }
                                    if(stats[0].corners != null){
                                        current_event.home.cnr = stats[1].corners - stats_ten[0][1].corners
                                        current_event.away.cnr = stats[0].corners - stats_ten[0][0].corners
                                    }

                                    if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                        if(stats[0].attacks.dangerous_attacks != null){
                                            current_event.home.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                            current_event.away.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                        }
                                    }
                                    if(stats_ten[0][0].possessiontime != null){
                                        current_event.home.poss = stats_ten[0][1].possessiontime
                                        current_event.away.poss = stats_ten[0][0].possessiontime
                                    }

                                    if(stats[0].substitutions != null){
                                        current_event.home.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                        current_event.away.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                    }

                                    if(stats[0].goals > current_event.home.goal){
                                        current_event.home.flash = 1
                                    }
                                    else{
                                        current_event.home.flash = 0
                                    }

                                    if(stats[1].goals > current_event.away.goal){
                                        current_event.away.flash = 1
                                    }
                                    else{
                                        current_event.away.flash = 0
                                    }

                                    current_event.home.goal = stats[1].goals - stats_ten[0][1].goals
                                    current_event.away.goal = stats[0].goals - stats_ten[0][0].goals
                                }

                                current_event.home.rtg = 0
                                current_event.away.rtg = 0
                                if((current_event.home.on >= 0) || (current_event.home.off >= 0) || (current_event.home.cnr >= 0) || (current_event.home.da > 0)){
                                    if(current_event.home.on >= 0){
                                        current_event.home.rtg = current_event.home.rtg + current_event.home.on*3
                                    }
                                    if(current_event.home.off >= 0){
                                        current_event.home.rtg = current_event.home.rtg + current_event.home.off*2
                                    }
                                    if(current_event.home.cnr >= 0){
                                        current_event.home.rtg = current_event.home.rtg + current_event.home.cnr
                                    }
                                    if(current_event.home.da >= 0){
                                        current_event.home.rtg = current_event.home.rtg + current_event.home.da
                                    }
                                }
                                else{
                                    current_event.home.rtg = '-'
                                }

                                if((current_event.away.on >= 0) || (current_event.away.off >= 0) || (current_event.away.cnr >= 0) || (current_event.away.da > 0)){
                                    if(current_event.away.on >= 0){
                                        current_event.away.rtg = current_event.away.rtg + current_event.away.on*3
                                    }
                                    if(current_event.away.off >= 0){
                                        current_event.away.rtg = current_event.away.rtg + current_event.away.off*2
                                    }
                                    if(current_event.away.cnr >= 0){
                                        current_event.away.rtg = current_event.away.rtg + current_event.away.cnr
                                    }
                                    if(current_event.away.da >= 0){
                                        current_event.away.rtg = current_event.away.rtg + current_event.away.da
                                    }
                                }
                                else{
                                    current_event.away.rtg = '-'
                                }

                                if(current_event.home.last_goal > 0){
                                    current_event.home.gdr = 0
                                    if(current_event.home.last_on > 0){
                                        current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.on/current_event.home.last_goal/current_event.home.last_on/9)*current_event.home.on)
                                    }
                                    if(current_event.home.last_off > 0){
                                        current_event.home.gdr = current_event.home.gdr + ( ( 100*current_event.home.off/current_event.home.last_goal/current_event.home.last_off/ 9 )*current_event.home.off )
                                    }
                                    if(current_event.home.last_cnr > 0){
                                        current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.cnr/current_event.home.last_goal/current_event.home.last_cnr/9)*current_event.home.cnr )
                                    }
                                    if(current_event.home.last_da > 0){
                                        current_event.home.gdr = current_event.home.gdr + ((100*current_event.home.da/current_event.home.last_goal/current_event.home.last_da/9)*current_event.home.da )
                                    }

                                    if(home_goal === 0){
                                        current_event.homeT.nxt = 0
                                        if(current_event.home.last_goal > 0 && current_event.home.last_on > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.on*90/tot_time/(current_event.home.last_on*current_event.home.last_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_off > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.off*90/tot_time/(current_event.home.last_off*current_event.home.last_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_cnr > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.cnr*90/tot_time/(current_event.home.last_cnr*current_event.home.last_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_da > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.da*90/tot_time/(current_event.home.last_da*current_event.home.last_goal/current_event.home.last_goal)))
                                        }
                                        current_event.homeT.nxt = (current_event.homeT.nxt*100/4).toFixed(0)

                                        current_event.homeT.nxt = -1 * current_event.homeT.nxt
                                    }
                                    else if(home_goal > 0){
                                        current_event.homeT.nxt = 0
                                        if(current_event.home.last_goal > 0 && current_event.home.last_on > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.on*90/tot_time/(current_event.home.last_on*home_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_off > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.off*90/tot_time/(current_event.home.last_off*home_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_cnr > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.cnr*90/tot_time/(current_event.home.last_cnr*home_goal/current_event.home.last_goal)))
                                        }
                                        if(current_event.home.last_goal > 0 && current_event.home.last_da > 0){
                                            current_event.homeT.nxt = current_event.homeT.nxt + ((current_event.homeT.da*90/tot_time/(current_event.home.last_da*home_goal/current_event.home.last_goal)))
                                        }
                                        current_event.homeT.nxt = (current_event.homeT.nxt*100/4 - 100).toFixed(0)

                                        current_event.homeT.nxt = -1 * current_event.homeT.nxt
                                    }
                                }
                                if(current_event.away.last_goal > 0){
                                    current_event.away.gdr = 0
                                    if(current_event.away.last_on > 0){
                                        current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.on/current_event.away.last_goal/current_event.away.last_on/9)*current_event.away.on)
                                    }
                                    if(current_event.away.last_off > 0){
                                        current_event.away.gdr = current_event.away.gdr + ( ( 100*current_event.away.off/current_event.away.last_goal/current_event.away.last_off/ 9 )*current_event.away.off )
                                    }
                                    if(current_event.away.last_cnr > 0){
                                        current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.cnr/current_event.away.last_goal/current_event.away.last_cnr/9)*current_event.away.cnr )
                                    }
                                    if(current_event.away.last_da > 0){
                                        current_event.away.gdr = current_event.away.gdr + ((100*current_event.away.da/current_event.away.last_goal/current_event.away.last_da/9)*current_event.away.da )
                                    }

                                    if(away_goal === 0){
                                        current_event.awayT.nxt = 0
                                        if(current_event.away.last_goal > 0 && current_event.away.last_on > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.on*90/tot_time/(current_event.away.last_on*current_event.away.last_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_off > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.off*90/tot_time/(current_event.away.last_off*current_event.away.last_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_cnr > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.cnr*90/tot_time/(current_event.away.last_cnr*current_event.away.last_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_da > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.da*90/tot_time/(current_event.away.last_da*current_event.away.last_goal/current_event.away.last_goal)))
                                        }
                                        current_event.awayT.nxt = (current_event.awayT.nxt*100/4).toFixed(0)

                                        current_event.awayT.nxt = -1 * current_event.awayT.nxt
                                    }
                                    else if(away_goal > 0){
                                        current_event.awayT.nxt = 0
                                        if(current_event.away.last_goal > 0 && current_event.away.last_on > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.on*90/tot_time/(current_event.away.last_on*away_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_off > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.off*90/tot_time/(current_event.away.last_off*away_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_cnr > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.cnr*90/tot_time/(current_event.away.last_cnr*away_goal/current_event.away.last_goal)))
                                        }
                                        if(current_event.away.last_goal > 0 && current_event.away.last_da > 0){
                                            current_event.awayT.nxt = current_event.awayT.nxt + ((current_event.awayT.da*90/tot_time/(current_event.away.last_da*away_goal/current_event.away.last_goal)))
                                        }
                                        current_event.awayT.nxt = (current_event.awayT.nxt*100/4 - 100).toFixed(0)

                                        current_event.awayT.nxt = -1 * current_event.awayT.nxt
                                    }
                                }
                                if(current_event.home.gdr > 0){
                                    current_event.home.gdr = current_event.home.gdr.toFixed(0)
                                }
                                if(current_event.away.gdr > 0){
                                    current_event.away.gdr = current_event.away.gdr.toFixed(0)
                                }
                                //----------------------------------goal notification-------------------------------
                                if(current_event.home.id === stats[0].team_id){
                                    if(stats_ten.length > 1){
                                        if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                            current_event.home.flash = 1
                                        }
                                        else{
                                            current_event.home.flash = 0
                                        }
                                        if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                            current_event.away.flash = 1
                                        }
                                        else{
                                            current_event.away.flash = 0
                                        }
                                    }
                                }
                                else{
                                    if(stats_ten.length > 1){
                                        if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                            current_event.home.flash = 1
                                        }
                                        else{
                                            current_event.home.flash = 0
                                        }
                                        if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                            current_event.away.flash = 1
                                        }
                                        else{
                                            current_event.away.flash = 0
                                        }
                                    }
                                }

                                current_event.home.goal = stats[0].goals - stats_ten[0][0].goals
                                current_event.away.goal = stats[1].goals - stats_ten[0][1].goals
                                //---------------------------------------Total Part---------------------------------
                                if(current_event.home.id === stats[0].team_id){
                                    if(stats[0].shots){
                                        if(stats[0].shots.ongoal != null){
                                            current_event.homeT.on = stats[0].shots.ongoal
                                            current_event.awayT.on = stats[1].shots.ongoal
                                        }
                                        if(stats[0].shots.offgoal != null){
                                            current_event.homeT.off = stats[0].shots.offgoal
                                            current_event.awayT.off = stats[1].shots.offgoal
                                        }
                                        if(stats[0].shots.blocked != null){
                                            current_event.homeT.blk = stats[0].shots.blocked
                                            current_event.awayT.blk = stats[1].shots.blocked
                                        }
                                        if(stats[0].shots.insidebox != null){
                                            current_event.homeT.in = stats[0].shots.insidebox
                                            current_event.awayT.in = stats[1].shots.insidebox
                                        }
                                        if(stats[0].shots.outsidebox != null){
                                            current_event.homeT.out = stats[0].shots.outsidebox
                                            current_event.awayT.out = stats[1].shots.outsidebox
                                        }
                                    }
                                    if(stats[0].corners != null){
                                        current_event.homeT.cnr = stats[0].corners
                                        current_event.awayT.cnr = stats[1].corners
                                    }

                                    if(stats[0].attacks != null){
                                        if(stats[0].attacks.dangerous_attacks != null){
                                            current_event.homeT.da = stats[0].attacks.dangerous_attacks
                                            current_event.awayT.da = stats[1].attacks.dangerous_attacks
                                        }
                                    }
                                    if(stats[0].goals != null){
                                        current_event.homeT.goal = stats[0].goals
                                        current_event.awayT.goal = stats[1].goals
                                    }
                                    if(stats[0].possessiontime != null){
                                        current_event.homeT.poss = stats[0].possessiontime
                                        current_event.awayT.poss = stats[1].possessiontime
                                    }
                                    if(stats[0].substitutions != null){
                                        current_event.homeT.sbst = stats[0].substitutions
                                        current_event.awayT.sbst = stats[1].substitutions
                                    }
                                    if(stats[0].redcards != null){
                                        current_event.homeT.red = stats[0].redcards
                                        current_event.awayT.red = stats[1].redcards
                                    }
                                    if(stats[0].yellowcards != null){
                                        current_event.homeT.yel = stats[0].yellowcards
                                        current_event.awayT.yel = stats[1].yellowcards
                                    }
                                }
                                else{
                                    if(stats[0].shots){
                                        if(stats[0].shots.ongoal != null){
                                            current_event.homeT.on = stats[1].shots.ongoal
                                            current_event.awayT.on = stats[0].shots.ongoal
                                        }
                                        if(stats[0].shots.offgoal != null){
                                            current_event.homeT.off = stats[1].shots.offgoal
                                            current_event.awayT.off = stats[0].shots.offgoal
                                        }
                                        if(stats[0].shots.blocked != null){
                                            current_event.homeT.blk = stats[1].shots.blocked
                                            current_event.awayT.blk = stats[0].shots.blocked
                                        }
                                        if(stats[0].shots.insidebox != null){
                                            current_event.homeT.in = stats[1].shots.insidebox
                                            current_event.awayT.in = stats[0].shots.insidebox
                                        }
                                        if(stats[0].shots.outsidebox != null){
                                            current_event.homeT.out = stats[1].shots.outsidebox
                                            current_event.awayT.out = stats[0].shots.outsidebox
                                        }
                                    }
                                    if(stats[0].corners != null){
                                        current_event.homeT.cnr = stats[1].corners
                                        current_event.awayT.cnr = stats[0].corners
                                    }

                                    if(stats[0].attacks != null){
                                        if(stats[0].attacks.dangerous_attacks != null){
                                            current_event.homeT.da = stats[1].attacks.dangerous_attacks
                                            current_event.awayT.da = stats[0].attacks.dangerous_attacks
                                        }
                                    }
                                    if(stats[0].goals != null){
                                        current_event.homeT.goal = stats[1].goals
                                        current_event.awayT.goal = stats[0].goals
                                    }
                                    if(stats[0].possessiontime != null){
                                        current_event.homeT.poss = stats[1].possessiontime
                                        current_event.awayT.poss = stats[0].possessiontime
                                    }
                                    if(stats[0].substitutions != null){
                                        current_event.homeT.sbst = stats[1].substitutions
                                        current_event.awayT.sbst = stats[0].substitutions
                                    }
                                    if(stats[0].redcards != null){
                                        current_event.homeT.red = stats[1].redcards
                                        current_event.awayT.red = stats[0].redcards
                                    }
                                    if(stats[0].yellowcards != null){
                                        current_event.homeT.yel = stats[1].yellowcards
                                        current_event.awayT.yel = stats[0].yellowcards
                                    }
                                }

                                if(current_event.home.last_on > 0 || current_event.home.last_off > 0 || current_event.home.last_cnr > 0 || current_event.home.last_da > 0){
                                    current_event.homeT.rtg = 0
                                    if(home_goal > 0){
                                        if(tot_time > 0 && current_event.home.last_on > 0 && current_event.homeT.on > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.on*90/tot_time/current_event.home.last_on
                                        }
                                        if(tot_time > 0 && current_event.home.last_off > 0 && current_event.homeT.off > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.off*90/tot_time/current_event.home.last_off
                                        }
                                        if(tot_time > 0 && current_event.home.last_cnr > 0 && current_event.homeT.cnr > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.cnr*90/tot_time/current_event.home.last_cnr
                                        }
                                        if(tot_time > 0 && current_event.home.last_da > 0 && current_event.homeT.da > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.da*90/tot_time/current_event.home.last_da
                                        }
                                        if(tot_time > 0 && current_event.home.last_goal > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + home_goal*90/tot_time/current_event.home.last_goal
                                        }
                                        current_event.homeT.rtg = (current_event.homeT.rtg*20 - 100).toFixed(0)
                                    }
                                    else{
                                        if(tot_time > 0 && current_event.home.last_on > 0 && current_event.homeT.on > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.on*90/tot_time/current_event.home.last_on
                                        }
                                        if(tot_time > 0 && current_event.home.last_off > 0 && current_event.homeT.off > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.off*90/tot_time/current_event.home.last_off
                                        }
                                        if(tot_time > 0 && current_event.home.last_cnr > 0 && current_event.homeT.cnr > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.cnr*90/tot_time/current_event.home.last_cnr
                                        }
                                        if(tot_time > 0 && current_event.home.last_da > 0 && current_event.homeT.da > 0){
                                            current_event.homeT.rtg = current_event.homeT.rtg + current_event.homeT.da*90/tot_time/current_event.home.last_da
                                        }
                                        current_event.homeT.rtg = (current_event.homeT.rtg*20 - 100).toFixed(0)
                                    }
                                }
                                else{
                                    current_event.homeT.rtg = '-'
                                }
                                if(current_event.away.last_on > 0 || current_event.away.last_off > 0 || current_event.away.last_cnr > 0 || current_event.away.last_da > 0){
                                    current_event.awayT.rtg = 0
                                    if(away_goal > 0){
                                        if(tot_time > 0 && current_event.away.last_on > 0 && current_event.awayT.on > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.on*90/tot_time/current_event.away.last_on
                                        }
                                        if(tot_time > 0 && current_event.away.last_off > 0 && current_event.awayT.off > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.off*90/tot_time/current_event.away.last_off
                                        }
                                        if(tot_time > 0 && current_event.away.last_cnr > 0 && current_event.awayT.cnr > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.cnr*90/tot_time/current_event.away.last_cnr
                                        }
                                        if(tot_time > 0 && current_event.away.last_da > 0 && current_event.awayT.da > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.da*90/tot_time/current_event.away.last_da
                                        }
                                        if(tot_time > 0 && current_event.away.last_goal > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + away_goal*90/tot_time/current_event.away.last_goal
                                        }
                                        current_event.awayT.rtg = (current_event.awayT.rtg*20 - 100).toFixed(0)
                                    }
                                    else{
                                        if(tot_time > 0 && current_event.away.last_on > 0 && current_event.awayT.on > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.on*90/tot_time/current_event.away.last_on
                                        }
                                        if(tot_time > 0 && current_event.away.last_off > 0 && current_event.awayT.off > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.off*90/tot_time/current_event.away.last_off
                                        }
                                        if(tot_time > 0 && current_event.away.last_cnr > 0 && current_event.awayT.cnr > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.cnr*90/tot_time/current_event.away.last_cnr
                                        }
                                        if(tot_time > 0 && current_event.away.last_da > 0 && current_event.awayT.da > 0){
                                            current_event.awayT.rtg = current_event.awayT.rtg + current_event.awayT.da*90/tot_time/current_event.away.last_da
                                        }
                                        current_event.awayT.rtg = (current_event.awayT.rtg*20 - 100).toFixed(0)
                                    }
                                }
                                else{
                                    current_event.awayT.rtg = '-'
                                }

                                let home_tip_array = {
                                    'on': '',
                                    'off': '',
                                    'in': '',
                                    'out': '',
                                    'blk': '',
                                    'cnr': ''
                                }
                                let away_tip_array = {
                                    'on': '',
                                    'off': '',
                                    'in': '',
                                    'out': '',
                                    'blk': '',
                                    'cnr': ''
                                }

                                // current_event.home_tooltip.onKey = this.create_UUID()
                                // //current_event.home_tooltip.on = home_tip_array.on
                                // current_event.home_tooltip.on = home_tooltip.on

                                // current_event.home_tooltip.offKey = this.create_UUID()
                                // //current_event.home_tooltip.off = home_tip_array.off
                                // current_event.home_tooltip.off = home_tooltip.off

                                // current_event.home_tooltip.inKey = this.create_UUID()
                                // //current_event.home_tooltip.in = home_tip_array.in
                                // current_event.home_tooltip.in = home_tooltip.in

                                // current_event.home_tooltip.outKey = this.create_UUID()
                                // //current_event.home_tooltip.out = home_tip_array.out
                                // current_event.home_tooltip.out = home_tooltip.out

                                // current_event.home_tooltip.blkKey = this.create_UUID()
                                // //current_event.home_tooltip.blk = home_tip_array.blk
                                // current_event.home_tooltip.blk = home_tooltip.blk

                                // current_event.home_tooltip.cnrKey = this.create_UUID()
                                // //current_event.home_tooltip.cnr = home_tip_array.cnr
                                // current_event.home_tooltip.cnr = home_tooltip.cnr

                                // current_event.home_tooltip.redKey = this.create_UUID()
                                // current_event.home_tooltip.red = home_tooltip2.red

                                // current_event.home_tooltip.yelKey = this.create_UUID()
                                // current_event.home_tooltip.yel = home_tooltip2.yel

                                // current_event.home_tooltip.sbstKey = this.create_UUID()
                                // current_event.home_tooltip.sbst = home_tooltip2.sbst

                                // current_event.away_tooltip.onKey = this.create_UUID()
                                // //current_event.away_tooltip.on = away_tip_array.on
                                // current_event.away_tooltip.on = away_tooltip.on

                                // current_event.away_tooltip.offKey = this.create_UUID()
                                // //current_event.away_tooltip.off = away_tip_array.off
                                // current_event.away_tooltip.off = away_tooltip.off

                                // current_event.away_tooltip.inKey = this.create_UUID()
                                // //current_event.away_tooltip.in = away_tip_array.in
                                // current_event.away_tooltip.in = away_tooltip.in

                                // current_event.away_tooltip.outKey = this.create_UUID()
                                // //current_event.away_tooltip.out = away_tip_array.out
                                // current_event.away_tooltip.out = away_tooltip.out

                                // current_event.away_tooltip.blkKey = this.create_UUID()
                                // //current_event.away_tooltip.blk = away_tip_array.blk
                                // current_event.away_tooltip.blk = away_tooltip.blk

                                // current_event.away_tooltip.cnrKey = this.create_UUID()
                                // //current_event.away_tooltip.cnr = away_tip_array.cnr
                                // current_event.away_tooltip.cnr = away_tooltip.cnr

                                // current_event.away_tooltip.redKey = this.create_UUID()
                                // current_event.away_tooltip.red = away_tooltip2.red

                                // current_event.away_tooltip.yelKey = this.create_UUID()
                                // current_event.away_tooltip.yel = away_tooltip2.yel

                                // current_event.away_tooltip.sbstKey = this.create_UUID()
                                // current_event.away_tooltip.sbst = away_tooltip2.sbst

                                if(current_main_data.home_tip_shots){
                                    for(let n = 0 ; n < current_main_data.home_tip_shots.length - 1 ; n++){
                                        if(current_main_data.home_tip_shots[n].shots != null){
                                            if(n === 0 && current_main_data.home_tip_shots[n].shots.ongoal != 0 && current_main_data.home_tip_shots[n].shots.ongoal != null){
                                                let time = current_main_data.home_tip_shots[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                }
                                                home_tip_array.on = home_tip_array.on + " " + time
                                            }
                                            else{
                                                let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.home_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.home_tip_shots[n].shots.ongoal === null){
                                                    current_main_data.home_tip_shots[n].shots.ongoal = 0
                                                }
                                                let check1 = current_main_data.home_tip_shots[n + 1].shots.ongoal - current_main_data.home_tip_shots[n].shots.ongoal
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_shots[n].shots.ongoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.ongoal === null){
                                                        current_main_data.home_tip_shots[n - 1].shots.ongoal = 0
                                                    }
                                                    check2 = current_main_data.home_tip_shots[n].shots.ongoal - current_main_data.home_tip_shots[n - 1].shots.ongoal
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_shots[n + 1].shots.ongoal = current_main_data.home_tip_shots[n].shots.ongoal
                                                }

                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.on = home_tip_array.on + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.on = home_tip_array.on + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.home_tip_shots[n].shots.offgoal != 0 && current_main_data.home_tip_shots[n].shots.offgoal != null){
                                                let time = current_main_data.home_tip_shots[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                }
                                                home_tip_array.off = home_tip_array.off + " " + time
                                            }
                                            else{
                                                let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.home_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.home_tip_shots[n].shots.offgoal === null){
                                                    current_main_data.home_tip_shots[n].shots.offgoal = 0
                                                }
                                                let check1 = current_main_data.home_tip_shots[n + 1].shots.offgoal - current_main_data.home_tip_shots[n].shots.offgoal
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_shots[n].shots.offgoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.offgoal === null){
                                                        current_main_data.home_tip_shots[n - 1].shots.offgoal = 0
                                                    }
                                                    check2 = current_main_data.home_tip_shots[n].shots.offgoal - current_main_data.home_tip_shots[n - 1].shots.offgoal
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_shots[n + 1].shots.offgoal = current_main_data.home_tip_shots[n].shots.offgoal
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.off = home_tip_array.off + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.off = home_tip_array.off + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.home_tip_shots[n].shots.insidebox != 0 && current_main_data.home_tip_shots[n].shots.insidebox != null){
                                                let time = current_main_data.home_tip_shots[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                }
                                                home_tip_array.in = home_tip_array.in + " " + time
                                            }
                                            else{
                                                let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.home_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.home_tip_shots[n].shots.insidebox === null){
                                                    current_main_data.home_tip_shots[n].shots.insidebox = 0
                                                }
                                                let check1 = current_main_data.home_tip_shots[n + 1].shots.insidebox - current_main_data.home_tip_shots[n].shots.insidebox
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_shots[n].shots.insidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.insidebox === null){
                                                        current_main_data.home_tip_shots[n - 1].shots.insidebox = 0
                                                    }
                                                    check2 = current_main_data.home_tip_shots[n].shots.insidebox - current_main_data.home_tip_shots[n - 1].shots.insidebox
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_shots[n + 1].shots.insidebox = current_main_data.home_tip_shots[n].shots.insidebox
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.in = home_tip_array.in + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.in = home_tip_array.in + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.home_tip_shots[n].shots.outsidebox != 0 && current_main_data.home_tip_shots[n].shots.outsidebox != null){
                                                let time = current_main_data.home_tip_shots[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                }
                                                home_tip_array.out = home_tip_array.out + " " + time
                                            }
                                            else{
                                                let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.home_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n].shots.outsidebox === null){
                                                    current_main_data.home_tip_shots[n].shots.outsidebox = 0
                                                }
                                                let check1 = current_main_data.home_tip_shots[n + 1].shots.outsidebox - current_main_data.home_tip_shots[n].shots.outsidebox
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_shots[n].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.outsidebox === null){
                                                        current_main_data.home_tip_shots[n - 1].shots.outsidebox = 0
                                                    }
                                                    check2 = current_main_data.home_tip_shots[n].shots.outsidebox - current_main_data.home_tip_shots[n - 1].shots.outsidebox
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_shots[n + 1].shots.outsidebox = current_main_data.home_tip_shots[n].shots.outsidebox
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.out = home_tip_array.out + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.out = home_tip_array.out + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.home_tip_shots[n].shots.blocked != 0 && current_main_data.home_tip_shots[n].shots.blocked != null){
                                                let time = current_main_data.home_tip_shots[n].time.minute
                                                if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                }
                                                home_tip_array.blk = home_tip_array.blk + " " + time
                                            }
                                            else{
                                                let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.home_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.home_tip_shots[n].shots.blocked === null){
                                                    current_main_data.home_tip_shots[n].shots.blocked = 0
                                                }
                                                let check1 = current_main_data.home_tip_shots[n + 1].shots.blocked - current_main_data.home_tip_shots[n].shots.blocked

                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_shots[n].shots.blocked >= 0 && current_main_data.home_tip_shots[n - 1].shots.blocked === null ){
                                                        current_main_data.home_tip_shots[n - 1].shots.blocked = 0
                                                    }
                                                    check2 = current_main_data.home_tip_shots[n].shots.blocked - current_main_data.home_tip_shots[n - 1].shots.blocked
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_shots[n + 1].shots.blocked = current_main_data.home_tip_shots[n].shots.blocked
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.blk = home_tip_array.blk + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.blk = home_tip_array.blk + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                }
                                if(current_main_data.home_tip_cnr){
                                    for(let n = 0 ; n < current_main_data.home_tip_cnr.length - 1 ; n++){
                                        let time = current_main_data.home_tip_cnr[n].time.minute
                                        if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                            time = time + "+" + current_main_data.home_tip_cnr[n].time.extra_time + "'"
                                        }
                                        if(n === 0 && current_main_data.home_tip_cnr[n].shots != 0 && current_main_data.home_tip_cnr[n].shots != null){
                                            home_tip_array.cnr = home_tip_array.cnr + " " + time
                                        }
                                        else{
                                            if(current_main_data.home_tip_cnr[n + 1].shots >= 0 && current_main_data.home_tip_cnr[n].shots === null){
                                                current_main_data.home_tip_cnr[n].shots = 0
                                            }
                                            let check1 = current_main_data.home_tip_cnr[n + 1].shots - current_main_data.home_tip_cnr[n].shots
                                            let check2 = 0
                                            if(n >= 1){
                                                if(current_main_data.home_tip_cnr[n].shots >= 0 && current_main_data.home_tip_cnr[n - 1].shots === null){
                                                    current_main_data.home_tip_cnr[n - 1].shots = 0
                                                }
                                                check2 = current_main_data.home_tip_cnr[n].shots - current_main_data.home_tip_cnr[n - 1].shots
                                            }
                                            if(check1 < 0){
                                                current_main_data.home_tip_cnr[n + 1].shots =  current_main_data.home_tip_cnr[n].shots
                                            }
                                            if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                home_tip_array.cnr = home_tip_array.cnr + " " + time
                                            }
                                            else if(check1 > 1 && check2 >= 0){
                                                home_tip_array.cnr = home_tip_array.cnr + " " + time + "(" + check1 + ")"
                                            }
                                        }
                                    }
                                }
                                if(current_main_data.away_tip_shots){
                                    for(let n = 0 ; n < current_main_data.away_tip_shots.length - 1 ; n++){
                                        if(current_main_data.away_tip_shots[n].shots != null){

                                            if(n === 0 && current_main_data.away_tip_shots[n].shots.ongoal != 0 && current_main_data.away_tip_shots[n].shots.ongoal != null){
                                                let time = current_main_data.away_tip_shots[n].time.minute
                                                if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                }
                                                away_tip_array.on = away_tip_array.on + " " + time
                                            }
                                            else{
                                                let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.away_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.away_tip_shots[n].shots.ongoal === null){
                                                    current_main_data.away_tip_shots[n].shots.ongoal = 0
                                                }
                                                let check1 = current_main_data.away_tip_shots[n + 1].shots.ongoal - current_main_data.away_tip_shots[n].shots.ongoal
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_shots[n].shots.ongoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.ongoal === null){
                                                        current_main_data.away_tip_shots[n - 1].shots.ongoal = 0
                                                    }
                                                    check2 = current_main_data.away_tip_shots[n].shots.ongoal - current_main_data.away_tip_shots[n - 1].shots.ongoal
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_shots[n + 1].shots.ongoal = current_main_data.away_tip_shots[n].shots.ongoal
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.on = away_tip_array.on + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.on = away_tip_array.on + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.away_tip_shots[n].shots.offgoal != 0 && current_main_data.away_tip_shots[n].shots.offgoal != null){
                                                let time = current_main_data.away_tip_shots[n].time.minute
                                                if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                }
                                                away_tip_array.off = away_tip_array.off + " " + time
                                            }
                                            else{
                                                let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.away_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.away_tip_shots[n].shots.offgoal === null){
                                                    current_main_data.away_tip_shots[n].shots.offgoal = 0
                                                }
                                                let check1 = current_main_data.away_tip_shots[n + 1].shots.offgoal - current_main_data.away_tip_shots[n].shots.offgoal
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_shots[n].shots.offgoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.offgoal === null){
                                                        current_main_data.away_tip_shots[n - 1].shots.offgoal = 0
                                                    }
                                                    check2 = current_main_data.away_tip_shots[n].shots.offgoal - current_main_data.away_tip_shots[n - 1].shots.offgoal
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_shots[n + 1].shots.offgoal = current_main_data.away_tip_shots[n].shots.offgoal
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.off = away_tip_array.off + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.off = away_tip_array.off + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.away_tip_shots[n].shots.insidebox != 0 && current_main_data.away_tip_shots[n].shots.insidebox != null){
                                                let time = current_main_data.away_tip_shots[n].time.minute
                                                if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                }
                                                away_tip_array.in = away_tip_array.in + " " + time
                                            }
                                            else{
                                                let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.away_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.away_tip_shots[n].shots.insidebox === null){
                                                    current_main_data.away_tip_shots[n].shots.insidebox = 0
                                                }
                                                let check1 = current_main_data.away_tip_shots[n + 1].shots.insidebox - current_main_data.away_tip_shots[n].shots.insidebox
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_shots[n].shots.insidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.insidebox === null){
                                                        current_main_data.away_tip_shots[n - 1].shots.insidebox = 0
                                                    }
                                                    check2 = current_main_data.away_tip_shots[n].shots.insidebox - current_main_data.away_tip_shots[n - 1].shots.insidebox
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_shots[n + 1].shots.insidebox = current_main_data.away_tip_shots[n].shots.insidebox
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.in = away_tip_array.in + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.in = away_tip_array.in + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.away_tip_shots[n].shots.outsidebox != 0 && current_main_data.away_tip_shots[n].shots.outsidebox != null){
                                                let time = current_main_data.away_tip_shots[n].time.minute
                                                if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                }
                                                away_tip_array.out = away_tip_array.out + " " + time
                                            }
                                            else{
                                                let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.away_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n].shots.outsidebox === null){
                                                    current_main_data.away_tip_shots[n].shots.outsidebox = 0
                                                }
                                                let check1 = current_main_data.away_tip_shots[n + 1].shots.outsidebox - current_main_data.away_tip_shots[n].shots.outsidebox
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_shots[n].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.outsidebox === null){
                                                        current_main_data.away_tip_shots[n - 1].shots.outsidebox = 0
                                                    }
                                                    check2 = current_main_data.away_tip_shots[n].shots.outsidebox - current_main_data.away_tip_shots[n - 1].shots.outsidebox
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_shots[n + 1].shots.outsidebox = current_main_data.away_tip_shots[n].shots.outsidebox
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.out = away_tip_array.out + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.out = away_tip_array.out + " " + time + "(" + check1 + ")"
                                                }
                                            }

                                            if(n === 0 && current_main_data.away_tip_shots[n].shots.blocked != 0 && current_main_data.away_tip_shots[n].shots.blocked != null){
                                                let time = current_main_data.away_tip_shots[n].time.minute
                                                if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                }
                                                away_tip_array.blk = away_tip_array.blk + " " + time
                                            }
                                            else{
                                                let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                    time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                }
                                                if(current_main_data.away_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.away_tip_shots[n].shots.blocked === null){
                                                    current_main_data.away_tip_shots[n].shots.blocked = 0
                                                }
                                                let check1 = current_main_data.away_tip_shots[n + 1].shots.blocked - current_main_data.away_tip_shots[n].shots.blocked
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_shots[n].shots.blocked >= 0 && current_main_data.away_tip_shots[n - 1].shots.blocked === null){
                                                        current_main_data.away_tip_shots[n - 1].shots.blocked = 0
                                                    }
                                                    check2 = current_main_data.away_tip_shots[n].shots.blocked - current_main_data.away_tip_shots[n - 1].shots.blocked
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_shots[n + 1].shots.blocked = current_main_data.away_tip_shots[n].shots.blocked
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.blk = away_tip_array.blk + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.blk = away_tip_array.blk + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                }
                                if(current_main_data.away_tip_cnr){
                                    for(let n = 0 ; n < current_main_data.away_tip_cnr.length - 1 ; n++){
                                        let time = current_main_data.away_tip_cnr[n].time.minute
                                        if(current_main_data.away_tip_cnr[n].time.extra_time > 0){
                                            time = time + "+" + current_main_data.away_tip_cnr[n].time.extra_time + "'"
                                        }
                                        if(n === 0 && current_main_data.away_tip_cnr[n].shots != 0 && current_main_data.away_tip_cnr[n].shots != null){
                                            away_tip_array.cnr = away_tip_array.cnr + " " + time
                                        }
                                        else{
                                            if(current_main_data.away_tip_cnr[n + 1].shots >= 0 && current_main_data.away_tip_cnr[n].shots === null){
                                                current_main_data.away_tip_cnr[n].shots = 0
                                            }
                                            let check1  = current_main_data.away_tip_cnr[n + 1].shots - current_main_data.away_tip_cnr[n].shots
                                            let check2 = 0
                                            if(n >= 1){
                                                if(current_main_data.away_tip_cnr[n].shots >= 0 && current_main_data.away_tip_cnr[n - 1].shots === null){
                                                    current_main_data.away_tip_cnr[n - 1].shots = 0
                                                }
                                                check2  = current_main_data.away_tip_cnr[n].shots - current_main_data.away_tip_cnr[n - 1].shots
                                            }
                                            if(check1 < 0){
                                                current_main_data.away_tip_cnr[n + 1].shots = current_main_data.away_tip_cnr[n].shots
                                            }
                                            if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                away_tip_array.cnr = away_tip_array.cnr + " " + time
                                            }
                                            else if(check1 > 1 && check2 >= 0){
                                                away_tip_array.cnr = away_tip_array.cnr + " " + time + "(" + check1 + ")"
                                            }
                                        }
                                    }
                                }

                                if(current_event.home_tooltip.on != home_tip_array.on && home_tip_array.on != ''){
                                    current_event.home_tooltip.onKey = this.create_UUID()
                                    current_event.home_tooltip.on = home_tip_array.on
                                }
                                if(current_event.home_tooltip.off != home_tip_array.off && home_tip_array.off != ''){
                                    current_event.home_tooltip.offKey = this.create_UUID()
                                    current_event.home_tooltip.off = home_tip_array.off
                                }
                                if(current_event.home_tooltip.in != home_tip_array.in && home_tip_array.in != ''){
                                    current_event.home_tooltip.inKey = this.create_UUID()
                                    current_event.home_tooltip.in = home_tip_array.in
                                }
                                if(current_event.home_tooltip.out != home_tip_array.out && home_tip_array.out != ''){
                                    current_event.home_tooltip.outKey = this.create_UUID()
                                    current_event.home_tooltip.out = home_tip_array.out
                                }
                                if(current_event.home_tooltip.blk != home_tip_array.blk && home_tip_array.blk != ''){
                                    current_event.home_tooltip.blkKey = this.create_UUID()
                                    current_event.home_tooltip.blk = home_tip_array.blk
                                }
                                if(current_event.home_tooltip.cnr != home_tip_array.cnr && home_tip_array.cnr != ''){
                                    current_event.home_tooltip.cnrKey = this.create_UUID()
                                    current_event.home_tooltip.cnr = home_tip_array.cnr
                                }

                                if(current_event.away_tooltip.on != away_tip_array.on && away_tip_array.on != ''){
                                    current_event.away_tooltip.onKey = this.create_UUID()
                                    current_event.away_tooltip.on = away_tip_array.on
                                }
                                if(current_event.away_tooltip.off != away_tip_array.off && away_tip_array.off != ''){
                                    current_event.away_tooltip.offKey = this.create_UUID()
                                    current_event.away_tooltip.off = away_tip_array.off
                                }
                                if(current_event.away_tooltip.in != away_tip_array.in && away_tip_array.in != ''){
                                    current_event.away_tooltip.inKey = this.create_UUID()
                                    current_event.away_tooltip.in = away_tip_array.in
                                }
                                if(current_event.away_tooltip.out != away_tip_array.out && away_tip_array.out != ''){
                                    current_event.away_tooltip.outKey = this.create_UUID()
                                    current_event.away_tooltip.out = away_tip_array.out
                                }
                                if(current_event.away_tooltip.blk != away_tip_array.blk && away_tip_array.blk != ''){
                                    current_event.away_tooltip.blkKey = this.create_UUID()
                                    current_event.away_tooltip.blk = away_tip_array.blk
                                }
                                if(current_event.away_tooltip.cnr != away_tip_array.cnr && away_tip_array.cnr != ''){
                                    current_event.away_tooltip.cnrKey = this.create_UUID()
                                    current_event.away_tooltip.cnr = away_tip_array.cnr
                                }
                                if(current_event.goal_tooltip != goal_tooltip && goal_tooltip != ''){
                                    current_event.goalKey = this.create_UUID()
                                    current_event.goal_tooltip = goal_tooltip
                                }

                                ////         red yellow tooltip   
                                
                                    current_event.home_tooltip.redKey = this.create_UUID()
                                    current_event.home_tooltip.red = current_main_data.home_tooltip2.redCard
                                
                                    current_event.home_tooltip.yelKey = this.create_UUID()
                                    current_event.home_tooltip.yel = current_main_data.home_tooltip2.yelCard

                                    console.log('current_main_data.home_tooltip2.yelCard', current_main_data.home_tooltip2.yelCard)
                                
                                
                                    current_event.home_tooltip.sbstKey = this.create_UUID()
                                    current_event.home_tooltip.sbst = current_main_data.home_tooltip2.subs
                                
                                    current_event.away_tooltip.redKey = this.create_UUID()
                                    current_event.away_tooltip.red = current_main_data.away_tooltip2.redCard
                                
                                
                                    current_event.away_tooltip.yelKey = this.create_UUID()
                                    current_event.away_tooltip.yel = current_main_data.away_tooltip2.yelCard
                                
                                    current_event.away_tooltip.sbstKey = this.create_UUID()
                                    current_event.away_tooltip.sbst = current_main_data.away_tooltip2.subs
                                

                                current_event.goalKey = this.create_UUID()
                                current_event.goal_tooltip = goal_tooltip

                                if(current_event.home.on > current_event.home_season.on/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.on = 'green'}
                                else{ current_event.home1.on = 'red'}
                                if(current_event.home.off > current_event.home_season.off/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.off = 'green'}
                                else{ current_event.home1.off = 'red'}
                                if(current_event.home.blk > current_event.home_season.block/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.blk = 'green'}
                                else{ current_event.home1.blk = 'red'}
                                if(current_event.home.in > current_event.home_season.in/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.in = 'green'}
                                else{ current_event.home1.in = 'red'}
                                if(current_event.home.out > current_event.home_season.out/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.out = 'green'}
                                else{ current_event.home1.out = 'red'}
                                if(current_event.home.cnr > current_event.home_season.cnr/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.cnr = 'green'}
                                else{ current_event.home1.cnr = 'red'}
                                if(current_event.home.da > current_event.home_season.da/9/(current_event.home_season.p + 0.00000001)){ current_event.home1.da = 'green'}
                                else{ current_event.home1.da = 'red'}
                                if(current_event.home.poss > current_event.home_season.pos/(current_event.home_season.p + 0.00000001)){ current_event.home1.poss = 'green'}
                                else{ current_event.home1.poss = 'red'}

                                if(current_event.away.on > current_event.away_season.on/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.on = 'green'}
                                else{ current_event.away1.on = 'red' }
                                if(current_event.away.off > current_event.away_season.off/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.off = 'green'}
                                else{ current_event.away1.off = 'red' }
                                if(current_event.away.blk > current_event.away_season.block/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.blk = 'green'}
                                else{ current_event.away1.blk = 'red' }
                                if(current_event.away.in > current_event.away_season.in/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.in = 'green'}
                                else{ current_event.away1.in = 'red' }
                                if(current_event.away.out > current_event.away_season.out/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.out = 'green'}
                                else{ current_event.away1.out = 'red' }
                                if(current_event.away.cnr > current_event.away_season.cnr/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.cnr = 'green'}
                                else{ current_event.away1.cnr = 'red' }
                                if(current_event.away.da > current_event.away_season.da/9/(current_event.away_season.p + 0.00000001)){ current_event.away1.da = 'green'}
                                else{ current_event.away1.da = 'red' }
                                if(current_event.away.poss > current_event.away_season.pos/(current_event.away_season.p + 0.00000001)){ current_event.away1.poss = 'green'}
                                else{ current_event.away1.poss = 'red' }

                                if(current_event.home_season.p == 0){
                                    current_event.home1 = {
                                        'on': 'black',
                                        'off': 'black',
                                        'blk': 'black',
                                        'in': 'black',
                                        'out': 'black',
                                        'cnr': 'black',
                                        'da': 'black',
                                        'poss': 'black',
                                    }
                                }
                                if(current_event.away_season.p == 0){
                                    current_event.away1 = {
                                        'on': 'black',
                                        'off': 'black',
                                        'blk': 'black',
                                        'in': 'black',
                                        'out': 'black',
                                        'cnr': 'black',
                                        'da': 'black',
                                        'poss': 'black',
                                    }
                                }

                                // this.item1 = current_event
                                this.goal_key = current_event.goalKey
                                this.goal_tooltip = goal_tooltip

                                console.log('this.item1', this.item1)
                                ////console.log("home_tooltip=>++++++++", current_event.home_tooltip, current_main_data)
                                //console.log("away_tooltip=>++++++++", current_event.away_tooltip)
                            }
                        }
                    }

                    for(let i = 0 ; i < self.mainList.length ; i++){
                        for(let j = 0 ; j < data1.length ; j++){
                            if(self.mainList[i].fixtureId == data1[j].updateArray._id){
                                self.mainList[i].livestatus = data1[j].updateArray
                            }
                        }
                    }
                    var alertidArray = []
                    for (var i = 0; i < this.alertArray.length; i++) {
                        alertidArray.push(this.alertArray[i].name + this.alertArray[i].alertName)
                    }
                    self.alertArray = []
                    //console.log("alert part by stats===>")
                    if(this.calc_odd != 0 && this.calc_stake != 0 && this.eventId != 0){
                        if(this.riskTrading == 'auto'){
                            //console.log("===>auto Trading Check==>", val1)
                            let val1 = this.selectedValue
                            let eventId = parseInt(val1.split(',')[1])
                            let marketType = val1.split(',')[2]
                            let team = val1.split(',')[3]
                            let runnerNo = val1.split(',')[6]
                            let pred = ""
                            let self = this
                            if(marketType == 'MATCH_ODDS'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- 1 - Back'
                                    }
                                    else{
                                        pred = '- 1 - Lay'
                                    }
                                }
                                else if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- 2 - Back'
                                    }
                                    else{
                                        pred = '- 2 - Lay'
                                    }
                                }
                                else if(team == '2'){
                                    if(runnerNo == '0'){
                                        pred = '- X - Back'
                                    }
                                    else{
                                        pred = '- X - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_05'){
                                if(team == '1'){
                                    if(runnerNo == '0'){
                                        pred = '- O 0.5 - Back'
                                    }
                                    else{
                                        pred = '- O 0.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_15'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 1.5 - Back'
                                    }
                                    else{
                                        pred = '- U 1.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 1.5 - Back'
                                    }
                                    else{
                                        pred = '- O 1.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_25'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 2.5 - Back'
                                    }
                                    else{
                                        pred = '- U 2.5 - Lay'
                                    }
                                }
                                else{
                                    if(runnerNo == '0'){
                                        pred = '- O 2.5 - Back'
                                    }
                                    else{
                                        pred = '- O 2.5 - Lay'
                                    }
                                }
                            }
                            else if(marketType == 'OVER_UNDER_35'){
                                if(team == '0'){
                                    if(runnerNo == '0'){
                                        pred = '- U 3.5 - Back'
                                    }
                                    else{
                                        pred = '- U 3.5 - Lay'
                                    }
                                }
                            }
                            let predT = self.pred_type_list.filter(function(item) {
                                return item.label == pred
                            })
                            //console.log('predT====>', predT, pred, self.cashoutTable)
                            if(predT.length > 0){
                                for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                    if(predT[0].value == self.cashoutTable[k].PredType.value){
                                        let triger = {
                                            "maxOddPre": 1000000,
                                            "minOddPre": 0,
                                            "maxOddLive": 1000000,
                                            "minOddLive": 0,
                                            "minscoreHome": 0,
                                            "maxscoreHome": 100,
                                            "minscoreAway": 0,
                                            "maxscoreAway": 100,
                                            "min_total_goal": 0,
                                            "max_total_goal": 100,
                                            "minTime": 0,
                                            "maxTime": 150,
                                            "matchStatus": 0,
                                            "alertName": null,
                                            "minonHome": 0,
                                            "maxonHome": 100,
                                            "minoffHome": 0,
                                            "maxoffHome": 100,
                                            "minonAway": 0,
                                            "maxonAway": 100,
                                            "minoffAway": 0,
                                            "maxoffAway": 100,
                                            "min_profit": -1000,
                                            "max_profit": 1000000000,
                                            "stop_loss": false,
                                            "tradingMode": false
                                        }
                                        if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                            triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                            triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                        }
                                        if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                            triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                        }
                                        if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                            triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                        }
                                        if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                            triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                        }
                                        if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                            triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                        }
                                        if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                            triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                        }
                                        if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                            triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                        }
                                        if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                            triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                            triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                        }
                                        if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                            triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                        }
                                        if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                            triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                        }
                                        if(self.cashoutTable[k].MatchStatus.value != null){
                                            triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                        }
                                        if(self.cashoutTable[k].Alert_Name.value != null){
                                            triger.alertName = self.cashoutTable[k].Alert_Name.value
                                        }
                                        if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                            triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                        }
                                        if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                            triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                        }
                                        if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                            triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                        }
                                        if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                            triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                        }
                                        if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                            triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                        }
                                        if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                            triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                        }
                                        if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                            triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                        }
                                        if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                            triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                        }
                                        if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                            triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                        }
                                        if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                            triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                        }
                                        if(self.cashoutTable[k].stop_loss.value != false){
                                            triger.stop_loss = true
                                        }
                                        if(self.cashoutTable[k].tradingMode.value != false){
                                            triger.tradingMode = true
                                        }
                                        for(let j = 0; j < self.mainList.length; j++){
                                            if(eventId == self.mainList[j].eventId){
                                                if (self.mainList[j].DailyApiEvents1.length == 0)
                                                    continue
                                                let eventTriger = {
                                                    "name": self.selectedLabel,
                                                    "oddPre": null,
                                                    "oddLive": null,
                                                    "scoreHome": 0,
                                                    "scoreAway": 0,
                                                    "total_goal": 0,
                                                    "min_total_goal": 0,
                                                    "max_total_goal": 0,
                                                    "time": 0,
                                                    "matchStatus": null,
                                                    "alertName": self.cashoutAlertName,
                                                    "onHome": 0,
                                                    "offHome": 0,
                                                    "onAway": 0,
                                                    "offAway": 0,
                                                    "c_color": "green",
                                                    "profit": parseFloat(this.currentPercent),
                                                    "stop_loss": self.stopLoss,
                                                    "tradingMode": self.tradingMode
                                                }
                                                let eventNode = self.mainList[j]
                                                if(eventNode.score){
                                                    let scoreDetail = eventNode.score
                                                    eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                    eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                    eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                }
                                                if(eventNode.status){
                                                    eventTriger.matchStatus = 1
                                                    eventTriger.time = eventNode.timeElapsed
                                                }
                                                else if(!eventNode.status){
                                                    eventTriger.matchStatus = 0
                                                }
                                                for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                    let marketNode = self.mainList[j].markets[c]
                                                    let check = 0
                                                    if(marketNode.marketType == marketType){
                                                        if(marketNode.state){
                                                            if(marketNode.state.status == "CLOSED"){
                                                                eventTriger.matchStatus = 0
                                                                check = 1
                                                            }
                                                        }
                                                        if(check === 0){
                                                            let runnerNode = marketNode.runners[team]
                                                            let prematchMarket = null
                                                            if(self.mainList[j].markets[c].prematchMarket){
                                                                prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                            }
                                                            if(eventNode.status && prematchMarket != null){
                                                                let runnerlists = prematchMarket.runners[team]
                                                                if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                }
                                                                if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                    eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToBack){
                                                                    if(runnerNo == 0){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                if(runnerNode.exchange.availableToLay){
                                                                    if(runnerNo == 1){
                                                                        eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                            if(runnerNo == 0){
                                                                if(runnerNode.exchange.availableToBack){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            else{
                                                                if(runnerNode.exchange.availableToLay){
                                                                    eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                let liveStatsNode = self.mainList[j].livestatus
                                                let liveNode = liveStatsNode.stats
                                                if(liveStatsNode.stats){
                                                    if(liveStatsNode.stats.length > 1){
                                                        if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                            if(liveStatsNode.stats[0].shots != null){
                                                                eventTriger.onHome = liveNode[0].shots.ongoal
                                                                eventTriger.offHome = liveNode[0].shots.offgoal
                                                                eventTriger.onAway = liveNode[1].shots.ongoal
                                                                eventTriger.offAway = liveNode[1].shots.offgoal
                                                            }
                                                        }
                                                        else{
                                                            if(liveStatsNode.stats[1].shots != null){
                                                                eventTriger.onHome = liveNode[1].shots.ongoal
                                                                eventTriger.offHome = liveNode[1].shots.offgoal
                                                                eventTriger.onAway = liveNode[0].shots.ongoal
                                                                eventTriger.offAway = liveNode[0].shots.offgoal
                                                            }
                                                        }
                                                    }
                                                }
                                                //console.log('****************************cash out message check cond= >', triger)
                                                //console.log('****************************cash out message check value= >', eventTriger)
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                            if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                if(triger.alertName == eventTriger.alertName){
                                                                                                    this.percentTextColor1 = '#000'
                                                                                                    this.percentBackgroundColor = '#ffc000'
                                                                                                    this.percent_text1 = 'Cash Out Now! '
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    for(let i = 1 ; i < self.eventLists3.length ; i++){
                        // //console.log('self.prediction list console=>', self.eventLists3[i].label)
                        let val1 = self.eventLists3[i].value
                        let eventId = parseInt(val1.split(',')[1])
                        let marketType = val1.split(',')[2]
                        let team = val1.split(',')[3]
                        let runnerNo = val1.split(',')[6]
                        let pred = ""

                        if(marketType == 'MATCH_ODDS'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- 1 - Back'
                                }
                                else{
                                    pred = '- 1 - Lay'
                                }
                            }
                            else if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- 2 - Back'
                                }
                                else{
                                    pred = '- 2 - Lay'
                                }
                            }
                            else if(team == '2'){
                                if(runnerNo == '0'){
                                    pred = '- X - Back'
                                }
                                else{
                                    pred = '- X - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_05'){
                            if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- O 0.5 - Back'
                                }
                                else{
                                    pred = '- O 0.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_15'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 1.5 - Back'
                                }
                                else{
                                    pred = '- U 1.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 1.5 - Back'
                                }
                                else{
                                    pred = '- O 1.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_25'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 2.5 - Back'
                                }
                                else{
                                    pred = '- U 2.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 2.5 - Back'
                                }
                                else{
                                    pred = '- O 2.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_35'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 3.5 - Back'
                                }
                                else{
                                    pred = '- U 3.5 - Lay'
                                }
                            }
                        }
                        let predT = self.pred_type_list.filter(function(item) {
                            return item.label == pred
                        })
                        if(predT.length > 0){
                            for(let k = 0 ; k < self.adminTable1.length ; k++){
                                if(predT[0].value == self.adminTable1[k].PredType.value){
                                    let triger = {
                                        "maxOddPre": 1000000,
                                        "minOddPre": 0,
                                        "maxOddLive": 1000000,
                                        "minOddLive": 0,
                                        "minscoreHome": 0,
                                        "maxscoreHome": 100,
                                        "minscoreAway": 0,
                                        "maxscoreAway": 100,
                                        "min_total_goal": 0,
                                        "max_total_goal": 100,
                                        "minTime": 0,
                                        "maxTime": 150,
                                        "matchStatus": 0,
                                        "alertName": null,
                                        "minonHome": 0,
                                        "maxonHome": 100,
                                        "minoffHome": 0,
                                        "maxoffHome": 100,
                                        "minonAway": 0,
                                        "maxonAway": 100,
                                        "minoffAway": 0,
                                        "maxoffAway": 100,
                                        "switch_f": 100,
                                        "hold_on": 100
                                    }
                                    if(self.adminTable1[k].maxOddpre.value != null && self.adminTable1[k].maxOddpre.value != ""){
                                        triger.maxOddPre = parseFloat(self.adminTable1[k].maxOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddpre.value != null && self.adminTable1[k].minOddpre.value != ""){
                                        triger.minOddPre = parseFloat(self.adminTable1[k].minOddpre.value)
                                    }
                                    if(self.adminTable1[k].minOddlive.value != null && self.adminTable1[k].minOddlive.value != ""){
                                        triger.minOddLive = parseFloat(self.adminTable1[k].minOddlive.value)
                                    }
                                    if(self.adminTable1[k].maxoddlive.value != null && self.adminTable1[k].maxoddlive.value != ""){
                                        triger.maxOddLive = parseFloat(self.adminTable1[k].maxoddlive.value)
                                    }
                                    if(self.adminTable1[k].min_score_home.value != null && self.adminTable1[k].min_score_home.value != ""){
                                        triger.minscoreHome = parseFloat(self.adminTable1[k].min_score_home.value)
                                    }
                                    if(self.adminTable1[k].max_score_home.value != null && self.adminTable1[k].max_score_home.value != ""){
                                        triger.maxscoreHome = parseFloat(self.adminTable1[k].max_score_home.value)
                                    }
                                    if(self.adminTable1[k].min_score_away.value != null && self.adminTable1[k].min_score_away.value != ""){
                                        triger.minscoreAway = parseFloat(self.adminTable1[k].min_score_away.value)
                                    }
                                    if(self.adminTable1[k].max_score_away.value != null && self.adminTable1[k].max_score_away.value != ""){
                                        triger.maxscoreAway = parseFloat(self.adminTable1[k].max_score_away.value)
                                    }
                                    if(self.adminTable1[k].min_total_goal.value != null && self.adminTable1[k].min_total_goal.value != ""){
                                        triger.min_total_goal = parseFloat(self.adminTable1[k].min_total_goal.value)
                                    }
                                    if(self.adminTable1[k].max_total_goal.value != null && self.adminTable1[k].max_total_goal.value != ""){
                                        triger.max_total_goal = parseFloat(self.adminTable1[k].max_total_goal.value)
                                    }
                                    if(self.adminTable1[k].min_time.value != null && self.adminTable1[k].min_time.value != ""){
                                        triger.minTime = parseInt(self.adminTable1[k].min_time.value)
                                    }
                                    if(self.adminTable1[k].max_time.value != null && self.adminTable1[k].max_time.value != ""){
                                        triger.maxTime = parseInt(self.adminTable1[k].max_time.value)
                                    }
                                    if(self.adminTable1[k].MatchStatus.value != null){
                                        triger.matchStatus = self.adminTable1[k].MatchStatus.value
                                    }
                                    if(self.adminTable1[k].Alert_Name.value != null){
                                        triger.alertName = self.adminTable1[k].Alert_Name.value
                                    }
                                    if(self.adminTable1[k].min_on_home.value != null && self.adminTable1[k].min_on_home.value != ""){
                                        triger.minonHome = parseInt(self.adminTable1[k].min_on_home.value)
                                    }
                                    if(self.adminTable1[k].max_on_home.value != null && self.adminTable1[k].max_on_home.value != ""){
                                        triger.maxonHome = parseInt(self.adminTable1[k].max_on_home.value)
                                    }
                                    if(self.adminTable1[k].min_off_home.value != null && self.adminTable1[k].min_off_home.value != ""){
                                        triger.minoffHome = parseInt(self.adminTable1[k].min_off_home.value)
                                    }
                                    if(self.adminTable1[k].max_off_home.value != null && self.adminTable1[k].max_off_home.value != ""){
                                        triger.maxoffHome = parseInt(self.adminTable1[k].max_off_home.value)
                                    }
                                    if(self.adminTable1[k].min_on_away.value != null && self.adminTable1[k].min_on_away.value != ""){
                                        triger.minonAway = parseInt(self.adminTable1[k].min_on_away.value)
                                    }
                                    if(self.adminTable1[k].max_on_away.value != null && self.adminTable1[k].max_on_away.value != ""){
                                        triger.maxonAway = parseInt(self.adminTable1[k].max_on_away.value)
                                    }
                                    if(self.adminTable1[k].min_off_away.value != null && self.adminTable1[k].min_off_away.value != ""){
                                        triger.minoffAway = parseInt(self.adminTable1[k].min_off_away.value)
                                    }
                                    if(self.adminTable1[k].max_off_away.value != null && self.adminTable1[k].max_off_away.value != ""){
                                        triger.maxoffAway = parseInt(self.adminTable1[k].max_off_away.value)
                                    }
                                    if(self.adminTable1[k].switch_btn.value != null && self.adminTable1[k].switch_btn.value != ""){
                                        triger.switch_f = parseInt(self.adminTable1[k].switch_btn.value)
                                    }
                                    if(self.adminTable1[k].hold_on.value != null && self.adminTable1[k].hold_on.value != ""){
                                        triger.hold_on = parseInt(self.adminTable1[k].hold_on.value)
                                    }
                                    for(let j = 0; j < self.mainList.length; j++){
                                        if(eventId == self.mainList[j].eventId){
                                            if (self.mainList[j].DailyApiEvents1.length == 0)
                                                continue
                                            let eventTriger = {
                                                "name": self.eventLists3[i].label,
                                                "oddPre": null,
                                                "oddLive": null,
                                                "scoreHome": 0,
                                                "scoreAway": 0,
                                                "total_goal": 0,
                                                "min_total_goal": 0,
                                                "max_total_goal": 0,
                                                "time": 0,
                                                "matchStatus": null,
                                                "alertName": null,
                                                "onHome": 0,
                                                "offHome": 0,
                                                "onAway": 0,
                                                "offAway": 0,
                                                "c_color": "green"
                                            }
                                            // let eventTriger = {
                                            //     "name": self.eventLists3[i].label,
                                            //     "oddPre": null,
                                            //     "oddLive": null,
                                            //     "scoreHome": 100000,
                                            //     "scoreAway": 100000,
                                            //     "total_goal": 100000,
                                            //     "min_total_goal": 100000,
                                            //     "max_total_goal": 100000,
                                            //     "time": 100000,
                                            //     "matchStatus": null,
                                            //     "alertName": null,
                                            //     "onHome": 100000,
                                            //     "offHome": 100000,
                                            //     "onAway": 100000,
                                            //     "offAway": 100000,
                                            //     "c_color": "green"
                                            // }
                                            let eventNode = self.mainList[j]
                                            if(eventNode.score){
                                                let scoreDetail = eventNode.score
                                                eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                            }
                                            if(eventNode.status){
                                                eventTriger.matchStatus = 1
                                                eventTriger.time = eventNode.timeElapsed
                                            }
                                            else if(!eventNode.status){
                                                eventTriger.matchStatus = 0
                                            }
                                            for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                let marketNode = self.mainList[j].markets[c]
                                                let check = 0
                                                if(marketNode.marketType == marketType){
                                                    if(marketNode.state){
                                                        if(marketNode.state.status == "CLOSED"){
                                                            eventTriger.matchStatus = 0
                                                            check = 1
                                                        }
                                                    }
                                                    if(check === 0){
                                                        let runnerNode = marketNode.runners[team]
                                                        let prematchMarket = null
                                                        if(self.mainList[j].markets[c].prematchMarket){
                                                            prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                        }
                                                        if(eventNode.status && prematchMarket != null){
                                                            let runnerlists = prematchMarket.runners[team]
                                                            if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                            }
                                                            if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNo == 0){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            if(runnerNode.exchange.availableToLay){
                                                                if(runnerNo == 1){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                        if(runnerNo == 0){
                                                            if(runnerNode.exchange.availableToBack){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToLay){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            let liveStatsNode = self.mainList[j].livestatus
                                            let liveNode = liveStatsNode.stats
                                            if(liveStatsNode.stats){
                                                if(liveStatsNode.stats.length > 1){
                                                    if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                        if(liveStatsNode.stats[0].shots != null){
                                                            eventTriger.onHome = liveNode[0].shots.ongoal
                                                            eventTriger.offHome = liveNode[0].shots.offgoal
                                                            eventTriger.onAway = liveNode[1].shots.ongoal
                                                            eventTriger.offAway = liveNode[1].shots.offgoal
                                                        }
                                                    }
                                                    else{
                                                        if(liveStatsNode.stats[1].shots != null){
                                                            eventTriger.onHome = liveNode[1].shots.ongoal
                                                            eventTriger.offHome = liveNode[1].shots.offgoal
                                                            eventTriger.onAway = liveNode[0].shots.ongoal
                                                            eventTriger.offAway = liveNode[0].shots.offgoal
                                                        }
                                                    }
                                                }
                                            }
                                            // //console.log("=======================Condition=========================>", triger)
                                            // //console.log("==========================data===========================>", eventTriger, liveStatsNode)
                                            if(triger.switch_f == 100){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        eventTriger.alertName = triger.alertName
                                                                                        self.alertArray.push(eventTriger)
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 1){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre <= triger.maxOddPre) {
                                                                                        if (eventTriger.oddPre > triger.minOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 2){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre >= triger.minOddPre) {
                                                                                        if (eventTriger.oddPre < triger.maxOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 3){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive <= triger.maxOddLive) {
                                                                                        if (eventTriger.oddLive > triger.minOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 4){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive >= triger.minOddLive) {
                                                                                        if (eventTriger.oddLive < triger.maxOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 5){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                                        if (eventTriger.scoreHome > triger.minscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 6){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                                        if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 20){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                                        if (eventTriger.scoreAway > triger.minscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 21){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                                        if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 8){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.max_total_goal) {
                                                                                        if (eventTriger.total_goal > triger.min_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 9){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.min_total_goal) {
                                                                                        if (eventTriger.total_goal < triger.max_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 10){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time <= triger.maxTime) {
                                                                                        if (eventTriger.time > triger.minTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 11){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time >= triger.minTime) {
                                                                                        if (eventTriger.time < triger.maxTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 12){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome <= triger.maxonHome) {
                                                                                        if (eventTriger.onHome > triger.minonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 13){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 14){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onAway <= triger.maxonAway) {
                                                                                        if (eventTriger.onAway > triger.minonAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 15){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 16){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome <= triger.maxoffHome) {
                                                                                        if (eventTriger.offHome > triger.minoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 17){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome >= triger.minoffHome) {
                                                                                        if (eventTriger.offHome < triger.maxoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 18){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway <= triger.maxoffAway) {
                                                                                        if (eventTriger.offAway > triger.minoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 19){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway >= triger.minoffAway) {
                                                                                        if (eventTriger.offAway < triger.maxoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            self.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            self.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if(triger.hold_on == 1){
                                                if (eventTriger.oddPre < triger.minOddPre) {
                                                    if(eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 2){
                                                if (eventTriger.oddPre < triger.maxOddPre) {
                                                    if(eventTriger.oddPre >= triger.minOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 3){
                                                if (eventTriger.oddLive < triger.minOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 4){
                                                if (eventTriger.oddLive < triger.maxOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 5){
                                                if (eventTriger.scoreHome < triger.minscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 6){
                                                if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 20){
                                                if (eventTriger.scoreAway < triger.minscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 21){
                                                if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 8){
                                                if (eventTriger.total_goal < triger.min_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 9){
                                                if (eventTriger.total_goal < triger.max_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 10){
                                                if (eventTriger.time < triger.minTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 11){
                                                if (eventTriger.time < triger.maxTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 12){
                                                if (eventTriger.onHome < triger.minonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 13){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 14){
                                                if (eventTriger.onAway < triger.minonAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 15){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 16){
                                                if (eventTriger.offHome < triger.minoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 17){
                                                if (eventTriger.offHome < triger.maxoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 18){
                                                if (eventTriger.offAway < triger.minoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 19){
                                                if (eventTriger.offAway < triger.maxoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        let deleteItem = self.alertArray.filter(function(item) {
                            return item.alertName == self.alertArray[i].alertName && item.name == self.alertArray[i].name;
                        });
                        if(deleteItem.length > 1){
                            let index = self.alertArray.indexOf(self.alertArray[i])
                            if (index > -1) {
                                self.alertArray.splice(index, 1)
                                i = i - 1                            
                            }
                        }
                    }

                    //please search

                    var new_alertidArray = []
                    for(let i = 0 ; i < self.alertArray.length ; i++){
                        var alertid = self.alertArray[i].name + self.alertArray[i].alertName
                        if(!alertidArray.includes(alertid)){
                            //console.log('--- alert added  ---')
                            //this.playeventaddSound()
                            this.playeventaddSound()
                        }
                        new_alertidArray.push(alertid);
                    }

                    for(let i = 0 ; i < alertidArray.length ; i++){
                        
                        if(!new_alertidArray.includes(alertidArray[i])){
                            //console.log('--- alert removed  ---')
                            this.playEventdeleteSound()
                        }
                        
                    }
                });
            },
            playScoresound() {
                if (this.goal_sound) {
                    this.$refs.goal_sound_on.play();
                }
            },

            playeventaddSound() {
                if (this.alert_sound) {
                    this.$refs.event_sound_on.play();
                }
            },

            playEventdeleteSound() {
                if (this.alert_sound) {
                     this.$refs.event_sound_off.play();
                }
            },
            set_usersetting() {                
                var user_id = localStorage.getItem("user_id");
                
                //console.log('user_id', user_id)
                if (user_id == 'undefined' || user_id == null) {
                    //console.log('---- user id not found ---');
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    //console.log('---- user id  found ---');
                    
                }
                
                var post_data = {
                    "user_id": user_id
                }
                window.axios.post(`${process.env.VUE_APP_URL}set_usersetting`, post_data).then(({data}) => {
                    //console.log(data);
                    if (data.data.length > 0){
                        this.goal_sound = data.data[0][0].goal_sound;
                        this.alert_sound = data.data[0][0].alert_sound;
                        this.mycurrency = data.data[0][0].mycurrency;

                        console.log('this.mycurrency=================', this.mycurrency)

                        var currency_infors = data.data[1];
                        for (var i=0; i<currency_infors.length; i++) {
                            var item = currency_infors[i];
                            this.currency_data[item.currency_id] = item.currency_rate;
                        }

                        //console.log('this.currency_data', this.currency_data)
                        //console.log('this.goal_sound', this.goal_sound);
                        //console.log('this.mycurrency', this.mycurrency);
                    }
                })
            },
            save_calc() {
            
                //console.log('--------save_calc part---------');
                var calc_odd = this.calc_odd;
                var calc_stake = this.calc_stake;
                var bookmarkerFee = this.bookmarkerFee;
                var score = this.key2;
                var cs_odd = this.cs_odd;
                var cs_stake = this.cs_stake;
                var stopLoss = this.stopLoss;
                var tradingMode = this.tradingMode;
                var alert_key = this.alert_key;
                var risk_key = this.risk_key;

                var eventId = this.eventId;
                var user_id = localStorage.getItem("user_id");
                //console.log('user_id', user_id);
                
                if (user_id == 'undefined' || user_id == null) {
                    //console.log('---- user id not found ---');
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    //console.log('---- user id  found ---');
                    
                }
                if (eventId == 0) {
                    swal.fire("Alert!", "Event not specified", "error");
                    return;
                }

                let marketType = this.key1.split(",")[2];
                let back_lay = this.key1.split(",")[6];
                var post_data = [calc_odd, calc_stake, bookmarkerFee, score, cs_odd, cs_stake, stopLoss, tradingMode, alert_key, risk_key, eventId, user_id, marketType, back_lay]

                window.axios.post(`${process.env.VUE_APP_URL}saveCalcOdds`, post_data).then(({data}) => {
                    //console.log(data.message);
                    swal.fire("Success!", "Data saved successfully", "success");
                })


                //console.log('--------calc_odd---------', calc_odd);
                //console.log('--------calc_stake---------', calc_stake);
                //console.log('--------bookmarkerFee---------', bookmarkerFee);
                //console.log('--------score---------', score);
                //console.log('--------cs_odd---------', cs_odd);
                //console.log('--------cs_stake---------', cs_stake);
                //console.log('--------stopLoss---------', stopLoss);
                //console.log('--------tradingMode---------', tradingMode);
                //console.log('--------alert_key---------', alert_key);
                //console.log('--------risk_key---------', risk_key);

                //console.log('--------eventId---------', eventId);
                //console.log('--------user_id---------', user_id);               

            },
            reset_cacl() {
                this.calc_odd = 0;

                this.calc_stake = 0;

                this.key2 = 0;
                this.correct_score_update(0);
                
                this.cs_odd = 0;
                this.cs_stake = 0;
                this.cs_stake_calc(0);

                this.checked_stoploss = true;
                this.stopLossfunction(this.checked_stoploss);
                this.checked_trading = false;
                this.tradingModefunction(this.checked_trading);                

                this.risk_key = '1';
                this.riskMode(this.risk_key)

                this.bookmaker_fee(0)
                this.bookmarkerFee = 0;
            },
            delete_calc() {                

                var eventId = this.eventId;
                var user_id = localStorage.getItem("user_id");
                //console.log('user_id', user_id);
                
                if (user_id == 'undefined' || user_id == null) {
                    //console.log('---- user id not found ---');
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    //console.log('---- user id  found ---');                   
                    
                }
                if (eventId == 0) {
                    swal.fire("Alert!", "Event not specified", "error");
                    return;
                }
                let marketType = this.key1.split(",")[2];
                var post_data = [eventId, user_id, marketType]

                window.axios.post(`${process.env.VUE_APP_URL}deleteCalcOdds`, post_data).then(({data}) => {
                    //console.log(data.message);
                    this.reset_cacl();
                    swal.fire("Success!", "Data reset successfully", "success");
                })


                //console.log('--------calc_odd---------', calc_odd);
                //console.log('--------calc_stake---------', calc_stake);
                //console.log('--------bookmarkerFee---------', bookmarkerFee);
                //console.log('--------score---------', score);
                //console.log('--------cs_odd---------', cs_odd);
                //console.log('--------cs_stake---------', cs_stake);
                //console.log('--------stopLoss---------', stopLoss);
                //console.log('--------tradingMode---------', tradingMode);
                //console.log('--------alert_key---------', alert_key);
                //console.log('--------risk_key---------', risk_key);

                //console.log('--------eventId---------', eventId);
                //console.log('--------user_id---------', user_id);               

            },
            authorize() {
                const token = localStorage.getItem("token");
                //console.log(token);
                if(!token){
                  this.$router.push("/pages/login")
                } else {
                  const response = fetch(`${process.env.VUE_APP_URL}api/users/authorize`, {
                    headers: {
                      Authorization: `Bearer ${token}`,
                    },
                  });
                  //console.log('response', response)
                }
            },
            replace_modal_data(home_id, away_id){
                this.current_modal_data = this.item3.spots
            },
            update_alert_name(val){
                let alertName = this.alertNameList.filter(function(item) {
                    return item.value == val;
                });
                if (alertName.length > 0)
                    this.cashoutAlertName = alertName[0].label;
                else
                    this.cashoutAlertName = 'OFF';
                this.stake_profit_calc()
            },
            update_alert_name1(val){
                
                this.cashoutAlertName = "OFF"
                console.log(' ========================     this.cashoutAlertName ', this.cashoutAlertName )
                this.stake_profit_calc()
            },
            correct_score_update(val){
                //console.log('value==>', val)
                this.CS_Odd_back_price = ''
                this.CS_Odd_lay_price = 1000000
                this.CS_Odd_back_stack = null
                this.CS_Odd_lay_stack = null
                
                this.currentCS_selectionId = val
                let currentRunner = this.currentCSR.filter(function(item) {
                    return item.selectionId == val;
                });
                if(currentRunner.length > 0){
                    if(currentRunner[0].exchange.availableToBack){
                        if(currentRunner[0].exchange.availableToBack.length > 0){
                            this.CS_Odd_back_price = currentRunner[0].exchange.availableToBack[0].price
                            this.CS_Odd_back_stack = currentRunner[0].exchange.availableToBack[0].size
                        }
                    }
                    if(currentRunner[0].exchange.availableToLay){
                        if(currentRunner[0].exchange.availableToLay.length > 0){
                            this.CS_Odd_lay_price = currentRunner[0].exchange.availableToLay[0].price
                            this.CS_Odd_lay_stack = currentRunner[0].exchange.availableToLay[0].size
                        }
                    }
                }
                this.cs_profit_calc()
            },
            
            bet_date(){
                this.bet_data.date = 'today';
                //console.log('bet data', this.bet_data)
                var user_id = localStorage.getItem("user_id");
                //console.log('user_id', user_id);
                var admin_role = localStorage.getItem('admin');
                
                
                if (user_id == 'undefined' || user_id == null) {
                    //console.log('---- user id not found ---');
                    swal.fire("Alert!", "User not specified", "error");
                    return;
                }
                else {
                    //console.log('---- user id  found ---');
                    
                }
                this.showModal_()

                window.axios.post(`${process.env.VUE_APP_URL}from_betsrc`,[this.bet_data, user_id, admin_role]).then(({data})=>{
                    //console.log('asdasdas',data.data[0],data.data[1],data.data[2],data.data[3],data.data[4])
                    let standing = data.data[11];
                    let new_standing = []
                    let seasonStandings_idList = []
                    for(let i = 0 ; i < standing.length ; i++){
                        let check = 0
                        for(let j = 0 ; j < standing[i].standings.length ; j++){
                            if(standing[i].standings[j].standings){
                                check = 1
                                standing[i].standings[j].standings = standing[i].standings[j].standings.data
                                if (!seasonStandings_idList.includes(standing[i].standings[j].id)) {
                                    new_standing.push(standing[i].standings[j])
                                    seasonStandings_idList.push(standing[i].standings[j].id)
                                }
                                
                            }
                        }
                        if(check == 0){
                            
                            if (!seasonStandings_idList.includes(standing[i]._id)) {
                                new_standing.push(standing[i])
                                seasonStandings_idList.push(standing[i]._id)
                            }
                        }
                    }
                    this.standingList = new_standing

                    this.baseData = data.data[0]

                    //console.log("baseData===>", this.baseData)
                    this.eventLists[0] = {'value': '', 'label': this.$t('Select Match')}
                    let temp =  JSON.stringify(data.data[0])
                    let eventData = JSON.parse(temp)
                    let eventData1 = JSON.parse(temp)

                    // this.mainList = data.data[0]
                    // for(let i = 0 ; i < eventData1.length ; i++){
                    //     for(let j = 0 ; j < eventData1[i].markets.length ; j++){
                    //         if(eventData1[i].markets[j].state.status != "CLOSED"){
                    //             let index = eventData1[i].markets.indexOf(eventData1[i].markets[j])
                    //             if (index > -1) {
                    //                 j = j - 1
                    //                 eventData1[i].markets.splice(index, 1)
                    //             }
                    //         }
                    //     }
                    // }
                    for(let i = 0 ; i < eventData.length ; i++){
                        for(let j = 0 ; j < eventData[i].markets.length ; j++){
                            if(eventData[i].markets[j].state){
                                if(eventData[i].markets[j].state.status == "CLOSED"){
                                    let index = eventData[i].markets.indexOf(eventData[i].markets[j])
                                    if (index > -1) {
                                        j = j - 1
                                        eventData[i].markets.splice(index, 1)
                                    }
                                }
                            }
                        }
                    }
                    //this.mainList = eventData
                    var mainList = []
                    for (var i=0; i<data.data[0].length; i++) {
                        var row = data.data[0][i]
                        console.log('row', row)
                        if (row.livestatus.length > 0 && row.livestatus[0].time && row.livestatus[0].time.status == 'FT')
                            continue
                        
                        mainList.push(row)

                    }
                    this.mainList = mainList
                    this.teamgroups1 = data.data[1]
                    this.teamgroups2 = data.data[2]
                    this.competitionList = data.data[0]
                    this.competitionList1 = data.data[0]
                    this.adminTable = data.data[6]
                    this.adminTable1 = data.data[4]
                    this.total_adminTable = data.data[9]

                    
                    this.alertNameList = data.data[7]
                    this.cashoutTable = data.data[8]

                    console.log('this.mainList', this.mainList)

                    let premarketArray = data.data[0]
                    let m_index = 0
                    for(let pp = 0 ; pp < premarketArray.length; pp++){
                        for(let uu = 0; uu < premarketArray[pp].markets.length; uu ++){
                            if(premarketArray[pp].markets[uu].prematchMarket){
                                m_index++
                                this.prematchOddList[m_index - 1] = premarketArray[pp].markets[uu].prematchMarket
                            }
                        }
                    }
                    // //console.log('prematch_odd_list====>', this.prematchOddList)

                    let eventList0 = data.data[0]
                    let marketNode = []
                    let marketArray = []
                    let marketIds = []
                    let check = 0

                    for(let i = 0; i < eventList0.length ; i++){
                        let eventNode = eventList0[i]
                        if(eventNode.status == 'IN_PLAY'){
                            marketNode[i] = eventNode.openDate.substring(11, 16) + " >> " + eventNode.name + ' - Live'
                        }else{
                            marketNode[i] = eventNode.openDate.substring(11, 16) + " >> " + eventNode.name
                        }
                        let selectionNodes = []
                        let check = 0
                        for(let j = 0; j < eventNode.markets.length; j++){
                            let marketElement = eventNode.markets[j]
                            // //console.log('status====>', eventNode.markets[j].state.status, ',', eventNode.eventId)
                            if(eventNode.markets[j].state && eventNode.markets[j].state.status != "CLOSED"){
                                check = 1
                            }
                            if(marketElement.marketType == 'MATCH_ODDS'){
                                check = check + 1
                                marketIds[0] = marketElement.marketId
                                selectionNodes[0] = marketElement.runners[0].selectionId
                                selectionNodes[1] = marketElement.runners[1].selectionId
                                selectionNodes[2] = marketElement.runners[2].selectionId
                            }else if(marketElement.marketType == 'OVER_UNDER_05'){
                                marketIds[1] = marketElement.marketId
                                selectionNodes[3] = marketElement.runners[1].selectionId
                            }else if(marketElement.marketType == 'OVER_UNDER_15'){
                                marketIds[2] = marketElement.marketId
                                selectionNodes[4] = marketElement.runners[1].selectionId
                            }else if(marketElement.marketType == 'OVER_UNDER_25'){
                                marketIds[3] = marketElement.marketId
                                selectionNodes[5] = marketElement.runners[0].selectionId
                                selectionNodes[6] = marketElement.runners[1].selectionId
                            }else if(marketElement.marketType == 'OVER_UNDER_35'){
                                marketIds[4] = marketElement.marketId
                                selectionNodes[7] = marketElement.runners[0].selectionId
                            }
                        }

                        if(check == 0){
                            let selectionString = selectionNodes[0]
                            for(let k = 1; k < 8; k++){
                                selectionString = selectionString + ',' + selectionNodes[k]
                            }

                            let marketString = marketIds[0]
                            for(let k = 1; k < 5; k++){
                                marketString = marketString + ',' + marketIds[k]
                            }

                            marketArray[i] = eventNode.eventId + ',' + marketString + ',' + selectionString
                            this.eventLists.push({'value': marketArray[i], 'label': marketNode[i]})
                        }
                    }
                    this.eventLists3 = this.eventLists


                    this.select_prediction(true)
                    this.hideModal_()
                    console.log('matchOddcounts------------>', this.eventLists)
                })

            },
            
            frame() {
                if (this.current_counter >= 45) {
                    this.current_counter = 45
                    clearInterval(this.clock);
                } else {
                    this.current_counter++;
                }
            },
            select_prediction(val){
                this.key1 = 0
                this.key2 = 0
                let eventList0 = this.mainList
                let marketNode1 = []
                let marketArray1 = []
                let index = 0
                this.eventLists[0] = {'value': '', 'label': this.$t('Select Match')}
                this.predictionList[0] = {'value': '', 'label': this.$t('Select Match')}
                let teamGroups = this.teamgroups2
                this.competitionName = this.$t('Competition ') + ' >> N/D'

                this.eventId = 0
                this.marketId =
                this.selectionId = 0
                this.lay =''
                this.lay_matched = 0
                this.back =''
                this.back_matched = 0
                this.total_matched = 0
                this.status =''
                this.scoreOne =''
                this.scoreTwo =''
                this.timeRecord =''

                console.log('----------   this.mainList - ----', this.mainList)
                console.log('----------   teamGroups - ----',teamGroups)

                for(let i = 0; i < eventList0.length ; i++){
                    let eventNode =  eventList0[i].name
                    let name1 = eventNode.split(' v ').splice(0,1).toString().trim()
                    let name2 = eventNode.split(' v ').splice(1,1).toString().trim()
                    let name11 =''
                    let name22 =''

                    let teamGroup1 = this.teamgroups1.filter(function(item) {
                        return item.betfair_com == name1;
                    });
                    if(teamGroup1.length > 0){
                        name11 = teamGroup1[0].statistic
                    }

                    let teamGroup2 = this.teamgroups1.filter(function(item) {
                        return item.betfair_com == name2;
                    });
                    if(teamGroup2.length > 0){
                        name22 = teamGroup2[0].statistic
                    }
                    console.log('==================================================', i)

                    for(let ii = 0 ;  ii < teamGroups.length ; ii++){
                        let groupAverage = 0
                        let groupSum = 0
                        for(let a = 0 ; a < teamGroups[ii].teamNames.length; a++){
                            groupSum = groupSum + parseInt(teamGroups[ii].teamNames[a].teamNo)
                        }
                        groupAverage = groupSum/teamGroups[ii].teamNames.length

                        console.log('==================================================', teamGroups[ii].teamNames.length)
                        for(let jj = 0 ; jj < teamGroups[ii].teamNames.length ; jj++){
                            if(teamGroups[ii].teamNames[jj].teamName == name1 || teamGroups[ii].teamNames[jj].teamName == name11){
                                let groupList = teamGroups[ii].groupName
                                let groupName = teamGroups[ii].groupName1
                                let marketType =  teamGroups[ii].marketType
                                let direction = teamGroups[ii].direction
                                let teamValue = teamGroups[ii].teamNames[jj].teamNo
                                if(groupList == '- Over 0.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 0.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 0.5 Back'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Over 1.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY') {
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 1.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 1.5 Back'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Under 2.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 2.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 2.5 Back'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Over 2.5 Back' && direction == 0 || groupList == '- Over 3.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 2.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 2.5 Back'
                                    }
                                    if(groupList == '- Over 3.5 Back' && direction == 0){
                                        marketType = 'OVER_UNDER_25'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Under 3.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 3.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 3.5 Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Lay' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay or - 2 Lay' && direction == 1){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay or - 2 Lay' && direction == 2){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Lay' && direction == 3){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Back' && direction == 3){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay' && direction == 3){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 2 - Lay' && direction == 3){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                            }
                            else if(teamGroups[ii].teamNames[jj].teamName == name2 || teamGroups[ii].teamNames[jj].teamName == name22){
                                let groupList = teamGroups[ii].groupName
                                let groupName = teamGroups[ii].groupName1
                                let marketType =  teamGroups[ii].marketType
                                let direction = teamGroups[ii].direction
                                let teamValue = teamGroups[ii].teamNames[jj].teamNo
                                if(groupList == '- Over 0.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 0.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 0.5 Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Over 1.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 1.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 1.5 Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Under 2.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 2.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 2.5 Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Over 2.5 Back' && direction == 0 || groupList == '- Over 3.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 2.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Over 2.5 Back'
                                    }
                                    if(groupList == '- Over 3.5 Back' && direction == 0){
                                        marketType = 'OVER_UNDER_25'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- Under 3.5 Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 3.5 Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - Under 3.5 Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Lay' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Back' && direction == 0){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay or - 2 Lay' && direction == 1){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay or - 2 Lay' && direction == 2){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Lay' && direction == 4){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Lay'
                                    }
                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- X - Back' && direction == 4){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - X - Back'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',2,' + groupAverage + ',' + teamValue + ',0'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 2 - Lay' && direction == 4){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] = eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 2 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',1,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                                else if(groupList == '- 1 - Lay' && direction == 4){
                                    index += 1
                                    if(eventList0[i].status == 'IN_PLAY'){
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay' + ' - Live'
                                    }
                                    else{
                                        marketNode1[index] =eventList0[i].openDate.substring(11, 16) + ' >> ' + eventList0[i].name + ' - 1 - Lay'
                                    }

                                    marketArray1[index] = '0,' + eventList0[i].eventId + ',' + marketType + ',0,' + groupAverage + ',' + teamValue + ',1'+ ',' + groupName
                                    this.predictionList.push({'value': marketArray1[index], 'label': marketNode1[index]})
                                }
                            }
                        }
                    }
                }

                this.eventLists2 = []
                for(let i = 0 ; i < this.predictionList.length ; i++){
                    let check = 0
                    for(let j = 0 ; j < this.eventLists2.length ; j++){
                        if(this.predictionList[i].label == this.eventLists2[j].label){
                            check = 1
                        }
                    }
                    if(check == 0){
                        this.eventLists2.push({'value': this.predictionList[i].value, 'label': this.predictionList[i].label})
                    }
                }
                this.predictionList = this.eventLists2
                console.log('================================ this.eventLists3 ====', this.eventLists2)
                if(val == true){
                    console.log('================================')
                    this.eventLists3 = this.predictionList
                    this.gameList1 = this.gameList2
                    this.matchWidth = '83.333333333%'
                    this.predictionWidth = 'none'

                    console.log('--------------this.filterQuery', this.filterQuery)
                    this.filter1(this.filterQuery)
                    this.predictionStatus =  true
                    //console.log('this eventlist3===>', this.eventLists3)
                }
                else{
                    this.eventLists3 = this.eventLists
                    this.gameList1 = this.gameList
                    this.matchWidth = '50%'
                    this.predictionWidth = 'block'
                    this.predictionStatus = false
                }



                for(let i = 1 ; i < this.eventLists3.length ; i++){
                    console.log('this.prediction list console++++++=>', this.eventLists3[i])
                    if(this.eventLists3[i].value){
                        let val1 = this.eventLists3[i].value
                        let eventId = parseInt(val1.split(',')[1])
                        let marketType = val1.split(',')[2]
                        let team = val1.split(',')[3]
                        let runnerNo = val1.split(',')[6]
                        let pred = ""

                        if(marketType == 'MATCH_ODDS'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- 1 - Back'
                                }
                                else{
                                    pred = '- 1 - Lay'
                                }
                            }
                            else if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- 2 - Back'
                                }
                                else{
                                    pred = '- 2 - Lay'
                                }
                            }
                            else if(team == '2'){
                                if(runnerNo == '0'){
                                    pred = '- X - Back'
                                }
                                else{
                                    pred = '- X - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_05'){
                            if(team == '1'){
                                if(runnerNo == '0'){
                                    pred = '- O 0.5 - Back'
                                }
                                else{
                                    pred = '- O 0.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_15'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 1.5 - Back'
                                }
                                else{
                                    pred = '- U 1.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 1.5 - Back'
                                }
                                else{
                                    pred = '- O 1.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_25'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 2.5 - Back'
                                }
                                else{
                                    pred = '- U 2.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    pred = '- O 2.5 - Back'
                                }
                                else{
                                    pred = '- O 2.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_35'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    pred = '- U 3.5 - Back'
                                }
                                else{
                                    pred = '- U 3.5 - Lay'
                                }
                            }
                        }
                        let predT = this.pred_type_list.filter(function(item) {
                            return item.label == pred
                        })
                        if(predT.length > 0){
                            for(let k = 0 ; k < this.adminTable1.length ; k++){
                                if(predT[0].value == this.adminTable1[k].PredType.value){
                                    let triger = {
                                        "maxOddPre": 1000000,
                                        "minOddPre": 0,
                                        "maxOddLive": 1000000,
                                        "minOddLive": 0,
                                        "minscoreHome": 0,
                                        "maxscoreHome": 100,
                                        "minscoreAway": 0,
                                        "maxscoreAway": 100,
                                        "min_total_goal": 0,
                                        "max_total_goal": 100,
                                        "minTime": 0,
                                        "maxTime": 150,
                                        "matchStatus": 0,
                                        "alertName": null,
                                        "minonHome": 0,
                                        "maxonHome": 100,
                                        "minoffHome": 0,
                                        "maxoffHome": 100,
                                        "minonAway": 0,
                                        "maxonAway": 100,
                                        "minoffAway": 0,
                                        "maxoffAway": 100,
                                        "switch_f": 100,
                                        "hold_on": 100
                                    }
                                    if(this.adminTable1[k].maxOddpre.value != null && this.adminTable1[k].maxOddpre.value != ""){
                                        triger.maxOddPre = parseFloat(this.adminTable1[k].maxOddpre.value)
                                    }
                                    if(this.adminTable1[k].minOddpre.value != null && this.adminTable1[k].minOddpre.value != ""){
                                        triger.minOddPre = parseFloat(this.adminTable1[k].minOddpre.value)
                                    }
                                    if(this.adminTable1[k].minOddlive.value != null && this.adminTable1[k].minOddlive.value != ""){
                                        triger.minOddLive = parseFloat(this.adminTable1[k].minOddlive.value)
                                    }
                                    if(this.adminTable1[k].maxoddlive.value != null && this.adminTable1[k].maxoddlive.value != ""){
                                        triger.maxOddLive = parseFloat(this.adminTable1[k].maxoddlive.value)
                                    }
                                    if(this.adminTable1[k].min_score_home.value != null && this.adminTable1[k].min_score_home.value != ""){
                                        triger.minscoreHome = parseFloat(this.adminTable1[k].min_score_home.value)
                                    }
                                    if(this.adminTable1[k].max_score_home.value != null && this.adminTable1[k].max_score_home.value != ""){
                                        triger.maxscoreHome = parseFloat(this.adminTable1[k].max_score_home.value)
                                    }
                                    if(this.adminTable1[k].min_score_away.value != null && this.adminTable1[k].min_score_away.value != ""){
                                        triger.minscoreAway = parseFloat(this.adminTable1[k].min_score_away.value)
                                    }
                                    if(this.adminTable1[k].max_score_away.value != null && this.adminTable1[k].max_score_away.value != ""){
                                        triger.maxscoreAway = parseFloat(this.adminTable1[k].max_score_away.value)
                                    }
                                    if(this.adminTable1[k].min_total_goal.value != null && this.adminTable1[k].min_total_goal.value != ""){
                                        triger.min_total_goal = parseFloat(this.adminTable1[k].min_total_goal.value)
                                    }
                                    if(this.adminTable1[k].max_total_goal.value != null && this.adminTable1[k].max_total_goal.value != ""){
                                        triger.max_total_goal = parseFloat(this.adminTable1[k].max_total_goal.value)
                                    }
                                    if(this.adminTable1[k].min_time.value != null && this.adminTable1[k].min_time.value != ""){
                                        triger.minTime = parseInt(this.adminTable1[k].min_time.value)
                                    }
                                    if(this.adminTable1[k].max_time.value != null && this.adminTable1[k].max_time.value != ""){
                                        triger.maxTime = parseInt(this.adminTable1[k].max_time.value)
                                    }
                                    if(this.adminTable1[k].MatchStatus.value != null){
                                        triger.matchStatus = this.adminTable1[k].MatchStatus.value
                                    }
                                    if(this.adminTable1[k].Alert_Name.value != null){
                                        triger.alertName = this.adminTable1[k].Alert_Name.value
                                    }
                                    if(this.adminTable1[k].min_on_home.value != null && this.adminTable1[k].min_on_home.value != ""){
                                        triger.minonHome = parseInt(this.adminTable1[k].min_on_home.value)
                                    }
                                    if(this.adminTable1[k].max_on_home.value != null && this.adminTable1[k].max_on_home.value != ""){
                                        triger.maxonHome = parseInt(this.adminTable1[k].max_on_home.value)
                                    }
                                    if(this.adminTable1[k].min_off_home.value != null && this.adminTable1[k].min_off_home.value != ""){
                                        triger.minoffHome = parseInt(this.adminTable1[k].min_off_home.value)
                                    }
                                    if(this.adminTable1[k].max_off_home.value != null && this.adminTable1[k].max_off_home.value != ""){
                                        triger.maxoffHome = parseInt(this.adminTable1[k].max_off_home.value)
                                    }
                                    if(this.adminTable1[k].min_on_away.value != null && this.adminTable1[k].min_on_away.value != ""){
                                        triger.minonAway = parseInt(this.adminTable1[k].min_on_away.value)
                                    }
                                    if(this.adminTable1[k].max_on_away.value != null && this.adminTable1[k].max_on_away.value != ""){
                                        triger.maxonAway = parseInt(this.adminTable1[k].max_on_away.value)
                                    }
                                    if(this.adminTable1[k].min_off_away.value != null && this.adminTable1[k].min_off_away.value != ""){
                                        triger.minoffAway = parseInt(this.adminTable1[k].min_off_away.value)
                                    }
                                    if(this.adminTable1[k].max_off_away.value != null && this.adminTable1[k].max_off_away.value != ""){
                                        triger.maxoffAway = parseInt(this.adminTable1[k].max_off_away.value)
                                    }
                                    if(this.adminTable1[k].switch_btn.value != null && this.adminTable1[k].switch_btn.value != ""){
                                        triger.switch_f = parseInt(this.adminTable1[k].switch_btn.value)
                                    }
                                    if(this.adminTable1[k].hold_on.value != null && this.adminTable1[k].hold_on.value != ""){
                                        triger.hold_on = parseInt(this.adminTable1[k].hold_on.value)
                                    }
                                    for(let j = 0; j < this.mainList.length; j++){
                                        if(eventId == this.mainList[j].eventId){
                                            if (this.mainList[j].DailyApiEvents1.length == 0)
                                                continue
                                            let eventTriger = {
                                                "name": this.eventLists3[i].label,
                                                "oddPre": null,
                                                "oddLive": null,
                                                "scoreHome": 0,
                                                "scoreAway": 0,
                                                "total_goal": 0,
                                                "min_total_goal": 0,
                                                "max_total_goal": 0,
                                                "time": 0,
                                                "matchStatus": null,
                                                "alertName": null,
                                                "onHome": 0,
                                                "offHome": 0,
                                                "onAway": 0,
                                                "offAway": 0,
                                                "c_color": "green"
                                            }
                                            // let eventTriger = {
                                            //     "name": this.eventLists3[i].label,
                                            //     "oddPre": null,
                                            //     "oddLive": null,
                                            //     "scoreHome": 100000,
                                            //     "scoreAway": 100000,
                                            //     "total_goal": 100000,
                                            //     "min_total_goal": 100000,
                                            //     "max_total_goal": 100000,
                                            //     "time": 100000,
                                            //     "matchStatus": null,
                                            //     "alertName": null,
                                            //     "onHome": 100000,
                                            //     "offHome": 100000,
                                            //     "onAway": 100000,
                                            //     "offAway": 100000,
                                            //     "c_color": "green"
                                            // }
                                            let eventNode = this.mainList[j]
                                            if(eventNode.score){
                                                let scoreDetail = eventNode.score
                                                eventTriger.scoreHome = scoreDetail.home.score
                                                eventTriger.scoreAway = scoreDetail.away.score
                                                eventTriger.total_goal = scoreDetail.home.score + scoreDetail.away.score
                                            }
                                            if(eventNode.status){
                                                eventTriger.matchStatus = 1
                                                eventTriger.time = eventNode.timeElapsed
                                            }
                                            else if(!eventNode.status){
                                                eventTriger.matchStatus = 0
                                            }
                                            for(let c = 0 ; c < this.mainList[j].markets.length; c++){
                                                let marketNode = this.mainList[j].markets[c]
                                                let check = 0
                                                if(marketNode.marketType == marketType){
                                                    if(marketNode.state){
                                                        if(marketNode.state.status == "CLOSED"){
                                                            eventTriger.matchStatus = 0
                                                            check = 1
                                                        }
                                                    }
                                                    if(check === 0){
                                                        let runnerNode = marketNode.runners[team]
                                                        let prematchMarket = null
                                                        if(this.mainList[j].markets[c].prematchMarket){
                                                            prematchMarket = this.mainList[j].markets[c].prematchMarket
                                                        }
                                                        if(eventNode.status && prematchMarket != null){
                                                            let runnerlists = prematchMarket.runners[team]
                                                            if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                            }
                                                            if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNo == 0){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                            if(runnerNode.exchange.availableToLay){
                                                                if(runnerNo == 1){
                                                                    eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                }
                                                            }
                                                        }
                                                        if(runnerNo == 0){
                                                            if(runnerNode.exchange.availableToBack){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                        else{
                                                            if(runnerNode.exchange.availableToLay){
                                                                eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            let liveStatsNode = this.mainList[j].livestatus
                                            if(liveStatsNode.length > 0){
                                                let liveNode = liveStatsNode[0].stats
                                                if(liveStatsNode[0].stats && liveStatsNode[0].stats.length > 1){
                                                    if(liveStatsNode[0].stats[0].team_id == this.mainList[j].localTeamId){
                                                        if(liveStatsNode[0].stats[0].shots != null){
                                                            eventTriger.onHome = liveNode[0].shots.ongoal
                                                            eventTriger.offHome = liveNode[0].shots.offgoal
                                                            eventTriger.onAway = liveNode[1].shots.ongoal
                                                            eventTriger.offAway = liveNode[1].shots.offgoal
                                                        }
                                                    }
                                                    else{
                                                        if(liveStatsNode[0].stats[1].shots != null){
                                                            eventTriger.onHome = liveNode[1].shots.ongoal
                                                            eventTriger.offHome = liveNode[1].shots.offgoal
                                                            eventTriger.onAway = liveNode[0].shots.ongoal
                                                            eventTriger.offAway = liveNode[0].shots.offgoal
                                                        }
                                                    }
                                                }
                                            }
                                            // //console.log("=======================Condition=========================>", triger)
                                            // //console.log("==========================data===========================>", eventTriger)
                                            if(triger.switch_f == 100){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                    if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                        if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                            if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                    if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                        eventTriger.alertName = triger.alertName
                                                                                        this.alertArray.push(eventTriger)
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 1){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre <= triger.maxOddPre) {
                                                                                        if (eventTriger.oddPre > triger.minOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 2){
                                                if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddPre >= triger.minOddPre) {
                                                                                        if (eventTriger.oddPre < triger.maxOddPre) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 3){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive <= triger.maxOddLive) {
                                                                                        if (eventTriger.oddLive > triger.minOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 4){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                        if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                            if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.oddLive >= triger.minOddLive) {
                                                                                        if (eventTriger.oddLive < triger.maxOddLive) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 5){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                                        if (eventTriger.scoreHome > triger.minscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 6){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                                    if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                                        if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 20){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                                        if (eventTriger.scoreAway > triger.minscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 21){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive) {
                                                        if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                            if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                    if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                        if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                            if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                if (eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreAway <= triger.maxscoreHome) {
                                                                                    if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                                        if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 8){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway >= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.max_total_goal) {
                                                                                        if (eventTriger.total_goal > triger.min_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 9){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.total_goal <= triger.min_total_goal) {
                                                                                        if (eventTriger.total_goal < triger.max_total_goal) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 10){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time <= triger.maxTime) {
                                                                                        if (eventTriger.time > triger.minTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 11){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.time >= triger.minTime) {
                                                                                        if (eventTriger.time < triger.maxTime) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 12){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome <= triger.maxonHome) {
                                                                                        if (eventTriger.onHome > triger.minonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 13){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 14){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onAway <= triger.maxonAway) {
                                                                                        if (eventTriger.onAway > triger.minonAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 15){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.onHome >= triger.minonHome) {
                                                                                        if (eventTriger.onHome < triger.maxonHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 16){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome <= triger.maxoffHome) {
                                                                                        if (eventTriger.offHome > triger.minoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 17){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway) {
                                                                                    if (eventTriger.offHome >= triger.minoffHome) {
                                                                                        if (eventTriger.offHome < triger.maxoffHome) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 18){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway <= triger.maxoffAway) {
                                                                                        if (eventTriger.offAway > triger.minoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.switch_f == 19){
                                                if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                    if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                        if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                            if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway) {
                                                                if (eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal) {
                                                                    if (eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime) {
                                                                        if (eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome) {
                                                                            if (eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway) {
                                                                                if (eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome) {
                                                                                    if (eventTriger.offAway >= triger.minoffAway) {
                                                                                        if (eventTriger.offAway < triger.maxoffAway) {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                        } else {
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            eventTriger.c_color = "red"
                                                                                            this.alertArray.push(eventTriger)
                                                                                        }
                                                                                        
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if(triger.hold_on == 1){
                                                if (eventTriger.oddPre < triger.minOddPre) {
                                                    if(eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 2){
                                                if (eventTriger.oddPre < triger.maxOddPre) {
                                                    if(eventTriger.oddPre >= triger.minOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 3){
                                                if (eventTriger.oddLive < triger.minOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 4){
                                                if (eventTriger.oddLive < triger.maxOddLive) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 5){
                                                if (eventTriger.scoreHome < triger.minscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 6){
                                                if (eventTriger.scoreHome < triger.maxscoreHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 20){
                                                if (eventTriger.scoreAway < triger.minscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 21){
                                                if (eventTriger.scoreAway < triger.maxscoreAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 8){
                                                if (eventTriger.total_goal < triger.min_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 9){
                                                if (eventTriger.total_goal < triger.max_total_goal) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 10){
                                                if (eventTriger.time < triger.minTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 11){
                                                if (eventTriger.time < triger.maxTime) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 12){
                                                if (eventTriger.onHome < triger.minonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 13){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 14){
                                                if (eventTriger.onAway < triger.minonAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 15){
                                                if (eventTriger.onHome < triger.maxonHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 16){
                                                if (eventTriger.offHome < triger.minoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 17){
                                                if (eventTriger.offHome < triger.maxoffHome) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 18){
                                                if (eventTriger.offAway < triger.minoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway <= triger.maxoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            if(triger.hold_on == 19){
                                                if (eventTriger.offAway < triger.maxoffAway) {
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway){
                                                                                            eventTriger.alertName = triger.alertName
                                                                                            this.alertArray.push(eventTriger)
                                                                                            
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            },
            callHistoricalData(home_id, away_id, season_id, eventName, home_rtg, home_a_rtg, away_rtg, away_a_rtg, id){
                console.log('home_id, away_id====>', home_id, away_id, home_rtg, home_a_rtg, away_rtg, away_a_rtg)
                console.log('id', id)
                
                if (id == 0 || id == undefined)
                    return
                this.historicModalData = {
                    "eventName": "",
                    "home_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    "away_season": {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    "home_p": 0,
                    "away_p": 0,
                    "home_rtg": home_rtg,
                    "home_a_rtg": home_a_rtg,
                    "away_rtg": away_rtg,
                    "away_a_rtg": away_a_rtg
                }
                this.historicModalData.eventName = 'Loading ...'
                this.isload = false
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame, 100)
                window.axios.post(`${process.env.VUE_APP_URL}getLiveEventHistory`, [id]).then(({data})=> {
                    console.log('called historical data===>', data.data[0])
                    this.isload = true
                    let seasonData = data.data[0][0]
                    console.log("time issue=>", this.item1)
                    let home_p = 0
                    let away_p = 0
                    let home_season = {}
                    let away_season = {}

                    if(seasonData.home_season){
                        home_p = seasonData.home_season.p
                        away_p = seasonData.away_season.p
                        home_season = seasonData.home_season
                        away_season = seasonData.away_season
                    }

                    this.flatodds = {
                        "h_win": "-",
                        "a_win": "-",
                        "d_win": "-",
                        "o_05": "-",
                        "o_15": "-",
                        "o_25": "-",
                        "o_35": "-",
                        "u_05": "-",
                        "u_15": "-",
                        "u_25": "-",
                        "u_35": "-",
                        "o_05_ht": "-",
                        "u_05_ht": "-",
                        "bts_yes": "-",
                        "bts_no": "-",
                        prob_home: "-",
                        prob_draw: "-",
                        prob_away : "-",
                        prob_over05: "-",
                        prob_over15: "-",
                        prob_over25 : "-",
                        prob_over35 : "-",
                        prob_bts: "-",
                        prob_over05_ht: "-",

                        prob_under05: "-",
                        prob_under15: "-",
                        prob_under25 : "-",
                        prob_under35: "-",

                        prob_bts_no: "-",
                        prob_under05_ht: "-",

                        prob_home_tt1: null,
                        prob_home_tt2: null,
                        prob_away_tt1: null,
                        prob_away_tt2: null,
                        prob_draw_tt1: null,
                        prob_draw_tt2: null,
                        prob_over05_tt1: null,
                        prob_over05_tt2: null,
                        prob_over15_tt1: null,
                        prob_over15_tt2: null,
                        prob_over25_tt1: null,
                        prob_over25_tt2: null,
                        prob_over35_tt1: null,
                        prob_over35_tt2: null,
                        prob_under05_tt1: null,
                        prob_under05_tt2: null,
                        prob_under15_tt1: null,
                        prob_under15_tt2: null,
                        prob_under25_tt1: null,
                        prob_under25_tt2: null,
                        prob_under35_tt1: null,
                        prob_under35_tt2: null,
                        prob_over05_ht_tt1: null,
                        prob_over05_ht_tt2: null,
                        prob_under05_ht_tt1: null,
                        prob_under05_ht_tt2: null,
                        prob_bts_tt1: null,
                        prob_bts_tt2: null,
                        prob_bts_no_tt1: null,
                        prob_bts_no_tt2: null,

                    };
                    this.matches_sample = 0;
                    if (seasonData.DailyFixtures.length != 0) {
                        seasonData.DailyFixtures[0].flatOdds.data.forEach((oItem) => {
                            let mkt_id = oItem.market_id;
                            if(oItem.bookmaker_id === 2) {
                                let suffix;
                                if(mkt_id === 1 || mkt_id === 12 || mkt_id === 976105  || mkt_id === 136703813 || mkt_id === 137918022 || mkt_id === 28077 || mkt_id === 1256989864) 
                                    suffix = 'FT';
                                else if(mkt_id === 37 || mkt_id === 31379 || mkt_id === 975903 || mkt_id === 976226 || mkt_id === 31359)
                                    suffix = 'HT';
                                (oItem.odds || oItem.values).forEach((item) => {
                                    let label;
                                    if(item.label)
                                        label = `${item.label}${item.total ? ' - ' + item.total : ''}`;
                                    else if(item.team)
                                        label = item.team;
                                    else if(item.info) {
                                        label = item.info;
                                    }
                                    if(label === 'Yes')
                                        label = 'BTS';
                                    else if(label === 'No')
                                        label = 'No BTS';
                                    if(label === '1')
                                        label = "Home";
                                    else if(label === '2')
                                        label = 'Away';
                                    else if(label === 'X')
                                        label = 'Draw';
                                    if(!label.includes(",")) {              //except over 2.0,2.5 case
                                        label = `${label} - ${suffix}`
                                        if(label == 'Home - FT') {
                                            
                                            this.flatodds.h_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Away - FT') {
                                            this.flatodds.a_win = parseFloat(item.value)
                                        }
                                        else if(label == 'Draw - FT') {
                                            
                                            this.flatodds.d_win = parseFloat(item.value)
                                        }

                                        else if(label == "Over - 0.5 - FT")
                                            this.flatodds.o_05 = parseFloat(item.value)
                                        else if(label == "Over - 1.5 - FT")
                                            this.flatodds.o_15 = parseFloat(item.value)
                                        else if(label == "Over - 2.5 - FT")
                                            this.flatodds.o_25 = parseFloat(item.value)
                                        else if(label == "Over - 3.5 - FT")
                                            this.flatodds.o_35 = parseFloat(item.value)

                                        else if(label == "Under - 0.5 - FT")
                                            this.flatodds.u_05 = parseFloat(item.value)
                                        else if(label == "Under - 1.5 - FT")
                                            this.flatodds.u_15  = parseFloat(item.value)
                                        else if(label == "Under - 2.5 - FT")
                                            this.flatodds.u_25  = parseFloat(item.value)
                                        else if(label == "Under - 3.5 - FT")
                                            this.flatodds.u_35  = parseFloat(item.value)

                                        else if(label == "BTS - FT")
                                            this.flatodds.bts_yes  = parseFloat(item.value)
                                        else if(label == "No BTS - FT")
                                            this.flatodds.bts_no = parseFloat(item.value)

                                        else if(label == "Over - 0.5 - HT")
                                            this.flatodds.o_05_ht = parseFloat(item.value)
                                        else if(label == "Under - 0.5 - HT")
                                            this.flatodds.u_05_ht = parseFloat(item.value)

                                        // event_odds_list.push({
                                        //     label: `${label} - ${suffix}`,
                                        //     value: `${label} - ${suffix}`.trim(),
                                        //     odd: parseFloat(item.value)
                                        // });
                                    }
                                });
                            }
                        });

                        var oddslines = null;
                        if ( seasonData.league5yearsStats.length > 0 ) {
                            oddslines = seasonData.league5yearsStats[0].oddslines;                            

                            var odds = null;
                            let home_odds = 100;
                            if (this.flatodds.h_win !== "-")
                                home_odds = this.flatodds.h_win;
                            let away_odds = 100;
                            if (this.flatodds.a_win !== "-")
                                away_odds = this.flatodds.a_win;
                            
                            if (home_odds <= 3 && away_odds <= 3) {
                                odds = oddslines[3]
                            }
                            else if (home_odds <= 1.5) {
                                odds = oddslines[0]
                            }
                            else if (home_odds > 1.5 && home_odds <= 2) {
                                odds = oddslines[1]
                            }
                            else if (home_odds > 2 && home_odds <= 3) {
                                odds = oddslines[2]
                            }
                            
                            else if (away_odds <= 1.5) {
                                odds = oddslines[4]
                            }
                            else if (away_odds > 1.5 && away_odds <= 2) {
                                odds = oddslines[5]
                            }
                            else if (away_odds > 2 && away_odds <= 3) {
                                odds = oddslines[6]
                            }
                            
                            if (odds) {
                                this.flatodds.prob_home = parseInt(odds.home_win_percent)
                                this.flatodds.prob_draw = parseInt(odds.draw_win_percent)
                                this.flatodds.prob_away = parseInt(odds.away_win_percent)
                                this.flatodds.prob_over05 = parseInt(odds.full_05_percent)
                                this.flatodds.prob_over15 = parseInt(odds.full_15_percent)
                                this.flatodds.prob_over25 = parseInt(odds.full_25_percent)
                                this.flatodds.prob_over35 = parseInt(odds.full_35_percent)
                                this.flatodds.prob_bts = parseInt(odds.bts_percent)
                                this.flatodds.prob_over05_ht = parseInt(odds.first_05_percent)

                                this.flatodds.prob_under05 = 100 - parseInt(odds.full_05_percent)
                                this.flatodds.prob_under15 = 100 - parseInt(odds.full_15_percent)
                                this.flatodds.prob_under25 = 100 - parseInt(odds.full_25_percent)
                                this.flatodds.prob_under35 = 100 - parseInt(odds.full_35_percent)

                                this.flatodds.prob_bts_no = 100 - parseInt(odds.bts_percent)
                                this.flatodds.prob_under05_ht = 100 - parseInt(odds.first_05_percent)

                                this.matches_sample = odds.total_matches;
                            }

                            if (this.flatodds.prob_home !== "-" && this.flatodds.h_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.h_win, this.flatodds.prob_home)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_home_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_home_tt2 = value.toFixed(2)                                    
                            }

                            if (this.flatodds.prob_draw !== "-" && this.flatodds.d_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.d_win, this.flatodds.prob_draw)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_draw_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_draw_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_away !== "-" && this.flatodds.a_win !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.a_win, this.flatodds.prob_away)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_away_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_away_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05 !== "-" && this.flatodds.o_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05, this.flatodds.prob_over05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over15 !== "-" && this.flatodds.o_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_15, this.flatodds.prob_over15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over15_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over25 !== "-" && this.flatodds.o_25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_25, this.flatodds.prob_over25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over25_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over35 !== "-" && this.flatodds.o_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_35, this.flatodds.prob_over35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05 !== "-" && this.flatodds.u_05 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05, this.flatodds.prob_under05)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under15 !== "-" && this.flatodds.u_15 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_15, this.flatodds.prob_under15)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under15_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under15_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under25 !== "-" && this.flatodds.oddsu_25_under25 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_25, this.flatodds.prob_under25)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under25_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under25_tt2 = value.toFixed(2)
                            }
                            if (this.flatodds.prob_under35 !== "-" && this.flatodds.u_35 !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_35, this.flatodds.prob_under35)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under35_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under35_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_over05_ht !== "-" && this.flatodds.o_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.o_05_ht, this.flatodds.prob_over05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_over05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_over05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_under05_ht !== "-" && this.flatodds.u_05_ht !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.u_05_ht, this.flatodds.prob_under05_ht)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_under05_ht_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_under05_ht_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts !== "-" && this.flatodds.bts_yes !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_yes, this.flatodds.prob_bts)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_tt2 = value.toFixed(2)
                            }

                            if (this.flatodds.prob_bts_no !== "-" && this.flatodds.bts_no !== "-") {
                                var val = this.get_trueodds_value(this.flatodds.bts_no, this.flatodds.prob_bts_no)
                                var true_odd = val[0]
                                var value = val[1]
                                this.flatodds.prob_bts_no_tt1 = true_odd.toFixed(2)
                                this.flatodds.prob_bts_no_tt2 = value.toFixed(2)
                            }
                        }
                        if (this.matches_sample == 0) {
                            this.flatodds = {
                                "h_win": "-",
                                "a_win": "-",
                                "d_win": "-",
                                "o_05": "-",
                                "o_15": "-",
                                "o_25": "-",
                                "o_35": "-",
                                "u_05": "-",
                                "u_15": "-",
                                "u_25": "-",
                                "u_35": "-",
                                "o_05_ht": "-",
                                "u_05_ht": "-",
                                "bts_yes": "-",
                                "bts_no": "-",
                                prob_home: "-",
                                prob_draw: "-",
                                prob_away : "-",
                                prob_over05: "-",
                                prob_over15: "-",
                                prob_over25 : "-",
                                prob_over35 : "-",
                                prob_bts: "-",
                                prob_over05_ht: "-",

                                prob_under05: "-",
                                prob_under15: "-",
                                prob_under25 : "-",
                                prob_under35: "-",

                                prob_bts_no: "-",
                                prob_under05_ht: "-",

                                prob_home_tt1: null,
                                prob_home_tt2: null,
                                prob_away_tt1: null,
                                prob_away_tt2: null,
                                prob_draw_tt1: null,
                                prob_draw_tt2: null,
                                prob_over05_tt1: null,
                                prob_over05_tt2: null,
                                prob_over15_tt1: null,
                                prob_over15_tt2: null,
                                prob_over25_tt1: null,
                                prob_over25_tt2: null,
                                prob_over35_tt1: null,
                                prob_over35_tt2: null,
                                prob_under05_tt1: null,
                                prob_under05_tt2: null,
                                prob_under15_tt1: null,
                                prob_under15_tt2: null,
                                prob_under25_tt1: null,
                                prob_under25_tt2: null,
                                prob_under35_tt1: null,
                                prob_under35_tt2: null,
                                prob_over05_ht_tt1: null,
                                prob_over05_ht_tt2: null,
                                prob_under05_ht_tt1: null,
                                prob_under05_ht_tt2: null,
                                prob_bts_tt1: null,
                                prob_bts_tt2: null,
                                prob_bts_no_tt1: null,
                                prob_bts_no_tt2: null,

                            };
                        }
                        
                    
                    }


                    let rtgTime = []
                    let homeRS = []
                    let awayRS = []

                    if (seasonData.liveStatsT.length > 0) {
                        let home_rtg_stats = seasonData.liveStatsT[0].home_rtg_stats
                        let away_rtg_stats = seasonData.liveStatsT[0].away_rtg_stats
                        if(home_rtg_stats){
                            for(let c = 0; c < home_rtg_stats.length; c++){
                                let minute = home_rtg_stats[c].time.minute
                                let half_extra_time = 0;
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }

                                if(home_rtg_stats[c].time.extra_time != null){
                                    minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                    if(home_rtg_stats[c].time.minute < 46){
                                        half_extra_time = home_rtg_stats[c].time.extra_time
                                    }
                                }
                                if(home_rtg_stats[c].time.minute > 45){
                                    minute = minute + half_extra_time
                                }
                                rtgTime.push(minute)

                                if(c <= 10){
                                    if(home_rtg_stats[c].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal
                                    }
                                    if(home_rtg_stats[c].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals
                                }
                                else{
                                    if(home_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(home_rtg_stats[c - 10].da != null){
                                        home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                    home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                homeRS.push(home_rtg.rtg)
                            }
                        }
                        if(away_rtg_stats){
                            for(let c = 0; c < away_rtg_stats.length; c++){
                                let home_rtg = {
                                    'on': null,
                                    'off': null,
                                    'cnr': null,
                                    'da': null,
                                    'goal': null,
                                    'rtg': null
                                }
                                if(c <= 10){
                                    if(away_rtg_stats[c].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal
                                    }
                                    if(away_rtg_stats[c].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals
                                }
                                else{
                                    if(away_rtg_stats[c - 10].shots != null){
                                        home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                        home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                    }
                                    if(away_rtg_stats[c - 10].da != null){
                                        home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                    }
                                    home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                    home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                }

                                if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                    home_rtg.rtg = 0
                                    if(home_rtg.on >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                    }
                                    if(home_rtg.off >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                    }
                                    if(home_rtg.cnr >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                    }
                                    if(home_rtg.da >= 0){
                                        home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                    }
                                }
                                else{
                                    home_rtg.rtg = '-'
                                }
                                awayRS.push(-home_rtg.rtg)
                            }
                        }
                    }

                    this.historicModalData.home_season = Object.assign(home_season)
                    this.historicModalData.away_season = Object.assign(away_season)
                    this.historicModalData.home_p = home_p
                    this.historicModalData.away_p = away_p
                    // this.data[0].x = this.item1.chart.time
                    // this.data[1].x = this.item1.chart.time
                    // this.data[0].y = this.item1.chart.homeRTG
                    // this.data[1].y = this.item1.chart.awayRTG
                    this.data[0].x = rtgTime
                    this.data[1].x = rtgTime
                    this.data[0].y = homeRS
                    this.data[1].y = awayRS
                    this.data[0].name = seasonData.localTeamName
                    this.data[1].name = seasonData.visitorTeamName


                    this.historicModalData.eventName = seasonData.localTeamName + " v " + seasonData.visitorTeamName
                    this.percallfunction()
                })
            },
            percallfunction(){
                this.current_counter = 0
                clearInterval(this.clock)
                this.clock = setInterval(this.frame1, 9000)
            },
            select_match(val){
                console.log("select match===>", val, "<===select match")
                if (val != '' && val != null && val != '  ')
                    this.showModal_2()


                this.key = '0'
                this.key2 = '0'
                this.max_profit = 0
                this.max_lose = 0
                this.guad_max = 0
                this.fixtureId = 0
                this.percent_text1 = ''
                this.percent_text2 = this.$t('Insert Odd and Stake')
                this.guad_att = 0
                this.percentTextColor = '#20a052'
                this.percentTextColor1 = '#20a052'
                this.percentBackgroundColor = '#d8e4bc'
                this.percentBackgroundColor1 = '#d8e4bc'
                this.cs_odd = 0
                this.cs_stake = 0
                this.cs_max_profit = 0
                this.cs_max_lose = 0
                this.cs_guad_max = 0
                this.stakeToCover = null
                this.currentCS_selectionId = null
                this.cs_percent_text1 = ''
                this.cs_percent_text2 = this.$t('Insert CS Odd and Stake')
                this.cs_guad_att = 0
                this.CS_Odd_back_price = ''
                this.CS_Odd_lay_price = 1000000
                this.CS_Odd_back_stack = null
                this.CS_Odd_lay_stack = null
                this.cs_percentTextColor = '#20a052'
                this.cs_percentTextColor1 = '#20a052'
                this.cs_percentBackgroundColor = '#d8e4bc'
                this.cs_percentBackgroundColor1 = '#d8e4bc'
                let temp =  JSON.stringify(this.eventId)
                this.second_eventId = JSON.parse(temp)
                // this.init_var1()
                this.item1 = {                    
                    'home_p': 1,
                    'league': '',
                    'away_p': 1,
                    'home1': {
                        'on': 'red',
                        'off': 'red',
                        'blk': 'red',
                        'in': 'red',
                        'out': 'red',
                        'cnr': 'red',
                        'da': 'red',
                        'poss': 'red',
                    },
                    'away1': {
                        'on': 'red',
                        'off': 'red',
                        'blk': 'red',
                        'in': 'red',
                        'out': 'red',
                        'cnr': 'red',
                        'da': 'red',
                        'poss': 'red',
                    },
                    'home_season' : {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                    },
                    'away_season' : {
                        'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                    },
                    'goal_tooltip': '',
                    'home_tooltip':{
                        'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                    },
                    'away_tooltip':{
                        'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                    },
                    'home':{
                        'index0': 0,
                        'flash': 0,
                        'name': '',
                        'rank': '',
                        'time': '',
                        'score': 0,
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'goal': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'rtg': 0,
                        'a_rtg': 14
                    },
                    'away':{
                        'index0': 0,
                        'flash': 0,
                        'name': '',
                        'rank': '',
                        'time': '',
                        'score': 0,
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'goal': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'rtg': 0,
                        'a_rtg': 14
                    },
                    'homeT':{
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'red': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                    },
                    'awayT':{
                        'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'red': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                    }
                }
                // if (val != '' && val != null && val != '  ' && val.split(',').length > 1){
                //     this.item1.fixtureId = parseInt(val.split(',')[1])
                // }
                if(val == ''){
                    // this.init_var2()
                }
                else{
                    this.selectedArray = val.split(',')
                    this.selectedValue = val
                    let current_pre = this.eventLists3.filter(function(item) {
                        return item.value == val
                    })
                    this.selectedLabel = current_pre[0].label
                    if(this.selectedArray[0] != '0'){
                        this.eventId = this.selectedArray[0]
                        this.marketId =''
                        this.selectionId =''
                        this.lay =''
                        this.back =''
                        this.total_matched = 0
                        this.back_matched = 0
                        this.lay_matched = 0
                        this.scoreOne =''
                        this.scoreTwo =''
                        this.status =''
                        this.marketStatus =''
                        this.timeRecord=''

                        let self = this
                        let competitionNode = this.competitionList.filter(function(item) {
                            return item.eventId == self.eventId;
                        });

                        if(competitionNode.length > 0){
                            this.competitionName = this.$t('Competition ') + " >> " + competitionNode[0].competitions[0].name
                            this.item1.league = competitionNode[0].competitions[0].name
                        }else{
                            this.competitionName = this.$t('Competition ') + " >> "
                            this.item1.league = 'N/D'
                        }

                        for(let i = 0; i < this.mainList.length; i++){
                            let eventValue = this.mainList[i]
                            if(eventValue.eventId == this.eventId){

                                if(eventValue.score){
                                    let scoreDetail = eventValue.score
                                    this.scoreOne = scoreDetail.home.score + ' - '
                                    this.scoreTwo = scoreDetail.away.score
                                }
                                else{
                                    this.scoreOne =''
                                    this.scoreTwo =''
                                }
                                if(eventValue.status){
                                    this.status = 'Live -'
                                    this.timeRecord = eventValue.timeElapsed + "'"
                                }
                                else if(!eventValue.status){
                                    this.status = this.$t('coming_up_main')
                                    this.timeRecord =''
                                }
                                if(eventValue.inPlayMatchStatus == 'FirstHalfEnd'){
                                    this.timeRecord = 'HT'
                                }
                            }
                        }
                    }

                    if(this.selectedArray[0] == '0'){

                        let eventId = parseInt(this.selectedArray[1])
                        //console.log('eventId', this.selectedArray)
                        let marketType = this.selectedArray[2]
                        let team = parseInt(this.selectedArray[3])
                        let runnerNo = parseInt(this.selectedArray[6])

                        let current_pre = this.eventLists3.filter(function(item) {
                            return item.value == val
                        })
                        let self = this
                        let event = this.baseData.filter(function(item) {
                            return (item.eventId == eventId && (current_pre[0].label.includes("1 - Lay") == true || current_pre[0].label.includes("2 - Lay") == true || current_pre[0].label.includes("X - Lay") == true || current_pre[0].label.includes("X - Back") == true))
                        })

                        this.correctScoreList = [{"value": 100, "label": "Select One"}]

                        if(event.length > 0){
                            for(let pp = 0 ; pp < event[0].markets.length ; pp++){
                                if(event[0].markets[pp].marketType == "CORRECT_SCORE"){
                                    this.currentCSR = event[0].markets[pp].runners
                                    this.currentCS_marketId = event[0].markets[pp].marketId
                                    this.CS_total_matched = event[0].markets[pp].totalMatched
                                    for(let p = 0 ; p < event[0].markets[pp].runners.length ; p++){
                                        if(event[0].markets[pp].runners[p].description){
                                            let value = event[0].markets[pp].runners[p].selectionId
                                            this.correctScoreList.push({"value": value, "label": event[0].markets[pp].runners[p].description.runnerName})
                                        }
                                    }
                                }
                            }
                        }
                        //console.log('current prediction==>',eventId, current_pre, event[0], this.correctScoreList)
                        //----------------------------classic_part--------------------------------
                        if(marketType == 'MATCH_ODDS'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- 1 - Back'
                                }
                                else{
                                    this.classic_match = '- 1 - Lay'
                                }
                            }
                            else if(team == '1'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- 2 - Back'
                                }
                                else{
                                    this.classic_match = '- 2 - Lay'
                                }
                            }
                            else if(team == '2'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- X - Back'
                                }
                                else{
                                    this.classic_match = '- X - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_05'){
                            if(team == '1'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- O 0.5 - Back'
                                }
                                else{
                                    this.classic_match = '- O 0.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_15'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- U 1.5 - Back'
                                }
                                else{
                                    this.classic_match = '- U 1.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    this.classic_match = '- O 1.5 - Back'
                                }
                                else{
                                    this.classic_match = '- O 1.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_25'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- U 2.5 - Back'
                                }
                                else{
                                    this.classic_match = '- U 2.5 - Lay'
                                }
                            }
                            else{
                                if(runnerNo == '0'){
                                    this.classic_match = '- O 2.5 - Back'
                                }
                                else{
                                    this.classic_match = '- O 2.5 - Lay'
                                }
                            }
                        }
                        else if(marketType == 'OVER_UNDER_35'){
                            if(team == '0'){
                                if(runnerNo == '0'){
                                    this.classic_match = '- U 3.5 - Back'
                                }
                                else{
                                    this.classic_match = '- U 3.5 - Lay'
                                }
                            }
                        }

                        //------------------------------------------------------------------------

                        this.eventId =eventId

                        let competitionNode = this.competitionList.filter(function(item) {
                            return item.eventId == self.eventId;
                        });
                        let competitionNode1 = this.competitionList1.filter(function(item) {
                            return item.eventId == self.eventId;
                        });
                        if(competitionNode.length > 0){
                            this.competitionName = this.$t('Competition ') + " >> " + competitionNode[0].competitions[0].name
                            this.item1.league = competitionNode[0].competitions[0].name
                            this.oddUrl = competitionNode[0].competitions[0].name.toLowerCase()
                            this.oddUrl = this.oddUrl.replace(" ", "-")

                            let eventNode = this.mainList.filter(function(item) {
                                return item.eventId == eventId;
                            });
                            if(eventNode){
                                this.oddUrl = this.oddUrl + "/" + eventNode[0].name.toLowerCase()
                                this.oddUrl = 'https://www.betfair.com/exchange/plus/en/football/' + this.oddUrl.replace(" ", "-") + '-betting-' + this.eventId
                            }
                        }else{
                            this.competitionName = this.$t('Competition ') + " >> "
                            this.item1.league = 'N/D'
                        }
                        if(competitionNode1.length > 0){
                            this.oddUrl1 = competitionNode1[0].competitions[0].name.toLowerCase()
                            this.oddUrl1 = this.oddUrl1.replaceAll(" ", "-")
                            this.oddUrl1 = this.oddUrl1 + "/" + competitionNode1[0].name.toLowerCase()
                            this.oddUrl1 = 'https://www.betfair.it/exchange/plus/it/calcio/' + this.oddUrl1.replaceAll(" ", "-") + '-scommesse-' + this.eventId
                        }

                        //console.log("betfair.it url------>", this.oddUrl1)

                        let eventNode = this.mainList.filter(function(item) {
                            return item.eventId == eventId;
                        });

                        // if(eventNode.length < 1){
                        //     return
                        // }
                        //---------------score----------------
                        if(eventNode[0].score){
                            let scoreDetail = eventNode[0].score
                            this.scoreOne = scoreDetail.home.score + ' - '
                            this.scoreTwo = scoreDetail.away.score
                        }
                        else{
                            this.scoreOne =''
                            this.scoreTwo =''
                        }

                        if(eventNode[0].status){
                            this.status = 'Live -'
                            this.timeRecord = eventNode[0].timeElapsed + "'"
                        }
                        else if(!eventNode[0].status){
                            this.status = this.$t('coming_up_main')
                            this.timeRecord =''
                        }
                        if(eventNode[0].inPlayMatchStatus == 'FirstHalfEnd'){
                            this.timeRecord = 'HT'
                        }

                        //----------------------------------------
                        let marketNode = eventNode[0].markets.filter(function(item) {
                            return item.marketType == marketType;
                        });
                        // if(marketNode.length < 1){
                        //     return
                        // }
                        // //console.log('marketNode', marketNode,team)

                        if(marketNode[0].state){
                            if(marketNode[0].state.status == 'SUSPENDED'){
                                this.marketStatus = 'SUSPENDED'
                            }
                            else if(marketNode[0].state.status == "CLOSED"){
                                this.marketStatus = 'CLOSED'
                            }
                            else if(marketNode[0].state.status == "OPEN"){
                                this.marketStatus =''
                            }
                        }
                        this.marketId = marketNode[0].marketId

                        this.total_matched = marketNode[0].totalMatched
                        let runnerNode = marketNode[0].runners[team]

                        this.selectionId = runnerNode.selectionId
                        if(eventNode[0].status){
                            // //console.log('great', this.marketId)
                            for(let u = 0; u < this.prematchOddList.length; u++){
                                let c1 =  this.marketId
                                let c2 =  this.prematchOddList[u].marketId
                                if(c1 == c2){
                                    let runnerlists = this.prematchOddList[u].runners[team]
                                    if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                        // //console.log('test!!!!',runnerlists.exchange.availableToBack[0].price)
                                        this.prematchOdd = runnerlists.exchange.availableToBack[0].price
                                    }

                                    if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                        this.prematchOdd = runnerlists.exchange.availableToLay[0].price
                                    }

                                }
                            }

                            if(!runnerNode.exchange){
                                return
                            }
                            if(runnerNode.exchange.availableToBack){
                                this.back = runnerNode.exchange.availableToBack[0].price
                                this.back_matched = runnerNode.exchange.availableToBack[0].size
                            }
                            else{
                                this.back = ""
                                this.back_matched = 0
                            }
                            if(runnerNode.exchange.availableToLay){
                                this.lay = runnerNode.exchange.availableToLay[0].price
                                this.lay_matched = runnerNode.exchange.availableToLay[0].size
                            }
                            else{
                                this.lay = ""
                                this.lay_matched = 0
                            }

                        }
                        else{
                            if(!runnerNode.exchange){
                                return
                            }
                            if(runnerNode.exchange.availableToBack){
                                this.back = runnerNode.exchange.availableToBack[0].price
                                if(runnerNo == 0){
                                    this.prematchOdd = this.back
                                }
                                this.back_matched = runnerNode.exchange.availableToBack[0].size
                            }
                            else{
                                this.back =''
                                if(runnerNo == 0){
                                    this.prematchOdd = this.back
                                }
                                this.back_matched = 0
                            }
                            if(runnerNode.exchange.availableToLay){
                                this.lay = runnerNode.exchange.availableToLay[0].price
                                if(runnerNo == 1){
                                    this.prematchOdd = this.lay
                                }
                                this.lay_matched = runnerNode.exchange.availableToLay[0].size
                            }
                            else{
                                this.lay =''
                                if(runnerNo == 1){
                                    this.prematchOdd = this.lay
                                }
                                this.lay_matched = 0
                            }
                        }
                        this.odd_calc(0)
                        this.stake_calc(0)
                        // //console.log('runnerNode===>',runnerNode)
                    }
                    //console.log('eventId=>', this.eventId)
                    let c = this.item1.league
                    this.item1.league = c

                    var user_id = localStorage.getItem("user_id");
                    //console.log('user_id', user_id);
                    
                    
                    if (user_id == 'undefined') {
                        //console.log('---- user id not found ---');
                        swal.fire("Alert!", "User not specified", "error");
                        return;
                    }
                    let marketType = val.split(",")[2];
                    let back_lay = val.split(",")[6];

                    window.axios.post(`${process.env.VUE_APP_URL}getPredictionLivestats0`,[this.eventId, user_id, marketType, back_lay]).then(({data})=>{
                        
                        // console.log('getPredictionLiveStats==>', data.data[0])
                        this.isload1 = true
                        this.hideModal_2()
                        this.coldstatsdata = data.data[0]
                        // let standing = data.data[1]
                        // let new_standing = []
                        // let seasonStandings_idList = []
                        // for(let i = 0 ; i < standing.length ; i++){
                        //     let check = 0
                        //     for(let j = 0 ; j < standing[i].standings.length ; j++){
                        //         if(standing[i].standings[j].standings){
                        //             check = 1
                        //             standing[i].standings[j].standings = standing[i].standings[j].standings.data
                        //             if (!seasonStandings_idList.includes(standing[i].standings[j].id)) {
                        //                 new_standing.push(standing[i].standings[j])
                        //                 seasonStandings_idList.push(standing[i].standings[j].id)
                        //             }
                                    
                        //         }
                        //     }
                        //     if(check == 0){
                                
                        //         if (!seasonStandings_idList.includes(standing[i]._id)) {
                        //             new_standing.push(standing[i])
                        //             seasonStandings_idList.push(standing[i]._id)
                        //         }
                        //     }
                        // }
                        // this.standingList = new_standing
                        //console.log('live stats data check===>', data.data[0])
                        if(data.data[0].length > 0) {
                            let livestats = data.data[0][0].liveStats
                            let total_data = data.data[0][0]

                            let main_data = data.data[0]
                            this.item1.fixtureId = data.data[0][0]._id
                            this.fixtureId = data.data[0][0]._id
                            this.item1.home.name = data.data[0][0].localTeamName
                            this.item1.away.name = data.data[0][0].visitorTeamName
                            this.item1.home.rank = data.data[0][0].standing.localteam_position
                            this.item1.away.rank = data.data[0][0].standing.visitorteam_position
                            let homeId = data.data[0][0].localTeamId
                            let awayId = data.data[0][0].visitorTeamId
                            this.home_id = homeId
                            this.away_id = awayId
                            if(livestats){
                                if(livestats[0] && livestats[0].scores){
                                    let current_main_data = livestats[0]
                                    let home = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr':0,
                                        'time': '',
                                        'score': 0,
                                        'flash': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let homeT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'flash': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0,
                                        'match_odd_1': '',
                                        'match_odd_2': '',
                                        'match_odd_3': '',
                                        'over_25_odd': '',
                                        'under_25_odd': '',
                                    }
                                    let away = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr': 0,
                                        'time': 0,
                                        'score': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let awayT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0
                                    }
                                    let home1 = {
                                        'on': 'red',
                                        'off': 'red',
                                        'blk': 'red',
                                        'in': 'red',
                                        'out': 'red',
                                        'cnr': 'red',
                                        'da': 'red',
                                        'poss': 'red',
                                    }
                                    let away1 = {
                                        'on': 'red',
                                        'off': 'red',
                                        'blk': 'red',
                                        'in': 'red',
                                        'out': 'red',
                                        'cnr': 'red',
                                        'da': 'red',
                                        'poss': 'red',
                                    }
                                    let home_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals':0
                                    }
                                    let away_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals': 0
                                    }
                                    let home_p = 0
                                    let away_p = 0
                                    let fixture_id = current_main_data._id
                                    let home_rtg_stats = current_main_data.home_rtg_stats
                                    let away_rtg_stats = current_main_data.away_rtg_stats
                                    let home_rank = current_main_data.home_rank
                                    let away_rank = current_main_data.away_rank

                                    let rtgTime = []
                                    let homeRS = []
                                    let awayRS = []
                                    let half_extra_time = 0

                                    let com_url = 'https://www.betfair.com/exchange/plus/en/football/'
                                    let it_url = ''

                                    if(total_data.com_link){
                                        // //console.log('com link========>', current_main_data.historical_stats[0].com_link)
                                        let com_name = total_data.com_link.competitionName
                                        let eventN = total_data.com_link.eventName
                                        com_name = com_name.toLowerCase()
                                        com_name = com_name.replaceAll(" ", "-")
                                        eventN = eventN.toLowerCase()
                                        eventN = eventN.replaceAll(" ", "-")
                                        com_url = com_name + "/" + eventN
                                        com_url = 'https://www.betfair.com/exchange/plus/en/football/' + com_url + '-betting-' + total_data.com_link.eventId
                                    }
                                    if(total_data.it_link){
                                        let it_name = total_data.it_link.competitionName
                                        let itN = total_data.it_link.eventName
                                        it_name = it_name.toLowerCase()
                                        it_name = it_name.replaceAll(" ", "")
                                        itN = itN.toLowerCase()
                                        itN = itN.replaceAll(" ", "")
                                        it_url = it_name + "/" + itN
                                        it_url = 'https://www.betfair.it/exchange/plus/it/calcio/' + it_url + '-scommesse-' + total_data.it_link.eventId
                                    }

                                    if(total_data.Odds.length > 0){
                                        for(let b = 0 ; b < total_data.Odds.length; b++){
                                            if(total_data.Odds[b].marketType === "MATCH_ODDS"){
                                                if(total_data.Odds[b].runners && total_data.Odds[b].runners.length > 0){
                                                    let runnerNode = total_data.Odds[b].runners[0]
                                                    if(runnerNode.exchange){
                                                        if(runnerNode.exchange.availableToBack){
                                                            if(runnerNode.exchange.availableToBack[0]){
                                                                homeT.match_odd_1 = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                                if(total_data.Odds[b].runners[1]){
                                                    let runnerNode1 = total_data.Odds[b].runners[1]
                                                    if(runnerNode1.exchange){
                                                        if(runnerNode1.exchange.availableToBack){
                                                            if(runnerNode1.exchange.availableToBack[0]){
                                                                homeT.match_odd_2 = runnerNode1.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                                if(total_data.Odds[b].runners[2]){
                                                    let runnerNode2 = total_data.Odds[b].runners[2]
                                                    if(runnerNode2.exchange){
                                                        if(runnerNode2.exchange.availableToBack){
                                                            if(runnerNode2.exchange.availableToBack[0]){
                                                                homeT.match_odd_3 = runnerNode2.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            else{
                                                if(total_data.Odds[b].runners && total_data.Odds[b].runners.length > 0){
                                                    let runnerNode = total_data.Odds[b].runners[0]
                                                    if(runnerNode.exchange){
                                                        if(runnerNode.exchange.availableToBack){
                                                            if(runnerNode.exchange.availableToBack[0]){
                                                                homeT.under_25_odd = runnerNode.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                                if(total_data.Odds[b].runners[1]){
                                                    let runnerNode1 = total_data.Odds[b].runners[1]
                                                    if(runnerNode1.exchange){
                                                        if(runnerNode1.exchange.availableToBack){
                                                            if(runnerNode1.exchange.availableToBack[0]){
                                                                homeT.over_25_odd = runnerNode1.exchange.availableToBack[0].price
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }

                                    if(home_rtg_stats){
                                        for(let c = 0; c < home_rtg_stats.length; c++){
                                            let minute = home_rtg_stats[c].time.minute
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }

                                            if(home_rtg_stats[c].time.extra_time != null){
                                                minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                                if(home_rtg_stats[c].time.minute < 46){
                                                    half_extra_time = home_rtg_stats[c].time.extra_time
                                                }
                                            }
                                            if(home_rtg_stats[c].time.minute > 45){
                                                minute = minute + half_extra_time
                                            }
                                            rtgTime.push(minute)

                                            if(c <= 10){
                                                if(home_rtg_stats[c].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal
                                                }
                                                if(home_rtg_stats[c].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals
                                            }
                                            else{
                                                if(home_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(home_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            homeRS.push(home_rtg.rtg)
                                        }
                                    }
                                    if(away_rtg_stats){
                                        for(let c = 0; c < away_rtg_stats.length; c++){
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }
                                            if(c <= 10){
                                                if(away_rtg_stats[c].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal
                                                }
                                                if(away_rtg_stats[c].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals
                                            }
                                            else{
                                                if(away_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(away_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            awayRS.push(-home_rtg.rtg)
                                        }
                                    }
                                    home.id = current_main_data.home_id
                                    away.id = current_main_data.away_id
                                    home.score = current_main_data.scores.localteam_score
                                    away.score = current_main_data.scores.visitorteam_score
                                    if(this.scoreOne == '' || this.scoreTwo == ''){
                                        this.scoreOne = current_main_data.scores.localteam_score + ' - '
                                        this.scoreTwo = current_main_data.scores.visitorteam_score
                                        this.status = current_main_data.time.status + ' - '
                                    }
                                    if (this.timeRecord == '' && current_main_data.time.minute != null){
                                        this.timeRecord = current_main_data.time.minute + "'"
                                    }
                                    let home_goal = current_main_data.scores.localteam_score
                                    let away_goal = current_main_data.scores.visitorteam_score
                                    this.eventScore = parseInt(home_goal) + parseInt(away_goal);
                                    //console.log('--------------- this.eventScore', this.eventScore)
                                    let goal_tooltip = ''
                                    if(current_main_data.goal_tooltip){
                                        goal_tooltip = current_main_data.goal_tooltip
                                    }

                                    let home_redCards_tooltip = ''
                                    let home_yelCards_tooltip = ''
                                    let home_sbst_tooltip = ''
                                    if (current_main_data.home_tooltip2) {
                                        home_redCards_tooltip = current_main_data.home_tooltip2.redCard
                                        home_yelCards_tooltip = current_main_data.home_tooltip2.yelCard
                                        home_sbst_tooltip = current_main_data.home_tooltip2.subs
                                    }

                                    let away_redCards_tooltip = ''
                                    let away_yelCards_tooltip = ''
                                    let away_sbst_tooltip = ''
                                    if (current_main_data.away_tooltip2) {
                                        away_redCards_tooltip = current_main_data.away_tooltip2.redCard
                                        away_yelCards_tooltip = current_main_data.away_tooltip2.yelCard
                                        away_sbst_tooltip = current_main_data.away_tooltip2.subs
                                    }

                                    let home_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'red': home_redCards_tooltip,
                                        'yel': home_yelCards_tooltip,
                                        'sbst': home_sbst_tooltip,
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID(),
                                        'redKey': this.create_UUID(),
                                        'yelKey': this.create_UUID(),
                                        'sbstKey': this.create_UUID()
                                    }
                                    let away_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'red': away_redCards_tooltip,
                                        'yel': away_yelCards_tooltip,
                                        'sbst': away_sbst_tooltip,
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID(),
                                        'redKey': this.create_UUID(),
                                        'yelKey': this.create_UUID(),
                                        'sbstKey': this.create_UUID()
                                    }
                                    if(current_main_data.home_tip_shots){
                                        for(let n = 0 ; n < current_main_data.home_tip_shots.length - 1 ; n++){
                                            if(current_main_data.home_tip_shots[n].shots != null){
                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.ongoal != 0 && current_main_data.home_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.on = home_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.home_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.home_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.ongoal - current_main_data.home_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.ongoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.ongoal - current_main_data.home_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.ongoal = current_main_data.home_tip_shots[n].shots.ongoal
                                                    }

                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.offgoal != 0 && current_main_data.home_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.off = home_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.home_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.home_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.offgoal - current_main_data.home_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.offgoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.offgoal - current_main_data.home_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.offgoal = current_main_data.home_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.insidebox != 0 && current_main_data.home_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.in = home_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.home_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.insidebox - current_main_data.home_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.insidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.insidebox - current_main_data.home_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.insidebox = current_main_data.home_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.outsidebox != 0 && current_main_data.home_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.out = home_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.outsidebox - current_main_data.home_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.outsidebox - current_main_data.home_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.outsidebox = current_main_data.home_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.blocked != 0 && current_main_data.home_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.blk = home_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.home_tip_shots[n].shots.blocked === null){
                                                        current_main_data.home_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.blocked - current_main_data.home_tip_shots[n].shots.blocked

                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.blocked >= 0 && current_main_data.home_tip_shots[n - 1].shots.blocked === null ){
                                                            current_main_data.home_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.blocked - current_main_data.home_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.blocked = current_main_data.home_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.home_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.home_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.home_tip_cnr[n].time.minute
                                            if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.home_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.home_tip_cnr[n].shots != 0 && current_main_data.home_tip_cnr[n].shots != null){
                                                home_tip_array.cnr = home_tip_array.cnr + " " + time
                                            }
                                            else{
                                                if(current_main_data.home_tip_cnr[n + 1].shots >= 0 && current_main_data.home_tip_cnr[n].shots === null){
                                                    current_main_data.home_tip_cnr[n].shots = 0
                                                }
                                                let check1 = current_main_data.home_tip_cnr[n + 1].shots - current_main_data.home_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_cnr[n].shots >= 0 && current_main_data.home_tip_cnr[n - 1].shots === null){
                                                        current_main_data.home_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2 = current_main_data.home_tip_cnr[n].shots - current_main_data.home_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_cnr[n + 1].shots =  current_main_data.home_tip_cnr[n].shots
                                                }

                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_shots){
                                        for(let n = 0 ; n < current_main_data.away_tip_shots.length - 1 ; n++){
                                            if(current_main_data.away_tip_shots[n].shots != null){

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.ongoal != 0 && current_main_data.away_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.on = away_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.away_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.away_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.ongoal - current_main_data.away_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.ongoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.ongoal - current_main_data.away_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.ongoal = current_main_data.away_tip_shots[n].shots.ongoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.offgoal != 0 && current_main_data.away_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.off = away_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.away_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.away_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.offgoal - current_main_data.away_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.offgoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.offgoal - current_main_data.away_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.offgoal = current_main_data.away_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.insidebox != 0 && current_main_data.away_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.in = away_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.away_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.insidebox - current_main_data.away_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.insidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.insidebox - current_main_data.away_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.insidebox = current_main_data.away_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.outsidebox != 0 && current_main_data.away_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.out = away_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.outsidebox - current_main_data.away_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.outsidebox - current_main_data.away_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.outsidebox = current_main_data.away_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.blocked != 0 && current_main_data.away_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.blk = away_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.away_tip_shots[n].shots.blocked === null){
                                                        current_main_data.away_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.blocked - current_main_data.away_tip_shots[n].shots.blocked
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.blocked >= 0 && current_main_data.away_tip_shots[n - 1].shots.blocked === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.blocked - current_main_data.away_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.blocked = current_main_data.away_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.away_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.away_tip_cnr[n].time.minute
                                            if(current_main_data.away_tip_cnr[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.away_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.away_tip_cnr[n].shots > 0 && current_main_data.away_tip_cnr[n].shots != null){
                                                away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                if(away.id == 10270){
                                                    //console.log('check1===>', away_tip_array.cnr)
                                                }
                                            }
                                            else{
                                                if(current_main_data.away_tip_cnr[n + 1].shots >= 0 && current_main_data.away_tip_cnr[n].shots === null){
                                                    current_main_data.away_tip_cnr[n].shots = 0
                                                }
                                                let check1  = current_main_data.away_tip_cnr[n + 1].shots - current_main_data.away_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_cnr[n].shots >= 0 && current_main_data.away_tip_cnr[n - 1].shots === null){
                                                        current_main_data.away_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2  = current_main_data.away_tip_cnr[n].shots - current_main_data.away_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_cnr[n + 1].shots = current_main_data.away_tip_cnr[n].shots
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    

                                    home.time = current_main_data.time.minute
                                    let tot_time = current_main_data.time.minute
                                    if (current_main_data.time.injury_time > 0) {
                                        home.time = current_main_data.time.minute + '+' + current_main_data.time.injury_time + "'"
                                        tot_time = current_main_data.time.minute + current_main_data.time.injury_time
                                    }
                                    if (current_main_data.time.status == 'HT') {
                                        home.time = 'HT'
                                        tot_time = 45
                                    }
                                    if(current_main_data.time.extra_minute > 0){
                                        home.time = current_main_data.time.minute + current_main_data.time.extra_minute + "'"
                                    }
                                    //---------Last 10 min Part----------//
                                    let stats = current_main_data.stats
                                    let stats_ten = current_main_data.stats_ten
                                    if (stats_ten) {
                                        if(stats_ten.length && stats_ten[0].length > 0){
                                            if (current_main_data.home_id == stats_ten[0][0].team_id) {
                                                if(stats[0].shots && stats_ten[0][0].shots){
                                                    if(stats[0].shots.ongoal != null){
                                                        home.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                        away.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                    }
                                                    if(stats[0].shots.offgoal != null){
                                                        home.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                        away.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                    }
                                                    if(stats[0].shots.blocked != null){
                                                        home.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                        away.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                    }
                                                    if(stats[0].shots.insidebox != null){
                                                        home.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                        away.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                    }
                                                    if(stats[0].shots.outsidebox != null){
                                                        home.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                        away.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                    }
                                                }

                                                if (stats[0].corners != null) {
                                                    home.cnr = stats[0].corners - stats_ten[0][0].corners
                                                    away.cnr = stats[1].corners - stats_ten[0][1].corners
                                                }

                                                if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                    if(stats[0].attacks.dangerous_attacks != null){
                                                        home.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                        away.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                    }
                                                }

                                                if(stats[0].goals != null){
                                                    home.goal = stats[0].goals - stats_ten[0][0].goals
                                                    away.goal = stats[1].goals - stats_ten[0][1].goals
                                                }

                                                if(stats_ten[0][0].possessiontime != null){
                                                    home.poss = stats_ten[0][0].possessiontime
                                                    away.poss = 100 - home.poss
                                                }

                                                if (stats[0].substitutions != null) {
                                                    home.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                                    away.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                                }
                                                if(stats[0].redcards != null){
                                                    home.red = stats[0].redcards - stats_ten[0][0].redcards
                                                    away.red = stats[1].redcards - stats_ten[0][1].redcards
                                                }
                                            }
                                            else {
                                                if(stats[0].shots && stats_ten[0][0].shots){
                                                    if(stats[0].shots.ongoal != null){
                                                        home.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                        away.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                    }
                                                    if(stats[0].shots.offgoal != null){
                                                        home.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                        away.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                    }
                                                    if(stats[0].shots.blocked != null){
                                                        home.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                        away.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                    }
                                                    if(stats[0].shots.insidebox != null){
                                                        home.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                        away.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                    }
                                                    if(stats[0].shots.outsidebox != null){
                                                        home.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                        away.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                    }
                                                }

                                                if (stats[0].corners != null) {
                                                    home.cnr = stats[1].corners - stats_ten[0][1].corners
                                                    away.cnr = stats[0].corners - stats_ten[0][0].corners
                                                }

                                                if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                    if(stats[0].attacks.dangerous_attacks != null){
                                                        home.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                        away.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                    }
                                                }

                                                if(stats[0].goals != null){
                                                    home.goal = stats[1].goals - stats_ten[0][1].goals
                                                    away.goal = stats[0].goals - stats_ten[0][0].goals
                                                }

                                                if(stats_ten[0][0].possessiontime != null){
                                                    home.poss = stats_ten[0][1].possessiontime
                                                    away.poss = 100 - home.poss
                                                }

                                                if (stats[0].substitutions != null) {
                                                    home.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                                    away.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                                }
                                                if(stats[0].redcards != null){
                                                    home.red = stats[1].redcards - stats_ten[0][1].redcards
                                                    away.red = stats[0].redcards - stats_ten[0][0].redcards
                                                }

                                            }
                                        }
                                    }
                                    if(stats.length > 0){
                                        //-------------Total Part------------//
                                        if (current_main_data.home_id === stats[0].team_id) {
                                            if(stats[0].shots){
                                                homeT.on = stats[0].shots.ongoal
                                                awayT.on = stats[1].shots.ongoal
                                                homeT.off = stats[0].shots.offgoal
                                                awayT.off = stats[1].shots.offgoal
                                                homeT.blk = stats[0].shots.blocked
                                                awayT.blk = stats[1].shots.blocked
                                                homeT.in = stats[0].shots.insidebox
                                                awayT.in = stats[1].shots.insidebox
                                                homeT.out = stats[0].shots.outsidebox
                                                awayT.out = stats[1].shots.outsidebox
                                            }

                                            homeT.cnr = stats[0].corners
                                            awayT.cnr = stats[1].corners
                                            if(stats[0].attacks != null){
                                                homeT.da = stats[0].attacks.dangerous_attacks
                                                awayT.da = stats[1].attacks.dangerous_attacks
                                            }
                                            else{
                                                homeT.da = null
                                                awayT.da = null
                                            }
                                            homeT.sbst = stats[0].substitutions
                                            awayT.sbst = stats[1].substitutions
                                            homeT.poss = stats[0].possessiontime
                                            awayT.poss = stats[1].possessiontime
                                            homeT.red = stats[0].redcards
                                            awayT.red = stats[1].redcards
                                            homeT.yel = stats[0].yellowcards
                                            awayT.yel = stats[1].yellowcards
                                        }
                                        else {
                                            if(stats[1].shots){
                                                homeT.on = stats[1].shots.ongoal
                                                awayT.on = stats[0].shots.ongoal
                                                homeT.off = stats[1].shots.offgoal
                                                awayT.off = stats[0].shots.offgoal
                                                homeT.blk = stats[1].shots.blocked
                                                awayT.blk = stats[0].shots.blocked
                                                homeT.in = stats[1].shots.insidebox
                                                awayT.in = stats[0].shots.insidebox
                                                homeT.out = stats[1].shots.outsidebox
                                                awayT.out = stats[0].shots.outsidebox
                                            }

                                            homeT.cnr = stats[1].corners
                                            awayT.cnr = stats[0].corners
                                            if(stats[1].attacks != null){
                                                homeT.da = stats[1].attacks.dangerous_attacks
                                                awayT.da = stats[0].attacks.dangerous_attacks
                                            }
                                            else{
                                                homeT.da = null
                                                awayT.da = null
                                            }

                                            homeT.sbst = stats[1].substitutions
                                            awayT.sbst = stats[0].substitutions
                                            homeT.poss = stats[1].possessiontime
                                            awayT.poss = stats[0].possessiontime
                                            homeT.red = stats[1].redcards
                                            awayT.red = stats[0].redcards
                                            homeT.yel = stats[1].yellowcards
                                            awayT.yel = stats[0].yellowcards
                                        }
                                        //----------------------------------goal notification-------------------------------
                                        if(current_main_data.home_id === stats[0].team_id){
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    home.flash = 1
                                                }
                                                else{
                                                    home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    away.flash = 1
                                                }
                                                else{
                                                    away.flash = 0
                                                }
                                                // //console.log('goal issue check===>', stats_ten[9][0].goals, stats_ten.length, stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals)
                                                home.goal = stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals
                                                away.goal = stats_ten[stats_ten.length - 1][1].goals - stats_ten[0][1].goals
                                            }
                                        }
                                        else{
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    home.flash = 1
                                                }
                                                else{
                                                    home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    away.flash = 1
                                                }
                                                else{
                                                    away.flash = 0
                                                }
                                                home.goal = stats_ten[stats_ten.length - 1][1].goals - stats_ten[0][1].goals
                                                away.goal = stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals
                                            }
                                        }
                                    }

                                    if((home.on >= 0) || (home.off >= 0) || (home.cnr >= 0) || (home.da > 0)){
                                        if(home.on >= 0){
                                            home.rtg = home.rtg + home.on*3
                                        }
                                        if(home.off >= 0){
                                            home.rtg = home.rtg + home.off*2
                                        }
                                        if(home.cnr >= 0){
                                            home.rtg = home.rtg + home.cnr
                                        }
                                        if(home.da >= 0){
                                            home.rtg = home.rtg + home.da
                                        }
                                    }
                                    else{
                                        home.rtg = '-'
                                    }

                                    if((away.on >= 0) || (away.off >= 0) || (away.cnr >= 0) || (away.da > 0)){
                                        if(away.on >= 0){
                                            away.rtg = away.rtg + away.on*3
                                        }
                                        if(away.off >= 0){
                                            away.rtg = away.rtg + away.off*2
                                        }
                                        if(away.cnr >= 0){
                                            away.rtg = away.rtg + away.cnr
                                        }
                                        if(away.da >= 0){
                                            away.rtg = away.rtg + away.da
                                        }
                                    }
                                    else{
                                        away.rtg = '-'
                                    }
                                    home.gdr = '-'
                                    away.gdr = '-'
                                    homeT.nxt = '-'
                                    awayT.nxt = '-'
                                    homeT.rtg = '-'
                                    awayT.rtg = '-'

                                    if(total_data.home_season){
                                        home_season = total_data.home_season
                                        if(total_data.home_season.p > 0){
                                            home.gdr = 0
                                            homeT.rtg = 0
                                            if(total_data.home_season.on > 0){
                                                home.last_on = total_data.home_season.on/total_data.home_season.p
                                            }
                                            if(total_data.home_season.off > 0){
                                                home.last_off = total_data.home_season.off/total_data.home_season.p
                                            }
                                            if(total_data.home_season.cnr > 0){
                                                home.last_cnr = total_data.home_season.cnr/total_data.home_season.p
                                            }
                                            if(total_data.home_season.da > 0){
                                                home.last_da = total_data.home_season.da/total_data.home_season.p
                                            }
                                            if(total_data.home_season.goals > 0){
                                                home.last_goal = total_data.home_season.goals/total_data.home_season.p
                                            }
                                            //----------average rtg-----------
                                            home.a_rtg = 0
                                            if(home.last_on > 0){
                                                home.a_rtg = home.a_rtg + (home.last_on/9)*3
                                            }
                                            if(home.last_off > 0){
                                                home.a_rtg = home.a_rtg + (home.last_off/9)*2
                                            }
                                            if(home.last_cnr > 0){
                                                home.a_rtg = home.a_rtg + (home.last_cnr/9)
                                            }
                                            if(home.last_da > 0){
                                                home.a_rtg = home.a_rtg + (home.last_da/9)
                                            }
                                            //--------------------------------

                                            if(home.last_goal > 0 && home.last_on > 0){
                                                home.gdr = home.gdr + ((100*home.on/home.last_goal/home.last_on/9)*home.on)
                                            }
                                            if(home.last_goal > 0 && home.last_off > 0){
                                                home.gdr = home.gdr + ( ( 100*home.off/home.last_goal/home.last_off/ 9 )*home.off )
                                            }
                                            if(home.last_goal > 0 && home.last_cnr > 0){
                                                home.gdr = home.gdr + ((100*home.cnr/home.last_goal/home.last_cnr/9)*home.cnr )
                                            }
                                            if(home.last_goal > 0 && home.last_da > 0){
                                                home.gdr = home.gdr + ((100*home.da/home.last_goal/home.last_da/9)*home.da )
                                            }
                                            home.gdr = home.gdr.toFixed(0)

                                            if(home_goal === 0){
                                                homeT.nxt = 0
                                                if(home.last_goal > 0 && home.last_on > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_off > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_cnr > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_da > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home.last_goal/home.last_goal)))
                                                }
                                                homeT.nxt = (homeT.nxt*100/4).toFixed(0)
                                                homeT.nxt = -1 * homeT.nxt
                                            }
                                            else if(home_goal > 0){
                                                homeT.nxt = 0
                                                if(home.last_goal > 0 && home.last_on > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_off > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_cnr > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_da > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home_goal/home.last_goal)))
                                                }
                                                homeT.nxt = (homeT.nxt*100/4 - 100).toFixed(0)
                                                homeT.nxt = -1 * homeT.nxt
                                            }

                                            if(home_goal > 0){
                                                if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                    homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                }
                                                if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                    homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                }
                                                if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                    homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                }
                                                if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                    homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                }
                                                if(tot_time > 0 && home.last_goal > 0){
                                                    homeT.rtg = homeT.rtg + home_goal*90/tot_time/home.last_goal
                                                }
                                                homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                    homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                }
                                                if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                    homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                }
                                                if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                    homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                }
                                                if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                    homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                }
                                                homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                    }

                                    if(total_data.away_season){
                                        away_season = total_data.away_season
                                        if(total_data.away_season.p > 0){
                                            away.gdr = 0
                                            awayT.rtg = 0
                                            if(total_data.away_season.on > 0){
                                                away.last_on = total_data.away_season.on/total_data.away_season.p
                                            }
                                            if(total_data.away_season.off > 0){
                                                away.last_off = total_data.away_season.off/total_data.away_season.p
                                            }
                                            if(total_data.away_season.cnr > 0){
                                                away.last_cnr = total_data.away_season.cnr/total_data.away_season.p
                                            }
                                            if(total_data.away_season.da > 0){
                                                away.last_da = total_data.away_season.da/total_data.away_season.p
                                            }
                                            if(total_data.away_season.goals > 0){
                                                away.last_goal = total_data.away_season.goals/total_data.away_season.p
                                            }

                                            if(away.last_goal > 0 && away.last_on > 0){
                                                away.gdr = away.gdr + ((100*away.on/away.last_goal/away.last_on/9)*away.on)
                                            }
                                            if(away.last_goal > 0 && away.last_off > 0){
                                                away.gdr = away.gdr + ( ( 100*away.off/away.last_goal/away.last_off/ 9 )*away.off )
                                            }
                                            if(away.last_goal > 0 && away.last_cnr > 0){
                                                away.gdr = away.gdr + ((100*away.cnr/away.last_goal/away.last_cnr/9)*away.cnr )
                                            }
                                            if(away.last_goal > 0 && away.last_da > 0){
                                                away.gdr = away.gdr + ((100*away.da/away.last_goal/away.last_da/9)*away.da )
                                            }
                                            away.gdr = away.gdr.toFixed(0)

                                            //---------------away average rtg-------------------
                                            away.a_rtg = 0
                                            if(away.last_on > 0){
                                                away.a_rtg = away.a_rtg + (away.last_on/9)*3
                                            }
                                            if(away.last_off > 0){
                                                away.a_rtg = away.a_rtg + (away.last_off/9)*2
                                            }
                                            if(away.last_cnr > 0){
                                                away.a_rtg = away.a_rtg + (away.last_cnr/9)
                                            }
                                            if(home.last_da > 0){
                                                away.a_rtg = away.a_rtg + (away.last_da/9)
                                            }
                                            //----------------------------------------------

                                            if(away_goal === 0){
                                                awayT.nxt = 0
                                                if(away.last_goal > 0 && away.last_on > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_off > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_cnr > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_da > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away.last_goal/away.last_goal)))
                                                }
                                                awayT.nxt =(awayT.nxt*100/4).toFixed(0)
                                                awayT.nxt = -1 * awayT.nxt
                                            }
                                            else if(away_goal > 0){
                                                awayT.nxt = 0
                                                if(away.last_goal > 0 && away.last_on > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_off > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_cnr > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_da > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away_goal/away.last_goal)))
                                                }
                                                awayT.nxt =(awayT.nxt*100/4 - 100).toFixed(0)
                                                awayT.nxt = -1 * awayT.nxt
                                            }

                                            if(away_goal > 0){
                                                if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                    awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                }
                                                if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                    awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                }
                                                if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                    awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                }
                                                if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                    awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                }
                                                if(tot_time > 0 && away.last_goal > 0){
                                                    awayT.rtg = awayT.rtg + away_goal*90/tot_time/away.last_goal
                                                }
                                                awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                    awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                }
                                                if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                    awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                }
                                                if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                    awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                }
                                                if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                    awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                }
                                                awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                    }

                                    current_main_data.stats = stats
                                    current_main_data.stats_ten = stats_ten

                                    //console.log('rtg_time=+++++++++++++===>', rtgTime, ', ', homeRS, ', ', awayRS)

                                    if(home.on > home_season.on/9/(home_season.p + 0.0000001)){ home1.on = 'green'}
                                    if(home.off > home_season.off/9/(home_season.p + 0.0000001)){ home1.off = 'green'}
                                    if(home.blk > home_season.block/9/(home_season.p + 0.0000001)){ home1.blk = 'green'}
                                    if(home.in > home_season.in/9/(home_season.p + 0.0000001)){ home1.in = 'green'}
                                    if(home.out > home_season.out/9/(home_season.p + 0.0000001)){ home1.out = 'green'}
                                    if(home.cnr > home_season.cnr/9/(home_season.p + 0.0000001)){ home1.cnr = 'green'}
                                    if(home.da > home_season.da/9/(home_season.p + 0.0000001)){ home1.da = 'green'}
                                    if(home.poss > home_season.pos/(home_season.p + 0.0000001)){ home1.poss = 'green'}

                                    if(home_season.p == 0){
                                        home1 = {
                                            'on': 'black',
                                            'off': 'black',
                                            'blk': 'black',
                                            'in': 'black',
                                            'out': 'black',
                                            'cnr': 'black',
                                            'da': 'black',
                                            'poss': 'black',
                                        }
                                    }

                                    if(away.on > away_season.on/9/(away_season.p + 0.0000001)){ away1.on = 'green'}
                                    if(away.off > away_season.off/9/(away_season.p + 0.0000001)){ away1.off = 'green'}
                                    if(away.blk > away_season.block/9/(away_season.p + 0.0000001)){ away1.blk = 'green'}
                                    if(away.in > away_season.in/9/(away_season.p + 0.0000001)){ away1.in = 'green'}
                                    if(away.out > away_season.out/9/(away_season.p + 0.0000001)){ away1.out = 'green'}
                                    if(away.cnr > away_season.cnr/9/(away_season.p + 0.0000001)){ away1.cnr = 'green'}
                                    if(away.da > away_season.da/9/(away_season.p + 0.0000001)){ away1.da = 'green'}
                                    if(away.poss > away_season.pos/(away_season.p + 0.0000001)){ away1.poss = 'green'}

                                    if(away_season.p == 0){
                                        away1 = {
                                            'on': 'black',
                                            'off': 'black',
                                            'blk': 'black',
                                            'in': 'black',
                                            'out': 'black',
                                            'cnr': 'black',
                                            'da': 'black',
                                            'poss': 'black',
                                        }
                                    }

                                    let chart = {
                                        'time': rtgTime,
                                        'homeRTG': homeRS,
                                        'awayRTG': awayRS
                                    }

                                    this.item1.fixtureId = fixture_id
                                    this.item1.main_data = current_main_data
                                    this.item1.home = home
                                    this.item1.away = away
                                    this.item1.home1 = home1
                                    this.item1.away1 = away1
                                    this.item1.homeRank = home_rank
                                    this.item1.awayRank = away_rank
                                    this.item1.chart = chart
                                    this.item1.home_p = home_p
                                    this.item1.goal_tooltip = goal_tooltip
                                    this.item1.goalKey = this.create_UUID()
                                    this.item1.away_p = away_p
                                    this.item1.homeT = homeT
                                    this.item1.awayT = awayT
                                    this.item1.com_url = com_url
                                    this.item1.it_url = it_url
                                    this.item1.home_season =  home_season
                                    this.item1.away_season = away_season
                                    this.item1.home_tooltip = home_tip_array
                                    this.item1.away_tooltip = away_tip_array
                                    this.item1.season_id = current_main_data.season_id
                                    this.goal_key = this.item1.goalKey
                                    this.goal_tooltip = goal_tooltip
                                }
                                else {
                                    this.eventScore = 0;
                                    //console.log('--------------- this.eventScore', this.eventScore)
                                }
                                console.log('this.item1============', this.item1)
                            }

                            //console.log('this item 1===>', this.item1)
                        }

                        if(data.data[2].length > 0) {                            
                            
                            this.calc_odd = data.data[2][0].calc_odd;

                            this.calc_stake = data.data[2][0].calc_stake;
                            

                            //please search

                            this.key2 = data.data[2][0].score;
                            this.correct_score_update(this.key2);
                            //console.log('-------------- key 2------------', this.key2)

                            this.cs_odd = data.data[2][0].cs_odd;
                            this.cs_stake = data.data[2][0].cs_stake;
                            this.cs_stake_calc(this.cs_stake);


                            this.checked_stoploss = data.data[2][0].stopLoss;
                            this.stopLossfunction(this.checked_stoploss);
                            this.checked_trading = data.data[2][0].tradingMode;
                            this.tradingModefunction(this.checked_trading);

                            if (this.checked_trading) {

                                this.alert_key = data.data[2][0].cashoutAlertName;
                                this.update_alert_name(this.alert_key );

                            }

                            this.risk_key = data.data[2][0].riskTrading;
                            this.riskMode(this.risk_key)

                            this.bookmaker_fee(data.data[2][0].bookmarkerFee)
                            this.bookmarkerFee = data.data[2][0].bookmarkerFee;
                        }
                        else {
                            this.reset_cacl();
                            if(data.data[3].length > 0) {
                                this.bookmarkerFee = data.data[3][0].default_bf;
                            }
                        }
                        
                        // this.cold_data_get()
                    })
                }
                this.item3 = {
                    home : {
                        p:0,
                        name:'',
                        rank: '',
                        z_z: 0,
                        over15: 0,
                        over25:0,
                        over35:0,
                        scored:0,
                        conc:0,
                        average1:0,
                        average2:0,
                        bts:0,
                        first1:0,
                        first2:0,
                        second1:0,
                        second2:0,
                        time15_S:0,
                        time30_S:0,
                        time45_S:0,
                        time60_S:0,
                        time75_S:0,
                        time90_S:0,
                        time15_C:0,
                        time30_C:0,
                        time45_C:0,
                        time60_C:0,
                        time75_C:0,
                        time90_C:0,
                        gs1:0,
                        gs2:0,
                        gc1:0,
                        gc2:0,
                        over40:0,
                        over85:0,
                        C_H:0,
                        C_D:0,
                        C_A:0,
                        first10:0,
                        first11:0,
                        first20:0,
                        second01:0,
                        second11:0,
                        second02:0,
                        firstGoal:0,
                        lastGoal:0,
                        secondplus:0,
                        secondminus:0,
                        homefirst:0,
                        drawfirst:0,
                        awayfirst:0,
                        homesecond:0,
                        drawsecond:0,
                        awaysecond:0,
                        eventdays:['All'],
                        pos:0,
                        h_a:0,
                        swing1:'',
                        FH:0,
                        swing2:'',
                        SH:0,
                        swing3:'',
                        attack:0,
                        defense:0,
                        form:0,
                        form_H_A:0

                    },
                    away : {
                        p:0,
                        name:'',
                        rank:'' ,
                        z_z: 0,
                        over15: 0,
                        over25:0,
                        over35:0,
                        scored:0,
                        conc:0,
                        average1:0,
                        average2:0,
                        bts:0,
                        first1:0,
                        first2:0,
                        second1:0,
                        second2:0,
                        time15_S:0,
                        time30_S:0,
                        time45_S:0,
                        time60_S:0,
                        time75_S:0,
                        time90_S:0,
                        time15_C:0,
                        time30_C:0,
                        time45_C:0,
                        time60_C:0,
                        time75_C:0,
                        time90_C:0,
                        gs1:0,
                        gs2:0,
                        gc1:0,
                        gc2:0,
                        over40:0,
                        over85:0,
                        C_H:0,
                        C_D:0,
                        C_A:0,
                        first10:0,
                        first11:0,
                        first20:0,
                        second01:0,
                        second11:0,
                        second02:0,
                        firstGoal:0,
                        lastGoal:0,
                        secondPlus:0,
                        secondMinus:0,
                        homefirst:0,
                        drawfirst:0,
                        awayfirst:0,
                        homesecond:0,
                        drawsecond:0,
                        awaysecond:0,
                        eventdays:['All'],
                        pos:0,
                        h_a:0,
                        swing1: '',
                        FH:0,
                        swing2: '',
                        SH:0,
                        swing3: '',
                        attack:0,
                        defense:0,
                        form:0,
                        form_H_A:0
                    },
                    homeDateList: [],
                    awayDateList : [],
                    home_id: 0,
                    away_id: 0,
                    openDate: '',
                    eventName: '',
                    rank_option: [],
                    rank_set: {},
                    rankFilter : false,
                    b_data : [],
                    homeLineupList: [],
                    awayLineupList: [],
                }

                this.checked_trading = false;

                console.log('this.checked_trading', this.checked_trading)

                //console.log("this.item1 format===>", this.item1)
                //console.log("this.eventId, second_eventId", this.eventId, this.second_eventId)
            },
            switch_tab(){
                this.home_id = 0
                this.away_id = 0
                this.show_collapse= false
                if(this.item3.away.name == ""){
                    this.isload1 = false
                    this.current_counter = 0
                    clearInterval(this.clock)
                    this.clock = setInterval(this.frame, 100)
                    window.axios.post(`${process.env.VUE_APP_URL}getPredictionLivestats`,[this.eventId]).then(({data})=>{
                        //console.log('getPredictionLiveStats==>', data.data[0])
                        this.isload1 = true
                        this.coldstatsdata = data.data[0]
                        // this.standingList = data.data[1]
                        //console.log('cold stats data check===>', data.data[0])
                        if(data.data[0].length > 0) {
                            let livestats = data.data[0][0].liveStats
                            let total_data = data.data[0][0]
                            let main_data = data.data[0]
                            this.item1.home.name = data.data[0][0].localTeamName
                            this.item1.away.name = data.data[0][0].visitorTeamName
                            this.item1.home.rank = data.data[0][0].standing.localteam_position
                            this.item1.away.rank = data.data[0][0].standing.visitorteam_position
                            let homeId = data.data[0][0].localTeamId
                            let awayId = data.data[0][0].visitorTeamId
                            this.home_id = homeId
                            this.away_id = awayId
                            if(livestats){
                                if(livestats[0] && livestats[0].scores){
                                    let current_main_data = livestats[0]
                                    let home = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr':0,
                                        'time': '',
                                        'score': 0,
                                        'flash': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let homeT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'flash': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0,
                                        'match_odd_1': '',
                                        'match_odd_2': '',
                                        'match_odd_3': '',
                                        'over_25_odd': '',
                                        'under_25_odd': '',
                                    }
                                    let away = {
                                        'id': 0,
                                        'on': null,
                                        'off': null,
                                        'blk': null,
                                        'in': null,
                                        'out': null,
                                        'cnr': null,
                                        'da': null,
                                        'goal': null,
                                        'rtg': 0,
                                        'gdr': 0,
                                        'time': 0,
                                        'score': 0,
                                        'poss': null,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': null,
                                        'red': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'last_on': 0,
                                        'last_off': 0,
                                        'last_cnr': 0,
                                        'last_da': 0,
                                        'last_goal': 0,
                                        'a_rtg': 14
                                    }
                                    let awayT = {
                                        'on': 0,
                                        'off': 0,
                                        'blk': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'poss': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'red': 0,
                                        'yel': 0,
                                        'fou': 0,
                                        'g_att': 0,
                                        'safe': 0,
                                        'nxt': 0,
                                        'rtg': 0
                                    }
                                    let home_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals':0
                                    }
                                    let away_season = {
                                        'on': 0,
                                        'off': 0,
                                        'block': 0,
                                        'in': 0,
                                        'out': 0,
                                        'cnr': 0,
                                        'da': 0,
                                        'pos': 0,
                                        'pas': 0,
                                        'acc': 0,
                                        'atk': 0,
                                        'ofs': 0,
                                        'sav': 0,
                                        'sbst': 0,
                                        'fou': 0 ,
                                        'g_att': 0 ,
                                        'safe': 0,
                                        'goals': 0
                                    }
                                    let home_p = 0
                                    let away_p = 0
                                    let fixture_id = current_main_data._id
                                    let home_rtg_stats = current_main_data.home_rtg_stats
                                    let away_rtg_stats = current_main_data.away_rtg_stats
                                    let home_rank = current_main_data.home_rank
                                    let away_rank = current_main_data.away_rank

                                    let rtgTime = []
                                    let homeRS = []
                                    let awayRS = []
                                    let half_extra_time = 0

                                    let com_url = 'https://www.betfair.com/exchange/plus/en/football/'
                                    let it_url = ''

                                    if(total_data.com_link && total_data.com_link.competitionName){
                                        // //console.log('com link========>', current_main_data.historical_stats[0].com_link)
                                        let com_name = total_data.com_link.competitionName
                                        let eventN = total_data.com_link.eventName
                                        com_name = com_name.toLowerCase()
                                        com_name = com_name.replaceAll(" ", "-")
                                        eventN = eventN.toLowerCase()
                                        eventN = eventN.replaceAll(" ", "-")
                                        com_url = com_name + "/" + eventN
                                        com_url = 'https://www.betfair.com/exchange/plus/en/football/' + com_url + '-betting-' + total_data.com_link.eventId
                                    }
                                    if(total_data.it_link && total_data.it_link.competitionName){
                                        let it_name = total_data.it_link.competitionName
                                        let itN = total_data.it_link.eventName
                                        it_name = it_name.toLowerCase()
                                        it_name = it_name.replaceAll(" ", "")
                                        itN = itN.toLowerCase()
                                        itN = itN.replaceAll(" ", "")
                                        it_url = it_name + "/" + itN
                                        it_url = 'https://www.betfair.it/exchange/plus/it/calcio/' + it_url + '-scommesse-' + total_data.it_link.eventId
                                    }
                                    if (total_data.Odds) {
                                        if(total_data.Odds.length > 0){
                                            for(let b = 0 ; b < total_data.Odds.length; b++){
                                                if(total_data.Odds[b].marketType === "MATCH_ODDS"){
                                                    if(total_data.Odds[b].runners && total_data.Odds[b].runners.length > 0){
                                                        let runnerNode = total_data.Odds[b].runners[0]
                                                        if(runnerNode.exchange){
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNode.exchange.availableToBack[0]){
                                                                    homeT.match_odd_1 = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if(total_data.Odds[b].runners[1]){
                                                        let runnerNode1 = total_data.Odds[b].runners[1]
                                                        if(runnerNode1.exchange){
                                                            if(runnerNode1.exchange.availableToBack){
                                                                if(runnerNode1.exchange.availableToBack[0]){
                                                                    homeT.match_odd_2 = runnerNode1.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if(total_data.Odds[b].runners[2]){
                                                        let runnerNode2 = total_data.Odds[b].runners[2]
                                                        if(runnerNode2.exchange){
                                                            if(runnerNode2.exchange.availableToBack){
                                                                if(runnerNode2.exchange.availableToBack[0]){
                                                                    homeT.match_odd_3 = runnerNode2.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                                else{
                                                    if(total_data.Odds[b].runners && total_data.Odds[b].runners.length > 0){
                                                        let runnerNode = total_data.Odds[b].runners[0]
                                                        if(runnerNode.exchange){
                                                            if(runnerNode.exchange.availableToBack){
                                                                if(runnerNode.exchange.availableToBack[0]){
                                                                    homeT.under_25_odd = runnerNode.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                    if(total_data.Odds[b].runners[1]){
                                                        let runnerNode1 = total_data.Odds[b].runners[1]
                                                        if(runnerNode1.exchange){
                                                            if(runnerNode1.exchange.availableToBack){
                                                                if(runnerNode1.exchange.availableToBack[0]){
                                                                    homeT.over_25_odd = runnerNode1.exchange.availableToBack[0].price
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    

                                    if(home_rtg_stats){
                                        for(let c = 0; c < home_rtg_stats.length; c++){
                                            let minute = home_rtg_stats[c].time.minute
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }

                                            if(home_rtg_stats[c].time.extra_time != null){
                                                minute = home_rtg_stats[c].time.minute + home_rtg_stats[c].time.extra_time
                                                if(home_rtg_stats[c].time.minute < 46){
                                                    half_extra_time = home_rtg_stats[c].time.extra_time
                                                }
                                            }
                                            if(home_rtg_stats[c].time.minute > 45){
                                                minute = minute + half_extra_time
                                            }
                                            rtgTime.push(minute)

                                            if(c <= 10){
                                                if(home_rtg_stats[c].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal
                                                }
                                                if(home_rtg_stats[c].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals
                                            }
                                            else{
                                                if(home_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = home_rtg_stats[c].shots.ongoal - home_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = home_rtg_stats[c].shots.offgoal - home_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(home_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = home_rtg_stats[c].da.dangerous_attacks - home_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = home_rtg_stats[c].cnr - home_rtg_stats[c - 10].cnr
                                                home_rtg.goal = home_rtg_stats[c].goals - home_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            homeRS.push(home_rtg.rtg)
                                        }
                                    }
                                    if(away_rtg_stats){
                                        for(let c = 0; c < away_rtg_stats.length; c++){
                                            let home_rtg = {
                                                'on': null,
                                                'off': null,
                                                'cnr': null,
                                                'da': null,
                                                'goal': null,
                                                'rtg': null
                                            }
                                            if(c <= 10){
                                                if(away_rtg_stats[c].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal
                                                }
                                                if(away_rtg_stats[c].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals
                                            }
                                            else{
                                                if(away_rtg_stats[c - 10].shots != null){
                                                    home_rtg.on = away_rtg_stats[c].shots.ongoal - away_rtg_stats[c - 10].shots.ongoal
                                                    home_rtg.off = away_rtg_stats[c].shots.offgoal - away_rtg_stats[c - 10].shots.offgoal
                                                }
                                                if(away_rtg_stats[c - 10].da != null){
                                                    home_rtg.da = away_rtg_stats[c].da.dangerous_attacks - away_rtg_stats[c - 10].da.dangerous_attacks
                                                }
                                                home_rtg.cnr = away_rtg_stats[c].cnr - away_rtg_stats[c - 10].cnr
                                                home_rtg.goal = away_rtg_stats[c].goals - away_rtg_stats[c - 10].goals
                                            }

                                            if((home_rtg.on >= 0) || (home_rtg.off >= 0) || (home_rtg.cnr >= 0) || (home_rtg.da > 0)){
                                                home_rtg.rtg = 0
                                                if(home_rtg.on >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.on*3
                                                }
                                                if(home_rtg.off >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.off*2
                                                }
                                                if(home_rtg.cnr >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.cnr
                                                }
                                                if(home_rtg.da >= 0){
                                                    home_rtg.rtg = home_rtg.rtg + home_rtg.da
                                                }
                                            }
                                            else{
                                                home_rtg.rtg = '-'
                                            }
                                            awayRS.push(-home_rtg.rtg)
                                        }
                                    }
                                    home.id = current_main_data.home_id
                                    away.id = current_main_data.away_id
                                    home.score = current_main_data.scores.localteam_score
                                    away.score = current_main_data.scores.visitorteam_score
                                    let home_goal = current_main_data.scores.localteam_score
                                    let away_goal = current_main_data.scores.visitorteam_score
                                    let goal_tooltip = ''
                                    if(current_main_data.goal_tooltip){
                                        goal_tooltip = current_main_data.goal_tooltip
                                    }
                                    let home_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'red': '',
                                        'yel': '',
                                        'sbst': '',
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID(),
                                        'redKey': this.create_UUID(),
                                        'yelKey': this.create_UUID(),
                                        'sbstKey': this.create_UUID()
                                    }
                                    let away_tip_array = {
                                        'on': '',
                                        'off': '',
                                        'in': '',
                                        'out': '',
                                        'blk': '',
                                        'cnr': '',
                                        'red': '',
                                        'yel': '',
                                        'sbst': '',
                                        'onKey': this.create_UUID(),
                                        'offKey': this.create_UUID(),
                                        'inKey': this.create_UUID(),
                                        'outKey': this.create_UUID(),
                                        'blkKey': this.create_UUID(),
                                        'cnrKey': this.create_UUID(),
                                        'redKey': this.create_UUID(),
                                        'yelKey': this.create_UUID(),
                                        'sbstKey': this.create_UUID()
                                    }
                                    if(current_main_data.home_tip_shots){
                                        for(let n = 0 ; n < current_main_data.home_tip_shots.length - 1 ; n++){
                                            if(current_main_data.home_tip_shots[n].shots != null){
                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.ongoal != 0 && current_main_data.home_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.on = home_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.home_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.home_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.ongoal - current_main_data.home_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.ongoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.ongoal - current_main_data.home_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.ongoal = current_main_data.home_tip_shots[n].shots.ongoal
                                                    }

                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.on = home_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.offgoal != 0 && current_main_data.home_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.off = home_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.home_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.home_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.offgoal - current_main_data.home_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.offgoal >= 0 && current_main_data.home_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.offgoal - current_main_data.home_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.offgoal = current_main_data.home_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.off = home_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.insidebox != 0 && current_main_data.home_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.in = home_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.home_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.insidebox - current_main_data.home_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.insidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.insidebox - current_main_data.home_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.insidebox = current_main_data.home_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.in = home_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.outsidebox != 0 && current_main_data.home_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.out = home_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.home_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.outsidebox - current_main_data.home_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.outsidebox >= 0 && current_main_data.home_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.home_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.outsidebox - current_main_data.home_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.outsidebox = current_main_data.home_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.out = home_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.home_tip_shots[n].shots.blocked != 0 && current_main_data.home_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.home_tip_shots[n].time.minute
                                                    if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    home_tip_array.blk = home_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.home_tip_shots[n + 1].time.minute
                                                    if(current_main_data.home_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.home_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.home_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.home_tip_shots[n].shots.blocked === null){
                                                        current_main_data.home_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.home_tip_shots[n + 1].shots.blocked - current_main_data.home_tip_shots[n].shots.blocked

                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.home_tip_shots[n].shots.blocked >= 0 && current_main_data.home_tip_shots[n - 1].shots.blocked === null ){
                                                            current_main_data.home_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.home_tip_shots[n].shots.blocked - current_main_data.home_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.home_tip_shots[n + 1].shots.blocked = current_main_data.home_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        home_tip_array.blk = home_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.home_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.home_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.home_tip_cnr[n].time.minute
                                            if(current_main_data.home_tip_shots[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.home_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.home_tip_cnr[n].shots != 0 && current_main_data.home_tip_cnr[n].shots != null){
                                                home_tip_array.cnr = home_tip_array.cnr + " " + time
                                            }
                                            else{
                                                if(current_main_data.home_tip_cnr[n + 1].shots >= 0 && current_main_data.home_tip_cnr[n].shots === null){
                                                    current_main_data.home_tip_cnr[n].shots = 0
                                                }
                                                let check1 = current_main_data.home_tip_cnr[n + 1].shots - current_main_data.home_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.home_tip_cnr[n].shots >= 0 && current_main_data.home_tip_cnr[n - 1].shots === null){
                                                        current_main_data.home_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2 = current_main_data.home_tip_cnr[n].shots - current_main_data.home_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.home_tip_cnr[n + 1].shots =  current_main_data.home_tip_cnr[n].shots
                                                }

                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    home_tip_array.cnr = home_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_shots){
                                        for(let n = 0 ; n < current_main_data.away_tip_shots.length - 1 ; n++){
                                            if(current_main_data.away_tip_shots[n].shots != null){

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.ongoal != 0 && current_main_data.away_tip_shots[n].shots.ongoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.on = away_tip_array.on + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.ongoal >= 0 && current_main_data.away_tip_shots[n].shots.ongoal === null){
                                                        current_main_data.away_tip_shots[n].shots.ongoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.ongoal - current_main_data.away_tip_shots[n].shots.ongoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.ongoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.ongoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.ongoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.ongoal - current_main_data.away_tip_shots[n - 1].shots.ongoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.ongoal = current_main_data.away_tip_shots[n].shots.ongoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.on = away_tip_array.on + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.offgoal != 0 && current_main_data.away_tip_shots[n].shots.offgoal != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.off = away_tip_array.off + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.offgoal >= 0 && current_main_data.away_tip_shots[n].shots.offgoal === null){
                                                        current_main_data.away_tip_shots[n].shots.offgoal = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.offgoal - current_main_data.away_tip_shots[n].shots.offgoal
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.offgoal >= 0 && current_main_data.away_tip_shots[n - 1].shots.offgoal === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.offgoal = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.offgoal - current_main_data.away_tip_shots[n - 1].shots.offgoal
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.offgoal = current_main_data.away_tip_shots[n].shots.offgoal
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.off = away_tip_array.off + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.insidebox != 0 && current_main_data.away_tip_shots[n].shots.insidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.in = away_tip_array.in + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.insidebox >= 0 && current_main_data.away_tip_shots[n].shots.insidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.insidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.insidebox - current_main_data.away_tip_shots[n].shots.insidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.insidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.insidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.insidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.insidebox - current_main_data.away_tip_shots[n - 1].shots.insidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.insidebox = current_main_data.away_tip_shots[n].shots.insidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.in = away_tip_array.in + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.outsidebox != 0 && current_main_data.away_tip_shots[n].shots.outsidebox != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.out = away_tip_array.out + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n].shots.outsidebox === null){
                                                        current_main_data.away_tip_shots[n].shots.outsidebox = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.outsidebox - current_main_data.away_tip_shots[n].shots.outsidebox
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.outsidebox >= 0 && current_main_data.away_tip_shots[n - 1].shots.outsidebox === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.outsidebox = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.outsidebox - current_main_data.away_tip_shots[n - 1].shots.outsidebox
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.outsidebox = current_main_data.away_tip_shots[n].shots.outsidebox
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.out = away_tip_array.out + " " + time + "(" + check1 + ")"
                                                    }
                                                }

                                                if(n === 0 && current_main_data.away_tip_shots[n].shots.blocked != 0 && current_main_data.away_tip_shots[n].shots.blocked != null){
                                                    let time = current_main_data.away_tip_shots[n].time.minute
                                                    if(current_main_data.away_tip_shots[n].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n].time.extra_time + "'"
                                                    }
                                                    away_tip_array.blk = away_tip_array.blk + " " + time
                                                }
                                                else{
                                                    let time = current_main_data.away_tip_shots[n + 1].time.minute
                                                    if(current_main_data.away_tip_shots[n + 1].time.extra_time > 0){
                                                        time = time + "+" + current_main_data.away_tip_shots[n + 1].time.extra_time + "'"
                                                    }
                                                    if(current_main_data.away_tip_shots[n + 1].shots.blocked >= 0 && current_main_data.away_tip_shots[n].shots.blocked === null){
                                                        current_main_data.away_tip_shots[n].shots.blocked = 0
                                                    }
                                                    let check1 = current_main_data.away_tip_shots[n + 1].shots.blocked - current_main_data.away_tip_shots[n].shots.blocked
                                                    let check2 = 0
                                                    if(n >= 1){
                                                        if(current_main_data.away_tip_shots[n].shots.blocked >= 0 && current_main_data.away_tip_shots[n - 1].shots.blocked === null){
                                                            current_main_data.away_tip_shots[n - 1].shots.blocked = 0
                                                        }
                                                        check2 = current_main_data.away_tip_shots[n].shots.blocked - current_main_data.away_tip_shots[n - 1].shots.blocked
                                                    }
                                                    if(check1 < 0){
                                                        current_main_data.away_tip_shots[n + 1].shots.blocked = current_main_data.away_tip_shots[n].shots.blocked
                                                    }
                                                    if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time
                                                    }
                                                    else if(check1 > 1 && check2 >= 0){
                                                        away_tip_array.blk = away_tip_array.blk + " " + time + "(" + check1 + ")"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    if(current_main_data.away_tip_cnr){
                                        for(let n = 0 ; n < current_main_data.away_tip_cnr.length - 1 ; n++){
                                            let time = current_main_data.away_tip_cnr[n].time.minute
                                            if(current_main_data.away_tip_cnr[n].time.extra_time > 0){
                                                time = time + "+" + current_main_data.away_tip_cnr[n].time.extra_time + "'"
                                            }
                                            if(n === 0 && current_main_data.away_tip_cnr[n].shots > 0 && current_main_data.away_tip_cnr[n].shots != null){
                                                away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                if(away.id == 10270){
                                                    //console.log('check1===>', away_tip_array.cnr)
                                                }
                                            }
                                            else{
                                                if(current_main_data.away_tip_cnr[n + 1].shots >= 0 && current_main_data.away_tip_cnr[n].shots === null){
                                                    current_main_data.away_tip_cnr[n].shots = 0
                                                }
                                                let check1  = current_main_data.away_tip_cnr[n + 1].shots - current_main_data.away_tip_cnr[n].shots
                                                let check2 = 0
                                                if(n >= 1){
                                                    if(current_main_data.away_tip_cnr[n].shots >= 0 && current_main_data.away_tip_cnr[n - 1].shots === null){
                                                        current_main_data.away_tip_cnr[n - 1].shots = 0
                                                    }
                                                    check2  = current_main_data.away_tip_cnr[n].shots - current_main_data.away_tip_cnr[n - 1].shots
                                                }
                                                if(check1 < 0){
                                                    current_main_data.away_tip_cnr[n + 1].shots = current_main_data.away_tip_cnr[n].shots
                                                }
                                                if(check1 > 0 && check1 < 2 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time
                                                }
                                                else if(check1 > 1 && check2 >= 0){
                                                    away_tip_array.cnr = away_tip_array.cnr + " " + time + "(" + check1 + ")"
                                                }
                                            }
                                        }
                                    }
                                    if (current_main_data.home_tooltip2) {
                                        home_tip_array.red = current_main_data.home_tooltip2.redCard
                                        home_tip_array.yel = current_main_data.home_tooltip2.yelCard
                                        home_tip_array.sbst = current_main_data.home_tooltip2.subs

                                        home_tip_array.redKey = this.create_UUID()
                                        home_tip_array.yelKey = this.create_UUID()
                                        home_tip_array.sbstKey = this.create_UUID()
                                    }
                                    if (current_main_data.away_tooltip2) {
                                        away_tip_array.red = current_main_data.home_tooltip2.redCard
                                        away_tip_array.yel = current_main_data.home_tooltip2.yelCard
                                        away_tip_array.sbst = current_main_data.home_tooltip2.subs

                                        away_tip_array.redKey = this.create_UUID()
                                        away_tip_array.yelKey = this.create_UUID()
                                        away_tip_array.sbstKey = this.create_UUID()
                                    }
                                    
                                    home.time = current_main_data.time.minute
                                    let tot_time = current_main_data.time.minute
                                    if (current_main_data.time.injury_time > 0) {
                                        home.time = current_main_data.time.minute + '+' + current_main_data.time.injury_time + "'"
                                        tot_time = current_main_data.time.minute + current_main_data.time.injury_time
                                    }
                                    if (current_main_data.time.status == 'HT') {
                                        home.time = 'HT'
                                        tot_time = 45
                                    }
                                    if(current_main_data.time.extra_minute > 0){
                                        home.time = current_main_data.time.minute + current_main_data.time.extra_minute + "'"
                                    }
                                    //---------Last 10 min Part----------//
                                    let stats = current_main_data.stats
                                    let stats_ten = current_main_data.stats_ten
                                    if (stats_ten) {
                                        if(stats_ten.length && stats_ten[0].length > 0){
                                            if (current_main_data.home_id == stats_ten[0][0].team_id) {
                                                if(stats[0].shots && stats_ten[0][0].shots){
                                                    if(stats[0].shots.ongoal != null){
                                                        home.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                        away.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                    }
                                                    if(stats[0].shots.offgoal != null){
                                                        home.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                        away.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                    }
                                                    if(stats[0].shots.blocked != null){
                                                        home.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                        away.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                    }
                                                    if(stats[0].shots.insidebox != null){
                                                        home.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                        away.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                    }
                                                    if(stats[0].shots.outsidebox != null){
                                                        home.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                        away.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                    }
                                                }

                                                if (stats[0].corners != null) {
                                                    home.cnr = stats[0].corners - stats_ten[0][0].corners
                                                    away.cnr = stats[1].corners - stats_ten[0][1].corners
                                                }

                                                if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                    if(stats[0].attacks.dangerous_attacks != null){
                                                        home.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                        away.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                    }
                                                }

                                                if(stats[0].goals != null){
                                                    home.goal = stats[0].goals - stats_ten[0][0].goals
                                                    away.goal = stats[1].goals - stats_ten[0][1].goals
                                                }

                                                if(stats_ten[0][0].possessiontime != null){
                                                    home.poss = stats_ten[0][0].possessiontime
                                                    away.poss = 100 - home.poss
                                                }

                                                if (stats[0].substitutions != null) {
                                                    home.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                                    away.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                                }
                                                if(stats[0].redcards != null){
                                                    home.red = stats[0].redcards - stats_ten[0][0].redcards
                                                    away.red = stats[1].redcards - stats_ten[0][1].redcards
                                                }
                                            }
                                            else {
                                                if(stats[0].shots && stats_ten[0][0].shots){
                                                    if(stats[0].shots.ongoal != null){
                                                        home.on = stats[1].shots.ongoal - stats_ten[0][1].shots.ongoal
                                                        away.on = stats[0].shots.ongoal - stats_ten[0][0].shots.ongoal
                                                    }
                                                    if(stats[0].shots.offgoal != null){
                                                        home.off = stats[1].shots.offgoal - stats_ten[0][1].shots.offgoal
                                                        away.off = stats[0].shots.offgoal - stats_ten[0][0].shots.offgoal
                                                    }
                                                    if(stats[0].shots.blocked != null){
                                                        home.blk = stats[1].shots.blocked - stats_ten[0][1].shots.blocked
                                                        away.blk = stats[0].shots.blocked - stats_ten[0][0].shots.blocked
                                                    }
                                                    if(stats[0].shots.insidebox != null){
                                                        home.in = stats[1].shots.insidebox - stats_ten[0][1].shots.insidebox
                                                        away.in = stats[0].shots.insidebox - stats_ten[0][0].shots.insidebox
                                                    }
                                                    if(stats[0].shots.outsidebox != null){
                                                        home.out = stats[1].shots.outsidebox - stats_ten[0][1].shots.outsidebox
                                                        away.out = stats[0].shots.outsidebox - stats_ten[0][0].shots.outsidebox
                                                    }
                                                }

                                                if (stats[0].corners != null) {
                                                    home.cnr = stats[1].corners - stats_ten[0][1].corners
                                                    away.cnr = stats[0].corners - stats_ten[0][0].corners
                                                }

                                                if(stats[0].attacks && stats_ten[0][0].attacks != null){
                                                    if(stats[0].attacks.dangerous_attacks != null){
                                                        home.da = stats[1].attacks.dangerous_attacks - stats_ten[0][1].attacks.dangerous_attacks
                                                        away.da = stats[0].attacks.dangerous_attacks - stats_ten[0][0].attacks.dangerous_attacks
                                                    }
                                                }

                                                if(stats[0].goals != null){
                                                    home.goal = stats[1].goals - stats_ten[0][1].goals
                                                    away.goal = stats[0].goals - stats_ten[0][0].goals
                                                }

                                                if(stats_ten[0][0].possessiontime != null){
                                                    home.poss = stats_ten[0][1].possessiontime
                                                    away.poss = 100 - home.poss
                                                }

                                                if (stats[0].substitutions != null) {
                                                    home.sbst = stats[1].substitutions - stats_ten[0][1].substitutions
                                                    away.sbst = stats[0].substitutions - stats_ten[0][0].substitutions
                                                }
                                                if(stats[0].redcards != null){
                                                    home.red = stats[1].redcards - stats_ten[0][1].redcards
                                                    away.red = stats[0].redcards - stats_ten[0][0].redcards
                                                }

                                            }
                                        }
                                    }
                                    //-------------Total Part------------//
                                    //console.log("team Id error check - stats data===>", stats)
                                    if(stats.length > 0){
                                        if (current_main_data.home_id === stats[0].team_id) {
                                            if(stats[0].shots){
                                                homeT.on = stats[0].shots.ongoal
                                                awayT.on = stats[1].shots.ongoal
                                                homeT.off = stats[0].shots.offgoal
                                                awayT.off = stats[1].shots.offgoal
                                                homeT.blk = stats[0].shots.blocked
                                                awayT.blk = stats[1].shots.blocked
                                                homeT.in = stats[0].shots.insidebox
                                                awayT.in = stats[1].shots.insidebox
                                                homeT.out = stats[0].shots.outsidebox
                                                awayT.out = stats[1].shots.outsidebox
                                            }

                                            homeT.cnr = stats[0].corners
                                            awayT.cnr = stats[1].corners
                                            if(stats[0].attacks != null){
                                                homeT.da = stats[0].attacks.dangerous_attacks
                                                awayT.da = stats[1].attacks.dangerous_attacks
                                            }
                                            else{
                                                homeT.da = null
                                                awayT.da = null
                                            }
                                            homeT.sbst = stats[0].substitutions
                                            awayT.sbst = stats[1].substitutions
                                            homeT.poss = stats[0].possessiontime
                                            awayT.poss = stats[1].possessiontime
                                            homeT.red = stats[0].redcards
                                            awayT.red = stats[1].redcards
                                            homeT.yel = stats[0].yellowcards
                                            awayT.yel = stats[1].yellowcards
                                        }
                                        else {
                                            if(stats[1].shots){
                                                homeT.on = stats[1].shots.ongoal
                                                awayT.on = stats[0].shots.ongoal
                                                homeT.off = stats[1].shots.offgoal
                                                awayT.off = stats[0].shots.offgoal
                                                homeT.blk = stats[1].shots.blocked
                                                awayT.blk = stats[0].shots.blocked
                                                homeT.in = stats[1].shots.insidebox
                                                awayT.in = stats[0].shots.insidebox
                                                homeT.out = stats[1].shots.outsidebox
                                                awayT.out = stats[0].shots.outsidebox
                                            }

                                            homeT.cnr = stats[1].corners
                                            awayT.cnr = stats[0].corners
                                            if(stats[1].attacks != null){
                                                homeT.da = stats[1].attacks.dangerous_attacks
                                                awayT.da = stats[0].attacks.dangerous_attacks
                                            }
                                            else{
                                                homeT.da = null
                                                awayT.da = null
                                            }

                                            homeT.sbst = stats[1].substitutions
                                            awayT.sbst = stats[0].substitutions
                                            homeT.poss = stats[1].possessiontime
                                            awayT.poss = stats[0].possessiontime
                                            homeT.red = stats[1].redcards
                                            awayT.red = stats[0].redcards
                                            homeT.yel = stats[1].yellowcards
                                            awayT.yel = stats[0].yellowcards
                                        }
                                        //----------------------------------goal notification-------------------------------
                                        if(current_main_data.home_id === stats[0].team_id){
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    home.flash = 1
                                                }
                                                else{
                                                    home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    away.flash = 1
                                                }
                                                else{
                                                    away.flash = 0
                                                }
                                                // //console.log('goal issue check===>', stats_ten[9][0].goals, stats_ten.length, stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals)
                                                home.goal = stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals
                                                away.goal = stats_ten[stats_ten.length - 1][1].goals - stats_ten[0][1].goals
                                            }
                                        }
                                        else{
                                            if(stats_ten.length > 1){
                                                if(stats_ten[stats_ten.length - 1][1].goals - stats_ten[stats_ten.length - 2][1].goals > 0){
                                                    home.flash = 1
                                                }
                                                else{
                                                    home.flash = 0
                                                }
                                                if(stats_ten[stats_ten.length - 1][0].goals - stats_ten[stats_ten.length - 2][0].goals > 0){
                                                    away.flash = 1
                                                }
                                                else{
                                                    away.flash = 0
                                                }
                                                home.goal = stats_ten[stats_ten.length - 1][1].goals - stats_ten[0][1].goals
                                                away.goal = stats_ten[stats_ten.length - 1][0].goals - stats_ten[0][0].goals
                                            }
                                        }
                                    }

                                    if((home.on >= 0) || (home.off >= 0) || (home.cnr >= 0) || (home.da > 0)){
                                        if(home.on >= 0){
                                            home.rtg = home.rtg + home.on*3
                                        }
                                        if(home.off >= 0){
                                            home.rtg = home.rtg + home.off*2
                                        }
                                        if(home.cnr >= 0){
                                            home.rtg = home.rtg + home.cnr
                                        }
                                        if(home.da >= 0){
                                            home.rtg = home.rtg + home.da
                                        }
                                    }
                                    else{
                                        home.rtg = '-'
                                    }

                                    if((away.on >= 0) || (away.off >= 0) || (away.cnr >= 0) || (away.da > 0)){
                                        if(away.on >= 0){
                                            away.rtg = away.rtg + away.on*3
                                        }
                                        if(away.off >= 0){
                                            away.rtg = away.rtg + away.off*2
                                        }
                                        if(away.cnr >= 0){
                                            away.rtg = away.rtg + away.cnr
                                        }
                                        if(away.da >= 0){
                                            away.rtg = away.rtg + away.da
                                        }
                                    }
                                    else{
                                        away.rtg = '-'
                                    }
                                    home.gdr = '-'
                                    away.gdr = '-'
                                    homeT.nxt = '-'
                                    awayT.nxt = '-'
                                    homeT.rtg = '-'
                                    awayT.rtg = '-'

                                    if(total_data.home_season){
                                        if(total_data.home_season.p > 0){
                                            home.gdr = 0
                                            homeT.rtg = 0
                                            if(total_data.home_season.on > 0){
                                                home.last_on = total_data.home_season.on/total_data.home_season.p
                                            }
                                            if(total_data.home_season.off > 0){
                                                home.last_off = total_data.home_season.off/total_data.home_season.p
                                            }
                                            if(total_data.home_season.cnr > 0){
                                                home.last_cnr = total_data.home_season.cnr/total_data.home_season.p
                                            }
                                            if(total_data.home_season.da > 0){
                                                home.last_da = total_data.home_season.da/total_data.home_season.p
                                            }
                                            if(total_data.home_season.goals > 0){
                                                home.last_goal = total_data.home_season.goals/total_data.home_season.p
                                            }
                                            //----------average rtg-----------
                                            home.a_rtg = 0
                                            if(home.last_on > 0){
                                                home.a_rtg = home.a_rtg + (home.last_on/9)*3
                                            }
                                            if(home.last_off > 0){
                                                home.a_rtg = home.a_rtg + (home.last_off/9)*2
                                            }
                                            if(home.last_cnr > 0){
                                                home.a_rtg = home.a_rtg + (home.last_cnr/9)
                                            }
                                            if(home.last_da > 0){
                                                home.a_rtg = home.a_rtg + (home.last_da/9)
                                            }
                                            //--------------------------------

                                            if(home.last_goal > 0 && home.last_on > 0){
                                                home.gdr = home.gdr + ((100*home.on/home.last_goal/home.last_on/9)*home.on)
                                            }
                                            if(home.last_goal > 0 && home.last_off > 0){
                                                home.gdr = home.gdr + ( ( 100*home.off/home.last_goal/home.last_off/ 9 )*home.off )
                                            }
                                            if(home.last_goal > 0 && home.last_cnr > 0){
                                                home.gdr = home.gdr + ((100*home.cnr/home.last_goal/home.last_cnr/9)*home.cnr )
                                            }
                                            if(home.last_goal > 0 && home.last_da > 0){
                                                home.gdr = home.gdr + ((100*home.da/home.last_goal/home.last_da/9)*home.da )
                                            }
                                            home.gdr = home.gdr.toFixed(0)

                                            if(home_goal === 0){
                                                homeT.nxt = 0
                                                if(home.last_goal > 0 && home.last_on > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_off > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_cnr > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home.last_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_da > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home.last_goal/home.last_goal)))
                                                }
                                                homeT.nxt = (homeT.nxt*100/4).toFixed(0)
                                                homeT.nxt = -1 * homeT.nxt
                                            }
                                            else if(home_goal > 0){
                                                homeT.nxt = 0
                                                if(home.last_goal > 0 && home.last_on > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.on*90/tot_time/(home.last_on*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_off > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.off*90/tot_time/(home.last_off*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_cnr > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.cnr*90/tot_time/(home.last_cnr*home_goal/home.last_goal)))
                                                }
                                                if(home.last_goal > 0 && home.last_da > 0){
                                                    homeT.nxt = homeT.nxt + ((homeT.da*90/tot_time/(home.last_da*home_goal/home.last_goal)))
                                                }
                                                homeT.nxt = (homeT.nxt*100/4 - 100).toFixed(0)
                                                homeT.nxt = -1 * homeT.nxt
                                            }

                                            if(home_goal > 0){
                                                if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                    homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                }
                                                if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                    homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                }
                                                if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                    homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                }
                                                if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                    homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                }
                                                if(tot_time > 0 && home.last_goal > 0){
                                                    homeT.rtg = homeT.rtg + home_goal*90/tot_time/home.last_goal
                                                }
                                                homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && home.last_on > 0 && homeT.on > 0){
                                                    homeT.rtg = homeT.rtg + homeT.on*90/tot_time/home.last_on
                                                }
                                                if(tot_time > 0 && home.last_off > 0 && homeT.off > 0){
                                                    homeT.rtg = homeT.rtg + homeT.off*90/tot_time/home.last_off
                                                }
                                                if(tot_time > 0 && home.last_cnr > 0 && homeT.cnr){
                                                    homeT.rtg = homeT.rtg + homeT.cnr*90/tot_time/home.last_cnr
                                                }
                                                if(tot_time > 0 && home.last_da > 0 && homeT.da > 0){
                                                    homeT.rtg = homeT.rtg + homeT.da*90/tot_time/home.last_da
                                                }
                                                homeT.rtg = (homeT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                    }

                                    if(total_data.away_season){
                                        if(total_data.away_season.p > 0){
                                            away.gdr = 0
                                            awayT.rtg = 0
                                            if(total_data.away_season.on > 0){
                                                away.last_on = total_data.away_season.on/total_data.away_season.p
                                            }
                                            if(total_data.away_season.off > 0){
                                                away.last_off = total_data.away_season.off/total_data.away_season.p
                                            }
                                            if(total_data.away_season.cnr > 0){
                                                away.last_cnr = total_data.away_season.cnr/total_data.away_season.p
                                            }
                                            if(total_data.away_season.da > 0){
                                                away.last_da = total_data.away_season.da/total_data.away_season.p
                                            }
                                            if(total_data.away_season.goals > 0){
                                                away.last_goal = total_data.away_season.goals/total_data.away_season.p
                                            }

                                            if(away.last_goal > 0 && away.last_on > 0){
                                                away.gdr = away.gdr + ((100*away.on/away.last_goal/away.last_on/9)*away.on)
                                            }
                                            if(away.last_goal > 0 && away.last_off > 0){
                                                away.gdr = away.gdr + ( ( 100*away.off/away.last_goal/away.last_off/ 9 )*away.off )
                                            }
                                            if(away.last_goal > 0 && away.last_cnr > 0){
                                                away.gdr = away.gdr + ((100*away.cnr/away.last_goal/away.last_cnr/9)*away.cnr )
                                            }
                                            if(away.last_goal > 0 && away.last_da > 0){
                                                away.gdr = away.gdr + ((100*away.da/away.last_goal/away.last_da/9)*away.da )
                                            }
                                            away.gdr = away.gdr.toFixed(0)

                                            //---------------away average rtg-------------------
                                            away.a_rtg = 0
                                            if(away.last_on > 0){
                                                away.a_rtg = away.a_rtg + (away.last_on/9)*3
                                            }
                                            if(away.last_off > 0){
                                                away.a_rtg = away.a_rtg + (away.last_off/9)*2
                                            }
                                            if(away.last_cnr > 0){
                                                away.a_rtg = away.a_rtg + (away.last_cnr/9)
                                            }
                                            if(home.last_da > 0){
                                                away.a_rtg = away.a_rtg + (away.last_da/9)
                                            }
                                            //----------------------------------------------

                                            if(away_goal === 0){
                                                awayT.nxt = 0
                                                if(away.last_goal > 0 && away.last_on > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_off > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_cnr > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away.last_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_da > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away.last_goal/away.last_goal)))
                                                }
                                                awayT.nxt =(awayT.nxt*100/4).toFixed(0)

                                                awayT.nxt = -1 * awayT.nxt
                                            }
                                            else if(away_goal > 0){
                                                awayT.nxt = 0
                                                if(away.last_goal > 0 && away.last_on > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.on*90/tot_time/(away.last_on*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_off > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.off*90/tot_time/(away.last_off*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_cnr > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.cnr*90/tot_time/(away.last_cnr*away_goal/away.last_goal)))
                                                }
                                                if(away.last_goal > 0 && away.last_da > 0){
                                                    awayT.nxt = awayT.nxt + ((awayT.da*90/tot_time/(away.last_da*away_goal/away.last_goal)))
                                                }
                                                awayT.nxt =(awayT.nxt*100/4 - 100).toFixed(0)

                                                awayT.nxt = -1 * awayT.nxt
                                            }

                                            if(away_goal > 0){
                                                if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                    awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                }
                                                if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                    awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                }
                                                if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                    awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                }
                                                if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                    awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                }
                                                if(tot_time > 0 && away.last_goal > 0){
                                                    awayT.rtg = awayT.rtg + away_goal*90/tot_time/away.last_goal
                                                }
                                                awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                            }
                                            else{
                                                if(tot_time > 0 && away.last_on > 0 && awayT.on > 0){
                                                    awayT.rtg = awayT.rtg + awayT.on*90/tot_time/away.last_on
                                                }
                                                if(tot_time > 0 && away.last_off > 0 && awayT.off > 0){
                                                    awayT.rtg = awayT.rtg + awayT.off*90/tot_time/away.last_off
                                                }
                                                if(tot_time > 0 && away.last_cnr > 0 && awayT.cnr > 0){
                                                    awayT.rtg = awayT.rtg + awayT.cnr*90/tot_time/away.last_cnr
                                                }
                                                if(tot_time > 0 && away.last_da > 0 && awayT.da > 0){
                                                    awayT.rtg = awayT.rtg + awayT.da*90/tot_time/away.last_da
                                                }
                                                awayT.rtg = (awayT.rtg*20 - 100).toFixed(0)
                                            }
                                        }
                                    }

                                    current_main_data.stats = stats
                                    current_main_data.stats_ten = stats_ten

                                    //console.log('rtg_time=+++++++++++++===>', rtgTime, ', ', homeRS, ', ', awayRS)

                                    let chart = {
                                        'time': rtgTime,
                                        'homeRTG': homeRS,
                                        'awayRTG': awayRS
                                    }

                                    this.item1.fixtureId = fixture_id
                                    this.item1.main_data = current_main_data
                                    this.item1.home = home
                                    this.item1.away = away
                                    this.item1.homeRank = home_rank
                                    this.item1.awayRank = away_rank
                                    this.item1.chart = chart
                                    this.item1.home_p = home_p
                                    this.item1.goal_tooltip = goal_tooltip
                                    this.item1.goalKey = this.create_UUID()
                                    this.item1.away_p = away_p
                                    this.item1.homeT = homeT
                                    this.item1.awayT = awayT
                                    this.item1.com_url = com_url
                                    this.item1.it_url = it_url
                                    this.item1.home_season =  home_season
                                    this.item1.away_season = away_season
                                    this.item1.home_tooltip = home_tip_array
                                    this.item1.away_tooltip = away_tip_array
                                    this.item1.season_id = current_main_data.season_id
                                }
                            }
                            //console.log('this item 1===>', this.item1)

                            let home_p = 0
                            let away_p = 0
                            let home_poss_index = 0
                            let away_poss_index = 0
                            let home_season = {
                                'on': 0,
                                'off': 0,
                                'block': 0,
                                'in': 0,
                                'out': 0,
                                'cnr': 0,
                                'da': 0,
                                'pos': 0,
                                'pas': 0,
                                'acc': 0,
                                'atk': 0,
                                'ofs': 0,
                                'sav': 0,
                                'sbst': 0,
                                'fou': 0,
                                'g_att': 0,
                                'safe': 0,
                                'goals': 0
                            }
                            let away_season = {
                                'on': 0,
                                'off': 0,
                                'block': 0,
                                'in': 0,
                                'out': 0,
                                'cnr': 0,
                                'da': 0,
                                'pos': 0,
                                'pas': 0,
                                'acc': 0,
                                'atk': 0,
                                'ofs': 0,
                                'sav': 0,
                                'sbst': 0,
                                'fou': 0,
                                'g_att': 0,
                                'safe': 0,
                                'goals': 0
                            }
                            total_data.season_stats = total_data.events
                            //console.log("season stats data log===>", total_data.season_stats)
                            if (total_data.season_stats.length > 0) {
                                for (let u = 0; u < total_data.season_stats.length; u++) {
                                    if (total_data.season_stats[u].stats) {
                                        if (total_data.season_stats[u].stats.length > 0) {
                                            for (let uu = 0; uu < total_data.season_stats[u].stats.length; uu++) {
                                                if (total_data.season_stats[u].stats[uu].stats[0]) {
                                                    if (total_data.season_stats[u].stats[uu].stats[0].team_id == homeId) {
                                                        home_p++
                                                        if (total_data.season_stats[u].stats[uu].stats[0].shots) {
                                                            home_season.on = home_season.on + total_data.season_stats[u].stats[uu].stats[0].shots.ongoal
                                                            home_season.off = home_season.off + total_data.season_stats[u].stats[uu].stats[0].shots.offgoal
                                                            home_season.block = home_season.block + total_data.season_stats[u].stats[uu].stats[0].shots.block
                                                            home_season.in = home_season.in + total_data.season_stats[u].stats[uu].stats[0].shots.insidebox
                                                            home_season.out = home_season.out + total_data.season_stats[u].stats[uu].stats[0].shots.outsidebox
                                                        }

                                                        if (total_data.season_stats[u].stats[uu].stats[0].goals) {
                                                            home_season.goals = home_season.goals + total_data.season_stats[u].stats[uu].stats[0].goals
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].corners != null) {
                                                            home_season.cnr = home_season.cnr + total_data.season_stats[u].stats[uu].stats[0].corners
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].attacks != null) {
                                                            home_season.da = home_season.da + total_data.season_stats[u].stats[uu].stats[0].attacks.dangerous_attacks
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].possessiontime) {
                                                            home_poss_index++
                                                            home_season.pos = home_season.pos + total_data.season_stats[u].stats[uu].stats[0].possessiontime
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].passes) {
                                                            home_season.pas = home_season.pas + total_data.season_stats[u].stats[uu].stats[0].passes.total
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].passes) {
                                                            home_season.acc = home_season.acc + total_data.season_stats[u].stats[uu].stats[0].passes.accurate
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].attacks) {
                                                            home_season.atk = home_season.atk + total_data.season_stats[u].stats[uu].stats[0].attacks.attacks
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].offsides) {
                                                            home_season.ofs = home_season.ofs + total_data.season_stats[u].stats[uu].stats[0].offsides
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].saves) {
                                                            home_season.sav = home_season.sav + total_data.season_stats[u].stats[uu].stats[0].saves
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].saves) {
                                                            home_season.sbst = home_season.sbst + total_data.season_stats[u].stats[uu].stats[0].substitutions
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].fouls) {
                                                            home_season.fou = home_season.fou + total_data.season_stats[u].stats[uu].stats[0].fouls
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].goal_attempts) {
                                                            home_season.g_att = home_season.g_att + total_data.season_stats[u].stats[uu].stats[0].goal_attempts
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].ball_safe) {
                                                            home_season.safe = home_season.safe + total_data.season_stats[u].stats[uu].stats[0].ball_safe
                                                        }
                                                    }
                                                    if (total_data.season_stats[u].stats[uu].stats[1].team_id == awayId) {
                                                        away_p++
                                                        if (total_data.season_stats[u].stats[uu].stats[1].shots) {
                                                            away_season.on = home_season.on + total_data.season_stats[u].stats[uu].stats[1].shots.ongoal
                                                            away_season.off = home_season.off + total_data.season_stats[u].stats[uu].stats[1].shots.offgoal

                                                            if (total_data.season_stats[u].stats[uu].stats[0].shots.block != null) {
                                                                away_season.block = home_season.block + total_data.season_stats[u].stats[uu].stats[1].shots.block
                                                            }
                                                            if (total_data.season_stats[u].stats[uu].stats[0].shots.insidebox != null) {
                                                                away_season.in = home_season.in + total_data.season_stats[u].stats[uu].stats[1].shots.insidebox
                                                            }
                                                            if (total_data.season_stats[u].stats[uu].stats[0].shots.outsidebox != null) {
                                                                away_season.out = home_season.out + total_data.season_stats[u].stats[uu].stats[1].shots.outsidebox
                                                            }
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[1].goals) {
                                                            away_season.goals = away_season.goals + total_data.season_stats[u].stats[uu].stats[1].goals
                                                        }

                                                        if (total_data.season_stats[u].stats[uu].stats[0].corners != null) {
                                                            away_season.cnr = home_season.cnr + total_data.season_stats[u].stats[uu].stats[1].corners
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].attacks != null) {
                                                            away_season.da = home_season.da + total_data.season_stats[u].stats[uu].stats[1].attacks.dangerous_attacks
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].possessiontime) {
                                                            away_poss_index++
                                                            away_season.pos = home_season.pos + total_data.season_stats[u].stats[uu].stats[1].possessiontime
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].passes) {
                                                            away_season.pas = home_season.pas + total_data.season_stats[u].stats[uu].stats[1].passes.total
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].passes) {
                                                            away_season.acc = home_season.acc + total_data.season_stats[u].stats[uu].stats[1].passes.accurate
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].attacks) {
                                                            away_season.atk = home_season.atk + total_data.season_stats[u].stats[uu].stats[1].attacks.attacks
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].offsides) {
                                                            away_season.ofs = home_season.ofs + total_data.season_stats[u].stats[uu].stats[1].offsides
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].saves) {
                                                            away_season.sav = home_season.sav + total_data.season_stats[u].stats[uu].stats[1].saves
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].saves) {
                                                            away_season.sbst = home_season.sbst + total_data.season_stats[u].stats[uu].stats[1].substitutions
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].fouls) {
                                                            away_season.fou = home_season.fou + total_data.season_stats[u].stats[uu].stats[1].fouls
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].goal_attempts) {
                                                            away_season.g_att = home_season.g_att + total_data.season_stats[u].stats[uu].stats[1].goal_attempts
                                                        }
                                                        if (total_data.season_stats[u].stats[uu].stats[0].ball_safe) {
                                                            away_season.safe = home_season.safe + total_data.season_stats[u].stats[uu].stats[1].ball_safe
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                home_season.pos = parseInt(home_season.pos / home_poss_index)
                                away_season.pos = parseInt(away_season.pos / away_poss_index)
                            }
                            this.item1.home_season = home_season
                            this.item1.away_season = away_season
                            if (home_p !== 0) {
                                this.item1.home_p = home_p
                                this.item1.away_p = away_p
                            }
                            let k = 0
                            for (let j = 0; j < main_data.length; j++) {
                                k++
                                let homeTeam = []
                                let awayTeam = []
                                let homeTeam1 = []
                                let awayTeam1 = []
                                let localTeamId = main_data[j].localTeamId
                                let visitTeamId = main_data[j].visitorTeamId
                                let homeTeamName = main_data[j].localTeamName
                                let awayTeamName = main_data[j].visitorTeamName
                                let homeTeamFormation = main_data[j].formations.localteam_formation
                                let awayTeamFormation = main_data[j].formations.visitorteam_formation
                                let homeTeamPformation = ''
                                let awayTeamPformation = ''
                                if (main_data[j].pre_formations) {
                                    homeTeamPformation = main_data[j].pre_formations.localteam_formation
                                    awayTeamPformation = main_data[j].pre_formations.visitorteam_formation
                                }
                                //
                                // let percentage0 = this.percentage_calculation(main_data[j])
                                let percentage = parseInt(main_data[j].percentage)
                                let numbers = parseInt(main_data[j].numbers)

                                let homeTeamLformation = main_data[j].live_formations.localteam_formation
                                let awayTeamLformation = main_data[j].live_formations.visitorteam_formation
                                if (main_data[j].lineup != null) {
                                    let h_k = 0
                                    let a_k = 0
                                    for (let k = 0; k < main_data[j].lineup.data.length; k++) {
                                        if (main_data[j].lineup.data[k].team_id === localTeamId && main_data[j].local_players.length > 0) {
                                            h_k++
                                            let position = ''
                                            if (main_data[j].lineup.data[k].position === 'G') {
                                                position = 'GK'
                                            } else if (main_data[j].lineup.data[k].position === 'D') {
                                                position = 'DEF'
                                            } else if (main_data[j].lineup.data[k].position === 'M') {
                                                position = 'MID'
                                            } else if (main_data[j].lineup.data[k].position === 'A') {
                                                position = 'FWD'
                                            } else {
                                                position = '-'
                                            }

                                            let market_value = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'
                                            let market_player_name = ''
                                            let local_players = main_data[j].local_players.filter(function (item) {
                                                return item.team_id == localTeamId && item.market_values.length > 0;
                                            });

                                            let player_birthday = ''
                                            let titularity1 = main_data[j].local_players[0].titularity.filter(function (item) {
                                                return item.player_id === main_data[j].lineup.data[k].player_id;
                                            })
                                            if (titularity1.length > 0) {
                                                if (titularity1[0].player) {
                                                    player_birthday = titularity1[0].player.data.birthdate
                                                }
                                            }
                                            if (player_birthday === "NaN/NaN/NaN") {
                                                player_birthday = ''
                                            }

                                            if (local_players.length > 0) {
                                                let values = local_players[0].market_values.filter(function (item) {
                                                    return item.player_number == main_data[j].lineup.data[k].number;
                                                });
                                                if (values.length > 0) {
                                                    if (values.length > 1) {
                                                        let values00 = local_players[0].market_values.filter(function (item) {
                                                            return item.player_number == main_data[j].lineup.data[k].number && item.player_birthday == player_birthday;
                                                        });
                                                        if (values00.length > 0) {
                                                            market_value = values00[0].player_marketvalue
                                                            market_player_name = values00[0].player_name
                                                        }
                                                    } else {
                                                        market_value = values[0].player_marketvalue
                                                        market_player_name = values[0].player_name
                                                    }
                                                } else {
                                                    let value = local_players[0].market_values.filter(function (item) {
                                                        return player_birthday == item.player_birthday;
                                                    });
                                                    if (value.length > 0) {
                                                        market_value = value[0].player_marketvalue
                                                        market_player_name = value[0].player_name

                                                    } else {
                                                        let value0 = local_players[0].market_values.filter(function (item) {
                                                            return item.player_name.trim() == main_data[j].lineup.data[k].player_name;
                                                        });
                                                        if (value0.length > 0) {
                                                            market_value = value0[0].player_marketvalue
                                                            market_player_name = value0[0].player_name
                                                        } else {
                                                            let value1 = local_players[0].market_values.filter(function (item) {
                                                                return player_birthday == item.player_birthday;
                                                            });
                                                            if (value1.length > 0) {
                                                                market_value = value1[0].player_marketvalue
                                                                market_player_name = value1[0].player_name
                                                            }
                                                        }
                                                    }
                                                }

                                                let roles = local_players[0].roles.filter(function (item) {
                                                    return item.player_number == main_data[j].lineup.data[k].number && item.player_name == market_player_name;
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                    if (localTeamId == 329) {
                                                        //console.log('====>', roles[0], main_data[j].lineup.data[k].player_name, main_role, main_data[j].lineup.data[k].number)
                                                    }
                                                    if (alt_role1 == '') {
                                                        alt_role1 = '...'
                                                    }
                                                    if (alt_role2 == '') {
                                                        alt_role2 = '...'
                                                    }
                                                } else {
                                                    let names = local_players[0].roles.filter(function (item) {
                                                        return item.player_name.trim() == market_player_name;
                                                    });
                                                    if (names.length > 0) {
                                                        main_role = names[0].player_main_role
                                                        alt_role1 = names[0].player_alt_role1
                                                        alt_role2 = names[0].player_alt_role2
                                                        if (alt_role1 == '') {
                                                            alt_role1 = '...'
                                                        }
                                                        if (alt_role2 == '') {
                                                            alt_role2 = '...'
                                                        }
                                                    } else {
                                                        let namex = local_players[0].roles.filter(function (item) {
                                                            return item.player_name.trim() === market_player_name;
                                                        });
                                                        if (namex.length > 0) {
                                                            main_role = namex[0].player_main_role
                                                            alt_role1 = namex[0].player_alt_role1
                                                            alt_role2 = namex[0].player_alt_role2
                                                            if (alt_role1 == '') {
                                                                alt_role1 = '...'
                                                            }
                                                            if (alt_role2 == '') {
                                                                alt_role2 = '...'
                                                            }
                                                        } else {
                                                            let name0 = local_players[0].roles.filter(function (item) {
                                                                return item.player_name.trim().substring(item.player_name.trim().length - 4, item.player_name.trim().length) == main_data[j].lineup.data[k].player_name.substring(main_data[j].lineup.data[k].player_name.length - 4, main_data[j].lineup.data[k].player_name.length);
                                                            });
                                                            if (name0.length > 0) {
                                                                main_role = name0[0].player_main_role
                                                                alt_role1 = name0[0].player_alt_role1
                                                                alt_role2 = name0[0].player_alt_role2
                                                                if (alt_role1 == '') {
                                                                    alt_role1 = '...'
                                                                }
                                                                if (alt_role2 == '') {
                                                                    alt_role2 = '...'
                                                                }
                                                            } else {
                                                                let name1 = local_players[0].roles.filter(function (item) {
                                                                    return item.player_name.trim().substring(0, 3) == main_data[j].lineup.data[k].player_name.substring(0, 3);
                                                                });
                                                                if (name1.length > 0) {
                                                                    main_role = name1[0].player_main_role
                                                                    alt_role1 = name1[0].player_alt_role1
                                                                    alt_role2 = name1[0].player_alt_role2
                                                                    if (alt_role1 == '') {
                                                                        alt_role1 = '...'
                                                                    }
                                                                    if (alt_role2 == '') {
                                                                        alt_role2 = '...'
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if (main_role == 'GK') {
                                                position = 'GK'
                                            } else if (main_role == 'RB') {
                                                position = 'DEF'
                                            } else if (main_role == 'CB') {
                                                position = 'DEF'
                                            } else if (main_role == 'LB') {
                                                position = 'DEF'
                                            } else if (main_role == 'RM') {
                                                position = 'MID'
                                            } else if (main_role == 'CM') {
                                                position = 'MID'
                                            } else if (main_role == 'LM') {
                                                position = 'MID'
                                            } else if (main_role == 'DM') {
                                                position = 'MID'
                                            } else if (main_role == 'AM') {
                                                position = 'MID'
                                            } else if (main_role == 'RW') {
                                                position = 'FWD'
                                            } else if (main_role == 'LW') {
                                                position = 'FWD'
                                            } else if (main_role == 'SS') {
                                                position = 'FWD'
                                            } else if (main_role == 'CF') {
                                                position = 'FWD'
                                            }

                                            let Tit = (0).toFixed(2)
                                            let rate = "..."
                                            let titularity = main_data[j].local_players[0].titularity.filter(function (item) {
                                                return item.player_id === main_data[j].lineup.data[k].player_id;
                                            })

                                            let home_team_played = 0
                                            home_team_played = main_data[j].home_events_number
                                            let minute = 0
                                            if (titularity[0]) {
                                                minute = titularity[0].minutes
                                                if (titularity[0].rating) {
                                                    rate = titularity[0].rating
                                                }
                                            }
                                            if (home_team_played > 0) {
                                                Tit = (minute / 90 / home_team_played * 100).toFixed(2) + ', ' + home_team_played
                                            }


                                            let rule_color = 'rgb(216, 228, 188)'
                                            // pre-formartion part
                                            let s_roles = this.s_role_set.filter(function (item) {
                                                return item.name === homeTeamFormation;
                                            })

                                            if (s_roles.length > 0) {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                if (!main_data[j].lineup.data[k].formation_position) {
                                                    position_number = h_k
                                                }
                                                let s_role = s_roles[0].s_role[position_number - 1]
                                                let s_role2 = s_roles[0].alt_s_role[position_number - 1]
                                                let s_role3 = s_roles[0].alt_s_role1[position_number - 1]
                                                let mean_role = s_roles[0].mean_role[position_number - 1]
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }

                                                homeTeam.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': localTeamId,
                                                    'sRole': s_role,
                                                    'mR': mean_role,
                                                    'sRole1': s_role,
                                                    'sRole2': s_role2,
                                                    'sRole3': s_role3,
                                                    'mR1': mean_role,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(216, 228, 188)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            } else {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                homeTeam.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': localTeamId,
                                                    'sRole': '...',
                                                    'mR': position,
                                                    'sRole1': '...',
                                                    'sRole2': '',
                                                    'mR1': position,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(216, 228, 188)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            }

                                            //live formartion part
                                            let s_roles_live = this.s_role_set.filter(function (item) {
                                                return item.name === homeTeamFormation;
                                            })

                                            if (s_roles_live.length > 0) {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                if (!main_data[j].lineup.data[k].formation_position) {
                                                    position_number = h_k
                                                }
                                                let s_role = s_roles_live[0].s_role[position_number - 1]
                                                let s_role2 = s_roles_live[0].alt_s_role[position_number - 1]
                                                let s_role3 = s_roles_live[0].alt_s_role1[position_number - 1]
                                                let mean_role = s_roles_live[0].mean_role[position_number - 1]
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }
                                                homeTeam1.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': localTeamId,
                                                    'sRole': s_role,
                                                    'mR': mean_role,
                                                    'sRole1': s_role,
                                                    'sRole2': s_role2,
                                                    'sRole3': s_role3,
                                                    'mR1': mean_role,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(216, 228, 188)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            } else {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                homeTeam1.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': localTeamId,
                                                    'sRole': '...',
                                                    'mR': position,
                                                    'sRole1': '...',
                                                    'sRole2': '',
                                                    'mR1': position,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(216, 228, 188)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            }
                                            //-------------------------------------------------------------------
                                        } else {
                                            let position = ''
                                            if (main_data[j].lineup.data[k].position === 'G') {
                                                position = 'GK'
                                            } else if (main_data[j].lineup.data[k].position === 'D') {
                                                position = 'DEF'
                                            } else if (main_data[j].lineup.data[k].position === 'M') {
                                                position = 'MID'
                                            } else if (main_data[j].lineup.data[k].position === 'A') {
                                                position = 'FWD'
                                            } else {
                                                position = '-'
                                            }

                                            let market_value = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'
                                            let market_player_name = '...'
                                            let local_players = main_data[j].visitor_players.filter(function (item) {
                                                return item.team_id == visitTeamId && item.market_values.length > 0;
                                            });

                                            let player_birthday = ''
                                            let titularity1 = main_data[j].local_players[0].titularity.filter(function (item) {
                                                return item.player_id === main_data[j].lineup.data[k].player_id;
                                            })
                                            if (titularity1.length > 0) {
                                                if (titularity1[0].player) {
                                                    player_birthday = titularity1[0].player.data.birthdate
                                                }
                                            }
                                            if (player_birthday === "NaN/NaN/NaN") {
                                                player_birthday = ''
                                            }

                                            if (local_players.length > 0) {
                                                let values = local_players[0].market_values.filter(function (item) {
                                                    return item.player_number == main_data[j].lineup.data[k].number;
                                                });
                                                if (values.length > 0) {
                                                    market_value = values[0].player_marketvalue
                                                    market_player_name = values[0].player_name
                                                } else {
                                                    let value = local_players[0].market_values.filter(function (item) {
                                                        return item.player_name == main_data[j].lineup.data[k].player_name;
                                                    });
                                                    if (value.length > 0) {
                                                        market_value = value[0].player_marketvalue
                                                        market_player_name = value[0].player_name
                                                    } else {
                                                        // let value0 = local_players[0].market_values.filter(function(item) {
                                                        //     return item.player_name.substring(item.player_name.length - 4, item.player_name.length) == main_data[j].lineup.data[k].player_name.substring(main_data[j].lineup.data[k].player_name.length - 4, main_data[j].lineup.data[k].player_name.length) && player_birthday == item.player_birthday;
                                                        // });
                                                        let value0 = local_players[0].market_values.filter(function (item) {
                                                            return player_birthday == item.player_birthday;
                                                        });
                                                        if (value0.length > 0) {
                                                            market_value = value0[0].player_marketvalue
                                                            market_player_name = value0[0].player_name
                                                        } else {
                                                            // let value1 = local_players[0].market_values.filter(function(item) {
                                                            //     return item.player_name.substring(0, 3) == main_data[j].lineup.data[k].player_name.substring(0, 3) && player_birthday == item.player_birthday;
                                                            // });
                                                            let value1 = local_players[0].market_values.filter(function (item) {
                                                                return player_birthday == item.player_birthday;
                                                            });
                                                            if (value1.length > 0) {
                                                                market_value = value1[0].player_marketvalue
                                                                market_player_name = value1[0].player_name
                                                            }
                                                        }
                                                    }
                                                }

                                                let roles = local_players[0].roles.filter(function (item) {
                                                    return item.player_number == main_data[j].lineup.data[k].number;
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                    if (alt_role1 == '') {
                                                        alt_role1 = '...'
                                                    }
                                                    if (alt_role2 == '') {
                                                        alt_role2 = '...'
                                                    }
                                                } else {
                                                    let names = local_players[0].roles.filter(function (item) {
                                                        return item.player_name == main_data[j].lineup.data[k].player_name || market_player_name == item.player_name;
                                                    });
                                                    if (names.length > 0) {
                                                        main_role = names[0].player_main_role
                                                        alt_role1 = names[0].player_alt_role1
                                                        alt_role2 = names[0].player_alt_role2
                                                        if (alt_role1 == '') {
                                                            alt_role1 = '...'
                                                        }
                                                        if (alt_role2 == '') {
                                                            alt_role2 = '...'
                                                        }
                                                    } else {
                                                        let name0 = local_players[0].roles.filter(function (item) {
                                                            return item.player_name.substring(item.player_name.length - 4, item.player_name.length) == main_data[j].lineup.data[k].player_name.substring(main_data[j].lineup.data[k].player_name.length - 4, main_data[j].lineup.data[k].player_name.length);
                                                        });
                                                        if (name0.length > 0) {
                                                            main_role = name0[0].player_main_role
                                                            alt_role1 = name0[0].player_alt_role1
                                                            alt_role2 = name0[0].player_alt_role2
                                                            if (alt_role1 == '') {
                                                                alt_role1 = '...'
                                                            }
                                                            if (alt_role2 == '') {
                                                                alt_role2 = '...'
                                                            }
                                                        } else {
                                                            let name1 = local_players[0].roles.filter(function (item) {
                                                                return item.player_name.substring(0, 3) == main_data[j].lineup.data[k].player_name.substring(0, 3);
                                                            });
                                                            if (name1.length > 0) {
                                                                main_role = name1[0].player_main_role
                                                                alt_role1 = name1[0].player_alt_role1
                                                                alt_role2 = name1[0].player_alt_role2
                                                                if (alt_role1 == '') {
                                                                    alt_role1 = '...'
                                                                }
                                                                if (alt_role2 == '') {
                                                                    alt_role2 = '...'
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }

                                            if (main_role == 'GK') {
                                                position = 'GK'
                                            } else if (main_role == 'RB') {
                                                position = 'DEF'
                                            } else if (main_role == 'CB') {
                                                position = 'DEF'
                                            } else if (main_role == 'LB') {
                                                position = 'DEF'
                                            } else if (main_role == 'RM') {
                                                position = 'MID'
                                            } else if (main_role == 'CM') {
                                                position = 'MID'
                                            } else if (main_role == 'LM') {
                                                position = 'MID'
                                            } else if (main_role == 'DM') {
                                                position = 'MID'
                                            } else if (main_role == 'AM') {
                                                position = 'MID'
                                            } else if (main_role == 'RW') {
                                                position = 'FWD'
                                            } else if (main_role == 'LW') {
                                                position = 'FWD'
                                            } else if (main_role == 'SS') {
                                                position = 'FWD'
                                            } else if (main_role == 'CF') {
                                                position = 'FWD'
                                            }

                                            let Tit = (0).toFixed(2)
                                            let rate = '...'
                                            let titularity = []
                                            if (main_data[j].visitor_players.length > 0) {
                                                titularity = main_data[j].visitor_players[0].titularity.filter(function (item) {
                                                    return item.player_id === main_data[j].lineup.data[k].player_id;
                                                })
                                            }

                                            let away_team_played = 0
                                            away_team_played = main_data[j].away_events_number
                                            let minute = 0
                                            if (titularity[0]) {
                                                minute = titularity[0].minutes
                                                if (titularity[0].rating) {
                                                    rate = titularity[0].rating
                                                }
                                            }
                                            if (away_team_played > 0) {
                                                Tit = (minute / 90 / away_team_played * 100).toFixed(2) + ', ' + away_team_played
                                            }
                                            let rule_color = 'rgb(230,184,183)'
                                            // away pre formation part
                                            let s_roles = this.s_role_set.filter(function (item) {
                                                return item.name === awayTeamFormation;
                                            });
                                            a_k++
                                            if (s_roles.length > 0) {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                if (!main_data[j].lineup.data[k].formation_position) {
                                                    position_number = a_k
                                                }
                                                let s_role = s_roles[0].s_role[position_number - 1]
                                                let s_role2 = s_roles[0].alt_s_role[position_number - 1]
                                                let s_role3 = s_roles[0].alt_s_role1[position_number - 1]
                                                let mean_role = s_roles[0].mean_role[position_number - 1]
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }
                                                awayTeam.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': visitTeamId,
                                                    'sRole': s_role,
                                                    'mR': mean_role,
                                                    'sRole1': s_role,
                                                    'sRole2': s_role2,
                                                    'sRole3': s_role3,
                                                    'mR1': mean_role,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(230, 184, 183)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            } else {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                awayTeam.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': visitTeamId,
                                                    'sRole': '...',
                                                    'mR': position,
                                                    'sRole1': '...',
                                                    'sRole2': '',
                                                    'mR1': position,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(230, 184, 183)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            }
                                            // away live formation part
                                            let s_roles_live_a = this.s_role_set.filter(function (item) {
                                                return item.name === awayTeamFormation;
                                            });

                                            if (s_roles_live_a.length > 0) {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                if (!main_data[j].lineup.data[k].formation_position) {
                                                    position_number = a_k
                                                }
                                                let s_role = s_roles_live_a[0].s_role[position_number - 1]
                                                let s_role2 = s_roles_live_a[0].alt_s_role[position_number - 1]
                                                let s_role3 = s_roles_live_a[0].alt_s_role1[position_number - 1]
                                                let mean_role = s_roles_live_a[0].mean_role[position_number - 1]
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }
                                                awayTeam1.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': visitTeamId,
                                                    'sRole': s_role,
                                                    'mR': mean_role,
                                                    'sRole1': s_role,
                                                    'sRole2': s_role2,
                                                    'sRole3': s_role3,
                                                    'mR1': mean_role,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(230, 184, 183)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            } else {
                                                let position_number = main_data[j].lineup.data[k].formation_position
                                                awayTeam1.push({
                                                    'order_key': 0,
                                                    'playerId': main_data[j].lineup.data[k].player_id,
                                                    'formation_position': position_number,
                                                    'teamId': visitTeamId,
                                                    'sRole': '...',
                                                    'mR': position,
                                                    'sRole1': '...',
                                                    'sRole2': '',
                                                    'mR1': position,
                                                    'Pname': main_data[j].lineup.data[k].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': position,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': 'rgb(230, 184, 183)',
                                                    'sub_minute': '',
                                                    'rule_color': rule_color,
                                                    'Tit': Tit,
                                                    'rating': rate
                                                })
                                            }
                                        }
                                    }

                                    let local_sub_array = []
                                    let visitor_sub_array = []
                                    let localTeam_substitution_index = 0
                                    let visitorTeam_substitution_index = 0
                                    if (main_data[j].events1 != null) {
                                        for (let k = 0; k < main_data[j].events1.data.length; k++) {
                                            let eventsNode = main_data[j].events1.data[k]
                                            if (eventsNode.type === 'substitution') {
                                                if (eventsNode.team_id == localTeamId) {
                                                    localTeam_substitution_index++
                                                    local_sub_array[localTeam_substitution_index - 1] = {
                                                        'minute': eventsNode.minute,
                                                        'player_id': eventsNode.player_id,
                                                        'player_name': eventsNode.player_name,
                                                        'related_player_id': eventsNode.related_player_id,
                                                        'related_player_name': eventsNode.related_player_name
                                                    }
                                                } else {
                                                    visitorTeam_substitution_index++
                                                    visitor_sub_array[visitorTeam_substitution_index - 1] = {
                                                        'minute': eventsNode.minute,
                                                        'player_id': eventsNode.player_id,
                                                        'player_name': eventsNode.player_name,
                                                        'related_player_id': eventsNode.related_player_id,
                                                        'related_player_name': eventsNode.related_player_name
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    let home_order_index = 0
                                    let home_substitutions = []
                                    for (let kk = 0; kk < local_sub_array.length; kk++) {
                                        for (let k = 0; k < homeTeam.length; k++) {
                                            if (homeTeam[k].playerId === local_sub_array[kk].related_player_id) {
                                                home_order_index++
                                                homeTeam[k].sub_order_color = this.sub_color_set[home_order_index - 1].color
                                                homeTeam[k].sub_minute = local_sub_array[kk].minute
                                                let local_players_markets = main_data[j].local_players[0].market_values
                                                let local_players_roles = main_data[j].local_players[0].roles
                                                let local_players_titularity = main_data[j].local_players[0].titularity

                                                let market_value = '...'
                                                let player_name = '...'
                                                let player_birthday = '...'
                                                let main_role = '...'
                                                let alt_role1 = '...'
                                                let alt_role2 = '...'

                                                let players = local_players_titularity.filter(function (item) {
                                                    return item.player_id === local_sub_array[kk].player_id
                                                });

                                                if (players.length > 0) {
                                                    if (players[0].player) {
                                                        player_birthday = players[0].player.data.birthdate
                                                    }
                                                }

                                                let market_values = local_players_markets.filter(function (item) {
                                                    return item.player_birthday === player_birthday;
                                                });
                                                if (market_values.length > 0) {
                                                    market_value = market_values[0].player_marketvalue
                                                    player_name = market_values[0].player_name
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < local_players_markets.length; n++) {
                                                        let compare1 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 4, local_players_markets[n].player_name.length - 3)
                                                        let compare2 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 3, local_players_markets[n].player_name.length - 2)
                                                        let compare3 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 2, local_players_markets[n].player_name.length - 1)
                                                        let compare4 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 1, local_players_markets[n].player_name.length)
                                                        let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            market_value = local_players_markets[n].player_marketvalue
                                                        }
                                                    }
                                                }

                                                let roles = local_players_roles.filter(function (item) {
                                                    return item.player_name.trim() === player_name.trim();
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < local_players_roles.length; n++) {
                                                        let compare1 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 4, local_players_roles[n].player_name.length - 3)
                                                        let compare2 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 3, local_players_roles[n].player_name.length - 2)
                                                        let compare3 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 2, local_players_roles[n].player_name.length - 1)
                                                        let compare4 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 1, local_players_roles[n].player_name.length)
                                                        let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            main_role = local_players_roles[n].player_main_role
                                                            alt_role1 = local_players_roles[n].player_alt_role1
                                                            alt_role2 = local_players_roles[n].player_alt_role2
                                                        }
                                                    }
                                                }

                                                let rule_color = 'rgb(216,228,188)'
                                                let mean_role = homeTeam[k].mR
                                                let position = homeTeam[k].p_m_Role
                                                let s_role = homeTeam[k].sRole
                                                let s_role2 = homeTeam[k].sRole2

                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }

                                                let Tit = (0).toFixed(2)
                                                let titularity = main_data[j].local_players[0].titularity.filter(function (item) {
                                                    return item.player_id === local_sub_array[kk].player_id;
                                                })

                                                let home_team_played = 0
                                                home_team_played = main_data[j].home_events_number
                                                let minute = 0
                                                if (titularity[0]) {
                                                    minute = titularity[0].minutes
                                                }
                                                if (home_team_played > 0) {
                                                    Tit = (minute / 90 / home_team_played * 100).toFixed(2) + ', ' + home_team_played
                                                }
                                                home_substitutions.push({
                                                    'playerId': local_sub_array[kk].player_id,
                                                    'teamId': homeTeam[k].teamId,
                                                    'sRole': homeTeam[k].sRole,
                                                    'sRole2': homeTeam[k].sRole2,
                                                    'mR': homeTeam[k].mR,
                                                    'Pname': local_sub_array[kk].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': homeTeam[k].p_m_Role,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': homeTeam[k].sub_order_color,
                                                    'sub_minute': homeTeam[k].sub_minute,
                                                    'rule_color': rule_color,
                                                    'Tit': Tit
                                                })
                                            }
                                        }
                                    }
                                    home_order_index = 0
                                    for (let kk = 0; kk < local_sub_array.length; kk++) {
                                        for (let k = 0; k < homeTeam1.length; k++) {
                                            if (homeTeam1[k].playerId === local_sub_array[kk].related_player_id) {
                                                home_order_index++
                                                homeTeam1[k].sub_order_color = this.sub_color_set[home_order_index - 1].color
                                                homeTeam1[k].sub_minute = local_sub_array[kk].minute
                                                let local_players_markets = main_data[j].local_players[0].market_values
                                                let local_players_roles = main_data[j].local_players[0].roles
                                                let local_players_titularity = main_data[j].local_players[0].titularity

                                                let market_value = '...'
                                                let player_name = '...'
                                                let player_birthday = '...'
                                                let main_role = '...'
                                                let alt_role1 = '...'
                                                let alt_role2 = '...'

                                                let players = local_players_titularity.filter(function (item) {
                                                    return item.player_id === local_sub_array[kk].player_id
                                                });

                                                if (players.length > 0) {
                                                    if (players[0].player) {
                                                        player_birthday = players[0].player.data.birthdate
                                                    }
                                                }

                                                let market_values = local_players_markets.filter(function (item) {
                                                    return item.player_birthday === player_birthday;
                                                });
                                                if (market_values.length > 0) {
                                                    market_value = market_values[0].player_marketvalue
                                                    player_name = market_values[0].player_name
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < local_players_markets.length; n++) {
                                                        let compare1 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 4, local_players_markets[n].player_name.length - 3)
                                                        let compare2 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 3, local_players_markets[n].player_name.length - 2)
                                                        let compare3 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 2, local_players_markets[n].player_name.length - 1)
                                                        let compare4 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 1, local_players_markets[n].player_name.length)
                                                        let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            market_value = local_players_markets[n].player_marketvalue
                                                        }
                                                    }
                                                }

                                                let roles = local_players_roles.filter(function (item) {
                                                    return item.player_name.trim() === player_name.trim();
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < local_players_roles.length; n++) {
                                                        let compare1 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 4, local_players_roles[n].player_name.length - 3)
                                                        let compare2 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 3, local_players_roles[n].player_name.length - 2)
                                                        let compare3 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 2, local_players_roles[n].player_name.length - 1)
                                                        let compare4 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 1, local_players_roles[n].player_name.length)
                                                        let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            main_role = local_players_roles[n].player_main_role
                                                            alt_role1 = local_players_roles[n].player_alt_role1
                                                            alt_role2 = local_players_roles[n].player_alt_role2
                                                        }
                                                    }
                                                }

                                                let Tit = (0).toFixed(2)
                                                let rate = '...'
                                                let titularity = main_data[j].local_players[0].titularity.filter(function (item) {
                                                    return item.player_id === local_sub_array[kk].player_id;
                                                })

                                                let home_team_played = 0
                                                home_team_played = main_data[j].home_events_number
                                                let minute = 0
                                                if (titularity[0]) {
                                                    minute = titularity[0].minutes
                                                    if (titularity[0].rating) {
                                                        rate = titularity[0].rating
                                                    }
                                                }
                                                if (home_team_played > 0) {
                                                    Tit = (minute / 90 / home_team_played * 100).toFixed(2) + ', ' + home_team_played
                                                }
                                                homeTeam1[k].playerId = local_sub_array[kk].player_id
                                                homeTeam1[k].Pname = local_sub_array[kk].player_name
                                                homeTeam1[k].marketValue = market_value
                                                homeTeam1[k].primaryRole = main_role
                                                homeTeam1[k].altRole1 = alt_role1
                                                homeTeam1[k].altRole2 = alt_role2
                                                homeTeam1[k].Tit = Tit
                                                homeTeam1[k].rating = rate

                                                if (main_role == 'GK') {
                                                    homeTeam1[k].p_m_Role = 'GK'
                                                } else if (main_role == 'RB') {
                                                    homeTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'CB') {
                                                    homeTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'LB') {
                                                    homeTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'RM') {
                                                    homeTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'CM') {
                                                    homeTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'LM') {
                                                    homeTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'DM') {
                                                    homeTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'AM') {
                                                    homeTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'RW') {
                                                    homeTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'LW') {
                                                    homeTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'SS') {
                                                    homeTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'CF') {
                                                    homeTeam1[k].p_m_Role = 'FWD'
                                                }

                                                let rule_color = 'rgb(216,228,188)'
                                                let mean_role = homeTeam1[k].mR
                                                let position = homeTeam1[k].p_m_Role
                                                let s_role = homeTeam1[k].sRole
                                                let s_role2 = homeTeam1[k].sRole2
                                                let s_role3 = homeTeam1[k].sRole3

                                                if (s_role2 === '') {
                                                    s_role2 = '...'
                                                }
                                                if (s_role3 === '') {
                                                    s_role3 === '...'
                                                }
                                                if (alt_role1 === '') {
                                                    alt_role1 = '...'
                                                }
                                                if (alt_role2 === '') {
                                                    alt_role2 = '...'
                                                }
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && s_role2 != '...' && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 != '' && s_role3 != '...') && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }
                                                homeTeam1[k].rule_color = rule_color
                                                // if(localTeamId === 329){
                                                //     //console.log('local_sub_array====>', local_sub_array[kk].player_name, mean_role,', ', position, ', ', s_role, ', ' ,main_role, ', ', alt_role1, ', ', alt_role2, ', ', s_role2, ', ', s_role3)
                                                // }
                                                // home_substitutions.push({'playerId': local_sub_array[kk].player_id, 'teamId':homeTeam[k].teamId ,'sRole': homeTeam[k].sRole, 'sRole2': homeTeam[k].sRole2, 'mR': homeTeam[k].mR, 'Pname': local_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': homeTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': homeTeam[k].sub_order_color, 'sub_minute': homeTeam[k].sub_minute, 'rule_color': rule_color, 'Tit': Tit})
                                            }
                                        }
                                    }

                                    let away_order_index = 0
                                    let away_substitutions = []
                                    for (let kk = 0; kk < visitor_sub_array.length; kk++) {
                                        for (let k = 0; k < awayTeam.length; k++) {
                                            if (awayTeam[k].playerId === visitor_sub_array[kk].related_player_id) {
                                                away_order_index++
                                                awayTeam[k].sub_order_color = this.sub_color_set[away_order_index - 1].color
                                                awayTeam[k].sub_minute = visitor_sub_array[kk].minute

                                                let visitor_players_markets = []
                                                let visitor_players_roles = []
                                                let visitor_players_titularity = []
                                                if (main_data[j].visitor_players.length > 0) {
                                                    visitor_players_markets = main_data[j].visitor_players[0].market_values
                                                    visitor_players_roles = main_data[j].visitor_players[0].roles
                                                    visitor_players_titularity = main_data[j].visitor_players[0].titularity
                                                }
                                                let market_value = '...'
                                                let player_name = '...'
                                                let player_birthday = '...'
                                                let main_role = '...'
                                                let alt_role1 = '...'
                                                let alt_role2 = '...'

                                                let players = visitor_players_titularity.filter(function (item) {
                                                    return item.player_id === visitor_sub_array[kk].player_id
                                                });

                                                if (players.length > 0) {
                                                    if (players[0].player) {
                                                        player_birthday = players[0].player.data.birthdate
                                                    }
                                                }

                                                let market_values = visitor_players_markets.filter(function (item) {
                                                    return item.player_birthday === player_birthday;
                                                });
                                                if (market_values.length > 0) {
                                                    market_value = market_values[0].player_marketvalue
                                                    player_name = market_values[0].player_name
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < visitor_players_markets.length; n++) {
                                                        let compare1 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 4, visitor_players_markets[n].player_name.length - 3)
                                                        let compare2 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 3, visitor_players_markets[n].player_name.length - 2)
                                                        let compare3 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 2, visitor_players_markets[n].player_name.length - 1)
                                                        let compare4 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 1, visitor_players_markets[n].player_name.length)
                                                        let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            market_value = visitor_players_markets[n].player_marketvalue
                                                        }
                                                    }
                                                }

                                                let roles = visitor_players_roles.filter(function (item) {
                                                    return item.player_name.trim() === player_name.trim();
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < visitor_players_roles.length; n++) {
                                                        let compare1 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 4, visitor_players_roles[n].player_name.length - 3)
                                                        let compare2 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 3, visitor_players_roles[n].player_name.length - 2)
                                                        let compare3 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 2, visitor_players_roles[n].player_name.length - 1)
                                                        let compare4 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 1, visitor_players_roles[n].player_name.length)
                                                        let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            main_role = visitor_players_roles[n].player_main_role
                                                            alt_role1 = visitor_players_roles[n].player_alt_role1
                                                            alt_role2 = visitor_players_roles[n].player_alt_role2
                                                        }
                                                    }
                                                }

                                                if (visitor_sub_array[kk].player_id === 323) {
                                                    //console.log('***********', player_name, player_birthday, main_role)
                                                }

                                                let rule_color = 'rgb(230,184,183)'
                                                let mean_role = awayTeam[k].mR
                                                let position = awayTeam[k].p_m_Role
                                                let s_role = awayTeam[k].sRole
                                                let s_role2 = awayTeam[k].sRole2
                                                let s_role3 = awayTeam[k].sRole3
                                                if (s_role2 === '') {
                                                    s_role2 = '...'
                                                }

                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }

                                                let Tit = (0).toFixed(2)
                                                let titularity = []
                                                if (main_data[j].visitor_players.length > 0) {
                                                    titularity = main_data[j].visitor_players[0].titularity.filter(function (item) {
                                                        return item.player_id === visitor_sub_array[kk].player_id;
                                                    })
                                                }

                                                let away_team_played = 0
                                                away_team_played = main_data[j].away_events_number
                                                let minute = 0
                                                if (titularity[0]) {
                                                    minute = titularity[0].minutes
                                                }
                                                if (away_team_played > 0) {
                                                    Tit = (minute / 90 / away_team_played * 100).toFixed(2) + ', ' + away_team_played
                                                }
                                                //-----------------
                                                away_substitutions.push({
                                                    'playerId': visitor_sub_array[kk].player_id,
                                                    'teamId': awayTeam[k].teamId,
                                                    'sRole': awayTeam[k].sRole,
                                                    'sRole2': awayTeam[k].sRole2,
                                                    'mR': awayTeam[k].mR,
                                                    'Pname': visitor_sub_array[kk].player_name,
                                                    'marketValue': market_value,
                                                    'p_m_Role': awayTeam[k].p_m_Role,
                                                    'primaryRole': main_role,
                                                    'altRole1': alt_role1,
                                                    'altRole2': alt_role2,
                                                    'tit': '###',
                                                    'sub_order_color': awayTeam[k].sub_order_color,
                                                    'sub_minute': awayTeam[k].sub_minute,
                                                    'rule_color': rule_color,
                                                    'Tit': Tit
                                                })
                                            }
                                        }
                                    }
                                    away_order_index = 0
                                    for (let kk = 0; kk < visitor_sub_array.length; kk++) {
                                        for (let k = 0; k < awayTeam1.length; k++) {
                                            if (awayTeam1[k].playerId === visitor_sub_array[kk].related_player_id) {
                                                away_order_index++
                                                awayTeam1[k].sub_order_color = this.sub_color_set[away_order_index - 1].color
                                                awayTeam1[k].sub_minute = visitor_sub_array[kk].minute

                                                let visitor_players_markets = []
                                                let visitor_players_roles = []
                                                let visitor_players_titularity = []
                                                if (main_data[j].visitor_players.length > 0) {
                                                    visitor_players_markets = main_data[j].visitor_players[0].market_values
                                                    visitor_players_roles = main_data[j].visitor_players[0].roles
                                                    visitor_players_titularity = main_data[j].visitor_players[0].titularity
                                                }

                                                let market_value = '...'
                                                let player_name = '...'
                                                let player_birthday = '...'
                                                let main_role = '...'
                                                let alt_role1 = '...'
                                                let alt_role2 = '...'

                                                let players = visitor_players_titularity.filter(function (item) {
                                                    return item.player_id === visitor_sub_array[kk].player_id
                                                });

                                                if (players.length > 0) {
                                                    if (players[0].player) {
                                                        player_birthday = players[0].player.data.birthdate
                                                    }
                                                }

                                                let market_values = visitor_players_markets.filter(function (item) {
                                                    return item.player_birthday === player_birthday;
                                                });

                                                if (market_values.length > 0) {
                                                    market_value = market_values[0].player_marketvalue
                                                    player_name = market_values[0].player_name
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < visitor_players_markets.length; n++) {
                                                        let compare1 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 4, visitor_players_markets[n].player_name.length - 3)
                                                        let compare2 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 3, visitor_players_markets[n].player_name.length - 2)
                                                        let compare3 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 2, visitor_players_markets[n].player_name.length - 1)
                                                        let compare4 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 1, visitor_players_markets[n].player_name.length)
                                                        let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            market_value = visitor_players_markets[n].player_marketvalue
                                                        }
                                                    }
                                                }

                                                let roles = visitor_players_roles.filter(function (item) {
                                                    return item.player_name.trim() === player_name.trim();
                                                });
                                                if (roles.length > 0) {
                                                    main_role = roles[0].player_main_role
                                                    alt_role1 = roles[0].player_alt_role1
                                                    alt_role2 = roles[0].player_alt_role2
                                                } else {
                                                    let compare_index = 0
                                                    for (let n = 0; n < visitor_players_roles.length; n++) {
                                                        let compare1 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 4, visitor_players_roles[n].player_name.length - 3)
                                                        let compare2 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 3, visitor_players_roles[n].player_name.length - 2)
                                                        let compare3 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 2, visitor_players_roles[n].player_name.length - 1)
                                                        let compare4 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 1, visitor_players_roles[n].player_name.length)
                                                        let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                        let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                        let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                        let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                        if (compare1 === local_compare1) {
                                                            compare_index++
                                                        } else if (compare2 === local_compare2) {
                                                            compare_index++
                                                        } else if (compare3 === local_compare3) {
                                                            compare_index++
                                                        } else if (compare4 === local_compare4) {
                                                            compare_index++
                                                        }
                                                        if (compare_index >= 3) {
                                                            main_role = visitor_players_roles[n].player_main_role
                                                            alt_role1 = visitor_players_roles[n].player_alt_role1
                                                            alt_role2 = visitor_players_roles[n].player_alt_role2
                                                        }
                                                    }
                                                }

                                                let Tit = (0).toFixed(2)
                                                let rate = '...'
                                                let titularity = []
                                                if (main_data[j].visitor_players.length > 0) {
                                                    titularity = main_data[j].visitor_players[0].titularity.filter(function (item) {
                                                        return item.player_id === visitor_sub_array[kk].player_id;
                                                    })
                                                }

                                                let away_team_played = 0
                                                away_team_played = main_data[j].away_events_number
                                                let minute = 0
                                                if (titularity[0]) {
                                                    minute = titularity[0].minutes
                                                    if (titularity[0].rating) {
                                                        rate = titularity[0].rating
                                                    }
                                                }
                                                if (away_team_played > 0) {
                                                    Tit = (minute / 90 / away_team_played * 100).toFixed(2) + ', ' + away_team_played
                                                }
                                                //-----------------------
                                                awayTeam1[k].playerId = visitor_sub_array[kk].player_id
                                                awayTeam1[k].Pname = visitor_sub_array[kk].player_name
                                                awayTeam1[k].marketValue = market_value
                                                awayTeam1[k].primaryRole = main_role
                                                awayTeam1[k].altRole1 = alt_role1
                                                awayTeam1[k].altRole2 = alt_role2
                                                awayTeam1[k].Tit = Tit
                                                awayTeam1[k].rating = rate
                                                if (main_role == 'GK') {
                                                    awayTeam1[k].p_m_Role = 'GK'
                                                } else if (main_role == 'RB') {
                                                    awayTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'CB') {
                                                    awayTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'LB') {
                                                    awayTeam1[k].p_m_Role = 'DEF'
                                                } else if (main_role == 'RM') {
                                                    awayTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'CM') {
                                                    awayTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'LM') {
                                                    awayTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'DM') {
                                                    awayTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'AM') {
                                                    awayTeam1[k].p_m_Role = 'MID'
                                                } else if (main_role == 'RW') {
                                                    awayTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'LW') {
                                                    awayTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'SS') {
                                                    awayTeam1[k].p_m_Role = 'FWD'
                                                } else if (main_role == 'CF') {
                                                    awayTeam1[k].p_m_Role = 'FWD'
                                                }

                                                let rule_color = 'rgb(230,184,183)'
                                                let mean_role = awayTeam1[k].mR
                                                let position = awayTeam1[k].p_m_Role
                                                let s_role = awayTeam1[k].sRole
                                                let s_role2 = awayTeam1[k].sRole2
                                                let s_role3 = awayTeam1[k].sRole3
                                                if (s_role2 === '') {
                                                    s_role2 = '...'
                                                }
                                                if (s_role3 === '') {
                                                    s_role3 === '...'
                                                }
                                                if (alt_role1 === '') {
                                                    alt_role1 = '...'
                                                }
                                                if (alt_role2 === '') {
                                                    alt_role2 = '...'
                                                }
                                                if ((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))) {
                                                    rule_color = 'rgb(146,208,80)'
                                                } else if ((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))) {
                                                    rule_color = 'rgb(255,255,0)'
                                                } else if ((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))) {
                                                    rule_color = 'rgb(255,0,0)'
                                                }

                                                awayTeam1[k].rule_color = rule_color
                                                // away_substitutions.push({'playerId': visitor_sub_array[kk].player_id, 'teamId':awayTeam[k].teamId ,'sRole': awayTeam[k].sRole, 'sRole2': awayTeam[k].sRole2, 'mR': awayTeam[k].mR, 'Pname': visitor_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': awayTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': awayTeam[k].sub_order_color, 'sub_minute': awayTeam[k].sub_minute,'rule_color': rule_color, 'Tit': Tit})
                                            }
                                        }
                                    }
                                    let home_legend = []
                                    let away_legend = []
                                    for (let k = 0; k < home_substitutions.length; k++) {
                                        home_legend.push(this.sub_color_set[k])
                                    }
                                    for (let k = 0; k < away_substitutions.length; k++) {
                                        away_legend.push(this.sub_color_set[k])
                                    }

                                    homeTeam.sort(this.sortByProperty('formation_position'))
                                    awayTeam.sort(this.sortByProperty('formation_position'))
                                    homeTeam1.sort(this.sortByProperty('formation_position'))
                                    awayTeam1.sort(this.sortByProperty('formation_position'))

                                    //console.log("homeTeam1==>", homeTeam1)
                                    //console.log("awayTeam1==>", awayTeam1)
                                    let temp0 = JSON.stringify(main_data[j].local_players)
                                    let temp1 = JSON.parse(temp0)
                                    //----------------------------formation analysis---------------------------------------
                                    let home_formation_array = []
                                    let away_formation_array = []
                                    let home_formation_array1 = []
                                    let away_formation_array1 = []
                                    let home_b_formation_array = []
                                    let away_b_formation_array = []
                                    let home_b_formation_array1 = []
                                    let away_b_formation_array1 = []
                                    let home_formation = homeTeamLformation
                                    let away_formation = awayTeamLformation

                                    if (!home_formation) {
                                        home_formation = homeTeamPformation
                                    }
                                    if (!away_formation) {
                                        away_formation = awayTeamPformation
                                    }

                                    for (let b = 0; b < main_data[j].events.length; b++) {
                                        if (main_data[j].events[b].formations) {
                                            if (main_data[j].events[b].formations.length > 0) {
                                                let formation_item = main_data[j].events[b].formations
                                                for (let bb = 0; bb < formation_item.length; bb++) {
                                                    if (formation_item[bb].localteamId == localTeamId || formation_item[bb].visitorteamId == localTeamId) {
                                                        home_b_formation_array1.push({
                                                            'formation': formation_item[bb].local_formation,
                                                            'date': formation_item[bb].date
                                                        })
                                                    }
                                                    if (formation_item[bb].localteamId == visitTeamId || formation_item[bb].visitorteamId == visitTeamId) {
                                                        away_b_formation_array1.push({
                                                            'formation': formation_item[bb].visit_formation,
                                                            'date': formation_item[bb].date
                                                        })
                                                    }
                                                }
                                                for (let bb = 0; bb < formation_item.length; bb++) {
                                                    if (formation_item[bb].localteamId == localTeamId) {
                                                        home_formation_array1.push({
                                                            'formation': formation_item[bb].local_formation,
                                                            'date': formation_item[bb].date
                                                        })
                                                    }
                                                    if (formation_item[bb].visitorteamId == visitTeamId) {
                                                        away_formation_array1.push({
                                                            'formation': formation_item[bb].visit_formation,
                                                            'date': formation_item[bb].date
                                                        })
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    //console.log("home_b_formation_array1==>", home_b_formation_array1)
                                    home_b_formation_array1.sort(this.sortByProperty1('date'))
                                    away_b_formation_array1.sort(this.sortByProperty1('date'))
                                    home_formation_array1.sort(this.sortByProperty1('date'))
                                    away_formation_array1.sort(this.sortByProperty1('date'))
                                    for (let b = 0; b < home_b_formation_array1.length; b++) {
                                        home_b_formation_array.push(home_b_formation_array1[b].formation)
                                    }
                                    for (let b = 0; b < away_b_formation_array1.length; b++) {
                                        away_b_formation_array.push(away_b_formation_array1[b].formation)
                                    }
                                    for (let b = 0; b < home_formation_array1.length; b++) {
                                        home_formation_array.push(home_formation_array1[b].formation)
                                    }
                                    for (let b = 0; b < away_formation_array1.length; b++) {
                                        away_formation_array.push(away_formation_array1[b].formation)
                                    }
                                    let temp_h = JSON.stringify(home_formation_array)
                                    let fmt_home = JSON.parse(temp_h)
                                    let temp_a = JSON.stringify(away_formation_array)
                                    let fmt_away = JSON.parse(temp_a)

                                    let temp_b_h = JSON.stringify(home_b_formation_array)
                                    let fmt_b_home = JSON.parse(temp_b_h)
                                    let temp_b_a = JSON.stringify(away_b_formation_array)
                                    let fmt_b_away = JSON.parse(temp_b_a)

                                    let used_home = 0
                                    let used_away = 0
                                    let used_b_home = 0
                                    let used_b_away = 0

                                    let index1 = home_formation_array.indexOf(home_formation);
                                    if (index1 > -1) {
                                        home_formation_array.splice(index1, 1);
                                    }

                                    let index2 = away_formation_array.indexOf(away_formation);
                                    if (index2 > -1) {
                                        away_formation_array.splice(index2, 1);
                                    }

                                    let index3 = home_b_formation_array.indexOf(home_formation);
                                    if (index3 > -1) {
                                        home_b_formation_array.splice(index3, 1);
                                    }

                                    let index4 = away_b_formation_array.indexOf(away_formation);
                                    if (index4 > -1) {
                                        away_b_formation_array.splice(index4, 1);
                                    }

                                    for (let b = 0; b < home_formation_array.length; b++) {
                                        if (home_formation_array[b] == home_formation) {
                                            used_home++
                                        }
                                    }
                                    for (let b = 0; b < away_formation_array.length; b++) {
                                        if (away_formation_array[b] == away_formation) {
                                            used_away++
                                        }
                                    }

                                    for (let b = 0; b < home_b_formation_array.length; b++) {
                                        if (home_formation_array[b] == home_formation) {
                                            used_b_home++
                                        }
                                    }
                                    for (let b = 0; b < away_b_formation_array.length; b++) {
                                        if (away_formation_array[b] == away_formation) {
                                            used_b_away++
                                        }
                                    }

                                    fmt_home = Array.from(new Set(fmt_home))
                                    fmt_away = Array.from(new Set(fmt_away))
                                    let home_fmt_pct = []
                                    let away_fmt_pct = []
                                    fmt_b_home = Array.from(new Set(fmt_b_home))
                                    fmt_b_away = Array.from(new Set(fmt_b_away))
                                    let home_b_fmt_pct = []
                                    let away_b_fmt_pct = []
                                    for (let b = 0; b < fmt_home.length; b++) {
                                        let count = 0
                                        for (let bb = 0; bb < home_formation_array.length; bb++) {
                                            if (fmt_home[b] == home_formation_array[bb]) {
                                                count++
                                            }
                                        }
                                        home_fmt_pct.push({"label": fmt_home[b], "count": count})
                                    }
                                    for (let b = 0; b < fmt_away.length; b++) {
                                        let count = 0
                                        for (let bb = 0; bb < away_formation_array.length; bb++) {
                                            if (fmt_away[b] == away_formation_array[bb]) {
                                                count++
                                            }
                                        }
                                        away_fmt_pct.push({"label": fmt_away[b], "count": count})
                                    }

                                    for (let b = 0; b < fmt_b_home.length; b++) {
                                        let count = 0
                                        for (let bb = 0; bb < home_b_formation_array.length; bb++) {
                                            if (fmt_b_home[b] == home_b_formation_array[bb]) {
                                                count++
                                            }
                                        }
                                        home_b_fmt_pct.push({"label": fmt_b_home[b], "count": count})
                                    }
                                    for (let b = 0; b < fmt_b_away.length; b++) {
                                        let count = 0
                                        for (let bb = 0; bb < away_b_formation_array.length; bb++) {
                                            if (fmt_b_away[b] == away_b_formation_array[bb]) {
                                                count++
                                            }
                                        }
                                        away_b_fmt_pct.push({"label": fmt_b_away[b], "count": count})
                                    }
                                    home_fmt_pct.sort(this.sortByProperty1('count'))
                                    away_fmt_pct.sort(this.sortByProperty1('count'))
                                    home_b_fmt_pct.sort(this.sortByProperty1('count'))
                                    away_b_fmt_pct.sort(this.sortByProperty1('count'))
                                    let home_fmt_ans = {
                                        "used": used_home,
                                        "ans": home_fmt_pct,
                                        "counts": home_formation_array.length
                                    }
                                    let away_fmt_ans = {
                                        "used": used_away,
                                        "ans": away_fmt_pct,
                                        "counts": away_formation_array.length
                                    }
                                    let home_b_fmt_ans = {
                                        "used": used_b_home,
                                        "ans": home_b_fmt_pct,
                                        "counts": home_b_formation_array.length
                                    }
                                    let away_b_fmt_ans = {
                                        "used": used_b_away,
                                        "ans": away_b_fmt_pct,
                                        "counts": away_b_formation_array.length
                                    }

                                    this.item1.home_fmt_ans = home_fmt_ans
                                    this.item1.away_fmt_ans = away_fmt_ans
                                    this.item1.home_b_fmt_ans = home_b_fmt_ans
                                    this.item1.away_b_fmt_ans = away_b_fmt_ans
                                    //--------------------------------------------------------------------
                                    // events[k - 1] = {"home_lineup": home_formation, "away_lineup": away_formation, "home_fmt_ans": home_fmt_ans, "away_fmt_ans": away_fmt_ans, "home_b_fmt_ans": home_b_fmt_ans, "away_b_fmt_ans": away_b_fmt_ans, 'local_p1': local_p1, 'visit_p1': visit_p1, 'local_p2': local_p2, 'visit_p2': visit_p2, 'home_best': home_best_p1, 'away_best': away_best_p1, 'home_best1': home_best_p2, 'away_best1': away_best_p2, 'home_id': localTeamId, 'away_id': visitTeamId, 'home_players': home_players, 'away_players': away_players, 'home_player': home_player, 'away_player': away_player, 'eventName': main_data[j].time.starting_at.time.substring(0, 5) + ' ' + main_data[j].localTeamName + '(' + main_data[j].standing.localteam_position + ')' + ' v ' + main_data[j].visitorTeamName +  '(' + main_data[j].standing.visitorteam_position + ')', 'openDate':  main_data[j].time.starting_at.time, 'homeTeam': homeTeam, 'awayTeam': awayTeam, 'homeTeam3': homeTeam, 'awayTeam3': awayTeam,  'homeTeam1': homeTeam1, 'awayTeam1': awayTeam1, 'homeTeam2': homeTeam1, 'awayTeam2': awayTeam1, 'homeTeamName': homeTeamName, 'awayTeamName': awayTeamName, 'homeTeamformation': homeTeamFormation, 'awayTeamformation': awayTeamFormation, 'homeTeamPformation': homeTeamPformation, 'awayTeamPformation': awayTeamPformation,  'homeTeamLformation': homeTeamLformation, 'awayTeamLformation': awayTeamLformation, 'home_substitutions': home_substitutions, 'away_substitutions': away_substitutions, 'home_legend': home_legend, 'away_legend': away_legend, 'home_rule_set': home_rule_color_number, 'away_rule_set': away_rule_color_number}
                                }
                                let home_rule_color_number = {"green_color": 0, "yellow_color": 0, "red_color": 0}
                                for(let pp = 0 ; pp < homeTeam1.length ; pp++){
                                    if(homeTeam1[pp].rule_color === 'rgb(146,208,80)'){
                                        home_rule_color_number.green_color++
                                    }
                                    else if(homeTeam1[pp].rule_color === 'rgb(255,255,0)'){
                                        home_rule_color_number.yellow_color++
                                    }
                                    else if(homeTeam1[pp].rule_color === 'rgb(255,0,0)'){
                                        home_rule_color_number.red_color++
                                    }
                                }

                                let away_rule_color_number = {"green_color": 0, "yellow_color": 0, "red_color": 0}
                                for(let pp = 0 ; pp < awayTeam1.length ; pp++){
                                    if(awayTeam1[pp].rule_color === 'rgb(146,208,80)'){
                                        away_rule_color_number.green_color++
                                    }
                                    else if(awayTeam1[pp].rule_color === 'rgb(255,255,0)'){
                                        away_rule_color_number.yellow_color++
                                    }
                                    else if(awayTeam1[pp].rule_color === 'rgb(255,0,0)'){
                                        away_rule_color_number.red_color++
                                    }
                                }

                                let local_sub_array = []
                                let visitor_sub_array = []
                                let localTeam_substitution_index = 0
                                let visitorTeam_substitution_index = 0
                                if(main_data[j].events1 != null){
                                    for(let k = 0 ; k < main_data[j].events1.data.length ; k++){
                                        let eventsNode = main_data[j].events1.data[k]
                                        if(eventsNode.type === 'substitution'){
                                            if(eventsNode.team_id == localTeamId){
                                                localTeam_substitution_index++
                                                local_sub_array[localTeam_substitution_index - 1] = {'minute': eventsNode.minute, 'player_id': eventsNode.player_id, 'player_name':eventsNode.player_name, 'related_player_id': eventsNode.related_player_id, 'related_player_name': eventsNode.related_player_name}
                                            }
                                            else{
                                                visitorTeam_substitution_index++
                                                visitor_sub_array[visitorTeam_substitution_index - 1] = {'minute': eventsNode.minute, 'player_id': eventsNode.player_id, 'player_name':eventsNode.player_name, 'related_player_id': eventsNode.related_player_id, 'related_player_name': eventsNode.related_player_name}
                                            }
                                        }
                                    }
                                }

                                let home_order_index = 0
                                let home_substitutions = []
                                for(let kk = 0 ; kk < local_sub_array.length; kk++){
                                    for(let k = 0 ; k < homeTeam.length ; k++){
                                        if(homeTeam[k].playerId === local_sub_array[kk].related_player_id){
                                            home_order_index++
                                            homeTeam[k].sub_order_color = this.sub_color_set[home_order_index - 1].color
                                            homeTeam[k].sub_minute = local_sub_array[kk].minute
                                            let local_players_markets = main_data[j].local_players[0].market_values
                                            let local_players_roles = main_data[j].local_players[0].roles
                                            let local_players_titularity = main_data[j].local_players[0].titularity

                                            let market_value = '...'
                                            let player_name = '...'
                                            let player_birthday = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'

                                            let players = local_players_titularity.filter(function(item) {
                                                return item.player_id === local_sub_array[kk].player_id
                                            });

                                            if(players.length > 0){
                                                if(players[0].player){
                                                    player_birthday = players[0].player.data.birthdate
                                                }
                                            }

                                            let market_values = local_players_markets.filter(function(item) {
                                                return item.player_birthday === player_birthday;
                                            });
                                            if(market_values.length > 0){
                                                market_value = market_values[0].player_marketvalue
                                                player_name = market_values[0].player_name
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < local_players_markets.length ; n++){
                                                    let compare1 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 4, local_players_markets[n].player_name.length - 3)
                                                    let compare2 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 3, local_players_markets[n].player_name.length - 2)
                                                    let compare3 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 2, local_players_markets[n].player_name.length - 1)
                                                    let compare4 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 1, local_players_markets[n].player_name.length)
                                                    let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        market_value = local_players_markets[n].player_marketvalue
                                                    }
                                                }
                                            }

                                            let roles = local_players_roles.filter(function(item) {
                                                return item.player_name.trim() === player_name.trim();
                                            });
                                            if(roles.length > 0){
                                                main_role = roles[0].player_main_role
                                                alt_role1 = roles[0].player_alt_role1
                                                alt_role2 = roles[0].player_alt_role2
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < local_players_roles.length ; n++){
                                                    let compare1 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 4, local_players_roles[n].player_name.length - 3)
                                                    let compare2 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 3, local_players_roles[n].player_name.length - 2)
                                                    let compare3 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 2, local_players_roles[n].player_name.length - 1)
                                                    let compare4 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 1, local_players_roles[n].player_name.length)
                                                    let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        main_role = local_players_roles[n].player_main_role
                                                        alt_role1 = local_players_roles[n].player_alt_role1
                                                        alt_role2 = local_players_roles[n].player_alt_role2
                                                    }
                                                }
                                            }

                                            let rule_color = 'rgb(216,228,188)'
                                            let mean_role = homeTeam[k].mR
                                            let position = homeTeam[k].p_m_Role
                                            let s_role = homeTeam[k].sRole
                                            let s_role2 = homeTeam[k].sRole2

                                            if((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2))){
                                                rule_color = 'rgb(146,208,80)'
                                            }
                                            else if((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2))){
                                                rule_color = 'rgb(255,255,0)'
                                            }
                                            else if((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2))){
                                                rule_color = 'rgb(255,0,0)'
                                            }

                                            let Tit = (0).toFixed(2)
                                            let titularity = main_data[j].local_players[0].titularity.filter(function(item) {
                                                return item.player_id === local_sub_array[kk].player_id;
                                            })

                                            let home_team_played = 0
                                            home_team_played = main_data[j].home_events_number
                                            let minute = 0
                                            if(titularity[0]){
                                                minute = titularity[0].minutes
                                            }
                                            if(home_team_played > 0){
                                                Tit = (minute/90/home_team_played*100).toFixed(2) + ', ' + home_team_played
                                            }
                                            home_substitutions.push({'playerId': local_sub_array[kk].player_id, 'teamId':homeTeam[k].teamId ,'sRole': homeTeam[k].sRole, 'sRole2': homeTeam[k].sRole2, 'mR': homeTeam[k].mR, 'Pname': local_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': homeTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': homeTeam[k].sub_order_color, 'sub_minute': homeTeam[k].sub_minute, 'rule_color': rule_color, 'Tit': Tit})
                                        }
                                    }
                                }
                                home_order_index = 0
                                for(let kk = 0 ; kk < local_sub_array.length; kk++){
                                    for(let k = 0 ; k < homeTeam1.length ; k++){
                                        if(homeTeam1[k].playerId === local_sub_array[kk].related_player_id){
                                            home_order_index++
                                            homeTeam1[k].sub_order_color = this.sub_color_set[home_order_index - 1].color
                                            homeTeam1[k].sub_minute = local_sub_array[kk].minute
                                            let local_players_markets = main_data[j].local_players[0].market_values
                                            let local_players_roles = main_data[j].local_players[0].roles
                                            let local_players_titularity = main_data[j].local_players[0].titularity

                                            let market_value = '...'
                                            let player_name = '...'
                                            let player_birthday = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'

                                            let players = local_players_titularity.filter(function(item) {
                                                return item.player_id === local_sub_array[kk].player_id
                                            });

                                            if(players.length > 0){
                                                if(players[0].player){
                                                    player_birthday = players[0].player.data.birthdate
                                                }
                                            }

                                            let market_values = local_players_markets.filter(function(item) {
                                                return item.player_birthday === player_birthday;
                                            });
                                            if(market_values.length > 0){
                                                market_value = market_values[0].player_marketvalue
                                                player_name = market_values[0].player_name
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < local_players_markets.length ; n++){
                                                    let compare1 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 4, local_players_markets[n].player_name.length - 3)
                                                    let compare2 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 3, local_players_markets[n].player_name.length - 2)
                                                    let compare3 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 2, local_players_markets[n].player_name.length - 1)
                                                    let compare4 = local_players_markets[n].player_name.substring(local_players_markets[n].player_name.length - 1, local_players_markets[n].player_name.length)
                                                    let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        market_value = local_players_markets[n].player_marketvalue
                                                    }
                                                }
                                            }

                                            let roles = local_players_roles.filter(function(item) {
                                                return item.player_name.trim() === player_name.trim();
                                            });
                                            if(roles.length > 0){
                                                main_role = roles[0].player_main_role
                                                alt_role1 = roles[0].player_alt_role1
                                                alt_role2 = roles[0].player_alt_role2
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < local_players_roles.length ; n++){
                                                    let compare1 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 4, local_players_roles[n].player_name.length - 3)
                                                    let compare2 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 3, local_players_roles[n].player_name.length - 2)
                                                    let compare3 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 2, local_players_roles[n].player_name.length - 1)
                                                    let compare4 = local_players_roles[n].player_name.substring(local_players_roles[n].player_name.length - 1, local_players_roles[n].player_name.length)
                                                    let local_compare1 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 4, local_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 3, local_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 2, local_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = local_sub_array[kk].player_name.substring(local_sub_array[kk].player_name.length - 1, local_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        main_role = local_players_roles[n].player_main_role
                                                        alt_role1 = local_players_roles[n].player_alt_role1
                                                        alt_role2 = local_players_roles[n].player_alt_role2
                                                    }
                                                }
                                            }

                                            let Tit = (0).toFixed(2)
                                            let rate = '...'
                                            let titularity = main_data[j].local_players[0].titularity.filter(function(item) {
                                                return item.player_id === local_sub_array[kk].player_id;
                                            })

                                            let home_team_played = 0
                                            home_team_played = main_data[j].home_events_number
                                            let minute = 0
                                            if(titularity[0]){
                                                minute = titularity[0].minutes
                                                if(titularity[0].rating){
                                                    rate = titularity[0].rating
                                                }
                                            }
                                            if(home_team_played > 0){
                                                Tit = (minute/90/home_team_played*100).toFixed(2) + ', ' + home_team_played
                                            }
                                            homeTeam1[k].playerId = local_sub_array[kk].player_id
                                            homeTeam1[k].Pname = local_sub_array[kk].player_name
                                            homeTeam1[k].marketValue = market_value
                                            homeTeam1[k].primaryRole = main_role
                                            homeTeam1[k].altRole1 = alt_role1
                                            homeTeam1[k].altRole2 = alt_role2
                                            homeTeam1[k].Tit = Tit
                                            homeTeam1[k].rating = rate

                                            if(main_role == 'GK'){ homeTeam1[k].p_m_Role = 'GK' }
                                            else if(main_role == 'RB'){ homeTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'CB'){ homeTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'LB'){ homeTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'RM'){ homeTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'CM'){ homeTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'LM'){ homeTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'DM'){ homeTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'AM'){ homeTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'RW'){ homeTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'LW'){ homeTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'SS'){ homeTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'CF'){ homeTeam1[k].p_m_Role = 'FWD' }

                                            let rule_color = 'rgb(216,228,188)'
                                            let mean_role = homeTeam1[k].mR
                                            let position = homeTeam1[k].p_m_Role
                                            let s_role = homeTeam1[k].sRole
                                            let s_role2 = homeTeam1[k].sRole2
                                            let s_role3 = homeTeam1[k].sRole3

                                            if(s_role2 === ''){
                                                s_role2 = '...'
                                            }
                                            if(s_role3 === ''){
                                                s_role3 === '...'
                                            }
                                            if(alt_role1 === ''){
                                                alt_role1 = '...'
                                            }
                                            if(alt_role2 === ''){
                                                alt_role2 = '...'
                                            }
                                            if((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && s_role2 != '...' && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 != '' && s_role3 != '...') && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))){
                                                rule_color = 'rgb(146,208,80)'
                                            }
                                            else if((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))){
                                                rule_color = 'rgb(255,255,0)'
                                            }
                                            else if((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))){
                                                rule_color = 'rgb(255,0,0)'
                                            }
                                            homeTeam1[k].rule_color = rule_color
                                            // if(localTeamId === 329){
                                            //     //console.log('local_sub_array====>', local_sub_array[kk].player_name, mean_role,', ', position, ', ', s_role, ', ' ,main_role, ', ', alt_role1, ', ', alt_role2, ', ', s_role2, ', ', s_role3)
                                            // }
                                            // home_substitutions.push({'playerId': local_sub_array[kk].player_id, 'teamId':homeTeam[k].teamId ,'sRole': homeTeam[k].sRole, 'sRole2': homeTeam[k].sRole2, 'mR': homeTeam[k].mR, 'Pname': local_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': homeTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': homeTeam[k].sub_order_color, 'sub_minute': homeTeam[k].sub_minute, 'rule_color': rule_color, 'Tit': Tit})
                                        }
                                    }
                                }

                                let away_order_index = 0
                                let away_substitutions = []
                                for(let kk = 0 ; kk < visitor_sub_array.length; kk++){
                                    for(let k = 0 ; k < awayTeam.length ; k++){
                                        if(awayTeam[k].playerId === visitor_sub_array[kk].related_player_id){
                                            away_order_index++
                                            awayTeam[k].sub_order_color = this.sub_color_set[away_order_index - 1].color
                                            awayTeam[k].sub_minute = visitor_sub_array[kk].minute

                                            let visitor_players_markets = []
                                            let visitor_players_roles = []
                                            let visitor_players_titularity = []
                                            if(main_data[j].visitor_players.length > 0){
                                                visitor_players_markets = main_data[j].visitor_players[0].market_values
                                                visitor_players_roles = main_data[j].visitor_players[0].roles
                                                visitor_players_titularity = main_data[j].visitor_players[0].titularity
                                            }
                                            let market_value = '...'
                                            let player_name = '...'
                                            let player_birthday = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'

                                            let players = visitor_players_titularity.filter(function(item) {
                                                return item.player_id === visitor_sub_array[kk].player_id
                                            });

                                            if(players.length > 0){
                                                if(players[0].player){
                                                    player_birthday = players[0].player.data.birthdate
                                                }
                                            }

                                            let market_values = visitor_players_markets.filter(function(item) {
                                                return item.player_birthday === player_birthday;
                                            });
                                            if(market_values.length > 0){
                                                market_value = market_values[0].player_marketvalue
                                                player_name = market_values[0].player_name
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < visitor_players_markets.length ; n++){
                                                    let compare1 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 4, visitor_players_markets[n].player_name.length - 3)
                                                    let compare2 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 3, visitor_players_markets[n].player_name.length - 2)
                                                    let compare3 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 2, visitor_players_markets[n].player_name.length - 1)
                                                    let compare4 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 1, visitor_players_markets[n].player_name.length)
                                                    let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        market_value = visitor_players_markets[n].player_marketvalue
                                                    }
                                                }
                                            }

                                            let roles = visitor_players_roles.filter(function(item) {
                                                return item.player_name.trim() === player_name.trim();
                                            });
                                            if(roles.length > 0){
                                                main_role = roles[0].player_main_role
                                                alt_role1 = roles[0].player_alt_role1
                                                alt_role2 = roles[0].player_alt_role2
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < visitor_players_roles.length ; n++){
                                                    let compare1 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 4, visitor_players_roles[n].player_name.length - 3)
                                                    let compare2 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 3, visitor_players_roles[n].player_name.length - 2)
                                                    let compare3 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 2, visitor_players_roles[n].player_name.length - 1)
                                                    let compare4 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 1, visitor_players_roles[n].player_name.length)
                                                    let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        main_role = visitor_players_roles[n].player_main_role
                                                        alt_role1 = visitor_players_roles[n].player_alt_role1
                                                        alt_role2 = visitor_players_roles[n].player_alt_role2
                                                    }
                                                }
                                            }

                                            if(visitor_sub_array[kk].player_id === 323){
                                                //console.log('***********', player_name, player_birthday, main_role)
                                            }

                                            let rule_color = 'rgb(230,184,183)'
                                            let mean_role = awayTeam[k].mR
                                            let position = awayTeam[k].p_m_Role
                                            let s_role = awayTeam[k].sRole
                                            let s_role2 = awayTeam[k].sRole2
                                            let s_role3 = awayTeam[k].sRole3
                                            if(s_role2 === ''){
                                                s_role2 = '...'
                                            }

                                            if((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))){
                                                rule_color = 'rgb(146,208,80)'
                                            }
                                            else if((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))){
                                                rule_color = 'rgb(255,255,0)'
                                            }
                                            else if((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))){
                                                rule_color = 'rgb(255,0,0)'
                                            }

                                            let Tit = (0).toFixed(2)
                                            let titularity = []
                                            if(main_data[j].visitor_players.length > 0){
                                                titularity = main_data[j].visitor_players[0].titularity.filter(function(item) {
                                                    return item.player_id === visitor_sub_array[kk].player_id;
                                                })
                                            }

                                            let away_team_played = 0
                                            away_team_played = main_data[j].away_events_number
                                            let minute = 0
                                            if(titularity[0]){
                                                minute = titularity[0].minutes
                                            }
                                            if(away_team_played > 0){
                                                Tit = (minute/90/away_team_played*100).toFixed(2) + ', ' + away_team_played
                                            }
                                            //-----------------
                                            away_substitutions.push({'playerId': visitor_sub_array[kk].player_id, 'teamId':awayTeam[k].teamId ,'sRole': awayTeam[k].sRole, 'sRole2': awayTeam[k].sRole2, 'mR': awayTeam[k].mR, 'Pname': visitor_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': awayTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': awayTeam[k].sub_order_color, 'sub_minute': awayTeam[k].sub_minute,'rule_color': rule_color, 'Tit': Tit})
                                        }
                                    }
                                }
                                away_order_index = 0
                                for(let kk = 0 ; kk < visitor_sub_array.length; kk++){
                                    for(let k = 0 ; k < awayTeam1.length ; k++){
                                        if(awayTeam1[k].playerId === visitor_sub_array[kk].related_player_id){
                                            away_order_index++
                                            awayTeam1[k].sub_order_color = this.sub_color_set[away_order_index - 1].color
                                            awayTeam1[k].sub_minute = visitor_sub_array[kk].minute

                                            let visitor_players_markets = []
                                            let visitor_players_roles = []
                                            let visitor_players_titularity = []
                                            if(main_data[j].visitor_players.length > 0){
                                                visitor_players_markets = main_data[j].visitor_players[0].market_values
                                                visitor_players_roles = main_data[j].visitor_players[0].roles
                                                visitor_players_titularity = main_data[j].visitor_players[0].titularity
                                            }

                                            let market_value = '...'
                                            let player_name = '...'
                                            let player_birthday = '...'
                                            let main_role = '...'
                                            let alt_role1 = '...'
                                            let alt_role2 = '...'

                                            let players = visitor_players_titularity.filter(function(item) {
                                                return item.player_id === visitor_sub_array[kk].player_id
                                            });

                                            if(players.length > 0){
                                                if(players[0].player){
                                                    player_birthday = players[0].player.data.birthdate
                                                }
                                            }

                                            let market_values = visitor_players_markets.filter(function(item) {
                                                return item.player_birthday === player_birthday;
                                            });

                                            if(market_values.length > 0){
                                                market_value = market_values[0].player_marketvalue
                                                player_name = market_values[0].player_name
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < visitor_players_markets.length ; n++){
                                                    let compare1 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 4, visitor_players_markets[n].player_name.length - 3)
                                                    let compare2 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 3, visitor_players_markets[n].player_name.length - 2)
                                                    let compare3 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 2, visitor_players_markets[n].player_name.length - 1)
                                                    let compare4 = visitor_players_markets[n].player_name.substring(visitor_players_markets[n].player_name.length - 1, visitor_players_markets[n].player_name.length)
                                                    let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        market_value = visitor_players_markets[n].player_marketvalue
                                                    }
                                                }
                                            }

                                            let roles = visitor_players_roles.filter(function(item) {
                                                return item.player_name.trim() === player_name.trim();
                                            });
                                            if(roles.length > 0){
                                                main_role = roles[0].player_main_role
                                                alt_role1 = roles[0].player_alt_role1
                                                alt_role2 = roles[0].player_alt_role2
                                            }
                                            else{
                                                let compare_index = 0
                                                for(let n = 0 ; n < visitor_players_roles.length ; n++){
                                                    let compare1 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 4, visitor_players_roles[n].player_name.length - 3)
                                                    let compare2 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 3, visitor_players_roles[n].player_name.length - 2)
                                                    let compare3 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 2, visitor_players_roles[n].player_name.length - 1)
                                                    let compare4 = visitor_players_roles[n].player_name.substring(visitor_players_roles[n].player_name.length - 1, visitor_players_roles[n].player_name.length)
                                                    let local_compare1 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 4, visitor_sub_array[kk].player_name.length - 3)
                                                    let local_compare2 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 3, visitor_sub_array[kk].player_name.length - 2)
                                                    let local_compare3 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 2, visitor_sub_array[kk].player_name.length - 1)
                                                    let local_compare4 = visitor_sub_array[kk].player_name.substring(visitor_sub_array[kk].player_name.length - 1, visitor_sub_array[kk].player_name.length)
                                                    if(compare1 === local_compare1){
                                                        compare_index++
                                                    }
                                                    else if(compare2 === local_compare2){
                                                        compare_index++
                                                    }
                                                    else if(compare3 === local_compare3){
                                                        compare_index++
                                                    }
                                                    else if(compare4 === local_compare4){
                                                        compare_index++
                                                    }
                                                    if(compare_index >= 3){
                                                        main_role = visitor_players_roles[n].player_main_role
                                                        alt_role1 = visitor_players_roles[n].player_alt_role1
                                                        alt_role2 = visitor_players_roles[n].player_alt_role2
                                                    }
                                                }
                                            }

                                            let Tit = (0).toFixed(2)
                                            let rate = '...'
                                            let titularity = []
                                            if(main_data[j].visitor_players.length > 0){
                                                titularity = main_data[j].visitor_players[0].titularity.filter(function(item) {
                                                    return item.player_id === visitor_sub_array[kk].player_id;
                                                })
                                            }

                                            let away_team_played = 0
                                            away_team_played = main_data[j].away_events_number
                                            let minute = 0
                                            if(titularity[0]){
                                                minute = titularity[0].minutes
                                                if(titularity[0].rating){
                                                    rate = titularity[0].rating
                                                }
                                            }
                                            if(away_team_played > 0){
                                                Tit = (minute/90/away_team_played*100).toFixed(2) + ', ' + away_team_played
                                            }
                                            //-----------------------
                                            awayTeam1[k].playerId = visitor_sub_array[kk].player_id
                                            awayTeam1[k].Pname = visitor_sub_array[kk].player_name
                                            awayTeam1[k].marketValue = market_value
                                            awayTeam1[k].primaryRole = main_role
                                            awayTeam1[k].altRole1 = alt_role1
                                            awayTeam1[k].altRole2 = alt_role2
                                            awayTeam1[k].Tit = Tit
                                            awayTeam1[k].rating = rate
                                            if(main_role == 'GK'){ awayTeam1[k].p_m_Role = 'GK' }
                                            else if(main_role == 'RB'){ awayTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'CB'){ awayTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'LB'){ awayTeam1[k].p_m_Role = 'DEF' }
                                            else if(main_role == 'RM'){ awayTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'CM'){ awayTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'LM'){ awayTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'DM'){ awayTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'AM'){ awayTeam1[k].p_m_Role = 'MID' }
                                            else if(main_role == 'RW'){ awayTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'LW'){ awayTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'SS'){ awayTeam1[k].p_m_Role = 'FWD' }
                                            else if(main_role == 'CF'){ awayTeam1[k].p_m_Role = 'FWD' }

                                            let rule_color = 'rgb(230,184,183)'
                                            let mean_role = awayTeam1[k].mR
                                            let position = awayTeam1[k].p_m_Role
                                            let s_role = awayTeam1[k].sRole
                                            let s_role2 = awayTeam1[k].sRole2
                                            let s_role3 = awayTeam1[k].sRole3
                                            if(s_role2 === ''){
                                                s_role2 = '...'
                                            }
                                            if(s_role3 === ''){
                                                s_role3 === '...'
                                            }
                                            if(alt_role1 === ''){
                                                alt_role1 = '...'
                                            }
                                            if(alt_role2 === ''){
                                                alt_role2 = '...'
                                            }
                                            if((mean_role === position && (s_role === alt_role1 || s_role === alt_role2 || main_role === s_role)) || (mean_role === position && (s_role2 === alt_role1 || s_role2 === alt_role2 || main_role === s_role2)) || (mean_role === position && (s_role3 === alt_role1 || s_role3 === alt_role2 || main_role === s_role3))){
                                                rule_color = 'rgb(146,208,80)'
                                            }
                                            else if((mean_role === position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role === s_role || s_role === alt_role1 || s_role === alt_role2)) || (mean_role === position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role === s_role2 || s_role2 === alt_role1 || s_role2 === alt_role2)) || (mean_role === position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2)) || (mean_role !== position && (main_role === s_role3 || s_role3 === alt_role1 || s_role3 === alt_role2))){
                                                rule_color = 'rgb(255,255,0)'
                                            }
                                            else if((mean_role !== position && (main_role !== s_role && s_role !== alt_role1 && s_role !== alt_role2)) || (mean_role !== position && (main_role !== s_role2 && s_role2 !== alt_role1 && s_role2 !== alt_role2)) || (mean_role !== position && (main_role !== s_role3 && s_role3 !== alt_role1 && s_role3 !== alt_role2))){
                                                rule_color = 'rgb(255,0,0)'
                                            }

                                            awayTeam1[k].rule_color = rule_color
                                            // away_substitutions.push({'playerId': visitor_sub_array[kk].player_id, 'teamId':awayTeam[k].teamId ,'sRole': awayTeam[k].sRole, 'sRole2': awayTeam[k].sRole2, 'mR': awayTeam[k].mR, 'Pname': visitor_sub_array[kk].player_name, 'marketValue': market_value, 'p_m_Role': awayTeam[k].p_m_Role, 'primaryRole': main_role, 'altRole1': alt_role1, 'altRole2': alt_role2, 'tit': '###', 'sub_order_color': awayTeam[k].sub_order_color, 'sub_minute': awayTeam[k].sub_minute,'rule_color': rule_color, 'Tit': Tit})
                                        }
                                    }
                                }
                                let home_legend = []
                                let away_legend = []
                                for(let k = 0 ; k < home_substitutions.length ; k++){
                                    home_legend.push(this.sub_color_set[k])
                                }
                                for(let k = 0 ; k < away_substitutions.length ; k++){
                                    away_legend.push(this.sub_color_set[k])
                                }
                                this.item1.homeTeamFormation = homeTeamFormation
                                this.item1.awayTeamFormation = awayTeamFormation
                                this.item1.home_legend = home_legend
                                this.item1.away_legend = away_legend
                                this.item1.home_rule_set = home_rule_color_number
                                this.item1.away_rule_set = away_rule_color_number
                                this.item1.homeTeam = homeTeam1
                                this.item1.awayTeam = awayTeam1
                                this.item1.homeTeam2 = homeTeam1
                                this.item1.awayTeam2 = awayTeam1
                                this.item1.homeTeamName = homeTeamName
                                this.item1.awayTeamName = awayTeamName
                            }
                        }
                        this.cold_data_get()
                    })
                }
            },
            init_var1(){
                this.isload = false
                this.counter = 50
                this.current_counter = 0
                this.historicModalData = {
                    "eventName": "",
                        "home_season": {
                        'on': 0,
                            'off': 0,
                            'block': 0,
                            'in': 0,
                            'out': 0,
                            'cnr': 0,
                            'da': 0,
                            'pos': 0,
                            'pas': 0,
                            'acc': 0,
                            'atk': 0,
                            'ofs': 0,
                            'sav': 0,
                            'sbst': 0,
                            'fou': 0 ,
                            'g_att': 0 ,
                            'safe': 0,
                            'goals':0
                    },
                    "away_season": {
                        'on': 0,
                            'off': 0,
                            'block': 0,
                            'in': 0,
                            'out': 0,
                            'cnr': 0,
                            'da': 0,
                            'pos': 0,
                            'pas': 0,
                            'acc': 0,
                            'atk': 0,
                            'ofs': 0,
                            'sav': 0,
                            'sbst': 0,
                            'fou': 0 ,
                            'g_att': 0 ,
                            'safe': 0,
                            'goals': 0
                    },
                    "home_p": 1,
                        "away_p": 1,
                        "home_rtg": 0,
                        "home_a_rtg": 0,
                        "away_rtg": 0,
                        "away_a_rtg": 0
                }
                this.data = [
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [10,15,13,17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        showarrow: false,
                        marker: {
                            color: 'rgba(244,66,66, 1)',
                            line: {
                                color: 'rgb(244,66,66)',
                                width: 1
                            }
                        }
                    },
                    {
                        x: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
                        y: [-10,-15,-13,-17,10,15,13,17,10,15,13,17],
                        type:"bar",
                        name: '-',
                        yaxis: 'y2',
                        showarrow: false,
                        marker: {
                            color: 'rgba(65,149,244,1)',
                            line: {
                                color: 'rgb(65,149,244)',
                                width: 1
                            }
                        }
                    },
                ]
                this.layout = {
                    title: "",
                        xaxis:{
                        "title": {
                            "text": 'Time',
                                "font": {
                                "size": 18,
                                    "color": '#263043',
                                    "weight": "bold"
                            }
                        },
                    },
                    yaxis: {
                        'showgrid': false,
                            'zeroline': false,
                            'visible': false
                    },
                    yaxis2: {
                        "title": {
                            "text": 'RTG',
                                "font": {
                                "size": 18,
                                    "color": '#263043',
                                    "weight": "bold"
                            }
                        },
                        "overlaying": 'y',
                            "matches": 'y',
                            "tickfont" : {
                            "color" : 'white'
                        },
                        // 'showgrid': true,
                        // 'zeroline': false,
                        // 'visible': false
                        // "autorange": 'reversed',
                    },
                    showlegend: true,
                        barmode: 'relative',
                        showarrow: false
                }
                this.lineup_home_id = 0
                this.lineup_away_id = 0
                this.coldstats_show = false
                this.home_id = 0
                this.away_id = 0
                this.show_collapse = false
                this.item1 = {
                'fixtureId': null,
                    'main_data': null,
                    'homeRank': null,
                    'awayRank': null,
                    'chart': {
                    'time': [],
                        'homeRTG': [],
                        'awayRTG': []
                },
                'home_p': 1,
                    'goal_tooltip': '',
                    'goalKey': null,
                    'away_p': 1,
                    'home': {
                    'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr':0,
                        'time': '',
                        'score': 0,
                        'flash': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                },
                'away': {
                    'id': 0,
                        'on': null,
                        'off': null,
                        'blk': null,
                        'in': null,
                        'out': null,
                        'cnr': null,
                        'da': null,
                        'goal': null,
                        'rtg': 0,
                        'gdr': 0,
                        'time': 0,
                        'score': 0,
                        'poss': null,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': null,
                        'red': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'last_on': 0,
                        'last_off': 0,
                        'last_cnr': 0,
                        'last_da': 0,
                        'last_goal': 0,
                        'a_rtg': 14
                },
                'homeT': {
                    'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'flash': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0,
                        'match_odd_1': '',
                        'match_odd_2': '',
                        'match_odd_3': '',
                        'over_25_odd': '',
                        'under_25_odd': '',
                },
                'awayT': {
                    'on': 0,
                        'off': 0,
                        'blk': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'poss': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'red': 0,
                        'yel': 0,
                        'fou': 0,
                        'g_att': 0,
                        'safe': 0,
                        'nxt': 0,
                        'rtg': 0
                },
                'com_url': '',
                    'it_url': '',
                    'home_season' : {
                    'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals':0
                },
                'away_season' : {
                    'on': 0,
                        'off': 0,
                        'block': 0,
                        'in': 0,
                        'out': 0,
                        'cnr': 0,
                        'da': 0,
                        'pos': 0,
                        'pas': 0,
                        'acc': 0,
                        'atk': 0,
                        'ofs': 0,
                        'sav': 0,
                        'sbst': 0,
                        'fou': 0 ,
                        'g_att': 0 ,
                        'safe': 0,
                        'goals': 0
                },
                'home_tooltip':{
                    'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                },
                'away_tooltip':{
                    'on': '',
                        'off': '',
                        'blk': '',
                        'in': '',
                        'out': '',
                        'cnr': ''
                },
                'season_id': null,
                    'league': '-',
                    'homeTeam': [],
                    'awayTeam': []
            }
                this.marketId = ''
                this.selectionId = 0
                this.lay = ''
                this.back = ''
                this.total_matched = 0
                this.back_matched = 0
                this.lay_matched = 0
                this.scoreOne = ''
                this.scoreTwo = ''
                this.status = ''
                this.timeRecord = ''
                this.key = ''
                this.key2 = ''
                this.oddUrl = ""
                this.oddUrl1 = ""
                this.eventName = ""
                this.prematchOdd = 0
                this.calc_odd = 0
                this.calc_stake = 0
                this.cs_odd = 0
                this.max_profit = 0
                this.max_lose = 0
                this.percent_text1=''
                this.percent_text2 =this.$t('Insert Odd and Stake')
                this.item3 = {
                    home : {
                        p:0,
                            name:'',
                            rank: '',
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondplus:0,
                            secondminus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1:'',
                            FH:0,
                            swing2:'',
                            SH:0,
                            swing3:'',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0

                    },
                    away : {
                        p:0,
                            name:'',
                            rank:'' ,
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondPlus:0,
                            secondMinus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1: '',
                            FH:0,
                            swing2: '',
                            SH:0,
                            swing3: '',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0
                    },
                    homeDateList: [],
                        awayDateList : [],
                        home_id: 0,
                        away_id: 0,
                        openDate: '',
                        eventName: '',
                        rank_option: [],
                        rank_set: {},
                    rankFilter : false,
                        b_data : [],
                        homeLineupList: [],
                        awayLineupList: [],
                }
                this.current_sort_field = ""
                this.correctScoreList = [
                    {"value": 100, "label": "Select One"}
                ]
                this.currentCSR = []
                this.CS_Odd_back_price = null
                this.CS_Odd_back_stack = null
                this. CS_Odd_lay_price = 1000000
                this.CS_Odd_lay_stack =  null
                this.CS_total_matched = null
                this.currentCS_marketId = null
                this.currentCS_selectionId = null
                this.stakeToCover = null
            },
            init_var2(){
            },
            create_UUID(){
                var dt = new Date().getTime();
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = (dt + Math.random()*16)%16 | 0;
                    dt = Math.floor(dt/16);
                    return (c=='x' ? r :(r&0x3|0x8)).toString(16);
                });
                return uuid
            },
            select_lineup1(value){
                let eventNode = this.item1
                if(this.selected_direction === 'home' && this.selected_team === eventNode.homeTeamName){
                    if(value !== '0'){
                        let temp2 =  JSON.stringify(eventNode.homeTeam2)
                        let temp3 =  JSON.stringify(eventNode.homeTeam2)
                        let homeTeam2 = JSON.parse(temp2)
                        let homeTeam3 = JSON.parse(temp3)
                        for(let k = 0 ; k < homeTeam2.length ; k++){
                            homeTeam2[k].order_key = 0
                            homeTeam3[k].order_key = 0
                        }

                        let s_roles = this.s_role_set.filter(function(item) {
                            return item.name === value;
                        });
                        if(s_roles.length > 0) {
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role || s_role22 === main_role) && (position === mean_role) && alt_role1 === '' && alt_role2 === '') {
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'blue'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }

                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role|| s_role22 === main_role) && (position === mean_role)){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role) && ((s_role === alt_role1 || s_role === alt_role2) || ((s_role12 === alt_role1 || s_role12 === alt_role2) && s_role12 != '') || ((s_role22 === alt_role1 || s_role22 === alt_role2) && s_role22 != ''))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role)){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }

                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role || s_role22 === main_role) && (alt_role1 === '' || alt_role2 === '')){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role) && (((alt_role1 === s_role || alt_role1 === s_role12 || alt_role1 === s_role22) && (alt_role1 != '')) || ((alt_role2 === s_role || alt_role2 === s_role12 || alt_role2 === s_role22) && (alt_role2 != '')))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if(position === mean_role){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if(((alt_role1 === s_role || alt_role1 === s_role12 || alt_role1 === s_role22) && (alt_role1 != '')) || ((alt_role2 === s_role || alt_role2 === s_role12 || alt_role2 === s_role22) && (alt_role2 != ''))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                if(homeTeam3[k].order_key === 0){
                                    let mean_role = homeTeam3[k].mR
                                    for(let kk = 0 ; kk < 11 ; kk++){
                                        if(homeTeam2[kk].order_key === 0){
                                            let mean_role1 = homeTeam2[kk].mR
                                            let s_role = homeTeam2[kk].sRole
                                            if(mean_role === 'DEF'){
                                                if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            else if(mean_role === 'MID'){
                                                if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            else if(mean_role === 'FWD'){
                                                if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            break
                                        }
                                    }
                                }
                            }
                        }
                        this.item1.homeTeam = homeTeam2
                    }
                    else{
                        for(let k = 0 ; k < eventNode.homeTeam2.length ; k++){
                            this.item1.homeTeam[k] = eventNode.homeTeam2[k]
                            // this.mainList[i].events[j].homeTeam1[k].sRole = eventNode.homeTeam2[k].sRole1
                            // this.mainList[i].events[j].homeTeam1[k].mR = eventNode.homeTeam2[k].mR1
                            // this.mainList[i].events[j].homeTeam1[k].rule_color = eventNode.homeTeam2[k].rule_color
                        }
                    }
                }
                else if(this.selected_direction === 'away' && this.selected_team === eventNode.awayTeamName){
                    if(value !== '0'){
                        let temp2 =  JSON.stringify(eventNode.awayTeam2)
                        let temp3 =  JSON.stringify(eventNode.awayTeam2)
                        let homeTeam2 = JSON.parse(temp2)
                        let homeTeam3 = JSON.parse(temp3)
                        //console.log('homeTeam2===>', homeTeam2, homeTeam3)
                        for(let k = 0 ; k < homeTeam2.length ; k++){
                            homeTeam2[k].order_key = 0
                            homeTeam3[k].order_key = 0
                        }

                        let s_roles = this.s_role_set.filter(function(item) {
                            return item.name === value;
                        });
                        if(s_roles.length > 0) {
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role || s_role22 === main_role) && (position === mean_role) && alt_role1 === '' && alt_role2 === '') {
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'blue'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }

                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role|| s_role22 === main_role) && (position === mean_role)){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role) && ((s_role === alt_role1 || s_role === alt_role2) || ((s_role12 === alt_role1 || s_role12 === alt_role2) && s_role12 != '') || ((s_role22 === alt_role1 || s_role22 === alt_role2) && s_role22 != ''))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role)){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'green'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }

                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((s_role === main_role || s_role12 === main_role || s_role22 === main_role) && (alt_role1 === '' || alt_role2 === '')){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if((position === mean_role) && (((alt_role1 === s_role || alt_role1 === s_role12 || alt_role1 === s_role22) && (alt_role1 != '')) || ((alt_role2 === s_role || alt_role2 === s_role12 || alt_role2 === s_role22) && (alt_role2 != '')))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if(position === mean_role){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                let s_role = s_roles[0].s_role[k]
                                let s_role12 = s_roles[0].alt_s_role[k]
                                let s_role22 = s_roles[0].alt_s_role1[k]
                                let mean_role = s_roles[0].mean_role[k]
                                homeTeam2[k].sRole = s_role
                                homeTeam2[k].sRole2 = s_role12
                                homeTeam2[k].mR = mean_role
                                for(let kk = 0 ; kk < homeTeam3.length ; kk++){
                                    if(homeTeam3[kk].order_key === 0 && homeTeam2[k].order_key === 0){
                                        let main_role = homeTeam3[kk].primaryRole
                                        let position = homeTeam3[kk].p_m_Role
                                        let alt_role1 = homeTeam3[kk].altRole1
                                        let alt_role2 = homeTeam3[kk].altRole2
                                        let s_role2 = homeTeam2[kk].sRole2

                                        if (alt_role1 === '...' || alt_role1 === '') {
                                            alt_role1 = ''
                                        }
                                        if (alt_role2 === '...' || alt_role2 === '') {
                                            alt_role2 = ''
                                        }
                                        if(((alt_role1 === s_role || alt_role1 === s_role12 || alt_role1 === s_role22) && (alt_role1 != '')) || ((alt_role2 === s_role || alt_role2 === s_role12 || alt_role2 === s_role22) && (alt_role2 != ''))){
                                            homeTeam2[k].Pname = homeTeam3[kk].Pname
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].marketValue = homeTeam3[kk].marketValue
                                            homeTeam2[k].playerId = homeTeam3[kk].playerId
                                            homeTeam2[k].formation_position = homeTeam3[kk].formation_position
                                            homeTeam2[k].teamId = homeTeam3[kk].teamId
                                            homeTeam2[k].mR1 = homeTeam3[kk].mR1
                                            homeTeam2[k].p_m_Role = homeTeam3[kk].p_m_Role
                                            homeTeam2[k].primaryRole = homeTeam3[kk].primaryRole
                                            homeTeam2[k].altRole1 = homeTeam3[kk].altRole1
                                            homeTeam2[k].altRole2 = homeTeam3[kk].altRole2
                                            homeTeam2[k].sub_order_color = homeTeam3[kk].sub_order_color
                                            homeTeam2[k].sub_minute = homeTeam3[kk].sub_minute
                                            homeTeam2[k].rule_color = 'pink'
                                            homeTeam2[k].Tit = homeTeam3[kk].Tit
                                            homeTeam2[k].order_key = 1
                                            homeTeam3[kk].order_key = 1
                                        }
                                    }
                                }
                            }
                            for(let k = 0 ; k < 11 ; k++){
                                if(homeTeam3[k].order_key === 0){
                                    let mean_role = homeTeam3[k].mR
                                    for(let kk = 0 ; kk < 11 ; kk++){
                                        if(homeTeam2[kk].order_key === 0){
                                            let mean_role1 = homeTeam2[kk].mR
                                            let s_role = homeTeam2[kk].sRole
                                            if(mean_role === 'DEF'){
                                                if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            else if(mean_role === 'MID'){
                                                if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            else if(mean_role === 'FWD'){
                                                if(mean_role1 === 'FWD'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'MID'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                                else if(mean_role1 === 'DEF'){
                                                    homeTeam2[kk] = homeTeam3[k]
                                                    homeTeam2[kk].sRole = s_role
                                                    homeTeam2[kk].mR = mean_role1
                                                    homeTeam2[kk].rule_color = 'gray'
                                                    homeTeam2[kk].order_key = 1
                                                    homeTeam3[k].order_key = 1
                                                }
                                            }
                                            break
                                        }
                                    }
                                }
                            }
                        }
                        this.item1.awayTeam = homeTeam2
                    }
                    else{
                        for(let k = 0 ; k < eventNode.homeTeam.length ; k++){
                            this.item1.awayTeam[k] = eventNode.awayTeam2[k]
                            // this.mainList[i].events[j].awayTeam1[k].sRole = eventNode.awayTeam2[k].sRole1
                            // this.mainList[i].events[j].awayTeam1[k].mR = eventNode.awayTeam2[k].mR1
                            // this.mainList[i].events[j].awayTeam1[k].rule_color = eventNode.awayTeam2[k].rule_color
                        }
                    }
                }

                let home_rule_color_number = {"green_color": 0, "yellow_color": 0, "red_color": 0}
                for(let pp = 0 ; pp < this.item1.homeTeam.length ; pp++){
                    if(this.item1.homeTeam[pp].rule_color === 'rgb(146,208,80)'){
                        home_rule_color_number.green_color++
                    }
                    else if(this.item1.homeTeam[pp].rule_color === 'rgb(255,255,0)'){
                        home_rule_color_number.yellow_color++
                    }
                    else if(this.item1.homeTeam[pp].rule_color === 'rgb(255,0,0)'){
                        home_rule_color_number.red_color++
                    }
                }

                let away_rule_color_number = {"green_color": 0, "yellow_color": 0, "red_color": 0}
                for(let pp = 0 ; pp < this.item1.awayTeam.length ; pp++){
                    if(this.item1.awayTeam[pp].rule_color === 'rgb(146,208,80)'){
                        away_rule_color_number.green_color++
                    }
                    else if(this.item1.awayTeam[pp].rule_color === 'rgb(255,255,0)'){
                        away_rule_color_number.yellow_color++
                    }
                    else if(this.item1.awayTeam[pp].rule_color === 'rgb(255,0,0)'){
                        away_rule_color_number.red_color++
                    }
                }
                this.item1.home_rule_set = home_rule_color_number
                this.item1.away_rule_set = away_rule_color_number
            },
            sortByProperty(property){
                return function(a,b){
                    if(a[property] > b[property])
                        return 1;
                    else if(a[property] < b[property])
                        return -1;
                    return 0;
                }
            },
            sortByProperty1(property){
                return function(a,b){
                    if(a[property] < b[property])
                        return 1;
                    else if(a[property] > b[property])
                        return -1;
                    return 0;
                }
            },
            select_filter1(val){
                if(val == true){
                    this.filterQuery.push('- 1 -')
                }
                else{
                    let index = this.filterQuery.indexOf('- 1 -');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter2(val){
                if(val == true){
                    this.filterQuery.push('- X -')
                }
                else{
                    let index = this.filterQuery.indexOf('- X -');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter3(val){
                if(val == true){
                    this.filterQuery.push('- 2 -')
                }
                else{
                    let index = this.filterQuery.indexOf('- 2 -');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter4(val){
                if(val ==  true){
                    this.filterQuery.push('- Over 0.5')
                }
                else{
                    let index = this.filterQuery.indexOf('- Over 0.5');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter5(val){
                if(val == true){
                    this.filterQuery.push('- Over 1.5')
                }
                else{
                    let index = this.filterQuery.indexOf('- Over 1.5');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter6(val){
                if(val == true){
                    this.filterQuery.push('- Over 2.5')
                }
                else{
                    let index = this.filterQuery.indexOf('- Over 2.5');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter7(val){
                if(val == true){
                    this.filterQuery.push('- Under 2.5')
                }
                else{
                    let index = this.filterQuery.indexOf('- Under 2.5');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter8(val){
                if(val ==  true){
                    this.filterQuery.push('- Under 3.5')
                }
                else{
                    let index = this.filterQuery.indexOf('- Under 3.5');
                    if (index > -1) {
                        this.filterQuery.splice(index, 1);
                    }
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter9(val){
                if(val == true){
                    this.backFilter = true
                }
                else{
                    this.backFilter = false
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter10(val){
                if(val == true){
                    this.layFilter = true
                }
                else{
                    this.layFilter = false
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter11(val){
                if(val == true){
                    this.doubleTips = true
                }
                else{
                    this.doubleTips = false
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter12(val){
                if(val == true){
                    this.cupFilter = true
                }
                else{
                    this.cupFilter = false
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            select_filter13(val){
                if(val == true){
                    this.weekFilter = true
                }
                else{
                    this.weekFilter = false
                }
                if(this.predictionStatus ==  true){
                    this.filter1(this.filterQuery)
                }
            },
            filter1(filterArray){
                this.predictionList1 = []
                
                this.predictionList1.push({'value': '', 'label': this.$t('Select Match')})                

                if(filterArray.length < 1){
                    this.eventLists3 = this.predictionList1
                    return
                }
                else{
                    for(let j = 1 ; j < this.predictionList.length; j++){
                        var prediction = this.predictionList[j].label.toString()
                        var value = this.predictionList[j].value
                        
                        for(let i = 0 ; i < filterArray.length; i++){
                            if(filterArray[i] == '- 1 -'){
                                if(prediction.includes('- 1 -') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- X -'){
                                if(prediction.includes('- X -') == true){
                                    this.predictionList1.push({"value": value, "label":prediction})
                                    
                                    
                                }
                            }
                            else if(filterArray[i] == '- 2 -'){
                                if(prediction.includes('- 2 -') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- Over 0.5'){
                                if(prediction.includes('- Over 0.5') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- Over 1.5'){
                                if(prediction.includes('- Over 1.5') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- Over 2.5'){
                                if(prediction.includes('- Over 2.5') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- Under 2.5'){
                                if(prediction.includes('- Under 2.5') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                            else if(filterArray[i] == '- Under 3.5'){
                                if(prediction.includes('- Under 3.5') == true){
                                    this.predictionList1.push({'value': value, 'label':prediction})
                                }
                            }
                        }
                        
                    }
                   

                    if(this.backFilter == false){
                        let predictions =this.predictionList1.filter(function(item) {
                            return !item.label.includes('Back');
                        });
                        this.predictionList1 = predictions
                    }

                    if(this.layFilter == false){
                        let predictions =this.predictionList1.filter(function(item) {
                            return !item.label.includes('Lay');
                        });
                        this.predictionList1 = predictions
                    }

                    //---------excluded filter-------------

                    for(let i = 0; i < this.predictionList1.length ; i++){
                        if(this.predictionList1[i].value.split(',')[2] != 'MATCH_ODDS'){
                            let self = this
                            let predictions =this.predictionList1.filter(function(item) {
                                return item.value.split(',')[1] == self.predictionList1[i].value.split(',')[1] && item.value.split(',')[2] == self.predictionList1[i].value.split(',')[2];
                            });
                            if(predictions.length > 1){
                                for(let j = 0 ; j < predictions.length; j++){
                                    let index = this.predictionList1.indexOf(predictions[j]);
                                    if (index > -1) {
                                        i = i - 1
                                        this.predictionList1.splice(index, 1);
                                    }
                                }
                            }

                            let predictions1 =this.predictionList1.filter(function(item) {
                                return item.value.split(',')[1] == self.predictionList1[i].value.split(',')[1] && self.predictionList1[i].value.split(',')[2] != 'MATCH_ODDS';
                            });

                            let pp = 0
                            let pp1 = 0

                            for(let j = 0 ; j < predictions1.length ; j++){
                                if(predictions1[j].value.split(',')[2] == 'OVER_UNDER_35' && predictions1[j].value.split(',')[3] == '0'){
                                    pp = 1
                                }
                                if(predictions1[j].value.split(',')[2] == 'OVER_UNDER_25' && predictions1[j].value.split(',')[3] == '1'){
                                    pp1 = 1
                                }
                            }

                            if(pp == 1 && pp1 == 1){
                                for(let j = 0 ; j < predictions1.length ; j++) {
                                    if(predictions1[j].value.split(',')[2] == 'OVER_UNDER_25' || predictions1[j].value.split(',')[2] == 'OVER_UNDER_35'){
                                        let index = this.predictionList1.indexOf(predictions1[j]);
                                        if (index > -1) {
                                            i = i - 1
                                            this.predictionList1.splice(index, 1);
                                        }
                                    }
                                }
                                //console.log('predictions1=>', predictions1)
                            }
                        }
                        else{
                            let self = this
                            let predictions =this.predictionList1.filter(function(item) {
                                return item.value.split(',')[1] == self.predictionList1[i].value.split(',')[1] && item.value.split(',')[2] == self.predictionList1[i].value.split(',')[2];
                            });
                            if(predictions.length > 1){
                                // //console.log('excluded check===>', predictions)
                                let check001 = 0
                                let check002 = 0
                                let check003 = 0
                                let check004 = 0
                                for(let c = 0 ; c < predictions.length ; c++){
                                    if(predictions[c].label.includes('1 - Lay')){
                                        check001 = 1
                                    }
                                    if(predictions[c].label.includes('2 - Lay')){
                                        check002 = 1
                                    }
                                    if(predictions[c].label.includes('X - Back')){
                                        check003 = 1
                                    }
                                    if(predictions[c].label.includes('X - Lay')){
                                        check004 = 1
                                    }
                                }
                                if((check001 === 1 && check002 === 1) || ((check003 === 1) && (check001 === 1 || check002 === 1)) || (check003 === 1 && check004 === 1)){
                                    for(let j = 0 ; j < predictions.length; j++){
                                        //console.log('predictions===>',predictions[j])
                                        let index = this.predictionList1.indexOf(predictions[j]);
                                        if (index > -1) {
                                            i = i - 1
                                            this.predictionList1.splice(index, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    //-------------------------------------

                    if(this.cupFilter == false){
                        for(let i = 1 ; i < this.predictionList1.length; i++){
                            let p_value = this.predictionList1[i].value
                            let com_label = p_value.split(',')
                            let com_eventId =  com_label[1]
                            let competition = this.competitionList.filter(function(item) {
                                return item.eventId == com_eventId;
                            });

                            let competitionLabel = competition[0].competitions[0].name
                            let check = 0
                            for(let k = 0; k < this.cupList.length; k++){
                                if(competitionLabel.includes(this.cupList[k]) == true){
                                    check = 1
                                }
                            }

                            if(check == 1){
                                let index = this.predictionList1.indexOf(this.predictionList1[i]);
                                if (index > -1) {
                                    i = i - 1
                                    this.predictionList1.splice(index, 1);
                                }
                            }

                        }
                    }

                    if(this.weekFilter ==  false){
                        //console.log('prediction_list_check===>',this.predictionList1)
                        // let predictions =this.predictionList1.filter(function(item) {
                        //     return parseInt(item.value.split(',')[5]) > parseInt(item.value.split(',')[4]);
                        // });

                        for(let n = 1 ; n < this.predictionList1.length ; n++){
                            let p_val = this.predictionList1[n].value.split(',')[7].trim()
                            let val1 = parseInt(this.predictionList1[n].value.split(',')[4])
                            let val2 = parseInt(this.predictionList1[n].value.split(',')[5])
                            //console.log('value is just these =>', p_val, val1, val2)
                            if(p_val == 'Perde da' || p_val == 'Perde in casa da' || p_val == 'Pareggia fuori da'){
                                //console.log('value is just these =>', p_val)
                                let index = this.predictionList1.indexOf(this.predictionList1[n]);
                                if (index > -1) {
                                    n = n - 1
                                    this.predictionList1.splice(index, 1);
                                }
                            }
                            else if(p_val != 'Non vince da' && p_val != 'Non pareggia da' && p_val != 'Non perde da' && p_val != 'Non perde in casa da' && p_val != 'Non vince fuori da' && p_val != 'Non pareggia fuori da'){
                                if(val1 > val2){
                                    let index = this.predictionList1.indexOf(this.predictionList1[n]);
                                    if (index > -1) {
                                        n = n - 1
                                        this.predictionList1.splice(index, 1);
                                    }
                                }
                            }
                            else{
                                //console.log(this.predictionList1)
                            }
                        }
                    }

                    if(this.doubleTips ==  false){
                        let eventArray = []
                        for(let d = 0 ; d < this.predictionList1.length; d++){
                            eventArray[d] = this.predictionList1[d].value.split(',')[1]
                        }
                        eventArray = Array.from(new Set (eventArray))

                        for(let d = 0 ; d < eventArray.length; d++){
                            let predictions = this.predictionList1.filter(function(item) {
                                return item.value.split(',')[1] == eventArray[d] && item.value.split(',')[2] == 'MATCH_ODDS';
                            });

                            if(predictions.length > 1){
                                let predictions1 = predictions.filter(function(item) {
                                    return item.value.split(',')[3] == '2';
                                });

                                if(predictions1.length > 0){
                                    for(let g = 0 ; g < predictions.length ; g++){
                                        if(predictions[g].value.split(',')[3] != '2'){
                                            let index = this.predictionList1.indexOf(predictions[g]);
                                            if (index > -1) {
                                                g = g - 1
                                                this.predictionList1.splice(index, 1);
                                            }
                                        }
                                    }
                                }

                                if(predictions.length > 1){
                                    let predictions1 = predictions.filter(function(item) {
                                        return item.value.split(',')[3] == '2' && item.value.split(',')[6] == '0';
                                    });
                                    if(predictions1.length > 0){
                                        for(let g = 0 ; g < predictions.length ; g++){
                                            if(predictions[g].label.includes('1 - Lay') == true || predictions[g].label.includes('2 - Lay') == true){
                                                let index = this.predictionList1.indexOf(predictions[g]);
                                                if (index > -1) {
                                                    g = g - 1
                                                    this.predictionList1.splice(index, 1);
                                                }
                                            }
                                        }
                                        let index = this.predictionList1.indexOf(predictions1[0]);
                                        if (index > -1) {
                                            this.predictionList1.splice(index, 1);
                                        }
                                    }
                                }
                            }
                        }
                    }

                    if(this.doubleTips ==  true){
                        let eventArray = []
                        for(let d = 0 ; d < this.predictionList1.length; d++){
                            eventArray[d] = this.predictionList1[d].value.split(',')[1]
                        }
                        eventArray = Array.from(new Set (eventArray))

                        for(let d = 0 ; d < eventArray.length; d++){
                            let predictions = this.predictionList1.filter(function(item) {
                                return item.value.split(',')[1] == eventArray[d] && item.value.split(',')[2] == 'MATCH_ODDS';
                            });

                            if(predictions.length > 1){
                                let predictions1 = predictions.filter(function(item) {
                                    return item.value.split(',')[3] == '2' && item.value.split(',')[6] == '0';
                                });
                                if(predictions1.length > 0){
                                    for(let g = 0 ; g < predictions.length ; g++){
                                        if(predictions[g].label.includes('1 - Lay') == true || predictions[g].label.includes('2 - Lay') == true){
                                            let index = this.predictionList1.indexOf(predictions[g]);
                                            if (index > -1) {
                                                g = g - 1
                                                this.predictionList1.splice(index, 1);
                                            }
                                        }
                                    }
                                    let index = this.predictionList1.indexOf(predictions1[0]);
                                    if (index > -1) {
                                        this.predictionList1.splice(index, 1);
                                    }
                                }
                            }
                        }
                    }

                    if(this.predictionStatus == true){
                        //-----------------------total_matched_money--------------------------
                        for(let p = 1; p < this.predictionList1.length; p++){
                            let eventId = this.predictionList1[p].value.split(',')[1]
                            let marketType = this.predictionList1[p].value.split(',')[2]

                            let eventNode = this.mainList.filter(function(item) {
                                return item.eventId == eventId;
                            });

                            let marketNode = eventNode[0].markets.filter(function(item) {
                                return item.marketType == marketType;
                            });
                            // //console.log('marketNode===>', marketNode, marketType)
                            if(marketNode.length > 0){
                                if(marketNode[0].totalMatched < this.matchedMin || marketNode[0].totalMatched > this.matchedMax){
                                    let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                    if (index > -1) {
                                        p = p - 1
                                        this.predictionList1.splice(index, 1);
                                    }
                                }
                            }
                            else{
                                // let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                // if (index > -1) {
                                //     p = p - 1
                                //     this.predictionList1.splice(index, 1);
                                // }
                            }
                        }
                        //---------------------------odd_filter----------------------------
                        for(let p = 1 ; p < this.predictionList1.length; p++){
                            let eventId = this.predictionList1[p].value.split(',')[1]
                            let marketType = this.predictionList1[p].value.split(',')[2]
                            let marketNo = parseInt(this.predictionList1[p].value.split(',')[3])
                            let runnerNo = parseInt(this.predictionList1[p].value.split(',')[6])
                            let predictionLabel = this.predictionList1[p].label

                            let eventNode = this.mainList.filter(function(item) {
                                return item.eventId == eventId;
                            });

                            let marketNode = eventNode[0].markets.filter(function(item) {
                                return item.marketType == marketType;
                            });
                            // //console.log('marketNode===>', marketNode[0])
                            if(marketNode[0]){
                                if(!marketNode[0].runners){
                                    return
                                }

                                if(predictionLabel.includes(' - Live') == true){
                                    for(let h = 0  ; h < this.prematchOddList.length ;  h++){
                                        if(this.prematchOddList[h].marketId == marketNode[0].marketId){
                                            // //console.log('great!!', marketNode[0].marketId)
                                            if(this.prematchOddList[h].runners[marketNo].exchange){
                                                if(runnerNo == '0'){
                                                    if(this.prematchOddList[h].runners[marketNo].exchange.availableToBack){
                                                        let backOdds = parseFloat(this.prematchOddList[h].runners[marketNo].exchange.availableToBack[0].price)
                                                        if(this.marketId == marketNode[0].marketId){
                                                            this.prematchOdd = backOdds
                                                        }
                                                        if(backOdds < parseFloat(this.oddMin) || backOdds > parseFloat(this.oddMax)){
                                                            let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                                            if (index > -1) {
                                                                p = p - 1
                                                                this.predictionList1.splice(index, 1);
                                                            }
                                                        }

                                                    }
                                                }
                                                else {
                                                    if(this.prematchOddList[h].runners[marketNo].exchange.availableToLay){
                                                        let layOdds = parseFloat(this.prematchOddList[h].runners[marketNo].exchange.availableToLay[0].price)
                                                        if(this.marketId == marketNode[0].marketId){
                                                            this.prematchOdd = layOdds
                                                        }
                                                        if(layOdds < parseFloat(this.oddMin) || layOdds > parseFloat(this.oddMax)){
                                                            let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                                            if (index > -1) {
                                                                p = p - 1
                                                                this.predictionList1.splice(index, 1);
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                                else{
                                    if(marketNode[0].runners[marketNo].exchange){
                                        if(runnerNo == '0'){
                                            if(marketNode[0].runners[marketNo].exchange.availableToBack){
                                                let backOdds = parseFloat(marketNode[0].runners[marketNo].exchange.availableToBack[0].price)
                                                if(backOdds < parseFloat(this.oddMin) || backOdds > parseFloat(this.oddMax)){
                                                    let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                                    if (index > -1) {
                                                        p = p - 1
                                                        this.predictionList1.splice(index, 1);
                                                    }
                                                }

                                            }
                                        }
                                        else {
                                            if(marketNode[0].runners[marketNo].exchange.availableToLay){
                                                let layOdds = parseFloat(marketNode[0].runners[marketNo].exchange.availableToLay[0].price)
                                                if(layOdds < parseFloat(this.oddMin) || layOdds > parseFloat(this.oddMax)){
                                                    let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                                    if (index > -1) {
                                                        p = p - 1
                                                        this.predictionList1.splice(index, 1);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            else{
                                let index = this.predictionList1.indexOf(this.predictionList1[p]);
                                if (index > -1) {
                                    p = p - 1
                                    this.predictionList1.splice(index, 1);
                                }
                            }
                        }



                        let checkSelect = 0;
                        for(let s = 0 ; s < this.predictionList1.length ; s++){
                            if(this.predictionList1[s].value == this.selectedValue){
                                checkSelect = 1
                            }
                        }
                        if(checkSelect == 0){
                            this.eventId = 0
                            this.marketId = ''
                                this.selectionId = 0
                            this.lay =''
                                this.lay_matched = 0
                            this.back =''
                                this.back_matched = 0
                            this.total_matched = 0
                            this.status =''
                                this.scoreOne =''
                                    this.scoreTwo =''
                                        this.timeRecord =''
                                            this.key1 = 0
                            this.key2 = 0
                        }
                        this.eventLists3 = this.predictionList1
                    }
                }
            },
            odd_min(val){
                this.oddMin = val
                // if(this.predictionStatus == true){
                this.filter1(this.filterQuery)
                // }
            },
            odd_max(val){
                this.oddMax = val
                // if(this.predictionStatus == true){
                this.filter1(this.filterQuery)
                // }
            },
            matched_min(val){
                this.matchedMin = val
                // if(this.predictionStatus == true){
                this.filter1(this.filterQuery)
                // }
            },
            cs_calc(val){
                this.cs_odd = parseInt(val)
                this.stake_profit_calc()
            },
            cs_stake_calc(val){
                this.cs_stake =  parseInt(val)
                this.cs_profit_calc()
            },
            odd_calc(val){
                this.calc_odd = val
                this.stake_profit_calc()
                this.cs_profit_calc()
            },
            stake_calc(val){
                this.calc_stake = val
                this.stake_profit_calc()
            },
            cs_profit_calc(){
                if(this.cs_odd != 0 && this.cs_stake != 0 && this.eventId != 0){

                    this.cs_max_profit = (this.cs_odd * this.cs_stake - this.cs_stake).toFixed(2)
                    this.cs_max_lose = this.cs_stake
                    this.cs_guad_max = this.cs_max_profit
                    if(this.CS_Odd_lay_price == '' || this.CS_Odd_lay_price == 0 || this.CS_Odd_lay_price == null){
                        this.cs_guad_att = 0
                    }
                    else{
                        this.cs_guad_att = (this.cs_odd * this.cs_stake/parseFloat(this.CS_Odd_lay_price) -  this.cs_stake).toFixed(2)
                    }

                    if(this.cs_guad_att > 0){
                        this.cs_guad_att = (this.cs_guad_att * (100 - this.bookmarkerFee)/100).toFixed(2)
                    }

                    if(this.cs_guad_max != 0){
                        if(this.cs_guad_att >= 0){
                            this.cs_currentPercent = (100*this.cs_guad_att/this.cs_guad_max).toFixed(2)
                        }
                        else{
                            this.cs_currentPercent = (100*this.cs_guad_att/this.cs_stake).toFixed(2)
                        }
                    }
                    else{
                        this.cs_currentPercent = 0
                    }

                    if(this.cs_currentPercent > 0){
                        // this.cs_percentTextColor = '#20a052'
                        // this.cs_percentTextColor1 = '#20a052'
                        // this.cs_percentBackgroundColor = '#d8e4bc'
                        // this.cs_percentBackgroundColor1 = '#d8e4bc'
                        this.cs_percentTextColor = 'darkgreen'
                        this.cs_percentTextColor1 = 'darkgreen'
                        this.cs_percentBackgroundColor = 'rgb(90, 239, 49)'
                        this.cs_percentBackgroundColor1 = 'rgb(90, 239, 49)'
                        this.cs_percent_text1 = 'Current Profit:'
                        this.cs_percent_text2 = this.cs_currentPercent.toString() + '%'
                    }
                    else if(this.cs_currentPercent < 0){
                        this.cs_percentTextColor = '#b80101'
                        this.cs_percentTextColor1 = '#b80101'
                        this.cs_percentBackgroundColor = '#ffc7ce'
                        this.cs_percentBackgroundColor1 = '#ffc7ce'
                        this.cs_percent_text1 = 'Current Profit:'
                        this.cs_percent_text2 = this.cs_currentPercent.toString() + '%'
                    }
                }
                else{
                    this.cs_max_profit = 0
                    this.cs_max_lose = 0
                    this.cs_guad_max = 0
                    this.cs_percent_text1 = ''
                    this.cs_percent_text2 = this.$t('Insert CS Odd and Stake')
                    this.cs_guad_att = 0
                    this.cs_percentTextColor = '#20a052'
                    this.cs_percentTextColor1 = '#20a052'
                    this.cs_percentBackgroundColor = '#d8e4bc'
                    this.cs_percentBackgroundColor1 = '#d8e4bc'
                }
            },
            stake_profit_calc(){
                if(this.calc_odd != 0 && this.calc_stake != 0 && this.eventId != 0){
                    if(parseInt(this.selectedArray[6]) == 0){
                        if(this.cs_odd > 1){
                            this.stakeToCover = this.calc_stake/(this.cs_odd - 1)
                            if((this.stakeToCover - parseInt(this.stakeToCover)) > 0 && (this.stakeToCover - parseInt(this.stakeToCover)) <= 0.5){
                                this.stakeToCover = parseInt(this.stakeToCover) + '.50'
                            }
                            else if((this.stakeToCover - parseInt(this.stakeToCover)) > 0.5){
                                this.stakeToCover = parseInt(this.stakeToCover) + 1
                            }
                        }
                        this.max_profit = (this.calc_odd * this.calc_stake - this.calc_stake).toFixed(2)
                        this.max_lose = this.calc_stake
                        this.guad_max = this.max_profit
                        if(this.lay == '' || this.lay == 0){
                            this.guad_att = 0
                        }
                        else{
                            this.guad_att = (this.calc_odd * this.calc_stake/parseFloat(this.lay) -  this.calc_stake).toFixed(2)
                        }

                        if(this.guad_att > 0){
                            this.guad_att = (this.guad_att * (100 - this.bookmarkerFee)/100).toFixed(2)
                        }

                        if(this.guad_max != 0){
                            if(this.guad_att >= 0){
                                this.currentPercent = (100*this.guad_att/this.guad_max).toFixed(2)
                            }
                            else{
                                this.currentPercent = (100*this.guad_att/this.calc_stake).toFixed(2)
                            }
                        }
                        else{
                            this.currentPercent = 0
                        }
                        if(this.currentPercent > 0){
                            // this.percentTextColor = '#20a052'
                            // this.percentTextColor1 = '#20a052'
                            // this.percentBackgroundColor = '#d8e4bc'
                            // this.percentBackgroundColor1 = '#d8e4bc'
                            this.percentTextColor = 'darkgreen'
                            this.percentTextColor1 = 'darkgreen'
                            this.percentBackgroundColor = 'rgb(90, 239, 49)'
                            this.percentBackgroundColor1 = 'rgb(90, 239, 49)'
                            this.percent_text1 = 'Current Profit:'
                            this.percent_text2 = this.currentPercent.toString() + '%'

                            let timeRecord = this.timeRecord
                            let MG = timeRecord.substring(0, timeRecord.length)

                            if(MG == ''){
                                MG = '0'
                            }
                            //console.log('XXXXXXXXXX->>>>',MG,this.riskTrading,this.stopLoss,this.tradingMode,this.currentPercent)
                            if(this.riskTrading == 'easy'){
                                if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].facile.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].facile.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].facile.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].facile.GT){
                                   this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'medium'){
                                if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].medio.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].medio.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].medio.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].medio.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'risky'){
                                if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].elevato.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].elevato.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].elevato.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].elevato.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'auto'){
                                //console.log("===>auto Trading Check==>", val1)
                                let val1 = this.selectedValue
                                let eventId = parseInt(val1.split(',')[1])
                                let marketType = val1.split(',')[2]
                                let team = val1.split(',')[3]
                                let runnerNo = val1.split(',')[6]
                                let pred = ""
                                let self = this
                                if(marketType == 'MATCH_ODDS'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- 1 - Back'
                                        }
                                        else{
                                            pred = '- 1 - Lay'
                                        }
                                    }
                                    else if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- 2 - Back'
                                        }
                                        else{
                                            pred = '- 2 - Lay'
                                        }
                                    }
                                    else if(team == '2'){
                                        if(runnerNo == '0'){
                                            pred = '- X - Back'
                                        }
                                        else{
                                            pred = '- X - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_05'){
                                    if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- O 0.5 - Back'
                                        }
                                        else{
                                            pred = '- O 0.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_15'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 1.5 - Back'
                                        }
                                        else{
                                            pred = '- U 1.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 1.5 - Back'
                                        }
                                        else{
                                            pred = '- O 1.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_25'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 2.5 - Back'
                                        }
                                        else{
                                            pred = '- U 2.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 2.5 - Back'
                                        }
                                        else{
                                            pred = '- O 2.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_35'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 3.5 - Back'
                                        }
                                        else{
                                            pred = '- U 3.5 - Lay'
                                        }
                                    }
                                }
                                let predT = self.pred_type_list.filter(function(item) {
                                    return item.label == pred
                                })
                                //console.log('predT====>', predT, pred, self.cashoutTable)
                                if(predT.length > 0){
                                    for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                        if(predT[0].value == self.cashoutTable[k].PredType.value){
                                            let triger = {
                                                "maxOddPre": 1000000,
                                                "minOddPre": 0,
                                                "maxOddLive": 1000000,
                                                "minOddLive": 0,
                                                "minscoreHome": 0,
                                                "maxscoreHome": 100,
                                                "minscoreAway": 0,
                                                "maxscoreAway": 100,
                                                "min_total_goal": 0,
                                                "max_total_goal": 100,
                                                "minTime": 0,
                                                "maxTime": 150,
                                                "matchStatus": 0,
                                                "alertName": null,
                                                "minonHome": 0,
                                                "maxonHome": 100,
                                                "minoffHome": 0,
                                                "maxoffHome": 100,
                                                "minonAway": 0,
                                                "maxonAway": 100,
                                                "minoffAway": 0,
                                                "maxoffAway": 100,
                                                "min_profit": -1000,
                                                "max_profit": 1000000000,
                                                "stop_loss": false,
                                                "tradingMode": false
                                            }
                                            if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                                triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                                triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                                triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                            }
                                            if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                                triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                            }
                                            if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                                triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                            }
                                            if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                                triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                            }
                                            if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                                triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                            }
                                            if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                                triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                            }
                                            if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                                triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                                triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                                triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                            }
                                            if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                                triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                            }
                                            if(self.cashoutTable[k].MatchStatus.value != null){
                                                triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                            }
                                            if(self.cashoutTable[k].Alert_Name.value != null){
                                                triger.alertName = self.cashoutTable[k].Alert_Name.value
                                            }
                                            if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                                triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                            }
                                            if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                                triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                            }
                                            if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                                triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                            }
                                            if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                                triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                            }
                                            if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                                triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                            }
                                            if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                                triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                            }
                                            if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                                triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                            }
                                            if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                                triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                            }
                                            if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                                triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                            }
                                            if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                                triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                            }
                                            if(self.cashoutTable[k].stop_loss.value != false){
                                                triger.stop_loss = true
                                            }
                                            if(self.cashoutTable[k].tradingMode.value != false){
                                                triger.tradingMode = true
                                            }
                                            for(let j = 0; j < self.mainList.length; j++){
                                                if(eventId == self.mainList[j].eventId){
                                                    if (self.mainList[j].DailyApiEvents1.length == 0)
                                                        continue
                                                    let eventTriger = {
                                                        "name": self.selectedLabel,
                                                        "oddPre": null,
                                                        "oddLive": null,
                                                        "scoreHome": 0,
                                                        "scoreAway": 0,
                                                        "total_goal": 0,
                                                        "min_total_goal": 0,
                                                        "max_total_goal": 0,
                                                        "time": 0,
                                                        "matchStatus": null,
                                                        "alertName": self.cashoutAlertName,
                                                        "onHome": 0,
                                                        "offHome": 0,
                                                        "onAway": 0,
                                                        "offAway": 0,
                                                        "c_color": "green",
                                                        "profit": parseFloat(this.currentPercent),
                                                        "stop_loss": self.stopLoss,
                                                        "tradingMode": self.tradingMode
                                                    }
                                                    let eventNode = self.mainList[j]
                                                    if(eventNode.score){
                                                        let scoreDetail = eventNode.score
                                                        eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                        eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                        eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                    }
                                                    if(eventNode.status){
                                                        eventTriger.matchStatus = 1
                                                        eventTriger.time = eventNode.timeElapsed
                                                    }
                                                    else if(!eventNode.status){
                                                        eventTriger.matchStatus = 0
                                                    }
                                                    for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                        let marketNode = self.mainList[j].markets[c]
                                                        let check = 0
                                                        if(marketNode.marketType == marketType){
                                                            if(marketNode.state){
                                                                if(marketNode.state.status == "CLOSED"){
                                                                    eventTriger.matchStatus = 0
                                                                    check = 1
                                                                }
                                                            }
                                                            if(check === 0){
                                                                let runnerNode = marketNode.runners[team]
                                                                let prematchMarket = null
                                                                if(self.mainList[j].markets[c].prematchMarket){
                                                                    prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                                }
                                                                if(eventNode.status && prematchMarket != null){
                                                                    let runnerlists = prematchMarket.runners[team]
                                                                    if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                    }
                                                                    if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        if(runnerNo == 0){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                        }
                                                                    }
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        if(runnerNo == 1){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                        }
                                                                    }
                                                                }
                                                                if(runnerNo == 0){
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    let liveStatsNode = self.mainList[j].livestatus
                                                    let liveNode = liveStatsNode.stats
                                                    if(liveStatsNode.stats){
                                                        if(liveStatsNode.stats.length > 1){
                                                            if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                                if(liveStatsNode.stats[0].shots != null){
                                                                    eventTriger.onHome = liveNode[0].shots.ongoal
                                                                    eventTriger.offHome = liveNode[0].shots.offgoal
                                                                    eventTriger.onAway = liveNode[1].shots.ongoal
                                                                    eventTriger.offAway = liveNode[1].shots.offgoal
                                                                }
                                                            }
                                                            else{
                                                                if(liveStatsNode.stats[1].shots != null){
                                                                    eventTriger.onHome = liveNode[1].shots.ongoal
                                                                    eventTriger.offHome = liveNode[1].shots.offgoal
                                                                    eventTriger.onAway = liveNode[0].shots.ongoal
                                                                    eventTriger.offAway = liveNode[0].shots.offgoal
                                                                }
                                                            }
                                                        }
                                                    }
                                                    //console.log('****************************cash out message check cond= >', triger)
                                                    //console.log('****************************cash out message check value= >', eventTriger)
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                                if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                    if(triger.alertName == eventTriger.alertName){
                                                                                                        this.percentTextColor1 = '#000'
                                                                                                        this.percentBackgroundColor = '#ffc000'
                                                                                                        this.percent_text1 = 'Cash Out Now! '
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else if(this.currentPercent < 0){
                            this.percentTextColor = '#b80101'
                            this.percentTextColor1 = '#b80101'
                            this.percentBackgroundColor = '#ffc7ce'
                            this.percentBackgroundColor1 = '#ffc7ce'
                            this.percent_text1 = 'Current Profit:'
                            this.percent_text2 = this.currentPercent.toString() + '%'

                            let timeRecord = this.timeRecord
                            let MG = timeRecord.substring(0, timeRecord.length)

                            if(MG =='' ){
                                MG = '0'
                            }

                            //console.log('XXXXXXXXXX',MG,this.riskTrading,this.stopLoss,this.tradingMode,this.currentPercent)

                            if(this.riskTrading == 'easy'){
                                if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].facile.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].facile.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'medium'){
                                if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].medio.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].medio.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'risky'){
                                if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].elevato.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].elevato.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'auto'){
                                //console.log("===>auto Trading Check==>", val1)
                                let val1 = this.selectedValue
                                let eventId = parseInt(val1.split(',')[1])
                                let marketType = val1.split(',')[2]
                                let team = val1.split(',')[3]
                                let runnerNo = val1.split(',')[6]
                                let pred = ""
                                let self = this
                                if(marketType == 'MATCH_ODDS'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- 1 - Back'
                                        }
                                        else{
                                            pred = '- 1 - Lay'
                                        }
                                    }
                                    else if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- 2 - Back'
                                        }
                                        else{
                                            pred = '- 2 - Lay'
                                        }
                                    }
                                    else if(team == '2'){
                                        if(runnerNo == '0'){
                                            pred = '- X - Back'
                                        }
                                        else{
                                            pred = '- X - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_05'){
                                    if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- O 0.5 - Back'
                                        }
                                        else{
                                            pred = '- O 0.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_15'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 1.5 - Back'
                                        }
                                        else{
                                            pred = '- U 1.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 1.5 - Back'
                                        }
                                        else{
                                            pred = '- O 1.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_25'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 2.5 - Back'
                                        }
                                        else{
                                            pred = '- U 2.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 2.5 - Back'
                                        }
                                        else{
                                            pred = '- O 2.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_35'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 3.5 - Back'
                                        }
                                        else{
                                            pred = '- U 3.5 - Lay'
                                        }
                                    }
                                }
                                let predT = self.pred_type_list.filter(function(item) {
                                    return item.label == pred
                                })
                                //console.log('predT====>', predT, pred, self.cashoutTable)
                                if(predT.length > 0){
                                    for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                        if(predT[0].value == self.cashoutTable[k].PredType.value){
                                            let triger = {
                                                "maxOddPre": 1000000,
                                                "minOddPre": 0,
                                                "maxOddLive": 1000000,
                                                "minOddLive": 0,
                                                "minscoreHome": 0,
                                                "maxscoreHome": 100,
                                                "minscoreAway": 0,
                                                "maxscoreAway": 100,
                                                "min_total_goal": 0,
                                                "max_total_goal": 100,
                                                "minTime": 0,
                                                "maxTime": 150,
                                                "matchStatus": 0,
                                                "alertName": null,
                                                "minonHome": 0,
                                                "maxonHome": 100,
                                                "minoffHome": 0,
                                                "maxoffHome": 100,
                                                "minonAway": 0,
                                                "maxonAway": 100,
                                                "minoffAway": 0,
                                                "maxoffAway": 100,
                                                "min_profit": -1000,
                                                "max_profit": 1000000000,
                                                "stop_loss": false,
                                                "tradingMode": false
                                            }
                                            if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                                triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                                triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                                triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                            }
                                            if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                                triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                            }
                                            if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                                triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                            }
                                            if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                                triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                            }
                                            if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                                triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                            }
                                            if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                                triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                            }
                                            if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                                triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                                triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                                triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                            }
                                            if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                                triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                            }
                                            if(self.cashoutTable[k].MatchStatus.value != null){
                                                triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                            }
                                            if(self.cashoutTable[k].Alert_Name.value != null){
                                                triger.alertName = self.cashoutTable[k].Alert_Name.value
                                            }
                                            if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                                triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                            }
                                            if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                                triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                            }
                                            if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                                triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                            }
                                            if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                                triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                            }
                                            if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                                triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                            }
                                            if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                                triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                            }
                                            if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                                triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                            }
                                            if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                                triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                            }
                                            if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                                triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                            }
                                            if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                                triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                            }
                                            if(self.cashoutTable[k].stop_loss.value != false){
                                                triger.stop_loss = true
                                            }
                                            if(self.cashoutTable[k].tradingMode.value != false){
                                                triger.tradingMode = true
                                            }
                                            for(let j = 0; j < self.mainList.length; j++){
                                                if(eventId == self.mainList[j].eventId){
                                                    if (self.mainList[j].DailyApiEvents1.length == 0)
                                                        continue
                                                    let eventTriger = {
                                                        "name": self.selectedLabel,
                                                        "oddPre": null,
                                                        "oddLive": null,
                                                        "scoreHome": 0,
                                                        "scoreAway": 0,
                                                        "total_goal": 0,
                                                        "min_total_goal": 0,
                                                        "max_total_goal": 0,
                                                        "time": 0,
                                                        "matchStatus": null,
                                                        "alertName": self.cashoutAlertName,
                                                        "onHome": 0,
                                                        "offHome": 0,
                                                        "onAway": 0,
                                                        "offAway": 0,
                                                        "c_color": "green",
                                                        "profit": parseFloat(this.currentPercent),
                                                        "stop_loss": self.stopLoss,
                                                        "tradingMode": self.tradingMode
                                                    }
                                                    let eventNode = self.mainList[j]
                                                    if(eventNode.score){
                                                        let scoreDetail = eventNode.score
                                                        eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                        eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                        eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                    }
                                                    if(eventNode.status){
                                                        eventTriger.matchStatus = 1
                                                        eventTriger.time = eventNode.timeElapsed
                                                    }
                                                    else if(!eventNode.status){
                                                        eventTriger.matchStatus = 0
                                                    }
                                                    for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                        let marketNode = self.mainList[j].markets[c]
                                                        let check = 0
                                                        if(marketNode.marketType == marketType){
                                                            if(marketNode.state){
                                                                if(marketNode.state.status == "CLOSED"){
                                                                    eventTriger.matchStatus = 0
                                                                    check = 1
                                                                }
                                                            }
                                                            if(check === 0){
                                                                let runnerNode = marketNode.runners[team]
                                                                let prematchMarket = null
                                                                if(self.mainList[j].markets[c].prematchMarket){
                                                                    prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                                }
                                                                if(eventNode.status && prematchMarket != null){
                                                                    let runnerlists = prematchMarket.runners[team]
                                                                    if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                    }
                                                                    if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        if(runnerNo == 0){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                        }
                                                                    }
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        if(runnerNo == 1){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                        }
                                                                    }
                                                                }
                                                                if(runnerNo == 0){
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    let liveStatsNode = self.mainList[j].livestatus
                                                    let liveNode = liveStatsNode.stats
                                                    if(liveStatsNode.stats){
                                                        if(liveStatsNode.stats.length > 1){
                                                            if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                                if(liveStatsNode.stats[0].shots != null){
                                                                    eventTriger.onHome = liveNode[0].shots.ongoal
                                                                    eventTriger.offHome = liveNode[0].shots.offgoal
                                                                    eventTriger.onAway = liveNode[1].shots.ongoal
                                                                    eventTriger.offAway = liveNode[1].shots.offgoal
                                                                }
                                                            }
                                                            else{
                                                                if(liveStatsNode.stats[1].shots != null){
                                                                    eventTriger.onHome = liveNode[1].shots.ongoal
                                                                    eventTriger.offHome = liveNode[1].shots.offgoal
                                                                    eventTriger.onAway = liveNode[0].shots.ongoal
                                                                    eventTriger.offAway = liveNode[0].shots.offgoal
                                                                }
                                                            }
                                                        }
                                                    }
                                                    //console.log('****************************cash out message check cond= >', triger)
                                                    //console.log('****************************cash out message check value= >', eventTriger)
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                                if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                    if(triger.alertName == eventTriger.alertName){
                                                                                                        this.percentTextColor1 = '#000'
                                                                                                        this.percentBackgroundColor = '#ffc000'
                                                                                                        this.percent_text1 = 'Cash Out Now! '
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        //console.log('Layasdasd===>', this.max_profit)

                    }
                    else{
                        if(this.cs_odd > 1){
                            this.stakeToCover = (this.calc_odd * this.calc_stake - this.calc_stake)/(this.cs_odd - 1)
                            if((this.stakeToCover - parseInt(this.stakeToCover)) > 0 && (this.stakeToCover - parseInt(this.stakeToCover)) <= 0.5){
                                this.stakeToCover = parseInt(this.stakeToCover) + '.50'
                            }
                            else if((this.stakeToCover - parseInt(this.stakeToCover)) > 0.5){
                                this.stakeToCover = parseInt(this.stakeToCover) + 1
                            }
                        }
                        this.max_lose = (this.calc_odd * this.calc_stake - this.calc_stake).toFixed(2)
                        this.max_profit = this.calc_stake
                        this.guad_max = this.calc_stake
                        if(this.back == '' || this.back == 0){
                            this.guad_att = 0
                        }
                        else{
                            this.guad_att = ( this.calc_stake - this.calc_odd * this.calc_stake/parseFloat(this.back)).toFixed(2)
                        }

                        if(this.guad_att > 0){
                            this.guad_att = (this.guad_att * (100 - this.bookmarkerFee)/100).toFixed(2)
                        }
                        //console.log('Lay===>', this.max_profit)

                        if(this.guad_max != 0){
                            if(this.guad_att >= 0){
                                this.currentPercent = (100*this.guad_att/this.guad_max).toFixed(2)
                            }
                            else{
                                this.currentPercent = (100*this.guad_att/(this.calc_odd * this.calc_stake - this.calc_stake)).toFixed(2)
                            }
                        }
                        else{
                            this.currentPercent = 0
                        }
                        if(this.currentPercent > 0){
                            // this.percentTextColor = '#20a052'
                            // this.percentTextColor1 = '#20a052'
                            // this.percentBackgroundColor = '#d8e4bc'
                            // this.percentBackgroundColor1 = '#d8e4bc'
                            this.percentTextColor = 'darkgreen'
                            this.percentTextColor1 = 'darkgreen'
                            this.percentBackgroundColor = 'rgb(90, 239, 49)'
                            this.percentBackgroundColor1 = 'rgb(90, 239, 49)'
                            this.percent_text1 = 'Current Profit:'
                            this.percent_text2 = this.currentPercent.toString() + '%'

                            let timeRecord = this.timeRecord
                            let MG = timeRecord.substring(0, timeRecord.length)

                            if(MG =='' ){
                                MG = '0'
                            }

                            //console.log('XXXXXXXXXX',MG,this.riskTrading,this.stopLoss,this.tradingMode,this.currentPercent)

                            if(this.riskTrading == 'easy'){
                                if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].facile.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].facile.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].facile.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].facile.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'medium'){
                                if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].medio.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].medio.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].medio.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].medio.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'risky'){
                                if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == false && this.tradingMode == false && this.currentPercent > this.adminTable[0].elevato.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == false && this.currentPercent > this.adminTable[0].elevato.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent > this.adminTable[0].elevato.GN){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent > this.adminTable[0].elevato.GT){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'auto'){
                                //console.log("===>auto Trading Check==>", val1)
                                let val1 = this.selectedValue
                                let eventId = parseInt(val1.split(',')[1])
                                let marketType = val1.split(',')[2]
                                let team = val1.split(',')[3]
                                let runnerNo = val1.split(',')[6]
                                let pred = ""
                                let self = this
                                if(marketType == 'MATCH_ODDS'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- 1 - Back'
                                        }
                                        else{
                                            pred = '- 1 - Lay'
                                        }
                                    }
                                    else if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- 2 - Back'
                                        }
                                        else{
                                            pred = '- 2 - Lay'
                                        }
                                    }
                                    else if(team == '2'){
                                        if(runnerNo == '0'){
                                            pred = '- X - Back'
                                        }
                                        else{
                                            pred = '- X - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_05'){
                                    if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- O 0.5 - Back'
                                        }
                                        else{
                                            pred = '- O 0.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_15'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 1.5 - Back'
                                        }
                                        else{
                                            pred = '- U 1.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 1.5 - Back'
                                        }
                                        else{
                                            pred = '- O 1.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_25'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 2.5 - Back'
                                        }
                                        else{
                                            pred = '- U 2.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 2.5 - Back'
                                        }
                                        else{
                                            pred = '- O 2.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_35'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 3.5 - Back'
                                        }
                                        else{
                                            pred = '- U 3.5 - Lay'
                                        }
                                    }
                                }
                                let predT = self.pred_type_list.filter(function(item) {
                                    return item.label == pred
                                })
                                //console.log('predT====>', predT, pred, self.cashoutTable)
                                if(predT.length > 0){
                                    for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                        if(predT[0].value == self.cashoutTable[k].PredType.value){
                                            let triger = {
                                                "maxOddPre": 1000000,
                                                "minOddPre": 0,
                                                "maxOddLive": 1000000,
                                                "minOddLive": 0,
                                                "minscoreHome": 0,
                                                "maxscoreHome": 100,
                                                "minscoreAway": 0,
                                                "maxscoreAway": 100,
                                                "min_total_goal": 0,
                                                "max_total_goal": 100,
                                                "minTime": 0,
                                                "maxTime": 150,
                                                "matchStatus": 0,
                                                "alertName": null,
                                                "minonHome": 0,
                                                "maxonHome": 100,
                                                "minoffHome": 0,
                                                "maxoffHome": 100,
                                                "minonAway": 0,
                                                "maxonAway": 100,
                                                "minoffAway": 0,
                                                "maxoffAway": 100,
                                                "min_profit": -1000,
                                                "max_profit": 1000000000,
                                                "stop_loss": false,
                                                "tradingMode": false
                                            }
                                            if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                                triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                                triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                                triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                            }
                                            if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                                triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                            }
                                            if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                                triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                            }
                                            if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                                triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                            }
                                            if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                                triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                            }
                                            if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                                triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                            }
                                            if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                                triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                                triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                                triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                            }
                                            if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                                triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                            }
                                            if(self.cashoutTable[k].MatchStatus.value != null){
                                                triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                            }
                                            if(self.cashoutTable[k].Alert_Name.value != null){
                                                triger.alertName = self.cashoutTable[k].Alert_Name.value
                                            }
                                            if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                                triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                            }
                                            if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                                triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                            }
                                            if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                                triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                            }
                                            if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                                triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                            }
                                            if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                                triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                            }
                                            if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                                triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                            }
                                            if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                                triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                            }
                                            if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                                triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                            }
                                            if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                                triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                            }
                                            if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                                triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                            }
                                            if(self.cashoutTable[k].stop_loss.value != false){
                                                triger.stop_loss = true
                                            }
                                            if(self.cashoutTable[k].tradingMode.value != false){
                                                triger.tradingMode = true
                                            }
                                            for(let j = 0; j < self.mainList.length; j++){
                                                if(eventId == self.mainList[j].eventId){
                                                    if (self.mainList[j].DailyApiEvents1.length == 0)
                                                        continue
                                                    let eventTriger = {
                                                        "name": self.selectedLabel,
                                                        "oddPre": null,
                                                        "oddLive": null,
                                                        "scoreHome": 0,
                                                        "scoreAway": 0,
                                                        "total_goal": 0,
                                                        "min_total_goal": 0,
                                                        "max_total_goal": 0,
                                                        "time": 0,
                                                        "matchStatus": null,
                                                        "alertName": self.cashoutAlertName,
                                                        "onHome": 0,
                                                        "offHome": 0,
                                                        "onAway": 0,
                                                        "offAway": 0,
                                                        "c_color": "green",
                                                        "profit": parseFloat(this.currentPercent),
                                                        "stop_loss": self.stopLoss,
                                                        "tradingMode": self.tradingMode
                                                    }
                                                    let eventNode = self.mainList[j]
                                                    if(eventNode.score){
                                                        let scoreDetail = eventNode.score
                                                        eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                        eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                        eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                    }
                                                    if(eventNode.status){
                                                        eventTriger.matchStatus = 1
                                                        eventTriger.time = eventNode.timeElapsed
                                                    }
                                                    else if(!eventNode.status){
                                                        eventTriger.matchStatus = 0
                                                    }
                                                    for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                        let marketNode = self.mainList[j].markets[c]
                                                        let check = 0
                                                        if(marketNode.marketType == marketType){
                                                            if(marketNode.state){
                                                                if(marketNode.state.status == "CLOSED"){
                                                                    eventTriger.matchStatus = 0
                                                                    check = 1
                                                                }
                                                            }
                                                            if(check === 0){
                                                                let runnerNode = marketNode.runners[team]
                                                                let prematchMarket = null
                                                                if(self.mainList[j].markets[c].prematchMarket){
                                                                    prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                                }
                                                                if(eventNode.status && prematchMarket != null){
                                                                    let runnerlists = prematchMarket.runners[team]
                                                                    if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                    }
                                                                    if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        if(runnerNo == 0){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                        }
                                                                    }
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        if(runnerNo == 1){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                        }
                                                                    }
                                                                }
                                                                if(runnerNo == 0){
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    let liveStatsNode = self.mainList[j].livestatus
                                                    let liveNode = liveStatsNode.stats
                                                    if(liveStatsNode.stats){
                                                        if(liveStatsNode.stats.length > 1){
                                                            if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                                if(liveStatsNode.stats[0].shots != null){
                                                                    eventTriger.onHome = liveNode[0].shots.ongoal
                                                                    eventTriger.offHome = liveNode[0].shots.offgoal
                                                                    eventTriger.onAway = liveNode[1].shots.ongoal
                                                                    eventTriger.offAway = liveNode[1].shots.offgoal
                                                                }
                                                            }
                                                            else{
                                                                if(liveStatsNode.stats[1].shots != null){
                                                                    eventTriger.onHome = liveNode[1].shots.ongoal
                                                                    eventTriger.offHome = liveNode[1].shots.offgoal
                                                                    eventTriger.onAway = liveNode[0].shots.ongoal
                                                                    eventTriger.offAway = liveNode[0].shots.offgoal
                                                                }
                                                            }
                                                        }
                                                    }
                                                    //console.log('****************************cash out message check cond= >', triger)
                                                    //console.log('****************************cash out message check value= >', eventTriger)
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                                if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                    if(triger.alertName == eventTriger.alertName){
                                                                                                        this.percentTextColor1 = '#000'
                                                                                                        this.percentBackgroundColor = '#ffc000'
                                                                                                        this.percent_text1 = 'Cash Out Now! '
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else if(this.currentPercent < 0){
                            this.percentTextColor = '#b80101'
                            this.percentTextColor1 = '#b80101'
                            this.percentBackgroundColor = '#ffc7ce'
                            this.percentBackgroundColor1 = '#ffc7ce'
                            this.percent_text1 = 'Current Profit:'
                            this.percent_text2 = this.currentPercent.toString() + '%'

                            let timeRecord = this.timeRecord
                            let MG = timeRecord.substring(0, timeRecord.length)

                            if(MG =='' ){
                                MG = '0'
                            }

                            //console.log('XXXXXXXXXX',MG,this.riskTrading,this.stopLoss,this.tradingMode,this.currentPercent,this.adminTable[0].facile.SLN)

                            if(this.riskTrading == 'easy'){
                                if(parseInt(MG) > this.adminTable[0].facile.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].facile.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].facile.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].facile.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'medium'){
                                if(parseInt(MG) > this.adminTable[0].medio.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].medio.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].medio.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].medio.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'risky'){
                                if(parseInt(MG) > this.adminTable[0].elevato.MG && this.stopLoss == true && this.tradingMode == false && this.currentPercent < this.adminTable[0].elevato.SLN * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                                else if(parseInt(MG) > this.adminTable[0].elevato.MG && this.tradingMode == true && this.stopLoss == true && this.currentPercent < this.adminTable[0].elevato.SLT * (-1)){
                                    this.percentTextColor1 = '#000'
                                    this.percentBackgroundColor = '#ffc000'
                                    this.percent_text1 = 'Cash Out Now! '
                                }
                            }
                            else if(this.riskTrading == 'auto'){
                                //console.log("===>auto Trading Check==>", val1)
                                let val1 = this.selectedValue
                                let eventId = parseInt(val1.split(',')[1])
                                let marketType = val1.split(',')[2]
                                let team = val1.split(',')[3]
                                let runnerNo = val1.split(',')[6]
                                let pred = ""
                                let self = this
                                if(marketType == 'MATCH_ODDS'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- 1 - Back'
                                        }
                                        else{
                                            pred = '- 1 - Lay'
                                        }
                                    }
                                    else if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- 2 - Back'
                                        }
                                        else{
                                            pred = '- 2 - Lay'
                                        }
                                    }
                                    else if(team == '2'){
                                        if(runnerNo == '0'){
                                            pred = '- X - Back'
                                        }
                                        else{
                                            pred = '- X - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_05'){
                                    if(team == '1'){
                                        if(runnerNo == '0'){
                                            pred = '- O 0.5 - Back'
                                        }
                                        else{
                                            pred = '- O 0.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_15'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 1.5 - Back'
                                        }
                                        else{
                                            pred = '- U 1.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 1.5 - Back'
                                        }
                                        else{
                                            pred = '- O 1.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_25'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 2.5 - Back'
                                        }
                                        else{
                                            pred = '- U 2.5 - Lay'
                                        }
                                    }
                                    else{
                                        if(runnerNo == '0'){
                                            pred = '- O 2.5 - Back'
                                        }
                                        else{
                                            pred = '- O 2.5 - Lay'
                                        }
                                    }
                                }
                                else if(marketType == 'OVER_UNDER_35'){
                                    if(team == '0'){
                                        if(runnerNo == '0'){
                                            pred = '- U 3.5 - Back'
                                        }
                                        else{
                                            pred = '- U 3.5 - Lay'
                                        }
                                    }
                                }
                                let predT = self.pred_type_list.filter(function(item) {
                                    return item.label == pred
                                })
                                //console.log('predT====>', predT, pred, self.cashoutTable)
                                if(predT.length > 0){
                                    for(let k = 0 ; k < self.cashoutTable.length ; k++){
                                        if(predT[0].value == self.cashoutTable[k].PredType.value){
                                            let triger = {
                                                "maxOddPre": 1000000,
                                                "minOddPre": 0,
                                                "maxOddLive": 1000000,
                                                "minOddLive": 0,
                                                "minscoreHome": 0,
                                                "maxscoreHome": 100,
                                                "minscoreAway": 0,
                                                "maxscoreAway": 100,
                                                "min_total_goal": 0,
                                                "max_total_goal": 100,
                                                "minTime": 0,
                                                "maxTime": 150,
                                                "matchStatus": 0,
                                                "alertName": null,
                                                "minonHome": 0,
                                                "maxonHome": 100,
                                                "minoffHome": 0,
                                                "maxoffHome": 100,
                                                "minonAway": 0,
                                                "maxonAway": 100,
                                                "minoffAway": 0,
                                                "maxoffAway": 100,
                                                "min_profit": -1000,
                                                "max_profit": 1000000000,
                                                "stop_loss": false,
                                                "tradingMode": false
                                            }
                                            if(self.cashoutTable[k].maxOddpre.value != null && self.cashoutTable[k].maxOddpre.value != ""){
                                                triger.maxOddPre = parseFloat(self.cashoutTable[k].maxOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddpre.value != null && self.cashoutTable[k].minOddpre.value != ""){
                                                triger.minOddPre = parseFloat(self.cashoutTable[k].minOddpre.value)
                                            }
                                            if(self.cashoutTable[k].minOddlive.value != null && self.cashoutTable[k].minOddlive.value != ""){
                                                triger.minOddLive = parseFloat(self.cashoutTable[k].minOddlive.value)
                                            }
                                            if(self.cashoutTable[k].maxoddlive.value != null && self.cashoutTable[k].maxoddlive.value != ""){
                                                triger.maxOddLive = parseFloat(self.cashoutTable[k].maxoddlive.value)
                                            }
                                            if(self.cashoutTable[k].min_score_home.value != null && self.cashoutTable[k].min_score_home.value != ""){
                                                triger.minscoreHome = parseFloat(self.cashoutTable[k].min_score_home.value)
                                            }
                                            if(self.cashoutTable[k].max_score_home.value != null && self.cashoutTable[k].max_score_home.value != ""){
                                                triger.maxscoreHome = parseFloat(self.cashoutTable[k].max_score_home.value)
                                            }
                                            if(self.cashoutTable[k].min_score_away.value != null && self.cashoutTable[k].min_score_away.value != ""){
                                                triger.minscoreAway = parseFloat(self.cashoutTable[k].min_score_away.value)
                                            }
                                            if(self.cashoutTable[k].max_score_away.value != null && self.cashoutTable[k].max_score_away.value != ""){
                                                triger.maxscoreAway = parseFloat(self.cashoutTable[k].max_score_away.value)
                                            }
                                            if(self.cashoutTable[k].min_total_goal.value != null && self.cashoutTable[k].min_total_goal.value != ""){
                                                triger.min_total_goal = parseFloat(self.cashoutTable[k].min_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].max_total_goal.value != null && self.cashoutTable[k].max_total_goal.value != ""){
                                                triger.max_total_goal = parseFloat(self.cashoutTable[k].max_total_goal.value)
                                            }
                                            if(self.cashoutTable[k].min_time.value != null && self.cashoutTable[k].min_time.value != ""){
                                                triger.minTime = parseInt(self.cashoutTable[k].min_time.value)
                                            }
                                            if(self.cashoutTable[k].max_time.value != null && self.cashoutTable[k].max_time.value != ""){
                                                triger.maxTime = parseInt(self.cashoutTable[k].max_time.value)
                                            }
                                            if(self.cashoutTable[k].MatchStatus.value != null){
                                                triger.matchStatus = self.cashoutTable[k].MatchStatus.value
                                            }
                                            if(self.cashoutTable[k].Alert_Name.value != null){
                                                triger.alertName = self.cashoutTable[k].Alert_Name.value
                                            }
                                            if(self.cashoutTable[k].min_on_home.value != null && self.cashoutTable[k].min_on_home.value != ""){
                                                triger.minonHome = parseInt(self.cashoutTable[k].min_on_home.value)
                                            }
                                            if(self.cashoutTable[k].max_on_home.value != null && self.cashoutTable[k].max_on_home.value != ""){
                                                triger.maxonHome = parseInt(self.cashoutTable[k].max_on_home.value)
                                            }
                                            if(self.cashoutTable[k].min_off_home.value != null && self.cashoutTable[k].min_off_home.value != ""){
                                                triger.minoffHome = parseInt(self.cashoutTable[k].min_off_home.value)
                                            }
                                            if(self.cashoutTable[k].max_off_home.value != null && self.cashoutTable[k].max_off_home.value != ""){
                                                triger.maxoffHome = parseInt(self.cashoutTable[k].max_off_home.value)
                                            }
                                            if(self.cashoutTable[k].min_on_away.value != null && self.cashoutTable[k].min_on_away.value != ""){
                                                triger.minonAway = parseInt(self.cashoutTable[k].min_on_away.value)
                                            }
                                            if(self.cashoutTable[k].max_on_away.value != null && self.cashoutTable[k].max_on_away.value != ""){
                                                triger.maxonAway = parseInt(self.cashoutTable[k].max_on_away.value)
                                            }
                                            if(self.cashoutTable[k].min_off_away.value != null && self.cashoutTable[k].min_off_away.value != ""){
                                                triger.minoffAway = parseInt(self.cashoutTable[k].min_off_away.value)
                                            }
                                            if(self.cashoutTable[k].max_off_away.value != null && self.cashoutTable[k].max_off_away.value != ""){
                                                triger.maxoffAway = parseInt(self.cashoutTable[k].max_off_away.value)
                                            }
                                            if(self.cashoutTable[k].min_profit.value != null && self.cashoutTable[k].min_profit.value != ""){
                                                triger.min_profit = parseFloat(self.cashoutTable[k].min_profit.value)
                                            }
                                            if(self.cashoutTable[k].max_profit.value != null && self.cashoutTable[k].max_profit.value != ""){
                                                triger.max_profit = parseFloat(self.cashoutTable[k].max_profit.value)
                                            }
                                            if(self.cashoutTable[k].stop_loss.value != false){
                                                triger.stop_loss = true
                                            }
                                            if(self.cashoutTable[k].tradingMode.value != false){
                                                triger.tradingMode = true
                                            }
                                            for(let j = 0; j < self.mainList.length; j++){
                                                if(eventId == self.mainList[j].eventId){
                                                    if (self.mainList[j].DailyApiEvents1.length == 0)
                                                        continue
                                                    let eventTriger = {
                                                        "name": self.selectedLabel,
                                                        "oddPre": null,
                                                        "oddLive": null,
                                                        "scoreHome": 0,
                                                        "scoreAway": 0,
                                                        "total_goal": 0,
                                                        "min_total_goal": 0,
                                                        "max_total_goal": 0,
                                                        "time": 0,
                                                        "matchStatus": null,
                                                        "alertName": self.cashoutAlertName,
                                                        "onHome": 0,
                                                        "offHome": 0,
                                                        "onAway": 0,
                                                        "offAway": 0,
                                                        "c_color": "green",
                                                        "profit": parseFloat(this.currentPercent),
                                                        "stop_loss": self.stopLoss,
                                                        "tradingMode": self.tradingMode
                                                    }
                                                    let eventNode = self.mainList[j]
                                                    if(eventNode.score){
                                                        let scoreDetail = eventNode.score
                                                        eventTriger.scoreHome = parseInt(scoreDetail.home.score)
                                                        eventTriger.scoreAway = parseInt(scoreDetail.away.score)
                                                        eventTriger.total_goal = parseInt(scoreDetail.home.score) + parseInt(scoreDetail.away.score)
                                                    }
                                                    if(eventNode.status){
                                                        eventTriger.matchStatus = 1
                                                        eventTriger.time = eventNode.timeElapsed
                                                    }
                                                    else if(!eventNode.status){
                                                        eventTriger.matchStatus = 0
                                                    }
                                                    for(let c = 0 ; c < self.mainList[j].markets.length; c++){
                                                        let marketNode = self.mainList[j].markets[c]
                                                        let check = 0
                                                        if(marketNode.marketType == marketType){
                                                            if(marketNode.state){
                                                                if(marketNode.state.status == "CLOSED"){
                                                                    eventTriger.matchStatus = 0
                                                                    check = 1
                                                                }
                                                            }
                                                            if(check === 0){
                                                                let runnerNode = marketNode.runners[team]
                                                                let prematchMarket = null
                                                                if(self.mainList[j].markets[c].prematchMarket){
                                                                    prematchMarket = self.mainList[j].markets[c].prematchMarket
                                                                }
                                                                if(eventNode.status && prematchMarket != null){
                                                                    let runnerlists = prematchMarket.runners[team]
                                                                    if(runnerNo == 0 && runnerlists.exchange && runnerlists.exchange.availableToBack){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToBack[0].price
                                                                    }
                                                                    if(runnerNo == 1 && runnerlists.exchange.availableToLay[0].price){
                                                                        eventTriger.oddPre = runnerlists.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        if(runnerNo == 0){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToBack[0].price
                                                                        }
                                                                    }
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        if(runnerNo == 1){
                                                                            eventTriger.oddPre = runnerNode.exchange.availableToLay[0].price
                                                                        }
                                                                    }
                                                                }
                                                                if(runnerNo == 0){
                                                                    if(runnerNode.exchange.availableToBack){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToBack[0].price
                                                                    }
                                                                }
                                                                else{
                                                                    if(runnerNode.exchange.availableToLay){
                                                                        eventTriger.oddLive = runnerNode.exchange.availableToLay[0].price
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                    let liveStatsNode = self.mainList[j].livestatus
                                                    let liveNode = liveStatsNode.stats
                                                    if(liveStatsNode.stats){
                                                        if(liveStatsNode.stats.length > 1){
                                                            if(liveStatsNode.stats[0].team_id == self.mainList[j].localTeamId){
                                                                if(liveStatsNode.stats[0].shots != null){
                                                                    eventTriger.onHome = liveNode[0].shots.ongoal
                                                                    eventTriger.offHome = liveNode[0].shots.offgoal
                                                                    eventTriger.onAway = liveNode[1].shots.ongoal
                                                                    eventTriger.offAway = liveNode[1].shots.offgoal
                                                                }
                                                            }
                                                            else{
                                                                if(liveStatsNode.stats[1].shots != null){
                                                                    eventTriger.onHome = liveNode[1].shots.ongoal
                                                                    eventTriger.offHome = liveNode[1].shots.offgoal
                                                                    eventTriger.onAway = liveNode[0].shots.ongoal
                                                                    eventTriger.offAway = liveNode[0].shots.offgoal
                                                                }
                                                            }
                                                        }
                                                    }
                                                    //console.log('****************************cash out message check cond= >', triger)
                                                    //console.log('****************************cash out message check value= >', eventTriger)
                                                    if(eventTriger.oddPre >= triger.minOddPre && eventTriger.oddPre <= triger.maxOddPre){
                                                        if(eventTriger.oddLive >= triger.minOddLive && eventTriger.oddLive <= triger.maxOddLive){
                                                            if(eventTriger.scoreHome >= triger.minscoreHome && eventTriger.scoreHome <= triger.maxscoreHome){
                                                                if(eventTriger.scoreAway >= triger.minscoreAway && eventTriger.scoreAway <= triger.maxscoreAway){
                                                                    if(eventTriger.total_goal >= triger.min_total_goal && eventTriger.total_goal <= triger.max_total_goal){
                                                                        if(eventTriger.time <= triger.maxTime && eventTriger.time >= triger.minTime){
                                                                            if(eventTriger.onHome >= triger.minonHome && eventTriger.onHome <= triger.maxonHome){
                                                                                if(eventTriger.onAway >= triger.minonAway && eventTriger.onAway <= triger.maxonAway){
                                                                                    if(eventTriger.offHome >= triger.minoffHome && eventTriger.offHome <= triger.maxoffHome){
                                                                                        if(eventTriger.offAway >= triger.minoffAway && eventTriger.offAway <= triger.maxoffAway){
                                                                                            if(eventTriger.profit >= triger.min_profit && eventTriger.profit <= triger.max_profit){
                                                                                                if(eventTriger.stop_loss == triger.stop_loss && eventTriger.tradingMode == triger.tradingMode){
                                                                                                    if(triger.alertName == eventTriger.alertName){
                                                                                                        this.percentTextColor1 = '#000'
                                                                                                        this.percentBackgroundColor = '#ffc000'
                                                                                                        this.percent_text1 = 'Cash Out Now! '
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    }
                }
                else{
                    this.max_profit = 0
                    this.max_lose = 0
                    this.guad_max = 0
                    this.percent_text1 = ''
                    this.percent_text2 = this.$t('Insert Odd and Stake')
                    this.guad_att = 0
                    this.percentTextColor = '#20a052'
                    this.percentTextColor1 = '#20a052'
                    this.percentBackgroundColor = '#d8e4bc'
                    this.percentBackgroundColor1 = '#d8e4bc'
                }
            },
            bookmaker_fee(val){
                this.bookmarkerFee = val
                this.odd_calc(this.calc_odd)
                this.cs_profit_calc()
                //console.log(val)
            },
            stopLossfunction(val){
                this.stopLoss = val
                this.odd_calc(this.calc_odd)
                //console.log('stoplossVal', val)
            },
            tradingModefunction(val){
                this.tradingMode = val
                if(val === false){
                    this.cashoutAlertName = "OFF"
                    this.alert_key = "OFF"
                }
                else{
                    if(this.alertNameList.length > 0){
                        this.cashoutAlertName = this.alertNameList[0].label
                    }
                }
                this.stake_calc(this.calc_stake)
                //console.log('tradingModeVal', val)
            },
            riskMode(val){
                if(val == '0'){
                    this.riskTrading = 'easy'
                }
                else if(val == '1'){
                    this.riskTrading = 'medium'
                }
                else if(val == '2'){
                    this.riskTrading = 'risky'
                }
                else if(val == '3'){
                    this.riskTrading = 'auto'
                }
                //console.log("risk mode ===>", val)
                this.odd_calc(this.calc_odd)
            },
            cashOut1(val){
                this.low_cash = val
                this.cash_out = false
                this.high_cash = false
                //console.log('low=>', this.low_cash, this.cash_out, this.high_cash)
            },
            cashOut2(val){
                this.cash_out = val
                this.low_cash = false
                this.high_cash = false

                this.net_profit1 = this.guad_att
                this.net_profit2 = this.guad_att

                if(parseInt(this.selectedArray[6]) == 0){
                    if(this.back != '' && this.back != 0){
                        this.stakeCashout = (this.calc_odd* this.calc_stake/this.lay).toFixed(2)
                    }
                    else{
                        this.stakeCashout = 0
                    }
                }
                else if(parseInt(this.selectedArray[6]) == 1){
                    if(this.back != '' && this.back != 0){
                        this.stakeCashout = (this.calc_odd* this.calc_stake/this.back).toFixed(2)
                    }
                    else{
                        this.stakeCashout = 0
                    }
                }
                //console.log('cashOut=>', this.low_cash, this.cash_out, this.high_cash)
            },
            cashOut3(val){
                this.high_cash = val
                this.cash_out = false
                this.low_cash = false
                //console.log('high=>', this.low_cash, this.cash_out, this.high_cash)
            },
            //    cold stats scripts  //
            home_lineup_refresh(val){
                //console.log('refresh final data check==!', val, this.lineup_home_id, this.lineup_away_id)
                if(val != '0'){
                    let c_home_id = this.lineup_home_id
                    let c_away_id = this.lineup_away_id
                    let main_data = this.coldstatsdata

                    let start_date4 = new Date();
                    let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                    next_date4 = new Date(next_date4).toISOString()
                    next_date4 = next_date4.substring(0,10)

                    for(let j = 0; j < main_data.length ; j++){
                        if(main_data[j].events.length > 0){
                            let home = {
                                p:0,
                                name:'',
                                rank: '',
                                z_z: 0,
                                over15: 0,
                                over25:0,
                                over35:0,
                                scored:0,
                                conc:0,
                                average1:0,
                                average2:0,
                                bts:0,
                                first1:0,
                                first2:0,
                                second1:0,
                                second2:0,
                                time15_S:0,
                                time30_S:0,
                                time45_S:0,
                                time60_S:0,
                                time75_S:0,
                                time90_S:0,
                                time15_C:0,
                                time30_C:0,
                                time45_C:0,
                                time60_C:0,
                                time75_C:0,
                                time90_C:0,
                                gs1:0,
                                gs2:0,
                                gc1:0,
                                gc2:0,
                                over40:0,
                                over85:0,
                                C_H:0,
                                C_D:0,
                                C_A:0,
                                first10:0,
                                first11:0,
                                first20:0,
                                second01:0,
                                second11:0,
                                second02:0,
                                firstGoal:0,
                                lastGoal:0,
                                secondplus:0,
                                secondminus:0,
                                homefirst:0,
                                drawfirst:0,
                                awayfirst:0,
                                homesecond:0,
                                drawsecond:0,
                                awaysecond:0,
                                eventdays:['All'],
                                pos:0,
                                h_a:0,
                                swing1:'',
                                FH:0,
                                swing2:'',
                                SH:0,
                                swing3:'',
                                attack:0,
                                defense:0,
                                form:0,
                                form_H_A:0

                            }
                            let away = this.away_team
                            let homeTeamId = main_data[j].localTeamId
                            let awayTeamId = main_data[j].visitorTeamId
                            if(homeTeamId == c_home_id && awayTeamId == c_away_id){
                                let seasonId = main_data[j].season_id
                                // home.pos = main_data[j].standing.localteam_position
                                // home.h_a = this.H_A_calculation(seasonId, homeTeamId, 'home')
                                // let swing1 = (away.pos - away.h_a) - (home.pos - home.h_a)
                                // if(swing1 > 0){
                                //     away.swing1 = '+'+swing1
                                //     home.swing1 =''
                                // }
                                // else if(swing1 < 0){
                                //     away.swing1 =''
                                //     home.swing1 = '+'+swing1*(-1)
                                // }
                                // if((home.pos > home.h_a && away.pos > away.h_a) || (home.pos < home.h_a && away.pos < away.h_a)){
                                //     away.swing1 =''
                                //     home.swing1 =''
                                // }
                                //
                                // home.FH = this.FH_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '4', val)
                                // let swing2 =(away.pos - away.FH) -  (home.pos - home.FH)
                                // if(swing2 > 0){
                                //     away.swing2 = '+'+swing2
                                //     home.swing2 =''
                                // }
                                // else if(swing2 < 0){
                                //     away.swing2 =''
                                //     home.swing2 = '+'+swing2*(-1)
                                // }
                                // if((home.pos > home.FH && away.pos > away.FH) || (home.pos < home.FH && away.pos < away.FH)){
                                //     away.swing2 =''
                                //     home.swing2 =''
                                // }
                                //
                                // home.SH = this.SH_calculation(main_data[j].events, main_data[j].localTeamId,seasonId, 'home', next_date4, '4', val)
                                // let swing3 =(away.pos - away.SH) -  (home.pos - home.SH)
                                // if(swing3 > 0){
                                //     away.swing3 = '+'+swing3
                                //     home.swing3 =''
                                // }
                                // else if(swing3 < 0){
                                //     away.swing3 =''
                                //     home.swing3 = '+'+swing3*(-1)
                                // }
                                // if((home.pos > home.SH && away.pos > away.SH) || (home.pos < home.SH && away.pos < away.SH)){
                                //     away.swing3 =''
                                //     home.swing3 =''
                                // }
                                //
                                // home.attack = this.attack_calculation(seasonId, homeTeamId, 'home')
                                // home.defense = this.defense_calculation(seasonId, homeTeamId, 'home')
                                // home.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '4', val)
                                // home.form = this.Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, next_date4, '2')
                                home.p = this.p_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                home.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.over15 = (this.over15_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.over25 = (this.over25_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.over35 = (this.over35_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.scored = (this.scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.conc = (this.concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.001)*100).toFixed(0)
                                home.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)).toFixed(2)
                                home.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)).toFixed(2)
                                if(this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val) == 0){home.average1 = 0;}
                                if(this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val) == 0){home.average2 = 0;}
                                home.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                home.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90,  '4', val)/(home.p + 0.0001)*100).toFixed(0)
                                let hgs1 = this.scored_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                let hgs2 = this.scored_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                home.gs1 = (hgs1/(hgs1 + hgs2)*100).toFixed(0)
                                home.gs2 = (hgs2/(hgs1 + hgs2)*100).toFixed(0)
                                if((hgs1 + hgs2) == 0){home.gs1 = 0; home.gs2 = 0}
                                let hgc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                let hgc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                home.gc1 = (hgc1/(hgc1 + hgc2)*100).toFixed(0)
                                home.gc2 = (hgc2/(hgc1 + hgc2)*100).toFixed(0)
                                if((hgc1 + hgc2) == 0){home.gc1 = 0; home.gc2 = 0}
                                home.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45,  '4', val)/(home.p)*100).toFixed(0)
                                home.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90,  '4', val)/(home.p)*100).toFixed(0)
                                home.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)

                                home.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                if(home.p == 0){home.over40 = 0; home.over85 = 0; home.C_H = 0; home.C_D = 0; home.C_A = 0; home.lastGoal = 0}
                                home.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                home.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2')/(home.first10)*100).toFixed(0)
                                home.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.first10)*100).toFixed(0)
                                if(home.first10 == 0){home.first11 = 0; home.first20 = 0}
                                home.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)
                                home.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.second01)*100).toFixed(0)
                                home.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.second01)*100).toFixed(0)
                                if(home.second01 == 0){home.second11 = 0; home.second02 = 0}
                                home.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                home.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4,  '4', val)/(home.p)*100).toFixed(0)
                                if(home.p == 0){home.secondplus = 0; home.secondminus = 0; home.homefirst = 0; home.drawfirst = 0; home.awayfirst = 0; home.homesecond = 0; home.drawsecond = 0; home.awaysecond = 0}

                                let home_name = this.item3.home.name
                                let home_rank = this.item3.home.rank
                                let away_name = this.item3.away.name
                                let away_rank = this.item3.away.rank
                                let home_pos = this.item3.home.pos
                                let home_h_a = this.item3.home.h_a
                                let home_swing1 = this.item3.home.swing1
                                let home_FH = this.item3.home.FH
                                let home_swing2 = this.item3.home.swing2
                                let home_SH = this.item3.home.SH
                                let home_swing3 = this.item3.home.swing3
                                let home_attack = this.item3.home.attack
                                let home_defense = this.item3.home.defense
                                let home_form_H_A = this.item3.home.form_H_A
                                let home_form = this.item3.home.form

                                this.item3.home = home
                                this.item3.away = away
                                this.item3.home.name = home_name
                                this.item3.home.rank = home_rank
                                this.item3.away.name = away_name
                                this.item3.away.rank = away_rank

                                this.item3.home.pos = home_pos
                                this.item3.home.h_a = home_h_a
                                this.item3.home.swing1 = home_swing1
                                this.item3.home.FH = home_FH
                                this.item3.home.swing2 = home_swing2
                                this.item3.home.SH = home_SH
                                this.item3.home.swing3 = home_swing3
                                this.item3.home.attack = home_attack
                                this.item3.home.defense = home_defense
                                this.item3.home.form_H_A = home_form_H_A
                                this.item3.home.form = home_form
                            }
                        }
                    }
                }
                else{
                    let data = this.item_X
                    let ranks = {"from": 0, "to": 50}
                    this.home_rank_refresh(ranks, data)
                }
            },
            away_lineup_refresh(val){
                //console.log('refresh final data check==!', val)
                if(val != '0'){
                    let c_home_id = this.lineup_home_id
                    let c_away_id = this.lineup_away_id
                    let main_data = this.coldstatsdata

                    let start_date4 = new Date();
                    let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                    next_date4 = new Date(next_date4).toISOString()
                    next_date4 = next_date4.substring(0,10)

                    for(let j = 0; j < main_data.length ; j++){
                        if(main_data[j].events.length > 0){
                            let away = {
                                p:0,
                                name:'',
                                rank: '',
                                z_z: 0,
                                over15: 0,
                                over25:0,
                                over35:0,
                                scored:0,
                                conc:0,
                                average1:0,
                                average2:0,
                                bts:0,
                                first1:0,
                                first2:0,
                                second1:0,
                                second2:0,
                                time15_S:0,
                                time30_S:0,
                                time45_S:0,
                                time60_S:0,
                                time75_S:0,
                                time90_S:0,
                                time15_C:0,
                                time30_C:0,
                                time45_C:0,
                                time60_C:0,
                                time75_C:0,
                                time90_C:0,
                                gs1:0,
                                gs2:0,
                                gc1:0,
                                gc2:0,
                                over40:0,
                                over85:0,
                                C_H:0,
                                C_D:0,
                                C_A:0,
                                first10:0,
                                first11:0,
                                first20:0,
                                second01:0,
                                second11:0,
                                second02:0,
                                firstGoal:0,
                                lastGoal:0,
                                secondplus:0,
                                secondminus:0,
                                homefirst:0,
                                drawfirst:0,
                                awayfirst:0,
                                homesecond:0,
                                drawsecond:0,
                                awaysecond:0,
                                eventdays:['All'],
                                pos:0,
                                h_a:0,
                                swing1:'',
                                FH:0,
                                swing2:'',
                                SH:0,
                                swing3:'',
                                attack:0,
                                defense:0,
                                form:0,
                                form_H_A:0

                            }
                            let home = this.home_team
                            let homeTeamId = main_data[j].localTeamId
                            let awayTeamId = main_data[j].visitorTeamId

                            if(homeTeamId == c_home_id && awayTeamId == c_away_id){
                                let seasonId = main_data[j].season_id

                                // away.pos = main_data[j].standing.visitorteam_position
                                // away.h_a = this.H_A_calculation(seasonId, awayTeamId, 'away')
                                //
                                // let swing1 = (away.pos - away.h_a) - (home.pos - home.h_a)
                                // if(swing1 > 0){
                                //     away.swing1 = '+'+swing1
                                //     home.swing1 =''
                                // }
                                // else if(swing1 < 0){
                                //     away.swing1 =''
                                //     home.swing1 = '+'+swing1*(-1)
                                // }
                                // if((home.pos > home.h_a && away.pos > away.h_a) || (home.pos < home.h_a && away.pos < away.h_a)){
                                //     away.swing1 =''
                                //     home.swing1 =''
                                // }
                                // away.FH = this.FH_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4, '4', val)
                                //
                                // let swing2 =(away.pos - away.FH) -  (home.pos - home.FH)
                                // if(swing2 > 0){
                                //     away.swing2 = '+'+swing2
                                //     home.swing2 =''
                                // }
                                // else if(swing2 < 0){
                                //     away.swing2 =''
                                //     home.swing2 = '+'+swing2*(-1)
                                // }
                                // if((home.pos > home.FH && away.pos > away.FH) || (home.pos < home.FH && away.pos < away.FH)){
                                //     away.swing2 =''
                                //     home.swing2 =''
                                // }
                                // away.SH = this.SH_calculation(main_data[j].events, main_data[j].visitorTeamId,seasonId, 'away', next_date4,  '4', val)
                                //
                                // let swing3 =(away.pos - away.SH) -  (home.pos - home.SH)
                                // if(swing3 > 0){
                                //     away.swing3 = '+'+swing3
                                //     home.swing3 =''
                                // }
                                // else if(swing3 < 0){
                                //     away.swing3 =''
                                //     home.swing3 = '+'+swing3*(-1)
                                // }
                                // if((home.pos > home.SH && away.pos > away.SH) || (home.pos < home.SH && away.pos < away.SH)){
                                //     away.swing3 =''
                                //     home.swing3 =''
                                // }
                                //
                                // away.attack = this.attack_calculation(seasonId, awayTeamId, 'away')
                                // away.defense = this.defense_calculation(seasonId, awayTeamId, 'away')
                                // away.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4,  '4', val)
                                // away.form = this.Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, next_date4, '2')
                                away.p = this.p_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                away.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.over15 = (this.over15_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.over25 = (this.over25_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.over35 = (this.over35_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.scored = (this.scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.conc = (this.concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.001)*100).toFixed(0)
                                away.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)).toFixed(2)
                                away.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)).toFixed(2)
                                if(this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val) == 0){away.average1 = 0;}
                                if(this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val) == 0){away.average2 = 0;}
                                away.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                away.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90,  '4', val)/(away.p + 0.0001)*100).toFixed(0)
                                let ags1 = this.scored_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                let ags2 = this.scored_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                away.gs1 = (ags1/(ags1 + ags2)*100).toFixed(0)
                                away.gs2 = (ags2/(ags1 + ags2)*100).toFixed(0)
                                if((ags1 + ags2) == 0){away.gs1 = 0 ; away.gs2 = 0}
                                let agc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                let agc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                away.gc1 = (agc1/(agc1 + agc2)*100).toFixed(0)
                                away.gc2 = (agc2/(agc1 + agc2)*100).toFixed(0)
                                if((agc1 + agc2) == 0){away.gc1 = 0 ; away.gc2 = 0}
                                away.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45,  '4', val)/(away.p)*100).toFixed(0)
                                away.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90,  '4', val)/(away.p)*100).toFixed(0)
                                away.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                if(away.p == 0){away.over40 = 0; away.over85 = 0; away.C_H = 0; away.C_D = 0; away.C_A = 0; away.lastGoal = 0}
                                away.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                away.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.first10)*100).toFixed(0)
                                away.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.first10)*100).toFixed(0)
                                if(away.first10 == 0){away.first11 = 0; away.first20 = 0}
                                away.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)
                                away.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.second01)*100).toFixed(0)
                                away.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.second01)*100).toFixed(0)
                                if(away.second01 == 0){away.second11 = 0; away.second02 = 0}
                                away.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                away.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4,  '4', val)/(away.p)*100).toFixed(0)
                                if(away.p == 0){away.secondplus = 0; away.secondminus = 0; away.homefirst = 0; away.drawfirst = 0; away.awayfirst = 0; away.homesecond = 0; away.drawsecond = 0; away.awaysecond = 0}

                                let home_name = this.item3.home.name
                                let home_rank = this.item3.home.rank
                                let away_name = this.item3.away.name
                                let away_rank = this.item3.away.rank
                                let home_pos = this.item3.away.pos
                                let home_h_a = this.item3.away.h_a
                                let home_swing1 = this.item3.away.swing1
                                let home_FH = this.item3.away.FH
                                let home_swing2 = this.item3.away.swing2
                                let home_SH = this.item3.away.SH
                                let home_swing3 = this.item3.away.swing3
                                let home_attack = this.item3.away.attack
                                let home_defense = this.item3.away.defense
                                let home_form_H_A = this.item3.away.form_H_A
                                let home_form = this.item3.away.form

                                this.item3.home = home
                                this.item3.away = away
                                this.item3.home.name = home_name
                                this.item3.home.rank = home_rank
                                this.item3.away.name = away_name
                                this.item3.away.rank = away_rank

                                this.item3.away.pos = home_pos
                                this.item3.away.h_a = home_h_a
                                this.item3.away.swing1 = home_swing1
                                this.item3.away.FH = home_FH
                                this.item3.away.swing2 = home_swing2
                                this.item3.away.SH = home_SH
                                this.item3.away.swing3 = home_swing3
                                this.item3.away.attack = home_attack
                                this.item3.away.defense = home_defense
                                this.item3.away.form_H_A = home_form_H_A
                                this.item3.away.form = home_form

                            }
                        }
                    }
                }
                else{
                    let data = this.item_X
                    let ranks = {"from": 0, "to": 50}
                    this.away_rank_refresh(ranks, data)
                }
            },
            FH_red(val){
                this.red_FH_check = val
                let home_id = this.item_X.home_id
                let away_id = this.item_X.away_id
                let temp =  JSON.stringify(this.mainData)
                let  main_data = JSON.parse(temp)
                //console.log('main_data', main_data)
                let bc_data = []
                this.home_date_list = []
                this.away_date_list = []
                let home_date_index = 0
                let away_date_list = 0
                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){
                        if(this.item_X.home_id === main_data[j].localTeamId && this.item_X.away_id === main_data[j].visitorTeamId){
                            bc_data = main_data[j].events
                            for(let p = 0 ; p < main_data[j].events.length ; p++){
                                for(let pp = 0 ; pp < main_data[j].events[p].events.length ; pp++){
                                    if(this.item_X.home_id === main_data[j].events[p].events[pp].localteamId){
                                        home_date_index++
                                        this.home_date_list.push({"date": main_data[j].events[p].events[pp].date, "value": home_date_index, "label": home_date_index})
                                    }
                                    if(this.item_X.away_id === main_data[j].events[p].events[pp].visitorteamId){
                                        away_date_list++
                                        this.away_date_list.push({"date": main_data[j].events[p].events[pp].date, "value": away_date_list, "label": away_date_list})
                                    }
                                }
                            }
                        }
                    }
                }
                //console.log('date list check ===>', this.home_date_list, this.away_date_list)
                let self = this
                this.sortJSON(self.home_date_list,'date', '123');
                this.sortJSON(self.away_date_list,'date', '123');
                for(let i = 0 ; i < bc_data.length; i++){
                    for(let j = 0 ; j < bc_data[i].redCards.length ; j++){
                        if(this.red_FH_check === true && bc_data[i].redCards[j].redFH > 0){
                            if(home_id === bc_data[i].redCards[j].localteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }

                                let index1 = this.home_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.home_date_list.splice(index1, 1)

                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                            }
                            if(away_id === bc_data[i].redCards[j].visitorteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }

                                let index1 = this.away_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.away_date_list.splice(index1, 1)

                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                            }
                        }
                        if(this.red_SH_check === true && bc_data[i].redCards[j].redSH > 0){
                            if(home_id === bc_data[i].redCards[j].localteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }

                                let index1 = this.home_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.home_date_list.splice(index1, 1)

                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                            }
                            if(away_id === bc_data[i].redCards[j].visitorteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }

                                let index1 = this.away_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.away_date_list.splice(index1, 1)

                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                            }
                        }
                    }
                }
                this.basic_data = bc_data
                this.refresh_calculation(this.item_X, this.home_date_list[0].date, this.away_date_list[0].date, this.basic_data)
            },
            SH_red(val){
                this.red_SH_check = val
                let home_id = this.item_X.home_id
                let away_id = this.item_X.away_id
                let temp =  JSON.stringify(this.mainData)
                let  main_data = JSON.parse(temp)
                let bc_data = []

                this.home_date_list = []
                this.away_date_list = []
                let home_date_index = 0
                let away_date_list = 0
                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){
                        if(this.item_X.home_id === main_data[j].localTeamId && this.item_X.away_id === main_data[j].visitorTeamId){
                            bc_data = main_data[j].events
                            for(let p = 0 ; p < main_data[j].events.length ; p++){
                                for(let pp = 0 ; pp < main_data[j].events[p].events.length ; pp++){
                                    if(this.item_X.home_id === main_data[j].events[p].events[pp].localteamId){
                                        home_date_index++
                                        this.home_date_list.push({"date": main_data[j].events[p].events[pp].date, "value": home_date_index, "label": home_date_index})
                                    }
                                    if(this.item_X.away_id === main_data[j].events[p].events[pp].visitorteamId){
                                        away_date_list++
                                        this.away_date_list.push({"date": main_data[j].events[p].events[pp].date, "value": away_date_list, "label": away_date_list})
                                    }
                                }
                            }
                        }
                    }
                }
                //console.log('date list check ===>', this.home_date_list, this.away_date_list)
                let self = this
                this.sortJSON(self.home_date_list,'date', '123');
                this.sortJSON(self.away_date_list,'date', '123');
                for(let i = 0 ; i < bc_data.length; i++){
                    for(let j = 0 ; j < bc_data[i].redCards.length ; j++){
                        if(this.red_FH_check === true && bc_data[i].redCards[j].redFH > 0){
                            if(home_id === bc_data[i].redCards[j].localteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }
                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                                let index1 = this.home_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.home_date_list.splice(index1, 1)
                            }
                            if(away_id === bc_data[i].redCards[j].visitorteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }
                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                                let index1 = this.away_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.away_date_list.splice(index1, 1)
                            }
                        }
                        if(this.red_SH_check === true && bc_data[i].redCards[j].redSH > 0){
                            if(home_id === bc_data[i].redCards[j].localteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }
                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                                let index1 = this.home_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.home_date_list.splice(index1, 1)
                            }
                            if(away_id === bc_data[i].redCards[j].visitorteamId){
                                let index2 = bc_data[i].events.indexOf(bc_data[i].events[j]);
                                if (index2 > -1) {
                                    bc_data[i].events.splice(index2, 1);
                                }
                                let index = bc_data[i].redCards.indexOf(bc_data[i].redCards[j]);
                                if (index > -1) {
                                    bc_data[i].redCards.splice(index, 1);
                                    j = j - 1
                                }
                                let index1 = this.away_date_list.indexOf(bc_data[i].redCards[j].date)
                                this.away_date_list.splice(index1, 1)
                            }
                        }
                    }
                }
                this.basic_data = bc_data
                this.refresh_calculation(this.item_X, this.home_date_list[0].date, this.away_date_list[0].date, this.basic_data)
            },
            refreshCalc(val){
                if(val == 1000){
                    this.refresh_calculation(this.item_X, this.home_date_list[1].date, this.away_date_list[1].date, this.basic_data)
                }
                else{
                    let home_date = ''
                    let away_date = ''
                    for(let i = 0 ; i < this.home_date_list.length ; i++){
                        if(this.home_date_list.length - i == val){
                            home_date = this.home_date_list[i].date
                        }
                    }
                    for(let i = 0 ; i < this.away_date_list.length; i++){
                        if(this.away_date_list.length - i == val){
                            away_date = this.away_date_list[i].date
                        }
                    }
                    //console.log('=====>', this.home_date_list, ', ', this.away_date_list)
                    this.refresh_calculation(this.item_X, home_date, away_date, this.basic_data)
                }
            },
            p_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    //console.log('==>', dir, ranks)
                    for(let i = 0; i < data.length; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks){
                                    p++
                                }
                            }
                        }
                    }
                }

                return p
            },
            percentage_calculation(data){
                let p = 0
                let p1 = 0
                let events = data.events
                let roundId = data.round_id
                let name1 = 0
                let stage_id = 0
                let round_ids = events.filter(function(item) {
                    return item.round_id == roundId;
                });
                if(events.length > 0){
                    if(round_ids.length > 0){
                        name1 = round_ids[0].name
                        stage_id =round_ids[0].stage_id
                        p = (name1/events.length*100).toFixed(0)
                    }

                    for(let i = 0 ; i < events.length ; i++){
                        if(events[i].stage_id !== stage_id && events[i].events.length > 0){
                            p1++
                        }
                    }

                    if(p1 > 0){
                        name1 = name1 + p1
                        p = (name1/events.length*100).toFixed(0)
                    }
                }
                return [p, name1]
            },
            fh_percentage_calculation(data, teamId, dir, date, d, ranks){
                let getDate = new Date();
                let endDate = getDate.setDate(getDate.getDate() + 0);
                endDate = new Date(endDate).toISOString()
                endDate = endDate.substring(0,10)

                let p = 0
                if(d == '0'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    if(home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    if(home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    if(home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    if(home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            sh_percentage_calculation(data, teamId, dir, date, d, ranks){
                let getDate = new Date();
                let endDate = getDate.setDate(getDate.getDate() + 0);
                endDate = new Date(endDate).toISOString()
                endDate = endDate.substring(0,10)

                let p = 0
                if(d == '0'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let sh_home_goal = parseInt(data[i].events[j].ft_score.split("-")[0])
                                    if(sh_home_goal - fh_home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    let sh_away_goal = parseInt(data[i].events[j].ft_score.split("-")[1])
                                    if(sh_away_goal - fh_away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                if(d == '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let sh_home_goal = parseInt(data[i].events[j].ft_score.split("-")[0])
                                    if(sh_home_goal - fh_home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    let sh_away_goal = parseInt(data[i].events[j].ft_score.split("-")[1])
                                    if(sh_away_goal - fh_away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let sh_home_goal = parseInt(data[i].events[j].ft_score.split("-")[0])
                                    if(sh_home_goal - fh_home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    let sh_away_goal = parseInt(data[i].events[j].ft_score.split("-")[1])
                                    if(sh_away_goal - fh_away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let sh_home_goal = parseInt(data[i].events[j].ft_score.split("-")[0])
                                    if(sh_home_goal - fh_home_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null && data[i].events[j].ft_score != null){
                                    let fh_away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    let sh_away_goal = parseInt(data[i].events[j].ft_score.split("-")[1])
                                    if(sh_away_goal - fh_away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            fh_probability_calculation(data, teamId, dir, date, d, ranks){
                let getDate = new Date();
                let endDate = getDate.setDate(getDate.getDate() + 0);
                endDate = new Date(endDate).toISOString()
                endDate = endDate.substring(0,10)

                let p = 0
                if(d == '0'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d == '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].date < endDate && data[i].events[j].hf_score != null){
                                    let home_goal = parseInt(data[i].events[j].hf_score.split("-")[0])
                                    let away_goal = parseInt(data[i].events[j].hf_score.split("-")[1])
                                    if(home_goal > 0 || away_goal > 0){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            zeroTozero_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore == 0 && data[i].events[j].visitorteamSore == 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            over15_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 1)){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            over25_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 2)){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            over35_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && (data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 3)){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            scored_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            concd_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            average_scored_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                    }
                }
                return p
            },
            average_concd_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore > 0){
                                    p = p + data[i].events[j].visitorteamSore
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore > 0){
                                    p = p + data[i].events[j].localteamScore
                                }
                            }
                        }
                    }
                }
                return p
            },
            average_bts_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > 0 && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > 0 && data[i].events[j].visitorteamSore > 0 ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > 0 && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > 0 && data[i].events[j].visitorteamSore > 0 ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore > 0 && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore > 0 && data[i].events[j].visitorteamSore > 0 ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore > 0 && data[i].events[j].localteamScore > 0){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore > 0 && data[i].events[j].visitorteamSore > 0 ){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            FH_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            FH_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute < 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            SH_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            SH_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45){
                                            check++
                                        }
                                    }
                                    if(check > 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            time_scored_calculation(data, teamId, dir, date, time, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == teamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            time_concd_calculation(data, teamId, dir, date, time, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].localteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].localteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].localteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].teamId == data[i].events[j].localteamId && data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 15){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            scored_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            scored_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            concd_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            concd_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 &&  data[i].events[j].goals[k].teamId ==data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            scored_plus_calculation(data, teamId, dir, date, time, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d ==='2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d ==='3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d ==='4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= time && data[i].events[j].goals[k].minute > time - 6){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            win_percentage_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore < data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore > data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore < data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore > data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore < data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore > data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore < data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore > data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            draw_percentage_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore == data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore == data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore == data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore == data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore == data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore == data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore == data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore == data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            loss_percentage_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore > data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore < data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore > data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore < data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore > data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore < data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore > data[i].events[j].localteamScore ){
                                    p++
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore < data[i].events[j].visitorteamSore ){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            one_to_zero_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            one_to_one_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            two_to_one_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].localteamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            zero_to_one_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[0].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            one_to_one2_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[1].teamId == teamId && data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[1].teamId == teamId && data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[1].teamId == teamId && data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[1].teamId == teamId && data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == data[i].events[j].localteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            zero_to_two_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == data[i].events[j].visitorteamId && data[i].events[j].goals[1].teamId == data[i].events[j].visitorteamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 1){
                                        if(data[i].events[j].goals[0].teamId == teamId && data[i].events[j].goals[1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            two_score_ahead_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                return p
            },
            two_score_behind_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(awayteamScore - hometeamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let check = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        let hometeamScore = parseInt(data[i].events[j].goals[k].result.split('-')[0])
                                        let awayteamScore = parseInt(data[i].events[j].goals[k].result.split('-')[1])
                                        if(hometeamScore - awayteamScore >= 2){
                                            check = 1
                                        }
                                    }
                                    if(check == 1){p++}
                                }
                            }
                        }
                    }
                }
                return p
            },
            H_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            D_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            A_1st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute <= 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            H_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum > visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            D_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum == visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            A_2st_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            localScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].visitorteamId){
                                            visitorScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    let localScoreSum = 0
                                    let visitorScoreSum = 0
                                    for(let k = 0 ; k < data[i].events[j].goals.length ; k++){
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == teamId){
                                            visitorScoreSum++
                                        }
                                        if(data[i].events[j].goals[k].minute > 45 && data[i].events[j].goals[k].teamId == data[i].events[j].localteamId){
                                            localScoreSum++
                                        }
                                    }
                                    if(localScoreSum < visitorScoreSum){
                                        p++
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            Last_goal_calculation(data, teamId, dir, date, d, ranks){
                let p = 0
                if(d === '1'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date < date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date < date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].date >= date && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].date >= date && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].awayRank >= ranks.from && data[i].events[j].awayRank <= ranks.to && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].homeRank >= ranks.from && data[i].events[j].homeRank <= ranks.to && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0; i < data.length ; i++){
                        if(dir == 'home'){
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].localteamId == teamId && data[i].events[j].local_formation == ranks && data[i].events[j].visitorteamSore + data[i].events[j].localteamScore > 0){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                        else{
                            for(let j = 0 ; j < data[i].events.length; j++){
                                if(data[i].events[j].visitorteamId == teamId && data[i].events[j].visit_formation == ranks && data[i].events[j].localteamScore + data[i].events[j].visitorteamSore > 0 ){
                                    if(data[i].events[j].goals.length > 0){
                                        if(data[i].events[j].goals[data[i].events[j].goals.length - 1].teamId == teamId){
                                            p++
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                return p
            },
            H_A_calculation(seasonId, teamId, dir){
                let rankArray = []
                let teamPoints = 0
                let rank = 1
                let team_goals_scored = 0
                let team_goals_against = 0
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            if(dir == 'home'){
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].home.won*3 + this.standingList[i].standings[j].home.draw, 'goals_scored': this.standingList[i].standings[j].home.goals_scored, 'goals_against': this.standingList[i].standings[j].home.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    teamPoints =  this.standingList[i].standings[j].home.won*3 + this.standingList[i].standings[j].home.draw
                                    team_goals_scored = this.standingList[i].standings[j].home.goals_scored
                                    team_goals_against = this.standingList[i].standings[j].home.goals_against
                                }
                            }
                            else{
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].away.won*3 + this.standingList[i].standings[j].away.draw, 'goals_scored': this.standingList[i].standings[j].away.goals_scored, 'goals_against': this.standingList[i].standings[j].away.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    teamPoints =  this.standingList[i].standings[j].away.won*3 + this.standingList[i].standings[j].away.draw
                                    team_goals_scored = this.standingList[i].standings[j].away.goals_scored
                                    team_goals_against = this.standingList[i].standings[j].away.goals_against
                                }
                            }
                        }

                        for(let j = 0 ; j < rankArray.length ; j++){
                            if(rankArray[j].points > teamPoints){
                                rank++
                            }
                            if(rankArray[j].points == teamPoints){
                                if((team_goals_scored - team_goals_against) < (rankArray[j].goals_scored - rankArray[j].goals_against)){
                                    rank++
                                }
                            }
                        }
                    }
                }
                if(teamId == 300){
                    //console.log('teamPoints=>',teamPoints)
                }
                return rank
            },
            FH_calculation(data, teamId, seasonId, dir, date, d, ranks){
                let teamIdArray = []
                let rank = 1
                let currentTeamData = {}
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            teamIdArray[j] = this.standingList[i].standings[j].team_id
                        }
                    }
                }
                teamIdArray = Array.from(new Set (teamIdArray))
                let rankArray = []
                if(d === '1'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }

                }
                else if(d === '3'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].awayRank >= ranks.from && data[j].events[k].awayRank <= ranks.to){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].homeRank >= ranks.from && data[j].events[k].homeRank <= ranks.to){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].local_formation == ranks){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].visit_formation == ranks){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute <= 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                for(let i = 0 ; i < rankArray.length ; i++){
                    if(rankArray[i].points > currentTeamData.points){
                        rank++
                    }
                    if(rankArray[i].points == currentTeamData.points){
                        if((rankArray[i].goals_scored - rankArray[i].goals_against) > (currentTeamData.goals_scored - currentTeamData.goals_against)){
                            rank++
                        }
                    }
                }
                return rank
            },
            SH_calculation(data, teamId, seasonId, dir, date, d, ranks){
                let teamIdArray = []
                let rank = 1
                let currentTeamData = {}
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            teamIdArray[j] = this.standingList[i].standings[j].team_id
                        }
                    }
                }
                teamIdArray = Array.from(new Set (teamIdArray))
                let rankArray = []
                if(d === '1'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].awayRank >= ranks.from && data[j].events[k].awayRank <= ranks.to){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].homeRank >= ranks.from && data[j].events[k].homeRank <= ranks.to){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = 0 ; j < data.length ; j++){
                            if(dir == 'home'){
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].local_formation == ranks){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = 0 ; k < data[j].events.length; k++){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].visit_formation == ranks){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].minute > 45 && data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                for(let i = 0 ; i < rankArray.length ; i++){
                    if(rankArray[i].points > currentTeamData.points){
                        rank++
                    }
                    if(rankArray[i].points == currentTeamData.points){
                        if((rankArray[i].goals_scored - rankArray[i].goals_against) > (currentTeamData.goals_scored - currentTeamData.goals_against)){
                            rank++
                        }
                    }
                }
                return rank
            },
            attack_calculation(seasonId, teamId, dir){
                let rankArray = []
                let rank = 1
                let team_goals_scored = 0
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            if(dir == 'home'){
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].home.won*3 + this.standingList[i].standings[j].home.draw, 'goals_scored': this.standingList[i].standings[j].home.goals_scored, 'goals_against': this.standingList[i].standings[j].home.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    team_goals_scored = this.standingList[i].standings[j].home.goals_scored
                                }
                            }
                            else{
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].away.won*3 + this.standingList[i].standings[j].away.draw, 'goals_scored': this.standingList[i].standings[j].away.goals_scored, 'goals_against': this.standingList[i].standings[j].away.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    team_goals_scored = this.standingList[i].standings[j].away.goals_scored
                                }
                            }
                        }

                        for(let j = 0 ; j < rankArray.length ; j++){
                            if(rankArray[j].goals_scored > team_goals_scored){
                                rank++
                            }
                        }
                    }
                }
                return rank
            },
            defense_calculation(seasonId, teamId, dir){
                let rankArray = []
                let rank = 1
                let team_goals_against = 0
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            if(dir == 'home'){
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].home.won*3 + this.standingList[i].standings[j].home.draw, 'goals_scored': this.standingList[i].standings[j].home.goals_scored, 'goals_against': this.standingList[i].standings[j].home.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    team_goals_against = this.standingList[i].standings[j].home.goals_against
                                }
                            }
                            else{
                                rankArray.push({"teamId": this.standingList[i].standings[j].team_id, "points": this.standingList[i].standings[j].away.won*3 + this.standingList[i].standings[j].away.draw, 'goals_scored': this.standingList[i].standings[j].away.goals_scored, 'goals_against': this.standingList[i].standings[j].away.goals_against})
                                if(this.standingList[i].standings[j].team_id == teamId){
                                    team_goals_against = this.standingList[i].standings[j].away.goals_against
                                }
                            }
                        }

                        for(let j = 0 ; j < rankArray.length ; j++){
                            if(rankArray[j].goals_against < team_goals_against){
                                rank++
                            }
                        }
                    }
                }
                return rank
            },
            H_A_Form_calculation(data, teamId, seasonId, dir, date,d, ranks){
                let teamIdArray = []
                let rank = 1
                let currentTeamData = {}
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            teamIdArray[j] = this.standingList[i].standings[j].team_id
                        }
                    }
                }
                teamIdArray = Array.from(new Set (teamIdArray))
                let rankArray = []
                if(d === '1'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            if(dir == 'home'){
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    localScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum > visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date < date){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                    localScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum < visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            if(dir == 'home'){
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    localScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum > visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].date >= date){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                    localScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum < visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            if(dir == 'home'){
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].awayRank >= ranks.from && data[j].events[k].awayRank <= ranks.to){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    localScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum > visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].homeRank >= ranks.from && data[j].events[k].homeRank <= ranks.to){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                    localScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum < visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '4'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            if(dir == 'home'){
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].localteamId == teamIdArray[i] && data[j].events[k].local_formation == ranks){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    localScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum > visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                            else{
                                for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                    if(data[j].events[k].visitorteamId == teamIdArray[i] && data[j].events[k].visit_formation == ranks){
                                        limit++
                                        if(limit <= 3){
                                            let localScoreSum = 0
                                            let visitorScoreSum = 0
                                            for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                                if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                    visitorScoreSum++
                                                    rankArray[i].goals_scored++
                                                }
                                                if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                    localScoreSum++
                                                    rankArray[i].goals_against++
                                                }
                                            }
                                            if(localScoreSum == visitorScoreSum){
                                                draw++
                                            }
                                            else if(localScoreSum < visitorScoreSum){
                                                won++
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                for(let i = 0 ; i < rankArray.length ; i++){
                    if(rankArray[i].points > currentTeamData.points){
                        rank++
                    }
                    if(rankArray[i].points == currentTeamData.points){
                        if((rankArray[i].goals_scored - rankArray[i].goals_against) > (currentTeamData.goals_scored - currentTeamData.goals_against)){
                            rank++
                        }
                    }
                }
                return rank
            },
            Form_calculation(data, teamId, seasonId, date, d, ranks){
                let teamIdArray = []
                let rank = 1
                let currentTeamData = {}
                for(let i = 0 ; i < this.standingList.length ; i++){
                    if(this.standingList[i].season_id == seasonId){
                        for(let j = 0 ; j < this.standingList[i].standings.length; j++){
                            teamIdArray[j] = this.standingList[i].standings[j].team_id
                        }
                    }
                }
                teamIdArray = Array.from(new Set (teamIdArray))
                let rankArray = []
                if(d === '1'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                if((data[j].events[k].localteamId == teamIdArray[i] || data[j].events[k].visitorteamId == teamIdArray[i]) && data[j].events[k].date < date){
                                    limit++
                                    if(data[j].events[k].localteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                    else if(data[j].events[k].visitorteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '2'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                if((data[j].events[k].localteamId == teamIdArray[i] || data[j].events[k].visitorteamId == teamIdArray[i]) && data[j].events[k].date >= date){
                                    limit++
                                    if(data[j].events[k].localteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                    else if(data[j].events[k].visitorteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }
                else if(d === '3'){
                    for(let i = 0 ; i < teamIdArray.length ; i++){
                        let won = 0
                        let draw = 0
                        let limit = 0
                        rankArray.push({"teamId": teamIdArray[i], "points": 0, 'goals_scored': 0, 'goals_against': 0})
                        for(let j = data.length - 1 ; j >= 0 ; j--){
                            for(let k = data[j].events.length - 1 ; k >= 0; k--){
                                if((data[j].events[k].localteamId == teamIdArray[i] || data[j].events[k].visitorteamId == teamIdArray[i])  && data[j].events[k].date >= date){
                                    limit++
                                    if(data[j].events[k].localteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                localScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].visitorteamId){
                                                visitorScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum > visitorScoreSum){
                                            won++
                                        }
                                    }
                                    else if(data[j].events[k].visitorteamId == teamIdArray[i] && limit <= 6){
                                        let localScoreSum = 0
                                        let visitorScoreSum = 0
                                        for(let l = 0 ; l < data[j].events[k].goals.length ; l++){
                                            if(data[j].events[k].goals[l].teamId == teamIdArray[i]){
                                                visitorScoreSum++
                                                rankArray[i].goals_scored++
                                            }
                                            if(data[j].events[k].goals[l].teamId == data[j].events[k].localteamId){
                                                localScoreSum++
                                                rankArray[i].goals_against++
                                            }
                                        }
                                        if(localScoreSum == visitorScoreSum){
                                            draw++
                                        }
                                        else if(localScoreSum < visitorScoreSum){
                                            won++
                                        }
                                    }
                                }
                            }
                        }
                        rankArray[i].points = draw + won*3
                        if(teamIdArray[i] == teamId){
                            currentTeamData = rankArray[i]
                        }
                    }
                }

                for(let i = 0 ; i < rankArray.length ; i++){
                    if(rankArray[i].points > currentTeamData.points){
                        rank++
                    }
                    if(rankArray[i].points == currentTeamData.points){
                        if((rankArray[i].goals_scored - rankArray[i].goals_against) > (currentTeamData.goals_scored - currentTeamData.goals_against)){
                            rank++
                        }
                    }
                }
                return rank
            },

            cold_data_get(){
                let main_data = this.coldstatsdata
                let ranking = this.standingList
                this.mainData = main_data
                let k = 0
                let events = []
                //console.log('mainData===>', main_data)
                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){
                        k++
                        let start_date4 = new Date();
                        let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                        next_date4 = new Date(next_date4).toISOString()
                        next_date4 = next_date4.substring(0,10)
                        let home = {
                            p:0,
                            name:'',
                            rank: '',
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondplus:0,
                            secondminus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1:'',
                            FH:0,
                            swing2:'',
                            SH:0,
                            swing3:'',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0,
                            fh_percentage: 0,
                            sh_percentage: 0,
                            fh_probability: 0,
                            sh_probability: 0
                        }
                        let away = {
                            p:0,
                            name:'',
                            rank:'' ,
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondPlus:0,
                            secondMinus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1: '',
                            FH:0,
                            swing2: '',
                            SH:0,
                            swing3: '',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0,
                            fh_percentage: 0,
                            sh_percentage: 0,
                        }
                        home.name = main_data[j].localTeamName + '(' + main_data[j].standing.localteam_position + ')'
                        away.name = main_data[j].visitorTeamName +  '(' + main_data[j].standing.visitorteam_position + ')'

                        let self =  this
                        let temp2 =  JSON.stringify(self.lineup_list)
                        let temp3 =  JSON.stringify(self.lineup_list)
                        let homelineuplist = JSON.parse(temp2)
                        let awaylineuplist = JSON.parse(temp3)
                        let local_Id = main_data[j].localTeamId
                        let visitor_Id = main_data[j].visitorTeamId
                        let home_lineups = []
                        let away_lineups = []
                        for(let p = 0 ; p < main_data[j].events.length ;p++){
                            let events = main_data[j].events[p].events
                            for(let pp = 0 ; pp < events.length ; pp++){
                                if(local_Id == events[pp].localteamId){
                                    if(events[pp].local_formation){
                                        home_lineups.push(events[pp].local_formation)
                                    }
                                }
                                if(visitor_Id == events[pp].visitorteamId){
                                    if(events[pp].visit_formation){
                                        away_lineups.push(events[pp].visit_formation)
                                    }
                                }
                            }
                        }
                        let home_lineup_check = 0
                        let away_lineup_check = 0
                        for(let p = 0 ; p < homelineuplist.length ; p++){
                            let count = 0
                            for(let pp = 0 ; pp < home_lineups.length ; pp++){
                                if(homelineuplist[p].value == home_lineups[pp]){
                                    count++
                                }
                            }
                            if(count > 0){
                                home_lineup_check = 1
                                homelineuplist[p].label = homelineuplist[p].label + '(' + count + ')'
                            }
                        }
                        for(let p = 0 ; p < awaylineuplist.length ; p++){
                            let count = 0
                            for(let pp = 0 ; pp < away_lineups.length ; pp++){
                                if(awaylineuplist[p].value == away_lineups[pp]){
                                    count++
                                }
                            }
                            if(count > 0){
                                away_lineup_check = 1
                                awaylineuplist[p].label = awaylineuplist[p].label + '(' + count + ')'
                            }
                        }
                        let homelineuplist1 = [{ value: '0', label: 'All'}]
                        let awaylineuplist1 = [{ value: '0', label: 'All'}]
                        for(let p = 0 ; p < homelineuplist.length ; p++){
                            if(homelineuplist[p].label.includes('(')){
                                homelineuplist1.push(homelineuplist[p])
                            }
                        }
                        for(let p = 0 ; p < awaylineuplist.length ; p++){
                            if(awaylineuplist[p].label.includes('(')){
                                awaylineuplist1.push(awaylineuplist[p])
                            }
                        }
                        if(away_lineup_check === 0){
                            awaylineuplist1 = []
                        }
                        if(home_lineup_check === 0){
                            homelineuplist1 = []
                        }

                        let home_team_scores = []
                        let away_team_scores = []
                        let season_id = main_data[j].season_id
                        let stage_id = main_data[j].stage_id
                        let full_time_score_array = []
                        let position_details_array = []
                        for(let c = 0 ; c < ranking.length ; c++){
                            if(ranking[c].season_id == season_id){
                                for(let cc = 0 ; cc < ranking[c].standings.length ; cc++){
                                    let color = "black"
                                    if((local_Id == ranking[c].standings[cc].team_id) || (visitor_Id == ranking[c].standings[cc].team_id)){
                                        color = "blue"
                                    }
                                    full_time_score_array.push({"color": color, "rank": ranking[c].standings[cc].position, "teamId": ranking[c].standings[cc].team_id, "teamName": ranking[c].standings[cc].team_name})
                                    let standing_details = {
                                        "name": ranking[c].standings[cc].team_name,
                                        "position": null,
                                        "p": null,
                                        "w": null,
                                        "d": null,
                                        "l": null,
                                        "f": null,
                                        "a": null,
                                        "gf": null,
                                        "points": null,
                                        "tooltip": null,
                                        "color": '',
                                        "border": '',
                                        "key": this.create_UUID()
                                    }
                                    standing_details.position = ranking[c].standings[cc].position
                                    standing_details.tooltip = ranking[c].standings[cc].result
                                    if((standing_details.tooltip == "UEFA Champions League") || (standing_details.tooltip == "Promotion") || 
                                        (standing_details.tooltip == "Championship Round") || (standing_details.tooltip == "CONMEBOL Libertadores") ||
                                        (standing_details.tooltip == "1st Phase") || (standing_details.tooltip == "2nd Phase") ||
                                        (standing_details.tooltip == "Next Round") || (standing_details.tooltip == "Final") ||
                                        (standing_details.tooltip == "Promotion Group") || (standing_details.tooltip == "Final Series") ||
                                        (standing_details.tooltip == "Final Tournament")){
                                        standing_details.color = 'blue'
                                        standing_details.border = "white"
                                    }
                                    if((standing_details.tooltip == "UEFA Champions League Qualifiers") || (standing_details.tooltip == "CONMEBOL Libertadores Qualifiers") ||
                                        (standing_details.tooltip == "CONMEBOL Libertadores Qualifiers")){
                                        standing_details.color = 'lightblue'
                                        standing_details.border = "white"
                                    }
                                    if((standing_details.tooltip == "Promotion Play-off") || (standing_details.tooltip == "UEFA Europa League") || 
                                        (standing_details.tooltip == "CONMEBOL Sudamericana") || (standing_details.tooltip == "Semi-finals") || 
                                        (standing_details.tooltip == "Champion Play-off") || (standing_details.tooltip == "Final Tournament or Play-offs") ||
                                        (standing_details.tooltip == "Final Series Play-offs")){
                                        standing_details.color = 'brown'
                                        standing_details.border = "white"
                                    }
                                    if((standing_details.tooltip == "UEFA Europa League Qualifiers") || (standing_details.tooltip == "CONMEBOL Sudamericana Qualifiers") ||
                                        (standing_details.tooltip == "Quarter-finals") || (standing_details.tooltip == "Possible Promotion Play-off")){
                                        standing_details.color = 'magenta'
                                        standing_details.border = "white"
                                    }
                                    if(standing_details.tooltip == "Relegation"){
                                        standing_details.color = 'red'
                                        standing_details.border = "white"
                                    }
                                    if((standing_details.tooltip == "Relegation Round") || (standing_details.tooltip == "Relegation Play-off")){
                                        standing_details.color = 'tomato'
                                        standing_details.border = "white"
                                    }
                                    if(ranking[c].standings[cc].overall != null){
                                        standing_details.p = ranking[c].standings[cc].overall.games_played
                                        standing_details.w = ranking[c].standings[cc].overall.won
                                        standing_details.d = ranking[c].standings[cc].overall.draw
                                        standing_details.l = ranking[c].standings[cc].overall.lost
                                        standing_details.f = ranking[c].standings[cc].overall.goals_scored
                                        standing_details.a = ranking[c].standings[cc].overall.goals_against
                                    }
                                    else{
                                        standing_details.p = '-'
                                        standing_details.w = '-'
                                        standing_details.d = '-'
                                        standing_details.l = '-'
                                        standing_details.f = '-'
                                        standing_details.a = '-'
                                    }
                                    if(ranking[c].standings[cc].total != null){
                                        standing_details.gf = ranking[c].standings[cc].total.goal_difference
                                        standing_details.points = ranking[c].standings[cc].total.points
                                    }
                                    else{
                                        standing_details.gf = '-'
                                        standing_details.points = '-'
                                    }
                                    position_details_array.push(standing_details)
                                }
                            }
                        }
                        for(let p = 0 ; p < main_data[j].events.length ;p++){
                            let events = main_data[j].events[p].events
                            for(let pp = 0 ; pp < events.length ; pp++){
                                if(local_Id == events[pp].localteamId){
                                    let home_goal_tlp = ""
                                    let away_goal_tlp = ""
                                    let goal_tlp = "0 - 0"
                                    for(let e = 0 ; e < events[pp].goals.length ; e++){
                                        if(events[pp].goals[e].teamId == local_Id){
                                            home_goal_tlp = home_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                        }
                                        else {
                                            away_goal_tlp = away_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                        }
                                    }
                                    if(home_goal_tlp == "" && away_goal_tlp != ""){
                                        goal_tlp = away_goal_tlp
                                    }
                                    else if(away_goal_tlp == "" && home_goal_tlp != ""){
                                        goal_tlp = home_goal_tlp
                                    }
                                    else if(away_goal_tlp != "" && home_goal_tlp != ""){
                                        goal_tlp = home_goal_tlp + '-' + away_goal_tlp
                                    }
                                    let hf_color = ""
                                    if(parseInt(events[pp].hf_score.split("-")[0]) == parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#cdcf46"
                                    }
                                    else if(parseInt(events[pp].hf_score.split("-")[0]) > parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#00cc00"
                                    }
                                    else if(parseInt(events[pp].hf_score.split("-")[0]) < parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#fe9f9f"
                                    }

                                    let ft_color = ""
                                    if(parseInt(events[pp].ft_score.split("-")[0]) == parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#cdcf46"
                                    }
                                    else if(parseInt(events[pp].ft_score.split("-")[0]) > parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#00cc00"
                                    }
                                    else if(parseInt(events[pp].ft_score.split("-")[0]) < parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#fe9f9f"
                                    }

                                    let local_name = ""
                                    let visitor_name = ""
                                    let local = full_time_score_array.filter(function(item) {
                                        return item.teamId === events[pp].localteamId
                                    });
                                    let visit = full_time_score_array.filter(function(item) {
                                        return item.teamId === events[pp].visitorteamId
                                    });
                                    if(local.length > 0){
                                        local_name = local[0].teamName
                                    }
                                    if(visit.length > 0){
                                        visitor_name = visit[0].teamName
                                    }
                                    home_team_scores.push({"key": this.create_UUID(),"ht_color": hf_color, "ft_color": ft_color, "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[pp].date, "ht_score": events[pp].hf_score, "ft_score": events[pp].ft_score, "home_goals": home_goal_tlp, "away_goals": away_goal_tlp})
                                    if(events[pp].local_formation){
                                        home_lineups.push(events[pp].local_formation)
                                    }
                                }
                                if(visitor_Id == events[pp].visitorteamId){
                                    let home_goal_tlp = ""
                                    let away_goal_tlp = ""
                                    let goal_tlp = "0 - 0"
                                    for(let e = 0 ; e < events[pp].goals.length ; e++){
                                        if(events[pp].goals[e].teamId == visitor_Id){
                                            away_goal_tlp = away_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                        }
                                        else {
                                            home_goal_tlp = home_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                        }
                                    }
                                    if(home_goal_tlp == "" && away_goal_tlp != ""){
                                        goal_tlp = away_goal_tlp
                                    }
                                    else if(away_goal_tlp == "" && home_goal_tlp != ""){
                                        goal_tlp = home_goal_tlp
                                    }
                                    else if(away_goal_tlp != "" && home_goal_tlp != ""){
                                        goal_tlp = home_goal_tlp + '-' + away_goal_tlp
                                    }

                                    let hf_color = ""
                                    if(parseInt(events[pp].hf_score.split("-")[0]) == parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#cdcf46"
                                    }
                                    else if(parseInt(events[pp].hf_score.split("-")[0]) < parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#00cc00"
                                    }
                                    else if(parseInt(events[pp].hf_score.split("-")[0]) > parseInt(events[pp].hf_score.split("-")[1])){
                                        hf_color = "#fe9f9f"
                                    }

                                    let ft_color = ""
                                    if(parseInt(events[pp].ft_score.split("-")[0]) == parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#cdcf46"
                                    }
                                    else if(parseInt(events[pp].ft_score.split("-")[0]) < parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#00cc00"
                                    }
                                    else if(parseInt(events[pp].ft_score.split("-")[0]) > parseInt(events[pp].ft_score.split("-")[1])){
                                        ft_color = "#fe9f9f"
                                    }
                                    let local_name = ""
                                    let visitor_name = ""
                                    let local = full_time_score_array.filter(function(item) {
                                        return item.teamId === events[pp].localteamId
                                    });
                                    let visit = full_time_score_array.filter(function(item) {
                                        return item.teamId === events[pp].visitorteamId
                                    });
                                    if(local.length > 0){
                                        local_name = local[0].teamName
                                    }
                                    if(visit.length > 0){
                                        visitor_name = visit[0].teamName
                                    }
                                    away_team_scores.push({"key": this.create_UUID(), "ht_color": hf_color, "ft_color": ft_color, "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[pp].date, "ht_score": events[pp].hf_score, "ft_score": events[pp].ft_score, "home_goals": home_goal_tlp, "away_goals": away_goal_tlp})
                                    if(events[pp].visit_formation){
                                        away_lineups.push(events[pp].visit_formation)
                                    }
                                }
                            }
                        }

                        let home_full_scores = []
                        let away_full_scores = []
                        for(let c = 0 ; c < full_time_score_array.length ; c++){
                            for(let cc = 0 ; cc < main_data[j].events.length ; cc++){
                                let events = main_data[j].events[cc].events
                                for(let ccc = 0 ; ccc < events.length ; ccc++){
                                    if(full_time_score_array[c].teamId == events[ccc].visitorteamId && local_Id == events[ccc].localteamId){
                                        let home_score_tlp = ""
                                        let away_score_tlp = ""
                                        let goal_tlp = "0 - 0"
                                        for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                            if(events[ccc].goals[e].teamId == events[ccc].localteamId){
                                                home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                            }
                                            else{
                                                away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                            }
                                        }
                                        if(home_score_tlp == "" && away_score_tlp != ""){
                                            goal_tlp = away_score_tlp
                                        }
                                        else if(away_score_tlp == "" && home_score_tlp != ""){
                                            goal_tlp = home_score_tlp
                                        }
                                        else if(away_score_tlp != "" && home_score_tlp != ""){
                                            goal_tlp = home_score_tlp + '-' + away_score_tlp
                                        }

                                        let ft_color = ""
                                        if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#cdcf46"
                                        }
                                        else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#00cc00"
                                        }
                                        else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#fe9f9f"
                                        }

                                        let local_name = ""
                                        let visitor_name = ""
                                        let local = full_time_score_array.filter(function(item) {
                                            return item.teamId === events[ccc].localteamId
                                        });
                                        let visit = full_time_score_array.filter(function(item) {
                                            return item.teamId === events[ccc].visitorteamId
                                        });
                                        if(local.length > 0){
                                            local_name = local[0].teamName
                                        }
                                        if(visit.length > 0){
                                            visitor_name = visit[0].teamName
                                        }

                                        home_full_scores[c] = {"key": this.create_UUID(), "ft_color": ft_color , "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                    }
                                    if(full_time_score_array[c].teamId == events[ccc].localteamId && visitor_Id == events[ccc].visitorteamId){
                                        let home_score_tlp = ""
                                        let away_score_tlp = ""
                                        let goal_tlp = "0 - 0"
                                        for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                            if(events[ccc].goals[e].teamId == events[ccc].visitorteamId){
                                                away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                            }
                                            else{
                                                home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                            }
                                        }
                                        if(home_score_tlp == "" && away_score_tlp != ""){
                                            goal_tlp = away_score_tlp
                                        }
                                        else if(away_score_tlp == "" && home_score_tlp != ""){
                                            goal_tlp = home_score_tlp
                                        }
                                        else if(away_score_tlp != "" && home_score_tlp != ""){
                                            goal_tlp = home_score_tlp + '-' + away_score_tlp
                                        }

                                        let ft_color = ""
                                        if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#cdcf46"
                                        }
                                        else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#00cc00"
                                        }
                                        else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                            ft_color = "#fe9f9f"
                                        }

                                        let local_name = ""
                                        let visitor_name = ""
                                        let local = full_time_score_array.filter(function(item) {
                                            return item.teamId === events[ccc].localteamId
                                        });
                                        let visit = full_time_score_array.filter(function(item) {
                                            return item.teamId === events[ccc].visitorteamId
                                        });
                                        if(local.length > 0){
                                            local_name = local[0].teamName
                                        }
                                        if(visit.length > 0){
                                            visitor_name = visit[0].teamName
                                        }
                                        away_full_scores[c] = {"key": this.create_UUID(), "goal_tlp": goal_tlp,"local_name": local_name, "visitor_name": visitor_name,  "ft_color": ft_color , "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                    }
                                }
                            }
                        }
                        for(let c = 0 ; c < full_time_score_array.length ; c++){
                            if(!home_full_scores[c]){
                                home_full_scores[c] = null
                            }
                            if(!away_full_scores[c]){
                                away_full_scores[c] = null
                            }
                        }

                        let current_modal_data = {
                            "current_home_name": home.name,
                            "current_away_name": away.name,
                            "home_team_scores": home_team_scores,
                            "away_team_scores": away_team_scores,
                            "full_time_score_array": full_time_score_array,
                            "home_full_scores": home_full_scores,
                            "away_full_scores": away_full_scores,
                            "position_details": position_details_array
                        }

                        //console.log('current modal data===>', current_modal_data)

                        events[k - 1] = {'spots': current_modal_data, 'homeLineupList': homelineuplist1,'awayLineupList': awaylineuplist1, 'rank_option': [], 'rank_set': {}, 'rankFilter': false, 'b_data': main_data[j].events, 'eventName': main_data[j].time.starting_at.time.substring(0, 5) + ' ' + main_data[j].localTeamName + '(' + main_data[j].standing.localteam_position + ')' + ' v ' + main_data[j].visitorTeamName +  '(' + main_data[j].standing.visitorteam_position + ')', 'home_id': 0, 'away_id': 0, 'openDate':  main_data[j].time.starting_at.time, 'home':home, 'away': away, 'homeDateList': [], "awayDateList": []}

                        let homeTeamId = main_data[j].localTeamId
                        let awayTeamId = main_data[j].visitorTeamId

                        events[k - 1].home_id = homeTeamId
                        events[k - 1].away_id = awayTeamId

                        let teamsInfo = main_data[j].teamInfo
                        let rank_filter_show = true
                        let teamArray = []
                        for(let m = 0 ; m < teamsInfo.length ; m++){
                            let teams = teamsInfo[m].teams
                            //console.log("teams length====>", teams, ', ', teams.length)
                            if(teams.length < 5){
                                rank_filter_show = false
                                break
                            }
                            for(let mm = 0 ; mm < teams.length ; mm++){
                                teamArray.push(teams[mm].team_id)
                            }
                        }
                        if(teamArray.length === 0){
                            rank_filter_show = false
                        }
                        teamArray = Array.from(new Set (teamArray))

                        let rank_set = {
                            "v1": {"from": 1, "to": 0},
                            "v2": {"from": 0, "to": 0},
                            "v3": {"from": 0, "to": 0},
                            "v4": {"from": 0, "to": 0}
                        }
                        let rankList_option = []
                        if(rank_filter_show === true){
                            let total_teams = teamArray.length
                            if(total_teams % 2 === 0){
                                let sec = total_teams/2
                                if(sec % 2 === 0){
                                    rank_set.v1.to = sec/2
                                    rank_set.v2.to = sec
                                    rank_set.v3.to = sec*3/2
                                    rank_set.v4.to = sec*2

                                    rank_set.v2.from = rank_set.v1.to + 1
                                    rank_set.v3.from = rank_set.v2.to + 1
                                    rank_set.v4.from = rank_set.v3.to + 1
                                }
                                else{
                                    rank_set.v1.to = (sec - 1)/2
                                    rank_set.v2.to = sec
                                    rank_set.v3.to = sec + (sec - 1)/2
                                    rank_set.v4.to = sec*2

                                    rank_set.v2.from = rank_set.v1.to + 1
                                    rank_set.v3.from = rank_set.v2.to + 1
                                    rank_set.v4.from = rank_set.v3.to + 1
                                }
                            }
                            else{
                                let f_sec = (total_teams - 1)/2
                                let s_sec = (total_teams - 1)/2 + 1
                                if(f_sec % 2 === 0){
                                    rank_set.v1.to = f_sec/2
                                    rank_set.v2.to = f_sec
                                    rank_set.v2.from = rank_set.v1.to + 1
                                    rank_set.v3.from = rank_set.v2.to + 1
                                }
                                else{
                                    rank_set.v1.to = (f_sec - 1)/2
                                    rank_set.v2.to = f_sec
                                    rank_set.v2.from = rank_set.v1.to + 1
                                    rank_set.v3.from = rank_set.v2.to + 1
                                }

                                if(s_sec % 2 === 0){
                                    rank_set.v3.to = s_sec/2
                                    rank_set.v4.to = s_sec
                                    rank_set.v4.from = rank_set.v3.to + 1
                                }
                                else{
                                    rank_set.v3.to = f_sec + (s_sec - 1)/2
                                    rank_set.v4.to = total_teams
                                    rank_set.v4.from = rank_set.v3.to + 1
                                }
                            }
                            events[k - 1].rankFilter = true
                            events[k - 1].rank_set = rank_set
                            rankList_option = [
                                {"value": 1, "label": "vs All"},
                                {"value": 2, "label": "vs High rank ( " + rank_set.v1.from + ' to ' + rank_set.v1.to + ' )'},
                                {"value": 3, "label": "vs middle-high rank ( " + rank_set.v2.from + ' to ' + rank_set.v2.to + ' )'},
                                {"value": 4, "label": "vs middle-low rank (" + rank_set.v3.from + ' to ' + rank_set.v3.to + ' )'},
                                {"value": 5, "label": "vs low rank (" + rank_set.v4.from + ' to ' + rank_set.v4.to + ' )'},
                            ]
                            events[k - 1].rank_option = rankList_option
                        }

                        let seasonId = main_data[j].season_id
                        let event_item = main_data[j].events
                        let home_date_list = [{'value': 1000, "date": '1900-01-01', "label": "ALL"}]
                        let away_date_list = [{'value': 1000, "date": '1900-01-01', "label": "ALL"}]
                        let home_date_Index = 0
                        let away_date_Index = 0
                        for(let m = 0 ; m < event_item.length ; m++){
                            for(let mm = 0 ; mm < event_item[m].events.length ; mm++){
                                if(event_item[m].events[mm].localteamId == homeTeamId){
                                    home_date_Index++
                                    home_date_list.push({'value': home_date_Index,"date": event_item[m].events[mm].date, "label": home_date_Index})
                                }
                                if(event_item[m].events[mm].visitorteamId == awayTeamId){
                                    away_date_Index++
                                    away_date_list.push({'value': away_date_Index,"date": event_item[m].events[mm].date, "label": away_date_Index})
                                }
                            }
                        }
                        this.sortJSON(home_date_list,'date', '123');
                        this.sortJSON(away_date_list,'date', '123');

                        for(let m = 1 ; m < home_date_list.length ; m++){
                            home_date_list[m].value = m
                            home_date_list[m].label = m
                        }

                        for(let m = 1 ; m < away_date_list.length ; m++){
                            away_date_list[m].value = m
                            away_date_list[m].label = m
                        }

                        events[k - 1].homeDateList = home_date_list
                        events[k - 1].awayDateList = away_date_list
                        home.pos = main_data[j].standing.localteam_position
                        away.pos = main_data[j].standing.visitorteam_position
                        let standings = this.standingList.filter(function(item) {
                            console.log('item.stage_id =>', item.stage_id)
                            console.log('stage_id =>', stage_id)
                            //return item.stage_id == stage_id;
                            return item.season_id == main_data[j].season_id;
                            //return item.standings.team_name == main_data[j].localTeamName;
                        });
                        let new_standing = [];
                                                        
                        if (standings.length > 1) {
                            
                            for (var ss = 0; ss < standings.length; ss++) {
                                var find_home = false;
                                var find_away = false;
                                for (var sss = 0; sss < standings[ss].standings.length; sss++) {
                                    if (standings[ss].standings[sss].team_name == main_data[j].localTeamName) {
                                        find_home = true
                                    }
                                    else if (standings[ss].standings[sss].team_name == main_data[j].visitorTeamName ) {
                                        find_away = true;                                                                        
                                    }
                                }
                                if (find_home && find_away) {
                                    new_standing.push(standings[ss]);
                                    break
                                }
                                    
                            }
                            
                        }
                        if (new_standing.length > 0)
                            standings = new_standing;

                        // let events = main_data[j].events.filter(function(item) {
                        //     return item.stage_id == stage_id
                        // });

                         home.h_a = this.h_a_calculation(standings, homeTeamId, '1')
                        away.h_a = this.h_a_calculation(standings, awayTeamId, '2')

                        let swing1 = (away.pos - away.h_a) - (home.pos - home.h_a)
                        if(swing1 > 0){
                            away.swing1 = '+'+swing1
                            home.swing1 =''
                        }
                        else if(swing1 < 0){
                            away.swing1 =''
                            home.swing1 = '+'+swing1*(-1)
                        }
                        if((home.pos > home.h_a && away.pos > away.h_a) || (home.pos < home.h_a && away.pos < away.h_a)){
                            away.swing1 =''
                            home.swing1 =''
                        }                        

                        home.FH = this.f_h_calculation(standings, main_data[j].events, main_data[j].localTeamId, '1')
                        away.FH = this.f_h_calculation(standings, main_data[j].events, main_data[j].visitorTeamId, '2')

                        // home.FH = this.FH_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '1', {}, stage_id)
                        // away.FH = this.FH_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4, '1', {}, stage_id)

                        let swing2 =(away.pos - away.FH) -  (home.pos - home.FH)
                        if(swing2 > 0){
                            away.swing2 = '+'+swing2
                            home.swing2 =''
                        }
                        else if(swing2 < 0){
                            away.swing2 =''
                            home.swing2 = '+'+swing2*(-1)
                        }
                        if((home.pos > home.FH && away.pos > away.FH) || (home.pos < home.FH && away.pos < away.FH)){
                            away.swing2 =''
                            home.swing2 =''
                        }

                        home.SH = this.s_h_calculation(standings, main_data[j].events, main_data[j].localTeamId, '1')
                        away.SH = this.s_h_calculation(standings, main_data[j].events, main_data[j].visitorTeamId, '2')

                        // home.SH = this.SH_calculation(main_data[j].events, main_data[j].localTeamId,seasonId, 'home', next_date4, '1', {}, stage_id)
                        // away.SH = this.SH_calculation(main_data[j].events, main_data[j].visitorTeamId,seasonId, 'away', next_date4, '1', {}, stage_id)

                        let swing3 =(away.pos - away.SH) -  (home.pos - home.SH)
                        if(swing3 > 0){
                            away.swing3 = '+'+swing3
                            home.swing3 =''
                        }
                        else if(swing3 < 0){
                            away.swing3 =''
                            home.swing3 = '+'+swing3*(-1)
                        }
                        if((home.pos > home.SH && away.pos > away.SH) || (home.pos < home.SH && away.pos < away.SH)){
                            away.swing3 =''
                            home.swing3 =''
                        }

                        home.attack = this.att_calculation(standings, main_data[j].localTeamId, '1')
                        // home.attack = this.attack_calculation(seasonId, homeTeamId, 'home', stage_id)
                        away.attack = this.def_calculation(standings, main_data[j].visitorTeamId, '2')
                        // away.attack = this.attack_calculation(seasonId, awayTeamId, 'away', stage_id)
                        home.defense = this.def_calculation(standings, main_data[j].localTeamId, '1')
                        // home.defense = this.defense_calculation(seasonId, homeTeamId, 'home', stage_id)
                        away.defense = this.att_calculation(standings, main_data[j].visitorTeamId, '2')
                        // away.defense = this.defense_calculation(seasonId, awayTeamId, 'away', stage_id)
                        home.form = this.form_calculation(standings, main_data[j].events, main_data[j].localTeamId, '1')
                        away.form = this.form_calculation(standings, main_data[j].events, main_data[j].visitorTeamId, '2')
                        home.form_H_A = this.form_h_a_calculation(standings, main_data[j].events, main_data[j].localTeamId, '1')
                        away.form_H_A = this.form_h_a_calculation(standings, main_data[j].events, main_data[j].visitorTeamId, '2')

                        // home.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '1', {}, stage_id)
                        // away.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4, '1', {}, stage_id)
                        //home.form = this.Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, next_date4, '1', {}, stage_id)
                        //away.form = this.Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, next_date4, '1', {}, stage_id)

                        let percentage0 = this.percentage_calculation(main_data[j])
                        // percentage = percentage0[0]
                        // numbers = percentage0[1]

                        home.p = this.p_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        away.p = this.p_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                        console.log('home p========>', home.p)
                        console.log('away p========>', away.p)

                        home.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)*100).toFixed(0)
                        away.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)*100).toFixed(0)
                        home.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)*100).toFixed(0)
                        away.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)*100).toFixed(0)
                        home.fh_probability = ((this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p) + this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p))/2*100).toFixed(0)
                        home.sh_probability = ((this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p) + this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p))/2*100).toFixed(0)
                        home.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)
                        away.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)
                        if(home.p == 0){
                            home.fh_percentage = 0
                            home.sh_percentage = 0
                        }
                        if(away.p == 0){
                            away.fh_percentage = 0
                            away.sh_percentage = 0
                        }
                        if(home.p == 0 && away.p == 0){
                            home.fh_probability = 0
                            home.sh_probability = 0
                        }
                        home.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.over15 = (this.over15_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.over15 = (this.over15_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.over25 = (this.over25_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.over25 = (this.over25_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.over35 = (this.over35_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.over35 = (this.over35_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.scored = (this.scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.scored = (this.scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.conc = (this.concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                        away.conc = (this.concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                        home.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)).toFixed(2)
                        away.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)).toFixed(2)
                        home.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)).toFixed(2)
                        away.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)).toFixed(2)
                        if(this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {}) == 0){home.average1 = 0;}
                        if(this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {}) == 0){away.average1 = 0;}
                        if(this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {}) == 0){home.average2 = 0;}
                        if(this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {}) == 0){away.average2 = 0;}
                        home.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)

                        away.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)

                        home.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)

                        home.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        home.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                        away.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                        let hgs1 = this.scored_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        let ags1 = this.scored_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                        let hgs2 = this.scored_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        let ags2 = this.scored_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                        home.gs1 = (hgs1/(hgs1 + hgs2)*100).toFixed(0)
                        home.gs2 = (hgs2/(hgs1 + hgs2)*100).toFixed(0)
                        if((hgs1 + hgs2) == 0){home.gs1 = 0; home.gs2 = 0}
                        away.gs1 = (ags1/(ags1 + ags2)*100).toFixed(0)
                        away.gs2 = (ags2/(ags1 + ags2)*100).toFixed(0)
                        if((ags1 + ags2) == 0){away.gs1 = 0 ; away.gs2 = 0}
                        let hgc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        let agc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                        let hgc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        let agc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                        home.gc1 = (hgc1/(hgc1 + hgc2)*100).toFixed(0)
                        home.gc2 = (hgc2/(hgc1 + hgc2)*100).toFixed(0)
                        if((hgc1 + hgc2) == 0){home.gc1 = 0; home.gc2 = 0}
                        away.gc1 = (agc1/(agc1 + agc2)*100).toFixed(0)
                        away.gc2 = (agc2/(agc1 + agc2)*100).toFixed(0)
                        if((agc1 + agc2) == 0){away.gc1 = 0 ; away.gc2 = 0}
                        home.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p)*100).toFixed(0)
                        away.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p)*100).toFixed(0)
                        home.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p)*100).toFixed(0)
                        away.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p)*100).toFixed(0)

                        home.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)

                        home.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        if(home.p == 0){home.over40 = 0; home.over85 = 0; home.C_H = 0; home.C_D = 0; home.C_A = 0; home.lastGoal = 0}
                        if(away.p == 0){away.over40 = 0; away.over85 = 0; away.C_H = 0; away.C_D = 0; away.C_A = 0; away.lastGoal = 0}
                        home.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        away.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                        home.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.first10)*100).toFixed(0)
                        away.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.first10)*100).toFixed(0)
                        home.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.first10)*100).toFixed(0)
                        away.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.first10)*100).toFixed(0)

                        if(home.first10 == 0){home.first11 = 0; home.first20 = 0}
                        if(away.first10 == 0){away.first11 = 0; away.first20 = 0}
                        home.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                        away.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                        home.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.second01)*100).toFixed(0)
                        away.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.second01)*100).toFixed(0)
                        home.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.second01)*100).toFixed(0)
                        away.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.second01)*100).toFixed(0)

                        if(home.second01 == 0){home.second11 = 0; home.second02 = 0}
                        if(away.second01 == 0){away.second11 = 0; away.second02 = 0}
                        home.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)

                        home.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        home.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                        away.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                        if(home.p == 0){home.secondplus = 0; home.secondminus = 0; home.homefirst = 0; home.drawfirst = 0; home.awayfirst = 0; home.homesecond = 0; home.drawsecond = 0; home.awaysecond = 0}
                        if(away.p == 0){away.secondplus = 0; away.secondminus = 0; away.homefirst = 0; away.drawfirst = 0; away.awayfirst = 0; away.homesecond = 0; away.drawsecond = 0; away.awaysecond = 0}
                        this.item3 = events[k - 1]
                        this.coldstats_show = true
                    }
                }
                //console.log('this.item3===>', this.item3)
            },
            refresh_calculation(val, home_date, away_date, b_data){
                //console.log('refresh final data check==!', val, ', ', home_date, ', ', away_date, ', ', b_data)

                let c_home_id = val.home_id
                let c_away_id = val.away_id
                let main_data = this.mainData
                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){

                        let home = {
                            p:0,
                            name:'',
                            rank: '',
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondplus:0,
                            secondminus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1:'',
                            FH:0,
                            swing2:'',
                            SH:0,
                            swing3:'',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0

                        }
                        let away = {
                            p:0,
                            name:'',
                            rank:'' ,
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondPlus:0,
                            secondMinus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1: '',
                            FH:0,
                            swing2: '',
                            SH:0,
                            swing3: '',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0
                        }

                        let homeTeamId = main_data[j].localTeamId
                        let awayTeamId = main_data[j].visitorTeamId

                        if(homeTeamId == c_home_id && awayTeamId == c_away_id){
                            let seasonId = main_data[j].season_id
                            home.pos = main_data[j].standing.localteam_position
                            away.pos = main_data[j].standing.visitorteam_position
                            home.h_a = this.H_A_calculation(seasonId, homeTeamId, 'home')
                            away.h_a = this.H_A_calculation(seasonId, awayTeamId, 'away')

                            let swing1 = (away.pos - away.h_a) - (home.pos - home.h_a)
                            if(swing1 > 0){
                                away.swing1 = '+'+swing1
                                home.swing1 =''
                            }
                            else if(swing1 < 0){
                                away.swing1 =''
                                home.swing1 = '+'+swing1*(-1)
                            }
                            if((home.pos > home.h_a && away.pos > away.h_a) || (home.pos < home.h_a && away.pos < away.h_a)){
                                away.swing1 =''
                                home.swing1 =''
                            }
                            home.FH = this.FH_calculation(b_data, main_data[j].localTeamId,seasonId, 'home', home_date, '2')
                            away.FH = this.FH_calculation(b_data, main_data[j].visitorTeamId,seasonId, 'away', away_date, '2')

                            let swing2 =(away.pos - away.FH) -  (home.pos - home.FH)
                            if(swing2 > 0){
                                away.swing2 = '+'+swing2
                                home.swing2 =''
                            }
                            else if(swing2 < 0){
                                away.swing2 =''
                                home.swing2 = '+'+swing2*(-1)
                            }
                            if((home.pos > home.FH && away.pos > away.FH) || (home.pos < home.FH && away.pos < away.FH)){
                                away.swing2 =''
                                home.swing2 =''
                            }

                            home.SH = this.SH_calculation(b_data, main_data[j].localTeamId,seasonId, 'home', home_date, '2')
                            away.SH = this.SH_calculation(b_data, main_data[j].visitorTeamId,seasonId, 'away', away_date, '2')

                            let swing3 =(away.pos - away.SH) -  (home.pos - home.SH)
                            if(swing3 > 0){
                                away.swing3 = '+'+swing3
                                home.swing3 =''
                            }
                            else if(swing3 < 0){
                                away.swing3 =''
                                home.swing3 = '+'+swing3*(-1)
                            }
                            if((home.pos > home.SH && away.pos > away.SH) || (home.pos < home.SH && away.pos < away.SH)){
                                away.swing3 =''
                                home.swing3 =''
                            }

                            home.attack = this.attack_calculation(seasonId, homeTeamId, 'home')
                            away.attack = this.attack_calculation(seasonId, awayTeamId, 'away')
                            home.defense = this.defense_calculation(seasonId, homeTeamId, 'home')
                            away.defense = this.defense_calculation(seasonId, awayTeamId, 'away')
                            home.form_H_A = this.H_A_Form_calculation(b_data, main_data[j].localTeamId, seasonId, 'home', home_date, '2')
                            away.form_H_A = this.H_A_Form_calculation(b_data, main_data[j].visitorTeamId, seasonId, 'away', away_date, '2')
                            home.form = this.Form_calculation(b_data, main_data[j].localTeamId, seasonId, home_date, '2')
                            away.form = this.Form_calculation(b_data, main_data[j].visitorTeamId, seasonId, away_date, '2')

                            home.p = this.p_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            away.p = this.p_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')



                            home.fh_percentage = (this.fh_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '1', {})/(home.p)*100).toFixed(0)
                            away.fh_percentage = (this.fh_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '1', {})/(away.p)*100).toFixed(0)
                            home.sh_percentage = (this.sh_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '1', {})/(home.p)*100).toFixed(0)
                            away.sh_percentage = (this.sh_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '1', {})/(away.p)*100).toFixed(0)
                            home.fh_probability = ((this.fh_probability_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '1', {})/(home.p) + this.fh_probability_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '1', {})/(away.p))/2*100).toFixed(0)
                            home.sh_probability = ((this.sh_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '1', {})/(home.p) + this.sh_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '1', {})/(away.p))/2*100).toFixed(0)
                            home.pro = this.fh_probability_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '1', {})/(home.p)
                            away.pro = this.fh_probability_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '1', {})/(away.p)
                            if(home.p == 0){
                                home.fh_percentage = 0
                                home.sh_percentage = 0
                            }
                            if(away.p == 0){
                                away.fh_percentage = 0
                                away.sh_percentage = 0
                            }
                            if(home.p == 0 && away.p == 0){
                                home.fh_probability = 0
                                home.sh_probability = 0
                            }

                            home.z_z = (this.zeroTozero_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.z_z = (this.zeroTozero_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.over15 = (this.over15_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.over15 = (this.over15_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.over25 = (this.over25_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.over25 = (this.over25_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.over35 = (this.over35_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.over35 = (this.over35_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.scored = (this.scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.scored = (this.scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.conc = (this.concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.001)*100).toFixed(0)
                            away.conc = (this.concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.001)*100).toFixed(0)
                            home.average1 = (this.average_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)).toFixed(2)
                            away.average1 = (this.average_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)).toFixed(2)
                            home.average2 = (this.average_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)).toFixed(2)
                            away.average2 = (this.average_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)).toFixed(2)
                            if(this.average_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2') == 0){home.average1 = 0;}
                            if(this.average_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2') == 0){away.average1 = 0;}
                            if(this.average_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2') == 0){home.average2 = 0;}
                            if(this.average_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2') == 0){away.average2 = 0;}
                            home.bts = (this.average_bts_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.bts = (this.average_bts_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.first1 = (this.FH_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.first1 = (this.FH_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.first2 = (this.FH_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.first2 = (this.FH_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.second1 = (this.SH_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.second1 = (this.SH_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.second2 = (this.SH_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.second2 = (this.SH_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time15_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 15, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time15_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 15, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time15_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 15, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time15_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 15, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time30_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 30, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time30_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 30, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time30_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 30, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time30_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 30, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time45_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 45, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time45_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 45, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time45_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 45, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time45_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 45, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time60_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 60, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time60_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 60, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time60_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 60, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time60_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 60, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time75_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 75, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time75_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 75, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time75_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 75, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time75_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 75, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time90_S = (this.time_scored_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 90, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time90_S = (this.time_scored_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 90, '2')/(away.p + 0.0001)*100).toFixed(0)
                            home.time90_C = (this.time_concd_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 90, '2')/(home.p + 0.0001)*100).toFixed(0)
                            away.time90_C = (this.time_concd_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 90, '2')/(away.p + 0.0001)*100).toFixed(0)
                            let hgs1 = this.scored_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            let ags1 = this.scored_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')
                            let hgs2 = this.scored_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            let ags2 = this.scored_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')
                            home.gs1 = (hgs1/(hgs1 + hgs2)*100).toFixed(0)
                            home.gs2 = (hgs2/(hgs1 + hgs2)*100).toFixed(0)
                            if((hgs1 + hgs2) == 0){home.gs1 = 0; home.gs2 = 0}
                            away.gs1 = (ags1/(ags1 + ags2)*100).toFixed(0)
                            away.gs2 = (ags2/(ags1 + ags2)*100).toFixed(0)
                            if((ags1 + ags2) == 0){away.gs1 = 0 ; away.gs2 = 0}
                            let hgc1 = this.concd_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            let agc1 = this.concd_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')
                            let hgc2 = this.concd_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            let agc2 = this.concd_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')
                            home.gc1 = (hgc1/(hgc1 + hgc2)*100).toFixed(0)
                            home.gc2 = (hgc2/(hgc1 + hgc2)*100).toFixed(0)
                            if((hgc1 + hgc2) == 0){home.gc1 = 0; home.gc2 = 0}
                            away.gc1 = (agc1/(agc1 + agc2)*100).toFixed(0)
                            away.gc2 = (agc2/(agc1 + agc2)*100).toFixed(0)
                            if((agc1 + agc2) == 0){away.gc1 = 0 ; away.gc2 = 0}
                            home.over40 = (this.scored_plus_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 45, '2')/(home.p)*100).toFixed(0)
                            away.over40 = (this.scored_plus_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 45, '2')/(away.p)*100).toFixed(0)
                            home.over85 = (this.scored_plus_calculation(b_data, main_data[j].localTeamId, 'home', home_date, 90, '2')/(home.p)*100).toFixed(0)
                            away.over85 = (this.scored_plus_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, 90, '2')/(away.p)*100).toFixed(0)

                            home.C_H = (this.win_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.C_H = (this.win_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.C_D = (this.draw_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.C_D = (this.draw_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.C_A = (this.loss_percentage_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.C_A = (this.loss_percentage_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)

                            home.lastGoal = (this.Last_goal_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.lastGoal = (this.Last_goal_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            if(home.p == 0){home.over40 = 0; home.over85 = 0; home.C_H = 0; home.C_D = 0; home.C_A = 0; home.lastGoal = 0}
                            if(away.p == 0){away.over40 = 0; away.over85 = 0; away.C_H = 0; away.C_D = 0; away.C_A = 0; away.lastGoal = 0}
                            home.first10 = this.one_to_zero_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            away.first10 = this.one_to_zero_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')

                            home.first11 = (this.one_to_one_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.first10)*100).toFixed(0)
                            away.first11 = (this.one_to_one_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.first10)*100).toFixed(0)
                            home.first20 = (this.two_to_one_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.first10)*100).toFixed(0)
                            away.first20 = (this.two_to_one_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.first10)*100).toFixed(0)

                            if(home.first10 == 0){home.first11 = 0; home.first20 = 0}
                            if(away.first10 == 0){away.first11 = 0; away.first20 = 0}
                            home.second01 = this.zero_to_one_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')
                            away.second01 = this.zero_to_one_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')

                            home.second11 = (this.one_to_one2_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.second01)*100).toFixed(0)
                            away.second11 = (this.one_to_one2_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.second01)*100).toFixed(0)
                            home.second02 = (this.zero_to_two_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.second01)*100).toFixed(0)
                            away.second02 = (this.zero_to_two_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.second01)*100).toFixed(0)

                            if(home.second01 == 0){home.second11 = 0; home.second02 = 0}
                            if(away.second01 == 0){away.second11 = 0; away.second02 = 0}
                            home.secondplus = (this.two_score_ahead_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.secondplus = (this.two_score_ahead_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.secondminus = (this.two_score_behind_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.secondminus = (this.two_score_behind_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.homefirst = (this.H_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.homefirst = (this.H_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.drawfirst = (this.D_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.drawfirst = (this.D_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.awayfirst = (this.A_1st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.awayfirst = (this.A_1st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)

                            home.homesecond = (this.H_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.homesecond = (this.H_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.drawsecond = (this.D_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.drawsecond = (this.D_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            home.awaysecond = (this.A_2st_calculation(b_data, main_data[j].localTeamId, 'home', home_date, '2')/(home.p)*100).toFixed(0)
                            away.awaysecond = (this.A_2st_calculation(b_data, main_data[j].visitorTeamId, 'away', away_date, '2')/(away.p)*100).toFixed(0)
                            if(home.p == 0){home.secondplus = 0; home.secondminus = 0; home.homefirst = 0; home.drawfirst = 0; home.awayfirst = 0; home.homesecond = 0; home.drawsecond = 0; home.awaysecond = 0}
                            if(away.p == 0){away.secondplus = 0; away.secondminus = 0; away.homefirst = 0; away.drawfirst = 0; away.awayfirst = 0; away.homesecond = 0; away.drawsecond = 0; away.awaysecond = 0}


                            let home_name = this.item3.home.name
                            let home_rank = this.item3.home.rank
                            let away_name = this.item3.away.name
                            let away_rank = this.item3.away.rank
                            let home_pos = this.item3.home.pos
                            let away_pos = this.item3.away.pos
                            let home_h_a = this.item3.home.h_a
                            let away_h_a = this.item3.away.h_a
                            let home_swing1 = this.item3.home.swing1
                            let away_swing1 = this.item3.away.swing1
                            let home_FH = this.item3.home.FH
                            let away_FH = this.item3.away.FH
                            let home_swing2 = this.item3.home.swing2
                            let away_swing2 = this.item3.away.swing2
                            let home_SH = this.item3.home.SH
                            let away_SH = this.item3.away.SH
                            let home_swing3 = this.item3.home.swing3
                            let away_swing3 = this.item3.away.swing3
                            let home_attack = this.item3.home.attack
                            let away_attack = this.item3.away.attack
                            let home_defense = this.item3.home.defense
                            let away_defense = this.item3.away.defense
                            let home_form_H_A = this.item3.home.form_H_A
                            let away_form_H_A = this.item3.away.form_H_A
                            let home_form = this.item3.home.form
                            let away_form = this.item3.away.form

                            this.item3.home = home
                            this.item3.away = away

                            this.item3.home.name = home_name
                            this.item3.home.rank = home_rank
                            this.item3.away.name = away_name
                            this.item3.away.rank = away_rank
                            this.item3.home.pos = home_pos
                            this.item3.away.pos = away_pos
                            this.item3.home.h_a = home_h_a
                            this.item3.away.h_a = away_h_a
                            this.item3.home.swing1 = home_swing1
                            this.item3.away.swing1 = away_swing1
                            this.item3.home.FH = home_FH
                            this.item3.away.FH = away_FH
                            this.item3.home.swing2 = home_swing2
                            this.item3.away.swing2 = away_swing2
                            this.item3.home.SH = home_SH
                            this.item3.away.SH = away_SH
                            this.item3.home.swing3 = home_swing3
                            this.item3.away.swing3 = away_swing3
                            this.item3.home.attack = home_attack
                            this.item3.away.attack = away_attack
                            this.item3.home.defense = home_defense
                            this.item3.away.defense = away_defense
                            this.item3.home.form_H_A = home_form_H_A
                            this.item3.away.form_H_A = away_form_H_A
                            this.item3.home.form = home_form
                            this.item3.away.form = away_form
                        }
                    }
                }
            },
            home_rank_refresh(ranks, val){
                console.log('refresh final data check==!', val, ', ', ranks)
                let c_home_id = val.home_id
                let c_away_id = val.away_id
                let main_data = this.mainData

                let start_date4 = new Date();
                let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                next_date4 = new Date(next_date4).toISOString()
                next_date4 = next_date4.substring(0,10)
                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){
                        let home = {
                            p:0,
                            name:'',
                            rank: '',
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondplus:0,
                            secondminus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1:'',
                            FH:0,
                            swing2:'',
                            SH:0,
                            swing3:'',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0

                        }
                        let away = this.away_team
                        let homeTeamId = main_data[j].localTeamId
                        let awayTeamId = main_data[j].visitorTeamId
                        if(homeTeamId == c_home_id && awayTeamId == c_away_id){
                            let seasonId = main_data[j].season_id
                            home.p = this.p_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            home.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2', ranks)/(home.p)*100).toFixed(0)
                            home.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2', ranks)/(home.p)*100).toFixed(0)
                            home.fh_probability = ((this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2', ranks)/(home.p) + away.pro)/2*100).toFixed(0)
                            home.sh_probability = ((this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2', ranks)/(home.p) + parseFloat(away.sh_percentage)/100)/2*100).toFixed(0)
                            home.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2', ranks)/(home.p)
                            // this.mainList[c].events[cc].home.name
                            if(home.p == 0){
                                home.fh_percentage = 0
                                home.sh_percentage = 0
                            }
                            if(away.p == 0){
                                away.fh_percentage = 0
                                away.sh_percentage = 0
                            }
                            if(home.p == 0 && away.p == 0){
                                home.fh_probability = 0
                                home.sh_probability = 0
                            }

                            home.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.over15 = (this.over15_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.over25 = (this.over25_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.over35 = (this.over35_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.scored = (this.scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.conc = (this.concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.001)*100).toFixed(0)
                            home.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)).toFixed(2)
                            home.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)).toFixed(2)
                            if(this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks) == 0){home.average1 = 0;}
                            if(this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks) == 0){home.average2 = 0;}
                            home.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            home.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '3', ranks)/(home.p + 0.0001)*100).toFixed(0)
                            let hgs1 = this.scored_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            let hgs2 = this.scored_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            home.gs1 = (hgs1/(hgs1 + hgs2)*100).toFixed(0)
                            home.gs2 = (hgs2/(hgs1 + hgs2)*100).toFixed(0)
                            if((hgs1 + hgs2) == 0){home.gs1 = 0; home.gs2 = 0}
                            let hgc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            let hgc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            home.gc1 = (hgc1/(hgc1 + hgc2)*100).toFixed(0)
                            home.gc2 = (hgc2/(hgc1 + hgc2)*100).toFixed(0)
                            if((hgc1 + hgc2) == 0){home.gc1 = 0; home.gc2 = 0}
                            home.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '3', ranks)/(home.p)*100).toFixed(0)
                            home.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '3', ranks)/(home.p)*100).toFixed(0)
                            home.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)

                            home.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            if(home.p == 0){home.over40 = 0; home.over85 = 0; home.C_H = 0; home.C_D = 0; home.C_A = 0; home.lastGoal = 0}
                            home.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            home.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '2')/(home.first10)*100).toFixed(0)
                            home.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.first10)*100).toFixed(0)
                            if(home.first10 == 0){home.first11 = 0; home.first20 = 0}
                            home.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)
                            home.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.second01)*100).toFixed(0)
                            home.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.second01)*100).toFixed(0)
                            if(home.second01 == 0){home.second11 = 0; home.second02 = 0}
                            home.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            home.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '3', ranks)/(home.p)*100).toFixed(0)
                            if(home.p == 0){home.secondplus = 0; home.secondminus = 0; home.homefirst = 0; home.drawfirst = 0; home.awayfirst = 0; home.homesecond = 0; home.drawsecond = 0; home.awaysecond = 0}                           

                            let home_name = this.item3.home.name
                            let home_rank = this.item3.home.rank
                           
                            let home_pos = this.item3.home.pos
                            
                            let home_h_a = this.item3.home.h_a
                            
                            let home_swing1 = this.item3.home.swing1
                            
                            let home_FH = this.item3.home.FH
                            
                            let home_swing2 = this.item3.home.swing2
                            
                            let home_SH = this.item3.home.SH
                            
                            let home_swing3 = this.item3.home.swing3
                            
                            let home_attack = this.item3.home.attack
                           
                            let home_defense = this.item3.home.defense
                            
                            let home_form_H_A = this.item3.home.form_H_A
                           
                            let home_form = this.item3.home.form
                           

                            this.item3.home = home
                            

                            this.item3.home.name = home_name
                            this.item3.home.rank = home_rank
                            
                            this.item3.home.pos = home_pos
                            
                            this.item3.home.h_a = home_h_a
                           
                            this.item3.home.swing1 = home_swing1
                           
                            this.item3.home.FH = home_FH
                           
                            this.item3.home.swing2 = home_swing2
                            
                            this.item3.home.SH = home_SH
                            
                            this.item3.home.swing3 = home_swing3
                            
                            this.item3.home.attack = home_attack
                           
                            this.item3.home.defense = home_defense
                            
                            this.item3.home.form_H_A = home_form_H_A
                           
                            this.item3.home.form = home_form
                            
                            
                        }
                    }
                }
            },
            away_rank_refresh(ranks, val){
                console.log('refresh final data check==!', val, ', ', ranks)
                let c_home_id = val.home_id
                let c_away_id = val.away_id
                let main_data = this.mainData

                let start_date4 = new Date();
                let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                next_date4 = new Date(next_date4).toISOString()
                next_date4 = next_date4.substring(0,10)

                for(let j = 0; j < main_data.length ; j++){
                    if(main_data[j].events.length < 100){

                        let away = {
                            p:0,
                            name:'',
                            rank: '',
                            z_z: 0,
                            over15: 0,
                            over25:0,
                            over35:0,
                            scored:0,
                            conc:0,
                            average1:0,
                            average2:0,
                            bts:0,
                            first1:0,
                            first2:0,
                            second1:0,
                            second2:0,
                            time15_S:0,
                            time30_S:0,
                            time45_S:0,
                            time60_S:0,
                            time75_S:0,
                            time90_S:0,
                            time15_C:0,
                            time30_C:0,
                            time45_C:0,
                            time60_C:0,
                            time75_C:0,
                            time90_C:0,
                            gs1:0,
                            gs2:0,
                            gc1:0,
                            gc2:0,
                            over40:0,
                            over85:0,
                            C_H:0,
                            C_D:0,
                            C_A:0,
                            first10:0,
                            first11:0,
                            first20:0,
                            second01:0,
                            second11:0,
                            second02:0,
                            firstGoal:0,
                            lastGoal:0,
                            secondplus:0,
                            secondminus:0,
                            homefirst:0,
                            drawfirst:0,
                            awayfirst:0,
                            homesecond:0,
                            drawsecond:0,
                            awaysecond:0,
                            eventdays:['All'],
                            pos:0,
                            h_a:0,
                            swing1:'',
                            FH:0,
                            swing2:'',
                            SH:0,
                            swing3:'',
                            attack:0,
                            defense:0,
                            form:0,
                            form_H_A:0

                        }
                        let home = this.home_team
                        let homeTeamId = main_data[j].localTeamId
                        let awayTeamId = main_data[j].visitorTeamId

                        if(homeTeamId == c_home_id && awayTeamId == c_away_id){
                            let seasonId = main_data[j].season_id

                            away.p = this.p_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            away.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '2', ranks)/(away.p)*100).toFixed(0)
                            away.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '2', ranks)/(away.p)*100).toFixed(0)
                            home.fh_probability = ((home.pro + this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '2', ranks)/(away.p))/2*100).toFixed(0)
                            home.sh_probability = ((parseFloat(home.sh_percentage)/100 + this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '2', ranks)/(away.p))/2*100).toFixed(0)
                            away.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '2', ranks)/(away.p)
                            if(home.p == 0){
                                home.fh_percentage = 0
                                home.sh_percentage = 0
                            }
                            if(away.p == 0){
                                away.fh_percentage = 0
                                away.sh_percentage = 0
                            }
                            if(home.p == 0 && away.p == 0){
                                home.fh_probability = 0
                                home.sh_probability = 0
                            }

                            away.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.over15 = (this.over15_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.over25 = (this.over25_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.over35 = (this.over35_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.scored = (this.scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.conc = (this.concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.001)*100).toFixed(0)
                            away.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)).toFixed(2)
                            away.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)).toFixed(2)
                            if(this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks) == 0){away.average1 = 0;}
                            if(this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks) == 0){away.average2 = 0;}
                            away.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            away.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '3', ranks)/(away.p + 0.0001)*100).toFixed(0)
                            let ags1 = this.scored_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            let ags2 = this.scored_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            away.gs1 = (ags1/(ags1 + ags2)*100).toFixed(0)
                            away.gs2 = (ags2/(ags1 + ags2)*100).toFixed(0)
                            if((ags1 + ags2) == 0){away.gs1 = 0 ; away.gs2 = 0}
                            let agc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            let agc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            away.gc1 = (agc1/(agc1 + agc2)*100).toFixed(0)
                            away.gc2 = (agc2/(agc1 + agc2)*100).toFixed(0)
                            if((agc1 + agc2) == 0){away.gc1 = 0 ; away.gc2 = 0}
                            away.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '3', ranks)/(away.p)*100).toFixed(0)
                            away.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '3', ranks)/(away.p)*100).toFixed(0)
                            away.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            if(away.p == 0){away.over40 = 0; away.over85 = 0; away.C_H = 0; away.C_D = 0; away.C_A = 0; away.lastGoal = 0}
                            away.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            away.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.first10)*100).toFixed(0)
                            away.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.first10)*100).toFixed(0)
                            if(away.first10 == 0){away.first11 = 0; away.first20 = 0}
                            away.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)
                            away.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.second01)*100).toFixed(0)
                            away.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.second01)*100).toFixed(0)
                            if(away.second01 == 0){away.second11 = 0; away.second02 = 0}
                            away.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            away.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '3', ranks)/(away.p)*100).toFixed(0)
                            if(away.p == 0){away.secondplus = 0; away.secondminus = 0; away.homefirst = 0; away.drawfirst = 0; away.awayfirst = 0; away.homesecond = 0; away.drawsecond = 0; away.awaysecond = 0}



                            let away_name = this.item3.away.name
                            let away_rank = this.item3.away.rank
                            
                            let away_pos = this.item3.away.pos
                            
                            let away_h_a = this.item3.away.h_a
                            
                            let away_swing1 = this.item3.away.swing1
                            
                            let away_FH = this.item3.away.FH
                            
                            let away_swing2 = this.item3.away.swing2
                            
                            let away_SH = this.item3.away.SH
                            
                            let away_swing3 = this.item3.away.swing3
                            
                            let away_attack = this.item3.away.attack
                           
                            let away_defense = this.item3.away.defense
                           
                            let away_form_H_A = this.item3.away.form_H_A
                            
                            let away_form = this.item3.away.form

                            
                            this.item3.away = away

                            
                            this.item3.away.name = away_name
                            this.item3.away.rank = away_rank
                            
                            this.item3.away.pos = away_pos
                            
                            this.item3.away.h_a = away_h_a
                            
                            this.item3.away.swing1 = away_swing1
                            
                            this.item3.away.FH = away_FH
                            
                            this.item3.away.swing2 = away_swing2
                           
                            this.item3.away.SH = away_SH
                           
                            this.item3.away.swing3 = away_swing3
                            
                            this.item3.away.attack = away_attack
                            
                            this.item3.away.defense = away_defense
                            
                            this.item3.away.form_H_A = away_form_H_A
                            
                            this.item3.away.form = away_form

                            
                        }
                    }
                }
            },
            home_rank_filter(val){
                if(val === 1){
                    //console.log("ALL")
                    let data = this.item_X
                    let ranks = {"from": 0, "to": 50}
                    this.home_rank_refresh(ranks, data)
                }
                else if(val === 2){
                    //console.log(this.rank_filter.v1)
                    let data = this.item_X
                    let ranks = this.rank_filter.v1
                    this.home_rank_refresh(ranks, data)
                }
                else if(val === 3){
                    //console.log(this.rank_filter.v2)
                    let data = this.item_X
                    let ranks = this.rank_filter.v2
                    this.home_rank_refresh(ranks, data)
                }
                else if(val === 4){
                    //console.log(this.rank_filter.v3)
                    let data = this.item_X
                    let ranks = this.rank_filter.v3
                    this.home_rank_refresh(ranks, data)
                }
                else if(val === 5){
                    //console.log(this.rank_filter.v4)
                    let data = this.item_X
                    let ranks = this.rank_filter.v4
                    this.home_rank_refresh(ranks, data)
                }
            },
            away_rank_filter(val){
                if(val === 1){
                    //console.log("ALL")
                    let data = this.item_X
                    let ranks = {"from": 0, "to": 50}
                    this.away_rank_refresh(ranks, data)
                }
                else if(val === 2){
                    //console.log(this.rank_filter.v1)
                    let data = this.item_X
                    let ranks = this.rank_filter.v1
                    this.away_rank_refresh(ranks, data)
                }
                else if(val === 3){
                    //console.log(this.rank_filter.v2)
                    let data = this.item_X
                    let ranks = this.rank_filter.v2
                    this.away_rank_refresh(ranks, data)
                }
                else if(val === 4){
                    //console.log(this.rank_filter.v3)
                    let data = this.item_X
                    let ranks = this.rank_filter.v3
                    this.away_rank_refresh(ranks, data)
                }
                else if(val === 5){
                    //console.log(this.rank_filter.v4)
                    let data = this.item_X
                    let ranks = this.rank_filter.v4
                    this.away_rank_refresh(ranks, data)
                }
            },
            sortJSON(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
                });
            },
            sortJSON1(data, key){
                return data.sort(function(a, b) {
                    var x = a[key]; var y = b[key];
                    return ((x > y) ? -1 : ((x < y) ? 1 : 0));
                });
            },
            /////////////////////////////////////////////
            h_a_calculation(standings, team_id, d){
                let p = 0
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let home_away_table = {
                    "home": [],
                    "away": []
                }

                for(let i = 0 ; i < season_data.length ; i++){
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    if(season_data[i].home != null){
                        home_team_data.home.p = season_data[i].home.games_played
                        home_team_data.team_name = season_data[i].team_name
                        home_team_data.team_id = season_data[i].team_id
                        home_team_data.home.w = season_data[i].home.won
                        home_team_data.d = season_data[i].home.draw
                        home_team_data.home.l = season_data[i].home.lost
                        home_team_data.home.f = season_data[i].home.goals_scored
                        home_team_data.f = season_data[i].home.goals_scored
                        home_team_data.home.a = season_data[i].home.goals_against
                        home_team_data.last.d = season_data[i].home.goals_scored - season_data[i].home.goals_against
                        home_team_data.gd = season_data[i].home.goals_scored - season_data[i].home.goals_against
                        home_team_data.last.points = home_team_data.home.w*3 + home_team_data.d
                        home_team_data.av = (home_team_data.last.points/home_team_data.home.p).toFixed(2)
                    }
                    if(season_data[i].away != null){
                        away_team_data.away.p = season_data[i].away.games_played
                        away_team_data.team_name = season_data[i].team_name
                        away_team_data.team_id = season_data[i].team_id
                        away_team_data.away.w = season_data[i].away.won
                        away_team_data.d = season_data[i].away.draw
                        away_team_data.away.l = season_data[i].away.lost
                        away_team_data.away.f = season_data[i].away.goals_scored
                        away_team_data.f = season_data[i].away.goals_scored
                        away_team_data.away.a = season_data[i].away.goals_against
                        away_team_data.last.d = season_data[i].away.goals_scored - season_data[i].away.goals_against
                        away_team_data.gd = season_data[i].away.goals_scored - season_data[i].away.goals_against
                        away_team_data.last.points = away_team_data.away.w*3 + away_team_data.d
                        away_team_data.av = (away_team_data.last.points/away_team_data.away.p).toFixed(2)
                    }
                    home_away_table.home.push(home_team_data)
                    home_away_table.away.push(away_team_data)
                }

                this.sortJSON1(home_away_table.home,'av', '123');
                this.sortJSON1(home_away_table.away,'av', '123');

                let new_away_table1 = []
                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    let len = home_away_table.home.filter(function(item) {
                        return item.av == home_away_table.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(home_away_table.home[j])
                    }
                }
                home_away_table.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    let len = home_away_table.home.filter(function(item) {
                        return (item.av == home_away_table.home[j].av && item.gd == home_away_table.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(home_away_table.home[j])
                    }
                }
                home_away_table.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    let len = home_away_table.away.filter(function(item) {
                        return item.av == home_away_table.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(home_away_table.away[j])
                    }
                }
                home_away_table.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    let len = home_away_table.away.filter(function(item) {
                        return (item.av == home_away_table.away[j].av && item.gd == home_away_table.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(home_away_table.away[j])
                    }
                }
                home_away_table.away = new_away_table3

                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    if(home_away_table.home[j].team_id == team_id && d == '1'){
                        p = j + 1
                    }
                }
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    if(home_away_table.away[j].team_id == team_id && d == '2'){
                        p = j + 1
                    }
                }
                return p
            },
            h_a_calculation(standings, team_id, d){
                let p = 0
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let home_away_table = {
                    "home": [],
                    "away": []
                }

                for(let i = 0 ; i < season_data.length ; i++){
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    if(season_data[i].home != null){
                        home_team_data.home.p = season_data[i].home.games_played
                        home_team_data.team_name = season_data[i].team_name
                        home_team_data.team_id = season_data[i].team_id
                        home_team_data.home.w = season_data[i].home.won
                        home_team_data.d = season_data[i].home.draw
                        home_team_data.home.l = season_data[i].home.lost
                        home_team_data.home.f = season_data[i].home.goals_scored
                        home_team_data.f = season_data[i].home.goals_scored
                        home_team_data.home.a = season_data[i].home.goals_against
                        home_team_data.last.d = season_data[i].home.goals_scored - season_data[i].home.goals_against
                        home_team_data.gd = season_data[i].home.goals_scored - season_data[i].home.goals_against
                        home_team_data.last.points = home_team_data.home.w*3 + home_team_data.d
                        home_team_data.av = (home_team_data.last.points/home_team_data.home.p).toFixed(2)
                    }
                    if(season_data[i].away != null){
                        away_team_data.away.p = season_data[i].away.games_played
                        away_team_data.team_name = season_data[i].team_name
                        away_team_data.team_id = season_data[i].team_id
                        away_team_data.away.w = season_data[i].away.won
                        away_team_data.d = season_data[i].away.draw
                        away_team_data.away.l = season_data[i].away.lost
                        away_team_data.away.f = season_data[i].away.goals_scored
                        away_team_data.f = season_data[i].away.goals_scored
                        away_team_data.away.a = season_data[i].away.goals_against
                        away_team_data.last.d = season_data[i].away.goals_scored - season_data[i].away.goals_against
                        away_team_data.gd = season_data[i].away.goals_scored - season_data[i].away.goals_against
                        away_team_data.last.points = away_team_data.away.w*3 + away_team_data.d
                        away_team_data.av = (away_team_data.last.points/away_team_data.away.p).toFixed(2)
                    }
                    home_away_table.home.push(home_team_data)
                    home_away_table.away.push(away_team_data)
                }

                this.sortJSON1(home_away_table.home,'av', '123');
                this.sortJSON1(home_away_table.away,'av', '123');

                let new_away_table1 = []
                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    let len = home_away_table.home.filter(function(item) {
                        return item.av == home_away_table.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(home_away_table.home[j])
                    }
                }
                home_away_table.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    let len = home_away_table.home.filter(function(item) {
                        return (item.av == home_away_table.home[j].av && item.gd == home_away_table.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(home_away_table.home[j])
                    }
                }
                home_away_table.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    let len = home_away_table.away.filter(function(item) {
                        return item.av == home_away_table.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(home_away_table.away[j])
                    }
                }
                home_away_table.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    let len = home_away_table.away.filter(function(item) {
                        return (item.av == home_away_table.away[j].av && item.gd == home_away_table.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_away_table.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(home_away_table.away[j])
                    }
                }
                home_away_table.away = new_away_table3

                for(let j = 0 ; j < home_away_table.home.length ; j++){
                    if(home_away_table.home[j].team_id == team_id && d == '1'){
                        p = j + 1
                    }
                }
                for(let j = 0 ; j < home_away_table.away.length ; j++){
                    if(home_away_table.away[j].team_id == team_id && d == '2'){
                        p = j + 1
                    }
                }
                return p
            },
            first_half_p(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                p++
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            first_half_w(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].localteamId == team_id && local_score > visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].visitorteamId == team_id && local_score < visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            first_half_d(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].localteamId == team_id && local_score == visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].visitorteamId == team_id && local_score == visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            first_half_l(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].localteamId == team_id && local_score < visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].visitorteamId == team_id && local_score > visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            first_half_f(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                if(events[i].events[j].localteamId == team_id){
                                    p += local_score
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].visitorteamId == team_id){
                                    p += visitor_score
                                }
                            }
                        }
                    }
                }
                return p
            },
            first_half_a(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let visitor_score = parseInt(events[i].events[j].hf_score.split("-")[1])
                                if(events[i].events[j].localteamId == team_id){
                                    p += visitor_score
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].hf_score != null){
                                let local_score = parseInt(events[i].events[j].hf_score.split("-")[0])
                                if(events[i].events[j].visitorteamId == team_id){
                                    p += local_score
                                }
                            }
                        }
                    }
                }
                return p
            },
            f_h_calculation(standings, events, team_id, d){
                console.log('----team id', team_id)
                console.log('----d', d)
                let ppp = 1
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let first_half = {
                    "home": [],
                    "away": []
                }
                for (let i = 0; i < season_data.length; i++) {
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }

                    home_team_data.team_name = season_data[i].team_name
                    home_team_data.team_id = season_data[i].team_id

                    away_team_data.team_name = season_data[i].team_name
                    away_team_data.team_id = season_data[i].team_id
                    first_half.home.push(home_team_data)
                    first_half.away.push(away_team_data)
                }

                for(let i = 0 ; i < first_half.home.length ; i++){
                    first_half.home[i].home.p = this.first_half_p(first_half.home[i].team_id, events, '1')
                    first_half.away[i].away.p = this.first_half_p(first_half.away[i].team_id, events, '2')
                    first_half.home[i].home.w = this.first_half_w(first_half.home[i].team_id, events, '1')
                    first_half.away[i].away.w = this.first_half_w(first_half.away[i].team_id, events, '2')
                    first_half.home[i].d = this.first_half_d(first_half.home[i].team_id, events, '1')
                    first_half.away[i].d = this.first_half_d(first_half.away[i].team_id, events, '2')
                    first_half.home[i].home.l = this.first_half_l(first_half.home[i].team_id, events, '1')
                    first_half.away[i].away.l = this.first_half_l(first_half.away[i].team_id, events, '2')
                    first_half.home[i].home.f = this.first_half_f(first_half.home[i].team_id, events, '1')
                    first_half.home[i].f = this.first_half_f(first_half.home[i].team_id, events, '1')
                    first_half.away[i].away.f = this.first_half_f(first_half.away[i].team_id, events, '2')
                    first_half.away[i].f = this.first_half_f(first_half.away[i].team_id, events, '2')
                    first_half.home[i].home.a = this.first_half_a(first_half.home[i].team_id, events, '1')
                    first_half.away[i].away.a = this.first_half_a(first_half.away[i].team_id, events, '2')
                    first_half.home[i].last.d = first_half.home[i].home.f - first_half.home[i].home.a
                    first_half.away[i].last.d = first_half.away[i].away.f - first_half.away[i].away.a
                    first_half.home[i].gd = first_half.home[i].home.f - first_half.home[i].home.a
                    first_half.away[i].gd = first_half.away[i].away.f - first_half.away[i].away.a
                    first_half.home[i].last.points = this.first_half_w(first_half.home[i].team_id, events, '1')*3 + this.first_half_d(first_half.home[i].team_id, events, '1')
                    first_half.away[i].last.points = this.first_half_w(first_half.home[i].team_id, events, '2')*3 + this.first_half_d(first_half.home[i].team_id, events, '2')
                    first_half.home[i].av = (first_half.home[i].last.points/first_half.home[i].home.p).toFixed(2)
                    first_half.away[i].av = (first_half.away[i].last.points/first_half.away[i].away.p).toFixed(2)
                }

                this.sortJSON1(first_half.home, 'av', '123')
                this.sortJSON1(first_half.away, 'av', '123')

                let new_away_table1 = []
                for(let j = 0 ; j < first_half.home.length ; j++){
                    let len = first_half.home.filter(function(item) {
                        return item.av == first_half.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            first_half.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(first_half.home[j])
                    }
                }
                first_half.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < first_half.home.length ; j++){
                    let len = first_half.home.filter(function(item) {
                        return (item.av == first_half.home[j].av && item.gd == first_half.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123')
                        for(let p = j ; p < j + len.length ; p++){
                            first_half.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(first_half.home[j])
                    }
                }
                first_half.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < first_half.away.length ; j++){
                    let len = first_half.away.filter(function(item) {
                        return item.av == first_half.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            first_half.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(first_half.away[j])
                    }
                }
                first_half.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < first_half.away.length ; j++){
                    let len = first_half.away.filter(function(item) {
                        return (item.av == first_half.away[j].av && item.gd == first_half.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            first_half.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(first_half.away[j])
                    }
                }
                first_half.away = new_away_table3

                console.log("first half=>", first_half)
                for(let j = 0 ; j < first_half.home.length ; j++){
                    if(first_half.home[j].team_id == team_id && d == '1'){
                        ppp = j + 1;
                        console.log('------ home team', j)
                    }
                }
                for(let j = 0 ; j < first_half.away.length ; j++){
                    if(first_half.away[j].team_id == team_id && d == '2'){
                        ppp = j + 1;
                        console.log('------ away team', j)
                    }
                }
                console.log('------ppp', ppp)
                return ppp
            },
            second_half_p(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                p++
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            second_half_w(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].localteamId == team_id && local_score > visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].visitorteamId == team_id && local_score < visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            second_half_d(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].localteamId == team_id && local_score == visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].visitorteamId == team_id && local_score == visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            second_half_l(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].localteamId == team_id && local_score < visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let local_score = local_score1 - local_score2
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].visitorteamId == team_id && local_score > visitor_score){
                                    p++
                                }
                            }
                        }
                    }
                }
                return p
            },
            second_half_f(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let local_score = local_score1 - local_score2
                                if(events[i].events[j].localteamId == team_id){
                                    p += local_score
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].visitorteamId == team_id){
                                    p += visitor_score
                                }
                            }
                        }
                    }
                }
                return p
            },
            second_half_a(team_id, events, d){
                let p = 0
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let visitor_score1 = parseInt(events[i].events[j].ft_score.split("-")[1])
                                let visitor_score2 = parseInt(events[i].events[j].hf_score.split("-")[1])
                                let visitor_score = visitor_score1 - visitor_score2
                                if(events[i].events[j].localteamId == team_id){
                                    p += visitor_score
                                }
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].ft_score != null && events[i].events[j].hf_score != null){
                                let local_score1 = parseInt(events[i].events[j].ft_score.split("-")[0])
                                let local_score2 = parseInt(events[i].events[j].hf_score.split("-")[0])
                                let local_score = local_score1 - local_score2
                                if(events[i].events[j].visitorteamId == team_id){
                                    p += local_score
                                }
                            }
                        }
                    }
                }
                return p
            },
            s_h_calculation(standings, events, team_id, d){
                let p = 1
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let second_half = {
                    "home": [],
                    "away": []
                }
                for (let i = 0; i < season_data.length; i++) {
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "av": null,
                        "gd": null,
                    }

                    home_team_data.team_name = season_data[i].team_name
                    home_team_data.team_id = season_data[i].team_id

                    away_team_data.team_name = season_data[i].team_name
                    away_team_data.team_id = season_data[i].team_id
                    second_half.home.push(home_team_data)
                    second_half.away.push(away_team_data)
                }

                for(let i = 0 ; i < second_half.home.length ; i++){
                    second_half.home[i].home.p = this.second_half_p(second_half.home[i].team_id, events, '1')
                    second_half.away[i].away.p = this.second_half_p(second_half.away[i].team_id, events, '2')
                    second_half.home[i].home.w = this.second_half_w(second_half.home[i].team_id, events, '1')
                    second_half.away[i].away.w = this.second_half_w(second_half.away[i].team_id, events, '2')
                    second_half.home[i].d = this.second_half_d(second_half.home[i].team_id, events, '1')
                    second_half.away[i].d = this.second_half_d(second_half.away[i].team_id, events, '2')
                    second_half.home[i].home.l = this.second_half_l(second_half.home[i].team_id, events, '1')
                    second_half.away[i].away.l = this.second_half_l(second_half.away[i].team_id, events, '2')
                    second_half.home[i].home.f = this.second_half_f(second_half.home[i].team_id, events, '1')
                    second_half.home[i].f = this.second_half_f(second_half.home[i].team_id, events, '1')
                    second_half.away[i].away.f = this.second_half_f(second_half.away[i].team_id, events, '2')
                    second_half.away[i].f = this.second_half_f(second_half.away[i].team_id, events, '2')
                    second_half.home[i].home.a = this.second_half_a(second_half.home[i].team_id, events, '1')
                    second_half.away[i].away.a = this.second_half_a(second_half.away[i].team_id, events, '2')
                    second_half.home[i].last.d = second_half.home[i].home.f - second_half.home[i].home.a
                    second_half.away[i].last.d = second_half.away[i].away.f - second_half.away[i].away.a
                    second_half.home[i].gd = second_half.home[i].home.f - second_half.home[i].home.a
                    second_half.away[i].gd = second_half.away[i].away.f - second_half.away[i].away.a
                    second_half.home[i].last.points = this.second_half_w(second_half.home[i].team_id, events, '1')*3 + this.second_half_d(second_half.home[i].team_id, events, '1')
                    second_half.away[i].last.points = this.second_half_w(second_half.home[i].team_id, events, '2')*3 + this.second_half_d(second_half.home[i].team_id, events, '2')
                    second_half.home[i].av = (second_half.home[i].last.points/second_half.home[i].home.p).toFixed(2)
                    second_half.away[i].av = (second_half.away[i].last.points/second_half.away[i].away.p).toFixed(2)
                }

                this.sortJSON1(second_half.home, 'av', '123');
                this.sortJSON1(second_half.away, 'av', '123');

                let new_away_table1 = []
                for(let j = 0 ; j < second_half.home.length ; j++){
                    let len = second_half.home.filter(function(item) {
                        return item.av == second_half.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            second_half.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(second_half.home[j])
                    }
                }
                second_half.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < second_half.home.length ; j++){
                    let len = second_half.home.filter(function(item) {
                        return (item.av == second_half.home[j].av && item.gd == second_half.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            second_half.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(second_half.home[j])
                    }
                }
                second_half.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < second_half.away.length ; j++){
                    let len = second_half.away.filter(function(item) {
                        return item.av == second_half.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            second_half.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(second_half.away[j])
                    }
                }
                second_half.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < second_half.away.length ; j++){
                    let len = second_half.away.filter(function(item) {
                        return (item.av == second_half.away[j].av && item.gd == second_half.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            second_half.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(second_half.away[j])
                    }
                }
                second_half.away = new_away_table3

                for(let j = 0 ; j < second_half.home.length ; j++){
                    if(second_half.home[j].team_id == team_id && d == '1'){
                        p = j + 1
                    }
                }
                for(let j = 0 ; j < second_half.away.length ; j++){
                    if(second_half.away[j].team_id == team_id && d == '2'){
                        p = j + 1
                    }
                }
                return p
            },
            att_calculation(standings, team_id, d){
                let p = 1
                if (standings.length == 0)
                    return '-'
                let full_table = []
                let home_A_away_D = {
                    "home": [],
                    "away": []
                }

                let season_data = standings[0].standings
                for(let i = 0 ; i < season_data.length ; i++){
                    let new_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "total": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "home": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "away": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "gd": null,
                        "points": null
                    }
                    if(season_data[i].overall != null){
                        new_team_data.total.p = season_data[i].overall.games_played
                        new_team_data.total.w = season_data[i].overall.won
                        new_team_data.total.d = season_data[i].overall.draw
                        new_team_data.total.l = season_data[i].overall.lost
                        new_team_data.total.f = season_data[i].overall.goals_scored
                        new_team_data.total.a = season_data[i].overall.goals_against
                    }
                    if(season_data[i].home != null){
                        new_team_data.home.p = season_data[i].home.games_played
                        new_team_data.home.w = season_data[i].home.won
                        new_team_data.home.d = season_data[i].home.draw
                        new_team_data.home.l = season_data[i].home.lost
                        new_team_data.home.f = season_data[i].home.goals_scored
                        new_team_data.home.a = season_data[i].home.goals_against
                    }
                    if(season_data[i].away != null){
                        new_team_data.away.p = season_data[i].away.games_played
                        new_team_data.away.w = season_data[i].away.won
                        new_team_data.away.d = season_data[i].away.draw
                        new_team_data.away.l = season_data[i].away.lost
                        new_team_data.away.f = season_data[i].away.goals_scored
                        new_team_data.away.a = season_data[i].away.goals_against
                    }
                    new_team_data.last.points = season_data[i].points
                    new_team_data.last.d = season_data[i].total.goal_difference
                    new_team_data.team_name = season_data[i].team_name
                    new_team_data.team_id = season_data[i].team_id
                    new_team_data.f = new_team_data.total.f
                    new_team_data.gd = new_team_data.last.d
                    new_team_data.points = new_team_data.last.points
                    full_table.push(new_team_data)
                }

                for(let i = 0 ; i < full_table.length ; i++){
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": full_table[i].team_name,
                        "team_id": full_table[i].team_id,
                        "over": null,
                        "p": full_table[i].home.p,
                        "f": full_table[i].home.f,
                        "gd": full_table[i].home.f - full_table[i].home.a,
                        "av": (full_table[i].home.f/full_table[i].home.p).toFixed(2),
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": full_table[i].team_name,
                        "team_id": full_table[i].team_id,
                        "over": null,
                        "p": full_table[i].away.p,
                        "f": full_table[i].away.a,
                        "gd": full_table[i].away.f - full_table[i].away.a,
                        "av": (full_table[i].away.a/full_table[i].away.p).toFixed(2),
                    }
                    home_A_away_D.home.push(home_team_data)
                    home_A_away_D.away.push(away_team_data)
                }
                // console.log("season data=>", home_A_away_D)
                this.sortJSON1(home_A_away_D.home, 'av', '123')
                this.sortJSON(home_A_away_D.away, 'av', '123')

                let new_away_table1 = []
                for(let j = 0 ; j < home_A_away_D.home.length ; j++){
                    let len = home_A_away_D.home.filter(function(item) {
                        return item.av == home_A_away_D.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_A_away_D.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(home_A_away_D.home[j])
                    }
                }
                home_A_away_D.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < home_A_away_D.home.length ; j++){
                    let len = home_A_away_D.home.filter(function(item) {
                        return (item.av == home_A_away_D.home[j].av && item.gd == home_A_away_D.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_A_away_D.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(home_A_away_D.home[j])
                    }
                }
                home_A_away_D.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < home_A_away_D.away.length ; j++){
                    let len = home_A_away_D.away.filter(function(item) {
                        return item.av == home_A_away_D.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_A_away_D.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(home_A_away_D.away[j])
                    }
                }
                home_A_away_D.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < home_A_away_D.away.length ; j++){
                    let len = home_A_away_D.away.filter(function(item) {
                        return (item.av == home_A_away_D.away[j].av && item.gd == home_A_away_D.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_A_away_D.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(home_A_away_D.away[j])
                    }
                }
                home_A_away_D.away = new_away_table3

                for(let j = 0 ; j < home_A_away_D.home.length ; j++){
                    if(home_A_away_D.home[j].team_id == team_id && d == '1'){
                        p = j + 1
                    }
                }
                for(let j = 0 ; j < home_A_away_D.home.length ; j++){
                    if(home_A_away_D.away[j].team_id == team_id && d == '2'){
                        p = j + 1
                    }
                }
                // console.log("season data=>", p)
                return p
            },
            def_calculation(standings, team_id, d){

                let p = 1
                if (standings.length == 0)
                    return '-'
                let full_table = []
                let home_D_away_A = {
                    "home": [],
                    "away": []
                }
                let season_data = standings[0].standings
                for(let i = 0 ; i < season_data.length ; i++){
                    let new_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "total": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "home": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "away": {
                            "p": null,
                            "w": null,
                            "d": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "last": {
                            "d": null,
                            "points": null,
                        },
                        "f": null,
                        "gd": null,
                        "points": null
                    }
                    if(season_data[i].overall != null){
                        new_team_data.total.p = season_data[i].overall.games_played
                        new_team_data.total.w = season_data[i].overall.won
                        new_team_data.total.d = season_data[i].overall.draw
                        new_team_data.total.l = season_data[i].overall.lost
                        new_team_data.total.f = season_data[i].overall.goals_scored
                        new_team_data.total.a = season_data[i].overall.goals_against
                    }
                    if(season_data[i].home != null){
                        new_team_data.home.p = season_data[i].home.games_played
                        new_team_data.home.w = season_data[i].home.won
                        new_team_data.home.d = season_data[i].home.draw
                        new_team_data.home.l = season_data[i].home.lost
                        new_team_data.home.f = season_data[i].home.goals_scored
                        new_team_data.home.a = season_data[i].home.goals_against
                    }
                    if(season_data[i].away != null){
                        new_team_data.away.p = season_data[i].away.games_played
                        new_team_data.away.w = season_data[i].away.won
                        new_team_data.away.d = season_data[i].away.draw
                        new_team_data.away.l = season_data[i].away.lost
                        new_team_data.away.f = season_data[i].away.goals_scored
                        new_team_data.away.a = season_data[i].away.goals_against
                    }
                    new_team_data.last.points = season_data[i].points
                    new_team_data.last.d = season_data[i].total.goal_difference
                    new_team_data.team_name = season_data[i].team_name
                    new_team_data.team_id = season_data[i].team_id
                    new_team_data.f = new_team_data.total.f
                    new_team_data.gd = new_team_data.last.d
                    new_team_data.points = new_team_data.last.points
                    full_table.push(new_team_data)
                }

                for(let i = 0 ; i < full_table.length ; i++){
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": full_table[i].team_name,
                        "team_id": full_table[i].team_id,
                        "over": null,
                        "p": full_table[i].home.p,
                        "f": full_table[i].home.a,
                        "gd": full_table[i].home.f - full_table[i].home.a,
                        "av": (full_table[i].home.a/full_table[i].home.p).toFixed(2),
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": full_table[i].team_name,
                        "team_id": full_table[i].team_id,
                        "over": null,
                        "p": full_table[i].away.p,
                        "f": full_table[i].away.f,
                        "gd": full_table[i].away.f - full_table[i].away.a,
                        "av": (full_table[i].away.f/full_table[i].away.p).toFixed(2),
                    }
                    home_D_away_A.home.push(home_team_data)
                    home_D_away_A.away.push(away_team_data)
                }

                this.sortJSON(home_D_away_A.home, 'av', '123')
                this.sortJSON1(home_D_away_A.away, 'av', '123')


                let new_away_table1 = []
                for(let j = 0 ; j < home_D_away_A.home.length ; j++){
                    let len = home_D_away_A.home.filter(function(item) {
                        return item.av == home_D_away_A.home[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_D_away_A.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(home_D_away_A.home[j])
                    }
                }
                home_D_away_A.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < home_D_away_A.home.length ; j++){
                    let len = home_D_away_A.home.filter(function(item) {
                        return (item.av == home_D_away_A.home[j].av && item.gd == home_D_away_A.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_D_away_A.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(home_D_away_A.home[j])
                    }
                }
                home_D_away_A.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < home_D_away_A.away.length ; j++){
                    let len = home_D_away_A.away.filter(function(item) {
                        return item.av == home_D_away_A.away[j].av
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_D_away_A.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(home_D_away_A.away[j])
                    }
                }
                home_D_away_A.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < home_D_away_A.away.length ; j++){
                    let len = home_D_away_A.away.filter(function(item) {
                        return (item.av == home_D_away_A.away[j].av && item.gd == home_D_away_A.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            home_D_away_A.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(home_D_away_A.away[j])
                    }
                }
                home_D_away_A.away = new_away_table3

                for(let j = 0 ; j < home_D_away_A.home.length ; j++){
                    if(home_D_away_A.home[j].team_id == team_id && d == '1'){
                        p = j + 1
                    }
                }

                for(let j = 0 ; j < home_D_away_A.away.length ; j++){
                    if(home_D_away_A.away[j].team_id == team_id && d == '2'){
                        p = j + 1
                    }
                }
                return p
            },
            overall_p(team_id, events, d){
                let p = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        if(p > 5){ break }
                        p++
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        if(p > 11){ break }
                        p++
                    }
                }
                return p
            },
            overall_w(team_id, events, d){
                let p = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                let p1 = 0
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 6){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if((new_event_arr[i].localteamId == team_id && local_score > visitor_score) || (new_event_arr[i].visitorteamId == team_id && local_score < visitor_score)){
                                p++
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 12){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if((new_event_arr[i].localteamId == team_id && local_score > visitor_score) || (new_event_arr[i].visitorteamId == team_id && local_score < visitor_score)){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            overall_d(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 6){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(local_score == visitor_score){
                                p++
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 12){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(local_score == visitor_score){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            overall_l(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 6){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if((new_event_arr[i].localteamId == team_id && local_score < visitor_score) || (new_event_arr[i].visitorteamId == team_id && local_score > visitor_score)){
                                p++
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 12){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if((new_event_arr[i].localteamId == team_id && local_score < visitor_score) || (new_event_arr[i].visitorteamId == team_id && local_score > visitor_score)){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            overall_f(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 6){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(new_event_arr[i].localteamId == team_id){
                                p += local_score
                            }
                            if(new_event_arr[i].visitorteamId == team_id){
                                p += visitor_score
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p > 12){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(new_event_arr[i].localteamId == team_id){
                                p += local_score
                            }
                            if(new_event_arr[i].visitorteamId == team_id){
                                p += visitor_score
                            }
                        }
                    }
                }
                return p
            },
            overall_a(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                for(let i = 0 ; i < events.length ; i++){
                    for(let j = 0 ; j < events[i].events.length ; j++){
                        if(events[i].events[j].localteamId == team_id || events[i].events[j].visitorteamId == team_id){
                            new_event_arr.push(events[i].events[j])
                        }
                    }
                }
                this.sortJSON1(new_event_arr,'date', '123');
                if(d === '1'){
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 6){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(new_event_arr[i].localteamId == team_id){
                                p += visitor_score
                            }
                            if(new_event_arr[i].visitorteamId == team_id){
                                p += local_score
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < new_event_arr.length ; i++){
                        p1++
                        if(p1 > 12){ break }
                        if(new_event_arr[i].ft_score != null){
                            let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                            let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                            if(new_event_arr[i].localteamId == team_id){
                                p += visitor_score
                            }
                            if(new_event_arr[i].visitorteamId == team_id){
                                p += local_score
                            }
                        }
                    }
                }
                return p
            },
            form_calculation(standings, events, team_id, d){
                let p = 0
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let overall = {
                    "home": [],
                    "away": []
                }
                for (let i = 0; i < season_data.length; i++) {
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "f": null,
                        "points": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "f": null,
                        "points": null,
                        "gd": null,
                    }
                    home_team_data.team_name = season_data[i].team_name
                    home_team_data.team_id = season_data[i].team_id

                    away_team_data.team_name = season_data[i].team_name
                    away_team_data.team_id = season_data[i].team_id
                    overall.home.push(home_team_data)
                    overall.away.push(away_team_data)
                }

                for(let i = 0 ; i < overall.home.length ; i++){
                    overall.home[i].home.p = this.overall_p(overall.home[i].team_id, events, '1')
                    overall.away[i].away.p = this.overall_p(overall.away[i].team_id, events, '2')
                    overall.home[i].home.w = this.overall_w(overall.home[i].team_id, events, '1')
                    overall.away[i].away.w = this.overall_w(overall.away[i].team_id, events, '2')
                    overall.home[i].d = this.overall_d(overall.home[i].team_id, events, '1')
                    overall.away[i].d = this.overall_d(overall.away[i].team_id, events, '2')
                    overall.home[i].home.l = this.overall_l(overall.home[i].team_id, events, '1')
                    overall.away[i].away.l = this.overall_l(overall.away[i].team_id, events, '2')
                    overall.home[i].home.f = this.overall_f(overall.home[i].team_id, events, '1')
                    overall.home[i].f = this.overall_f(overall.home[i].team_id, events, '1')
                    overall.away[i].away.f = this.overall_f(overall.away[i].team_id, events, '2')
                    overall.away[i].f = this.overall_f(overall.away[i].team_id, events, '2')
                    overall.home[i].home.a = this.overall_a(overall.home[i].team_id, events, '1')
                    overall.away[i].away.a = this.overall_a(overall.away[i].team_id, events, '2')
                    overall.home[i].gd = overall.home[i].home.f - overall.home[i].home.a
                    overall.away[i].gd = overall.away[i].away.f - overall.away[i].away.a
                    overall.home[i].points = this.overall_w(overall.home[i].team_id, events, '1')*3 + this.overall_d(overall.home[i].team_id, events, '1')
                    overall.away[i].points = this.overall_w(overall.away[i].team_id, events, '2')*3 + this.overall_d(overall.away[i].team_id, events, '2')
                }

                this.sortJSON1(overall.home, 'points', '123');
                this.sortJSON1(overall.away, 'points', '123');

                let new_away_table1 = []
                for(let j = 0 ; j < overall.home.length ; j++){
                    let len = overall.home.filter(function(item) {
                        return item.points == overall.home[j].points
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            overall.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(overall.home[j])
                    }
                }
                overall.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < overall.home.length ; j++){
                    let len = overall.home.filter(function(item) {
                        return (item.points == overall.home[j].points && item.gd == overall.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            overall.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(overall.home[j])
                    }
                }
                overall.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < overall.away.length ; j++){
                    let len = overall.away.filter(function(item) {
                        return item.points == overall.away[j].points
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            overall.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(overall.away[j])
                    }
                }
                overall.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < overall.away.length ; j++){
                    let len = overall.away.filter(function(item) {
                        return (item.points == overall.away[j].points && item.gd == overall.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            overall.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(overall.away[j])
                    }
                }
                overall.away = new_away_table3

                for(let j = 0 ; j < overall.home.length ; j++){
                    if(overall.home[j].team_id == team_id){
                        p = j + 1
                    }
                }
                return p
            },
            form_3_p(team_id, events, d){
                let p = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    if(p > 2){ break }
                    p++
                }
                return p
            },
            form_3_w(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    p1++
                    if(p1 > 3){ break }
                    if(new_event_arr[i].ft_score != null){
                        let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                        let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                        if(d === '1'){
                            if(new_event_arr[i].localteamId == team_id && local_score > visitor_score){
                                p++
                            }
                        }
                        else{
                            if(new_event_arr[i].visitorteamId == team_id && local_score < visitor_score){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            form_3_d(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    p1++
                    if(p1 > 3){ break }
                    if(new_event_arr[i].ft_score != null){
                        let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                        let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                        if(d === '1'){
                            if(new_event_arr[i].localteamId == team_id && local_score == visitor_score){
                                p++
                            }
                        }
                        else{
                            if(new_event_arr[i].visitorteamId == team_id && local_score == visitor_score){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            form_3_l(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    p1++
                    if(p1 > 3){ break }
                    if(new_event_arr[i].ft_score != null){
                        let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                        let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                        if(d === '1'){
                            if(new_event_arr[i].localteamId == team_id && local_score < visitor_score){
                                p++
                            }
                        }
                        else{
                            if(new_event_arr[i].visitorteamId == team_id && local_score > visitor_score){
                                p++
                            }
                        }
                    }
                }
                return p
            },
            form_3_f(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    p1++
                    if(p1 > 3){ break }
                    if(new_event_arr[i].ft_score != null){
                        let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                        let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                        if(d === '1'){
                            if(new_event_arr[i].localteamId == team_id){
                                p+=local_score
                            }
                        }
                        else{
                            if(new_event_arr[i].visitorteamId == team_id){
                                p+=visitor_score
                            }
                        }
                    }
                }
                return p
            },
            form_3_a(team_id, events, d){
                let p = 0
                let p1 = 0
                let new_event_arr = []
                if(d === '1'){
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].localteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }
                else{
                    for(let i = 0 ; i < events.length ; i++){
                        for(let j = 0 ; j < events[i].events.length ; j++){
                            if(events[i].events[j].visitorteamId == team_id){
                                new_event_arr.push(events[i].events[j])
                            }
                        }
                    }
                }

                this.sortJSON1(new_event_arr,'date', '123');
                for(let i = 0 ; i < new_event_arr.length ; i++){
                    p1++
                    if(p1 > 3){ break }
                    if(new_event_arr[i].ft_score != null){
                        let local_score = parseInt(new_event_arr[i].ft_score.split("-")[0])
                        let visitor_score = parseInt(new_event_arr[i].ft_score.split("-")[1])
                        if(d === '1'){
                            if(new_event_arr[i].localteamId == team_id){
                                p+=visitor_score
                            }
                        }
                        else{
                            if(new_event_arr[i].visitorteamId == team_id){
                                p+=local_score
                            }
                        }
                    }
                }
                return p
            },
            form_h_a_calculation(standings, events, team_id, d){
                let p = 1
                if (standings.length == 0)
                    return '-'
                let season_data = standings[0].standings
                let form_3_matches = {
                    "home": [],
                    "away": []
                }
                for (let i = 0; i < season_data.length; i++) {
                    let home_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "home": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "f": null,
                        "points": null,
                        "gd": null,
                    }
                    let away_team_data = {
                        "id": this.create_UUID(),
                        "team_name": null,
                        "team_id": null,
                        "over": null,
                        "away": {
                            "p": null,
                            "w": null,
                            "l": null,
                            "f": null,
                            "a": null,
                        },
                        "d": null,
                        "f": null,
                        "points": null,
                        "gd": null,
                    }
                    home_team_data.team_name = season_data[i].team_name
                    home_team_data.team_id = season_data[i].team_id

                    away_team_data.team_name = season_data[i].team_name
                    away_team_data.team_id = season_data[i].team_id
                    form_3_matches.home.push(home_team_data)
                    form_3_matches.away.push(away_team_data)
                }

                for(let i = 0 ; i < form_3_matches.home.length ; i++){
                    form_3_matches.home[i].home.p = this.form_3_p(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].away.p = this.form_3_p(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].home.w = this.form_3_w(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].away.w = this.form_3_w(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].d = this.form_3_d(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].d = this.form_3_d(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].home.l = this.form_3_l(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].away.l = this.form_3_l(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].home.f = this.form_3_f(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.home[i].f = this.form_3_f(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].away.f = this.form_3_f(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.away[i].f = this.form_3_f(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].home.a = this.form_3_a(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].away.a = this.form_3_a(form_3_matches.away[i].team_id, events, '2')
                    form_3_matches.home[i].gd = form_3_matches.home[i].home.f - form_3_matches.home[i].home.a
                    form_3_matches.away[i].gd = form_3_matches.away[i].away.f - form_3_matches.away[i].away.a
                    form_3_matches.home[i].points = this.form_3_w(form_3_matches.home[i].team_id, events, '1')*3 + this.form_3_d(form_3_matches.home[i].team_id, events, '1')
                    form_3_matches.away[i].points = this.form_3_w(form_3_matches.away[i].team_id, events, '2')*3 + this.form_3_d(form_3_matches.away[i].team_id, events, '2')
                }

                this.sortJSON1(form_3_matches.home, 'points', '123');
                this.sortJSON1(form_3_matches.away, 'points', '123');

                let new_away_table1 = []
                for(let j = 0 ; j < form_3_matches.home.length ; j++){
                    let len = form_3_matches.home.filter(function(item) {
                        return item.points == form_3_matches.home[j].points
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            form_3_matches.home[p] = len[p - j]
                            new_away_table1.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table1.push(form_3_matches.home[j])
                    }
                }
                form_3_matches.home = new_away_table1

                let new_away_table2 = []
                for(let j = 0 ; j < form_3_matches.home.length ; j++){
                    let len = form_3_matches.home.filter(function(item) {
                        return (item.points == form_3_matches.home[j].points && item.gd == form_3_matches.home[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            form_3_matches.home[p] = len[p - j]
                            new_away_table2.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table2.push(form_3_matches.home[j])
                    }
                }
                form_3_matches.home = new_away_table2

                let new_away_table = []
                for(let j = 0 ; j < form_3_matches.away.length ; j++){
                    let len = form_3_matches.away.filter(function(item) {
                        return item.points == form_3_matches.away[j].points
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'gd', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            form_3_matches.away[p] = len[p - j]
                            new_away_table.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table.push(form_3_matches.away[j])
                    }
                }
                form_3_matches.away = new_away_table

                let new_away_table3 = []
                for(let j = 0 ; j < form_3_matches.away.length ; j++){
                    let len = form_3_matches.away.filter(function(item) {
                        return (item.points == form_3_matches.away[j].points && item.gd == form_3_matches.away[j].gd)
                    });
                    if(len.length > 1){
                        this.sortJSON1(len,'f', '123');
                        for(let p = j ; p < j + len.length ; p++){
                            form_3_matches.away[p] = len[p - j]
                            new_away_table3.push(len[p - j])
                        }
                        j = j + len.length - 1
                    }
                    else{
                        new_away_table3.push(form_3_matches.away[j])
                    }
                }
                form_3_matches.away = new_away_table3

                for(let j = 0 ; j < form_3_matches.home.length ; j++){
                    if(form_3_matches.home[j].team_id == team_id && d == '1'){
                        p =  j + 1
                    }
                }
                for(let j = 0 ; j < form_3_matches.away.length ; j++){
                    if(form_3_matches.away[j].team_id == team_id && d == '2'){
                        p =  j + 1
                    }
                }
                return p
            },
            eventDetailData(home_id, away_id, season_id, item){
                console.log('home_id==>', home_id)
                console.log('away_id==>', away_id)
                console.log('item==>', item)
                console.log('_id==>', item._id)
                this.current_modal_data = null
                let ranking = this.standingList
                for(let u = 0 ; u < this.mainList.length ; u++) {
                    for (let uu = 0; uu < this.mainList[u].events.length; uu++) {
                        if(home_id == this.mainList[u].events[uu].home_id && away_id == this.mainList[u].events[uu].away_id){
                            if(this.mainList[u].events[uu].show){
                                this.mainList[u].events[uu].show = false
                                break;
                            }
                            else{
                                this.showModal_()
                                window.axios.post(`${process.env.VUE_APP_URL}geteventData`, [item._id]).then(({data})=> {
                                    console.log('data0******', data.data[0])
                                    this.hideModal_()
                                    this.filter_key1 = 0
                                    this.filter_key2 = 0
                                    this.filter_key3 = 0
                                    this.filter_key4 = 0
                                    this.filter_key5 = 0
                                    this.filter_key6 = 0
                                    this.filter_key7 = 0
                                    this.filter_key8 = 0
                                    let start_date4 = new Date();
                                    let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                                    next_date4 = new Date(next_date4).toISOString()
                                    next_date4 = next_date4.substring(0,10)
                                    let main_data =  data.data[0]
                                    this.mainData = main_data

                                    let localteamevents = []
                                    let awayteamevents = []

                                    for(let u = 0 ; u < this.mainList.length ; u++){
                                        for(let uu = 0 ; uu < this.mainList[u].events.length ; uu++){
                                            for(let j = 0 ; j < main_data.length ; j++){
                                                let localTeamId = main_data[j].localTeamId
                                                let visitorTeamId = main_data[j].visitorTeamId
                                                let stage_id = main_data[j].stage_id
                                                let round_id = main_data[j].round_id
                                                if(localTeamId == this.mainList[u].events[uu].home_id && visitorTeamId == this.mainList[u].events[uu].away_id){
                                                    if(this.mainList[u].events[uu].show){
                                                        this.mainList[u].events[uu].show = false
                                                        break;
                                                    }
                                                    else{
                                                        let start_date4 = new Date();
                                                        let next_date4 = start_date4.setDate(start_date4.getDate() + 0);
                                                        next_date4 = new Date(next_date4).toISOString()
                                                        next_date4 = next_date4.substring(0,10)
                                                        let home = {
                                                            p:0,
                                                            name:'',
                                                            rank: '',
                                                            z_z: 0,
                                                            over15: 0,
                                                            over25:0,
                                                            over35:0,
                                                            scored:0,
                                                            conc:0,
                                                            average1:0,
                                                            average2:0,
                                                            bts:0,
                                                            first1:0,
                                                            first2:0,
                                                            second1:0,
                                                            second2:0,
                                                            time15_S:0,
                                                            time30_S:0,
                                                            time45_S:0,
                                                            time60_S:0,
                                                            time75_S:0,
                                                            time90_S:0,
                                                            time15_C:0,
                                                            time30_C:0,
                                                            time45_C:0,
                                                            time60_C:0,
                                                            time75_C:0,
                                                            time90_C:0,
                                                            gs1:0,
                                                            gs2:0,
                                                            gc1:0,
                                                            gc2:0,
                                                            over40:0,
                                                            over85:0,
                                                            C_H:0,
                                                            C_D:0,
                                                            C_A:0,
                                                            first10:0,
                                                            first11:0,
                                                            first20:0,
                                                            second01:0,
                                                            second11:0,
                                                            second02:0,
                                                            firstGoal:0,
                                                            lastGoal:0,
                                                            secondplus:0,
                                                            secondminus:0,
                                                            homefirst:0,
                                                            drawfirst:0,
                                                            awayfirst:0,
                                                            homesecond:0,
                                                            drawsecond:0,
                                                            awaysecond:0,
                                                            eventdays:['All'],
                                                            pos:0,
                                                            h_a:0,
                                                            swing1:'',
                                                            FH:0,
                                                            swing2:'',
                                                            SH:0,
                                                            swing3:'',
                                                            attack:0,
                                                            defense:0,
                                                            form:0,
                                                            form_H_A:0,
                                                            fh_percentage: 0,
                                                            sh_percentage: 0,
                                                            fh_probability: 0,
                                                            sh_probability: 0,
                                                            pro: 0
                                                        }
                                                        let away = {
                                                            p:0,
                                                            name:'',
                                                            rank:'' ,
                                                            z_z: 0,
                                                            over15: 0,
                                                            over25:0,
                                                            over35:0,
                                                            scored:0,
                                                            conc:0,
                                                            average1:0,
                                                            average2:0,
                                                            bts:0,
                                                            first1:0,
                                                            first2:0,
                                                            second1:0,
                                                            second2:0,
                                                            time15_S:0,
                                                            time30_S:0,
                                                            time45_S:0,
                                                            time60_S:0,
                                                            time75_S:0,
                                                            time90_S:0,
                                                            time15_C:0,
                                                            time30_C:0,
                                                            time45_C:0,
                                                            time60_C:0,
                                                            time75_C:0,
                                                            time90_C:0,
                                                            gs1:0,
                                                            gs2:0,
                                                            gc1:0,
                                                            gc2:0,
                                                            over40:0,
                                                            over85:0,
                                                            C_H:0,
                                                            C_D:0,
                                                            C_A:0,
                                                            first10:0,
                                                            first11:0,
                                                            first20:0,
                                                            second01:0,
                                                            second11:0,
                                                            second02:0,
                                                            firstGoal:0,
                                                            lastGoal:0,
                                                            secondPlus:0,
                                                            secondMinus:0,
                                                            homefirst:0,
                                                            drawfirst:0,
                                                            awayfirst:0,
                                                            homesecond:0,
                                                            drawsecond:0,
                                                            awaysecond:0,
                                                            eventdays:['All'],
                                                            pos:0,
                                                            h_a:0,
                                                            swing1: '',
                                                            FH:0,
                                                            swing2: '',
                                                            SH:0,
                                                            swing3: '',
                                                            attack:0,
                                                            defense:0,
                                                            form:0,
                                                            form_H_A:0,
                                                            fh_percentage: 0,
                                                            sh_percentage: 0,
                                                            probability: 0,
                                                            fh_probability: 0,
                                                            sh_probability: 0,
                                                            pro: 0
                                                        }
                                                        home.name = this.mainList[u].events[uu].home.name
                                                        away.name = this.mainList[u].events[uu].away.name
                                                        let eventName = this.mainList[u].events[uu].eventName
                                                        this.current_home_name = main_data[j].localTeamName.substring(0,12) + '(' + main_data[j].standing.localteam_position + ')'
                                                        this.current_away_name = main_data[j].visitorTeamName.substring(0,12) + '(' + main_data[j].standing.visitorteam_position + ')'
                                                        let self =  this
                                                        let season_id = main_data[j].season_id

                                                        let temp2 =  JSON.stringify(self.lineup_list)
                                                        let temp3 =  JSON.stringify(self.lineup_list)
                                                        let homelineuplist = JSON.parse(temp2)
                                                        let awaylineuplist = JSON.parse(temp3)
                                                        let local_Id = main_data[j].localTeamId
                                                        let visitor_Id = main_data[j].visitorTeamId
                                                        let home_lineups = []
                                                        let away_lineups = []
                                                        let home_team_scores = []
                                                        let away_team_scores = []

                                                        let p_check = 0
                                                        let h_w_check = 0
                                                        let h_d_check = 0
                                                        let h_l_check = 0
                                                        let a_w_check = 0
                                                        let a_d_check = 0
                                                        let a_l_check = 0
                                                        if(main_data[j].time.status === 'FT' || main_data[j].time.status === "FT_PEN" || main_data[j].time.status === "AET"){
                                                            p_check = 1
                                                            if(main_data[j].scores.localteam_score > main_data[j].scores.visitorteam_score){
                                                                h_w_check = 1
                                                                a_l_check = 1
                                                            }
                                                            else if(main_data[j].scores.localteam_score == main_data[j].scores.visitorteam_score){
                                                                h_d_check = 1
                                                                a_d_check = 1
                                                            }
                                                            else{
                                                                a_w_check = 1
                                                                h_l_check = 1
                                                            }
                                                        }

                                                        let full_time_score_array = []
                                                        let position_details_array = []
                                                        let position_details_array1 = []
                                                        let standing_details_array = []
                                                        let k = 0
                                                        for(let c = 0 ; c < ranking.length ; c++){
                                                            if(ranking[c].season_id == season_id){
                                                                k++
                                                                let stage_name = ''
                                                                let group_name = ''
                                                                if(ranking[c].resource == 'stage'){
                                                                    stage_name = ranking[c].stage_name
                                                                    group_name = ''
                                                                }
                                                                else{
                                                                    stage_name = ranking[c].stage_name
                                                                    group_name = ' / ' + ranking[c].name
                                                                }
                                                                let round_id = ranking[c].round_id
                                                                let stage_id = ranking[c].stage_id
                                                                position_details_array1[k - 1] = {'stage_id': stage_id, 'stage_name': stage_name, 'group_name': group_name, 'round_id': round_id, 'standings': []}
                                                                standing_details_array[k - 1] = {'stage_id': stage_id, 'stage_name': stage_name, 'group_name': group_name, 'round_id': round_id, 'positions': []}
                                                                for(let cc = 0 ; cc < ranking[c].standings.length ; cc++){
                                                                    let color = "black"
                                                                    if((local_Id == ranking[c].standings[cc].team_id) || (visitor_Id == ranking[c].standings[cc].team_id)){
                                                                        color = "blue"
                                                                    }
                                                                    position_details_array1[k - 1].standings.push({"color": color, "rank": ranking[c].standings[cc].position, "teamId": ranking[c].standings[cc].team_id, "teamName": ranking[c].standings[cc].team_name, "home_score": null, "away_score": null})
                                                                    full_time_score_array.push({"color": color, "rank": ranking[c].standings[cc].position, "teamId": ranking[c].standings[cc].team_id, "teamName": ranking[c].standings[cc].team_name})
                                                                    let standing_details = {
                                                                        "name": ranking[c].standings[cc].team_name,
                                                                        "position": null,
                                                                        "p": null,
                                                                        "w": null,
                                                                        "d": null,
                                                                        "l": null,
                                                                        "f": null,
                                                                        "a": null,
                                                                        "gf": null,
                                                                        "points": null,
                                                                        "tooltip": null,
                                                                        "color": '',
                                                                        "border": '',
                                                                        "key": this.create_UUID(),
                                                                        "perRank": null
                                                                    }
                                                                    standing_details.position = ranking[c].standings[cc].position
                                                                    standing_details.tooltip = ranking[c].standings[cc].result
                                                                    if((standing_details.tooltip == "UEFA Champions League") || (standing_details.tooltip == "Promotion") || 
                                                                        (standing_details.tooltip == "Championship Round") || (standing_details.tooltip == "CONMEBOL Libertadores") ||
                                                                        (standing_details.tooltip == "1st Phase") || (standing_details.tooltip == "2nd Phase") ||
                                                                        (standing_details.tooltip == "Next Round") || (standing_details.tooltip == "Final") ||
                                                                        (standing_details.tooltip == "Promotion Group") || (standing_details.tooltip == "Final Series") ||
                                                                        (standing_details.tooltip == "Final Tournament")){
                                                                        standing_details.color = 'blue'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if((standing_details.tooltip == "UEFA Champions League Qualifiers") || (standing_details.tooltip == "CONMEBOL Libertadores Qualifiers") ||
                                                                        (standing_details.tooltip == "CONMEBOL Libertadores Qualifiers")){
                                                                        standing_details.color = 'lightblue'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if((standing_details.tooltip == "Promotion Play-off") || (standing_details.tooltip == "UEFA Europa League") || 
                                                                        (standing_details.tooltip == "CONMEBOL Sudamericana") || (standing_details.tooltip == "Semi-finals") || 
                                                                        (standing_details.tooltip == "Champion Play-off") || (standing_details.tooltip == "Final Tournament or Play-offs") ||
                                                                        (standing_details.tooltip == "Final Series Play-offs")){
                                                                        standing_details.color = 'brown'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if((standing_details.tooltip == "UEFA Europa League Qualifiers") || (standing_details.tooltip == "CONMEBOL Sudamericana Qualifiers") ||
                                                                        (standing_details.tooltip == "Quarter-finals") || (standing_details.tooltip == "Possible Promotion Play-off")){
                                                                        standing_details.color = 'magenta'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if(standing_details.tooltip == "Relegation"){
                                                                        standing_details.color = 'red'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if((standing_details.tooltip == "Relegation Round") || (standing_details.tooltip == "Relegation Play-off")){
                                                                        standing_details.color = 'tomato'
                                                                        standing_details.border = "white"
                                                                    }
                                                                    if(ranking[c].standings[cc].overall != null){
                                                                        standing_details.p = ranking[c].standings[cc].overall.games_played
                                                                        standing_details.w = ranking[c].standings[cc].overall.won
                                                                        standing_details.d = ranking[c].standings[cc].overall.draw
                                                                        standing_details.l = ranking[c].standings[cc].overall.lost
                                                                        standing_details.f = ranking[c].standings[cc].overall.goals_scored
                                                                        standing_details.a = ranking[c].standings[cc].overall.goals_against
                                                                    }
                                                                    else{
                                                                        standing_details.p = '-'
                                                                        standing_details.w = '-'
                                                                        standing_details.d = '-'
                                                                        standing_details.l = '-'
                                                                        standing_details.f = '-'
                                                                        standing_details.a = '-'
                                                                    }
                                                                    if(ranking[c].standings[cc].total != null){
                                                                        standing_details.gf = ranking[c].standings[cc].total.goal_difference
                                                                        standing_details.points = ranking[c].standings[cc].total.points
                                                                    }
                                                                    else{
                                                                        standing_details.gf = '-'
                                                                        standing_details.points = '-'
                                                                    }
                                                                    // console.log("standing details=>", standing_details, 'p->check=>', p_check)
                                                                    if(ranking[c].standings[cc].team_id == local_Id){
                                                                        if(standing_details.p > 0){
                                                                            standing_details.p = parseInt(standing_details.p) - p_check
                                                                        }
                                                                        if(standing_details.w > 0){
                                                                            standing_details.w = parseInt(standing_details.w) - h_w_check
                                                                        }
                                                                        if(standing_details.l > 0){
                                                                            standing_details.l = parseInt(standing_details.l) - h_l_check
                                                                        }
                                                                        if(standing_details.d > 0){
                                                                            standing_details.d = parseInt(standing_details.l) - h_d_check
                                                                        }
                                                                    }
                                                                    if(ranking[c].standings[cc].team_id == visitor_Id){
                                                                        if(standing_details.p > 0){
                                                                            standing_details.p = standing_details.p - p_check
                                                                        }
                                                                        if(standing_details.w > 0){
                                                                            standing_details.w = standing_details.w - a_w_check
                                                                        }
                                                                        if(standing_details.l > 0){
                                                                            standing_details.l = standing_details.l - a_l_check
                                                                        }
                                                                        if(standing_details.d > 0){
                                                                            standing_details.d = standing_details.l - a_d_check
                                                                        }
                                                                    }
                                                                    if(parseInt(standing_details.p) > 0 && parseInt(standing_details.points) > 0){
                                                                        standing_details.perRank = parseInt(standing_details.points)/parseInt(standing_details.p)
                                                                    }
                                                                    standing_details_array[k - 1].positions.push(standing_details)
                                                                    position_details_array.push(standing_details)
                                                                }
                                                            }
                                                        }
                                                        
                                                        for(let p = 0 ; p < main_data[j].events.length ;p++){
                                                            let events = main_data[j].events[p].events
                                                            for(let pp = 0 ; pp < events.length ; pp++){
                                                                if(local_Id == events[pp].localteamId){
                                                                    localteamevents.push(events[pp])
                                                                }
                                                                else if(local_Id == events[pp].visitorteamId){
                                                                    localteamevents.push(events[pp])
                                                                }
                                                                if(visitor_Id == events[pp].localteamId){
                                                                    awayteamevents.push(events[pp])
                                                                }
                                                                if(visitor_Id == events[pp].visitorteamId){
                                                                    awayteamevents.push(events[pp])
                                                                }

                                                                if(local_Id == events[pp].localteamId && events[pp].date < next_date4){
                                                                    let home_goal_tlp = ""
                                                                    let away_goal_tlp = ""
                                                                    let goal_tlp = "0 - 0"
                                                                    for(let e = 0 ; e < events[pp].goals.length ; e++){
                                                                        if(events[pp].goals[e].teamId == local_Id){
                                                                            home_goal_tlp = home_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                                                        }
                                                                        else {
                                                                            away_goal_tlp = away_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                                                        }
                                                                    }
                                                                    if(home_goal_tlp == "" && away_goal_tlp != ""){
                                                                        goal_tlp = away_goal_tlp
                                                                    }
                                                                    else if(away_goal_tlp == "" && home_goal_tlp != ""){
                                                                        goal_tlp = home_goal_tlp
                                                                    }
                                                                    else if(away_goal_tlp != "" && home_goal_tlp != ""){
                                                                        goal_tlp = home_goal_tlp + '-' + away_goal_tlp
                                                                    }
                                                                    let hf_color = ""
                                                                    if(events[pp].hf_score != null){
                                                                        if(parseInt(events[pp].hf_score.split("-")[0]) == parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#cdcf46"
                                                                        }
                                                                        else if(parseInt(events[pp].hf_score.split("-")[0]) > parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#00cc00"
                                                                        }
                                                                        else if(parseInt(events[pp].hf_score.split("-")[0]) < parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#fe9f9f"
                                                                        }

                                                                        let ft_color = ""
                                                                        if(parseInt(events[pp].ft_score.split("-")[0]) == parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#cdcf46"
                                                                        }
                                                                        else if(parseInt(events[pp].ft_score.split("-")[0]) > parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#00cc00"
                                                                        }
                                                                        else if(parseInt(events[pp].ft_score.split("-")[0]) < parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#fe9f9f"
                                                                        }

                                                                        let local_name = ""
                                                                        let visitor_name = ""
                                                                        let local = full_time_score_array.filter(function(item) {
                                                                            return item.teamId === events[pp].localteamId
                                                                        });
                                                                        let visit = full_time_score_array.filter(function(item) {
                                                                            return item.teamId === events[pp].visitorteamId
                                                                        });
                                                                        if(local.length > 0){
                                                                            local_name = local[0].teamName
                                                                        }
                                                                        if(visit.length > 0){
                                                                            visitor_name = visit[0].teamName
                                                                        }
                                                                        home_team_scores.push({"key": this.create_UUID(),"ht_color": hf_color, "ft_color": ft_color, "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[pp].date, "ht_score": events[pp].hf_score, "ft_score": events[pp].ft_score, "home_goals": home_goal_tlp, "away_goals": away_goal_tlp})
                                                                        if(events[pp].local_formation){
                                                                            home_lineups.push(events[pp].local_formation)
                                                                        }
                                                                    }
                                                                }
                                                                if(visitor_Id == events[pp].visitorteamId && events[pp].date < next_date4){
                                                                    let home_goal_tlp = ""
                                                                    let away_goal_tlp = ""
                                                                    let goal_tlp = "0 - 0"
                                                                    for(let e = 0 ; e < events[pp].goals.length ; e++){
                                                                        if(events[pp].goals[e].teamId == visitor_Id){
                                                                            away_goal_tlp = away_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                                                        }
                                                                        else {
                                                                            home_goal_tlp = home_goal_tlp + " " + events[pp].goals[e].minute + "'"
                                                                        }
                                                                    }
                                                                    if(home_goal_tlp == "" && away_goal_tlp != ""){
                                                                        goal_tlp = away_goal_tlp
                                                                    }
                                                                    else if(away_goal_tlp == "" && home_goal_tlp != ""){
                                                                        goal_tlp = home_goal_tlp
                                                                    }
                                                                    else if(away_goal_tlp != "" && home_goal_tlp != ""){
                                                                        goal_tlp = home_goal_tlp + '-' + away_goal_tlp
                                                                    }

                                                                    let hf_color = ""
                                                                    if(events[pp].hf_score != null){
                                                                        if(parseInt(events[pp].hf_score.split("-")[0]) == parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#cdcf46"
                                                                        }
                                                                        else if(parseInt(events[pp].hf_score.split("-")[0]) < parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#00cc00"
                                                                        }
                                                                        else if(parseInt(events[pp].hf_score.split("-")[0]) > parseInt(events[pp].hf_score.split("-")[1])){
                                                                            hf_color = "#fe9f9f"
                                                                        }

                                                                        let ft_color = ""
                                                                        if(parseInt(events[pp].ft_score.split("-")[0]) == parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#cdcf46"
                                                                        }
                                                                        else if(parseInt(events[pp].ft_score.split("-")[0]) < parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#00cc00"
                                                                        }
                                                                        else if(parseInt(events[pp].ft_score.split("-")[0]) > parseInt(events[pp].ft_score.split("-")[1])){
                                                                            ft_color = "#fe9f9f"
                                                                        }
                                                                        let local_name = ""
                                                                        let visitor_name = ""
                                                                        let local = full_time_score_array.filter(function(item) {
                                                                            return item.teamId === events[pp].localteamId
                                                                        });
                                                                        let visit = full_time_score_array.filter(function(item) {
                                                                            return item.teamId === events[pp].visitorteamId
                                                                        });
                                                                        if(local.length > 0){
                                                                            local_name = local[0].teamName
                                                                        }
                                                                        if(visit.length > 0){
                                                                            visitor_name = visit[0].teamName
                                                                        }
                                                                        away_team_scores.push({"key": this.create_UUID(), "ht_color": hf_color, "ft_color": ft_color, "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[pp].date, "ht_score": events[pp].hf_score, "ft_score": events[pp].ft_score, "home_goals": home_goal_tlp, "away_goals": away_goal_tlp})
                                                                        if(events[pp].visit_formation){
                                                                            away_lineups.push(events[pp].visit_formation)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        

                                                        let temp =  JSON.stringify(main_data)
                                                        let main_data1 = JSON.parse(temp)
                                                        let full_time_score_array1 = position_details_array1
                                                        
                                                        console.log('full time score array=>', position_details_array1)
                                                        for(let c = 0 ; c < full_time_score_array1.length ; c++){
                                                            for(let h = 0 ; h < full_time_score_array1[c].standings.length ; h++){
                                                                for(let cc = 0 ; cc < main_data1[j].events.length ; cc++){
                                                                    let events = main_data1[j].events[cc].events
                                                                    for(let ccc = 0 ; ccc < events.length ; ccc++){
                                                                        if(full_time_score_array1[c].stage_id == events[ccc].stage_id && full_time_score_array1[c].standings[h].teamId == events[ccc].visitorteamId && local_Id == events[ccc].localteamId && events[ccc].date < next_date4){
                                                                            let home_score_tlp = ""
                                                                            let away_score_tlp = ""
                                                                            let goal_tlp = "0 - 0"
                                                                            for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                                                                if(events[ccc].goals[e].teamId == events[ccc].localteamId){
                                                                                    home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                                }
                                                                                else{
                                                                                    away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                                }
                                                                            }
                                                                            if(home_score_tlp == "" && away_score_tlp != ""){
                                                                                goal_tlp = away_score_tlp
                                                                            }
                                                                            else if(away_score_tlp == "" && home_score_tlp != ""){
                                                                                goal_tlp = home_score_tlp
                                                                            }
                                                                            else if(away_score_tlp != "" && home_score_tlp != ""){
                                                                                goal_tlp = home_score_tlp + '-' + away_score_tlp
                                                                            }

                                                                            let ft_color = ""
                                                                            if(events[ccc].ft_score != null){
                                                                                if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#cdcf46"
                                                                                }
                                                                                else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#00cc00"
                                                                                }
                                                                                else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#fe9f9f"
                                                                                }

                                                                                let local_name = ""
                                                                                let visitor_name = ""
                                                                                let local = full_time_score_array.filter(function(item) {
                                                                                    return item.teamId === events[ccc].localteamId
                                                                                });
                                                                                let visit = full_time_score_array.filter(function(item) {
                                                                                    return item.teamId === events[ccc].visitorteamId
                                                                                });
                                                                                if(local.length > 0){
                                                                                    local_name = local[0].teamName
                                                                                }
                                                                                if(visit.length > 0){
                                                                                    visitor_name = visit[0].teamName
                                                                                }
                                                                                full_time_score_array1[c].standings[h].home_score = {"key": this.create_UUID(), "ft_color": ft_color , "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                                                            }
                                                                            // console.log("****************", full_time_score_array1[c].round_id,', ',main_data[j].events[cc].round_id)
                                                                        }
                                                                        if(full_time_score_array1[c].stage_id == events[ccc].stage_id && full_time_score_array1[c].standings[h].teamId == events[ccc].localteamId && visitor_Id == events[ccc].visitorteamId && events[ccc].date < next_date4){
                                                                            let home_score_tlp = ""
                                                                            let away_score_tlp = ""
                                                                            let goal_tlp = "0 - 0"
                                                                            for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                                                                if(events[ccc].goals[e].teamId == events[ccc].visitorteamId){
                                                                                    away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                                }
                                                                                else{
                                                                                    home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                                }
                                                                            }
                                                                            if(home_score_tlp == "" && away_score_tlp != ""){
                                                                                goal_tlp = away_score_tlp
                                                                            }
                                                                            else if(away_score_tlp == "" && home_score_tlp != ""){
                                                                                goal_tlp = home_score_tlp
                                                                            }
                                                                            else if(away_score_tlp != "" && home_score_tlp != ""){
                                                                                goal_tlp = home_score_tlp + '-' + away_score_tlp
                                                                            }

                                                                            let ft_color = ""
                                                                            if(events[ccc].ft_score != null){
                                                                                if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#cdcf46"
                                                                                }
                                                                                else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#00cc00"
                                                                                }
                                                                                else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                    ft_color = "#fe9f9f"
                                                                                }

                                                                                let local_name = ""
                                                                                let visitor_name = ""
                                                                                let local = full_time_score_array.filter(function(item) {
                                                                                    return item.teamId === events[ccc].localteamId
                                                                                });
                                                                                let visit = full_time_score_array.filter(function(item) {
                                                                                    return item.teamId === events[ccc].visitorteamId
                                                                                });
                                                                                if(local.length > 0){
                                                                                    local_name = local[0].teamName
                                                                                }
                                                                                if(visit.length > 0){
                                                                                    visitor_name = visit[0].teamName
                                                                                }
                                                                                full_time_score_array1[c].standings[h].away_score = {"key": this.create_UUID(), "goal_tlp": goal_tlp,"local_name": local_name, "visitor_name": visitor_name,  "ft_color": ft_color , "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                                                                // let index = main_data1[j].events[cc].events.indexOf(events[ccc]);
                                                                                // if (index > -1) {
                                                                                //     main_data1[j].events[cc].events.splice(index, 1);
                                                                                //     if(ccc > 0){
                                                                                //         ccc = ccc - 1
                                                                                //     }
                                                                                // }
                                                                            }
                                                                            //console.log("****************", full_time_score_array1[c].round_id,', ',main_data[j].events[cc].round_id)
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        let home_full_scores = []
                                                        let away_full_scores = []
                                                        console.log('=================    local_Id   ==============', local_Id)
                                                        console.log('=================    full_time_score_array   ==============', full_time_score_array)
                                                        for(let c = 0 ; c < full_time_score_array.length ; c++){
                                                            for(let cc = 0 ; cc < main_data[j].events.length ; cc++){
                                                                let events = main_data[j].events[cc].events
                                                                console.log('=================    events   ==============', events)


                                                                for(let ccc = 0 ; ccc < events.length ; ccc++){
                                                                    if(full_time_score_array[c].teamId == events[ccc].visitorteamId && local_Id == events[ccc].localteamId){
                                                                        console.log('=================    home matched   ==============')
                                                                    }
                                                                    if(full_time_score_array[c].teamId == events[ccc].visitorteamId && local_Id == events[ccc].localteamId && events[ccc].date < next_date4){
                                                                        console.log('=================    home matched   ==============')
                                                                        let home_score_tlp = ""
                                                                        let away_score_tlp = ""
                                                                        let goal_tlp = "0 - 0"
                                                                        for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                                                            if(events[ccc].goals[e].teamId == events[ccc].localteamId){
                                                                                home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                            }
                                                                            else{
                                                                                away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                            }
                                                                        }
                                                                        if(home_score_tlp == "" && away_score_tlp != ""){
                                                                            goal_tlp = away_score_tlp
                                                                        }
                                                                        else if(away_score_tlp == "" && home_score_tlp != ""){
                                                                            goal_tlp = home_score_tlp
                                                                        }
                                                                        else if(away_score_tlp != "" && home_score_tlp != ""){
                                                                            goal_tlp = home_score_tlp + '-' + away_score_tlp
                                                                        }

                                                                        let ft_color = ""
                                                                        if(events[ccc].ft_score != null){
                                                                            if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#cdcf46"
                                                                            }
                                                                            else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#00cc00"
                                                                            }
                                                                            else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#fe9f9f"
                                                                            }

                                                                            let local_name = ""
                                                                            let visitor_name = ""
                                                                            let local = full_time_score_array.filter(function(item) {
                                                                                return item.teamId === events[ccc].localteamId
                                                                            });
                                                                            let visit = full_time_score_array.filter(function(item) {
                                                                                return item.teamId === events[ccc].visitorteamId
                                                                            });
                                                                            if(local.length > 0){
                                                                                local_name = local[0].teamName
                                                                            }
                                                                            if(visit.length > 0){
                                                                                visitor_name = visit[0].teamName
                                                                            }
                                                                            home_full_scores[c] = {"key": this.create_UUID(), "ft_color": ft_color , "goal_tlp": goal_tlp, "local_name": local_name, "visitor_name": visitor_name, "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                                                        }
                                                                    }
                                                                    if(full_time_score_array[c].teamId == events[ccc].localteamId && visitor_Id == events[ccc].visitorteamId && events[ccc].date < next_date4){
                                                                        console.log('=================    away matched   ==============')
                                                                        let home_score_tlp = ""
                                                                        let away_score_tlp = ""
                                                                        let goal_tlp = "0 - 0"
                                                                        for(let e = 0 ; e < events[ccc].goals.length ; e++){
                                                                            if(events[ccc].goals[e].teamId == events[ccc].visitorteamId){
                                                                                away_score_tlp = away_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                            }
                                                                            else{
                                                                                home_score_tlp = home_score_tlp + " " + events[ccc].goals[e].minute + "'"
                                                                            }
                                                                        }
                                                                        if(home_score_tlp == "" && away_score_tlp != ""){
                                                                            goal_tlp = away_score_tlp
                                                                        }
                                                                        else if(away_score_tlp == "" && home_score_tlp != ""){
                                                                            goal_tlp = home_score_tlp
                                                                        }
                                                                        else if(away_score_tlp != "" && home_score_tlp != ""){
                                                                            goal_tlp = home_score_tlp + '-' + away_score_tlp
                                                                        }

                                                                        let ft_color = ""
                                                                        if(events[ccc].ft_score != null){
                                                                            if(parseInt(events[ccc].ft_score.split("-")[0]) == parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#cdcf46"
                                                                            }
                                                                            else if(parseInt(events[ccc].ft_score.split("-")[0]) < parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#00cc00"
                                                                            }
                                                                            else if(parseInt(events[ccc].ft_score.split("-")[0]) > parseInt(events[ccc].ft_score.split("-")[1])){
                                                                                ft_color = "#fe9f9f"
                                                                            }

                                                                            let local_name = ""
                                                                            let visitor_name = ""
                                                                            let local = full_time_score_array.filter(function(item) {
                                                                                return item.teamId === events[ccc].localteamId
                                                                            });
                                                                            let visit = full_time_score_array.filter(function(item) {
                                                                                return item.teamId === events[ccc].visitorteamId
                                                                            });
                                                                            if(local.length > 0){
                                                                                local_name = local[0].teamName
                                                                            }
                                                                            if(visit.length > 0){
                                                                                visitor_name = visit[0].teamName
                                                                            }
                                                                            away_full_scores[c] = {"key": this.create_UUID(), "goal_tlp": goal_tlp,"local_name": local_name, "visitor_name": visitor_name,  "ft_color": ft_color , "date": events[ccc].date, "ht_score": events[ccc].hf_score, "ft_score": events[ccc].ft_score, "home_goals": home_score_tlp, "away_goals": away_score_tlp}
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        console.log('=================    home_full_scores   ==============', home_full_scores)
                                                        console.log('=================    away_full_scores   ==============', away_full_scores)
                                                        for(let c = 0 ; c < full_time_score_array.length ; c++){
                                                            if(!home_full_scores[c]){
                                                                home_full_scores[c] = null
                                                            }
                                                            if(!away_full_scores[c]){
                                                                away_full_scores[c] = null
                                                            }
                                                        }


                                                        let current_modal_data = {
                                                            "home_team_scores": home_team_scores,
                                                            "away_team_scores": away_team_scores,
                                                            "full_time_score_array": full_time_score_array,
                                                            "full_time_score_array1": position_details_array1,
                                                            "home_full_scores": home_full_scores,
                                                            "away_full_scores": away_full_scores,
                                                            "position_details": position_details_array,
                                                            "standing_details": standing_details_array
                                                        }
                                                        this.current_modal_data = {
                                                            "home_team_scores": home_team_scores,
                                                            "away_team_scores": away_team_scores,
                                                            "full_time_score_array": full_time_score_array,
                                                            "home_full_scores": home_full_scores,
                                                            "away_full_scores": away_full_scores,
                                                            "position_details": position_details_array,
                                                            "standing_details": standing_details_array
                                                        }
                                                        let home_lineup_check = 0
                                                        let away_lineup_check = 0
                                                        for(let p = 0 ; p < homelineuplist.length ; p++){
                                                            let count = 0
                                                            for(let pp = 0 ; pp < home_lineups.length ; pp++){
                                                                if(homelineuplist[p].value == home_lineups[pp]){
                                                                    count++
                                                                }
                                                            }
                                                            if(count > 0){
                                                                home_lineup_check = 1
                                                                homelineuplist[p].label = homelineuplist[p].label + '(' + count + ')'
                                                            }
                                                        }
                                                        for(let p = 0 ; p < awaylineuplist.length ; p++){
                                                            let count = 0
                                                            for(let pp = 0 ; pp < away_lineups.length ; pp++){
                                                                if(awaylineuplist[p].value == away_lineups[pp]){
                                                                    count++
                                                                }
                                                            }
                                                            if(count > 0){
                                                                away_lineup_check = 1
                                                                awaylineuplist[p].label = awaylineuplist[p].label + '(' + count + ')'
                                                            }
                                                        }
                                                        let homelineuplist1 = [{ value: '0', label: 'All'}]
                                                        let awaylineuplist1 = [{ value: '0', label: 'All'}]
                                                        for(let p = 0 ; p < homelineuplist.length ; p++){
                                                            if(homelineuplist[p].label.includes('(')){
                                                                homelineuplist1.push(homelineuplist[p])
                                                            }
                                                        }
                                                        for(let p = 0 ; p < awaylineuplist.length ; p++){
                                                            if(awaylineuplist[p].label.includes('(')){
                                                                awaylineuplist1.push(awaylineuplist[p])
                                                            }
                                                        }
                                                        if(away_lineup_check === 0){
                                                            awaylineuplist1 = []
                                                        }
                                                        if(home_lineup_check === 0){
                                                            homelineuplist1 = []
                                                        }
                                                        let seasonId = main_data[j].season_id
                                                        this.mainList[u].events[uu] = Object.assign(this.mainList[u].events[uu],{'_id': main_data[j]._id,'season_id': seasonId, 'spots': current_modal_data,'show': false, 'homeLineupList': homelineuplist1,'awayLineupList': awaylineuplist1, 'rank_option': [], 'rank_set': {}, 'rankFilter': false, 'b_data': main_data[j].events, 'eventName': eventName, 'home_id': 0, 'away_id': 0, 'openDate':  main_data[j].time.starting_at.time, 'home':home, 'away': away, 'homeDateList': [], "awayDateList": []})
                                                        let homeTeamId = main_data[j].localTeamId
                                                        let awayTeamId = main_data[j].visitorTeamId

                                                        this.mainList[u].events[uu].home_id = homeTeamId
                                                        this.mainList[u].events[uu].away_id = awayTeamId

                                                        let teamsInfo = main_data[j].teamInfo
                                                        let rank_filter_show = true
                                                        let teamArray = []
                                                        for(let m = 0 ; m < teamsInfo.length ; m++){
                                                            let teams = teamsInfo[m].teams
                                                            if(teams.length < 5){
                                                                continue
                                                            }
                                                            for(let mm = 0 ; mm < teams.length ; mm++){
                                                                if (teams[mm].team_id)
                                                                    teamArray.push(teams[mm].team_id)
                                                            }
                                                        }
                                                        if(teamArray.length < 5){
                                                            rank_filter_show = false
                                                        }
                                                        teamArray = Array.from(new Set (teamArray))

                                                        let rank_set = {
                                                            "v1": {"from": 1, "to": 0},
                                                            "v2": {"from": 0, "to": 0},
                                                            "v3": {"from": 0, "to": 0},
                                                            "v4": {"from": 0, "to": 0}
                                                        }
                                                        let rankList_option = []
                                                        if(rank_filter_show === true){
                                                            let total_teams = teamArray.length
                                                            if(total_teams % 2 === 0){
                                                                let sec = total_teams/2
                                                                if(sec % 2 === 0){
                                                                    rank_set.v1.to = sec/2
                                                                    rank_set.v2.to = sec
                                                                    rank_set.v3.to = sec*3/2
                                                                    rank_set.v4.to = sec*2

                                                                    rank_set.v2.from = rank_set.v1.to + 1
                                                                    rank_set.v3.from = rank_set.v2.to + 1
                                                                    rank_set.v4.from = rank_set.v3.to + 1
                                                                }
                                                                else{
                                                                    rank_set.v1.to = (sec - 1)/2
                                                                    rank_set.v2.to = sec
                                                                    rank_set.v3.to = sec + (sec - 1)/2
                                                                    rank_set.v4.to = sec*2

                                                                    rank_set.v2.from = rank_set.v1.to + 1
                                                                    rank_set.v3.from = rank_set.v2.to + 1
                                                                    rank_set.v4.from = rank_set.v3.to + 1
                                                                }
                                                            }
                                                            else{
                                                                let f_sec = (total_teams - 1)/2
                                                                let s_sec = (total_teams - 1)/2 + 1
                                                                if(f_sec % 2 === 0){
                                                                    rank_set.v1.to = f_sec/2
                                                                    rank_set.v2.to = f_sec
                                                                    rank_set.v2.from = rank_set.v1.to + 1
                                                                    rank_set.v3.from = rank_set.v2.to + 1
                                                                }
                                                                else{
                                                                    rank_set.v1.to = (f_sec - 1)/2
                                                                    rank_set.v2.to = f_sec
                                                                    rank_set.v2.from = rank_set.v1.to + 1
                                                                    rank_set.v3.from = rank_set.v2.to + 1
                                                                }

                                                                if(s_sec % 2 === 0){
                                                                    rank_set.v3.to = s_sec/2
                                                                    rank_set.v4.to = s_sec
                                                                    rank_set.v4.from = rank_set.v3.to + 1
                                                                }
                                                                else{
                                                                    rank_set.v3.to = f_sec + (s_sec - 1)/2
                                                                    rank_set.v4.to = total_teams
                                                                    rank_set.v4.from = rank_set.v3.to + 1
                                                                }
                                                            }
                                                            this.mainList[u].events[uu].rankFilter = true
                                                            this.mainList[u].events[uu].rank_set = rank_set
                                                            rankList_option = [
                                                                {"value": 1, "label": "vs All"},
                                                                {"value": 2, "label": "vs High rank ( " + rank_set.v1.from + ' to ' + rank_set.v1.to + ' )'},
                                                                {"value": 3, "label": "vs middle-high rank ( " + rank_set.v2.from + ' to ' + rank_set.v2.to + ' )'},
                                                                {"value": 4, "label": "vs middle-low rank (" + rank_set.v3.from + ' to ' + rank_set.v3.to + ' )'},
                                                                {"value": 5, "label": "vs low rank (" + rank_set.v4.from + ' to ' + rank_set.v4.to + ' )'},
                                                            ]
                                                            this.mainList[u].events[uu].rank_option = rankList_option
                                                        }

                                                        let event_item = main_data[j].events
                                                        console.log("event_item===>", event_item)
                                                        let home_date_list = [{'value': 1000,"date": '1900-01-01', "label": "ALL"}]
                                                        let away_date_list = [{'value': 1000,"date": '1900-01-01', "label": "ALL"}]
                                                        let home_date_Index = 0
                                                        let away_date_Index = 0
                                                        for(let m = 0 ; m < event_item.length ; m++){
                                                            for(let mm = 0 ; mm < event_item[m].events.length ; mm++){
                                                                if(event_item[m].events[mm].localteamId == homeTeamId){
                                                                    home_date_Index++
                                                                    home_date_list.push({'value': home_date_Index,"date": event_item[m].events[mm].date, "label": home_date_Index})
                                                                }
                                                                if(event_item[m].events[mm].visitorteamId == awayTeamId){
                                                                    away_date_Index++
                                                                    away_date_list.push({'value': away_date_Index,"date": event_item[m].events[mm].date, "label": away_date_Index})
                                                                }
                                                            }
                                                        }
                                                        this.sortJSON(home_date_list,'date', '123');
                                                        this.sortJSON(away_date_list,'date', '123');

                                                        for(let m = 1 ; m < home_date_list.length; m++){
                                                            home_date_list[m].value = m
                                                            home_date_list[m].label = m
                                                        }

                                                        for(let m = 1 ; m < away_date_list.length; m++){
                                                            away_date_list[m].value = m
                                                            away_date_list[m].label = m
                                                        }

                                                        this.mainList[u].events[uu].homeDateList = home_date_list
                                                        this.mainList[u].events[uu].awayDateList = away_date_list
                                                        home.pos = main_data[j].standing.localteam_position
                                                        away.pos = main_data[j].standing.visitorteam_position

                                                        
                                                        let standings = this.standingList.filter(function(item) {
                                                            console.log('item.stage_id =>', item.stage_id)
                                                            console.log('stage_id =>', stage_id)
                                                            //return item.stage_id == stage_id;
                                                            return item.season_id == main_data[j].season_id;
                                                            //return item.standings.team_name == main_data[j].localTeamName;
                                                        });


                                                        let new_standing = [];
                                                        
                                                        if (standings.length > 1) {
                                                            
                                                            for (var ss = 0; ss < standings.length; ss++) {
                                                                var find_home = false;
                                                                var find_away = false;
                                                                for (var sss = 0; sss < standings[ss].standings.length; sss++) {
                                                                    if (standings[ss].standings[sss].team_name == main_data[j].localTeamName) {
                                                                        find_home = true
                                                                    }
                                                                    else if (standings[ss].standings[sss].team_name == main_data[j].visitorTeamName ) {
                                                                        find_away = true;                                                                        
                                                                    }
                                                                }
                                                                if (find_home && find_away) {
                                                                    new_standing.push(standings[ss]);
                                                                    break
                                                                }
                                                                    
                                                            }
                                                            
                                                        }
                                                        if (new_standing.length > 0)
                                                            standings = new_standing;
                                                        
                                                        console.log('round_id =>', round_id)
                                                        console.log('stage_id =>', stage_id)

                                                        console.log('this.standingList =>', this.standingList)
                                                        console.log(" new standings=>", standings, stage_id, main_data[j])
                                                        console.log(" new standings--=>", standings)
                                                        console.log(' main id', main_data[j]._id)
                                                        home.h_a = this.h_a_calculation(standings, homeTeamId, '1')
                                                        away.h_a = this.h_a_calculation(standings, awayTeamId, '2')

                                                        // home.h_a = this.H_A_calculation(seasonId, homeTeamId, stage_id,round_id, 'home')
                                                        // away.h_a = this.H_A_calculation(seasonId, awayTeamId, stage_id,round_id,'away')

                                                        let swing1 = (away.pos - away.h_a) - (home.pos - home.h_a)
                                                        if(swing1 > 0){
                                                            away.swing1 = '+'+swing1
                                                            home.swing1 =''
                                                        }
                                                        else if(swing1 < 0){
                                                            away.swing1 =''
                                                            home.swing1 = '+'+swing1*(-1)
                                                        }
                                                        if((home.pos > home.h_a && away.pos > away.h_a) || (home.pos < home.h_a && away.pos < away.h_a)){
                                                            away.swing1 =''
                                                            home.swing1 =''
                                                        }

                                                        let events = main_data[j].events.filter(function(item) {
                                                            return item.stage_id == stage_id
                                                        });
                                                        console.log("events====>", events)
                                                        home.FH = this.f_h_calculation(standings, events, main_data[j].localTeamId, '1')
                                                        away.FH = this.f_h_calculation(standings, events, main_data[j].visitorTeamId, '2')

                                                        // home.FH = this.FH_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '1', {}, stage_id)
                                                        // away.FH = this.FH_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4, '1', {}, stage_id)

                                                        let swing2 =(away.pos - away.FH) -  (home.pos - home.FH)
                                                        if(swing2 > 0){
                                                            away.swing2 = '+'+swing2
                                                            home.swing2 =''
                                                        }
                                                        else if(swing2 < 0){
                                                            away.swing2 =''
                                                            home.swing2 = '+'+swing2*(-1)
                                                        }
                                                        if((home.pos > home.FH && away.pos > away.FH) || (home.pos < home.FH && away.pos < away.FH)){
                                                            away.swing2 =''
                                                            home.swing2 =''
                                                        }

                                                        home.SH = this.s_h_calculation(standings, events, main_data[j].localTeamId, '1')
                                                        away.SH = this.s_h_calculation(standings, events, main_data[j].visitorTeamId, '2')

                                                        // home.SH = this.SH_calculation(main_data[j].events, main_data[j].localTeamId,seasonId, 'home', next_date4, '1', {}, stage_id)
                                                        // away.SH = this.SH_calculation(main_data[j].events, main_data[j].visitorTeamId,seasonId, 'away', next_date4, '1', {}, stage_id)

                                                        let swing3 =(away.pos - away.SH) -  (home.pos - home.SH)
                                                        if(swing3 > 0){
                                                            away.swing3 = '+'+swing3
                                                            home.swing3 =''
                                                        }
                                                        else if(swing3 < 0){
                                                            away.swing3 =''
                                                            home.swing3 = '+'+swing3*(-1)
                                                        }
                                                        if((home.pos > home.SH && away.pos > away.SH) || (home.pos < home.SH && away.pos < away.SH)){
                                                            away.swing3 =''
                                                            home.swing3 =''
                                                        }

                                                        home.attack = this.att_calculation(standings, main_data[j].localTeamId, '1')
                                                        // home.attack = this.attack_calculation(seasonId, homeTeamId, 'home', stage_id)
                                                        away.attack = this.def_calculation(standings, main_data[j].visitorTeamId, '2')
                                                        // away.attack = this.attack_calculation(seasonId, awayTeamId, 'away', stage_id)
                                                        home.defense = this.def_calculation(standings, main_data[j].localTeamId, '1')
                                                        // home.defense = this.defense_calculation(seasonId, homeTeamId, 'home', stage_id)
                                                        away.defense = this.att_calculation(standings, main_data[j].visitorTeamId, '2')
                                                        // away.defense = this.defense_calculation(seasonId, awayTeamId, 'away', stage_id)
                                                        home.form = this.form_calculation(standings, events, main_data[j].localTeamId, '1')
                                                        away.form = this.form_calculation(standings, events, main_data[j].visitorTeamId, '2')
                                                        home.form_H_A = this.form_h_a_calculation(standings, events, main_data[j].localTeamId, '1')
                                                        away.form_H_A = this.form_h_a_calculation(standings, events, main_data[j].visitorTeamId, '2')

                                                        // home.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, 'home', next_date4, '1', {}, stage_id)
                                                        // away.form_H_A = this.H_A_Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, 'away', next_date4, '1', {}, stage_id)
                                                        //home.form = this.Form_calculation(main_data[j].events, main_data[j].localTeamId, seasonId, next_date4, '1', {}, stage_id)
                                                        //away.form = this.Form_calculation(main_data[j].events, main_data[j].visitorTeamId, seasonId, next_date4, '1', {}, stage_id)

                                                        let percentage0 = this.percentage_calculation(main_data[j])
                                                        // percentage = percentage0[0]
                                                        // numbers = percentage0[1]

                                                        home.p = this.p_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        away.p = this.p_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                                                        console.log('home p========>', home.p)
                                                        console.log('away p========>', away.p)

                                                        home.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)*100).toFixed(0)
                                                        away.fh_percentage = (this.fh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)*100).toFixed(0)
                                                        home.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)*100).toFixed(0)
                                                        away.sh_percentage = (this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)*100).toFixed(0)
                                                        home.fh_probability = ((this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p) + this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p))/2*100).toFixed(0)
                                                        home.sh_probability = ((this.sh_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p) + this.sh_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p))/2*100).toFixed(0)
                                                        home.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '0', {})/(home.p)
                                                        away.pro = this.fh_probability_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '0', {})/(away.p)
                                                        if(home.p == 0){
                                                            home.fh_percentage = 0
                                                            home.sh_percentage = 0
                                                        }
                                                        if(away.p == 0){
                                                            away.fh_percentage = 0
                                                            away.sh_percentage = 0
                                                        }
                                                        if(home.p == 0 && away.p == 0){
                                                            home.fh_probability = 0
                                                            home.sh_probability = 0
                                                        }
                                                        home.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.z_z = (this.zeroTozero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.over15 = (this.over15_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.over15 = (this.over15_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.over25 = (this.over25_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.over25 = (this.over25_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.over35 = (this.over35_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.over35 = (this.over35_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.scored = (this.scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.scored = (this.scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.conc = (this.concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.001)*100).toFixed(0)
                                                        away.conc = (this.concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.001)*100).toFixed(0)
                                                        home.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)).toFixed(2)
                                                        away.average1 = (this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)).toFixed(2)
                                                        home.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)).toFixed(2)
                                                        away.average2 = (this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)).toFixed(2)
                                                        if(this.average_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {}) == 0){home.average1 = 0;}
                                                        if(this.average_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {}) == 0){away.average1 = 0;}
                                                        if(this.average_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {}) == 0){home.average2 = 0;}
                                                        if(this.average_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {}) == 0){away.average2 = 0;}
                                                        home.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.bts = (this.average_bts_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.first1 = (this.FH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.first2 = (this.FH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.second1 = (this.SH_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.second2 = (this.SH_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p + 0.0001)*100).toFixed(0)

                                                        home.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time15_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 15, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time15_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 15, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time30_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 30, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time30_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 30, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time45_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time45_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time60_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 60, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time60_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 60, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time75_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 75, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time75_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 75, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time90_S = (this.time_scored_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        home.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p + 0.0001)*100).toFixed(0)
                                                        away.time90_C = (this.time_concd_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p + 0.0001)*100).toFixed(0)
                                                        let hgs1 = this.scored_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        let ags1 = this.scored_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                                                        let hgs2 = this.scored_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        let ags2 = this.scored_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                                                        home.gs1 = (hgs1/(hgs1 + hgs2)*100).toFixed(0)
                                                        home.gs2 = (hgs2/(hgs1 + hgs2)*100).toFixed(0)
                                                        if((hgs1 + hgs2) == 0){home.gs1 = 0; home.gs2 = 0}
                                                        away.gs1 = (ags1/(ags1 + ags2)*100).toFixed(0)
                                                        away.gs2 = (ags2/(ags1 + ags2)*100).toFixed(0)
                                                        if((ags1 + ags2) == 0){away.gs1 = 0 ; away.gs2 = 0}
                                                        let hgc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        let agc1 = this.concd_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                                                        let hgc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        let agc2 = this.concd_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                                                        home.gc1 = (hgc1/(hgc1 + hgc2)*100).toFixed(0)
                                                        home.gc2 = (hgc2/(hgc1 + hgc2)*100).toFixed(0)
                                                        if((hgc1 + hgc2) == 0){home.gc1 = 0; home.gc2 = 0}
                                                        away.gc1 = (agc1/(agc1 + agc2)*100).toFixed(0)
                                                        away.gc2 = (agc2/(agc1 + agc2)*100).toFixed(0)
                                                        if((agc1 + agc2) == 0){away.gc1 = 0 ; away.gc2 = 0}
                                                        home.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 45, '1', {})/(home.p)*100).toFixed(0)
                                                        away.over40 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 45, '1', {})/(away.p)*100).toFixed(0)
                                                        home.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, 90, '1', {})/(home.p)*100).toFixed(0)
                                                        away.over85 = (this.scored_plus_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, 90, '1', {})/(away.p)*100).toFixed(0)

                                                        home.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.C_H = (this.win_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.C_D = (this.draw_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.C_A = (this.loss_percentage_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)

                                                        home.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.lastGoal = (this.Last_goal_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        if(home.p == 0){home.over40 = 0; home.over85 = 0; home.C_H = 0; home.C_D = 0; home.C_A = 0; home.lastGoal = 0}
                                                        if(away.p == 0){away.over40 = 0; away.over85 = 0; away.C_H = 0; away.C_D = 0; away.C_A = 0; away.lastGoal = 0}
                                                        home.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        away.first10 = this.one_to_zero_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                                                        home.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.first10)*100).toFixed(0)
                                                        away.first11 = (this.one_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.first10)*100).toFixed(0)
                                                        home.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.first10)*100).toFixed(0)
                                                        away.first20 = (this.two_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.first10)*100).toFixed(0)

                                                        if(home.first10 == 0){home.first11 = 0; home.first20 = 0}
                                                        if(away.first10 == 0){away.first11 = 0; away.first20 = 0}
                                                        home.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})
                                                        away.second01 = this.zero_to_one_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})

                                                        home.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.second01)*100).toFixed(0)
                                                        away.second11 = (this.one_to_one2_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.second01)*100).toFixed(0)
                                                        home.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.second01)*100).toFixed(0)
                                                        away.second02 = (this.zero_to_two_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.second01)*100).toFixed(0)

                                                        if(home.second01 == 0){home.second11 = 0; home.second02 = 0}
                                                        if(away.second01 == 0){away.second11 = 0; away.second02 = 0}
                                                        home.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.secondplus = (this.two_score_ahead_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.secondminus = (this.two_score_behind_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.homefirst = (this.H_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.drawfirst = (this.D_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.awayfirst = (this.A_1st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)

                                                        home.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.homesecond = (this.H_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.drawsecond = (this.D_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        home.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].localTeamId, 'home', next_date4, '1', {})/(home.p)*100).toFixed(0)
                                                        away.awaysecond = (this.A_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})/(away.p)*100).toFixed(0)
                                                        if(home.p == 0){home.secondplus = 0; home.secondminus = 0; home.homefirst = 0; home.drawfirst = 0; home.awayfirst = 0; home.homesecond = 0; home.drawsecond = 0; home.awaysecond = 0}
                                                        if(away.p == 0){away.secondplus = 0; away.secondminus = 0; away.homefirst = 0; away.drawfirst = 0; away.awayfirst = 0; away.homesecond = 0; away.drawsecond = 0; away.awaysecond = 0}
                                                        this.mainList[u].events[uu].home =  home
                                                        this.mainList[u].events[uu].away =  away
                                                        this.mainList[u].events[uu].show =  true
                                                        console.log('home&away==>', home, away, this.mainList[u].events[uu])
                                                        this.A_2st_calculation(main_data[j].events, main_data[j].visitorTeamId, 'away', next_date4, '1', {})
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    console.log('localteamevents========>', localteamevents)
                                    console.log('awayteamevents========>', awayteamevents)
                                    
                                })
                            }
                        }
                    }
                }

            },
            //////////////////////////////////////////////////
        },
        ready() {
          
        },
        mounted: function (){
          this.$nextTick(function () {
            this.bet_date();
            
            this.start_socket();

          })
        },        
        created() { 
            
            this.authorize();
            this.set_usersetting();        

            this.gameList1 = this.gameList
            let self = this;

            // let chatUrl = "http://34.242.166.202:5000";

            let chatUrl = window.location.origin;

            this.sockets_server1 = io(chatUrl, {
                transports: ["websocket"],
                path: "/_server1/socket.io/"
            });
        },
        computed: {
            currentAlertList() {
                let data = [];

                console.log('classic_match', this.classic_match)
                if (this.classic_match){
                    let pred_typeList = this.pred_type_list.filter(dItem => dItem.label === this.classic_match);
                    if (pred_typeList.length > 0) {
                        let val = pred_typeList[0].value;

                        this.adminTable1.forEach((item) => {
                            if (item.PredType.value === val) {
                                data.push({
                                    label: item.Alert_Name.value,
                                    value: item.Alert_Name.value
                                })
                            }
                        });

                        // this.total_adminTable.forEach((item) => {
                        //     if (item.PredType.value === val) {
                        //         data.push({
                        //             label: item.Alert_Name.value,
                        //             value: item.Alert_Name.value
                        //         })
                        //     }
                        // });
                        
                    }
                }
                if (data.length == 0){
                    data.push({
                        label: 'no strategies available',
                        value: 0
                    })
                }
                console.log('=============  current alert list', data)
                return data;

            }
        },
        beforeDestroy() {
            this.sockets.unsubscribe('UpdateOdds');
            this.sockets.unsubscribe('UpdateScore');
            this.sockets.unsubscribe('UpdateStats');
            this.$root.$off('bv::hidden::modal');
            clearTimeout(this.frequentModalTimer);

        }
    }
</script>
<style scoped>
    .stats_table_modify{
        padding-left: 0;
        padding-right: 0;
    }
    .odd-cont{
        padding: 0
    }
    .odd-cont1{
        padding: 0;
        padding-left: 10px;
        padding-right: 15px;
    }
    .cold-stats-team-analysis li{
        width: 50%;
        text-align: center;
        font-size: 14px;
    }
    .save_match_data{
        min-width: 85px;
        position: relative;
        left: -28px;
        top: 18px;
        letter-spacing: -0.3px;
    }
    .cs-odd-part{
        height: 128px;
    }
    .check-box.check-box-x{
        min-width: 40px!important;
    }
    .bottom-part .season-stats-part div{
        font-size: 10px!important;
    }
    .match-container{
        border: 1px solid #d3d3d3;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
        /*background: #1e1e1e;*/
    }
    .filter-container{
        border: 1px solid lightgray;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);

    }
    .data_option-container{
        border: 1px solid lightgray;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
    }
    .form-group{
        margin-bottom: 5px;
    }
    .check-box{
        margin-bottom: 5px;
        min-width: 55px;
    }
    .checkbox-row{
        padding: 0;
    }
    .odd-filter-inputbox{
        width: calc(100% - 32px);
        float: left;
    }
    .select-container1{
        border: 1px solid lightgray;
        padding: 10px;
        padding-bottom: 5px;
        border-radius: 5px;
        margin-bottom: 10px;
        background: whitesmoke;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
    }
    .select-container2{
        border: 1px solid lightgray;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
    }
    .select-container2 .header-content{
        font-size: 16px;
        font-weight: 600;
        padding: 2px 6px;
        text-align: center;
        background: #cecece;
    }
    .betfair-classic-container1{
        border: 1px solid lightgray;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        height: 340px;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
    }
    .betfair-classic-container{
        border: 1px solid lightgray;
        padding: 10px;
        border-radius: 5px;
        background: whitesmoke;
        height: 133px;
        box-shadow: 0 0 4px 0 rgba(0,0,0,.08), 0 2px 4px 0 rgba(0,0,0,.12);
    }
    .btn-info{
        font-size: 15px;
        padding-top: 5px;
        padding-bottom: 10px;
        background: green;
        color: #fff;
        font-weight: 500;
        border: 1px solid #ebedef;
    }

    .link-style {
    color: #007bff; /* Link color */
    text-decoration: none;
    font-weight: 600;
    transition: color 0.3s ease;
}

    .link-style:hover {
        color: #0056b3; /* Darker color on hover */
        text-decoration: underline; /* Underline on hover */
    }

    .btn-danger{
        font-size: 15px;
        padding-top: 5px;
        padding-bottom: 10px;
        background: red;
        color: #fff;
        font-weight: 500;
        border: 1px solid #ebedef;
    }
    .btn-success {
        color: #2b2b2b;
        background-color: #e6eef5;
        border-color: #ebedef;
        font-size: 25px;
        width: 100px;
        margin-top: 28px!important;
    }
    .button_group{
        width: 100%;
        margin-bottom: 10px;
    }
    .before_btn{
        background: #ebedef;
        font-weight: 600;
    }
    .current_btn{
        background: #cecece;
        font-weight: 600;
    }
    .after_btn{
        background: #ebedef;
        font-weight: 600;
    }
    .refresh-btn{
        width: 100%;
        background: #00791f;
        color: white;
        margin-top: 1px;
        padding-top: 5px;
        font-size: 15px;
        padding-left: 0px;
        padding-right: 0px;
        text-align: center;
        height: 36px;
    }
    .stop-btn{
        width: 100%;
        background: #ca2640;
        color: white;
        margin-top: 1px;
        padding-top: 5px;
        font-size: 15px;
        padding-left: 0px;
        padding-right: 0px;
        text-align: center;
        height: 36px;
    }
    .trading-mode-btn{
        width: 90%;
        color: red;
        border: 1px solid gainsboro;
    }
    .check-box0{
        height: 37px;
    }
    label, p, div, button, select{
        font-size: 12px!important;
    }
    .height40 {
        height: 40px !important;
    }
    .p_font_score {
        font-size : 25px !important;
    }
    @media (max-width: 576px){
        .betfair-classic-container{
            height: 110px;
        }
        .betfair-classic-container1 {
            height : 285px !important;
        }
        .font-size9 {
            font-size : 9px !important;
        }
        .p_font_score {
            font-size : 25px !important;
        }
        .chartzoom {
            zoom : 0.4;
        }
        .alert-name-list {
            left : 0px !important;
        }

        /* label, p, div, button{
            font-size: 28px!important;
        }
        .cold-stats-team-analysis li {
            font-size : 35px !important;
        }
        .font_size_16 {
            font-size : 16px !important;
        } */
    }

</style>
<style scoped>
    .alert-name-list select{
        margin-top: 10px;
    }
    .alert-name-list{
        position: relative;
        top: -10px;
        left: -10px;
    }
    .trading-mode{
        float: right;
        margin-right: 10px;
    }
    .inputOdd, .inputOdd1{
        width: 60px;
        height: 25px;

    }
    .inputOdd input{
        padding: 2px 5px;
        height: 25px;
        background: white!important;
        border-radius: 0;
        color: black;
        border: 1px solid black;
    }
    .inputOdd1 input{
        padding: 2px 5px;
        height: 25px;
        background: none!important;
        border-radius: 0;
        color: gray;
        border: none;
    }
    .form-check1{
        width: 110px;
        font-weight: 700;
        margin: auto;
    }
    .form-check1 input{
        margin-top: 3px;
    }
    .filter-container input[type = 'checkbox']{
        width: 10px!important;
    }
    .form-control{
        font-size: 12px!important;
    }
    .slide-fade-enter-active {
        -webkit-animation-name: example;
        -webkit-animation-duration: .51s;
        -webkit-animation-iteration-count: 1;
        animation-name: example;
        animation-duration: .51s;
        animation-iteration-count: 1;
    }

    .livenow {
        -webkit-animation-name: example;
        -webkit-animation-duration: .25s;
        -webkit-animation-iteration-count: 1;
        animation-name: example;
        animation-duration: .55s;
        animation-iteration-count: 1;
    }

    @keyframes example {
        0% {
            background-color: rgba(166, 216, 255, 0.53);
        }
        50% {
            background-color: rgba(18, 18, 18, 0.34);
        }
        100% {
            background-color: rgba(250, 201, 209, 0.53);
        }
        100% {
            background-color: rgba(243, 196, 0, 0.5)!important;
        }
    }

    @media (max-width: 576px){
        /* .font_size{
        font-size: 28px!important;
        }
        .header_label {
        font-size: 35px !important;
        } */
        .stats_table_modify1{
            padding-left: 30px;
            padding-right: 30px;
        }
        .graph_group{
            width: 1200px;   
        }
        .cold-stats-team-analysis{
            width: 100%;
            overflow-x: auto;
        }
    }

</style>